
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a5056a6656605403$exports = {};
/*! For license information please see widget.module.js.LICENSE.txt */ (()=>{
    var t1 = {
        375: (t1, e, n)=>{
            var i = n(853), r = {
                ease: i(.25, .1, .25, 1),
                easeIn: i(.42, 0, 1, 1),
                easeOut: i(0, 0, .58, 1),
                easeInOut: i(.42, 0, .58, 1),
                linear: i(0, 0, 1, 1)
            };
            function a() {}
            function s() {
                var t1 = new Set, e = new Set, n = 0;
                return {
                    next: i,
                    cancel: i,
                    clearAll: function() {
                        t1.clear(), e.clear(), cancelAnimationFrame(n), n = 0;
                    }
                };
                function i(t1) {
                    e.add(t1), n || (n = requestAnimationFrame(r));
                }
                function r() {
                    n = 0;
                    var i = e;
                    e = t1, (t1 = i).forEach(function(t1) {
                        t1();
                    }), t1.clear();
                }
            }
            t1.exports = function(t1, e, n) {
                var i = Object.create(null), s = Object.create(null), o = "function" == typeof (n = n || {}).easing ? n.easing : r[n.easing];
                o || (n.easing && console.warn("Unknown easing function in amator: " + n.easing), o = r.ease);
                var l = "function" == typeof n.step ? n.step : a, c = "function" == typeof n.done ? n.done : a, u = function(t1) {
                    if (!t1) return "undefined" != typeof window && window.requestAnimationFrame ? {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    } : {
                        next: function(t1) {
                            return setTimeout(t1, 1e3 / 60);
                        },
                        cancel: function(t1) {
                            return clearTimeout(t1);
                        }
                    };
                    if ("function" != typeof t1.next) throw new Error("Scheduler is supposed to have next(cb) function");
                    if ("function" != typeof t1.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
                    return t1;
                }(n.scheduler), h = Object.keys(e);
                h.forEach(function(n) {
                    i[n] = t1[n], s[n] = e[n] - t1[n];
                });
                var d, p = "number" == typeof n.duration ? n.duration : 400, f = Math.max(1, .06 * p), m = 0;
                return d = u.next(function e() {
                    var n = o(m / f);
                    m += 1, function(e) {
                        h.forEach(function(n) {
                            t1[n] = s[n] * e + i[n];
                        });
                    }(n), m <= f ? (d = u.next(e), l(t1)) : (d = 0, setTimeout(function() {
                        c(t1);
                    }, 0));
                }), {
                    cancel: function() {
                        u.cancel(d), d = 0;
                    }
                };
            }, t1.exports.makeAggregateRaf = s, t1.exports.sharedScheduler = s();
        },
        853: (t1)=>{
            var e = .1, n = "function" == typeof Float32Array;
            function i(t1, e) {
                return 1 - 3 * e + 3 * t1;
            }
            function r(t1, e) {
                return 3 * e - 6 * t1;
            }
            function a(t1) {
                return 3 * t1;
            }
            function s(t1, e, n) {
                return ((i(e, n) * t1 + r(e, n)) * t1 + a(e)) * t1;
            }
            function o(t1, e, n) {
                return 3 * i(e, n) * t1 * t1 + 2 * r(e, n) * t1 + a(e);
            }
            function l(t1) {
                return t1;
            }
            t1.exports = function(t1, i, r, a) {
                if (!(0 <= t1 && t1 <= 1 && 0 <= r && r <= 1)) throw new Error("bezier x values must be in [0, 1] range");
                if (t1 === i && r === a) return l;
                for(var c = n ? new Float32Array(11) : new Array(11), u = 0; u < 11; ++u)c[u] = s(u * e, t1, r);
                return function(n) {
                    return 0 === n ? 0 : 1 === n ? 1 : s(function(n) {
                        for(var i = 0, a = 1; 10 !== a && c[a] <= n; ++a)i += e;
                        --a;
                        var l = i + (n - c[a]) / (c[a + 1] - c[a]) * e, u = o(l, t1, r);
                        return u >= .001 ? function(t1, e, n, i) {
                            for(var r = 0; r < 4; ++r){
                                var a = o(e, n, i);
                                if (0 === a) return e;
                                e -= (s(e, n, i) - t1) / a;
                            }
                            return e;
                        }(n, l, t1, r) : 0 === u ? l : function(t1, e, n, i, r) {
                            var a, o, l = 0;
                            do (a = s(o = e + (n - e) / 2, i, r) - t1) > 0 ? n = o : e = o;
                            while (Math.abs(a) > 1e-7 && ++l < 10);
                            return o;
                        }(n, i, i + e, t1, r);
                    }(n), i, a);
                };
            };
        },
        809: (t1, e, n)=>{
            "use strict";
            n.d(e, {
                A: ()=>f
            });
            var i = n(601), r = n.n(i), a = n(314), s = n.n(a), o = n(417), l = n.n(o), c = new URL(n(877), n.b), u = new URL(n(709), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        875: (t1, e, n)=>{
            "use strict";
            n.d(e, {
                A: ()=>f
            });
            var i = n(601), r = n.n(i), a = n(314), s = n.n(a), o = n(417), l = n.n(o), c = new URL(n(67), n.b), u = new URL(n(907), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        482: (t1, e, n)=>{
            "use strict";
            n.d(e, {
                A: ()=>f
            });
            var i = n(601), r = n.n(i), a = n(314), s = n.n(a), o = n(417), l = n.n(o), c = new URL(n(702), n.b), u = new URL(n(356), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        928: (t1, e, n)=>{
            "use strict";
            n.d(e, {
                A: ()=>f
            });
            var i = n(601), r = n.n(i), a = n(314), s = n.n(a), o = n(417), l = n.n(o), c = new URL(n(756), n.b), u = new URL(n(933), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        761: (t1, e, n)=>{
            "use strict";
            n.d(e, {
                A: ()=>o
            });
            var i = n(601), r = n.n(i), a = n(314), s = n.n(a)()(r());
            s.push([
                t1.id,
                '.widget-application{--main-color: #FAC62D;--main-text: #413E3E;width:100%;height:100%;flex:none;overflow:hidden;position:relative;z-index:1;background-color:#fff;font-size:20px}.widget-application *,.widget-application *:before,.widget-application *:after{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:"Roboto Mono",monospace;text-decoration:none;font-weight:700;color:#413e3e;outline:none;padding:0;margin:0;box-sizing:border-box;-webkit-box-sizing:border-box}.widget-application .widget-logo{position:absolute;left:45px;top:30px;z-index:3}.widget-application--tablet.widget-application .widget-logo{left:36px;top:39px}.widget-application--mobile.widget-application .widget-logo{left:23px;top:24px}.widget-application--smallMobile.widget-application .widget-logo{left:23px;top:21px}.widget-application .widget-logo img{display:block;width:82px;height:82px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-logo img{width:58px;height:58px}.widget-application--mobile.widget-application .widget-logo img{width:36px;height:36px}.widget-application--smallMobile.widget-application .widget-logo img{width:28px;height:28px}.widget-application .widget-tab__panorama-close-map{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-tab__panorama-close-map{right:30px;top:35px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map{padding:5px;right:22px;top:20px}.widget-application .widget-tab__panorama-close-map img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-tab__panorama-close-map img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-tab__panorama-close-map img{width:26px;height:26px}.widget-application .widget-enter-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-enter-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-enter-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-enter-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-enter-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-enter-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-enter-fullscreen img{width:26px;height:26px}.widget-application .widget-exit-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-exit-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-exit-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-exit-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-exit-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-exit-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-exit-fullscreen img{width:26px;height:26px}.widget-application .widget-tab-buttons{position:absolute;z-index:3;right:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab-buttons{right:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab-buttons{right:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab-buttons{right:20px;bottom:30px}.widget-application .widget-tab-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;color:#413e3e;font-size:28px;line-height:120%;font-weight:700;margin-left:40px}.widget-application--tablet.widget-application .widget-tab-button{margin-left:20px;width:60px;height:60px;font-size:22px}.widget-application--mobile.widget-application .widget-tab-button{margin-left:10px;font-size:17px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab-button{width:36px;height:36px;font-size:14px}.widget-application .widget-tab-button--active{background-color:var(--main-color);color:var(--main-text)}.widget-application .widget-tab{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px}.widget-application--smallMobile.widget-application .widget-tab{padding:60px 20px}.widget-application .widget-tab--rotation{padding:0 !important}.widget-application .widget-tab-menu{position:absolute;z-index:3;left:15px;top:15px;max-height:100%;overflow-y:auto;padding-bottom:30px}.widget-application .widget-tab-menu__wallpapers{display:flex;flex-wrap:wrap;align-items:flex-start;margin-top:10px;width:100%}.widget-application .widget-tab-menu__wallpapers img{width:30px;height:30px;display:block;object-fit:cover;cursor:pointer;margin-right:10px;margin-block-end:10px}.widget-application .widget-tab-menu ul{list-style-type:none}.widget-application .widget-tab-menu ul li{color:#413e3e;background-color:var(--main-color);padding:5px 15px;border-radius:10px;font-size:.7rem;border:none;cursor:pointer;margin-bottom:15px;width:200px;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab-menu ul li label{display:flex;cursor:inherit;width:100%}.widget-application .widget-tab-menu ul li input[type=color]{cursor:pointer;margin-left:auto;width:50px;height:20px;border:0;border-radius:5px}.widget-application .widget-tab-menu ul li input[type=color]::-webkit-color-swatch-wrapper{display:none !important}.widget-application .widget-tab-menu ul li input[type=file]{display:none}.widget-application .widget-tab-menu ul li:nth-child(1){position:relative}.widget-application .widget-tab-menu ul li:nth-child(1)::after{--bar-width: 2px;content:"";width:20px;height:15px;display:block;background:repeating-linear-gradient(180deg, #000000, #000000 var(--bar-width), rgba(0, 0, 0, 0) var(--bar-width), rgba(0, 0, 0, 0) calc(var(--bar-width) * 3));position:absolute;right:10px;top:50%;transform:translateY(-50%)}.widget-application .widget-instructions{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:cover}.widget-application .widget-instructions__content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;background-color:rgba(234,234,234,.85);border-radius:20px;overflow:hidden;width:400px;max-width:calc(100% - 60px);padding:36px 30px 30px 30px;backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-instructions__content{width:280px;padding:26px 20px 20px 20px}.widget-application .widget-instructions__steps{display:flex;align-items:flex-start;justify-content:center}.widget-application .widget-instructions__step{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 15px}.widget-application--tablet.widget-application .widget-instructions__step{margin:0 10px}.widget-application .widget-instructions__step img{display:block;width:52px;height:80px;object-fit:contain;object-position:center}.widget-application--mobile.widget-application .widget-instructions__step img{width:40px;height:60px}.widget-application--smallMobile.widget-application .widget-instructions__step img{width:35px}.widget-application .widget-instructions__step p{color:#413e3e;font-size:20px;font-weight:700;text-align:center;margin-top:10px;max-width:130px}.widget-application--tablet.widget-application .widget-instructions__step p{font-size:18px;max-width:115px}.widget-application--mobile.widget-application .widget-instructions__step p{font-size:16px}.widget-application--smallMobile.widget-application .widget-instructions__step p{font-size:14px}.widget-application .widget-instructions__hint p{color:#413e3e;font-weight:700;text-align:center;margin-top:1.5em;font-size:14px}.widget-application--tablet.widget-application .widget-instructions__hint p{font-size:12px}.widget-application--mobile.widget-application .widget-instructions__hint p{font-size:10px}.widget-application--smallMobile.widget-application .widget-instructions__hint p{font-size:8px}.widget-application .widget-instructions button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;height:44px;padding:0 33px;border-radius:52px;background-color:var(--main-color);color:var(--main-text);font-size:24px;font-weight:700;text-transform:uppercase;margin:25px auto 0 auto}.widget-application .widget-instructions button:disabled{opacity:.75;cursor:not-allowed}.widget-application--tablet.widget-application .widget-instructions button{font-size:18px;height:40px}.widget-application--mobile.widget-application .widget-instructions button{font-size:16px;height:35px}.widget-application--smallMobile.widget-application .widget-instructions button{font-size:14px;height:26px;padding:0 25px}.widget-application .widget-tab__panorama{width:100%;height:100%;position:absolute;left:0;top:0;z-index:2}.widget-application .widget-tab__panorama-overlay{width:100%;height:100%;overflow:hidden;background:#fff !important}.widget-application .widget-tab__panorama-overlay *{display:none !important}.widget-application .widget-tab__panorama-overlay canvas{display:block !important}.widget-application .widget-tab__panorama-enter-vr{position:absolute;left:50%;bottom:50px;transform:translateX(-50%);z-index:3;padding:10px 15px;border-radius:10px;border:2px solid #000;background-color:#fff;font-size:16px;font-weight:600;cursor:pointer}.widget-application .widget-tab__panorama-enter-vr:disabled{opacity:.5}.widget-application .widget-tab__panorama-controls{position:absolute;z-index:2;left:50%;bottom:35px;display:flex;align-items:center;justify-content:center;padding:8px;border-radius:38px;background-color:rgba(0,0,0,.2);transform:translateX(-50%);backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-tab__panorama-controls{padding:5px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls{bottom:30px}.widget-application .widget-tab__panorama-controls-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:55px;height:55px;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;margin-right:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button{width:44px;height:44px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button{margin-right:10px;width:33px;height:33px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button{width:26px;height:26px}.widget-application .widget-tab__panorama-controls-button:disabled{background-color:#e6e6e6;cursor:not-allowed}.widget-application .widget-tab__panorama-controls-button:disabled img{filter:invert(100%) saturate(0)}.widget-application .widget-tab__panorama-controls-button img{display:block}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.7)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.52)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.45)}.widget-application .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-button span{font-size:23px;font-weight:700;line-height:120%;letter-spacing:-0.12em}.widget-application .widget-tab__panorama-close-map{z-index:4}.widget-application .widget-tab__panorama-map{position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__panorama-map::before{content:"";position:absolute;z-index:-1;left:50%;top:50%;transform:translate(-50%, -50%);width:100%;height:100%;border-radius:inherit;background-color:#fff}.widget-application--tablet.widget-application .widget-tab__panorama-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled::after{content:"";position:absolute;z-index:-2;left:50%;top:50%;transform:translate(-50%, -50%);width:100vw;height:100vh;background-color:rgba(196,196,196,.8)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled svg path:active{opacity:.3 !important}.widget-application--mobile.widget-application .widget-tab__panorama-map--scaled{transform:scale(1) translate(-50%, 50%)}.widget-application .widget-tab__panorama-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-map canvas{width:200px;border-radius:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map-image{position:absolute;left:0;top:0;z-index:-1;display:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map svg{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);width:200px;height:calc(100% - 16px);z-index:3;display:block;border-radius:inherit}.widget-application .widget-tab__panorama-map svg path{opacity:0;fill:var(--main-color);cursor:pointer}.widget-application .widget-tab__panorama-map svg path:hover{opacity:.3}.widget-application .widget-tab__panorama-map__fov{--x: 0;--y: 0;--rotate: 0;position:absolute;left:calc(var(--x) + 8px);top:calc(var(--y) + 8px);width:16px;height:16px;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad));transform-origin:50% 50%;z-index:4;pointer-events:none}.widget-application .widget-tab__panorama-map__fov-direction{border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application .widget-tab__panorama-map__fov-dot{position:relative;z-index:5;width:100%;height:100%;background-color:var(--main-color);border-radius:50%;border:2px solid var(--main-color);box-shadow:inset 0 0 0 2px #fff}.widget-application .widget-tab__rotation{width:100%;height:100%}.widget-application .widget-tab__rotation-start{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;position:absolute;left:50%;bottom:35px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;padding:0 25px 0 10px;background-color:#eaeaea;border-radius:38px;height:72px;width:202px}.widget-application--tablet.widget-application .widget-tab__rotation-start{height:60px;width:166px;padding:0 20px 0 8px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__rotation-start{height:44px;width:115px;padding:0 10px 0 6px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start{height:36px;width:85px;padding:0 8px 0 6px;bottom:30px}.widget-application .widget-tab__rotation-start-icon{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:#fff;margin-right:18px;padding:10px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon{padding:7px;margin-right:15px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon{margin-right:7px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon{padding:6px;margin-right:5px}.widget-application .widget-tab__rotation-start-icon img{display:block;position:relative;top:2px;width:34px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon img{width:30px;top:1px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon img{width:19px;top:0}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon img{width:15px}.widget-application .widget-tab__rotation-start span{font-size:24px;font-weight:700;color:#413e3e;text-transform:uppercase;width:100%;display:block;text-align:center;position:relative;top:1px}.widget-application--tablet.widget-application .widget-tab__rotation-start span{font-size:20px}.widget-application--mobile.widget-application .widget-tab__rotation-start span{font-size:14px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start span{font-size:10px;top:0}.widget-application .widget-tab__threesixty,.widget-application .widget-tab__isometry{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__threesixty-container,.widget-application .widget-tab__isometry-container{width:100% !important;height:100% !important;position:relative;background-image:none !important}.widget-application .widget-tab__threesixty-container img,.widget-application .widget-tab__isometry-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 120px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab__threesixty-container img.active,.widget-application .widget-tab__isometry-container img.active{opacity:1}.widget-application .widget-tab__threesixty--active{cursor:move}.widget-application--smallMobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 40px)}.widget-application--smallMobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-arrows{position:absolute;z-index:3;left:50%;bottom:35px;transform:translateX(-50%);height:72px;display:flex;align-items:center;justify-content:center}.widget-application--tablet.widget-application .widget-tab__isometry-arrows{bottom:35px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows{bottom:22px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows{bottom:100px;height:36px}.widget-application .widget-tab__isometry-arrows::before{content:"";position:absolute;left:50%;top:50%;width:calc(100% + 30px);height:100%;transform:translate(-50%, -50%);background-color:#eaeaea;z-index:-1;border-radius:60px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows::before{border-radius:32px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows::before{width:calc(100% + 15px);border-radius:30px}.widget-application .widget-tab__isometry-arrows span{font-size:28px;font-weight:700;display:block;margin:0 9px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows span{font-size:22px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows span{font-size:17px;margin:0 3px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows span{font-size:14px;margin:0}.widget-application .widget-tab__isometry-arrow{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:5px}.widget-application .widget-tab__isometry-arrow img{width:32px}.widget-application--tablet.widget-application .widget-tab__isometry-arrow img{width:24px}.widget-application--mobile.widget-application .widget-tab__isometry-arrow img{width:18px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrow img{width:14px}.widget-application .widget-tab__isometry-buttons{position:absolute;z-index:3;left:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab__isometry-buttons{left:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__isometry-buttons{left:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__isometry-buttons{left:20px;bottom:30px}.widget-application .widget-tab__isometry-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;margin-top:40px}.widget-application--tablet.widget-application .widget-tab__isometry-button{margin-top:20px;width:60px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-button{margin-top:10px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button{width:36px;height:36px}.widget-application .widget-tab__isometry-button img{display:block;width:50px}.widget-application--tablet.widget-application .widget-tab__isometry-button img{width:40px}.widget-application--mobile.widget-application .widget-tab__isometry-button img{width:30px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button img{width:25px}.widget-application .widget-loader{display:block;position:relative;width:80px;height:80px}.widget-application .widget-loader--absolute{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}.widget-application .widget-loader--sm{transform:translate(-50%, -50%) scale(0.75)}.widget-application .widget-loader div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:var(--main-color);animation-timing-function:cubic-bezier(0, 1, 1, 0)}.widget-application .widget-loader div:nth-child(1){left:8px;animation:widget-loader-1 .6s infinite}.widget-application .widget-loader div:nth-child(2){left:8px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(3){left:32px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(4){left:56px;animation:widget-loader-3 .6s infinite}@keyframes widget-loader-1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes widget-loader-3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes widget-loader-2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}.widget-application .widget-watermark-button{position:absolute;right:4px;bottom:4px;z-index:1000}.widget-application--tablet.widget-application .widget-watermark-button{right:3px;bottom:2px}.widget-application--mobile.widget-application .widget-watermark-button{right:2px}.widget-application--smallMobile.widget-application .widget-watermark-button{right:13px;bottom:8px}.widget-application .widget-watermark-button a{font-size:18px;line-height:90%;color:#000;opacity:.5}.widget-application--tablet.widget-application .widget-watermark-button a{font-size:15px}.widget-application--mobile.widget-application .widget-watermark-button a{font-size:10px}.widget-application--smallMobile.widget-application .widget-watermark-button a{font-size:9px}.widget-application .widget-watermark-button a span{font-weight:100;font-size:inherit;line-height:90%;color:inherit}.widget-application .floors-select{position:absolute;top:47px;left:50%;background:none;height:37px;border:none;transform:translateX(-50%);cursor:pointer;white-space:nowrap;overflow-x:visible;z-index:3}.widget-application .floors-select--text{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:28px;line-height:36px;font-weight:700;word-spacing:-12px;border-bottom:1px #413e3e solid;padding:0 2px}.widget-application--tablet.widget-application .floors-select--text{font-size:24px;line-height:32px;word-spacing:-9px}.widget-application--mobile.widget-application .floors-select--text{font-size:20px;line-height:28px;word-spacing:-6px}.widget-application .floors-select--text:hover{border-bottom:1px #000 solid}.widget-application .floors-select--block{display:flex;flex-direction:column;background:#fff;margin-top:7px;border-radius:6px;-moz-box-shadow:0 0 2px 2px rgba(0,0,0,.2);-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.2);box-shadow:0 0 2px 2px rgba(0,0,0,.2);overflow:hidden}.widget-application .floors-select--block-item{font-size:20px;text-align:center;line-height:40px;word-spacing:-9px}.widget-application--tablet.widget-application .floors-select--block-item{font-size:18px;word-spacing:-5px}.widget-application--mobile.widget-application .floors-select--block-item{font-size:16px;word-spacing:-4px}.widget-application .floors-select--block-item:active{background:linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)}.widget-application .floors-select--block-item--active{background:var(--main-color)}',
                ""
            ]);
            const o = s;
        },
        314: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var n = "", i = void 0 !== e[5];
                        return e[4] && (n += "@supports (".concat(e[4], ") {")), e[2] && (n += "@media ".concat(e[2], " {")), i && (n += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), n += t1(e), i && (n += "}"), e[2] && (n += "}"), e[4] && (n += "}"), n;
                    }).join("");
                }, e.i = function(t1, n, i, r, a) {
                    "string" == typeof t1 && (t1 = [
                        [
                            null,
                            t1,
                            void 0
                        ]
                    ]);
                    var s = {};
                    if (i) for(var o = 0; o < this.length; o++){
                        var l = this[o][0];
                        null != l && (s[l] = !0);
                    }
                    for(var c = 0; c < t1.length; c++){
                        var u = [].concat(t1[c]);
                        i && s[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), n && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = n) : u[2] = n), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), e.push(u));
                    }
                }, e;
            };
        },
        417: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                return e || (e = {}), t1 ? (t1 = String(t1.__esModule ? t1.default : t1), /^['"].*['"]$/.test(t1) && (t1 = t1.slice(1, -1)), e.hash && (t1 += e.hash), /["'() \t\n]|(%20)/.test(t1) || e.needQuotes ? '"'.concat(t1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t1) : t1;
            };
        },
        601: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                return t1[1];
            };
        },
        790: (t1)=>{
            t1.exports = function(t1) {
                !function(t1) {
                    if (!t1) throw new Error("Eventify cannot use falsy object as events subject");
                    for(var e = [
                        "on",
                        "fire",
                        "off"
                    ], n = 0; n < e.length; ++n)if (t1.hasOwnProperty(e[n])) throw new Error("Subject cannot be eventified, since it already has property '" + e[n] + "'");
                }(t1);
                var e = function(t1) {
                    var e = Object.create(null);
                    return {
                        on: function(n, i, r) {
                            if ("function" != typeof i) throw new Error("callback is expected to be a function");
                            var a = e[n];
                            return a || (a = e[n] = []), a.push({
                                callback: i,
                                ctx: r
                            }), t1;
                        },
                        off: function(n, i) {
                            if (void 0 === n) return e = Object.create(null), t1;
                            if (e[n]) {
                                if ("function" != typeof i) delete e[n];
                                else for(var r = e[n], a = 0; a < r.length; ++a)r[a].callback === i && r.splice(a, 1);
                            }
                            return t1;
                        },
                        fire: function(n) {
                            var i, r = e[n];
                            if (!r) return t1;
                            arguments.length > 1 && (i = Array.prototype.splice.call(arguments, 1));
                            for(var a = 0; a < r.length; ++a){
                                var s = r[a];
                                s.callback.apply(s.ctx, i);
                            }
                            return t1;
                        }
                    };
                }(t1);
                return t1.on = e.on, t1.off = e.off, t1.fire = e.fire, t1;
            };
        },
        228: (t1)=>{
            "use strict";
            var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
            t1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var t1 = new String("abc");
                    if (t1[5] = "de", "5" === Object.getOwnPropertyNames(t1)[0]) return !1;
                    for(var e = {}, n = 0; n < 10; n++)e["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function(t1) {
                        return e[t1];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(t1) {
                        i[t1] = t1;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (t1) {
                    return !1;
                }
            }() ? Object.assign : function(t1, r) {
                for(var a, s, o = function(t1) {
                    if (null == t1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(t1);
                }(t1), l = 1; l < arguments.length; l++){
                    for(var c in a = Object(arguments[l]))n.call(a, c) && (o[c] = a[c]);
                    if (e) {
                        s = e(a);
                        for(var u = 0; u < s.length; u++)i.call(a, s[u]) && (o[s[u]] = a[s[u]]);
                    }
                }
                return o;
            };
        },
        611: (t1, e, n)=>{
            "use strict";
            var i = n(964), r = n(375), a = n(790), s = n(860), o = n(833), l = o(), c = o(!0), u = n(59), h = n(25), d = n(35);
            function p(t1, e) {
                var n = (e = e || {}).controller;
                if (n || (h.canAttach(t1) ? n = h(t1, e) : d.canAttach(t1) && (n = d(t1, e))), !n) throw new Error("Cannot create panzoom for the current type of dom element");
                var o = n.getOwner(), p = {
                    x: 0,
                    y: 0
                }, m = !1, y = new u;
                n.initTransform && n.initTransform(y);
                var M, b = "function" == typeof e.filterKey ? e.filterKey : g, x = "number" == typeof e.pinchSpeed ? e.pinchSpeed : 1, w = e.bounds, _ = "number" == typeof e.maxZoom ? e.maxZoom : Number.POSITIVE_INFINITY, E = "number" == typeof e.minZoom ? e.minZoom : 0, S = "number" == typeof e.boundsPadding ? e.boundsPadding : .05, T = "number" == typeof e.zoomDoubleClickSpeed ? e.zoomDoubleClickSpeed : 1.75, I = e.beforeWheel || g, C = e.beforeMouseDown || g, N = "number" == typeof e.zoomSpeed ? e.zoomSpeed : 1, D = f(e.transformOrigin), L = e.enableTextSelection ? c : l;
                !function(t1) {
                    var e = typeof t1;
                    if ("undefined" !== e && "boolean" !== e && !(A(t1.left) && A(t1.top) && A(t1.bottom) && A(t1.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }(w), e.autocenter && function() {
                    var t1, e, i = 0, r = 0, a = at();
                    if (a) i = a.left, r = a.top, t1 = a.right - a.left, e = a.bottom - a.top;
                    else {
                        var s = o.getBoundingClientRect();
                        t1 = s.width, e = s.height;
                    }
                    var l = n.getBBox();
                    if (0 !== l.width && 0 !== l.height) {
                        var c = e / l.height, u = t1 / l.width, h = Math.min(u, c);
                        y.x = -(l.left + l.width / 2) * h + t1 / 2 + i, y.y = -(l.top + l.height / 2) * h + e / 2 + r, y.scale = h;
                    }
                }();
                var O, R, P, z, U, k, B, j, F, H, V = 0, Q = 0, G = 0, W = null, X = new Date, Y = !1, Z = !1;
                B = "smoothScroll" in e && !e.smoothScroll ? {
                    start: g,
                    stop: g,
                    cancel: g
                } : s(function() {
                    return {
                        x: y.x,
                        y: y.y
                    };
                }, function(t1, e) {
                    Lt(), nt(t1, e);
                }, e.smoothScroll);
                var q = !1;
                ut();
                var J = {
                    dispose: function() {
                        ht();
                    },
                    moveBy: ct,
                    moveTo: nt,
                    smoothMoveTo: function(t1, e) {
                        ct(t1 - y.x, e - y.y, !0);
                    },
                    centerOn: function(t1) {
                        var e = t1.ownerSVGElement;
                        if (!e) throw new Error("ui element is required to be within the scene");
                        var n = t1.getBoundingClientRect(), i = n.left + n.width / 2, r = n.top + n.height / 2, a = e.getBoundingClientRect();
                        ct(a.width / 2 - i, a.height / 2 - r, !0);
                    },
                    zoomTo: Dt,
                    zoomAbs: lt,
                    smoothZoom: Ct,
                    smoothZoomAbs: function(t1, e, n) {
                        var i = {
                            scale: y.scale
                        }, a = {
                            scale: n
                        };
                        B.cancel(), Lt(), F = r(i, a, {
                            step: function(n) {
                                lt(t1, e, n.scale);
                            }
                        });
                    },
                    showRectangle: function(t1) {
                        var e = o.getBoundingClientRect(), n = et(e.width, e.height), i = t1.right - t1.left, r = t1.bottom - t1.top;
                        if (!Number.isFinite(i) || !Number.isFinite(r)) throw new Error("Invalid rectangle");
                        var a = n.x / i, s = n.y / r, l = Math.min(a, s);
                        y.x = -(t1.left + i / 2) * l + n.x / 2, y.y = -(t1.top + r / 2) * l + n.y / 2, y.scale = l;
                    },
                    pause: function() {
                        ht(), q = !0;
                    },
                    resume: function() {
                        q && (ut(), q = !1);
                    },
                    isPaused: function() {
                        return q;
                    },
                    getTransform: function() {
                        return y;
                    },
                    getMinZoom: function() {
                        return E;
                    },
                    setMinZoom: function(t1) {
                        E = t1;
                    },
                    getMaxZoom: function() {
                        return _;
                    },
                    setMaxZoom: function(t1) {
                        _ = t1;
                    },
                    getTransformOrigin: function() {
                        return D;
                    },
                    setTransformOrigin: function(t1) {
                        D = f(t1);
                    },
                    getZoomSpeed: function() {
                        return N;
                    },
                    setZoomSpeed: function(t1) {
                        if (!Number.isFinite(t1)) throw new Error("Zoom speed should be a number");
                        N = t1;
                    }
                };
                a(J);
                var K = "number" == typeof e.initialX ? e.initialX : y.x, $ = "number" == typeof e.initialY ? e.initialY : y.y, tt = "number" == typeof e.initialZoom ? e.initialZoom : y.scale;
                return K == y.x && $ == y.y && tt == y.scale || lt(K, $, tt), J;
                function et(t1, e) {
                    if (n.getScreenCTM) {
                        var i = n.getScreenCTM(), r = i.a, a = i.d, s = i.e, o = i.f;
                        p.x = t1 * r - s, p.y = e * a - o;
                    } else p.x = t1, p.y = e;
                    return p;
                }
                function nt(t1, e) {
                    y.x = t1, y.y = e, rt(), Ut("pan"), st();
                }
                function it(t1, e) {
                    nt(y.x + t1, y.y + e);
                }
                function rt() {
                    var t1 = at();
                    if (t1) {
                        var e, i, r, a, s = !1, o = (r = (e = n.getBBox()).left, a = e.top, {
                            left: (i = {
                                x: r * y.scale + y.x,
                                y: a * y.scale + y.y
                            }).x,
                            top: i.y,
                            right: e.width * y.scale + i.x,
                            bottom: e.height * y.scale + i.y
                        }), l = t1.left - o.right;
                        return l > 0 && (y.x += l, s = !0), (l = t1.right - o.left) < 0 && (y.x += l, s = !0), (l = t1.top - o.bottom) > 0 && (y.y += l, s = !0), (l = t1.bottom - o.top) < 0 && (y.y += l, s = !0), s;
                    }
                }
                function at() {
                    if (w) {
                        if ("boolean" == typeof w) {
                            var t1 = o.getBoundingClientRect(), e = t1.width, n = t1.height;
                            return {
                                left: e * S,
                                top: n * S,
                                right: e * (1 - S),
                                bottom: n * (1 - S)
                            };
                        }
                        return w;
                    }
                }
                function st() {
                    m = !0, M = window.requestAnimationFrame(dt);
                }
                function ot(t1, e, n) {
                    if (v(t1) || v(e) || v(n)) throw new Error("zoom requires valid numbers");
                    var i = y.scale * n;
                    if (i < E) {
                        if (y.scale === E) return;
                        n = E / y.scale;
                    }
                    if (i > _) {
                        if (y.scale === _) return;
                        n = _ / y.scale;
                    }
                    var r = et(t1, e);
                    y.x = r.x - n * (r.x - y.x), y.y = r.y - n * (r.y - y.y), w && 1 === S && 1 === E ? (y.scale *= n, rt()) : rt() || (y.scale *= n), Ut("zoom"), st();
                }
                function lt(t1, e, n) {
                    ot(t1, e, n / y.scale);
                }
                function ct(t1, e, n) {
                    if (!n) return it(t1, e);
                    j && j.cancel();
                    var i = 0, a = 0;
                    j = r({
                        x: 0,
                        y: 0
                    }, {
                        x: t1,
                        y: e
                    }, {
                        step: function(t1) {
                            it(t1.x - i, t1.y - a), i = t1.x, a = t1.y;
                        }
                    });
                }
                function ut() {
                    o.addEventListener("mousedown", xt, {
                        passive: !1
                    }), o.addEventListener("dblclick", bt, {
                        passive: !1
                    }), o.addEventListener("touchstart", ft, {
                        passive: !1
                    }), o.addEventListener("keydown", pt, {
                        passive: !1
                    }), i.addWheelListener(o, Tt, {
                        passive: !1
                    }), st();
                }
                function ht() {
                    i.removeWheelListener(o, Tt), o.removeEventListener("mousedown", xt), o.removeEventListener("keydown", pt), o.removeEventListener("dblclick", bt), o.removeEventListener("touchstart", ft), M && (window.cancelAnimationFrame(M), M = 0), B.cancel(), Et(), St(), L.release(), Pt();
                }
                function dt() {
                    m && (m = !1, n.applyTransform(y), Ut("transform"), M = 0);
                }
                function pt(t1) {
                    var e = 0, n = 0, i = 0;
                    if (38 === t1.keyCode ? n = 1 : 40 === t1.keyCode ? n = -1 : 37 === t1.keyCode ? e = 1 : 39 === t1.keyCode ? e = -1 : 189 === t1.keyCode || 109 === t1.keyCode ? i = 1 : 187 !== t1.keyCode && 107 !== t1.keyCode || (i = -1), !b(t1, e, n, i)) {
                        if (e || n) {
                            t1.preventDefault(), t1.stopPropagation();
                            var r = o.getBoundingClientRect();
                            ct(.05 * (a = Math.min(r.width, r.height)) * e, .05 * a * n);
                        }
                        if (i) {
                            var a, s = Ot(100 * i);
                            Dt((a = D ? Nt() : {
                                x: (l = o.getBoundingClientRect()).width / 2,
                                y: l.height / 2
                            }).x, a.y, s);
                        }
                        var l;
                    }
                }
                function ft(t1) {
                    if (function(t1) {
                        e.onTouch && !e.onTouch(t1) || (t1.stopPropagation(), t1.preventDefault());
                    }(t1), At(), 1 === t1.touches.length) return function(t1) {
                        Q = new Date;
                        var e = It(t1.touches[0]);
                        O = e;
                        var n = et(e.x, e.y);
                        R = n.x, P = n.y, z = R, U = P, B.cancel(), mt();
                    }(t1, t1.touches[0]);
                    2 === t1.touches.length && (k = Mt(t1.touches[0], t1.touches[1]), H = !0, mt());
                }
                function mt() {
                    Y || (Y = !0, document.addEventListener("touchmove", gt), document.addEventListener("touchend", yt), document.addEventListener("touchcancel", yt));
                }
                function gt(t1) {
                    if (1 === t1.touches.length) {
                        t1.stopPropagation();
                        var e = et((u = It(t1.touches[0])).x, u.y), n = e.x - R, i = e.y - P;
                        0 !== n && 0 !== i && Rt(), R = e.x, P = e.y, ct(n, i);
                    } else if (2 === t1.touches.length) {
                        H = !0;
                        var r = t1.touches[0], a = t1.touches[1], s = Mt(r, a), o = 1 + (s / k - 1) * x, l = It(r), c = It(a);
                        if (R = (l.x + c.x) / 2, P = (l.y + c.y) / 2, D) {
                            var u = Nt();
                            R = u.x, P = u.y;
                        }
                        Dt(R, P, o), k = s, t1.stopPropagation(), t1.preventDefault();
                    }
                }
                function At() {
                    G && (clearTimeout(G), G = 0);
                }
                function vt(t1) {
                    if (e.onClick) {
                        At();
                        var n = R - z, i = P - U;
                        Math.sqrt(n * n + i * i) > 5 || (G = setTimeout(function() {
                            G = 0, e.onClick(t1);
                        }, 300));
                    }
                }
                function yt(t1) {
                    if (At(), t1.touches.length > 0) {
                        var e = et((n = It(t1.touches[0])).x, n.y);
                        R = e.x, P = e.y;
                    } else {
                        var n, i = new Date;
                        i - V < 300 ? D ? Ct((n = Nt()).x, n.y, T) : Ct(O.x, O.y, T) : i - Q < 200 && vt(t1), V = i, Pt(), St();
                    }
                }
                function Mt(t1, e) {
                    var n = t1.clientX - e.clientX, i = t1.clientY - e.clientY;
                    return Math.sqrt(n * n + i * i);
                }
                function bt(t1) {
                    !function(t1) {
                        At(), e.onDoubleClick && !e.onDoubleClick(t1) || (t1.preventDefault(), t1.stopPropagation());
                    }(t1);
                    var n = It(t1);
                    D && (n = Nt()), Ct(n.x, n.y, T);
                }
                function xt(t1) {
                    if (At(), !C(t1)) {
                        if (W = t1, X = new Date, Y) return t1.stopPropagation(), !1;
                        if (1 === t1.button && null !== window.event || 0 === t1.button) {
                            B.cancel();
                            var e = It(t1), n = et(e.x, e.y);
                            return z = R = n.x, U = P = n.y, document.addEventListener("mousemove", wt), document.addEventListener("mouseup", _t), L.capture(t1.target || t1.srcElement), !1;
                        }
                    }
                }
                function wt(t1) {
                    if (!Y) {
                        Rt();
                        var e = It(t1), n = et(e.x, e.y), i = n.x - R, r = n.y - P;
                        R = n.x, P = n.y, ct(i, r);
                    }
                }
                function _t() {
                    new Date - X < 200 && vt(W), L.release(), Pt(), Et();
                }
                function Et() {
                    document.removeEventListener("mousemove", wt), document.removeEventListener("mouseup", _t), Z = !1;
                }
                function St() {
                    document.removeEventListener("touchmove", gt), document.removeEventListener("touchend", yt), document.removeEventListener("touchcancel", yt), Z = !1, H = !1, Y = !1;
                }
                function Tt(t1) {
                    if (!I(t1)) {
                        B.cancel();
                        var e = t1.deltaY;
                        t1.deltaMode > 0 && (e *= 100);
                        var n = Ot(e);
                        if (1 !== n) {
                            var i = D ? Nt() : It(t1);
                            Dt(i.x, i.y, n), t1.preventDefault();
                        }
                    }
                }
                function It(t1) {
                    var e = o.getBoundingClientRect();
                    return {
                        x: t1.clientX - e.left,
                        y: t1.clientY - e.top
                    };
                }
                function Ct(t1, e, n) {
                    var i = y.scale, a = {
                        scale: i
                    }, s = {
                        scale: n * i
                    };
                    B.cancel(), Lt(), F = r(a, s, {
                        step: function(n) {
                            lt(t1, e, n.scale);
                        },
                        done: zt
                    });
                }
                function Nt() {
                    var t1 = o.getBoundingClientRect();
                    return {
                        x: t1.width * D.x,
                        y: t1.height * D.y
                    };
                }
                function Dt(t1, e, n) {
                    return B.cancel(), Lt(), ot(t1, e, n);
                }
                function Lt() {
                    F && (F.cancel(), F = null);
                }
                function Ot(t1) {
                    return 1 - Math.sign(t1) * Math.min(.25, Math.abs(N * t1 / 128));
                }
                function Rt() {
                    Z || (Ut("panstart"), Z = !0, B.start());
                }
                function Pt() {
                    Z && (H || B.stop(), Ut("panend"));
                }
                function zt() {
                    Ut("zoomend");
                }
                function Ut(t1) {
                    J.fire(t1, J);
                }
            }
            function f(t1) {
                if (t1) return "object" == typeof t1 ? (A(t1.x) && A(t1.y) || m(t1), t1) : void m();
            }
            function m(t1) {
                throw console.error(t1), new Error([
                    "Cannot parse transform origin.",
                    "Some good examples:",
                    '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                    '  "top center" can be achieved with {x: 0.5, y: 0}',
                    '  "bottom right" can be achieved with {x: 1, y: 1}'
                ].join("\n"));
            }
            function g() {}
            function A(t1) {
                return Number.isFinite(t1);
            }
            function v(t1) {
                return Number.isNaN ? Number.isNaN(t1) : t1 != t1;
            }
            t1.exports = p, function() {
                if ("undefined" != typeof document) {
                    var t1 = document.getElementsByTagName("script");
                    if (t1) {
                        for(var e, n = 0; n < t1.length; ++n){
                            var i = t1[n];
                            if (i.src && i.src.match(/\bpanzoom(\.min)?\.js/)) {
                                e = i;
                                break;
                            }
                        }
                        if (e) {
                            var r = e.getAttribute("query");
                            if (r) {
                                var a = e.getAttribute("name") || "pz", s = Date.now();
                                !function t1() {
                                    var n = document.querySelector(r);
                                    if (!n) return Date.now() - s < 2e3 ? void setTimeout(t1, 100) : void console.error("Cannot find the panzoom element", a);
                                    var i = function(t1) {
                                        for(var e = t1.attributes, n = {}, i = 0; i < e.length; ++i){
                                            var r = o(e[i]);
                                            r && (n[r.name] = r.value);
                                        }
                                        return n;
                                    }(e);
                                    console.log(i), window[a] = p(n, i);
                                }();
                            }
                        }
                    }
                }
                function o(t1) {
                    if (t1.name && "p" === t1.name[0] && "z" === t1.name[1] && "-" === t1.name[2]) return {
                        name: t1.name.substr(3),
                        value: JSON.parse(t1.value)
                    };
                }
            }();
        },
        833: (t1)=>{
            function e(t1) {
                return t1.stopPropagation(), !1;
            }
            function n() {}
            t1.exports = function(t1) {
                if (t1) return {
                    capture: n,
                    release: n
                };
                var i, r, a, s = !1;
                return {
                    capture: function(t1) {
                        s = !0, r = window.document.onselectstart, a = window.document.ondragstart, window.document.onselectstart = e, (i = t1).ondragstart = e;
                    },
                    release: function() {
                        s && (s = !1, window.document.onselectstart = r, i && (i.ondragstart = a));
                    }
                };
            };
        },
        35: (t1)=>{
            function e(t1) {
                return t1 && t1.parentElement && t1.style;
            }
            t1.exports = function(t1, n) {
                if (!e(t1)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
                var i = t1.parentElement;
                return t1.scrollTop = 0, n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        return {
                            left: 0,
                            top: 0,
                            width: t1.clientWidth,
                            height: t1.clientHeight
                        };
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(e) {
                        t1.style.transformOrigin = "0 0 0", t1.style.transform = "matrix(" + e.scale + ", 0, 0, " + e.scale + ", " + e.x + ", " + e.y + ")";
                    }
                };
            }, t1.exports.canAttach = e;
        },
        860: (t1)=>{
            function e() {
                return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
            }
            function n() {
                return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function(t1) {
                    return setTimeout(t1, 16);
                };
            }
            t1.exports = function(t1, i, r) {
                "object" != typeof r && (r = {});
                var a, s, o, l, c, u, h, d, p, f, m = "number" == typeof r.minVelocity ? r.minVelocity : 5, g = "number" == typeof r.amplitude ? r.amplitude : .25, A = "function" == typeof r.cancelAnimationFrame ? r.cancelAnimationFrame : e(), v = "function" == typeof r.requestAnimationFrame ? r.requestAnimationFrame : n();
                return {
                    start: function() {
                        a = t1(), u = p = l = h = 0, s = new Date, A(o), A(f), o = v(y);
                    },
                    stop: function() {
                        A(o), A(f);
                        var e = t1();
                        c = e.x, d = e.y, s = Date.now(), (l < -m || l > m) && (c += u = g * l), (h < -m || h > m) && (d += p = g * h), f = v(M);
                    },
                    cancel: function() {
                        A(o), A(f);
                    }
                };
                function y() {
                    var e = Date.now(), n = e - s;
                    s = e;
                    var i = t1(), r = i.x - a.x, c = i.y - a.y;
                    a = i;
                    var u = 1e3 / (1 + n);
                    l = .8 * r * u + .2 * l, h = .8 * c * u + .2 * h, o = v(y);
                }
                function M() {
                    var t1 = Date.now() - s, e = !1, n = 0, r = 0;
                    u && ((n = -u * Math.exp(-t1 / 342)) > .5 || n < -0.5 ? e = !0 : n = u = 0), p && ((r = -p * Math.exp(-t1 / 342)) > .5 || r < -0.5 ? e = !0 : r = p = 0), e && (i(c + n, d + r), f = v(M));
                }
            };
        },
        25: (t1)=>{
            function e(t1) {
                return t1 && t1.ownerSVGElement && t1.getCTM;
            }
            t1.exports = function(t1, n) {
                if (!e(t1)) throw new Error("svg element is required for svg.panzoom to work");
                var i = t1.ownerSVGElement;
                if (!i) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                return n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        var e = t1.getBBox();
                        return {
                            left: e.x,
                            top: e.y,
                            width: e.width,
                            height: e.height
                        };
                    },
                    getScreenCTM: function() {
                        var t1 = i.getCTM();
                        return t1 || i.getScreenCTM();
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(e) {
                        t1.setAttribute("transform", "matrix(" + e.scale + " 0 0 " + e.scale + " " + e.x + " " + e.y + ")");
                    },
                    initTransform: function(e) {
                        var n = t1.getCTM();
                        null === n && (n = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix()), e.x = n.e, e.y = n.f, e.scale = n.a, i.removeAttributeNS(null, "viewBox");
                    }
                };
            }, t1.exports.canAttach = e;
        },
        59: (t1)=>{
            t1.exports = function() {
                this.x = 0, this.y = 0, this.scale = 1;
            };
        },
        551: (t1, e, n)=>{
            "use strict";
            var i = n(540), r = n(228), a = n(982);
            function s(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, n = 1; n < arguments.length; n++)e += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!i) throw Error(s(227));
            var o = new Set, l = {};
            function c(t1, e) {
                u(t1, e), u(t1 + "Capture", e);
            }
            function u(t1, e) {
                for(l[t1] = e, t1 = 0; t1 < e.length; t1++)o.add(e[t1]);
            }
            var h = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = Object.prototype.hasOwnProperty, f = {}, m = {};
            function g(t1, e, n, i, r, a, s) {
                this.acceptsBooleans = 2 === e || 3 === e || 4 === e, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = t1, this.type = e, this.sanitizeURL = a, this.removeEmptyString = s;
            }
            var A = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(t1) {
                A[t1] = new g(t1, 0, !1, t1, null, !1, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(t1) {
                var e = t1[0];
                A[e] = new g(e, 1, !1, t1[1], null, !1, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 2, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 2, !1, t1, null, !1, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(t1) {
                A[t1] = new g(t1, 3, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 3, !0, t1, null, !1, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 4, !1, t1, null, !1, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 6, !1, t1, null, !1, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 5, !1, t1.toLowerCase(), null, !1, !1);
            });
            var v = /[\-:]([a-z])/g;
            function y(t1) {
                return t1[1].toUpperCase();
            }
            function M(t1, e, n, i) {
                var r = A.hasOwnProperty(e) ? A[e] : null;
                (null !== r ? 0 === r.type : !i && 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])) || (function(t1, e, n, i) {
                    if (null == e || function(t1, e, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof e){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (t1 = t1.toLowerCase().slice(0, 5)) && "aria-" !== t1);
                            default:
                                return !1;
                        }
                    }(t1, e, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !e;
                        case 4:
                            return !1 === e;
                        case 5:
                            return isNaN(e);
                        case 6:
                            return isNaN(e) || 1 > e;
                    }
                    return !1;
                }(e, n, r, i) && (n = null), i || null === r ? function(t1) {
                    return !!p.call(m, t1) || !p.call(f, t1) && (d.test(t1) ? m[t1] = !0 : (f[t1] = !0, !1));
                }(e) && (null === n ? t1.removeAttribute(e) : t1.setAttribute(e, "" + n)) : r.mustUseProperty ? t1[r.propertyName] = null === n ? 3 !== r.type && "" : n : (e = r.attributeName, i = r.attributeNamespace, null === n ? t1.removeAttribute(e) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? t1.setAttributeNS(i, e, n) : t1.setAttribute(e, n))));
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(t1) {
                var e = t1.replace(v, y);
                A[e] = new g(e, 1, !1, t1, null, !1, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(t1) {
                var e = t1.replace(v, y);
                A[e] = new g(e, 1, !1, t1, "http://www.w3.org/1999/xlink", !1, !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(t1) {
                var e = t1.replace(v, y);
                A[e] = new g(e, 1, !1, t1, "http://www.w3.org/XML/1998/namespace", !1, !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 1, !1, t1.toLowerCase(), null, !1, !1);
            }), A.xlinkHref = new g("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(t1) {
                A[t1] = new g(t1, 1, !1, t1.toLowerCase(), null, !0, !0);
            });
            var b = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, x = 60103, w = 60106, _ = 60107, E = 60108, S = 60114, T = 60109, I = 60110, C = 60112, N = 60113, D = 60120, L = 60115, O = 60116, R = 60121, P = 60128, z = 60129, U = 60130, k = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var B = Symbol.for;
                x = B("react.element"), w = B("react.portal"), _ = B("react.fragment"), E = B("react.strict_mode"), S = B("react.profiler"), T = B("react.provider"), I = B("react.context"), C = B("react.forward_ref"), N = B("react.suspense"), D = B("react.suspense_list"), L = B("react.memo"), O = B("react.lazy"), R = B("react.block"), B("react.scope"), P = B("react.opaque.id"), z = B("react.debug_trace_mode"), U = B("react.offscreen"), k = B("react.legacy_hidden");
            }
            var j, F = "function" == typeof Symbol && Symbol.iterator;
            function H(t1) {
                return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = F && t1[F] || t1["@@iterator"]) ? t1 : null;
            }
            function V(t1) {
                if (void 0 === j) try {
                    throw Error();
                } catch (t1) {
                    var e = t1.stack.trim().match(/\n( *(at )?)/);
                    j = e && e[1] || "";
                }
                return "\n" + j + t1;
            }
            var Q = !1;
            function G(t1, e) {
                if (!t1 || Q) return "";
                Q = !0;
                var n = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (e) {
                        if (e = function() {
                            throw Error();
                        }, Object.defineProperty(e.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        }), "object" == typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(e, []);
                            } catch (t1) {
                                var i = t1;
                            }
                            Reflect.construct(t1, [], e);
                        } else {
                            try {
                                e.call();
                            } catch (t1) {
                                i = t1;
                            }
                            t1.call(e.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (t1) {
                            i = t1;
                        }
                        t1();
                    }
                } catch (t1) {
                    if (t1 && i && "string" == typeof t1.stack) {
                        for(var r = t1.stack.split("\n"), a = i.stack.split("\n"), s = r.length - 1, o = a.length - 1; 1 <= s && 0 <= o && r[s] !== a[o];)o--;
                        for(; 1 <= s && 0 <= o; s--, o--)if (r[s] !== a[o]) {
                            if (1 !== s || 1 !== o) do {
                                if (s--, 0 > --o || r[s] !== a[o]) return "\n" + r[s].replace(" at new ", " at ");
                            }while (1 <= s && 0 <= o);
                            break;
                        }
                    }
                } finally{
                    Q = !1, Error.prepareStackTrace = n;
                }
                return (t1 = t1 ? t1.displayName || t1.name : "") ? V(t1) : "";
            }
            function W(t1) {
                switch(t1.tag){
                    case 5:
                        return V(t1.type);
                    case 16:
                        return V("Lazy");
                    case 13:
                        return V("Suspense");
                    case 19:
                        return V("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return G(t1.type, !1);
                    case 11:
                        return G(t1.type.render, !1);
                    case 22:
                        return G(t1.type._render, !1);
                    case 1:
                        return G(t1.type, !0);
                    default:
                        return "";
                }
            }
            function X(t1) {
                if (null == t1) return null;
                if ("function" == typeof t1) return t1.displayName || t1.name || null;
                if ("string" == typeof t1) return t1;
                switch(t1){
                    case _:
                        return "Fragment";
                    case w:
                        return "Portal";
                    case S:
                        return "Profiler";
                    case E:
                        return "StrictMode";
                    case N:
                        return "Suspense";
                    case D:
                        return "SuspenseList";
                }
                if ("object" == typeof t1) switch(t1.$$typeof){
                    case I:
                        return (t1.displayName || "Context") + ".Consumer";
                    case T:
                        return (t1._context.displayName || "Context") + ".Provider";
                    case C:
                        var e = t1.render;
                        return e = e.displayName || e.name || "", t1.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
                    case L:
                        return X(t1.type);
                    case R:
                        return X(t1._render);
                    case O:
                        e = t1._payload, t1 = t1._init;
                        try {
                            return X(t1(e));
                        } catch (t1) {}
                }
                return null;
            }
            function Y(t1) {
                switch(typeof t1){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return t1;
                    default:
                        return "";
                }
            }
            function Z(t1) {
                var e = t1.type;
                return (t1 = t1.nodeName) && "input" === t1.toLowerCase() && ("checkbox" === e || "radio" === e);
            }
            function q(t1) {
                t1._valueTracker || (t1._valueTracker = function(t1) {
                    var e = Z(t1) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(t1.constructor.prototype, e), i = "" + t1[e];
                    if (!t1.hasOwnProperty(e) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                        var r = n.get, a = n.set;
                        return Object.defineProperty(t1, e, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(t1) {
                                i = "" + t1, a.call(this, t1);
                            }
                        }), Object.defineProperty(t1, e, {
                            enumerable: n.enumerable
                        }), {
                            getValue: function() {
                                return i;
                            },
                            setValue: function(t1) {
                                i = "" + t1;
                            },
                            stopTracking: function() {
                                t1._valueTracker = null, delete t1[e];
                            }
                        };
                    }
                }(t1));
            }
            function J(t1) {
                if (!t1) return !1;
                var e = t1._valueTracker;
                if (!e) return !0;
                var n = e.getValue(), i = "";
                return t1 && (i = Z(t1) ? t1.checked ? "true" : "false" : t1.value), (t1 = i) !== n && (e.setValue(t1), !0);
            }
            function K(t1) {
                if (void 0 === (t1 = t1 || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return t1.activeElement || t1.body;
                } catch (e) {
                    return t1.body;
                }
            }
            function $(t1, e) {
                var n = e.checked;
                return r({}, e, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != n ? n : t1._wrapperState.initialChecked
                });
            }
            function tt(t1, e) {
                var n = null == e.defaultValue ? "" : e.defaultValue, i = null != e.checked ? e.checked : e.defaultChecked;
                n = Y(null != e.value ? e.value : n), t1._wrapperState = {
                    initialChecked: i,
                    initialValue: n,
                    controlled: "checkbox" === e.type || "radio" === e.type ? null != e.checked : null != e.value
                };
            }
            function et(t1, e) {
                null != (e = e.checked) && M(t1, "checked", e, !1);
            }
            function nt(t1, e) {
                et(t1, e);
                var n = Y(e.value), i = e.type;
                if (null != n) "number" === i ? (0 === n && "" === t1.value || t1.value != n) && (t1.value = "" + n) : t1.value !== "" + n && (t1.value = "" + n);
                else if ("submit" === i || "reset" === i) return void t1.removeAttribute("value");
                e.hasOwnProperty("value") ? rt(t1, e.type, n) : e.hasOwnProperty("defaultValue") && rt(t1, e.type, Y(e.defaultValue)), null == e.checked && null != e.defaultChecked && (t1.defaultChecked = !!e.defaultChecked);
            }
            function it(t1, e, n) {
                if (e.hasOwnProperty("value") || e.hasOwnProperty("defaultValue")) {
                    var i = e.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== e.value && null !== e.value)) return;
                    e = "" + t1._wrapperState.initialValue, n || e === t1.value || (t1.value = e), t1.defaultValue = e;
                }
                "" !== (n = t1.name) && (t1.name = ""), t1.defaultChecked = !!t1._wrapperState.initialChecked, "" !== n && (t1.name = n);
            }
            function rt(t1, e, n) {
                "number" === e && K(t1.ownerDocument) === t1 || (null == n ? t1.defaultValue = "" + t1._wrapperState.initialValue : t1.defaultValue !== "" + n && (t1.defaultValue = "" + n));
            }
            function at(t1, e) {
                return t1 = r({
                    children: void 0
                }, e), (e = function(t1) {
                    var e = "";
                    return i.Children.forEach(t1, function(t1) {
                        null != t1 && (e += t1);
                    }), e;
                }(e.children)) && (t1.children = e), t1;
            }
            function st(t1, e, n, i) {
                if (t1 = t1.options, e) {
                    e = {};
                    for(var r = 0; r < n.length; r++)e["$" + n[r]] = !0;
                    for(n = 0; n < t1.length; n++)r = e.hasOwnProperty("$" + t1[n].value), t1[n].selected !== r && (t1[n].selected = r), r && i && (t1[n].defaultSelected = !0);
                } else {
                    for(n = "" + Y(n), e = null, r = 0; r < t1.length; r++){
                        if (t1[r].value === n) return t1[r].selected = !0, void (i && (t1[r].defaultSelected = !0));
                        null !== e || t1[r].disabled || (e = t1[r]);
                    }
                    null !== e && (e.selected = !0);
                }
            }
            function ot(t1, e) {
                if (null != e.dangerouslySetInnerHTML) throw Error(s(91));
                return r({}, e, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + t1._wrapperState.initialValue
                });
            }
            function lt(t1, e) {
                var n = e.value;
                if (null == n) {
                    if (n = e.children, e = e.defaultValue, null != n) {
                        if (null != e) throw Error(s(92));
                        if (Array.isArray(n)) {
                            if (!(1 >= n.length)) throw Error(s(93));
                            n = n[0];
                        }
                        e = n;
                    }
                    null == e && (e = ""), n = e;
                }
                t1._wrapperState = {
                    initialValue: Y(n)
                };
            }
            function ct(t1, e) {
                var n = Y(e.value), i = Y(e.defaultValue);
                null != n && ((n = "" + n) !== t1.value && (t1.value = n), null == e.defaultValue && t1.defaultValue !== n && (t1.defaultValue = n)), null != i && (t1.defaultValue = "" + i);
            }
            function ut(t1) {
                var e = t1.textContent;
                e === t1._wrapperState.initialValue && "" !== e && null !== e && (t1.value = e);
            }
            var ht = {
                html: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function dt(t1) {
                switch(t1){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function pt(t1, e) {
                return null == t1 || "http://www.w3.org/1999/xhtml" === t1 ? dt(e) : "http://www.w3.org/2000/svg" === t1 && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : t1;
            }
            var ft, mt, gt = (mt = function(t1, e) {
                if (t1.namespaceURI !== ht.svg || "innerHTML" in t1) t1.innerHTML = e;
                else {
                    for((ft = ft || document.createElement("div")).innerHTML = "<svg>" + e.valueOf().toString() + "</svg>", e = ft.firstChild; t1.firstChild;)t1.removeChild(t1.firstChild);
                    for(; e.firstChild;)t1.appendChild(e.firstChild);
                }
            }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t1, e, n, i) {
                MSApp.execUnsafeLocalFunction(function() {
                    return mt(t1, e);
                });
            } : mt);
            function At(t1, e) {
                if (e) {
                    var n = t1.firstChild;
                    if (n && n === t1.lastChild && 3 === n.nodeType) return void (n.nodeValue = e);
                }
                t1.textContent = e;
            }
            var vt = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, yt = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function Mt(t1, e, n) {
                return null == e || "boolean" == typeof e || "" === e ? "" : n || "number" != typeof e || 0 === e || vt.hasOwnProperty(t1) && vt[t1] ? ("" + e).trim() : e + "px";
            }
            function bt(t1, e) {
                for(var n in t1 = t1.style, e)if (e.hasOwnProperty(n)) {
                    var i = 0 === n.indexOf("--"), r = Mt(n, e[n], i);
                    "float" === n && (n = "cssFloat"), i ? t1.setProperty(n, r) : t1[n] = r;
                }
            }
            Object.keys(vt).forEach(function(t1) {
                yt.forEach(function(e) {
                    e = e + t1.charAt(0).toUpperCase() + t1.substring(1), vt[e] = vt[t1];
                });
            });
            var xt = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function wt(t1, e) {
                if (e) {
                    if (xt[t1] && (null != e.children || null != e.dangerouslySetInnerHTML)) throw Error(s(137, t1));
                    if (null != e.dangerouslySetInnerHTML) {
                        if (null != e.children) throw Error(s(60));
                        if ("object" != typeof e.dangerouslySetInnerHTML || !("__html" in e.dangerouslySetInnerHTML)) throw Error(s(61));
                    }
                    if (null != e.style && "object" != typeof e.style) throw Error(s(62));
                }
            }
            function _t(t1, e) {
                if (-1 === t1.indexOf("-")) return "string" == typeof e.is;
                switch(t1){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            function Et(t1) {
                return (t1 = t1.target || t1.srcElement || window).correspondingUseElement && (t1 = t1.correspondingUseElement), 3 === t1.nodeType ? t1.parentNode : t1;
            }
            var St = null, Tt = null, It = null;
            function Ct(t1) {
                if (t1 = nr(t1)) {
                    if ("function" != typeof St) throw Error(s(280));
                    var e = t1.stateNode;
                    e && (e = rr(e), St(t1.stateNode, t1.type, e));
                }
            }
            function Nt(t1) {
                Tt ? It ? It.push(t1) : It = [
                    t1
                ] : Tt = t1;
            }
            function Dt() {
                if (Tt) {
                    var t1 = Tt, e = It;
                    if (It = Tt = null, Ct(t1), e) for(t1 = 0; t1 < e.length; t1++)Ct(e[t1]);
                }
            }
            function Lt(t1, e) {
                return t1(e);
            }
            function Ot(t1, e, n, i, r) {
                return t1(e, n, i, r);
            }
            function Rt() {}
            var Pt = Lt, zt = !1, Ut = !1;
            function kt() {
                null === Tt && null === It || (Rt(), Dt());
            }
            function Bt(t1, e) {
                var n = t1.stateNode;
                if (null === n) return null;
                var i = rr(n);
                if (null === i) return null;
                n = i[e];
                t: switch(e){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (t1 = t1.type) || "input" === t1 || "select" === t1 || "textarea" === t1)), t1 = !i;
                        break t;
                    default:
                        t1 = !1;
                }
                if (t1) return null;
                if (n && "function" != typeof n) throw Error(s(231, e, typeof n));
                return n;
            }
            var jt = !1;
            if (h) try {
                var Ft = {};
                Object.defineProperty(Ft, "passive", {
                    get: function() {
                        jt = !0;
                    }
                }), window.addEventListener("test", Ft, Ft), window.removeEventListener("test", Ft, Ft);
            } catch (mt) {
                jt = !1;
            }
            function Ht(t1, e, n, i, r, a, s, o, l) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    e.apply(n, c);
                } catch (t1) {
                    this.onError(t1);
                }
            }
            var Vt = !1, Qt = null, Gt = !1, Wt = null, Xt = {
                onError: function(t1) {
                    Vt = !0, Qt = t1;
                }
            };
            function Yt(t1, e, n, i, r, a, s, o, l) {
                Vt = !1, Qt = null, Ht.apply(Xt, arguments);
            }
            function Zt(t1) {
                var e = t1, n = t1;
                if (t1.alternate) for(; e.return;)e = e.return;
                else {
                    t1 = e;
                    do !!(1026 & (e = t1).flags) && (n = e.return), t1 = e.return;
                    while (t1);
                }
                return 3 === e.tag ? n : null;
            }
            function qt(t1) {
                if (13 === t1.tag) {
                    var e = t1.memoizedState;
                    if (null === e && null !== (t1 = t1.alternate) && (e = t1.memoizedState), null !== e) return e.dehydrated;
                }
                return null;
            }
            function Jt(t1) {
                if (Zt(t1) !== t1) throw Error(s(188));
            }
            function Kt(t1) {
                if (t1 = function(t1) {
                    var e = t1.alternate;
                    if (!e) {
                        if (null === (e = Zt(t1))) throw Error(s(188));
                        return e !== t1 ? null : t1;
                    }
                    for(var n = t1, i = e;;){
                        var r = n.return;
                        if (null === r) break;
                        var a = r.alternate;
                        if (null === a) {
                            if (null !== (i = r.return)) {
                                n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === a.child) {
                            for(a = r.child; a;){
                                if (a === n) return Jt(r), t1;
                                if (a === i) return Jt(r), e;
                                a = a.sibling;
                            }
                            throw Error(s(188));
                        }
                        if (n.return !== i.return) n = r, i = a;
                        else {
                            for(var o = !1, l = r.child; l;){
                                if (l === n) {
                                    o = !0, n = r, i = a;
                                    break;
                                }
                                if (l === i) {
                                    o = !0, i = r, n = a;
                                    break;
                                }
                                l = l.sibling;
                            }
                            if (!o) {
                                for(l = a.child; l;){
                                    if (l === n) {
                                        o = !0, n = a, i = r;
                                        break;
                                    }
                                    if (l === i) {
                                        o = !0, i = a, n = r;
                                        break;
                                    }
                                    l = l.sibling;
                                }
                                if (!o) throw Error(s(189));
                            }
                        }
                        if (n.alternate !== i) throw Error(s(190));
                    }
                    if (3 !== n.tag) throw Error(s(188));
                    return n.stateNode.current === n ? t1 : e;
                }(t1), !t1) return null;
                for(var e = t1;;){
                    if (5 === e.tag || 6 === e.tag) return e;
                    if (e.child) e.child.return = e, e = e.child;
                    else {
                        if (e === t1) break;
                        for(; !e.sibling;){
                            if (!e.return || e.return === t1) return null;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                }
                return null;
            }
            function $t(t1, e) {
                for(var n = t1.alternate; null !== e;){
                    if (e === t1 || e === n) return !0;
                    e = e.return;
                }
                return !1;
            }
            var te, ee, ne, ie, re = !1, ae = [], se = null, oe = null, le = null, ce = new Map, ue = new Map, he = [], de = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
            function pe(t1, e, n, i, r) {
                return {
                    blockedOn: t1,
                    domEventName: e,
                    eventSystemFlags: 16 | n,
                    nativeEvent: r,
                    targetContainers: [
                        i
                    ]
                };
            }
            function fe(t1, e) {
                switch(t1){
                    case "focusin":
                    case "focusout":
                        se = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        oe = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        le = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ce.delete(e.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        ue.delete(e.pointerId);
                }
            }
            function me(t1, e, n, i, r, a) {
                return null === t1 || t1.nativeEvent !== a ? (t1 = pe(e, n, i, r, a), null !== e && null !== (e = nr(e)) && ee(e), t1) : (t1.eventSystemFlags |= i, e = t1.targetContainers, null !== r && -1 === e.indexOf(r) && e.push(r), t1);
            }
            function ge(t1) {
                var e = er(t1.target);
                if (null !== e) {
                    var n = Zt(e);
                    if (null !== n) {
                        if (13 === (e = n.tag)) {
                            if (null !== (e = qt(n))) return t1.blockedOn = e, void ie(t1.lanePriority, function() {
                                a.unstable_runWithPriority(t1.priority, function() {
                                    ne(n);
                                });
                            });
                        } else if (3 === e && n.stateNode.hydrate) return void (t1.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                    }
                }
                t1.blockedOn = null;
            }
            function Ae(t1) {
                if (null !== t1.blockedOn) return !1;
                for(var e = t1.targetContainers; 0 < e.length;){
                    var n = Ke(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                    if (null !== n) return null !== (e = nr(n)) && ee(e), t1.blockedOn = n, !1;
                    e.shift();
                }
                return !0;
            }
            function ve(t1, e, n) {
                Ae(t1) && n.delete(e);
            }
            function ye() {
                for(re = !1; 0 < ae.length;){
                    var t1 = ae[0];
                    if (null !== t1.blockedOn) {
                        null !== (t1 = nr(t1.blockedOn)) && te(t1);
                        break;
                    }
                    for(var e = t1.targetContainers; 0 < e.length;){
                        var n = Ke(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                        if (null !== n) {
                            t1.blockedOn = n;
                            break;
                        }
                        e.shift();
                    }
                    null === t1.blockedOn && ae.shift();
                }
                null !== se && Ae(se) && (se = null), null !== oe && Ae(oe) && (oe = null), null !== le && Ae(le) && (le = null), ce.forEach(ve), ue.forEach(ve);
            }
            function Me(t1, e) {
                t1.blockedOn === e && (t1.blockedOn = null, re || (re = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, ye)));
            }
            function be(t1) {
                function e(e) {
                    return Me(e, t1);
                }
                if (0 < ae.length) {
                    Me(ae[0], t1);
                    for(var n = 1; n < ae.length; n++){
                        var i = ae[n];
                        i.blockedOn === t1 && (i.blockedOn = null);
                    }
                }
                for(null !== se && Me(se, t1), null !== oe && Me(oe, t1), null !== le && Me(le, t1), ce.forEach(e), ue.forEach(e), n = 0; n < he.length; n++)(i = he[n]).blockedOn === t1 && (i.blockedOn = null);
                for(; 0 < he.length && null === (n = he[0]).blockedOn;)ge(n), null === n.blockedOn && he.shift();
            }
            function xe(t1, e) {
                var n = {};
                return n[t1.toLowerCase()] = e.toLowerCase(), n["Webkit" + t1] = "webkit" + e, n["Moz" + t1] = "moz" + e, n;
            }
            var we = {
                animationend: xe("Animation", "AnimationEnd"),
                animationiteration: xe("Animation", "AnimationIteration"),
                animationstart: xe("Animation", "AnimationStart"),
                transitionend: xe("Transition", "TransitionEnd")
            }, _e = {}, Ee = {};
            function Se(t1) {
                if (_e[t1]) return _e[t1];
                if (!we[t1]) return t1;
                var e, n = we[t1];
                for(e in n)if (n.hasOwnProperty(e) && e in Ee) return _e[t1] = n[e];
                return t1;
            }
            h && (Ee = document.createElement("div").style, "AnimationEvent" in window || (delete we.animationend.animation, delete we.animationiteration.animation, delete we.animationstart.animation), "TransitionEvent" in window || delete we.transitionend.transition);
            var Te = Se("animationend"), Ie = Se("animationiteration"), Ce = Se("animationstart"), Ne = Se("transitionend"), De = new Map, Le = new Map, Oe = [
                "abort",
                "abort",
                Te,
                "animationEnd",
                Ie,
                "animationIteration",
                Ce,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Ne,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function Re(t1, e) {
                for(var n = 0; n < t1.length; n += 2){
                    var i = t1[n], r = t1[n + 1];
                    r = "on" + (r[0].toUpperCase() + r.slice(1)), Le.set(i, e), De.set(i, r), c(r, [
                        i
                    ]);
                }
            }
            (0, a.unstable_now)();
            var Pe = 8;
            function ze(t1) {
                if (1 & t1) return Pe = 15, 1;
                if (2 & t1) return Pe = 14, 2;
                if (4 & t1) return Pe = 13, 4;
                var e = 24 & t1;
                return 0 !== e ? (Pe = 12, e) : 32 & t1 ? (Pe = 11, 32) : 0 != (e = 192 & t1) ? (Pe = 10, e) : 256 & t1 ? (Pe = 9, 256) : 0 != (e = 3584 & t1) ? (Pe = 8, e) : 4096 & t1 ? (Pe = 7, 4096) : 0 != (e = 4186112 & t1) ? (Pe = 6, e) : 0 != (e = 62914560 & t1) ? (Pe = 5, e) : 67108864 & t1 ? (Pe = 4, 67108864) : 134217728 & t1 ? (Pe = 3, 134217728) : 0 != (e = 805306368 & t1) ? (Pe = 2, e) : 1073741824 & t1 ? (Pe = 1, 1073741824) : (Pe = 8, t1);
            }
            function Ue(t1, e) {
                var n = t1.pendingLanes;
                if (0 === n) return Pe = 0;
                var i = 0, r = 0, a = t1.expiredLanes, s = t1.suspendedLanes, o = t1.pingedLanes;
                if (0 !== a) i = a, r = Pe = 15;
                else if (0 != (a = 134217727 & n)) {
                    var l = a & ~s;
                    0 !== l ? (i = ze(l), r = Pe) : 0 != (o &= a) && (i = ze(o), r = Pe);
                } else 0 != (a = n & ~s) ? (i = ze(a), r = Pe) : 0 !== o && (i = ze(o), r = Pe);
                if (0 === i) return 0;
                if (i = n & ((0 > (i = 31 - Ve(i)) ? 0 : 1 << i) << 1) - 1, 0 !== e && e !== i && !(e & s)) {
                    if (ze(e), r <= Pe) return e;
                    Pe = r;
                }
                if (0 !== (e = t1.entangledLanes)) for(t1 = t1.entanglements, e &= i; 0 < e;)r = 1 << (n = 31 - Ve(e)), i |= t1[n], e &= ~r;
                return i;
            }
            function ke(t1) {
                return 0 != (t1 = -1073741825 & t1.pendingLanes) ? t1 : 1073741824 & t1 ? 1073741824 : 0;
            }
            function Be(t1, e) {
                switch(t1){
                    case 15:
                        return 1;
                    case 14:
                        return 2;
                    case 12:
                        return 0 === (t1 = je(24 & ~e)) ? Be(10, e) : t1;
                    case 10:
                        return 0 === (t1 = je(192 & ~e)) ? Be(8, e) : t1;
                    case 8:
                        return 0 === (t1 = je(3584 & ~e)) && 0 === (t1 = je(4186112 & ~e)) && (t1 = 512), t1;
                    case 2:
                        return 0 === (e = je(805306368 & ~e)) && (e = 268435456), e;
                }
                throw Error(s(358, t1));
            }
            function je(t1) {
                return t1 & -t1;
            }
            function Fe(t1) {
                for(var e = [], n = 0; 31 > n; n++)e.push(t1);
                return e;
            }
            function He(t1, e, n) {
                t1.pendingLanes |= e;
                var i = e - 1;
                t1.suspendedLanes &= i, t1.pingedLanes &= i, (t1 = t1.eventTimes)[e = 31 - Ve(e)] = n;
            }
            var Ve = Math.clz32 ? Math.clz32 : function(t1) {
                return 0 === t1 ? 32 : 31 - (Qe(t1) / Ge | 0) | 0;
            }, Qe = Math.log, Ge = Math.LN2, We = a.unstable_UserBlockingPriority, Xe = a.unstable_runWithPriority, Ye = !0;
            function Ze(t1, e, n, i) {
                zt || Rt();
                var r = Je, a = zt;
                zt = !0;
                try {
                    Ot(r, t1, e, n, i);
                } finally{
                    (zt = a) || kt();
                }
            }
            function qe(t1, e, n, i) {
                Xe(We, Je.bind(null, t1, e, n, i));
            }
            function Je(t1, e, n, i) {
                var r;
                if (Ye) {
                    if ((r = !(4 & e)) && 0 < ae.length && -1 < de.indexOf(t1)) t1 = pe(null, t1, e, n, i), ae.push(t1);
                    else {
                        var a = Ke(t1, e, n, i);
                        if (null === a) r && fe(t1, i);
                        else {
                            if (r) {
                                if (-1 < de.indexOf(t1)) return t1 = pe(a, t1, e, n, i), void ae.push(t1);
                                if (function(t1, e, n, i, r) {
                                    switch(e){
                                        case "focusin":
                                            return se = me(se, t1, e, n, i, r), !0;
                                        case "dragenter":
                                            return oe = me(oe, t1, e, n, i, r), !0;
                                        case "mouseover":
                                            return le = me(le, t1, e, n, i, r), !0;
                                        case "pointerover":
                                            var a = r.pointerId;
                                            return ce.set(a, me(ce.get(a) || null, t1, e, n, i, r)), !0;
                                        case "gotpointercapture":
                                            return a = r.pointerId, ue.set(a, me(ue.get(a) || null, t1, e, n, i, r)), !0;
                                    }
                                    return !1;
                                }(a, t1, e, n, i)) return;
                                fe(t1, i);
                            }
                            Ri(t1, e, i, null, n);
                        }
                    }
                }
            }
            function Ke(t1, e, n, i) {
                var r = Et(i);
                if (null !== (r = er(r))) {
                    var a = Zt(r);
                    if (null === a) r = null;
                    else {
                        var s = a.tag;
                        if (13 === s) {
                            if (null !== (r = qt(a))) return r;
                            r = null;
                        } else if (3 === s) {
                            if (a.stateNode.hydrate) return 3 === a.tag ? a.stateNode.containerInfo : null;
                            r = null;
                        } else a !== r && (r = null);
                    }
                }
                return Ri(t1, e, i, r, n), null;
            }
            var $e = null, tn = null, en = null;
            function nn() {
                if (en) return en;
                var t1, e, n = tn, i = n.length, r = "value" in $e ? $e.value : $e.textContent, a = r.length;
                for(t1 = 0; t1 < i && n[t1] === r[t1]; t1++);
                var s = i - t1;
                for(e = 1; e <= s && n[i - e] === r[a - e]; e++);
                return en = r.slice(t1, 1 < e ? 1 - e : void 0);
            }
            function rn(t1) {
                var e = t1.keyCode;
                return "charCode" in t1 ? 0 === (t1 = t1.charCode) && 13 === e && (t1 = 13) : t1 = e, 10 === t1 && (t1 = 13), 32 <= t1 || 13 === t1 ? t1 : 0;
            }
            function an() {
                return !0;
            }
            function sn() {
                return !1;
            }
            function on(t1) {
                function e(e, n, i, r, a) {
                    for(var s in this._reactName = e, this._targetInst = i, this.type = n, this.nativeEvent = r, this.target = a, this.currentTarget = null, t1)t1.hasOwnProperty(s) && (e = t1[s], this[s] = e ? e(r) : r[s]);
                    return this.isDefaultPrevented = (null != r.defaultPrevented ? r.defaultPrevented : !1 === r.returnValue) ? an : sn, this.isPropagationStopped = sn, this;
                }
                return r(e.prototype, {
                    preventDefault: function() {
                        this.defaultPrevented = !0;
                        var t1 = this.nativeEvent;
                        t1 && (t1.preventDefault ? t1.preventDefault() : "unknown" != typeof t1.returnValue && (t1.returnValue = !1), this.isDefaultPrevented = an);
                    },
                    stopPropagation: function() {
                        var t1 = this.nativeEvent;
                        t1 && (t1.stopPropagation ? t1.stopPropagation() : "unknown" != typeof t1.cancelBubble && (t1.cancelBubble = !0), this.isPropagationStopped = an);
                    },
                    persist: function() {},
                    isPersistent: an
                }), e;
            }
            var ln, cn, un, hn = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function(t1) {
                    return t1.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0
            }, dn = on(hn), pn = r({}, hn, {
                view: 0,
                detail: 0
            }), fn = on(pn), mn = r({}, pn, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: Tn,
                button: 0,
                buttons: 0,
                relatedTarget: function(t1) {
                    return void 0 === t1.relatedTarget ? t1.fromElement === t1.srcElement ? t1.toElement : t1.fromElement : t1.relatedTarget;
                },
                movementX: function(t1) {
                    return "movementX" in t1 ? t1.movementX : (t1 !== un && (un && "mousemove" === t1.type ? (ln = t1.screenX - un.screenX, cn = t1.screenY - un.screenY) : cn = ln = 0, un = t1), ln);
                },
                movementY: function(t1) {
                    return "movementY" in t1 ? t1.movementY : cn;
                }
            }), gn = on(mn), An = on(r({}, mn, {
                dataTransfer: 0
            })), vn = on(r({}, pn, {
                relatedTarget: 0
            })), yn = on(r({}, hn, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), Mn = r({}, hn, {
                clipboardData: function(t1) {
                    return "clipboardData" in t1 ? t1.clipboardData : window.clipboardData;
                }
            }), bn = on(Mn), xn = on(r({}, hn, {
                data: 0
            })), wn = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, _n = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, En = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function Sn(t1) {
                var e = this.nativeEvent;
                return e.getModifierState ? e.getModifierState(t1) : !!(t1 = En[t1]) && !!e[t1];
            }
            function Tn() {
                return Sn;
            }
            var In = r({}, pn, {
                key: function(t1) {
                    if (t1.key) {
                        var e = wn[t1.key] || t1.key;
                        if ("Unidentified" !== e) return e;
                    }
                    return "keypress" === t1.type ? 13 === (t1 = rn(t1)) ? "Enter" : String.fromCharCode(t1) : "keydown" === t1.type || "keyup" === t1.type ? _n[t1.keyCode] || "Unidentified" : "";
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: Tn,
                charCode: function(t1) {
                    return "keypress" === t1.type ? rn(t1) : 0;
                },
                keyCode: function(t1) {
                    return "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                },
                which: function(t1) {
                    return "keypress" === t1.type ? rn(t1) : "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                }
            }), Cn = on(In), Nn = on(r({}, mn, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Dn = on(r({}, pn, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: Tn
            })), Ln = on(r({}, hn, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), On = r({}, mn, {
                deltaX: function(t1) {
                    return "deltaX" in t1 ? t1.deltaX : "wheelDeltaX" in t1 ? -t1.wheelDeltaX : 0;
                },
                deltaY: function(t1) {
                    return "deltaY" in t1 ? t1.deltaY : "wheelDeltaY" in t1 ? -t1.wheelDeltaY : "wheelDelta" in t1 ? -t1.wheelDelta : 0;
                },
                deltaZ: 0,
                deltaMode: 0
            }), Rn = on(On), Pn = [
                9,
                13,
                27,
                32
            ], zn = h && "CompositionEvent" in window, Un = null;
            h && "documentMode" in document && (Un = document.documentMode);
            var kn = h && "TextEvent" in window && !Un, Bn = h && (!zn || Un && 8 < Un && 11 >= Un), jn = String.fromCharCode(32), Fn = !1;
            function Hn(t1, e) {
                switch(t1){
                    case "keyup":
                        return -1 !== Pn.indexOf(e.keyCode);
                    case "keydown":
                        return 229 !== e.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Vn(t1) {
                return "object" == typeof (t1 = t1.detail) && "data" in t1 ? t1.data : null;
            }
            var Qn = !1, Gn = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function Wn(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return "input" === e ? !!Gn[t1.type] : "textarea" === e;
            }
            function Xn(t1, e, n, i) {
                Nt(i), 0 < (e = zi(e, "onChange")).length && (n = new dn("onChange", "change", null, n, i), t1.push({
                    event: n,
                    listeners: e
                }));
            }
            var Yn = null, Zn = null;
            function qn(t1) {
                Ii(t1, 0);
            }
            function Jn(t1) {
                if (J(ir(t1))) return t1;
            }
            function Kn(t1, e) {
                if ("change" === t1) return e;
            }
            var $n = !1;
            if (h) {
                var ti;
                if (h) {
                    var ei = "oninput" in document;
                    if (!ei) {
                        var ni = document.createElement("div");
                        ni.setAttribute("oninput", "return;"), ei = "function" == typeof ni.oninput;
                    }
                    ti = ei;
                } else ti = !1;
                $n = ti && (!document.documentMode || 9 < document.documentMode);
            }
            function ii() {
                Yn && (Yn.detachEvent("onpropertychange", ri), Zn = Yn = null);
            }
            function ri(t1) {
                if ("value" === t1.propertyName && Jn(Zn)) {
                    var e = [];
                    if (Xn(e, Zn, t1, Et(t1)), t1 = qn, zt) t1(e);
                    else {
                        zt = !0;
                        try {
                            Lt(t1, e);
                        } finally{
                            zt = !1, kt();
                        }
                    }
                }
            }
            function ai(t1, e, n) {
                "focusin" === t1 ? (ii(), Zn = n, (Yn = e).attachEvent("onpropertychange", ri)) : "focusout" === t1 && ii();
            }
            function si(t1) {
                if ("selectionchange" === t1 || "keyup" === t1 || "keydown" === t1) return Jn(Zn);
            }
            function oi(t1, e) {
                if ("click" === t1) return Jn(e);
            }
            function li(t1, e) {
                if ("input" === t1 || "change" === t1) return Jn(e);
            }
            var ci = "function" == typeof Object.is ? Object.is : function(t1, e) {
                return t1 === e && (0 !== t1 || 1 / t1 == 1 / e) || t1 != t1 && e != e;
            }, ui = Object.prototype.hasOwnProperty;
            function hi(t1, e) {
                if (ci(t1, e)) return !0;
                if ("object" != typeof t1 || null === t1 || "object" != typeof e || null === e) return !1;
                var n = Object.keys(t1), i = Object.keys(e);
                if (n.length !== i.length) return !1;
                for(i = 0; i < n.length; i++)if (!ui.call(e, n[i]) || !ci(t1[n[i]], e[n[i]])) return !1;
                return !0;
            }
            function di(t1) {
                for(; t1 && t1.firstChild;)t1 = t1.firstChild;
                return t1;
            }
            function pi(t1, e) {
                var n, i = di(t1);
                for(t1 = 0; i;){
                    if (3 === i.nodeType) {
                        if (n = t1 + i.textContent.length, t1 <= e && n >= e) return {
                            node: i,
                            offset: e - t1
                        };
                        t1 = n;
                    }
                    t: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break t;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = di(i);
                }
            }
            function fi(t1, e) {
                return !(!t1 || !e) && (t1 === e || (!t1 || 3 !== t1.nodeType) && (e && 3 === e.nodeType ? fi(t1, e.parentNode) : "contains" in t1 ? t1.contains(e) : !!t1.compareDocumentPosition && !!(16 & t1.compareDocumentPosition(e))));
            }
            function mi() {
                for(var t1 = window, e = K(); e instanceof t1.HTMLIFrameElement;){
                    try {
                        var n = "string" == typeof e.contentWindow.location.href;
                    } catch (t1) {
                        n = !1;
                    }
                    if (!n) break;
                    e = K((t1 = e.contentWindow).document);
                }
                return e;
            }
            function gi(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return e && ("input" === e && ("text" === t1.type || "search" === t1.type || "tel" === t1.type || "url" === t1.type || "password" === t1.type) || "textarea" === e || "true" === t1.contentEditable);
            }
            var Ai = h && "documentMode" in document && 11 >= document.documentMode, vi = null, yi = null, Mi = null, bi = !1;
            function xi(t1, e, n) {
                var i = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
                bi || null == vi || vi !== K(i) || (i = "selectionStart" in (i = vi) && gi(i) ? {
                    start: i.selectionStart,
                    end: i.selectionEnd
                } : {
                    anchorNode: (i = (i.ownerDocument && i.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: i.anchorOffset,
                    focusNode: i.focusNode,
                    focusOffset: i.focusOffset
                }, Mi && hi(Mi, i) || (Mi = i, 0 < (i = zi(yi, "onSelect")).length && (e = new dn("onSelect", "select", null, e, n), t1.push({
                    event: e,
                    listeners: i
                }), e.target = vi)));
            }
            Re("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Re("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Re(Oe, 2);
            for(var wi = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), _i = 0; _i < wi.length; _i++)Le.set(wi[_i], 0);
            u("onMouseEnter", [
                "mouseout",
                "mouseover"
            ]), u("onMouseLeave", [
                "mouseout",
                "mouseover"
            ]), u("onPointerEnter", [
                "pointerout",
                "pointerover"
            ]), u("onPointerLeave", [
                "pointerout",
                "pointerover"
            ]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", [
                "compositionend",
                "keypress",
                "textInput",
                "paste"
            ]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var Ei = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Si = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ei));
            function Ti(t1, e, n) {
                var i = t1.type || "unknown-event";
                t1.currentTarget = n, function(t1, e, n, i, r, a, o, l, c) {
                    if (Yt.apply(this, arguments), Vt) {
                        if (!Vt) throw Error(s(198));
                        var u = Qt;
                        Vt = !1, Qt = null, Gt || (Gt = !0, Wt = u);
                    }
                }(i, e, void 0, t1), t1.currentTarget = null;
            }
            function Ii(t1, e) {
                e = !!(4 & e);
                for(var n = 0; n < t1.length; n++){
                    var i = t1[n], r = i.event;
                    i = i.listeners;
                    t: {
                        var a = void 0;
                        if (e) for(var s = i.length - 1; 0 <= s; s--){
                            var o = i[s], l = o.instance, c = o.currentTarget;
                            if (o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            Ti(r, o, c), a = l;
                        }
                        else for(s = 0; s < i.length; s++){
                            if (l = (o = i[s]).instance, c = o.currentTarget, o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            Ti(r, o, c), a = l;
                        }
                    }
                }
                if (Gt) throw t1 = Wt, Gt = !1, Wt = null, t1;
            }
            function Ci(t1, e) {
                var n = ar(e), i = t1 + "__bubble";
                n.has(i) || (Oi(e, t1, 2, !1), n.add(i));
            }
            var Ni = "_reactListening" + Math.random().toString(36).slice(2);
            function Di(t1) {
                t1[Ni] || (t1[Ni] = !0, o.forEach(function(e) {
                    Si.has(e) || Li(e, !1, t1, null), Li(e, !0, t1, null);
                }));
            }
            function Li(t1, e, n, i) {
                var r = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, a = n;
                if ("selectionchange" === t1 && 9 !== n.nodeType && (a = n.ownerDocument), null !== i && !e && Si.has(t1)) {
                    if ("scroll" !== t1) return;
                    r |= 2, a = i;
                }
                var s = ar(a), o = t1 + "__" + (e ? "capture" : "bubble");
                s.has(o) || (e && (r |= 4), Oi(a, t1, r, e), s.add(o));
            }
            function Oi(t1, e, n, i) {
                var r = Le.get(e);
                switch(void 0 === r ? 2 : r){
                    case 0:
                        r = Ze;
                        break;
                    case 1:
                        r = qe;
                        break;
                    default:
                        r = Je;
                }
                n = r.bind(null, e, n, t1), r = void 0, !jt || "touchstart" !== e && "touchmove" !== e && "wheel" !== e || (r = !0), i ? void 0 !== r ? t1.addEventListener(e, n, {
                    capture: !0,
                    passive: r
                }) : t1.addEventListener(e, n, !0) : void 0 !== r ? t1.addEventListener(e, n, {
                    passive: r
                }) : t1.addEventListener(e, n, !1);
            }
            function Ri(t1, e, n, i, r) {
                var a = i;
                if (!(1 & e || 2 & e || null === i)) t: for(;;){
                    if (null === i) return;
                    var s = i.tag;
                    if (3 === s || 4 === s) {
                        var o = i.stateNode.containerInfo;
                        if (o === r || 8 === o.nodeType && o.parentNode === r) break;
                        if (4 === s) for(s = i.return; null !== s;){
                            var l = s.tag;
                            if ((3 === l || 4 === l) && ((l = s.stateNode.containerInfo) === r || 8 === l.nodeType && l.parentNode === r)) return;
                            s = s.return;
                        }
                        for(; null !== o;){
                            if (null === (s = er(o))) return;
                            if (5 === (l = s.tag) || 6 === l) {
                                i = a = s;
                                continue t;
                            }
                            o = o.parentNode;
                        }
                    }
                    i = i.return;
                }
                !function(t1, e, n) {
                    if (Ut) return t1();
                    Ut = !0;
                    try {
                        return Pt(t1, e, n);
                    } finally{
                        Ut = !1, kt();
                    }
                }(function() {
                    var i = a, r = Et(n), s = [];
                    t: {
                        var o = De.get(t1);
                        if (void 0 !== o) {
                            var l = dn, c = t1;
                            switch(t1){
                                case "keypress":
                                    if (0 === rn(n)) break t;
                                case "keydown":
                                case "keyup":
                                    l = Cn;
                                    break;
                                case "focusin":
                                    c = "focus", l = vn;
                                    break;
                                case "focusout":
                                    c = "blur", l = vn;
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    l = vn;
                                    break;
                                case "click":
                                    if (2 === n.button) break t;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    l = gn;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    l = An;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    l = Dn;
                                    break;
                                case Te:
                                case Ie:
                                case Ce:
                                    l = yn;
                                    break;
                                case Ne:
                                    l = Ln;
                                    break;
                                case "scroll":
                                    l = fn;
                                    break;
                                case "wheel":
                                    l = Rn;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    l = bn;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    l = Nn;
                            }
                            var u = !!(4 & e), h = !u && "scroll" === t1, d = u ? null !== o ? o + "Capture" : null : o;
                            u = [];
                            for(var p, f = i; null !== f;){
                                var m = (p = f).stateNode;
                                if (5 === p.tag && null !== m && (p = m, null !== d && null != (m = Bt(f, d)) && u.push(Pi(f, m, p))), h) break;
                                f = f.return;
                            }
                            0 < u.length && (o = new l(o, c, null, n, r), s.push({
                                event: o,
                                listeners: u
                            }));
                        }
                    }
                    if (!(7 & e)) {
                        if (l = "mouseout" === t1 || "pointerout" === t1, (!(o = "mouseover" === t1 || "pointerover" === t1) || 16 & e || !(c = n.relatedTarget || n.fromElement) || !er(c) && !c[$i]) && (l || o) && (o = r.window === r ? r : (o = r.ownerDocument) ? o.defaultView || o.parentWindow : window, l ? (l = i, null !== (c = (c = n.relatedTarget || n.toElement) ? er(c) : null) && (c !== (h = Zt(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = i), l !== c)) {
                            if (u = gn, m = "onMouseLeave", d = "onMouseEnter", f = "mouse", "pointerout" !== t1 && "pointerover" !== t1 || (u = Nn, m = "onPointerLeave", d = "onPointerEnter", f = "pointer"), h = null == l ? o : ir(l), p = null == c ? o : ir(c), (o = new u(m, f + "leave", l, n, r)).target = h, o.relatedTarget = p, m = null, er(r) === i && ((u = new u(d, f + "enter", c, n, r)).target = p, u.relatedTarget = h, m = u), h = m, l && c) t: {
                                for(d = c, f = 0, p = u = l; p; p = Ui(p))f++;
                                for(p = 0, m = d; m; m = Ui(m))p++;
                                for(; 0 < f - p;)u = Ui(u), f--;
                                for(; 0 < p - f;)d = Ui(d), p--;
                                for(; f--;){
                                    if (u === d || null !== d && u === d.alternate) break t;
                                    u = Ui(u), d = Ui(d);
                                }
                                u = null;
                            }
                            else u = null;
                            null !== l && ki(s, o, l, u, !1), null !== c && null !== h && ki(s, h, c, u, !0);
                        }
                        if ("select" === (l = (o = i ? ir(i) : window).nodeName && o.nodeName.toLowerCase()) || "input" === l && "file" === o.type) var g = Kn;
                        else if (Wn(o)) {
                            if ($n) g = li;
                            else {
                                g = si;
                                var A = ai;
                            }
                        } else (l = o.nodeName) && "input" === l.toLowerCase() && ("checkbox" === o.type || "radio" === o.type) && (g = oi);
                        switch(g && (g = g(t1, i)) ? Xn(s, g, n, r) : (A && A(t1, o, i), "focusout" === t1 && (A = o._wrapperState) && A.controlled && "number" === o.type && rt(o, "number", o.value)), A = i ? ir(i) : window, t1){
                            case "focusin":
                                (Wn(A) || "true" === A.contentEditable) && (vi = A, yi = i, Mi = null);
                                break;
                            case "focusout":
                                Mi = yi = vi = null;
                                break;
                            case "mousedown":
                                bi = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                bi = !1, xi(s, n, r);
                                break;
                            case "selectionchange":
                                if (Ai) break;
                            case "keydown":
                            case "keyup":
                                xi(s, n, r);
                        }
                        var v;
                        if (zn) t: {
                            switch(t1){
                                case "compositionstart":
                                    var y = "onCompositionStart";
                                    break t;
                                case "compositionend":
                                    y = "onCompositionEnd";
                                    break t;
                                case "compositionupdate":
                                    y = "onCompositionUpdate";
                                    break t;
                            }
                            y = void 0;
                        }
                        else Qn ? Hn(t1, n) && (y = "onCompositionEnd") : "keydown" === t1 && 229 === n.keyCode && (y = "onCompositionStart");
                        y && (Bn && "ko" !== n.locale && (Qn || "onCompositionStart" !== y ? "onCompositionEnd" === y && Qn && (v = nn()) : (tn = "value" in ($e = r) ? $e.value : $e.textContent, Qn = !0)), 0 < (A = zi(i, y)).length && (y = new xn(y, t1, null, n, r), s.push({
                            event: y,
                            listeners: A
                        }), (v || null !== (v = Vn(n))) && (y.data = v))), (v = kn ? function(t1, e) {
                            switch(t1){
                                case "compositionend":
                                    return Vn(e);
                                case "keypress":
                                    return 32 !== e.which ? null : (Fn = !0, jn);
                                case "textInput":
                                    return (t1 = e.data) === jn && Fn ? null : t1;
                                default:
                                    return null;
                            }
                        }(t1, n) : function(t1, e) {
                            if (Qn) return "compositionend" === t1 || !zn && Hn(t1, e) ? (t1 = nn(), en = tn = $e = null, Qn = !1, t1) : null;
                            switch(t1){
                                case "paste":
                                default:
                                    return null;
                                case "keypress":
                                    if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
                                        if (e.char && 1 < e.char.length) return e.char;
                                        if (e.which) return String.fromCharCode(e.which);
                                    }
                                    return null;
                                case "compositionend":
                                    return Bn && "ko" !== e.locale ? null : e.data;
                            }
                        }(t1, n)) && 0 < (i = zi(i, "onBeforeInput")).length && (r = new xn("onBeforeInput", "beforeinput", null, n, r), s.push({
                            event: r,
                            listeners: i
                        }), r.data = v);
                    }
                    Ii(s, e);
                });
            }
            function Pi(t1, e, n) {
                return {
                    instance: t1,
                    listener: e,
                    currentTarget: n
                };
            }
            function zi(t1, e) {
                for(var n = e + "Capture", i = []; null !== t1;){
                    var r = t1, a = r.stateNode;
                    5 === r.tag && null !== a && (r = a, null != (a = Bt(t1, n)) && i.unshift(Pi(t1, a, r)), null != (a = Bt(t1, e)) && i.push(Pi(t1, a, r))), t1 = t1.return;
                }
                return i;
            }
            function Ui(t1) {
                if (null === t1) return null;
                do t1 = t1.return;
                while (t1 && 5 !== t1.tag);
                return t1 || null;
            }
            function ki(t1, e, n, i, r) {
                for(var a = e._reactName, s = []; null !== n && n !== i;){
                    var o = n, l = o.alternate, c = o.stateNode;
                    if (null !== l && l === i) break;
                    5 === o.tag && null !== c && (o = c, r ? null != (l = Bt(n, a)) && s.unshift(Pi(n, l, o)) : r || null != (l = Bt(n, a)) && s.push(Pi(n, l, o))), n = n.return;
                }
                0 !== s.length && t1.push({
                    event: e,
                    listeners: s
                });
            }
            function Bi() {}
            var ji = null, Fi = null;
            function Hi(t1, e) {
                switch(t1){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!e.autoFocus;
                }
                return !1;
            }
            function Vi(t1, e) {
                return "textarea" === t1 || "option" === t1 || "noscript" === t1 || "string" == typeof e.children || "number" == typeof e.children || "object" == typeof e.dangerouslySetInnerHTML && null !== e.dangerouslySetInnerHTML && null != e.dangerouslySetInnerHTML.__html;
            }
            var Qi = "function" == typeof setTimeout ? setTimeout : void 0, Gi = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function Wi(t1) {
                (1 === t1.nodeType || 9 === t1.nodeType && null != (t1 = t1.body)) && (t1.textContent = "");
            }
            function Xi(t1) {
                for(; null != t1; t1 = t1.nextSibling){
                    var e = t1.nodeType;
                    if (1 === e || 3 === e) break;
                }
                return t1;
            }
            function Yi(t1) {
                t1 = t1.previousSibling;
                for(var e = 0; t1;){
                    if (8 === t1.nodeType) {
                        var n = t1.data;
                        if ("$" === n || "$!" === n || "$?" === n) {
                            if (0 === e) return t1;
                            e--;
                        } else "/$" === n && e++;
                    }
                    t1 = t1.previousSibling;
                }
                return null;
            }
            var Zi = 0, qi = Math.random().toString(36).slice(2), Ji = "__reactFiber$" + qi, Ki = "__reactProps$" + qi, $i = "__reactContainer$" + qi, tr = "__reactEvents$" + qi;
            function er(t1) {
                var e = t1[Ji];
                if (e) return e;
                for(var n = t1.parentNode; n;){
                    if (e = n[$i] || n[Ji]) {
                        if (n = e.alternate, null !== e.child || null !== n && null !== n.child) for(t1 = Yi(t1); null !== t1;){
                            if (n = t1[Ji]) return n;
                            t1 = Yi(t1);
                        }
                        return e;
                    }
                    n = (t1 = n).parentNode;
                }
                return null;
            }
            function nr(t1) {
                return !(t1 = t1[Ji] || t1[$i]) || 5 !== t1.tag && 6 !== t1.tag && 13 !== t1.tag && 3 !== t1.tag ? null : t1;
            }
            function ir(t1) {
                if (5 === t1.tag || 6 === t1.tag) return t1.stateNode;
                throw Error(s(33));
            }
            function rr(t1) {
                return t1[Ki] || null;
            }
            function ar(t1) {
                var e = t1[tr];
                return void 0 === e && (e = t1[tr] = new Set), e;
            }
            var sr = [], or = -1;
            function lr(t1) {
                return {
                    current: t1
                };
            }
            function cr(t1) {
                0 > or || (t1.current = sr[or], sr[or] = null, or--);
            }
            function ur(t1, e) {
                or++, sr[or] = t1.current, t1.current = e;
            }
            var hr = {}, dr = lr(hr), pr = lr(!1), fr = hr;
            function mr(t1, e) {
                var n = t1.type.contextTypes;
                if (!n) return hr;
                var i = t1.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === e) return i.__reactInternalMemoizedMaskedChildContext;
                var r, a = {};
                for(r in n)a[r] = e[r];
                return i && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = e, t1.__reactInternalMemoizedMaskedChildContext = a), a;
            }
            function gr(t1) {
                return null != t1.childContextTypes;
            }
            function Ar() {
                cr(pr), cr(dr);
            }
            function vr(t1, e, n) {
                if (dr.current !== hr) throw Error(s(168));
                ur(dr, e), ur(pr, n);
            }
            function yr(t1, e, n) {
                var i = t1.stateNode;
                if (t1 = e.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var a in i = i.getChildContext())if (!(a in t1)) throw Error(s(108, X(e) || "Unknown", a));
                return r({}, n, i);
            }
            function Mr(t1) {
                return t1 = (t1 = t1.stateNode) && t1.__reactInternalMemoizedMergedChildContext || hr, fr = dr.current, ur(dr, t1), ur(pr, pr.current), !0;
            }
            function br(t1, e, n) {
                var i = t1.stateNode;
                if (!i) throw Error(s(169));
                n ? (t1 = yr(t1, e, fr), i.__reactInternalMemoizedMergedChildContext = t1, cr(pr), cr(dr), ur(dr, t1)) : cr(pr), ur(pr, n);
            }
            var xr = null, wr = null, _r = a.unstable_runWithPriority, Er = a.unstable_scheduleCallback, Sr = a.unstable_cancelCallback, Tr = a.unstable_shouldYield, Ir = a.unstable_requestPaint, Cr = a.unstable_now, Nr = a.unstable_getCurrentPriorityLevel, Dr = a.unstable_ImmediatePriority, Lr = a.unstable_UserBlockingPriority, Or = a.unstable_NormalPriority, Rr = a.unstable_LowPriority, Pr = a.unstable_IdlePriority, zr = {}, Ur = void 0 !== Ir ? Ir : function() {}, kr = null, Br = null, jr = !1, Fr = Cr(), Hr = 1e4 > Fr ? Cr : function() {
                return Cr() - Fr;
            };
            function Vr() {
                switch(Nr()){
                    case Dr:
                        return 99;
                    case Lr:
                        return 98;
                    case Or:
                        return 97;
                    case Rr:
                        return 96;
                    case Pr:
                        return 95;
                    default:
                        throw Error(s(332));
                }
            }
            function Qr(t1) {
                switch(t1){
                    case 99:
                        return Dr;
                    case 98:
                        return Lr;
                    case 97:
                        return Or;
                    case 96:
                        return Rr;
                    case 95:
                        return Pr;
                    default:
                        throw Error(s(332));
                }
            }
            function Gr(t1, e) {
                return t1 = Qr(t1), _r(t1, e);
            }
            function Wr(t1, e, n) {
                return t1 = Qr(t1), Er(t1, e, n);
            }
            function Xr() {
                if (null !== Br) {
                    var t1 = Br;
                    Br = null, Sr(t1);
                }
                Yr();
            }
            function Yr() {
                if (!jr && null !== kr) {
                    jr = !0;
                    var t1 = 0;
                    try {
                        var e = kr;
                        Gr(99, function() {
                            for(; t1 < e.length; t1++){
                                var n = e[t1];
                                do n = n(!0);
                                while (null !== n);
                            }
                        }), kr = null;
                    } catch (e) {
                        throw null !== kr && (kr = kr.slice(t1 + 1)), Er(Dr, Xr), e;
                    } finally{
                        jr = !1;
                    }
                }
            }
            var Zr = b.ReactCurrentBatchConfig;
            function qr(t1, e) {
                if (t1 && t1.defaultProps) {
                    for(var n in e = r({}, e), t1 = t1.defaultProps)void 0 === e[n] && (e[n] = t1[n]);
                    return e;
                }
                return e;
            }
            var Jr = lr(null), Kr = null, $r = null, ta = null;
            function ea() {
                ta = $r = Kr = null;
            }
            function na(t1) {
                var e = Jr.current;
                cr(Jr), t1.type._context._currentValue = e;
            }
            function ia(t1, e) {
                for(; null !== t1;){
                    var n = t1.alternate;
                    if ((t1.childLanes & e) === e) {
                        if (null === n || (n.childLanes & e) === e) break;
                        n.childLanes |= e;
                    } else t1.childLanes |= e, null !== n && (n.childLanes |= e);
                    t1 = t1.return;
                }
            }
            function ra(t1, e) {
                Kr = t1, ta = $r = null, null !== (t1 = t1.dependencies) && null !== t1.firstContext && (!!(t1.lanes & e) && (Ps = !0), t1.firstContext = null);
            }
            function aa(t1, e) {
                if (ta !== t1 && !1 !== e && 0 !== e) {
                    if ("number" == typeof e && 1073741823 !== e || (ta = t1, e = 1073741823), e = {
                        context: t1,
                        observedBits: e,
                        next: null
                    }, null === $r) {
                        if (null === Kr) throw Error(s(308));
                        $r = e, Kr.dependencies = {
                            lanes: 0,
                            firstContext: e,
                            responders: null
                        };
                    } else $r = $r.next = e;
                }
                return t1._currentValue;
            }
            var sa = !1;
            function oa(t1) {
                t1.updateQueue = {
                    baseState: t1.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function la(t1, e) {
                t1 = t1.updateQueue, e.updateQueue === t1 && (e.updateQueue = {
                    baseState: t1.baseState,
                    firstBaseUpdate: t1.firstBaseUpdate,
                    lastBaseUpdate: t1.lastBaseUpdate,
                    shared: t1.shared,
                    effects: t1.effects
                });
            }
            function ca(t1, e) {
                return {
                    eventTime: t1,
                    lane: e,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function ua(t1, e) {
                if (null !== (t1 = t1.updateQueue)) {
                    var n = (t1 = t1.shared).pending;
                    null === n ? e.next = e : (e.next = n.next, n.next = e), t1.pending = e;
                }
            }
            function ha(t1, e) {
                var n = t1.updateQueue, i = t1.alternate;
                if (null !== i && n === (i = i.updateQueue)) {
                    var r = null, a = null;
                    if (null !== (n = n.firstBaseUpdate)) {
                        do {
                            var s = {
                                eventTime: n.eventTime,
                                lane: n.lane,
                                tag: n.tag,
                                payload: n.payload,
                                callback: n.callback,
                                next: null
                            };
                            null === a ? r = a = s : a = a.next = s, n = n.next;
                        }while (null !== n);
                        null === a ? r = a = e : a = a.next = e;
                    } else r = a = e;
                    return n = {
                        baseState: i.baseState,
                        firstBaseUpdate: r,
                        lastBaseUpdate: a,
                        shared: i.shared,
                        effects: i.effects
                    }, void (t1.updateQueue = n);
                }
                null === (t1 = n.lastBaseUpdate) ? n.firstBaseUpdate = e : t1.next = e, n.lastBaseUpdate = e;
            }
            function da(t1, e, n, i) {
                var a = t1.updateQueue;
                sa = !1;
                var s = a.firstBaseUpdate, o = a.lastBaseUpdate, l = a.shared.pending;
                if (null !== l) {
                    a.shared.pending = null;
                    var c = l, u = c.next;
                    c.next = null, null === o ? s = u : o.next = u, o = c;
                    var h = t1.alternate;
                    if (null !== h) {
                        var d = (h = h.updateQueue).lastBaseUpdate;
                        d !== o && (null === d ? h.firstBaseUpdate = u : d.next = u, h.lastBaseUpdate = c);
                    }
                }
                if (null !== s) {
                    for(d = a.baseState, o = 0, h = u = c = null;;){
                        l = s.lane;
                        var p = s.eventTime;
                        if ((i & l) === l) {
                            null !== h && (h = h.next = {
                                eventTime: p,
                                lane: 0,
                                tag: s.tag,
                                payload: s.payload,
                                callback: s.callback,
                                next: null
                            });
                            t: {
                                var f = t1, m = s;
                                switch(l = e, p = n, m.tag){
                                    case 1:
                                        if ("function" == typeof (f = m.payload)) {
                                            d = f.call(p, d, l);
                                            break t;
                                        }
                                        d = f;
                                        break t;
                                    case 3:
                                        f.flags = -4097 & f.flags | 64;
                                    case 0:
                                        if (null == (l = "function" == typeof (f = m.payload) ? f.call(p, d, l) : f)) break t;
                                        d = r({}, d, l);
                                        break t;
                                    case 2:
                                        sa = !0;
                                }
                            }
                            null !== s.callback && (t1.flags |= 32, null === (l = a.effects) ? a.effects = [
                                s
                            ] : l.push(s));
                        } else p = {
                            eventTime: p,
                            lane: l,
                            tag: s.tag,
                            payload: s.payload,
                            callback: s.callback,
                            next: null
                        }, null === h ? (u = h = p, c = d) : h = h.next = p, o |= l;
                        if (null === (s = s.next)) {
                            if (null === (l = a.shared.pending)) break;
                            s = l.next, l.next = null, a.lastBaseUpdate = l, a.shared.pending = null;
                        }
                    }
                    null === h && (c = d), a.baseState = c, a.firstBaseUpdate = u, a.lastBaseUpdate = h, Bo |= o, t1.lanes = o, t1.memoizedState = d;
                }
            }
            function pa(t1, e, n) {
                if (t1 = e.effects, e.effects = null, null !== t1) for(e = 0; e < t1.length; e++){
                    var i = t1[e], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = n, "function" != typeof r) throw Error(s(191, r));
                        r.call(i);
                    }
                }
            }
            var fa = (new i.Component).refs;
            function ma(t1, e, n, i) {
                n = null == (n = n(i, e = t1.memoizedState)) ? e : r({}, e, n), t1.memoizedState = n, 0 === t1.lanes && (t1.updateQueue.baseState = n);
            }
            var ga = {
                isMounted: function(t1) {
                    return !!(t1 = t1._reactInternals) && Zt(t1) === t1;
                },
                enqueueSetState: function(t1, e, n) {
                    t1 = t1._reactInternals;
                    var i = ul(), r = hl(t1), a = ca(i, r);
                    a.payload = e, null != n && (a.callback = n), ua(t1, a), dl(t1, r, i);
                },
                enqueueReplaceState: function(t1, e, n) {
                    t1 = t1._reactInternals;
                    var i = ul(), r = hl(t1), a = ca(i, r);
                    a.tag = 1, a.payload = e, null != n && (a.callback = n), ua(t1, a), dl(t1, r, i);
                },
                enqueueForceUpdate: function(t1, e) {
                    t1 = t1._reactInternals;
                    var n = ul(), i = hl(t1), r = ca(n, i);
                    r.tag = 2, null != e && (r.callback = e), ua(t1, r), dl(t1, i, n);
                }
            };
            function Aa(t1, e, n, i, r, a, s) {
                return "function" == typeof (t1 = t1.stateNode).shouldComponentUpdate ? t1.shouldComponentUpdate(i, a, s) : !(e.prototype && e.prototype.isPureReactComponent && hi(n, i) && hi(r, a));
            }
            function va(t1, e, n) {
                var i = !1, r = hr, a = e.contextType;
                return "object" == typeof a && null !== a ? a = aa(a) : (r = gr(e) ? fr : dr.current, a = (i = null != (i = e.contextTypes)) ? mr(t1, r) : hr), e = new e(n, a), t1.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, e.updater = ga, t1.stateNode = e, e._reactInternals = t1, i && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, t1.__reactInternalMemoizedMaskedChildContext = a), e;
            }
            function ya(t1, e, n, i) {
                t1 = e.state, "function" == typeof e.componentWillReceiveProps && e.componentWillReceiveProps(n, i), "function" == typeof e.UNSAFE_componentWillReceiveProps && e.UNSAFE_componentWillReceiveProps(n, i), e.state !== t1 && ga.enqueueReplaceState(e, e.state, null);
            }
            function Ma(t1, e, n, i) {
                var r = t1.stateNode;
                r.props = n, r.state = t1.memoizedState, r.refs = fa, oa(t1);
                var a = e.contextType;
                "object" == typeof a && null !== a ? r.context = aa(a) : (a = gr(e) ? fr : dr.current, r.context = mr(t1, a)), da(t1, n, r, i), r.state = t1.memoizedState, "function" == typeof (a = e.getDerivedStateFromProps) && (ma(t1, e, a, n), r.state = t1.memoizedState), "function" == typeof e.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (e = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), e !== r.state && ga.enqueueReplaceState(r, r.state, null), da(t1, n, r, i), r.state = t1.memoizedState), "function" == typeof r.componentDidMount && (t1.flags |= 4);
            }
            var ba = Array.isArray;
            function xa(t1, e, n) {
                if (null !== (t1 = n.ref) && "function" != typeof t1 && "object" != typeof t1) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(s(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(s(147, t1));
                        var r = "" + t1;
                        return null !== e && null !== e.ref && "function" == typeof e.ref && e.ref._stringRef === r ? e.ref : (e = function(t1) {
                            var e = i.refs;
                            e === fa && (e = i.refs = {}), null === t1 ? delete e[r] : e[r] = t1;
                        }, e._stringRef = r, e);
                    }
                    if ("string" != typeof t1) throw Error(s(284));
                    if (!n._owner) throw Error(s(290, t1));
                }
                return t1;
            }
            function wa(t1, e) {
                if ("textarea" !== t1.type) throw Error(s(31, "[object Object]" === Object.prototype.toString.call(e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : e));
            }
            function _a(t1) {
                function e(e, n) {
                    if (t1) {
                        var i = e.lastEffect;
                        null !== i ? (i.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n, n.nextEffect = null, n.flags = 8;
                    }
                }
                function n(n, i) {
                    if (!t1) return null;
                    for(; null !== i;)e(n, i), i = i.sibling;
                    return null;
                }
                function i(t1, e) {
                    for(t1 = new Map; null !== e;)null !== e.key ? t1.set(e.key, e) : t1.set(e.index, e), e = e.sibling;
                    return t1;
                }
                function r(t1, e) {
                    return (t1 = Ql(t1, e)).index = 0, t1.sibling = null, t1;
                }
                function a(e, n, i) {
                    return e.index = i, t1 ? null !== (i = e.alternate) ? (i = i.index) < n ? (e.flags = 2, n) : i : (e.flags = 2, n) : n;
                }
                function o(e) {
                    return t1 && null === e.alternate && (e.flags = 2), e;
                }
                function l(t1, e, n, i) {
                    return null === e || 6 !== e.tag ? ((e = Yl(n, t1.mode, i)).return = t1, e) : ((e = r(e, n)).return = t1, e);
                }
                function c(t1, e, n, i) {
                    return null !== e && e.elementType === n.type ? ((i = r(e, n.props)).ref = xa(t1, e, n), i.return = t1, i) : ((i = Gl(n.type, n.key, n.props, null, t1.mode, i)).ref = xa(t1, e, n), i.return = t1, i);
                }
                function u(t1, e, n, i) {
                    return null === e || 4 !== e.tag || e.stateNode.containerInfo !== n.containerInfo || e.stateNode.implementation !== n.implementation ? ((e = Zl(n, t1.mode, i)).return = t1, e) : ((e = r(e, n.children || [])).return = t1, e);
                }
                function h(t1, e, n, i, a) {
                    return null === e || 7 !== e.tag ? ((e = Wl(n, t1.mode, i, a)).return = t1, e) : ((e = r(e, n)).return = t1, e);
                }
                function d(t1, e, n) {
                    if ("string" == typeof e || "number" == typeof e) return (e = Yl("" + e, t1.mode, n)).return = t1, e;
                    if ("object" == typeof e && null !== e) {
                        switch(e.$$typeof){
                            case x:
                                return (n = Gl(e.type, e.key, e.props, null, t1.mode, n)).ref = xa(t1, null, e), n.return = t1, n;
                            case w:
                                return (e = Zl(e, t1.mode, n)).return = t1, e;
                        }
                        if (ba(e) || H(e)) return (e = Wl(e, t1.mode, n, null)).return = t1, e;
                        wa(t1, e);
                    }
                    return null;
                }
                function p(t1, e, n, i) {
                    var r = null !== e ? e.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : l(t1, e, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case x:
                                return n.key === r ? n.type === _ ? h(t1, e, n.props.children, i, r) : c(t1, e, n, i) : null;
                            case w:
                                return n.key === r ? u(t1, e, n, i) : null;
                        }
                        if (ba(n) || H(n)) return null !== r ? null : h(t1, e, n, i, null);
                        wa(t1, n);
                    }
                    return null;
                }
                function f(t1, e, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return l(e, t1 = t1.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case x:
                                return t1 = t1.get(null === i.key ? n : i.key) || null, i.type === _ ? h(e, t1, i.props.children, r, i.key) : c(e, t1, i, r);
                            case w:
                                return u(e, t1 = t1.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (ba(i) || H(i)) return h(e, t1 = t1.get(n) || null, i, r, null);
                        wa(e, i);
                    }
                    return null;
                }
                function m(r, s, o, l) {
                    for(var c = null, u = null, h = s, m = s = 0, g = null; null !== h && m < o.length; m++){
                        h.index > m ? (g = h, h = null) : g = h.sibling;
                        var A = p(r, h, o[m], l);
                        if (null === A) {
                            null === h && (h = g);
                            break;
                        }
                        t1 && h && null === A.alternate && e(r, h), s = a(A, s, m), null === u ? c = A : u.sibling = A, u = A, h = g;
                    }
                    if (m === o.length) return n(r, h), c;
                    if (null === h) {
                        for(; m < o.length; m++)null !== (h = d(r, o[m], l)) && (s = a(h, s, m), null === u ? c = h : u.sibling = h, u = h);
                        return c;
                    }
                    for(h = i(r, h); m < o.length; m++)null !== (g = f(h, r, m, o[m], l)) && (t1 && null !== g.alternate && h.delete(null === g.key ? m : g.key), s = a(g, s, m), null === u ? c = g : u.sibling = g, u = g);
                    return t1 && h.forEach(function(t1) {
                        return e(r, t1);
                    }), c;
                }
                function g(r, o, l, c) {
                    var u = H(l);
                    if ("function" != typeof u) throw Error(s(150));
                    if (null == (l = u.call(l))) throw Error(s(151));
                    for(var h = u = null, m = o, g = o = 0, A = null, v = l.next(); null !== m && !v.done; g++, v = l.next()){
                        m.index > g ? (A = m, m = null) : A = m.sibling;
                        var y = p(r, m, v.value, c);
                        if (null === y) {
                            null === m && (m = A);
                            break;
                        }
                        t1 && m && null === y.alternate && e(r, m), o = a(y, o, g), null === h ? u = y : h.sibling = y, h = y, m = A;
                    }
                    if (v.done) return n(r, m), u;
                    if (null === m) {
                        for(; !v.done; g++, v = l.next())null !== (v = d(r, v.value, c)) && (o = a(v, o, g), null === h ? u = v : h.sibling = v, h = v);
                        return u;
                    }
                    for(m = i(r, m); !v.done; g++, v = l.next())null !== (v = f(m, r, g, v.value, c)) && (t1 && null !== v.alternate && m.delete(null === v.key ? g : v.key), o = a(v, o, g), null === h ? u = v : h.sibling = v, h = v);
                    return t1 && m.forEach(function(t1) {
                        return e(r, t1);
                    }), u;
                }
                return function(t1, i, a, l) {
                    var c = "object" == typeof a && null !== a && a.type === _ && null === a.key;
                    c && (a = a.props.children);
                    var u = "object" == typeof a && null !== a;
                    if (u) switch(a.$$typeof){
                        case x:
                            t: {
                                for(u = a.key, c = i; null !== c;){
                                    if (c.key === u) {
                                        if (7 === c.tag) {
                                            if (a.type === _) {
                                                n(t1, c.sibling), (i = r(c, a.props.children)).return = t1, t1 = i;
                                                break t;
                                            }
                                        } else if (c.elementType === a.type) {
                                            n(t1, c.sibling), (i = r(c, a.props)).ref = xa(t1, c, a), i.return = t1, t1 = i;
                                            break t;
                                        }
                                        n(t1, c);
                                        break;
                                    }
                                    e(t1, c), c = c.sibling;
                                }
                                a.type === _ ? ((i = Wl(a.props.children, t1.mode, l, a.key)).return = t1, t1 = i) : ((l = Gl(a.type, a.key, a.props, null, t1.mode, l)).ref = xa(t1, i, a), l.return = t1, t1 = l);
                            }
                            return o(t1);
                        case w:
                            t: {
                                for(c = a.key; null !== i;){
                                    if (i.key === c) {
                                        if (4 === i.tag && i.stateNode.containerInfo === a.containerInfo && i.stateNode.implementation === a.implementation) {
                                            n(t1, i.sibling), (i = r(i, a.children || [])).return = t1, t1 = i;
                                            break t;
                                        }
                                        n(t1, i);
                                        break;
                                    }
                                    e(t1, i), i = i.sibling;
                                }
                                (i = Zl(a, t1.mode, l)).return = t1, t1 = i;
                            }
                            return o(t1);
                    }
                    if ("string" == typeof a || "number" == typeof a) return a = "" + a, null !== i && 6 === i.tag ? (n(t1, i.sibling), (i = r(i, a)).return = t1, t1 = i) : (n(t1, i), (i = Yl(a, t1.mode, l)).return = t1, t1 = i), o(t1);
                    if (ba(a)) return m(t1, i, a, l);
                    if (H(a)) return g(t1, i, a, l);
                    if (u && wa(t1, a), void 0 === a && !c) switch(t1.tag){
                        case 1:
                        case 22:
                        case 0:
                        case 11:
                        case 15:
                            throw Error(s(152, X(t1.type) || "Component"));
                    }
                    return n(t1, i);
                };
            }
            var Ea = _a(!0), Sa = _a(!1), Ta = {}, Ia = lr(Ta), Ca = lr(Ta), Na = lr(Ta);
            function Da(t1) {
                if (t1 === Ta) throw Error(s(174));
                return t1;
            }
            function La(t1, e) {
                switch(ur(Na, e), ur(Ca, t1), ur(Ia, Ta), t1 = e.nodeType){
                    case 9:
                    case 11:
                        e = (e = e.documentElement) ? e.namespaceURI : pt(null, "");
                        break;
                    default:
                        e = pt(e = (t1 = 8 === t1 ? e.parentNode : e).namespaceURI || null, t1 = t1.tagName);
                }
                cr(Ia), ur(Ia, e);
            }
            function Oa() {
                cr(Ia), cr(Ca), cr(Na);
            }
            function Ra(t1) {
                Da(Na.current);
                var e = Da(Ia.current), n = pt(e, t1.type);
                e !== n && (ur(Ca, t1), ur(Ia, n));
            }
            function Pa(t1) {
                Ca.current === t1 && (cr(Ia), cr(Ca));
            }
            var za = lr(0);
            function Ua(t1) {
                for(var e = t1; null !== e;){
                    if (13 === e.tag) {
                        var n = e.memoizedState;
                        if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return e;
                    } else if (19 === e.tag && void 0 !== e.memoizedProps.revealOrder) {
                        if (64 & e.flags) return e;
                    } else if (null !== e.child) {
                        e.child.return = e, e = e.child;
                        continue;
                    }
                    if (e === t1) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === t1) return null;
                        e = e.return;
                    }
                    e.sibling.return = e.return, e = e.sibling;
                }
                return null;
            }
            var ka = null, Ba = null, ja = !1;
            function Fa(t1, e) {
                var n = Hl(5, null, null, 0);
                n.elementType = "DELETED", n.type = "DELETED", n.stateNode = e, n.return = t1, n.flags = 8, null !== t1.lastEffect ? (t1.lastEffect.nextEffect = n, t1.lastEffect = n) : t1.firstEffect = t1.lastEffect = n;
            }
            function Ha(t1, e) {
                switch(t1.tag){
                    case 5:
                        var n = t1.type;
                        return null !== (e = 1 !== e.nodeType || n.toLowerCase() !== e.nodeName.toLowerCase() ? null : e) && (t1.stateNode = e, !0);
                    case 6:
                        return null !== (e = "" === t1.pendingProps || 3 !== e.nodeType ? null : e) && (t1.stateNode = e, !0);
                    default:
                        return !1;
                }
            }
            function Va(t1) {
                if (ja) {
                    var e = Ba;
                    if (e) {
                        var n = e;
                        if (!Ha(t1, e)) {
                            if (!(e = Xi(n.nextSibling)) || !Ha(t1, e)) return t1.flags = -1025 & t1.flags | 2, ja = !1, void (ka = t1);
                            Fa(ka, n);
                        }
                        ka = t1, Ba = Xi(e.firstChild);
                    } else t1.flags = -1025 & t1.flags | 2, ja = !1, ka = t1;
                }
            }
            function Qa(t1) {
                for(t1 = t1.return; null !== t1 && 5 !== t1.tag && 3 !== t1.tag && 13 !== t1.tag;)t1 = t1.return;
                ka = t1;
            }
            function Ga(t1) {
                if (t1 !== ka) return !1;
                if (!ja) return Qa(t1), ja = !0, !1;
                var e = t1.type;
                if (5 !== t1.tag || "head" !== e && "body" !== e && !Vi(e, t1.memoizedProps)) for(e = Ba; e;)Fa(t1, e), e = Xi(e.nextSibling);
                if (Qa(t1), 13 === t1.tag) {
                    if (!(t1 = null !== (t1 = t1.memoizedState) ? t1.dehydrated : null)) throw Error(s(317));
                    t: {
                        for(t1 = t1.nextSibling, e = 0; t1;){
                            if (8 === t1.nodeType) {
                                var n = t1.data;
                                if ("/$" === n) {
                                    if (0 === e) {
                                        Ba = Xi(t1.nextSibling);
                                        break t;
                                    }
                                    e--;
                                } else "$" !== n && "$!" !== n && "$?" !== n || e++;
                            }
                            t1 = t1.nextSibling;
                        }
                        Ba = null;
                    }
                } else Ba = ka ? Xi(t1.stateNode.nextSibling) : null;
                return !0;
            }
            function Wa() {
                Ba = ka = null, ja = !1;
            }
            var Xa = [];
            function Ya() {
                for(var t1 = 0; t1 < Xa.length; t1++)Xa[t1]._workInProgressVersionPrimary = null;
                Xa.length = 0;
            }
            var Za = b.ReactCurrentDispatcher, qa = b.ReactCurrentBatchConfig, Ja = 0, Ka = null, $a = null, ts = null, es = !1, ns = !1;
            function is() {
                throw Error(s(321));
            }
            function rs(t1, e) {
                if (null === e) return !1;
                for(var n = 0; n < e.length && n < t1.length; n++)if (!ci(t1[n], e[n])) return !1;
                return !0;
            }
            function as(t1, e, n, i, r, a) {
                if (Ja = a, Ka = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, Za.current = null === t1 || null === t1.memoizedState ? Ds : Ls, t1 = n(i, r), ns) {
                    a = 0;
                    do {
                        if (ns = !1, !(25 > a)) throw Error(s(301));
                        a += 1, ts = $a = null, e.updateQueue = null, Za.current = Os, t1 = n(i, r);
                    }while (ns);
                }
                if (Za.current = Ns, e = null !== $a && null !== $a.next, Ja = 0, ts = $a = Ka = null, es = !1, e) throw Error(s(300));
                return t1;
            }
            function ss() {
                var t1 = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === ts ? Ka.memoizedState = ts = t1 : ts = ts.next = t1, ts;
            }
            function os() {
                if (null === $a) {
                    var t1 = Ka.alternate;
                    t1 = null !== t1 ? t1.memoizedState : null;
                } else t1 = $a.next;
                var e = null === ts ? Ka.memoizedState : ts.next;
                if (null !== e) ts = e, $a = t1;
                else {
                    if (null === t1) throw Error(s(310));
                    t1 = {
                        memoizedState: ($a = t1).memoizedState,
                        baseState: $a.baseState,
                        baseQueue: $a.baseQueue,
                        queue: $a.queue,
                        next: null
                    }, null === ts ? Ka.memoizedState = ts = t1 : ts = ts.next = t1;
                }
                return ts;
            }
            function ls(t1, e) {
                return "function" == typeof e ? e(t1) : e;
            }
            function cs(t1) {
                var e = os(), n = e.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = t1;
                var i = $a, r = i.baseQueue, a = n.pending;
                if (null !== a) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = a.next, a.next = o;
                    }
                    i.baseQueue = r = a, n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var l = o = a = null, c = r;
                    do {
                        var u = c.lane;
                        if ((Ja & u) === u) null !== l && (l = l.next = {
                            lane: 0,
                            action: c.action,
                            eagerReducer: c.eagerReducer,
                            eagerState: c.eagerState,
                            next: null
                        }), i = c.eagerReducer === t1 ? c.eagerState : t1(i, c.action);
                        else {
                            var h = {
                                lane: u,
                                action: c.action,
                                eagerReducer: c.eagerReducer,
                                eagerState: c.eagerState,
                                next: null
                            };
                            null === l ? (o = l = h, a = i) : l = l.next = h, Ka.lanes |= u, Bo |= u;
                        }
                        c = c.next;
                    }while (null !== c && c !== r);
                    null === l ? a = i : l.next = o, ci(i, e.memoizedState) || (Ps = !0), e.memoizedState = i, e.baseState = a, e.baseQueue = l, n.lastRenderedState = i;
                }
                return [
                    e.memoizedState,
                    n.dispatch
                ];
            }
            function us(t1) {
                var e = os(), n = e.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = t1;
                var i = n.dispatch, r = n.pending, a = e.memoizedState;
                if (null !== r) {
                    n.pending = null;
                    var o = r = r.next;
                    do a = t1(a, o.action), o = o.next;
                    while (o !== r);
                    ci(a, e.memoizedState) || (Ps = !0), e.memoizedState = a, null === e.baseQueue && (e.baseState = a), n.lastRenderedState = a;
                }
                return [
                    a,
                    i
                ];
            }
            function hs(t1, e, n) {
                var i = e._getVersion;
                i = i(e._source);
                var r = e._workInProgressVersionPrimary;
                if (null !== r ? t1 = r === i : (t1 = t1.mutableReadLanes, (t1 = (Ja & t1) === t1) && (e._workInProgressVersionPrimary = i, Xa.push(e))), t1) return n(e._source);
                throw Xa.push(e), Error(s(350));
            }
            function ds(t1, e, n, i) {
                var r = Do;
                if (null === r) throw Error(s(349));
                var a = e._getVersion, o = a(e._source), l = Za.current, c = l.useState(function() {
                    return hs(r, e, n);
                }), u = c[1], h = c[0];
                c = ts;
                var d = t1.memoizedState, p = d.refs, f = p.getSnapshot, m = d.source;
                d = d.subscribe;
                var g = Ka;
                return t1.memoizedState = {
                    refs: p,
                    source: e,
                    subscribe: i
                }, l.useEffect(function() {
                    p.getSnapshot = n, p.setSnapshot = u;
                    var t1 = a(e._source);
                    if (!ci(o, t1)) {
                        t1 = n(e._source), ci(h, t1) || (u(t1), t1 = hl(g), r.mutableReadLanes |= t1 & r.pendingLanes), t1 = r.mutableReadLanes, r.entangledLanes |= t1;
                        for(var i = r.entanglements, s = t1; 0 < s;){
                            var l = 31 - Ve(s), c = 1 << l;
                            i[l] |= t1, s &= ~c;
                        }
                    }
                }, [
                    n,
                    e,
                    i
                ]), l.useEffect(function() {
                    return i(e._source, function() {
                        var t1 = p.getSnapshot, n = p.setSnapshot;
                        try {
                            n(t1(e._source));
                            var i = hl(g);
                            r.mutableReadLanes |= i & r.pendingLanes;
                        } catch (t1) {
                            n(function() {
                                throw t1;
                            });
                        }
                    });
                }, [
                    e,
                    i
                ]), ci(f, n) && ci(m, e) && ci(d, i) || ((t1 = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: h
                }).dispatch = u = Cs.bind(null, Ka, t1), c.queue = t1, c.baseQueue = null, h = hs(r, e, n), c.memoizedState = c.baseState = h), h;
            }
            function ps(t1, e, n) {
                return ds(os(), t1, e, n);
            }
            function fs(t1) {
                var e = ss();
                return "function" == typeof t1 && (t1 = t1()), e.memoizedState = e.baseState = t1, t1 = (t1 = e.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: t1
                }).dispatch = Cs.bind(null, Ka, t1), [
                    e.memoizedState,
                    t1
                ];
            }
            function ms(t1, e, n, i) {
                return t1 = {
                    tag: t1,
                    create: e,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (e = Ka.updateQueue) ? (e = {
                    lastEffect: null
                }, Ka.updateQueue = e, e.lastEffect = t1.next = t1) : null === (n = e.lastEffect) ? e.lastEffect = t1.next = t1 : (i = n.next, n.next = t1, t1.next = i, e.lastEffect = t1), t1;
            }
            function gs(t1) {
                return t1 = {
                    current: t1
                }, ss().memoizedState = t1;
            }
            function As() {
                return os().memoizedState;
            }
            function vs(t1, e, n, i) {
                var r = ss();
                Ka.flags |= t1, r.memoizedState = ms(1 | e, n, void 0, void 0 === i ? null : i);
            }
            function ys(t1, e, n, i) {
                var r = os();
                i = void 0 === i ? null : i;
                var a = void 0;
                if (null !== $a) {
                    var s = $a.memoizedState;
                    if (a = s.destroy, null !== i && rs(i, s.deps)) return void ms(e, n, a, i);
                }
                Ka.flags |= t1, r.memoizedState = ms(1 | e, n, a, i);
            }
            function Ms(t1, e) {
                return vs(516, 4, t1, e);
            }
            function bs(t1, e) {
                return ys(516, 4, t1, e);
            }
            function xs(t1, e) {
                return ys(4, 2, t1, e);
            }
            function ws(t1, e) {
                return "function" == typeof e ? (t1 = t1(), e(t1), function() {
                    e(null);
                }) : null != e ? (t1 = t1(), e.current = t1, function() {
                    e.current = null;
                }) : void 0;
            }
            function _s(t1, e, n) {
                return n = null != n ? n.concat([
                    t1
                ]) : null, ys(4, 2, ws.bind(null, e, t1), n);
            }
            function Es() {}
            function Ss(t1, e) {
                var n = os();
                e = void 0 === e ? null : e;
                var i = n.memoizedState;
                return null !== i && null !== e && rs(e, i[1]) ? i[0] : (n.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Ts(t1, e) {
                var n = os();
                e = void 0 === e ? null : e;
                var i = n.memoizedState;
                return null !== i && null !== e && rs(e, i[1]) ? i[0] : (t1 = t1(), n.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Is(t1, e) {
                var n = Vr();
                Gr(98 > n ? 98 : n, function() {
                    t1(!0);
                }), Gr(97 < n ? 97 : n, function() {
                    var n = qa.transition;
                    qa.transition = 1;
                    try {
                        t1(!1), e();
                    } finally{
                        qa.transition = n;
                    }
                });
            }
            function Cs(t1, e, n) {
                var i = ul(), r = hl(t1), a = {
                    lane: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, s = e.pending;
                if (null === s ? a.next = a : (a.next = s.next, s.next = a), e.pending = a, s = t1.alternate, t1 === Ka || null !== s && s === Ka) ns = es = !0;
                else {
                    if (0 === t1.lanes && (null === s || 0 === s.lanes) && null !== (s = e.lastRenderedReducer)) try {
                        var o = e.lastRenderedState, l = s(o, n);
                        if (a.eagerReducer = s, a.eagerState = l, ci(l, o)) return;
                    } catch (t1) {}
                    dl(t1, r, i);
                }
            }
            var Ns = {
                readContext: aa,
                useCallback: is,
                useContext: is,
                useEffect: is,
                useImperativeHandle: is,
                useLayoutEffect: is,
                useMemo: is,
                useReducer: is,
                useRef: is,
                useState: is,
                useDebugValue: is,
                useDeferredValue: is,
                useTransition: is,
                useMutableSource: is,
                useOpaqueIdentifier: is,
                unstable_isNewReconciler: !1
            }, Ds = {
                readContext: aa,
                useCallback: function(t1, e) {
                    return ss().memoizedState = [
                        t1,
                        void 0 === e ? null : e
                    ], t1;
                },
                useContext: aa,
                useEffect: Ms,
                useImperativeHandle: function(t1, e, n) {
                    return n = null != n ? n.concat([
                        t1
                    ]) : null, vs(4, 2, ws.bind(null, e, t1), n);
                },
                useLayoutEffect: function(t1, e) {
                    return vs(4, 2, t1, e);
                },
                useMemo: function(t1, e) {
                    var n = ss();
                    return e = void 0 === e ? null : e, t1 = t1(), n.memoizedState = [
                        t1,
                        e
                    ], t1;
                },
                useReducer: function(t1, e, n) {
                    var i = ss();
                    return e = void 0 !== n ? n(e) : e, i.memoizedState = i.baseState = e, t1 = (t1 = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: t1,
                        lastRenderedState: e
                    }).dispatch = Cs.bind(null, Ka, t1), [
                        i.memoizedState,
                        t1
                    ];
                },
                useRef: gs,
                useState: fs,
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = fs(t1), n = e[0], i = e[1];
                    return Ms(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            i(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), n;
                },
                useTransition: function() {
                    var t1 = fs(!1), e = t1[0];
                    return gs(t1 = Is.bind(null, t1[1])), [
                        t1,
                        e
                    ];
                },
                useMutableSource: function(t1, e, n) {
                    var i = ss();
                    return i.memoizedState = {
                        refs: {
                            getSnapshot: e,
                            setSnapshot: null
                        },
                        source: t1,
                        subscribe: n
                    }, ds(i, t1, e, n);
                },
                useOpaqueIdentifier: function() {
                    if (ja) {
                        var t1 = !1, e = function(t1) {
                            return {
                                $$typeof: P,
                                toString: t1,
                                valueOf: t1
                            };
                        }(function() {
                            throw t1 || (t1 = !0, n("r:" + (Zi++).toString(36))), Error(s(355));
                        }), n = fs(e)[1];
                        return !(2 & Ka.mode) && (Ka.flags |= 516, ms(5, function() {
                            n("r:" + (Zi++).toString(36));
                        }, void 0, null)), e;
                    }
                    return fs(e = "r:" + (Zi++).toString(36)), e;
                },
                unstable_isNewReconciler: !1
            }, Ls = {
                readContext: aa,
                useCallback: Ss,
                useContext: aa,
                useEffect: bs,
                useImperativeHandle: _s,
                useLayoutEffect: xs,
                useMemo: Ts,
                useReducer: cs,
                useRef: As,
                useState: function() {
                    return cs(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = cs(ls), n = e[0], i = e[1];
                    return bs(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            i(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), n;
                },
                useTransition: function() {
                    var t1 = cs(ls)[0];
                    return [
                        As().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return cs(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Os = {
                readContext: aa,
                useCallback: Ss,
                useContext: aa,
                useEffect: bs,
                useImperativeHandle: _s,
                useLayoutEffect: xs,
                useMemo: Ts,
                useReducer: us,
                useRef: As,
                useState: function() {
                    return us(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = us(ls), n = e[0], i = e[1];
                    return bs(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            i(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), n;
                },
                useTransition: function() {
                    var t1 = us(ls)[0];
                    return [
                        As().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return us(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Rs = b.ReactCurrentOwner, Ps = !1;
            function zs(t1, e, n, i) {
                e.child = null === t1 ? Sa(e, null, n, i) : Ea(e, t1.child, n, i);
            }
            function Us(t1, e, n, i, r) {
                n = n.render;
                var a = e.ref;
                return ra(e, r), i = as(t1, e, n, i, a, r), null === t1 || Ps ? (e.flags |= 1, zs(t1, e, i, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, no(t1, e, r));
            }
            function ks(t1, e, n, i, r, a) {
                if (null === t1) {
                    var s = n.type;
                    return "function" != typeof s || Vl(s) || void 0 !== s.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((t1 = Gl(n.type, null, i, e, e.mode, a)).ref = e.ref, t1.return = e, e.child = t1) : (e.tag = 15, e.type = s, Bs(t1, e, s, i, r, a));
                }
                return s = t1.child, r & a || (r = s.memoizedProps, !(n = null !== (n = n.compare) ? n : hi)(r, i) || t1.ref !== e.ref) ? (e.flags |= 1, (t1 = Ql(s, i)).ref = e.ref, t1.return = e, e.child = t1) : no(t1, e, a);
            }
            function Bs(t1, e, n, i, r, a) {
                if (null !== t1 && hi(t1.memoizedProps, i) && t1.ref === e.ref) {
                    if (Ps = !1, !(a & r)) return e.lanes = t1.lanes, no(t1, e, a);
                    16384 & t1.flags && (Ps = !0);
                }
                return Hs(t1, e, n, i, a);
            }
            function js(t1, e, n) {
                var i = e.pendingProps, r = i.children, a = null !== t1 ? t1.memoizedState : null;
                if ("hidden" === i.mode || "unstable-defer-without-hiding" === i.mode) {
                    if (4 & e.mode) {
                        if (!(1073741824 & n)) return t1 = null !== a ? a.baseLanes | n : n, e.lanes = e.childLanes = 1073741824, e.memoizedState = {
                            baseLanes: t1
                        }, Ml(0, t1), null;
                        e.memoizedState = {
                            baseLanes: 0
                        }, Ml(0, null !== a ? a.baseLanes : n);
                    } else e.memoizedState = {
                        baseLanes: 0
                    }, Ml(0, n);
                } else null !== a ? (i = a.baseLanes | n, e.memoizedState = null) : i = n, Ml(0, i);
                return zs(t1, e, r, n), e.child;
            }
            function Fs(t1, e) {
                var n = e.ref;
                (null === t1 && null !== n || null !== t1 && t1.ref !== n) && (e.flags |= 128);
            }
            function Hs(t1, e, n, i, r) {
                var a = gr(n) ? fr : dr.current;
                return a = mr(e, a), ra(e, r), n = as(t1, e, n, i, a, r), null === t1 || Ps ? (e.flags |= 1, zs(t1, e, n, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, no(t1, e, r));
            }
            function Vs(t1, e, n, i, r) {
                if (gr(n)) {
                    var a = !0;
                    Mr(e);
                } else a = !1;
                if (ra(e, r), null === e.stateNode) null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), va(e, n, i), Ma(e, n, i, r), i = !0;
                else if (null === t1) {
                    var s = e.stateNode, o = e.memoizedProps;
                    s.props = o;
                    var l = s.context, c = n.contextType;
                    c = "object" == typeof c && null !== c ? aa(c) : mr(e, c = gr(n) ? fr : dr.current);
                    var u = n.getDerivedStateFromProps, h = "function" == typeof u || "function" == typeof s.getSnapshotBeforeUpdate;
                    h || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== i || l !== c) && ya(e, s, i, c), sa = !1;
                    var d = e.memoizedState;
                    s.state = d, da(e, i, s, r), l = e.memoizedState, o !== i || d !== l || pr.current || sa ? ("function" == typeof u && (ma(e, n, u, i), l = e.memoizedState), (o = sa || Aa(e, n, o, i, d, l, c)) ? (h || "function" != typeof s.UNSAFE_componentWillMount && "function" != typeof s.componentWillMount || ("function" == typeof s.componentWillMount && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && s.UNSAFE_componentWillMount()), "function" == typeof s.componentDidMount && (e.flags |= 4)) : ("function" == typeof s.componentDidMount && (e.flags |= 4), e.memoizedProps = i, e.memoizedState = l), s.props = i, s.state = l, s.context = c, i = o) : ("function" == typeof s.componentDidMount && (e.flags |= 4), i = !1);
                } else {
                    s = e.stateNode, la(t1, e), o = e.memoizedProps, c = e.type === e.elementType ? o : qr(e.type, o), s.props = c, h = e.pendingProps, d = s.context, l = "object" == typeof (l = n.contextType) && null !== l ? aa(l) : mr(e, l = gr(n) ? fr : dr.current);
                    var p = n.getDerivedStateFromProps;
                    (u = "function" == typeof p || "function" == typeof s.getSnapshotBeforeUpdate) || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== h || d !== l) && ya(e, s, i, l), sa = !1, d = e.memoizedState, s.state = d, da(e, i, s, r);
                    var f = e.memoizedState;
                    o !== h || d !== f || pr.current || sa ? ("function" == typeof p && (ma(e, n, p, i), f = e.memoizedState), (c = sa || Aa(e, n, c, i, d, f, l)) ? (u || "function" != typeof s.UNSAFE_componentWillUpdate && "function" != typeof s.componentWillUpdate || ("function" == typeof s.componentWillUpdate && s.componentWillUpdate(i, f, l), "function" == typeof s.UNSAFE_componentWillUpdate && s.UNSAFE_componentWillUpdate(i, f, l)), "function" == typeof s.componentDidUpdate && (e.flags |= 4), "function" == typeof s.getSnapshotBeforeUpdate && (e.flags |= 256)) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), e.memoizedProps = i, e.memoizedState = f), s.props = i, s.state = f, s.context = l, i = c) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), i = !1);
                }
                return Qs(t1, e, n, i, a, r);
            }
            function Qs(t1, e, n, i, r, a) {
                Fs(t1, e);
                var s = !!(64 & e.flags);
                if (!i && !s) return r && br(e, n, !1), no(t1, e, a);
                i = e.stateNode, Rs.current = e;
                var o = s && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return e.flags |= 1, null !== t1 && s ? (e.child = Ea(e, t1.child, null, a), e.child = Ea(e, null, o, a)) : zs(t1, e, o, a), e.memoizedState = i.state, r && br(e, n, !0), e.child;
            }
            function Gs(t1) {
                var e = t1.stateNode;
                e.pendingContext ? vr(0, e.pendingContext, e.pendingContext !== e.context) : e.context && vr(0, e.context, !1), La(t1, e.containerInfo);
            }
            var Ws, Xs, Ys, Zs, qs = {
                dehydrated: null,
                retryLane: 0
            };
            function Js(t1, e, n) {
                var i, r = e.pendingProps, a = za.current, s = !1;
                return (i = !!(64 & e.flags)) || (i = (null === t1 || null !== t1.memoizedState) && !!(2 & a)), i ? (s = !0, e.flags &= -65) : null !== t1 && null === t1.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (a |= 1), ur(za, 1 & a), null === t1 ? (void 0 !== r.fallback && Va(e), t1 = r.children, a = r.fallback, s ? (t1 = Ks(e, t1, a, n), e.child.memoizedState = {
                    baseLanes: n
                }, e.memoizedState = qs, t1) : "number" == typeof r.unstable_expectedLoadTime ? (t1 = Ks(e, t1, a, n), e.child.memoizedState = {
                    baseLanes: n
                }, e.memoizedState = qs, e.lanes = 33554432, t1) : ((n = Xl({
                    mode: "visible",
                    children: t1
                }, e.mode, n, null)).return = e, e.child = n)) : (t1.memoizedState, s ? (r = function(t1, e, n, i, r) {
                    var a = e.mode, s = t1.child;
                    t1 = s.sibling;
                    var o = {
                        mode: "hidden",
                        children: n
                    };
                    return 2 & a || e.child === s ? n = Ql(s, o) : ((n = e.child).childLanes = 0, n.pendingProps = o, null !== (s = n.lastEffect) ? (e.firstEffect = n.firstEffect, e.lastEffect = s, s.nextEffect = null) : e.firstEffect = e.lastEffect = null), null !== t1 ? i = Ql(t1, i) : (i = Wl(i, a, r, null)).flags |= 2, i.return = e, n.return = e, n.sibling = i, e.child = n, i;
                }(t1, e, r.children, r.fallback, n), s = e.child, a = t1.child.memoizedState, s.memoizedState = null === a ? {
                    baseLanes: n
                } : {
                    baseLanes: a.baseLanes | n
                }, s.childLanes = t1.childLanes & ~n, e.memoizedState = qs, r) : (n = function(t1, e, n, i) {
                    var r = t1.child;
                    return t1 = r.sibling, n = Ql(r, {
                        mode: "visible",
                        children: n
                    }), !(2 & e.mode) && (n.lanes = i), n.return = e, n.sibling = null, null !== t1 && (t1.nextEffect = null, t1.flags = 8, e.firstEffect = e.lastEffect = t1), e.child = n;
                }(t1, e, r.children, n), e.memoizedState = null, n));
            }
            function Ks(t1, e, n, i) {
                var r = t1.mode, a = t1.child;
                return e = {
                    mode: "hidden",
                    children: e
                }, 2 & r || null === a ? a = Xl(e, r, 0, null) : (a.childLanes = 0, a.pendingProps = e), n = Wl(n, r, i, null), a.return = t1, n.return = t1, a.sibling = n, t1.child = a, n;
            }
            function $s(t1, e) {
                t1.lanes |= e;
                var n = t1.alternate;
                null !== n && (n.lanes |= e), ia(t1.return, e);
            }
            function to(t1, e, n, i, r, a) {
                var s = t1.memoizedState;
                null === s ? t1.memoizedState = {
                    isBackwards: e,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailMode: r,
                    lastEffect: a
                } : (s.isBackwards = e, s.rendering = null, s.renderingStartTime = 0, s.last = i, s.tail = n, s.tailMode = r, s.lastEffect = a);
            }
            function eo(t1, e, n) {
                var i = e.pendingProps, r = i.revealOrder, a = i.tail;
                if (zs(t1, e, i.children, n), 2 & (i = za.current)) i = 1 & i | 2, e.flags |= 64;
                else {
                    if (null !== t1 && 64 & t1.flags) t: for(t1 = e.child; null !== t1;){
                        if (13 === t1.tag) null !== t1.memoizedState && $s(t1, n);
                        else if (19 === t1.tag) $s(t1, n);
                        else if (null !== t1.child) {
                            t1.child.return = t1, t1 = t1.child;
                            continue;
                        }
                        if (t1 === e) break t;
                        for(; null === t1.sibling;){
                            if (null === t1.return || t1.return === e) break t;
                            t1 = t1.return;
                        }
                        t1.sibling.return = t1.return, t1 = t1.sibling;
                    }
                    i &= 1;
                }
                if (ur(za, i), 2 & e.mode) switch(r){
                    case "forwards":
                        for(n = e.child, r = null; null !== n;)null !== (t1 = n.alternate) && null === Ua(t1) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = e.child, e.child = null) : (r = n.sibling, n.sibling = null), to(e, !1, r, n, a, e.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = e.child, e.child = null; null !== r;){
                            if (null !== (t1 = r.alternate) && null === Ua(t1)) {
                                e.child = r;
                                break;
                            }
                            t1 = r.sibling, r.sibling = n, n = r, r = t1;
                        }
                        to(e, !0, n, null, a, e.lastEffect);
                        break;
                    case "together":
                        to(e, !1, null, null, void 0, e.lastEffect);
                        break;
                    default:
                        e.memoizedState = null;
                }
                else e.memoizedState = null;
                return e.child;
            }
            function no(t1, e, n) {
                if (null !== t1 && (e.dependencies = t1.dependencies), Bo |= e.lanes, n & e.childLanes) {
                    if (null !== t1 && e.child !== t1.child) throw Error(s(153));
                    if (null !== e.child) {
                        for(n = Ql(t1 = e.child, t1.pendingProps), e.child = n, n.return = e; null !== t1.sibling;)t1 = t1.sibling, (n = n.sibling = Ql(t1, t1.pendingProps)).return = e;
                        n.sibling = null;
                    }
                    return e.child;
                }
                return null;
            }
            function io(t1, e) {
                if (!ja) switch(t1.tailMode){
                    case "hidden":
                        e = t1.tail;
                        for(var n = null; null !== e;)null !== e.alternate && (n = e), e = e.sibling;
                        null === n ? t1.tail = null : n.sibling = null;
                        break;
                    case "collapsed":
                        n = t1.tail;
                        for(var i = null; null !== n;)null !== n.alternate && (i = n), n = n.sibling;
                        null === i ? e || null === t1.tail ? t1.tail = null : t1.tail.sibling = null : i.sibling = null;
                }
            }
            function ro(t1, e, n) {
                var i = e.pendingProps;
                switch(e.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                    case 17:
                        return gr(e.type) && Ar(), null;
                    case 3:
                        return Oa(), cr(pr), cr(dr), Ya(), (i = e.stateNode).pendingContext && (i.context = i.pendingContext, i.pendingContext = null), null !== t1 && null !== t1.child || (Ga(e) ? e.flags |= 4 : i.hydrate || (e.flags |= 256)), Xs(e), null;
                    case 5:
                        Pa(e);
                        var a = Da(Na.current);
                        if (n = e.type, null !== t1 && null != e.stateNode) Ys(t1, e, n, i, a), t1.ref !== e.ref && (e.flags |= 128);
                        else {
                            if (!i) {
                                if (null === e.stateNode) throw Error(s(166));
                                return null;
                            }
                            if (t1 = Da(Ia.current), Ga(e)) {
                                i = e.stateNode, n = e.type;
                                var o = e.memoizedProps;
                                switch(i[Ji] = e, i[Ki] = o, n){
                                    case "dialog":
                                        Ci("cancel", i), Ci("close", i);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Ci("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(t1 = 0; t1 < Ei.length; t1++)Ci(Ei[t1], i);
                                        break;
                                    case "source":
                                        Ci("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Ci("error", i), Ci("load", i);
                                        break;
                                    case "details":
                                        Ci("toggle", i);
                                        break;
                                    case "input":
                                        tt(i, o), Ci("invalid", i);
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Ci("invalid", i);
                                        break;
                                    case "textarea":
                                        lt(i, o), Ci("invalid", i);
                                }
                                for(var c in wt(n, o), t1 = null, o)o.hasOwnProperty(c) && (a = o[c], "children" === c ? "string" == typeof a ? i.textContent !== a && (t1 = [
                                    "children",
                                    a
                                ]) : "number" == typeof a && i.textContent !== "" + a && (t1 = [
                                    "children",
                                    "" + a
                                ]) : l.hasOwnProperty(c) && null != a && "onScroll" === c && Ci("scroll", i));
                                switch(n){
                                    case "input":
                                        q(i), it(i, o, !0);
                                        break;
                                    case "textarea":
                                        q(i), ut(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = Bi);
                                }
                                i = t1, e.updateQueue = i, null !== i && (e.flags |= 4);
                            } else {
                                switch(c = 9 === a.nodeType ? a : a.ownerDocument, t1 === ht.html && (t1 = dt(n)), t1 === ht.html ? "script" === n ? ((t1 = c.createElement("div")).innerHTML = "<script></script>", t1 = t1.removeChild(t1.firstChild)) : "string" == typeof i.is ? t1 = c.createElement(n, {
                                    is: i.is
                                }) : (t1 = c.createElement(n), "select" === n && (c = t1, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : t1 = c.createElementNS(t1, n), t1[Ji] = e, t1[Ki] = i, Ws(t1, e, !1, !1), e.stateNode = t1, c = _t(n, i), n){
                                    case "dialog":
                                        Ci("cancel", t1), Ci("close", t1), a = i;
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Ci("load", t1), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ei.length; a++)Ci(Ei[a], t1);
                                        a = i;
                                        break;
                                    case "source":
                                        Ci("error", t1), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Ci("error", t1), Ci("load", t1), a = i;
                                        break;
                                    case "details":
                                        Ci("toggle", t1), a = i;
                                        break;
                                    case "input":
                                        tt(t1, i), a = $(t1, i), Ci("invalid", t1);
                                        break;
                                    case "option":
                                        a = at(t1, i);
                                        break;
                                    case "select":
                                        t1._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Ci("invalid", t1);
                                        break;
                                    case "textarea":
                                        lt(t1, i), a = ot(t1, i), Ci("invalid", t1);
                                        break;
                                    default:
                                        a = i;
                                }
                                wt(n, a);
                                var u = a;
                                for(o in u)if (u.hasOwnProperty(o)) {
                                    var h = u[o];
                                    "style" === o ? bt(t1, h) : "dangerouslySetInnerHTML" === o ? null != (h = h ? h.__html : void 0) && gt(t1, h) : "children" === o ? "string" == typeof h ? ("textarea" !== n || "" !== h) && At(t1, h) : "number" == typeof h && At(t1, "" + h) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (l.hasOwnProperty(o) ? null != h && "onScroll" === o && Ci("scroll", t1) : null != h && M(t1, o, h, c));
                                }
                                switch(n){
                                    case "input":
                                        q(t1), it(t1, i, !1);
                                        break;
                                    case "textarea":
                                        q(t1), ut(t1);
                                        break;
                                    case "option":
                                        null != i.value && t1.setAttribute("value", "" + Y(i.value));
                                        break;
                                    case "select":
                                        t1.multiple = !!i.multiple, null != (o = i.value) ? st(t1, !!i.multiple, o, !1) : null != i.defaultValue && st(t1, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (t1.onclick = Bi);
                                }
                                Hi(n, i) && (e.flags |= 4);
                            }
                            null !== e.ref && (e.flags |= 128);
                        }
                        return null;
                    case 6:
                        if (t1 && null != e.stateNode) Zs(t1, e, t1.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === e.stateNode) throw Error(s(166));
                            n = Da(Na.current), Da(Ia.current), Ga(e) ? (i = e.stateNode, n = e.memoizedProps, i[Ji] = e, i.nodeValue !== n && (e.flags |= 4)) : ((i = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ji] = e, e.stateNode = i);
                        }
                        return null;
                    case 13:
                        return cr(za), i = e.memoizedState, 64 & e.flags ? (e.lanes = n, e) : (i = null !== i, n = !1, null === t1 ? void 0 !== e.memoizedProps.fallback && Ga(e) : n = null !== t1.memoizedState, i && !n && 2 & e.mode && (null === t1 && !0 !== e.memoizedProps.unstable_avoidThisFallback || 1 & za.current ? 0 === zo && (zo = 3) : (0 !== zo && 3 !== zo || (zo = 4), null === Do || !(134217727 & Bo) && !(134217727 & jo) || gl(Do, Oo))), (i || n) && (e.flags |= 4), null);
                    case 4:
                        return Oa(), Xs(e), null === t1 && Di(e.stateNode.containerInfo), null;
                    case 10:
                        return na(e), null;
                    case 19:
                        if (cr(za), null === (i = e.memoizedState)) return null;
                        if (o = !!(64 & e.flags), null === (c = i.rendering)) {
                            if (o) io(i, !1);
                            else {
                                if (0 !== zo || null !== t1 && 64 & t1.flags) for(t1 = e.child; null !== t1;){
                                    if (null !== (c = Ua(t1))) {
                                        for(e.flags |= 64, io(i, !1), null !== (o = c.updateQueue) && (e.updateQueue = o, e.flags |= 4), null === i.lastEffect && (e.firstEffect = null), e.lastEffect = i.lastEffect, i = n, n = e.child; null !== n;)t1 = i, (o = n).flags &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childLanes = 0, o.lanes = t1, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = c.childLanes, o.lanes = c.lanes, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, o.type = c.type, t1 = c.dependencies, o.dependencies = null === t1 ? null : {
                                            lanes: t1.lanes,
                                            firstContext: t1.firstContext
                                        }), n = n.sibling;
                                        return ur(za, 1 & za.current | 2), e.child;
                                    }
                                    t1 = t1.sibling;
                                }
                                null !== i.tail && Hr() > Qo && (e.flags |= 64, o = !0, io(i, !1), e.lanes = 33554432);
                            }
                        } else {
                            if (!o) {
                                if (null !== (t1 = Ua(c))) {
                                    if (e.flags |= 64, o = !0, null !== (n = t1.updateQueue) && (e.updateQueue = n, e.flags |= 4), io(i, !0), null === i.tail && "hidden" === i.tailMode && !c.alternate && !ja) return null !== (e = e.lastEffect = i.lastEffect) && (e.nextEffect = null), null;
                                } else 2 * Hr() - i.renderingStartTime > Qo && 1073741824 !== n && (e.flags |= 64, o = !0, io(i, !1), e.lanes = 33554432);
                            }
                            i.isBackwards ? (c.sibling = e.child, e.child = c) : (null !== (n = i.last) ? n.sibling = c : e.child = c, i.last = c);
                        }
                        return null !== i.tail ? (n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = e.lastEffect, i.renderingStartTime = Hr(), n.sibling = null, e = za.current, ur(za, o ? 1 & e | 2 : 1 & e), n) : null;
                    case 23:
                    case 24:
                        return bl(), null !== t1 && null !== t1.memoizedState != (null !== e.memoizedState) && "unstable-defer-without-hiding" !== i.mode && (e.flags |= 4), null;
                }
                throw Error(s(156, e.tag));
            }
            function ao(t1) {
                switch(t1.tag){
                    case 1:
                        gr(t1.type) && Ar();
                        var e = t1.flags;
                        return 4096 & e ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 3:
                        if (Oa(), cr(pr), cr(dr), Ya(), 64 & (e = t1.flags)) throw Error(s(285));
                        return t1.flags = -4097 & e | 64, t1;
                    case 5:
                        return Pa(t1), null;
                    case 13:
                        return cr(za), 4096 & (e = t1.flags) ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 19:
                        return cr(za), null;
                    case 4:
                        return Oa(), null;
                    case 10:
                        return na(t1), null;
                    case 23:
                    case 24:
                        return bl(), null;
                    default:
                        return null;
                }
            }
            function so(t1, e) {
                try {
                    var n = "", i = e;
                    do n += W(i), i = i.return;
                    while (i);
                    var r = n;
                } catch (t1) {
                    r = "\nError generating stack: " + t1.message + "\n" + t1.stack;
                }
                return {
                    value: t1,
                    source: e,
                    stack: r
                };
            }
            function oo(t1, e) {
                try {
                    console.error(e.value);
                } catch (t1) {
                    setTimeout(function() {
                        throw t1;
                    });
                }
            }
            Ws = function(t1, e) {
                for(var n = e.child; null !== n;){
                    if (5 === n.tag || 6 === n.tag) t1.appendChild(n.stateNode);
                    else if (4 !== n.tag && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === e) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === e) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }, Xs = function() {}, Ys = function(t1, e, n, i) {
                var a = t1.memoizedProps;
                if (a !== i) {
                    t1 = e.stateNode, Da(Ia.current);
                    var s, o = null;
                    switch(n){
                        case "input":
                            a = $(t1, a), i = $(t1, i), o = [];
                            break;
                        case "option":
                            a = at(t1, a), i = at(t1, i), o = [];
                            break;
                        case "select":
                            a = r({}, a, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), o = [];
                            break;
                        case "textarea":
                            a = ot(t1, a), i = ot(t1, i), o = [];
                            break;
                        default:
                            "function" != typeof a.onClick && "function" == typeof i.onClick && (t1.onclick = Bi);
                    }
                    for(h in wt(n, i), n = null, a)if (!i.hasOwnProperty(h) && a.hasOwnProperty(h) && null != a[h]) {
                        if ("style" === h) {
                            var c = a[h];
                            for(s in c)c.hasOwnProperty(s) && (n || (n = {}), n[s] = "");
                        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (l.hasOwnProperty(h) ? o || (o = []) : (o = o || []).push(h, null));
                    }
                    for(h in i){
                        var u = i[h];
                        if (c = null != a ? a[h] : void 0, i.hasOwnProperty(h) && u !== c && (null != u || null != c)) {
                            if ("style" === h) {
                                if (c) {
                                    for(s in c)!c.hasOwnProperty(s) || u && u.hasOwnProperty(s) || (n || (n = {}), n[s] = "");
                                    for(s in u)u.hasOwnProperty(s) && c[s] !== u[s] && (n || (n = {}), n[s] = u[s]);
                                } else n || (o || (o = []), o.push(h, n)), n = u;
                            } else "dangerouslySetInnerHTML" === h ? (u = u ? u.__html : void 0, c = c ? c.__html : void 0, null != u && c !== u && (o = o || []).push(h, u)) : "children" === h ? "string" != typeof u && "number" != typeof u || (o = o || []).push(h, "" + u) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (l.hasOwnProperty(h) ? (null != u && "onScroll" === h && Ci("scroll", t1), o || c === u || (o = [])) : "object" == typeof u && null !== u && u.$$typeof === P ? u.toString() : (o = o || []).push(h, u));
                        }
                    }
                    n && (o = o || []).push("style", n);
                    var h = o;
                    (e.updateQueue = h) && (e.flags |= 4);
                }
            }, Zs = function(t1, e, n, i) {
                n !== i && (e.flags |= 4);
            };
            var lo = "function" == typeof WeakMap ? WeakMap : Map;
            function co(t1, e, n) {
                (n = ca(-1, n)).tag = 3, n.payload = {
                    element: null
                };
                var i = e.value;
                return n.callback = function() {
                    Yo || (Yo = !0, Zo = i), oo(0, e);
                }, n;
            }
            function uo(t1, e, n) {
                (n = ca(-1, n)).tag = 3;
                var i = t1.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = e.value;
                    n.payload = function() {
                        return oo(0, e), i(r);
                    };
                }
                var a = t1.stateNode;
                return null !== a && "function" == typeof a.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === qo ? qo = new Set([
                        this
                    ]) : qo.add(this), oo(0, e));
                    var t1 = e.stack;
                    this.componentDidCatch(e.value, {
                        componentStack: null !== t1 ? t1 : ""
                    });
                }), n;
            }
            var ho = "function" == typeof WeakSet ? WeakSet : Set;
            function po(t1) {
                var e = t1.ref;
                if (null !== e) {
                    if ("function" == typeof e) try {
                        e(null);
                    } catch (e) {
                        kl(t1, e);
                    }
                    else e.current = null;
                }
            }
            function fo(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                    case 1:
                        if (256 & e.flags && null !== t1) {
                            var n = t1.memoizedProps, i = t1.memoizedState;
                            e = (t1 = e.stateNode).getSnapshotBeforeUpdate(e.elementType === e.type ? n : qr(e.type, n), i), t1.__reactInternalSnapshotBeforeUpdate = e;
                        }
                        return;
                    case 3:
                        return void (256 & e.flags && Wi(e.stateNode.containerInfo));
                }
                throw Error(s(163));
            }
            function mo(t1, e, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        if (null !== (e = null !== (e = n.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                if (!(3 & ~t1.tag)) {
                                    var i = t1.create;
                                    t1.destroy = i();
                                }
                                t1 = t1.next;
                            }while (t1 !== e);
                        }
                        if (null !== (e = null !== (e = n.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                var r = t1;
                                i = r.next, 4 & (r = r.tag) && 1 & r && (Pl(n, t1), Rl(n, t1)), t1 = i;
                            }while (t1 !== e);
                        }
                        return;
                    case 1:
                        return t1 = n.stateNode, 4 & n.flags && (null === e ? t1.componentDidMount() : (i = n.elementType === n.type ? e.memoizedProps : qr(n.type, e.memoizedProps), t1.componentDidUpdate(i, e.memoizedState, t1.__reactInternalSnapshotBeforeUpdate))), void (null !== (e = n.updateQueue) && pa(n, e, t1));
                    case 3:
                        if (null !== (e = n.updateQueue)) {
                            if (t1 = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                case 1:
                                    t1 = n.child.stateNode;
                            }
                            pa(n, e, t1);
                        }
                        return;
                    case 5:
                        return t1 = n.stateNode, void (null === e && 4 & n.flags && Hi(n.type, n.memoizedProps) && t1.focus());
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                    case 23:
                    case 24:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && be(n)))));
                }
                throw Error(s(163));
            }
            function go(t1, e) {
                for(var n = t1;;){
                    if (5 === n.tag) {
                        var i = n.stateNode;
                        if (e) "function" == typeof (i = i.style).setProperty ? i.setProperty("display", "none", "important") : i.display = "none";
                        else {
                            i = n.stateNode;
                            var r = n.memoizedProps.style;
                            r = null != r && r.hasOwnProperty("display") ? r.display : null, i.style.display = Mt("display", r);
                        }
                    } else if (6 === n.tag) n.stateNode.nodeValue = e ? "" : n.memoizedProps;
                    else if ((23 !== n.tag && 24 !== n.tag || null === n.memoizedState || n === t1) && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === t1) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === t1) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }
            function Ao(t1, e) {
                if (wr && "function" == typeof wr.onCommitFiberUnmount) try {
                    wr.onCommitFiberUnmount(xr, e);
                } catch (t1) {}
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (t1 = e.updateQueue) && null !== (t1 = t1.lastEffect)) {
                            var n = t1 = t1.next;
                            do {
                                var i = n, r = i.destroy;
                                if (i = i.tag, void 0 !== r) {
                                    if (4 & i) Pl(e, n);
                                    else {
                                        i = e;
                                        try {
                                            r();
                                        } catch (t1) {
                                            kl(i, t1);
                                        }
                                    }
                                }
                                n = n.next;
                            }while (n !== t1);
                        }
                        break;
                    case 1:
                        if (po(e), "function" == typeof (t1 = e.stateNode).componentWillUnmount) try {
                            t1.props = e.memoizedProps, t1.state = e.memoizedState, t1.componentWillUnmount();
                        } catch (t1) {
                            kl(e, t1);
                        }
                        break;
                    case 5:
                        po(e);
                        break;
                    case 4:
                        wo(t1, e);
                }
            }
            function vo(t1) {
                t1.alternate = null, t1.child = null, t1.dependencies = null, t1.firstEffect = null, t1.lastEffect = null, t1.memoizedProps = null, t1.memoizedState = null, t1.pendingProps = null, t1.return = null, t1.updateQueue = null;
            }
            function yo(t1) {
                return 5 === t1.tag || 3 === t1.tag || 4 === t1.tag;
            }
            function Mo(t1) {
                t: {
                    for(var e = t1.return; null !== e;){
                        if (yo(e)) break t;
                        e = e.return;
                    }
                    throw Error(s(160));
                }
                var n = e;
                switch(e = n.stateNode, n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        e = e.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(s(161));
                }
                16 & n.flags && (At(e, ""), n.flags &= -17);
                t: e: for(n = t1;;){
                    for(; null === n.sibling;){
                        if (null === n.return || yo(n.return)) {
                            n = null;
                            break t;
                        }
                        n = n.return;
                    }
                    for(n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;){
                        if (2 & n.flags) continue e;
                        if (null === n.child || 4 === n.tag) continue e;
                        n.child.return = n, n = n.child;
                    }
                    if (!(2 & n.flags)) {
                        n = n.stateNode;
                        break t;
                    }
                }
                i ? bo(t1, n, e) : xo(t1, n, e);
            }
            function bo(t1, e, n) {
                var i = t1.tag, r = 5 === i || 6 === i;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? 8 === n.nodeType ? n.parentNode.insertBefore(t1, e) : n.insertBefore(t1, e) : (8 === n.nodeType ? (e = n.parentNode).insertBefore(t1, n) : (e = n).appendChild(t1), null != (n = n._reactRootContainer) || null !== e.onclick || (e.onclick = Bi));
                else if (4 !== i && null !== (t1 = t1.child)) for(bo(t1, e, n), t1 = t1.sibling; null !== t1;)bo(t1, e, n), t1 = t1.sibling;
            }
            function xo(t1, e, n) {
                var i = t1.tag, r = 5 === i || 6 === i;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? n.insertBefore(t1, e) : n.appendChild(t1);
                else if (4 !== i && null !== (t1 = t1.child)) for(xo(t1, e, n), t1 = t1.sibling; null !== t1;)xo(t1, e, n), t1 = t1.sibling;
            }
            function wo(t1, e) {
                for(var n, i, r = e, a = !1;;){
                    if (!a) {
                        a = r.return;
                        t: for(;;){
                            if (null === a) throw Error(s(160));
                            switch(n = a.stateNode, a.tag){
                                case 5:
                                    i = !1;
                                    break t;
                                case 3:
                                case 4:
                                    n = n.containerInfo, i = !0;
                                    break t;
                            }
                            a = a.return;
                        }
                        a = !0;
                    }
                    if (5 === r.tag || 6 === r.tag) {
                        t: for(var o = t1, l = r, c = l;;)if (Ao(o, c), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
                        else {
                            if (c === l) break t;
                            for(; null === c.sibling;){
                                if (null === c.return || c.return === l) break t;
                                c = c.return;
                            }
                            c.sibling.return = c.return, c = c.sibling;
                        }
                        i ? (o = n, l = r.stateNode, 8 === o.nodeType ? o.parentNode.removeChild(l) : o.removeChild(l)) : n.removeChild(r.stateNode);
                    } else if (4 === r.tag) {
                        if (null !== r.child) {
                            n = r.stateNode.containerInfo, i = !0, r.child.return = r, r = r.child;
                            continue;
                        }
                    } else if (Ao(t1, r), null !== r.child) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === e) break;
                    for(; null === r.sibling;){
                        if (null === r.return || r.return === e) return;
                        4 === (r = r.return).tag && (a = !1);
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
            }
            function _o(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        var n = e.updateQueue;
                        if (null !== (n = null !== n ? n.lastEffect : null)) {
                            var i = n = n.next;
                            do !(3 & ~i.tag) && (t1 = i.destroy, i.destroy = void 0, void 0 !== t1 && t1()), i = i.next;
                            while (i !== n);
                        }
                        return;
                    case 1:
                    case 12:
                    case 17:
                        return;
                    case 5:
                        if (null != (n = e.stateNode)) {
                            i = e.memoizedProps;
                            var r = null !== t1 ? t1.memoizedProps : i;
                            t1 = e.type;
                            var a = e.updateQueue;
                            if (e.updateQueue = null, null !== a) {
                                for(n[Ki] = i, "input" === t1 && "radio" === i.type && null != i.name && et(n, i), _t(t1, r), e = _t(t1, i), r = 0; r < a.length; r += 2){
                                    var o = a[r], l = a[r + 1];
                                    "style" === o ? bt(n, l) : "dangerouslySetInnerHTML" === o ? gt(n, l) : "children" === o ? At(n, l) : M(n, o, l, e);
                                }
                                switch(t1){
                                    case "input":
                                        nt(n, i);
                                        break;
                                    case "textarea":
                                        ct(n, i);
                                        break;
                                    case "select":
                                        t1 = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (a = i.value) ? st(n, !!i.multiple, a, !1) : t1 !== !!i.multiple && (null != i.defaultValue ? st(n, !!i.multiple, i.defaultValue, !0) : st(n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === e.stateNode) throw Error(s(162));
                        return void (e.stateNode.nodeValue = e.memoizedProps);
                    case 3:
                        return void ((n = e.stateNode).hydrate && (n.hydrate = !1, be(n.containerInfo)));
                    case 13:
                        return null !== e.memoizedState && (Vo = Hr(), go(e.child, !0)), void Eo(e);
                    case 19:
                        return void Eo(e);
                    case 23:
                    case 24:
                        return void go(e, null !== e.memoizedState);
                }
                throw Error(s(163));
            }
            function Eo(t1) {
                var e = t1.updateQueue;
                if (null !== e) {
                    t1.updateQueue = null;
                    var n = t1.stateNode;
                    null === n && (n = t1.stateNode = new ho), e.forEach(function(e) {
                        var i = jl.bind(null, t1, e);
                        n.has(e) || (n.add(e), e.then(i, i));
                    });
                }
            }
            function So(t1, e) {
                return null !== t1 && (null === (t1 = t1.memoizedState) || null !== t1.dehydrated) && null !== (e = e.memoizedState) && null === e.dehydrated;
            }
            var To = Math.ceil, Io = b.ReactCurrentDispatcher, Co = b.ReactCurrentOwner, No = 0, Do = null, Lo = null, Oo = 0, Ro = 0, Po = lr(0), zo = 0, Uo = null, ko = 0, Bo = 0, jo = 0, Fo = 0, Ho = null, Vo = 0, Qo = 1 / 0;
            function Go() {
                Qo = Hr() + 500;
            }
            var Wo, Xo = null, Yo = !1, Zo = null, qo = null, Jo = !1, Ko = null, $o = 90, tl = [], el = [], nl = null, il = 0, rl = null, al = -1, sl = 0, ol = 0, ll = null, cl = !1;
            function ul() {
                return 48 & No ? Hr() : -1 !== al ? al : al = Hr();
            }
            function hl(t1) {
                if (!(2 & (t1 = t1.mode))) return 1;
                if (!(4 & t1)) return 99 === Vr() ? 1 : 2;
                if (0 === sl && (sl = ko), 0 !== Zr.transition) {
                    0 !== ol && (ol = null !== Ho ? Ho.pendingLanes : 0), t1 = sl;
                    var e = 4186112 & ~ol;
                    return 0 == (e &= -e) && 0 == (e = (t1 = 4186112 & ~t1) & -t1) && (e = 8192), e;
                }
                return t1 = Vr(), t1 = Be(4 & No && 98 === t1 ? 12 : t1 = function(t1) {
                    switch(t1){
                        case 99:
                            return 15;
                        case 98:
                            return 10;
                        case 97:
                        case 96:
                            return 8;
                        case 95:
                            return 2;
                        default:
                            return 0;
                    }
                }(t1), sl);
            }
            function dl(t1, e, n) {
                if (50 < il) throw il = 0, rl = null, Error(s(185));
                if (null === (t1 = pl(t1, e))) return null;
                He(t1, e, n), t1 === Do && (jo |= e, 4 === zo && gl(t1, Oo));
                var i = Vr();
                1 === e ? 8 & No && !(48 & No) ? Al(t1) : (fl(t1, n), 0 === No && (Go(), Xr())) : (!(4 & No) || 98 !== i && 99 !== i || (null === nl ? nl = new Set([
                    t1
                ]) : nl.add(t1)), fl(t1, n)), Ho = t1;
            }
            function pl(t1, e) {
                t1.lanes |= e;
                var n = t1.alternate;
                for(null !== n && (n.lanes |= e), n = t1, t1 = t1.return; null !== t1;)t1.childLanes |= e, null !== (n = t1.alternate) && (n.childLanes |= e), n = t1, t1 = t1.return;
                return 3 === n.tag ? n.stateNode : null;
            }
            function fl(t1, e) {
                for(var n = t1.callbackNode, i = t1.suspendedLanes, r = t1.pingedLanes, a = t1.expirationTimes, o = t1.pendingLanes; 0 < o;){
                    var l = 31 - Ve(o), c = 1 << l, u = a[l];
                    if (-1 === u) {
                        if (!(c & i) || c & r) {
                            u = e, ze(c);
                            var h = Pe;
                            a[l] = 10 <= h ? u + 250 : 6 <= h ? u + 5e3 : -1;
                        }
                    } else u <= e && (t1.expiredLanes |= c);
                    o &= ~c;
                }
                if (i = Ue(t1, t1 === Do ? Oo : 0), e = Pe, 0 === i) null !== n && (n !== zr && Sr(n), t1.callbackNode = null, t1.callbackPriority = 0);
                else {
                    if (null !== n) {
                        if (t1.callbackPriority === e) return;
                        n !== zr && Sr(n);
                    }
                    15 === e ? (n = Al.bind(null, t1), null === kr ? (kr = [
                        n
                    ], Br = Er(Dr, Yr)) : kr.push(n), n = zr) : 14 === e ? n = Wr(99, Al.bind(null, t1)) : (n = function(t1) {
                        switch(t1){
                            case 15:
                            case 14:
                                return 99;
                            case 13:
                            case 12:
                            case 11:
                            case 10:
                                return 98;
                            case 9:
                            case 8:
                            case 7:
                            case 6:
                            case 4:
                            case 5:
                                return 97;
                            case 3:
                            case 2:
                            case 1:
                                return 95;
                            case 0:
                                return 90;
                            default:
                                throw Error(s(358, t1));
                        }
                    }(e), n = Wr(n, ml.bind(null, t1))), t1.callbackPriority = e, t1.callbackNode = n;
                }
            }
            function ml(t1) {
                if (al = -1, ol = sl = 0, 48 & No) throw Error(s(327));
                var e = t1.callbackNode;
                if (Ol() && t1.callbackNode !== e) return null;
                var n = Ue(t1, t1 === Do ? Oo : 0);
                if (0 === n) return null;
                var i = n, r = No;
                No |= 16;
                var a = _l();
                for(Do === t1 && Oo === i || (Go(), xl(t1, i));;)try {
                    Tl();
                    break;
                } catch (e) {
                    wl(t1, e);
                }
                if (ea(), Io.current = a, No = r, null !== Lo ? i = 0 : (Do = null, Oo = 0, i = zo), ko & jo) xl(t1, 0);
                else if (0 !== i) {
                    if (2 === i && (No |= 64, t1.hydrate && (t1.hydrate = !1, Wi(t1.containerInfo)), 0 !== (n = ke(t1)) && (i = El(t1, n))), 1 === i) throw e = Uo, xl(t1, 0), gl(t1, n), fl(t1, Hr()), e;
                    switch(t1.finishedWork = t1.current.alternate, t1.finishedLanes = n, i){
                        case 0:
                        case 1:
                            throw Error(s(345));
                        case 2:
                        case 5:
                            Nl(t1);
                            break;
                        case 3:
                            if (gl(t1, n), (62914560 & n) === n && 10 < (i = Vo + 500 - Hr())) {
                                if (0 !== Ue(t1, 0)) break;
                                if (((r = t1.suspendedLanes) & n) !== n) {
                                    ul(), t1.pingedLanes |= t1.suspendedLanes & r;
                                    break;
                                }
                                t1.timeoutHandle = Qi(Nl.bind(null, t1), i);
                                break;
                            }
                            Nl(t1);
                            break;
                        case 4:
                            if (gl(t1, n), (4186112 & n) === n) break;
                            for(i = t1.eventTimes, r = -1; 0 < n;){
                                var o = 31 - Ve(n);
                                a = 1 << o, (o = i[o]) > r && (r = o), n &= ~a;
                            }
                            if (n = r, 10 < (n = (120 > (n = Hr() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * To(n / 1960)) - n)) {
                                t1.timeoutHandle = Qi(Nl.bind(null, t1), n);
                                break;
                            }
                            Nl(t1);
                            break;
                        default:
                            throw Error(s(329));
                    }
                }
                return fl(t1, Hr()), t1.callbackNode === e ? ml.bind(null, t1) : null;
            }
            function gl(t1, e) {
                for(e &= ~Fo, e &= ~jo, t1.suspendedLanes |= e, t1.pingedLanes &= ~e, t1 = t1.expirationTimes; 0 < e;){
                    var n = 31 - Ve(e), i = 1 << n;
                    t1[n] = -1, e &= ~i;
                }
            }
            function Al(t1) {
                if (48 & No) throw Error(s(327));
                if (Ol(), t1 === Do && t1.expiredLanes & Oo) {
                    var e = Oo, n = El(t1, e);
                    ko & jo && (n = El(t1, e = Ue(t1, e)));
                } else n = El(t1, e = Ue(t1, 0));
                if (0 !== t1.tag && 2 === n && (No |= 64, t1.hydrate && (t1.hydrate = !1, Wi(t1.containerInfo)), 0 !== (e = ke(t1)) && (n = El(t1, e))), 1 === n) throw n = Uo, xl(t1, 0), gl(t1, e), fl(t1, Hr()), n;
                return t1.finishedWork = t1.current.alternate, t1.finishedLanes = e, Nl(t1), fl(t1, Hr()), null;
            }
            function vl(t1, e) {
                var n = No;
                No |= 1;
                try {
                    return t1(e);
                } finally{
                    0 === (No = n) && (Go(), Xr());
                }
            }
            function yl(t1, e) {
                var n = No;
                No &= -2, No |= 8;
                try {
                    return t1(e);
                } finally{
                    0 === (No = n) && (Go(), Xr());
                }
            }
            function Ml(t1, e) {
                ur(Po, Ro), Ro |= e, ko |= e;
            }
            function bl() {
                Ro = Po.current, cr(Po);
            }
            function xl(t1, e) {
                t1.finishedWork = null, t1.finishedLanes = 0;
                var n = t1.timeoutHandle;
                if (-1 !== n && (t1.timeoutHandle = -1, Gi(n)), null !== Lo) for(n = Lo.return; null !== n;){
                    var i = n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            Oa(), cr(pr), cr(dr), Ya();
                            break;
                        case 5:
                            Pa(i);
                            break;
                        case 4:
                            Oa();
                            break;
                        case 13:
                        case 19:
                            cr(za);
                            break;
                        case 10:
                            na(i);
                            break;
                        case 23:
                        case 24:
                            bl();
                    }
                    n = n.return;
                }
                Do = t1, Lo = Ql(t1.current, null), Oo = Ro = ko = e, zo = 0, Uo = null, Fo = jo = Bo = 0;
            }
            function wl(t1, e) {
                for(;;){
                    var n = Lo;
                    try {
                        if (ea(), Za.current = Ns, es) {
                            for(var i = Ka.memoizedState; null !== i;){
                                var r = i.queue;
                                null !== r && (r.pending = null), i = i.next;
                            }
                            es = !1;
                        }
                        if (Ja = 0, ts = $a = Ka = null, ns = !1, Co.current = null, null === n || null === n.return) {
                            zo = 1, Uo = e, Lo = null;
                            break;
                        }
                        t: {
                            var a = t1, s = n.return, o = n, l = e;
                            if (e = Oo, o.flags |= 2048, o.firstEffect = o.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                                var c = l;
                                if (!(2 & o.mode)) {
                                    var u = o.alternate;
                                    u ? (o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.lanes = u.lanes) : (o.updateQueue = null, o.memoizedState = null);
                                }
                                var h = !!(1 & za.current), d = s;
                                do {
                                    var p;
                                    if (p = 13 === d.tag) {
                                        var f = d.memoizedState;
                                        if (null !== f) p = null !== f.dehydrated;
                                        else {
                                            var m = d.memoizedProps;
                                            p = void 0 !== m.fallback && (!0 !== m.unstable_avoidThisFallback || !h);
                                        }
                                    }
                                    if (p) {
                                        var g = d.updateQueue;
                                        if (null === g) {
                                            var A = new Set;
                                            A.add(c), d.updateQueue = A;
                                        } else g.add(c);
                                        if (!(2 & d.mode)) {
                                            if (d.flags |= 64, o.flags |= 16384, o.flags &= -2981, 1 === o.tag) {
                                                if (null === o.alternate) o.tag = 17;
                                                else {
                                                    var v = ca(-1, 1);
                                                    v.tag = 2, ua(o, v);
                                                }
                                            }
                                            o.lanes |= 1;
                                            break t;
                                        }
                                        l = void 0, o = e;
                                        var y = a.pingCache;
                                        if (null === y ? (y = a.pingCache = new lo, l = new Set, y.set(c, l)) : void 0 === (l = y.get(c)) && (l = new Set, y.set(c, l)), !l.has(o)) {
                                            l.add(o);
                                            var M = Bl.bind(null, a, c, o);
                                            c.then(M, M);
                                        }
                                        d.flags |= 4096, d.lanes = e;
                                        break t;
                                    }
                                    d = d.return;
                                }while (null !== d);
                                l = Error((X(o.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                            }
                            5 !== zo && (zo = 2), l = so(l, o), d = s;
                            do {
                                switch(d.tag){
                                    case 3:
                                        a = l, d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, co(0, a, e));
                                        break t;
                                    case 1:
                                        a = l;
                                        var b = d.type, x = d.stateNode;
                                        if (!(64 & d.flags || "function" != typeof b.getDerivedStateFromError && (null === x || "function" != typeof x.componentDidCatch || null !== qo && qo.has(x)))) {
                                            d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, uo(d, a, e));
                                            break t;
                                        }
                                }
                                d = d.return;
                            }while (null !== d);
                        }
                        Cl(n);
                    } catch (t1) {
                        e = t1, Lo === n && null !== n && (Lo = n = n.return);
                        continue;
                    }
                    break;
                }
            }
            function _l() {
                var t1 = Io.current;
                return Io.current = Ns, null === t1 ? Ns : t1;
            }
            function El(t1, e) {
                var n = No;
                No |= 16;
                var i = _l();
                for(Do === t1 && Oo === e || xl(t1, e);;)try {
                    Sl();
                    break;
                } catch (e) {
                    wl(t1, e);
                }
                if (ea(), No = n, Io.current = i, null !== Lo) throw Error(s(261));
                return Do = null, Oo = 0, zo;
            }
            function Sl() {
                for(; null !== Lo;)Il(Lo);
            }
            function Tl() {
                for(; null !== Lo && !Tr();)Il(Lo);
            }
            function Il(t1) {
                var e = Wo(t1.alternate, t1, Ro);
                t1.memoizedProps = t1.pendingProps, null === e ? Cl(t1) : Lo = e, Co.current = null;
            }
            function Cl(t1) {
                var e = t1;
                do {
                    var n = e.alternate;
                    if (t1 = e.return, 2048 & e.flags) {
                        if (null !== (n = ao(e))) return n.flags &= 2047, void (Lo = n);
                        null !== t1 && (t1.firstEffect = t1.lastEffect = null, t1.flags |= 2048);
                    } else {
                        if (null !== (n = ro(n, e, Ro))) return void (Lo = n);
                        if (24 !== (n = e).tag && 23 !== n.tag || null === n.memoizedState || 1073741824 & Ro || !(4 & n.mode)) {
                            for(var i = 0, r = n.child; null !== r;)i |= r.lanes | r.childLanes, r = r.sibling;
                            n.childLanes = i;
                        }
                        null !== t1 && !(2048 & t1.flags) && (null === t1.firstEffect && (t1.firstEffect = e.firstEffect), null !== e.lastEffect && (null !== t1.lastEffect && (t1.lastEffect.nextEffect = e.firstEffect), t1.lastEffect = e.lastEffect), 1 < e.flags && (null !== t1.lastEffect ? t1.lastEffect.nextEffect = e : t1.firstEffect = e, t1.lastEffect = e));
                    }
                    if (null !== (e = e.sibling)) return void (Lo = e);
                    Lo = e = t1;
                }while (null !== e);
                0 === zo && (zo = 5);
            }
            function Nl(t1) {
                var e = Vr();
                return Gr(99, Dl.bind(null, t1, e)), null;
            }
            function Dl(t1, e) {
                do Ol();
                while (null !== Ko);
                if (48 & No) throw Error(s(327));
                var n = t1.finishedWork;
                if (null === n) return null;
                if (t1.finishedWork = null, t1.finishedLanes = 0, n === t1.current) throw Error(s(177));
                t1.callbackNode = null;
                var i = n.lanes | n.childLanes, r = i, a = t1.pendingLanes & ~r;
                t1.pendingLanes = r, t1.suspendedLanes = 0, t1.pingedLanes = 0, t1.expiredLanes &= r, t1.mutableReadLanes &= r, t1.entangledLanes &= r, r = t1.entanglements;
                for(var o = t1.eventTimes, l = t1.expirationTimes; 0 < a;){
                    var c = 31 - Ve(a), u = 1 << c;
                    r[c] = 0, o[c] = -1, l[c] = -1, a &= ~u;
                }
                if (null !== nl && !(24 & i) && nl.has(t1) && nl.delete(t1), t1 === Do && (Lo = Do = null, Oo = 0), 1 < n.flags ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
                    if (r = No, No |= 32, Co.current = null, ji = Ye, gi(o = mi())) {
                        if ("selectionStart" in o) l = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else t: if (l = (l = o.ownerDocument) && l.defaultView || window, (u = l.getSelection && l.getSelection()) && 0 !== u.rangeCount) {
                            l = u.anchorNode, a = u.anchorOffset, c = u.focusNode, u = u.focusOffset;
                            try {
                                l.nodeType, c.nodeType;
                            } catch (t1) {
                                l = null;
                                break t;
                            }
                            var h = 0, d = -1, p = -1, f = 0, m = 0, g = o, A = null;
                            e: for(;;){
                                for(var v; g !== l || 0 !== a && 3 !== g.nodeType || (d = h + a), g !== c || 0 !== u && 3 !== g.nodeType || (p = h + u), 3 === g.nodeType && (h += g.nodeValue.length), null !== (v = g.firstChild);)A = g, g = v;
                                for(;;){
                                    if (g === o) break e;
                                    if (A === l && ++f === a && (d = h), A === c && ++m === u && (p = h), null !== (v = g.nextSibling)) break;
                                    A = (g = A).parentNode;
                                }
                                g = v;
                            }
                            l = -1 === d || -1 === p ? null : {
                                start: d,
                                end: p
                            };
                        } else l = null;
                        l = l || {
                            start: 0,
                            end: 0
                        };
                    } else l = null;
                    Fi = {
                        focusedElem: o,
                        selectionRange: l
                    }, Ye = !1, ll = null, cl = !1, Xo = i;
                    do try {
                        Ll();
                    } catch (t1) {
                        if (null === Xo) throw Error(s(330));
                        kl(Xo, t1), Xo = Xo.nextEffect;
                    }
                    while (null !== Xo);
                    ll = null, Xo = i;
                    do try {
                        for(o = t1; null !== Xo;){
                            var y = Xo.flags;
                            if (16 & y && At(Xo.stateNode, ""), 128 & y) {
                                var M = Xo.alternate;
                                if (null !== M) {
                                    var b = M.ref;
                                    null !== b && ("function" == typeof b ? b(null) : b.current = null);
                                }
                            }
                            switch(1038 & y){
                                case 2:
                                    Mo(Xo), Xo.flags &= -3;
                                    break;
                                case 6:
                                    Mo(Xo), Xo.flags &= -3, _o(Xo.alternate, Xo);
                                    break;
                                case 1024:
                                    Xo.flags &= -1025;
                                    break;
                                case 1028:
                                    Xo.flags &= -1025, _o(Xo.alternate, Xo);
                                    break;
                                case 4:
                                    _o(Xo.alternate, Xo);
                                    break;
                                case 8:
                                    wo(o, l = Xo);
                                    var x = l.alternate;
                                    vo(l), null !== x && vo(x);
                            }
                            Xo = Xo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Xo) throw Error(s(330));
                        kl(Xo, t1), Xo = Xo.nextEffect;
                    }
                    while (null !== Xo);
                    if (b = Fi, M = mi(), y = b.focusedElem, o = b.selectionRange, M !== y && y && y.ownerDocument && fi(y.ownerDocument.documentElement, y)) {
                        null !== o && gi(y) && (M = o.start, void 0 === (b = o.end) && (b = M), "selectionStart" in y ? (y.selectionStart = M, y.selectionEnd = Math.min(b, y.value.length)) : (b = (M = y.ownerDocument || document) && M.defaultView || window).getSelection && (b = b.getSelection(), l = y.textContent.length, x = Math.min(o.start, l), o = void 0 === o.end ? x : Math.min(o.end, l), !b.extend && x > o && (l = o, o = x, x = l), l = pi(y, x), a = pi(y, o), l && a && (1 !== b.rangeCount || b.anchorNode !== l.node || b.anchorOffset !== l.offset || b.focusNode !== a.node || b.focusOffset !== a.offset) && ((M = M.createRange()).setStart(l.node, l.offset), b.removeAllRanges(), x > o ? (b.addRange(M), b.extend(a.node, a.offset)) : (M.setEnd(a.node, a.offset), b.addRange(M))))), M = [];
                        for(b = y; b = b.parentNode;)1 === b.nodeType && M.push({
                            element: b,
                            left: b.scrollLeft,
                            top: b.scrollTop
                        });
                        for("function" == typeof y.focus && y.focus(), y = 0; y < M.length; y++)(b = M[y]).element.scrollLeft = b.left, b.element.scrollTop = b.top;
                    }
                    Ye = !!ji, Fi = ji = null, t1.current = n, Xo = i;
                    do try {
                        for(y = t1; null !== Xo;){
                            var w = Xo.flags;
                            if (36 & w && mo(y, Xo.alternate, Xo), 128 & w) {
                                M = void 0;
                                var _ = Xo.ref;
                                if (null !== _) {
                                    var E = Xo.stateNode;
                                    Xo.tag, M = E, "function" == typeof _ ? _(M) : _.current = M;
                                }
                            }
                            Xo = Xo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Xo) throw Error(s(330));
                        kl(Xo, t1), Xo = Xo.nextEffect;
                    }
                    while (null !== Xo);
                    Xo = null, Ur(), No = r;
                } else t1.current = n;
                if (Jo) Jo = !1, Ko = t1, $o = e;
                else for(Xo = i; null !== Xo;)e = Xo.nextEffect, Xo.nextEffect = null, 8 & Xo.flags && ((w = Xo).sibling = null, w.stateNode = null), Xo = e;
                if (0 === (i = t1.pendingLanes) && (qo = null), 1 === i ? t1 === rl ? il++ : (il = 0, rl = t1) : il = 0, n = n.stateNode, wr && "function" == typeof wr.onCommitFiberRoot) try {
                    wr.onCommitFiberRoot(xr, n, void 0, !(64 & ~n.current.flags));
                } catch (t1) {}
                if (fl(t1, Hr()), Yo) throw Yo = !1, t1 = Zo, Zo = null, t1;
                return 8 & No || Xr(), null;
            }
            function Ll() {
                for(; null !== Xo;){
                    var t1 = Xo.alternate;
                    cl || null === ll || (8 & Xo.flags ? $t(Xo, ll) && (cl = !0) : 13 === Xo.tag && So(t1, Xo) && $t(Xo, ll) && (cl = !0));
                    var e = Xo.flags;
                    256 & e && fo(t1, Xo), !(512 & e) || Jo || (Jo = !0, Wr(97, function() {
                        return Ol(), null;
                    })), Xo = Xo.nextEffect;
                }
            }
            function Ol() {
                if (90 !== $o) {
                    var t1 = 97 < $o ? 97 : $o;
                    return $o = 90, Gr(t1, zl);
                }
                return !1;
            }
            function Rl(t1, e) {
                tl.push(e, t1), Jo || (Jo = !0, Wr(97, function() {
                    return Ol(), null;
                }));
            }
            function Pl(t1, e) {
                el.push(e, t1), Jo || (Jo = !0, Wr(97, function() {
                    return Ol(), null;
                }));
            }
            function zl() {
                if (null === Ko) return !1;
                var t1 = Ko;
                if (Ko = null, 48 & No) throw Error(s(331));
                var e = No;
                No |= 32;
                var n = el;
                el = [];
                for(var i = 0; i < n.length; i += 2){
                    var r = n[i], a = n[i + 1], o = r.destroy;
                    if (r.destroy = void 0, "function" == typeof o) try {
                        o();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        kl(a, t1);
                    }
                }
                for(n = tl, tl = [], i = 0; i < n.length; i += 2){
                    r = n[i], a = n[i + 1];
                    try {
                        var l = r.create;
                        r.destroy = l();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        kl(a, t1);
                    }
                }
                for(l = t1.current.firstEffect; null !== l;)t1 = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = t1;
                return No = e, Xr(), !0;
            }
            function Ul(t1, e, n) {
                ua(t1, e = co(0, e = so(n, e), 1)), e = ul(), null !== (t1 = pl(t1, 1)) && (He(t1, 1, e), fl(t1, e));
            }
            function kl(t1, e) {
                if (3 === t1.tag) Ul(t1, t1, e);
                else for(var n = t1.return; null !== n;){
                    if (3 === n.tag) {
                        Ul(n, t1, e);
                        break;
                    }
                    if (1 === n.tag) {
                        var i = n.stateNode;
                        if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) {
                            var r = uo(n, t1 = so(e, t1), 1);
                            if (ua(n, r), r = ul(), null !== (n = pl(n, 1))) He(n, 1, r), fl(n, r);
                            else if ("function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) try {
                                i.componentDidCatch(e, t1);
                            } catch (t1) {}
                            break;
                        }
                    }
                    n = n.return;
                }
            }
            function Bl(t1, e, n) {
                var i = t1.pingCache;
                null !== i && i.delete(e), e = ul(), t1.pingedLanes |= t1.suspendedLanes & n, Do === t1 && (Oo & n) === n && (4 === zo || 3 === zo && (62914560 & Oo) === Oo && 500 > Hr() - Vo ? xl(t1, 0) : Fo |= n), fl(t1, e);
            }
            function jl(t1, e) {
                var n = t1.stateNode;
                null !== n && n.delete(e), 0 == (e = 0) && (2 & (e = t1.mode) ? 4 & e ? (0 === sl && (sl = ko), 0 === (e = je(62914560 & ~sl)) && (e = 4194304)) : e = 99 === Vr() ? 1 : 2 : e = 1), n = ul(), null !== (t1 = pl(t1, e)) && (He(t1, e, n), fl(t1, n));
            }
            function Fl(t1, e, n, i) {
                this.tag = t1, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function Hl(t1, e, n, i) {
                return new Fl(t1, e, n, i);
            }
            function Vl(t1) {
                return !(!(t1 = t1.prototype) || !t1.isReactComponent);
            }
            function Ql(t1, e) {
                var n = t1.alternate;
                return null === n ? ((n = Hl(t1.tag, e, t1.key, t1.mode)).elementType = t1.elementType, n.type = t1.type, n.stateNode = t1.stateNode, n.alternate = t1, t1.alternate = n) : (n.pendingProps = e, n.type = t1.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = t1.childLanes, n.lanes = t1.lanes, n.child = t1.child, n.memoizedProps = t1.memoizedProps, n.memoizedState = t1.memoizedState, n.updateQueue = t1.updateQueue, e = t1.dependencies, n.dependencies = null === e ? null : {
                    lanes: e.lanes,
                    firstContext: e.firstContext
                }, n.sibling = t1.sibling, n.index = t1.index, n.ref = t1.ref, n;
            }
            function Gl(t1, e, n, i, r, a) {
                var o = 2;
                if (i = t1, "function" == typeof t1) Vl(t1) && (o = 1);
                else if ("string" == typeof t1) o = 5;
                else t: switch(t1){
                    case _:
                        return Wl(n.children, r, a, e);
                    case z:
                        o = 8, r |= 16;
                        break;
                    case E:
                        o = 8, r |= 1;
                        break;
                    case S:
                        return (t1 = Hl(12, n, e, 8 | r)).elementType = S, t1.type = S, t1.lanes = a, t1;
                    case N:
                        return (t1 = Hl(13, n, e, r)).type = N, t1.elementType = N, t1.lanes = a, t1;
                    case D:
                        return (t1 = Hl(19, n, e, r)).elementType = D, t1.lanes = a, t1;
                    case U:
                        return Xl(n, r, a, e);
                    case k:
                        return (t1 = Hl(24, n, e, r)).elementType = k, t1.lanes = a, t1;
                    default:
                        if ("object" == typeof t1 && null !== t1) switch(t1.$$typeof){
                            case T:
                                o = 10;
                                break t;
                            case I:
                                o = 9;
                                break t;
                            case C:
                                o = 11;
                                break t;
                            case L:
                                o = 14;
                                break t;
                            case O:
                                o = 16, i = null;
                                break t;
                            case R:
                                o = 22;
                                break t;
                        }
                        throw Error(s(130, null == t1 ? t1 : typeof t1, ""));
                }
                return (e = Hl(o, n, e, r)).elementType = t1, e.type = i, e.lanes = a, e;
            }
            function Wl(t1, e, n, i) {
                return (t1 = Hl(7, t1, i, e)).lanes = n, t1;
            }
            function Xl(t1, e, n, i) {
                return (t1 = Hl(23, t1, i, e)).elementType = U, t1.lanes = n, t1;
            }
            function Yl(t1, e, n) {
                return (t1 = Hl(6, t1, null, e)).lanes = n, t1;
            }
            function Zl(t1, e, n) {
                return (e = Hl(4, null !== t1.children ? t1.children : [], t1.key, e)).lanes = n, e.stateNode = {
                    containerInfo: t1.containerInfo,
                    pendingChildren: null,
                    implementation: t1.implementation
                }, e;
            }
            function ql(t1, e, n) {
                this.tag = e, this.containerInfo = t1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Fe(0), this.expirationTimes = Fe(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fe(0), this.mutableSourceEagerHydrationData = null;
            }
            function Jl(t1, e, n, i) {
                var r = e.current, a = ul(), o = hl(r);
                t: if (n) {
                    e: {
                        if (Zt(n = n._reactInternals) !== n || 1 !== n.tag) throw Error(s(170));
                        var l = n;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break e;
                                case 1:
                                    if (gr(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(s(171));
                    }
                    if (1 === n.tag) {
                        var c = n.type;
                        if (gr(c)) {
                            n = yr(n, c, l);
                            break t;
                        }
                    }
                    n = l;
                } else n = hr;
                return null === e.context ? e.context = n : e.pendingContext = n, (e = ca(a, o)).payload = {
                    element: t1
                }, null !== (i = void 0 === i ? null : i) && (e.callback = i), ua(r, e), dl(r, o, a), o;
            }
            function Kl(t1) {
                return (t1 = t1.current).child ? (t1.child.tag, t1.child.stateNode) : null;
            }
            function $l(t1, e) {
                if (null !== (t1 = t1.memoizedState) && null !== t1.dehydrated) {
                    var n = t1.retryLane;
                    t1.retryLane = 0 !== n && n < e ? n : e;
                }
            }
            function tc(t1, e) {
                $l(t1, e), (t1 = t1.alternate) && $l(t1, e);
            }
            function ec(t1, e, n) {
                var i = null != n && null != n.hydrationOptions && n.hydrationOptions.mutableSources || null;
                if (n = new ql(t1, e, null != n && !0 === n.hydrate), e = Hl(3, null, null, 2 === e ? 7 : 1 === e ? 3 : 0), n.current = e, e.stateNode = n, oa(e), t1[$i] = n.current, Di(8 === t1.nodeType ? t1.parentNode : t1), i) for(t1 = 0; t1 < i.length; t1++){
                    var r = (e = i[t1])._getVersion;
                    r = r(e._source), null == n.mutableSourceEagerHydrationData ? n.mutableSourceEagerHydrationData = [
                        e,
                        r
                    ] : n.mutableSourceEagerHydrationData.push(e, r);
                }
                this._internalRoot = n;
            }
            function nc(t1) {
                return !(!t1 || 1 !== t1.nodeType && 9 !== t1.nodeType && 11 !== t1.nodeType && (8 !== t1.nodeType || " react-mount-point-unstable " !== t1.nodeValue));
            }
            function ic(t1, e, n, i, r) {
                var a = n._reactRootContainer;
                if (a) {
                    var s = a._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var t1 = Kl(s);
                            o.call(t1);
                        };
                    }
                    Jl(e, s, t1, r);
                } else {
                    if (a = n._reactRootContainer = function(t1, e) {
                        if (e || (e = !(!(e = t1 ? 9 === t1.nodeType ? t1.documentElement : t1.firstChild : null) || 1 !== e.nodeType || !e.hasAttribute("data-reactroot"))), !e) for(var n; n = t1.lastChild;)t1.removeChild(n);
                        return new ec(t1, 0, e ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), s = a._internalRoot, "function" == typeof r) {
                        var l = r;
                        r = function() {
                            var t1 = Kl(s);
                            l.call(t1);
                        };
                    }
                    yl(function() {
                        Jl(e, s, t1, r);
                    });
                }
                return Kl(s);
            }
            function rc(t1, e) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!nc(e)) throw Error(s(200));
                return function(t1, e, n) {
                    var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                    return {
                        $$typeof: w,
                        key: null == i ? null : "" + i,
                        children: t1,
                        containerInfo: e,
                        implementation: n
                    };
                }(t1, e, null, n);
            }
            Wo = function(t1, e, n) {
                var i = e.lanes;
                if (null !== t1) {
                    if (t1.memoizedProps !== e.pendingProps || pr.current) Ps = !0;
                    else {
                        if (!(n & i)) {
                            switch(Ps = !1, e.tag){
                                case 3:
                                    Gs(e), Wa();
                                    break;
                                case 5:
                                    Ra(e);
                                    break;
                                case 1:
                                    gr(e.type) && Mr(e);
                                    break;
                                case 4:
                                    La(e, e.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = e.memoizedProps.value;
                                    var r = e.type._context;
                                    ur(Jr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== e.memoizedState) return n & e.child.childLanes ? Js(t1, e, n) : (ur(za, 1 & za.current), null !== (e = no(t1, e, n)) ? e.sibling : null);
                                    ur(za, 1 & za.current);
                                    break;
                                case 19:
                                    if (i = !!(n & e.childLanes), 64 & t1.flags) {
                                        if (i) return eo(t1, e, n);
                                        e.flags |= 64;
                                    }
                                    if (null !== (r = e.memoizedState) && (r.rendering = null, r.tail = null, r.lastEffect = null), ur(za, za.current), i) break;
                                    return null;
                                case 23:
                                case 24:
                                    return e.lanes = 0, js(t1, e, n);
                            }
                            return no(t1, e, n);
                        }
                        Ps = !!(16384 & t1.flags);
                    }
                } else Ps = !1;
                switch(e.lanes = 0, e.tag){
                    case 2:
                        if (i = e.type, null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = mr(e, dr.current), ra(e, n), r = as(null, e, i, t1, r, n), e.flags |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (e.tag = 1, e.memoizedState = null, e.updateQueue = null, gr(i)) {
                                var a = !0;
                                Mr(e);
                            } else a = !1;
                            e.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oa(e);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && ma(e, i, o, t1), r.updater = ga, e.stateNode = r, r._reactInternals = e, Ma(e, i, t1, n), e = Qs(null, e, i, !0, a, n);
                        } else e.tag = 0, zs(null, e, r, n), e = e.child;
                        return e;
                    case 16:
                        r = e.elementType;
                        t: {
                            switch(null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = (a = r._init)(r._payload), e.type = r, a = e.tag = function(t1) {
                                if ("function" == typeof t1) return Vl(t1) ? 1 : 0;
                                if (null != t1) {
                                    if ((t1 = t1.$$typeof) === C) return 11;
                                    if (t1 === L) return 14;
                                }
                                return 2;
                            }(r), t1 = qr(r, t1), a){
                                case 0:
                                    e = Hs(null, e, r, t1, n);
                                    break t;
                                case 1:
                                    e = Vs(null, e, r, t1, n);
                                    break t;
                                case 11:
                                    e = Us(null, e, r, t1, n);
                                    break t;
                                case 14:
                                    e = ks(null, e, r, qr(r.type, t1), i, n);
                                    break t;
                            }
                            throw Error(s(306, r, ""));
                        }
                        return e;
                    case 0:
                        return i = e.type, r = e.pendingProps, Hs(t1, e, i, r = e.elementType === i ? r : qr(i, r), n);
                    case 1:
                        return i = e.type, r = e.pendingProps, Vs(t1, e, i, r = e.elementType === i ? r : qr(i, r), n);
                    case 3:
                        if (Gs(e), i = e.updateQueue, null === t1 || null === i) throw Error(s(282));
                        if (i = e.pendingProps, r = null !== (r = e.memoizedState) ? r.element : null, la(t1, e), da(e, i, null, n), (i = e.memoizedState.element) === r) Wa(), e = no(t1, e, n);
                        else {
                            if ((a = (r = e.stateNode).hydrate) && (Ba = Xi(e.stateNode.containerInfo.firstChild), ka = e, a = ja = !0), a) {
                                if (null != (t1 = r.mutableSourceEagerHydrationData)) for(r = 0; r < t1.length; r += 2)(a = t1[r])._workInProgressVersionPrimary = t1[r + 1], Xa.push(a);
                                for(n = Sa(e, null, i, n), e.child = n; n;)n.flags = -3 & n.flags | 1024, n = n.sibling;
                            } else zs(t1, e, i, n), Wa();
                            e = e.child;
                        }
                        return e;
                    case 5:
                        return Ra(e), null === t1 && Va(e), i = e.type, r = e.pendingProps, a = null !== t1 ? t1.memoizedProps : null, o = r.children, Vi(i, r) ? o = null : null !== a && Vi(i, a) && (e.flags |= 16), Fs(t1, e), zs(t1, e, o, n), e.child;
                    case 6:
                        return null === t1 && Va(e), null;
                    case 13:
                        return Js(t1, e, n);
                    case 4:
                        return La(e, e.stateNode.containerInfo), i = e.pendingProps, null === t1 ? e.child = Ea(e, null, i, n) : zs(t1, e, i, n), e.child;
                    case 11:
                        return i = e.type, r = e.pendingProps, Us(t1, e, i, r = e.elementType === i ? r : qr(i, r), n);
                    case 7:
                        return zs(t1, e, e.pendingProps, n), e.child;
                    case 8:
                    case 12:
                        return zs(t1, e, e.pendingProps.children, n), e.child;
                    case 10:
                        t: {
                            i = e.type._context, r = e.pendingProps, o = e.memoizedProps, a = r.value;
                            var l = e.type._context;
                            if (ur(Jr, l._currentValue), l._currentValue = a, null !== o) {
                                if (l = o.value, 0 == (a = ci(l, a) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(l, a) : 1073741823))) {
                                    if (o.children === r.children && !pr.current) {
                                        e = no(t1, e, n);
                                        break t;
                                    }
                                } else for(null !== (l = e.child) && (l.return = e); null !== l;){
                                    var c = l.dependencies;
                                    if (null !== c) {
                                        o = l.child;
                                        for(var u = c.firstContext; null !== u;){
                                            if (u.context === i && u.observedBits & a) {
                                                1 === l.tag && ((u = ca(-1, n & -n)).tag = 2, ua(l, u)), l.lanes |= n, null !== (u = l.alternate) && (u.lanes |= n), ia(l.return, n), c.lanes |= n;
                                                break;
                                            }
                                            u = u.next;
                                        }
                                    } else o = 10 === l.tag && l.type === e.type ? null : l.child;
                                    if (null !== o) o.return = l;
                                    else for(o = l; null !== o;){
                                        if (o === e) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (l = o.sibling)) {
                                            l.return = o.return, o = l;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    l = o;
                                }
                            }
                            zs(t1, e, r.children, n), e = e.child;
                        }
                        return e;
                    case 9:
                        return r = e.type, i = (a = e.pendingProps).children, ra(e, n), i = i(r = aa(r, a.unstable_observedBits)), e.flags |= 1, zs(t1, e, i, n), e.child;
                    case 14:
                        return a = qr(r = e.type, e.pendingProps), ks(t1, e, r, a = qr(r.type, a), i, n);
                    case 15:
                        return Bs(t1, e, e.type, e.pendingProps, i, n);
                    case 17:
                        return i = e.type, r = e.pendingProps, r = e.elementType === i ? r : qr(i, r), null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), e.tag = 1, gr(i) ? (t1 = !0, Mr(e)) : t1 = !1, ra(e, n), va(e, i, r), Ma(e, i, r, n), Qs(null, e, i, !0, t1, n);
                    case 19:
                        return eo(t1, e, n);
                    case 23:
                    case 24:
                        return js(t1, e, n);
                }
                throw Error(s(156, e.tag));
            }, ec.prototype.render = function(t1) {
                Jl(t1, this._internalRoot, null, null);
            }, ec.prototype.unmount = function() {
                var t1 = this._internalRoot, e = t1.containerInfo;
                Jl(null, t1, null, function() {
                    e[$i] = null;
                });
            }, te = function(t1) {
                13 === t1.tag && (dl(t1, 4, ul()), tc(t1, 4));
            }, ee = function(t1) {
                13 === t1.tag && (dl(t1, 67108864, ul()), tc(t1, 67108864));
            }, ne = function(t1) {
                if (13 === t1.tag) {
                    var e = ul(), n = hl(t1);
                    dl(t1, n, e), tc(t1, n);
                }
            }, ie = function(t1, e) {
                return e();
            }, St = function(t1, e, n) {
                switch(e){
                    case "input":
                        if (nt(t1, n), e = n.name, "radio" === n.type && null != e) {
                            for(n = t1; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + e) + '][type="radio"]'), e = 0; e < n.length; e++){
                                var i = n[e];
                                if (i !== t1 && i.form === t1.form) {
                                    var r = rr(i);
                                    if (!r) throw Error(s(90));
                                    J(i), nt(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ct(t1, n);
                        break;
                    case "select":
                        null != (e = n.value) && st(t1, !!n.multiple, e, !1);
                }
            }, Lt = vl, Ot = function(t1, e, n, i, r) {
                var a = No;
                No |= 4;
                try {
                    return Gr(98, t1.bind(null, e, n, i, r));
                } finally{
                    0 === (No = a) && (Go(), Xr());
                }
            }, Rt = function() {
                !(49 & No) && (function() {
                    if (null !== nl) {
                        var t1 = nl;
                        nl = null, t1.forEach(function(t1) {
                            t1.expiredLanes |= 24 & t1.pendingLanes, fl(t1, Hr());
                        });
                    }
                    Xr();
                }(), Ol());
            }, Pt = function(t1, e) {
                var n = No;
                No |= 2;
                try {
                    return t1(e);
                } finally{
                    0 === (No = n) && (Go(), Xr());
                }
            };
            var ac = {
                Events: [
                    nr,
                    ir,
                    rr,
                    Nt,
                    Dt,
                    Ol,
                    {
                        current: !1
                    }
                ]
            }, sc = {
                findFiberByHostInstance: er,
                bundleType: 0,
                version: "17.0.2",
                rendererPackageName: "react-dom"
            }, oc = {
                bundleType: sc.bundleType,
                version: sc.version,
                rendererPackageName: sc.rendererPackageName,
                rendererConfig: sc.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: b.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(t1) {
                    return null === (t1 = Kt(t1)) ? null : t1.stateNode;
                },
                findFiberByHostInstance: sc.findFiberByHostInstance || function() {
                    return null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            };
            if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                var lc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (!lc.isDisabled && lc.supportsFiber) try {
                    xr = lc.inject(oc), wr = lc;
                } catch (mt) {}
            }
            e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ac, e.createPortal = rc, e.findDOMNode = function(t1) {
                if (null == t1) return null;
                if (1 === t1.nodeType) return t1;
                var e = t1._reactInternals;
                if (void 0 === e) {
                    if ("function" == typeof t1.render) throw Error(s(188));
                    throw Error(s(268, Object.keys(t1)));
                }
                return null === (t1 = Kt(e)) ? null : t1.stateNode;
            }, e.flushSync = function(t1, e) {
                var n = No;
                if (48 & n) return t1(e);
                No |= 1;
                try {
                    if (t1) return Gr(99, t1.bind(null, e));
                } finally{
                    No = n, Xr();
                }
            }, e.hydrate = function(t1, e, n) {
                if (!nc(e)) throw Error(s(200));
                return ic(null, t1, e, !0, n);
            }, e.render = function(t1, e, n) {
                if (!nc(e)) throw Error(s(200));
                return ic(null, t1, e, !1, n);
            }, e.unmountComponentAtNode = function(t1) {
                if (!nc(t1)) throw Error(s(40));
                return !!t1._reactRootContainer && (yl(function() {
                    ic(null, null, t1, !1, function() {
                        t1._reactRootContainer = null, t1[$i] = null;
                    });
                }), !0);
            }, e.unstable_batchedUpdates = vl, e.unstable_createPortal = function(t1, e) {
                return rc(t1, e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, e.unstable_renderSubtreeIntoContainer = function(t1, e, n, i) {
                if (!nc(n)) throw Error(s(200));
                if (null == t1 || void 0 === t1._reactInternals) throw Error(s(38));
                return ic(t1, e, n, !1, i);
            }, e.version = "17.0.2";
        },
        961: (t1, e, n)=>{
            "use strict";
            !function t1() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t1);
                } catch (t1) {
                    console.error(t1);
                }
            }(), t1.exports = n(551);
        },
        287: (t1, e, n)=>{
            "use strict";
            var i = n(228), r = 60103, a = 60106;
            e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
            var s = 60109, o = 60110, l = 60112;
            e.Suspense = 60113;
            var c = 60115, u = 60116;
            if ("function" == typeof Symbol && Symbol.for) {
                var h = Symbol.for;
                r = h("react.element"), a = h("react.portal"), e.Fragment = h("react.fragment"), e.StrictMode = h("react.strict_mode"), e.Profiler = h("react.profiler"), s = h("react.provider"), o = h("react.context"), l = h("react.forward_ref"), e.Suspense = h("react.suspense"), c = h("react.memo"), u = h("react.lazy");
            }
            var d = "function" == typeof Symbol && Symbol.iterator;
            function p(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, n = 1; n < arguments.length; n++)e += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var f = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, m = {};
            function g(t1, e, n) {
                this.props = t1, this.context = e, this.refs = m, this.updater = n || f;
            }
            function A() {}
            function v(t1, e, n) {
                this.props = t1, this.context = e, this.refs = m, this.updater = n || f;
            }
            g.prototype.isReactComponent = {}, g.prototype.setState = function(t1, e) {
                if ("object" != typeof t1 && "function" != typeof t1 && null != t1) throw Error(p(85));
                this.updater.enqueueSetState(this, t1, e, "setState");
            }, g.prototype.forceUpdate = function(t1) {
                this.updater.enqueueForceUpdate(this, t1, "forceUpdate");
            }, A.prototype = g.prototype;
            var y = v.prototype = new A;
            y.constructor = v, i(y, g.prototype), y.isPureReactComponent = !0;
            var M = {
                current: null
            }, b = Object.prototype.hasOwnProperty, x = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function w(t1, e, n) {
                var i, a = {}, s = null, o = null;
                if (null != e) for(i in void 0 !== e.ref && (o = e.ref), void 0 !== e.key && (s = "" + e.key), e)b.call(e, i) && !x.hasOwnProperty(i) && (a[i] = e[i]);
                var l = arguments.length - 2;
                if (1 === l) a.children = n;
                else if (1 < l) {
                    for(var c = Array(l), u = 0; u < l; u++)c[u] = arguments[u + 2];
                    a.children = c;
                }
                if (t1 && t1.defaultProps) for(i in l = t1.defaultProps)void 0 === a[i] && (a[i] = l[i]);
                return {
                    $$typeof: r,
                    type: t1,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: M.current
                };
            }
            function _(t1) {
                return "object" == typeof t1 && null !== t1 && t1.$$typeof === r;
            }
            var E = /\/+/g;
            function S(t1, e) {
                return "object" == typeof t1 && null !== t1 && null != t1.key ? function(t1) {
                    var e = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + t1.replace(/[=:]/g, function(t1) {
                        return e[t1];
                    });
                }("" + t1.key) : e.toString(36);
            }
            function T(t1, e, n, i, s) {
                var o = typeof t1;
                "undefined" !== o && "boolean" !== o || (t1 = null);
                var l = !1;
                if (null === t1) l = !0;
                else switch(o){
                    case "string":
                    case "number":
                        l = !0;
                        break;
                    case "object":
                        switch(t1.$$typeof){
                            case r:
                            case a:
                                l = !0;
                        }
                }
                if (l) return s = s(l = t1), t1 = "" === i ? "." + S(l, 0) : i, Array.isArray(s) ? (n = "", null != t1 && (n = t1.replace(E, "$&/") + "/"), T(s, e, n, "", function(t1) {
                    return t1;
                })) : null != s && (_(s) && (s = function(t1, e) {
                    return {
                        $$typeof: r,
                        type: t1.type,
                        key: e,
                        ref: t1.ref,
                        props: t1.props,
                        _owner: t1._owner
                    };
                }(s, n + (!s.key || l && l.key === s.key ? "" : ("" + s.key).replace(E, "$&/") + "/") + t1)), e.push(s)), 1;
                if (l = 0, i = "" === i ? "." : i + ":", Array.isArray(t1)) for(var c = 0; c < t1.length; c++){
                    var u = i + S(o = t1[c], c);
                    l += T(o, e, n, u, s);
                }
                else if (u = function(t1) {
                    return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = d && t1[d] || t1["@@iterator"]) ? t1 : null;
                }(t1), "function" == typeof u) for(t1 = u.call(t1), c = 0; !(o = t1.next()).done;)l += T(o = o.value, e, n, u = i + S(o, c++), s);
                else if ("object" === o) throw e = "" + t1, Error(p(31, "[object Object]" === e ? "object with keys {" + Object.keys(t1).join(", ") + "}" : e));
                return l;
            }
            function I(t1, e, n) {
                if (null == t1) return t1;
                var i = [], r = 0;
                return T(t1, i, "", "", function(t1) {
                    return e.call(n, t1, r++);
                }), i;
            }
            function C(t1) {
                if (-1 === t1._status) {
                    var e = t1._result;
                    e = e(), t1._status = 0, t1._result = e, e.then(function(e) {
                        0 === t1._status && (e = e.default, t1._status = 1, t1._result = e);
                    }, function(e) {
                        0 === t1._status && (t1._status = 2, t1._result = e);
                    });
                }
                if (1 === t1._status) return t1._result;
                throw t1._result;
            }
            var N = {
                current: null
            };
            function D() {
                var t1 = N.current;
                if (null === t1) throw Error(p(321));
                return t1;
            }
            var L = {
                ReactCurrentDispatcher: N,
                ReactCurrentBatchConfig: {
                    transition: 0
                },
                ReactCurrentOwner: M,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            e.Children = {
                map: I,
                forEach: function(t1, e, n) {
                    I(t1, function() {
                        e.apply(this, arguments);
                    }, n);
                },
                count: function(t1) {
                    var e = 0;
                    return I(t1, function() {
                        e++;
                    }), e;
                },
                toArray: function(t1) {
                    return I(t1, function(t1) {
                        return t1;
                    }) || [];
                },
                only: function(t1) {
                    if (!_(t1)) throw Error(p(143));
                    return t1;
                }
            }, e.Component = g, e.PureComponent = v, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L, e.cloneElement = function(t1, e, n) {
                if (null == t1) throw Error(p(267, t1));
                var a = i({}, t1.props), s = t1.key, o = t1.ref, l = t1._owner;
                if (null != e) {
                    if (void 0 !== e.ref && (o = e.ref, l = M.current), void 0 !== e.key && (s = "" + e.key), t1.type && t1.type.defaultProps) var c = t1.type.defaultProps;
                    for(u in e)b.call(e, u) && !x.hasOwnProperty(u) && (a[u] = void 0 === e[u] && void 0 !== c ? c[u] : e[u]);
                }
                var u = arguments.length - 2;
                if (1 === u) a.children = n;
                else if (1 < u) {
                    c = Array(u);
                    for(var h = 0; h < u; h++)c[h] = arguments[h + 2];
                    a.children = c;
                }
                return {
                    $$typeof: r,
                    type: t1.type,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: l
                };
            }, e.createContext = function(t1, e) {
                return void 0 === e && (e = null), (t1 = {
                    $$typeof: o,
                    _calculateChangedBits: e,
                    _currentValue: t1,
                    _currentValue2: t1,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: s,
                    _context: t1
                }, t1.Consumer = t1;
            }, e.createElement = w, e.createFactory = function(t1) {
                var e = w.bind(null, t1);
                return e.type = t1, e;
            }, e.createRef = function() {
                return {
                    current: null
                };
            }, e.forwardRef = function(t1) {
                return {
                    $$typeof: l,
                    render: t1
                };
            }, e.isValidElement = _, e.lazy = function(t1) {
                return {
                    $$typeof: u,
                    _payload: {
                        _status: -1,
                        _result: t1
                    },
                    _init: C
                };
            }, e.memo = function(t1, e) {
                return {
                    $$typeof: c,
                    type: t1,
                    compare: void 0 === e ? null : e
                };
            }, e.useCallback = function(t1, e) {
                return D().useCallback(t1, e);
            }, e.useContext = function(t1, e) {
                return D().useContext(t1, e);
            }, e.useDebugValue = function() {}, e.useEffect = function(t1, e) {
                return D().useEffect(t1, e);
            }, e.useImperativeHandle = function(t1, e, n) {
                return D().useImperativeHandle(t1, e, n);
            }, e.useLayoutEffect = function(t1, e) {
                return D().useLayoutEffect(t1, e);
            }, e.useMemo = function(t1, e) {
                return D().useMemo(t1, e);
            }, e.useReducer = function(t1, e, n) {
                return D().useReducer(t1, e, n);
            }, e.useRef = function(t1) {
                return D().useRef(t1);
            }, e.useState = function(t1) {
                return D().useState(t1);
            }, e.version = "17.0.2";
        },
        540: (t1, e, n)=>{
            "use strict";
            t1.exports = n(287);
        },
        463: (t1, e)=>{
            "use strict";
            var n, i, r, a;
            if ("object" == typeof performance && "function" == typeof performance.now) {
                var s = performance;
                e.unstable_now = function() {
                    return s.now();
                };
            } else {
                var o = Date, l = o.now();
                e.unstable_now = function() {
                    return o.now() - l;
                };
            }
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, u = null, h = function() {
                    if (null !== c) try {
                        var t1 = e.unstable_now();
                        c(!0, t1), c = null;
                    } catch (t1) {
                        throw setTimeout(h, 0), t1;
                    }
                };
                n = function(t1) {
                    null !== c ? setTimeout(n, 0, t1) : (c = t1, setTimeout(h, 0));
                }, i = function(t1, e) {
                    u = setTimeout(t1, e);
                }, r = function() {
                    clearTimeout(u);
                }, e.unstable_shouldYield = function() {
                    return !1;
                }, a = e.unstable_forceFrameRate = function() {};
            } else {
                var d = window.setTimeout, p = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var f = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof f && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
                }
                var m = !1, g = null, A = -1, v = 5, y = 0;
                e.unstable_shouldYield = function() {
                    return e.unstable_now() >= y;
                }, a = function() {}, e.unstable_forceFrameRate = function(t1) {
                    0 > t1 || 125 < t1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : v = 0 < t1 ? Math.floor(1e3 / t1) : 5;
                };
                var M = new MessageChannel, b = M.port2;
                M.port1.onmessage = function() {
                    if (null !== g) {
                        var t1 = e.unstable_now();
                        y = t1 + v;
                        try {
                            g(!0, t1) ? b.postMessage(null) : (m = !1, g = null);
                        } catch (t1) {
                            throw b.postMessage(null), t1;
                        }
                    } else m = !1;
                }, n = function(t1) {
                    g = t1, m || (m = !0, b.postMessage(null));
                }, i = function(t1, n) {
                    A = d(function() {
                        t1(e.unstable_now());
                    }, n);
                }, r = function() {
                    p(A), A = -1;
                };
            }
            function x(t1, e) {
                var n = t1.length;
                t1.push(e);
                t: for(;;){
                    var i = n - 1 >>> 1, r = t1[i];
                    if (!(void 0 !== r && 0 < E(r, e))) break t;
                    t1[i] = e, t1[n] = r, n = i;
                }
            }
            function w(t1) {
                return void 0 === (t1 = t1[0]) ? null : t1;
            }
            function _(t1) {
                var e = t1[0];
                if (void 0 !== e) {
                    var n = t1.pop();
                    if (n !== e) {
                        t1[0] = n;
                        t: for(var i = 0, r = t1.length; i < r;){
                            var a = 2 * (i + 1) - 1, s = t1[a], o = a + 1, l = t1[o];
                            if (void 0 !== s && 0 > E(s, n)) void 0 !== l && 0 > E(l, s) ? (t1[i] = l, t1[o] = n, i = o) : (t1[i] = s, t1[a] = n, i = a);
                            else {
                                if (!(void 0 !== l && 0 > E(l, n))) break t;
                                t1[i] = l, t1[o] = n, i = o;
                            }
                        }
                    }
                    return e;
                }
                return null;
            }
            function E(t1, e) {
                var n = t1.sortIndex - e.sortIndex;
                return 0 !== n ? n : t1.id - e.id;
            }
            var S = [], T = [], I = 1, C = null, N = 3, D = !1, L = !1, O = !1;
            function R(t1) {
                for(var e = w(T); null !== e;){
                    if (null === e.callback) _(T);
                    else {
                        if (!(e.startTime <= t1)) break;
                        _(T), e.sortIndex = e.expirationTime, x(S, e);
                    }
                    e = w(T);
                }
            }
            function P(t1) {
                if (O = !1, R(t1), !L) {
                    if (null !== w(S)) L = !0, n(z);
                    else {
                        var e = w(T);
                        null !== e && i(P, e.startTime - t1);
                    }
                }
            }
            function z(t1, n) {
                L = !1, O && (O = !1, r()), D = !0;
                var a = N;
                try {
                    for(R(n), C = w(S); null !== C && (!(C.expirationTime > n) || t1 && !e.unstable_shouldYield());){
                        var s = C.callback;
                        if ("function" == typeof s) {
                            C.callback = null, N = C.priorityLevel;
                            var o = s(C.expirationTime <= n);
                            n = e.unstable_now(), "function" == typeof o ? C.callback = o : C === w(S) && _(S), R(n);
                        } else _(S);
                        C = w(S);
                    }
                    if (null !== C) var l = !0;
                    else {
                        var c = w(T);
                        null !== c && i(P, c.startTime - n), l = !1;
                    }
                    return l;
                } finally{
                    C = null, N = a, D = !1;
                }
            }
            var U = a;
            e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(t1) {
                t1.callback = null;
            }, e.unstable_continueExecution = function() {
                L || D || (L = !0, n(z));
            }, e.unstable_getCurrentPriorityLevel = function() {
                return N;
            }, e.unstable_getFirstCallbackNode = function() {
                return w(S);
            }, e.unstable_next = function(t1) {
                switch(N){
                    case 1:
                    case 2:
                    case 3:
                        var e = 3;
                        break;
                    default:
                        e = N;
                }
                var n = N;
                N = e;
                try {
                    return t1();
                } finally{
                    N = n;
                }
            }, e.unstable_pauseExecution = function() {}, e.unstable_requestPaint = U, e.unstable_runWithPriority = function(t1, e) {
                switch(t1){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        t1 = 3;
                }
                var n = N;
                N = t1;
                try {
                    return e();
                } finally{
                    N = n;
                }
            }, e.unstable_scheduleCallback = function(t1, a, s) {
                var o = e.unstable_now();
                switch(s = "object" == typeof s && null !== s && "number" == typeof (s = s.delay) && 0 < s ? o + s : o, t1){
                    case 1:
                        var l = -1;
                        break;
                    case 2:
                        l = 250;
                        break;
                    case 5:
                        l = 1073741823;
                        break;
                    case 4:
                        l = 1e4;
                        break;
                    default:
                        l = 5e3;
                }
                return t1 = {
                    id: I++,
                    callback: a,
                    priorityLevel: t1,
                    startTime: s,
                    expirationTime: l = s + l,
                    sortIndex: -1
                }, s > o ? (t1.sortIndex = s, x(T, t1), null === w(S) && t1 === w(T) && (O ? r() : O = !0, i(P, s - o))) : (t1.sortIndex = l, x(S, t1), L || D || (L = !0, n(z))), t1;
            }, e.unstable_wrapCallback = function(t1) {
                var e = N;
                return function() {
                    var n = N;
                    N = e;
                    try {
                        return t1.apply(this, arguments);
                    } finally{
                        N = n;
                    }
                };
            };
        },
        982: (t1, e, n)=>{
            "use strict";
            t1.exports = n(463);
        },
        72: (t1)=>{
            "use strict";
            var e = [];
            function n(t1) {
                for(var n = -1, i = 0; i < e.length; i++)if (e[i].identifier === t1) {
                    n = i;
                    break;
                }
                return n;
            }
            function i(t1, i) {
                for(var a = {}, s = [], o = 0; o < t1.length; o++){
                    var l = t1[o], c = i.base ? l[0] + i.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                    a[c] = u + 1;
                    var d = n(h), p = {
                        css: l[1],
                        media: l[2],
                        sourceMap: l[3],
                        supports: l[4],
                        layer: l[5]
                    };
                    if (-1 !== d) e[d].references++, e[d].updater(p);
                    else {
                        var f = r(p, i);
                        i.byIndex = o, e.splice(o, 0, {
                            identifier: h,
                            updater: f,
                            references: 1
                        });
                    }
                    s.push(h);
                }
                return s;
            }
            function r(t1, e) {
                var n = e.domAPI(e);
                return n.update(t1), function(e) {
                    if (e) {
                        if (e.css === t1.css && e.media === t1.media && e.sourceMap === t1.sourceMap && e.supports === t1.supports && e.layer === t1.layer) return;
                        n.update(t1 = e);
                    } else n.remove();
                };
            }
            t1.exports = function(t1, r) {
                var a = i(t1 = t1 || [], r = r || {});
                return function(t1) {
                    t1 = t1 || [];
                    for(var s = 0; s < a.length; s++){
                        var o = n(a[s]);
                        e[o].references--;
                    }
                    for(var l = i(t1, r), c = 0; c < a.length; c++){
                        var u = n(a[c]);
                        0 === e[u].references && (e[u].updater(), e.splice(u, 1));
                    }
                    a = l;
                };
            };
        },
        659: (t1)=>{
            "use strict";
            var e = {};
            t1.exports = function(t1, n) {
                var i = function(t1) {
                    if (void 0 === e[t1]) {
                        var n = document.querySelector(t1);
                        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                            n = n.contentDocument.head;
                        } catch (t1) {
                            n = null;
                        }
                        e[t1] = n;
                    }
                    return e[t1];
                }(t1);
                if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                i.appendChild(n);
            };
        },
        159: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = document.createElement("style");
                return t1.setAttributes(e, t1.attributes), t1.insert(e, t1.options), e;
            };
        },
        56: (t1, e, n)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = n.nc;
                e && t1.setAttribute("nonce", e);
            };
        },
        825: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                if ("undefined" == typeof document) return {
                    update: function() {},
                    remove: function() {}
                };
                var e = t1.insertStyleElement(t1);
                return {
                    update: function(n) {
                        !function(t1, e, n) {
                            var i = "";
                            n.supports && (i += "@supports (".concat(n.supports, ") {")), n.media && (i += "@media ".concat(n.media, " {"));
                            var r = void 0 !== n.layer;
                            r && (i += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), i += n.css, r && (i += "}"), n.media && (i += "}"), n.supports && (i += "}");
                            var a = n.sourceMap;
                            a && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleTagTransform(i, t1, e.options);
                        }(e, t1, n);
                    },
                    remove: function() {
                        !function(t1) {
                            if (null === t1.parentNode) return !1;
                            t1.parentNode.removeChild(t1);
                        }(e);
                    }
                };
            };
        },
        113: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                if (e.styleSheet) e.styleSheet.cssText = t1;
                else {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(t1));
                }
            };
        },
        232: function(t1, e, n) {
            var i;
            !function(r, a) {
                "use strict";
                var s = "function", o = "undefined", l = "object", c = "string", u = "major", h = "model", d = "name", p = "type", f = "vendor", m = "version", g = "architecture", A = "console", v = "mobile", y = "tablet", M = "smarttv", b = "wearable", x = "embedded", w = "Amazon", _ = "Apple", E = "ASUS", S = "BlackBerry", T = "Browser", I = "Chrome", C = "Firefox", N = "Google", D = "Huawei", L = "LG", O = "Microsoft", R = "Motorola", P = "Opera", z = "Samsung", U = "Sharp", k = "Sony", B = "Xiaomi", j = "Zebra", F = "Facebook", H = "Chromium OS", V = "Mac OS", Q = function(t1) {
                    for(var e = {}, n = 0; n < t1.length; n++)e[t1[n].toUpperCase()] = t1[n];
                    return e;
                }, G = function(t1, e) {
                    return typeof t1 === c && -1 !== W(e).indexOf(W(t1));
                }, W = function(t1) {
                    return t1.toLowerCase();
                }, X = function(t1, e) {
                    if (typeof t1 === c) return t1 = t1.replace(/^\s\s*/, ""), typeof e === o ? t1 : t1.substring(0, 500);
                }, Y = function(t1, e) {
                    for(var n, i, r, o, c, u, h = 0; h < e.length && !c;){
                        var d = e[h], p = e[h + 1];
                        for(n = i = 0; n < d.length && !c && d[n];)if (c = d[n++].exec(t1)) for(r = 0; r < p.length; r++)u = c[++i], typeof (o = p[r]) === l && o.length > 0 ? 2 === o.length ? typeof o[1] == s ? this[o[0]] = o[1].call(this, u) : this[o[0]] = o[1] : 3 === o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? this[o[0]] = u ? u.replace(o[1], o[2]) : a : this[o[0]] = u ? o[1].call(this, u, o[2]) : a : 4 === o.length && (this[o[0]] = u ? o[3].call(this, u.replace(o[1], o[2])) : a) : this[o] = u || a;
                        h += 2;
                    }
                }, Z = function(t1, e) {
                    for(var n in e)if (typeof e[n] === l && e[n].length > 0) {
                        for(var i = 0; i < e[n].length; i++)if (G(e[n][i], t1)) return "?" === n ? a : n;
                    } else if (G(e[n], t1)) return "?" === n ? a : n;
                    return t1;
                }, q = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, J = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                P + " Mini"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                P
                            ]
                        ],
                        [
                            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Baidu"
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                            /(heytap|ovi)browser\/([\d\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "UC" + T
                            ]
                        ],
                        [
                            /microm.+\bqbcore\/([\w\.]+)/i,
                            /\bqbcore\/([\w\.]+).+microm/i,
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            m,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /ya(?:search)?browser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /slbrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Smart Lenovo " + T
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure " + T
                            ],
                            m
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                C + " Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                P + " Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                P + " Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "MIUI " + T
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                C
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 " + T
                            ]
                        ],
                        [
                            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 " + T
                            ],
                            m
                        ],
                        [
                            /samsungbrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                z + " Internet"
                            ]
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            m
                        ],
                        [
                            /metasr[\/ ]?([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Sogou Explorer"
                            ]
                        ],
                        [
                            /(sogou)mo\w+\/([\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Sogou Mobile"
                            ],
                            m
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(lbbrowser)/i,
                            /\[(linkedin)app\]/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                F
                            ],
                            m
                        ],
                        [
                            /(Klarna)\/([\w\.]+)/i,
                            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(alipay)client\/([\w\.]+)/i,
                            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            m,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "TikTok"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            m,
                            [
                                d,
                                I + " Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                I + " WebView"
                            ],
                            m
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Android " + T
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            m,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                m,
                                Z,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            m
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            m,
                            [
                                d,
                                C + " Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i,
                            /panasonic;(viera)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(cobalt)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                m,
                                /master.|lts./,
                                ""
                            ]
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                g,
                                W
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                g,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                g,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                g,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                g,
                                /ower/,
                                "",
                                W
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                g,
                                W
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(macintosh);/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Vivo"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Realme"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Lenovo"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                "Nokia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                N
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                N
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                "Xperia Tablet"
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OnePlus"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                h,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            h,
                            f,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                S
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "HTC"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                        ],
                        [
                            f,
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Acer"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Meizu"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Ulefone"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(kobo)\s(ereader|touch)/i,
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Fairphone"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "AT&T"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Siemens"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "RCA"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Dell"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Verizon"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Barnes & Noble"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NuVision"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Zeki"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                f,
                                "Dragon Touch"
                            ],
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Insignia"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NextBook"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                f,
                                "Voice"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                f,
                                "LvTel"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            h,
                            [
                                f,
                                "Essential"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Envizen"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "MachSpeed"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Rotor"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                h,
                                /\./g,
                                " "
                            ],
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            f,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                h,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            f,
                            [
                                h,
                                _ + " TV"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                h,
                                I + "cast"
                            ],
                            [
                                f,
                                N
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+aft(\w+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i,
                            /(aquos-tv[\w ]+)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(bravia[\w ]+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(mitv-\w{5}) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /Hbbtv.*(technisat) (.*);/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                        ],
                        [
                            [
                                f,
                                X
                            ],
                            [
                                h,
                                X
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            h,
                            [
                                f,
                                N
                            ],
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /(quest( 2| pro)?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                F
                            ],
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(aeobc)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i,
                            /\b(libweb)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            m,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                        ],
                        [
                            d,
                            [
                                m,
                                Z,
                                q
                            ]
                        ],
                        [
                            /windows nt 6\.2; (arm)/i,
                            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                m,
                                Z,
                                q
                            ],
                            [
                                d,
                                "Windows"
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                m,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                V
                            ],
                            [
                                m,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                        ],
                        [
                            m,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            m,
                            [
                                d,
                                S
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                C + " OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "watchOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                I + "cast"
                            ]
                        ],
                        [
                            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                        ],
                        [
                            [
                                d,
                                H
                            ],
                            m
                        ],
                        [
                            /panasonic;(viera)/i,
                            /(netrange)mmh/i,
                            /(nettv)\/(\d+\.[\w\.]+)/i,
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            m
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            m
                        ]
                    ]
                }, K = function(t1, e) {
                    if (typeof t1 === l && (e = t1, t1 = a), !(this instanceof K)) return new K(t1, e).getResult();
                    var n = typeof r !== o && r.navigator ? r.navigator : a, i = t1 || (n && n.userAgent ? n.userAgent : ""), A = n && n.userAgentData ? n.userAgentData : a, M = e ? function(t1, e) {
                        var n = {};
                        for(var i in t1)e[i] && e[i].length % 2 == 0 ? n[i] = e[i].concat(t1[i]) : n[i] = t1[i];
                        return n;
                    }(J, e) : J, b = n && n.userAgent == i;
                    return this.getBrowser = function() {
                        var t1, e = {};
                        return e[d] = a, e[m] = a, Y.call(e, i, M.browser), e[u] = typeof (t1 = e[m]) === c ? t1.replace(/[^\d\.]/g, "").split(".")[0] : a, b && n && n.brave && typeof n.brave.isBrave == s && (e[d] = "Brave"), e;
                    }, this.getCPU = function() {
                        var t1 = {};
                        return t1[g] = a, Y.call(t1, i, M.cpu), t1;
                    }, this.getDevice = function() {
                        var t1 = {};
                        return t1[f] = a, t1[h] = a, t1[p] = a, Y.call(t1, i, M.device), b && !t1[p] && A && A.mobile && (t1[p] = v), b && "Macintosh" == t1[h] && n && typeof n.standalone !== o && n.maxTouchPoints && n.maxTouchPoints > 2 && (t1[h] = "iPad", t1[p] = y), t1;
                    }, this.getEngine = function() {
                        var t1 = {};
                        return t1[d] = a, t1[m] = a, Y.call(t1, i, M.engine), t1;
                    }, this.getOS = function() {
                        var t1 = {};
                        return t1[d] = a, t1[m] = a, Y.call(t1, i, M.os), b && !t1[d] && A && "Unknown" != A.platform && (t1[d] = A.platform.replace(/chrome os/i, H).replace(/macos/i, V)), t1;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return i;
                    }, this.setUA = function(t1) {
                        return i = typeof t1 === c && t1.length > 500 ? X(t1, 500) : t1, this;
                    }, this.setUA(i), this;
                };
                K.VERSION = "1.0.37", K.BROWSER = Q([
                    d,
                    m,
                    u
                ]), K.CPU = Q([
                    g
                ]), K.DEVICE = Q([
                    h,
                    f,
                    p,
                    A,
                    v,
                    M,
                    y,
                    b,
                    x
                ]), K.ENGINE = K.OS = Q([
                    d,
                    m
                ]), typeof e !== o ? (t1.exports && (e = t1.exports = K), e.UAParser = K) : n.amdO ? (i = (function() {
                    return K;
                }).call(e, n, e, t1)) === a || (t1.exports = i) : typeof r !== o && (r.UAParser = K);
                var $ = typeof r !== o && (r.jQuery || r.Zepto);
                if ($ && !$.ua) {
                    var tt = new K;
                    $.ua = tt.getResult(), $.ua.get = function() {
                        return tt.getUA();
                    }, $.ua.set = function(t1) {
                        tt.setUA(t1);
                        var e = tt.getResult();
                        for(var n in e)$.ua[n] = e[n];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        964: (t1)=>{
            function e(t1, e, n) {
                t1.addEventListener("wheel", e, n);
            }
            t1.exports = e, t1.exports.addWheelListener = e, t1.exports.removeWheelListener = function(t1, e, n) {
                t1.removeEventListener("wheel", e, n);
            };
        },
        709: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        877: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        907: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        67: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,d09GMgABAAAAABuUAA4AAAAAMkgAABs5AAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHDYGYD9TVEFURACCDBEICtQ8wH0Lgg4AATYCJAOCDgQgBYRsByAMBxuFJqOilpNajCj++kA7wvK7YEaReNQWNIvS05pd7aptbjUOmon1b/Hd9x+7ghJPgfFNNB815fHQFFBGF9AxQpJZiGqN7NmbfSJWhBxUsWHNIBSCAgCXin8X4OH5bfbQYTWRNmgjLYLE5xMCigGiGBhgDysW5+ruFu1KN9e6FG+6MFZxc65aN3UX7dXW+v/p/BwSvblPY/ioDRBXOdslFZnoL7M8jdzK6YihWwKef/927v+1tQWYQqBtQRKQpNB7W3WVfHtOGGhl9dS+DkKu1jQl8i5TG1vhX7jqZ7gQ8O5tA8Bj9weHHJgnHhi9efb/m/Z7O5ehtSocByUREpU3sxsyuS/vTAqczIbWEtoWWltKqQ6F5CDU29BKU6CaRaGQTThTf6nuC6m/mumQs7sYplGD44Mn+3tnE/GUYYXgge7v3j1MBPAgCcW82vrhEsh3y/sjBD21Vw8Q9BZ8PkMQALixqvlfJ1Z9OkZAgj1iGQCJvctxXrIMxtXc2cBU8jhiwznpQMCU+JBt+i8CoM/LZMZBnOxA0GJ7FkAcxFlzgsGgCUmabdPC7ScC/2rpBT0RFL+OAfEzN20c1DLiX8xbzo4OJwZgd3Xm8eNqvNijjmiy5mqdduiE7tb++KOWGMWjKZqn9dqpu9Q2KvADwB9H/J5T4698fDAp5ioCAMOwlRJuliVg8GsdyChHrjxBgoUwaVcgVCGKIsWozMKEi2CRL1KJUmXKVahUJcp8VtU4uOLx1EjAJ1ArkZCIWB2Jeg0gjaSaLNEsRQutVm0WWChVmnSLLLVYBgTyXw6AnQCIF7AD8DwD8LsAkGWAjDqOoZZ/BqPf6ePeZMFnK3eYVi4TJsUyEC5x0dCVOkyL5k1U/H+w66U63gIS8sIiyh/ry5x7FMBl7G64oepiPLBwbUq1K5BlV2SP4zJjMoBMGF/BfNNDd7pVdwXqbpGXnqYrL0OGSt1Vjau6h67JFtwD2WXOhTWKh+PLGHF8VZricqD/wFXZa+YjD9zsVt1Ncqcoyww/cV+t5rs8pWPcb4+H1s3JukQ44+ES5/LHc2BMtfrB+EXOkPP/6MsiFOBlwCjQ9sJ4ZNPj/NvrKbk/N9NrHOWMjDoVkrUwR18RV3zxa34Jw8+NZfNBFIOcCzg6gYLgmUmm2slKXj1l1D0Mgu0iAjZecAhRRUQsfVhIkuFcNfCNaqszMdb06Hae7sSmRmdH+8v00dCOB4pJMPCyJ+74pBJ9Pu5MTq3nuhYFqC5k+1KX220SVM7vp+2izcIHi1PSNnagDQNDxeNH8bImOObEj7B9G+/czjt2osryC456pscE4Fk5wHtUtgoCmwFQaHXNhfY5oHm83LlzNZzVA3kSrHhp4AzhaU5W6y8108o9zqWLCdsuuDKJM0GFd2l+FAk2VvS3FNVhaivMe5DByo2XVQy6XQu13HHrKP1+0xUtb+MW5wgTVwmuPDgRkLRAnmjjrDeKImWyhIBUMVgwyxja9zXrj4eubtdps+HB+4vDHWZfueOR/PTq2BMuJBRRUXCGnObO92b6d4GzM44yEUX2rWH+uIRLHU+edigC25chyTQ2XNfOT88Rlfvd57d5TpUxRQQMGq0R8sZLzMsOrFyxxvdL6mGz79itngpXZBtW7vw5H6nA0hAF5uUJkeXPniyAcey0Y/teVnJO6v5acsw8iHjnsz1WguWl+MFP66Uyzz9YTLxgbnZIvry/9Q0xjPzgxeS+YNaZTeewb5hzLLdrHDylnR0eVcUS604reVqxFVXJ1THTsADVdEWVHYghIxF2h8/fI2Wy3iQMbGzlkbPsI3H8w3w27sDIsq0Pxg/IqI3gMFg3pclcEr5XirWrwEnOX/hn2udMc9gjRoJdXmYp0iZjzvyKwcE1UT6mJB28BSqACZD9HFrt1LRvQ3yrueFouTTk6RgDhQ43wvAYj62xQd90LiEq53h6j31+6jg8Sxbd4hVdMUiKjd4Pbh42veBlO1F5TI7+WIScfcjeVwavFY2KaoUj6Vhf6iOMl5wMx9z+PnZz/qSEgG2BN+iulyZOm90t5FXFY0owGAzzH+mMQQ0V9H7H8FjmdWXGHwsiiY76090IG7MrVgxjRrMxMtTHFev/GDlkfmSv3ZW0uqI6yMd/JY3F9ltx3o4rauysi7lfpqQg2AlFnv8mdSjzB1TnExRQbgNbSEjDuVeKGB2kerJeHkeRYvQ1nLjNHmXuzDn7GHN/vNNucZRnFVoOlW5xvJSe2Ll2kYhDNs/P41/rRRWtVSxpykICs1yRYSJUe+nHXyYJJ4Zhu51vfZEFUsYtGGlJm6IrKsYnBVmJOWrTkLVzUhBVOnn/xd20rcGbZBBRl0d9dEiToh66A+5bZXV4snbLxnRMh3XLnoRLlWKnJSeRq7mVJNX0umuUJG5bgJh3Gk4ObiY9tYk0HaF9RaX8MBALUKHpWt+u0iWHfHCEff/B0I6NTVBPoNBRsiKsd5qNZ7IRnq0xjdVVrBPzPbiGOt8Ionvh+ZdbSePb6JJ9+flK6RiHbxQhRCTJea9R4heM+iqrC4aKIjaZIbxISIyWlV+tx1wHGEmMSAVvdg9kG5petjF39oAVbPZpxfIoPJwg3hJrSZpXTVRXcN9zJ1yFk2i68HES2r4Fv1V0Vfu3ofxahlM3jZwH8iSfDYg2XvsbGlX/guXaQTrjGgw1KwhrquZgmpFuc0rblrPqRIfHRyp+ihXakKxRGiEhKOG96NMmyfNcDs3kiI32ielSEzX+JRwVA95ix7NL8GnvMEnafwq+G+aceZD6cwmYnyeMJmbleL3iZUBpxPTFBa/aIZaDdS9gt1rOnfzU9vuupHk4rER9OkxDrQXaJS7p7NpLGDXUcGACdAKPuEXMmCCED6DShMldkbs05ymcUm6j3AfEnxpzn7Q8hXE3uJGwwjDj2MjXmtGhpCXTrHb7KeMj2V5LiKO/Ze42GmSip8wEwW/AkZtML+bLvefj3JFuY63YwPZTDs0icuwc+hl9lryQy1KzviNJq0I7sJ2EXRxyfx2f2eNYg1pT5OWqFWuHmjlLy4gNI8G2ORLawnSx0j+2YTZjQLtv8zmW5Pltl3eXcYiW59czBHJfhOZa03BUPRBbkjqkNCntYmzTz977Yhx260hHDmM1cbEBqg/X9ATOh/JFdyBQTJgwo8VREXjxihcFxL+AvOA6zl4cnPv775kETrjEZ1+7+R7d55vMqyLX+bdcuIavF64JTDQETJ4nF9iLsM41qkFxojhxCGpOXR12QBxV0u6fRoAIuwyX88g9RJgE6+uab26Lya4dlkACSKDtAyL6ogm99fSbewBpezg93Amk7yFa16XDxNcL09TVBNxQtmnUr6ippCnir8RpwAi1zTLIhnPnUkJo/HT/9TxfDRMPquU9IvbbE5z5pQOQRCARqA+DEuA7C5i6El2y/6Won5caCn5a2t+JB0gb/hggXbHlAqTNrs91zeGcVWebXHv77OhXPrcrCMi/q3pQFNIXpPQXGSoO9GyMyEhfE75iq8FKlvorAo6YHmQT9xCk5CRj4/aedZE67UrKxrdFTYFyf3lgL5HxiO1SdOhhTAbhIIyJiJLier6P0O/f7ljAesR1Mu+4FpNOWDJNDZeg9uHjMt4MuRSDY6inTecgiC9JUBwoLFMckQgg/jlp098AacN9uPeUnxl65zwxkxFF1I5PZAbzgcrv5pstb4Zv4m8Cqv3BL86KbXf3vVQ7e7t4K5C2/W4SiMOXf1uomsw7efDaiYne2MKqXvau4/w2GE3y9KL/G0VPwq5oWEARdTafjvgJjoJXZss4jXj8yth0RqaPSDhcqr7/5Th1r5AmIoWevXrFiBWvHRrYdvu23Bds9935poWZtLLj83ZBGq8gWJsSmewusp840iS+nAgL4ZPqhppzqbASVmrGFoRVJZ9VwArZzVTkpRlLGzA84q+JQl/fTNVNjGsCgHs9b5rZwJyqnQo1RPkFWCTQgZAkfZpYrE9LCjkggSzAl8mb9q5mkqTLNsu8w1y+SjXt/879dR0O3CjGVx2K3btHsKMyPdJPpE9XdD+7pAwdsFBQTdB1sVKkPJvW2jKaJoJG/SZU46t2n0WsHE1vbR1Jn2qhVNRKlATXMDKSyUgUKjlylGRIUFJc45F+TYHQYAzj9ytY343+ErKhypyNZlt2prOUTAX7RiOqjf09S8GS70wuoev96JO8bOcyRL83CsI0dnWlMRJCz1YtUt64/LxsZ8WCoIS0uMOd2EbArAnHfbuuW+vDjs7wtrfbFeksES2Zmh4StlpP0D7+Km1WJEurr13tiSvwhJwz8V91c7HY8vwalS+Dn0H6xodMQKvEiyd+P8GsqTzCGh0VtkBwYllTcxc3zyfJvYAwed4M2n78OTWyzKeJEv1/wbuCqCZKuU8k4AxktHJ6e7n52KCMF4z/28IqSFVvW2jE/W7CxkFHDCYs0EviHXg//hDgzPTZ0HRHNAjuuDqEfuKHBvw3e2/gX83awRQqbId4lV0Xx1RcObkwIiU5yKuDmBF4dehYallCAjpiMVUKPr/jSQZbJefzO2IzkhQCwTUBt3retLRBOrVpim0A/j/gNuQfvJkPoIGxmeOhrsaA/I7jD+561xigS3+7jL1sdunVJcB8mWS0tlpymg8lSHvTzS6j2FGzS08GX5oglZyurpWMfPhywz06po+UWHbAJAovg1vE4dVLCMVLRBCp9ETlI4X0rVWGCq0H0mVjM+EzsWO4yv4NfqxUwqHfyJk8f0eYSJJTROD+kj6F0Ri9VVsj6/lfxB5gWTE+d9uAIo4A72hQ3q0/skjxgtyIL+4B683+T6afEOpiukdGkkjRkjz/uVdXFc4TY51r1YNQ4rOn85JF9ed0UPKJkl6vIqxWTEo10uTLGQvryx5JeQK0QVvO/Gi7ZFrwUMOKlBsdeje/KRw7GyOf4XOqSM2OSpZ9evTKb8ZmDWtkZDLzWKlFaSeNvJ4GzykX+k1gkE9mbJxXNsKuLBQDjAjLMcu77LVwDIl11GJhHSZHr4WzHR1mS4+VInb96EjdSgv00cfQvDK9vUuonmD95rEZu5mbx3CrHc6HF9djM2UoBeMy7nIlvGvm3F5mgb3J0zEPODz8CiBtRaWEUi3S8eNd4wAKmRd9vf8+zi66DsF8KV95uNSi7JHyYN510aL9bOx+iSnI/Qs5NTaOnPkXMIVK9gN41kKVV4zfpqb7zDNyHTNQS/9CKyHdY3ak/HcL1eIzcxFjPfZLQjW11UPT6l4A85C5IM5H9XVShGeww7OPKYssESX/l0Qvt1AmD3kWOYStTeKq/lcBzabqvG41XcU4RytsGeMq2QpWWrclObbt5S1N9J/ydPH1a2Qj3aLaIWXCjCvMlrIhrowpY6ZtNeEiQqC3P+pwdHEe+eefSTJq4JPH7tKod3+n+V1+cdk3bvYHWUBrNjqJFhWcFBlpJkvic8l4fIg8AtB1Ntz9vXtxAGnD4e7v2YMHSBuQ/mfLR773QKT5xrrmb0CKWXGBU7LiDmVcWmNI0Vi9a6qAYq/zmIeKHsODPBdsJVpuaI91eiet2BFQ3EX3PkFSZ39+Y0fzv4wf7QvasEHuS6Povbe6IL04f56vcPR2JGvuFvyfDb9PU+tGjZOjF7Sh85VXcFcWSgae3jjOrgyt99BE4gGaZfPxComa1nt85bjz+DMvpj2eh/Dlt99dE/t7/PTj49rGQeHTp8LdpgJh99Mng4mNWYrwLG6y/6o2tCoqBq1ZsDo5gJsF0AyT1vBMTtFWYXw8c6oArevHt6v4xuhp0yX7YCb7FTH+3c9vuk6/W67aWxN7yTEAd38LHh8wm9r3enaFCdM4u0blkFQEiUYg68LrqTI1rFK9WB27SjMBq589XUxraD6vheA3XHGmDDdPQiibmc4LFcTnRLp9Dlploi6eXkw1h6wiEAuofIY+dPof/xIgu/txaJd0Qpx4pi5crqyj7WaL4h93fJXV9h4gbe9zsgqWRl6NFEWI2yUZae3cx0wR+w4o/ax2Ljl3uzOAoOo751yi/qxytpzrUxECOm+fc7aA96b9oX/UdoUtZcEsZXeZnvltyGFJTCFvQ7Q3//XpQToh+eZvBWRo5PSIxET8dJOYCiIYX5h5vhu1MG3OXcmqMJuLY8bMvutYPz2OqEt/TW5Zu0uDyp6POdGQWORLb/dSe8Jee3MFzZLvRUqRciS9tWVEI5IKpZLRalRlwql4KF7Sq977SpgZdeAgtpiLEmArenr00YnCzOieHkyFAMXFFB88oI8CKx3L9lIaG3h1mkiSZvKlLmZ1/xoRxfKHvypSnVhzYKA3pOwCqnE2+nUA+R2OiEuMnoiY3ff8SJzMMyUaS8SF8vkv1wMo2DC1j4cygPWT1X7BjtI1UjvfoB1GH2QVwuhwwEPsIeYbWiYQy36pFUyjUla5yz0PAtrd7Qu34aakj/7FtW2L3D67PbxtG/bJh1eJfgu2MbtvJagRZukWw2HScBvVaB2KhMKhcHWzhkPJEm+RBK8mbUwXUVOjNbKGtyLKYNj8wmNR70URSa0aFPHj7bNqz2i2GvVVTQ4Gg4l9Vt3hswk7dmYMP01HOvw18TMe37f3uzQ0h61DXbjwBx7Qi3lb+r9D89DXRwOCzaTN1Udpq53ygnau33X5SnYAaICXcYsG0oIiXKFvyaJwViBi5u7mvZo4zWtqu3Ny7rwS7q8UAwaYkjr+yOb9r+5UDe/ONv7PywEJPMzJzScxPMz+zfsBn3eJhzF0GIAq2Dipm9xpxBgBm4Iys20smAnvMBX57cBtL/LtMrFk4nP6zfdhnH6mrGR2mop9z+PON9/EhPGqsPudmlE0bwMFtbrOXNeFpnhlqaSoOO9sCvtYbWndUTbF2wAcN/N4MWKEL3lXDsbYZAQFPMwnhoX+j9g+OEHnMziIV7Az0BmVcKc4TkQfpjUwKl3icwHaj+fBi+J5GJcbHZQCqAfdaXvEr33J1Tlvnopwf/k+zmIrt12l4DZXtu2LK1/1bcBTR+w3qyJPBnp/QGG/+ASdilwFKk63O/Pohes4c3/e7nj20W2/f1rHLPzhNA/H+/9teIz64VULHjv/4j15TDjovlWJ5lGrjrD6dgmWaLSCZd3HjzCrvCa846SotDQ6kSBMTTPziYCQE1VCHcVmIxgk4uMSiGDc+50+TEhPIZ85Q5KFI03w9jc/HOeVL7uYIVIKFcKrteTaVylU9u78Jd2ywmO8f0TMpLUZyFD3K98lY4C+/kogL/BoOsij7fv422ppvmmNKhaKkcScqmisgLZdQaxkrdqUs1L+xx/0o3Zmx02NHGfLtWu3g4Im18jFwmnkPmw8HhQ8/qQA7MdDV/Sy+voSlyQXVXTmhf95iPiw9VMb+vr3+LSMdAkuBhCdot5BkBiEhRwc+Pkg+uDgwCBeG3fMm5strQE0FfbQIWI6Dwz5o2Qhf1ixeJbO/dljIgdK5krG7Cx9owmcbuL2hoauoevYJuKOf5trEWDtBlcTur6PoE8V2IQMQu6mjdrw+GgV+dAhghzjgMiHdlx9eCiheOGITqh8MlRA9PVKVI5mLMo9yJueVqxDpDugfh8cVGIAYz9vxa04ez1UgtHifmjAYBB/UUvWa6I150MXO2uSkaW8X60Gp6JOllbLWaFN4SwTJnZyjcjlZcSZf+xxAQj/eYFvZ/9+BWq27cHwMENtQ8H5m1gBAawVWi1reWzsJla+Wz5mD7rLLfDR1L0LRNLl+zNPAt3ALQ/6B1w60Z2bBzb31+4cBo6sPBI0ZAN6neE3ysjBlYY8X+YGVufxMLxMC9qi52GMHUBWP5aOsZ4eJmbD/xhIqIRBQjJ/ay9RheemirO3xHqlVq//nB7djoX18IrA0B1cDkoS9igMBXE5h0NDDnO46X6X/XPRixAhTvf1wBpa9biLOLg8K8zDI8xQoRuXFsYWghBdjk528e/+EXjBV3B7rf+fET3g1Cyg+osePdLjuMJSgiY3PBch9rNmHJJxU8UPJVbrMBNiQHT1ZlO2ZOOZ6z3pRUTYZ35kedTN7t0HUFSy5MljPZ4ryA747SU51cunULUPSoB4I+La+cNcKVPK1HTkRPto7ShsSZSYfVSTh9P4ldLcPuMhUHED0rNWd/rWC8mJfnVdq3Usif9L4xe6DpSV/8Ui7bJ7eZrM0r+aB8bZwB4L3i4BAuA4sAFTtzjIOxjpLkJ4iLw3IYMxRYuXDFzrRfcCOwqYB4SIQDb3KRmMkmJWQCNCa+cAQgAr56DuydwBRFrGznvLiUXlIzSMRoWrIACxxYYSjGqKl1+jYSyOgDaaeyS/pQkNKOEVE2qppqBXUqYpOq4gIKH9JCPTGq3TJVwEUk+V3ScSGq9WGjxAF2ilLMH2Q3BapYlqReUhFD101V2BW6vluYakWxHPaokjK+dZS41QTmBCfPufsvbO+bGbkGczTKkjBaw5tUpwRIMLdV2RNtsx1q5m1BS2iusC7YV/jXyB3RzmYcQFRFhjb8UOgTWQAJugFKythI6RYLEwAdpA2qt2bqYNeVm0gBw6YG2vKXOY+jTZuwhwDsSwKsiA+6LOHaq0nWpAKeMSltpvoEREMQ03lMkMBcksa/h04ZEVxBnhTI3sqnWtCuwbraATj2nYZL+4JuOG7WuTbltvFFxuXPEDbt76i1HVXMMtL67WZy2i9xAQMbG937PKzHbp13h349TqTt5hN/Bpwvwn5P/QQe42DQJ3DAACfxiR+tRSsVaw5/lTQ8Y/cIAo7VJs0uYCq3aLaXUgIKtT7bFJJTZolYWZo7JIksWd+68Wa7QQ85ePwoiqylLRfcmsqOxYa6dUqRiSLBUgo5+qs9I6gYLUarFckBotWuTiaLFAuhRcRVayYtP0uAooxn6vxTYdmmy1yRpZLugstha0MwPWzGy1WButlixSYImX2DJWDZhIr7ZOq8fIMWk5JiuDvb9AYRDATv3QvobEDJ2nKS8O3M+l7sBFYNlOCDHQzuDGo3YORe61U+Li0s4SkZR2LsSksq0PvRnvRsBLzoNnuduWnxQ2buiPm1iQGUGtsj/FxNULQEcTh4V9EQezSLOKQgX1GgMNzr9XWrVZlBuxiF2JNUCUFlWrjmIYX1Wvmime2GdQogwWNigU4w2sqt4Ja8gtUcnMIqNVvTqxC0i3qharE66TkGD2SsUYYtDOrRLIpewol8CoL0qix4tnpA4K9MxmYdn75QIkLQl3HYPEApvOYYwC1QWLEMYYxESJRVUqGyiz+YJmDAqpKUFgydJ1EI0ue2gms8eEUlkF7JiMPVY9de059dv/KAYQsq9mrhWzBgAAAA==";
        },
        356: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,d09GRgABAAAAADwYAA4AAAAAV+wAAQABAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABRAAAADYAAAA2kw2CBE9TLzIAAAF8AAAAVQAAAGB0OVF0U1RBVAAAAdQAAAA3AAAAROOEzChjbWFwAAACDAAAAXkAAAI2OPA88mdhc3AAAAOIAAAACAAAAAgAAAAQZ2x5ZgAAA5AAADPLAABNJINPyMNoZWFkAAA3XAAAADYAAAA2ATWcDmhoZWEAADeUAAAAHwAAACQKsQEqaG10eAAAN7QAAAEyAAABwmVfW9psb2NhAAA46AAAAbcAAAHCMiIgPG1heHAAADqgAAAAHAAAACAA/wE6bmFtZQAAOrwAAAE8AAACkkJUZWJwb3N0AAA7+AAAABYAAAAg/20AZXByZXAAADwQAAAABwAAAAdoBoyFAAEAAAAKACQAJgAEREZMVAAeY3lybAAiZ3JlawAibGF0bgAiAAAAAAAIAAAAAAAAAAD//wAAAAB42mNgYTnL8IuBlYGBdRarMQMDozyEZr7IkMbEAAacEKqBgUEdSHkDsQKI7+7v787gwMD7/y9H0t+rDAwcSUzaCgyM8/0ZGRhYrFg3gNUxAgCVBA5mAAAAeNodxAEGgEAUBcB5vxCFoiN0sYiKAEvXjwYjYlBY/zf1nlcL7rY/GUVvFsjkQCcqCwgfrdoEWgB42pXMA6xYWQBF0fU5tn2H4di1bdu2bdu2bdu2gvrFTu32M6zbw3AjFnH4MHVj0j8+9jvkkk2CeG/51f+yqaCaDrpIjvk9pmTsptg9sWdiz4XY8Fp4I3wYPg9fh+/CT+HPkCHkCq3Com+/++797z5KSk5+kJyMtwS/ySC7iqrraFoqpcQjlA/Cp+HLdMof4f8nUHYhkeTtJG+E5FlJt5O+T0p4cOPB5ehUdCQ6HBWNikSFo8zRv1GGKGPq145+uVj7Qu0LDWLOuSgGOVAF9dBMGy+vGKXVNkAxPQxUSxNN9ddGedVV0FVFlXTSUWdlDdJMN80NVc1+LfTU0jDnlVFcCaWU1MtgR/SW0wldXNDHYf20k10OB5w0RBXHZJPLKXnkllc5oww3whgjjZbPWBONM94E00w2xVSTTDfbDDPNNUt7cyw0z3wLLFJYUcsstsQKSy2X30prrbLaGhuts94GhWyyzWZb7LBVB9vtsdMuu+1VxL4UZjaQ2QAAAAABAAH//wAPeNqtfAV8G0f28M7syg6aZEm2Bba0YpZWuyuwLEtmZo4dO9g4jA22aThNkzQpc69w0Os11PZSZm7TY+j1eoXj4mHbxFp/byVFkS/N9/tTslJWb97MvHk0M+/NhMDEZoKg1kiOE9nEDIJAUgbRiJHyCJHfP+wX6AqB9h/KRwakR6eEFsnxs+3oFEdum9hJkMSvoWYt1FQSViJAEIyW43iOM/mMJqPRZEr8YJM/tFKtXK6Qy2XyrOysrGxtfn7qd2Hi96/R8323h4JVyG2xrqpE/JC2jG6ORO7tE25k0Y21OxhvBSpnmH1NwlrENh72+6sjPnZfAw74fEfnVK93OityJLKA2bQoOnqN0+FA8VJsN1s2NLVfabd7EH4br0d6g/Hy7s71RpMBEYg4PPkxFZS8RERgxHSWSINJB4QmHhYITz0iiQomAQaU1CMDWOJh5CIWFWRzKrzMoZHmjU5XTCYvRKhQLqtyOjc1DR9kmEgOO7MuFLpvUfcen6+5uLgIoaLi4ibWt6d78b2hUB16uucmvz+KfHb7umjlvsp3I/uilevsNgahqN9/Y/foA5FIA0K8y3VFbd1Nde/U31BXd4XL5UeNlZEHQHqvggx6QQYywpaWgMh31nh+PFpFktfiI0uPQvsqWtFzXXn5cFkZjXRlZcPl5df1CEd9KBha6mhYpleXIaRRqbs5bler8DL2OeybamtvbzvZdntt7SaH3Yc5rC42X9UcPdzwSP3ByuhKi8WNgbPvAj0yoGcmcJbV5mtTH/LR+BBJTbxCBiYm8E84vIY7287h2wGJ+CPU0EKN6RdqMPnki/FeMnviJR9+0483ADJ+U8TdO/kJxUteJKoIwkBqZdr8pOyMF8mO8WbIjtZdJDuFNyE7HgkxdLVuyOdb4WvZ5vHWFxWJAlIoat2uTY3dexhvdT47qzlUfsdw516Way9RKhFSqZSdPH+gJ7w1GFx8O/qKF/ptgfz8HIS8NuvaaOWBqi8qd0cqVgBHOLd7V+vgTX6+wudwbKyuua7+s6ab6+q2Op0cKpDJqsQxnYTxq5Ic0+bT+eKHgW9KxUxMMAxJSY7H+/F3gQM/iTtF/J8RBHk2iS8FDmhlSR7/DK0UjpBGYSfaJjnuP/s0x0lifhF/2+Qn5F8TVgrWnZJ/gll0UosTnODzyVMI+73ea3p7Dni8AYrPigYCd4zNuzsQqMSS4xMzuq7nQU2Rz+3e1z33Nt5f3hiJfGcu+W/o4Q8wgpugh1nQA2IQolF2YhDoM7yoKr4N9zTGf/prnw9PxClShw/F7/ojWQfjsYjU/R3q2qCuBCQqjp5FFp4McJLNoB9i+eOp8hz4IbZJQgck/EsjNL2NQ2jYizZhrls4LLom/CK+ZWITeSQ+HC8HmpdD/YehvjKpXcBZqdgGiSilSIyXwSJ3zx6TdJxtl3SffZAAezoEGlYBGmYgmqBH0YoupUJJxsFDpq2K1l1CEeGhKlBRUXGTj93TDa6AbSoSXQH4g2bWt7era6/P1wS650NSmSwGvqO5eZPoTWSiN5HJoi7nRoC4nCIEL32n7kZwAm4Xz7vcV9TBjyTA5eZ5t0sEIPrdyn3R6Dq7nWFEvxJN+hUA2BjGZl9XGd0HY03wfgHwJo8ohbFqpzhsYPFUH43MaM+cu0Oh6qpQ6O5hoZpDezoO+phQ2Oe7pg0vRiGOu3l09DY/H8YgiDvwbzHn9uzr7trldDFI7O1y4WtqDDhrJlr/C5xFPPnfYe4YUilVnbz/mp6ea3h/p1K0UyXYqZ8/2OPoNCCJ8cv6JXqaZpFCUVTv8V7R2nqFx9ugSJh7kaLe69kGEK+noUhRBAxuvAWM1OVkWadra13dLY3vJK3WxeblCJ+Deluuamv9AXK/W3UgGl1rtXk8ouFHD1S9W3V1NLrGZvV4rLY1ldED4rg/Ai4PAZcLCTphHyz6T0azUzmNX0BjvHBbbKXZ7KgJld89KKz3od62gz5fmHE4tjXilfEjOXh1SaPHs6V55BY+yfGVHP459rnce7oarnJ7gqIvvh10uQk43gD9FqZZmGn4aTISD+u7hOuE3+mHKqzx+w839N4UDDVNZ6n6cPVjC3vuqYy0dlRU3dVadW0w2FDn919d3bEPJr9pLAWT311D7XdEIu0IDdaEbqitORIKNaPhrsuNRoPD4dg9MHyUCZc7nc4DI3OvdrtjRYWcxbymq2W1waD3uVw724ZvZtmQw+7Y0794t8sclMkCVusm0TesAs7OF1cuiZlDpiWZfGr+xGz0Pgb/wXFn90g2A9Zx4IIGsNSiByEzVYmkyUxOUBofwj6P59DQ0GGPl024srDff89li+8J+EV/Yui+ozzcUB8uv6OH/M2EYexEVXV7e3XViTHoZTwl5WngZxjRA5oQjasq0DsBoVcuF3r94Gjea22V6AB3DHBvBNwCEVfKK6SMlCazTWTyCzV6P5UWfuz9i+cRjfp33g80qke91NPj4+dikuPnbn38cWrRuVtPn6YWiRzYDi2tTc220CliEg+NNwkDUfSKYK5AT6AnIoIZvRIl8/FdcT5ejJ+KV+E/4deg9iDU7kzSLNaWMvlQtUeor0IfIB/6MIIHyd6JTfFfYgu5V+ztMODnJ30pj0zAcKSAeQconngSCxO/Q+RVnKTbyJ49YedA708D31VUK8ESDeI4RYbnZ1q8ItOEZdqEYGSFGZ5VLpck5MQaEz9Tkz352wiaUYBwhOMOt9cdDoZaKI6sZpht5dVbXE4/Fv41eLqxaSTodm+NVm0PBMZoNE2oYBZbrD7UXFF7sgNN08wJBHdP5xbwWNNzlc1qM5vMG9pw9XwtrIVoelnDnUhjMF45VrfCYDDBZN/NMwsKSjWagUDbYq2xCE8SlfO0Wq1o2+/DGNVZBFh21cU+LTEJslPnCtN/urP8/3BkapgB5FUu17Y2dqHD0azkOFWby7nA07rF7aoC78+j3PyCgNmyopZb5nI1SQtqnI4V5XXLrRZ/QX4elsoqd4bDy8wmp7pE2ezEV5wl7rZVgc9zmc3LwuGd3TL/Op6fZzDY1Gp1D49nBcdo2mjTG+bx/HpRxqdgRLkgNQbm4ySF7CUXVLLMsSWX0XjDZTe4PU6EnB739YsbtrldwSwuO8ZxR3rWfJf38wjxfv/31rQd5rnaady0cpd7i66ruvqhYevQsZrqLqfVdnlDzwGvh5vT1PzCIuvi55ua57gdjqs6QBhGI4FFayY/BY4rxPWu9IK+yBjgdtpfXfBk+ec5fdzpYe5dP/ZCgOO4J8a33O91OPx6i+3Q8vXPGa2vjy+7xm42YLNs5IW29sXDA/dkEfHtI6uWdDc/u0bW8YP6prkH18f/smTdaEPDD4CK+4BLFuCSjnAThAS6N6VXoayWvZhH0gT3ZLLkHIuPrnquxhT93sL53woEKxHZhsp5/53zVjwUDscQqo9WPjLYdbXHw098MiPK+q4t7BlUttYj1FFddWw4FBn+bmWkcbi5+fmF9iXPNzUNUPaY33+0fXbHTcFgDUjwJ2Cl/Vkyoky0OhIWhxeYwWdSli0a8D8jFHpKqIp4fdvaHH32aSW+kkKLrPXGUKgRI+E3yECR/NzhPQZ9SdZ0HywCMCq1WK/fMJcXtf+k0Ex+nrDwtimygEHKMnU8O9PL5tOyzJllypyTn1HrpJv33b7Ws8DpbFMh8P67+8svs6vZIqMyovOuq5x/k8/H88pmh2Ohb9u3PS4LrzNbjqwqX+F0VBdIG1zuZdz8Q2anBUQ69mZb0yis6atsR7qOcFwFrSlk1Ho6KC+j6yrC9w1TtseczUqlemVnx2OrZO0P1DYuMtH0WCj+Jd+jVmt6quqeEC3j58DX6VlEYq2UWN5mbhLhZ8ao0Cyez23k2F0NneuMBhrxyGa37xuu28r42kkWv3GWwE/XJnZxyOd0XdUcr8ZP9l3PseU2g3GxyNnPoS+v5DR4WmXmKp8sFLnI+i709Dk6KKwlq4TtC9QWc2n2tOnKQply2rQsKshNeDmOopBPabcrc5QzZ8yaNWOmEto+JTSRdsljMB+KC3Bou/CSokr3B50hF7rP73Jvq85jlCpeSqk8RUVeNczdDLtUbTWXlpnMpWKveNn1TpcFYSQh3ZIsjHFlMHjffMqHWJEQjd0GnSIE46vIIi7eMXyEpfXxt3Fee/yf+3keN8YfxSvQm0JgM5V9lkDPAHqSN1B3eiZnPkdHhJXAh11ZBHd2GcdJXgfMXsDcBPoZBExoXZopMJhzfUY2AyITIRnmkRQnvOz1ePAMtUo1UBttkRXOQtiD0UytWj0Qq2otLJwJP/NKFAs7fL062ps3XadStXGLtgArzr1MFtrnGA1ujBw6uoOeeJP0UdkSurG01IwxYzT10xPvk2WOyxyusEqhKNdqwwqFEg/WJvd4VBZQDrrG/Keikb4pU8zPQNPYhKYZzmva3oSmtZXwl9Qyw+JyRIEuHAQ/Vgn9FIv+XjrFn7OZVjplDsi07YOoMlx+fPXqY+XlEYQqy8PHEu+VLApw7G3z59/OsQGE/Cx364IFt7NcAHutS15oahocamp64bILr0fB/VdXd3dXVx8bss55qLqmqwteRUt4VxilioFCNcEDhUx+pn5OcbQsjWSXmljf5VTtTphE193j8XgxF2ZvWuqD2bVFyZFZ2OSyXb2QFSfTQmmN07k8NHe3nXUJo7jCFpMriha0tL46Khv/RUd1h6qkpNH5cPwzWf/p+lgfqEQXh+XBuTqdoSnU/JxI7QlhlPwsTe0Uj5jP/Fc93wm3z3fnOjd4vnY1TP8JF7f+fhfn8NNe+9WXBZY7nbWFsiaXayk7fsBqN4KLG329tWVekUIes8ZfkLzzsLOxpEQ10j705AZZz/HW6gGjTjcSiP+Z7VKp1CNVDacIhPaAhvmoNkJGEMgI3DOJG2MuY6Igv3P8bHkWW0HK50Yr7+ii69RZ2nqqFR3ZXfPkuZfxqfn7bVbDdAmTPZ1AxJugR1qq9X+/00iyLPmQH7ss5Ydqwjs4vmUan9UeqbitsfHbMXsE4jEHK9m9PBepYZj13tCVHFuL/VnNwdDR5ooDXLi5NRDbWu8/xLsiaDrTogYyVMrhuvZVtE5ndJYurO5YRtPWnJk6jbK/ItJVXCxTaUrHarrXGww6jUa3pLFjiVqry51l06n7RY/zEqw5/ikZSezfaNHhZGohb5qideCMcDgoPI8qsNdu31iv4pQ5qpyZs1WzS3zK4Jheb8Foj7BZMiK8y8eJ1nGtVo1IRJEMfGNcpCzpiZAEL/b6K+h1ggoSKnEeh9DFlG7oCySQL/r9KCfq8e5o7VhnMOoRh+wO+/6RA8/5qGBcWrvSaLL4PZ4dTfhEvKP/Zt5fuXqB2P460IBuKjh1x1LPo5+HhSUqtTAepoITvdEq8ruA2wK4RwD3EjuWWs9PjPTPPV8Hjtt8z3mfY63HA6TjwQcnfgpNTP785yRKfou93ggtdVDBi3Ys64Tt9eh+oaYO3YhurhVq0P31eBC9H/9b/OdoQqCwDedC7W6hiVoPtcVZMcn9FOHowqIa2PJ5bJHZFC7GgajQq9QIsQiaaJJxNN3PyayFWOEQmky0bthPfTbRWhEhT5x79UFXm0pdmkUykizoZT/Q2EcFk/scXlwmZWvZX5MBNHErKZ94BZFnOPJnbn7CYucIkngQdN8EseRiwkqExLWBEV9Q5/zCgrSmSEDv8zMVf4pIEQAoE+6c69rXveW7LOvuWuje1XXFAwzjnPjp7JkWB3NwdfN6u628QIf0DustqxvX2mzlUvyzGdMR7kSzDiLNgJ1f1t//wbjwz0PCn+c6mTV9g79azC71oRlzf9HQNeqxWldF4l8Pv9LRNQ7bgaXl+B3PfHcyAotfgX1dViJGJpEZ8vErUsGLHpAc/3H5K2dvTO21yXMQS7ACDqvNDGGk/C+Tch6ZISMZeW7iffRt9xK7PRTm+RsH5tzE8xGSIzm3a1dHyw63i/UaTXOsAs2hT/it1dVHW4eOwIKiJhi6o79lv48pd9rs29pqYEuzwhN/hwM6FoBVfAJ0NItrFyYjbHJpj/Nfo/XOle23lIcaQgxzoL3ren+gBshsqYx8d+7gXaFgtddmWxsNLjYZnRW8/8b+gVuDwWpAKPd697Y273S7uVq//2Atif2INpmumNN9ld3h9Hnc+3vG7oBQaYD13TjSstFuD+YWhKzW5VWDR32MP8iy1w+2bXc6vC4YZWv7epPJlIiUDYs2AvKYkYh65tNIJkaJGGA7hGl7ovEG/Dw3MTGKS7rRC+Sn585pIC1ykCN1V090A4f+DProhdpuqKvgOIX3v8AjkS9SUa7Flpp75vRd7XH7zDbb3pFOGFpoOj+j2s/fNGf8NsbrDvsDd85rvycSwjfEg/hsXgWPIrC76+67LRiq8Tid29sHr4dwTWtV7Ni8ufeHw7VuD65nxVHdCXRJQXImojKRdaGys3DmFnKqiJJrHobMlFFWxn6UXCR9WPiqu68Foapw+NjyBbf6fKyf5e5YGNnEcv2a7L72tj/fIp0cvMbt8jgdsH2YdxvHBVFuO8/vlLyI963bJPzhzu8ufry2rnOgru7U4MgPYrHWUrWm23fw7MjIShT/uiYYvKWn9a7Kyg6Emioj35mzKTZuNCai1leDhOyixaQiT4ih7BMj5IL4Hl5ySAeRJ/ALJ2C87TBeF1FHzAU830Wz3EUhj0yFJTMkljldXgpOGauDwdt6+24JBKKwwJsfqFxjs3mbo5XfHRr8brSy2SfGfQMLjQb77NpA4LqWluuCwdq6YOBoczO81VkijG93bd0uhqkIMd5dDXV7fEyEqhg8ApRxXubIYGy5zR4uyI86nRvr59/g9TIM471hXv1GpzOaX1Bhs62Ib+rebrVBOMW6vafrKrvN4bDbt+PNzRssFpvVYtnQ0rLFZnW6bLYtojbcI0aHEtHgKEEY6KRJFpxf0mVyJnNDKb0wbHgyVqNobxnWff+rjo52DAw5sXXx3RzvD3Dc7fPrYXXQpUSNTc0fGfr2O10et8N5ZGTlLW63DRW08f69Og5dvmgRkt1178ofd7TMRXMaGh8bHjpeU9Nj1NPzQnlHvh6aM47+1FIRvr299e7q2l6MBhsanxgL1W6w2kQjQw/gW/CvUtog+k8+H/9quvCbr/AtpGKM7Yg7AWcQ30YeljxBWBMaw/9X/edhQX9OVaEs0Vt09KCHG9Ub7CRYulrV4jDVKZWlGoWCLRLew7d5vlJF9fo2G9uhVKq0mtIB3lkL+QaZTBaxGqo0pXyR8Gs70DEXHyavkTz+f+4/sbrO0qOnHQZNaavZ1l6mtVAcxZhMCzjvmNHo0hQVx/RlQYVcadXrhz3MHL3eSbGUQa1qsBgb1CqdrUzbaqCqPSi3QFrpdcRkCelXOQO9KrVKCUttv62ySKGZNqNULg/quU6VEoCqDtZaKQPUQhilvVwqzRP9J4rgU8DrFwkfUQ+jZMRp13gJ6hWyKbrGpQKPhkw9Y5IqRnaHZudgvVY3WuG/zGrlKJ6063S9Tqa5pESJT/Lr3e4KOwzObe+mSxwFeKbwlbFRpaY5i2XMfmIGp9e34+ccAy4ULF9o0FtVanVfubdGJivQqjUd7hokVyr7q7i2kpIiVKzId5SUhWfmSwvCNr5aWjAbPWgIFcoU4ug4fJK8CUaX2LOh/8GeDXHIajKtrq9faTJZkPi+qr5+ldFkZZG2rHROOAw5YS1C2tKyOeGK4dIyLbV+ffUmp5PlIDFVtb5qs9PJwevm0+v9i2BCdBhNiwLrwbOYHHajcRF4vhrwjjskp8AePASbton/htobkAmhnmnCV++Tw0L3h8X+oqIyQ2lph93Tq9WaSDdZWlxSY6Eri4pUEO9wy4Rzws1YwcT/ij/Gr/a5G+Ib4jL770qCZdo6k6uhuKhYo1S1eywRuUwhlUr9Rl25UuWRC1+aD1BrSs8dAnKJMHxtkPwQaM4nZERxmmr4Bym0MoZNTr8SkbIWkTL8c07Yj9BW9y4hBylM8f1JAj4/T8C/0IdCjur0aTsarxR6B5Idif0g6pDkdGJuHxLnBcPUDv5PjVIK1FIzptKZU2loKSsza1XKWr2pXq02UB7KSYNzcfTpdDalXF5epvYVFhYbtWXddmentsxKuihtSUnUoIuVFJea1Opa3arEWP8wZYTkDjuanZ8XdJjBDgvAIsstTEtJSXFRSXGT1xSQyZXZ01XSQp/W3VgMEikuqXcbA1JAlRYEDGYuPz8XTaiSXMJihpDaCh41N7HjYLVk6oMYqVaKkJTaKnTmo8XCTXno+0JR/H32TrRupnADqldw+NscvgwODKDvCX3oPXLVxLWgkT6YbW6B/WkfrGN3EITk4p0bPKyooBkMzTQmxpjBXAX9TckKxX+6DeABYCRQkVYEZhokuc3Zpi31KVSFbuCoOdijKTXNnDkD2zFS6rRr+rg+rdaTl63VaIZiFeKyA/uwWqPuD9R2yeWz0StN601mq1ZbNhb19hsNwcI8hqaH4/9mW4qLi3Va7Vjk5ZmU3KvVduFJQTJ95kyjWt3JN84pKSkkgawCpsxa7CookOvV6maLuUN34nDFHr+/UatSNVlNTWoVbaLphWFHm0atAyfXrn8a8U7XtvryFVart1SlbLRbGlUqrc9C6wbd5eNmsxu56zSdtYXl9SqVDvfP0g84HN3aMnOl273GK873DZP/or4H85+a8CQkmp/6nD9ZI8tPczMljfwUx7wQHNFR3xNU6B5hBP1eUPhXBjbe5nSa9Q7HvRsDy/3vrThgtChVdsP+ZU7odoDDt4sHTLIphNb29Z4ZEn7U8Vbf4FZJlg2tae15rBZ565/tqV+GkARS/wRoxzTQjpdBO6qI+QQkQaQXC1aRqTAmY4bCZE4sl4zugM6IFpnpgxMF2dkX9GKawabfNhRbYNC7c3Pdenq0wtas0wZLlDKPWlNn87Wr1aZZs2ZiA4lUWu3K7sgoTbtyct0Gw4KqgV0GcxmnLNMuafN3l2osgAfhXrOmtNvftkhLq8lFtXNVSjlGwsykKnTgFfc0PdoQHnCKMzQ732RyIWl+vqPYKjXn5ckQsmi1PQ5Hn3794drDkNF1m0wLOW4RoA3VNT/453tCt0dinVZYkrhcw8Z7jMMu16COtrYGK76Nr27i+S3ujtn0EAD1tA1kPx/2bH/PshA2WAkTiDdlpwLN2QqRu+dZlsn15GSG0UWrXFk6f4b/+jPNB11vbS5c9VTru+qPF2xTlL+1Qow9VlSHgt8a7tjt87WUFBcjtE94pBNy5+Ucy966YPyPboyQTCaPOZ0bJLJV7o2N6x0Qk4ytd28b+/dtvUNNsdjJxQuPx2LNYsasIry7sv0d1H3uSCwYuH1w8I5gsGrpeF5ZfmdgPe+HaI5N1O1fgLeKJvK52tQplalnKWRT0vtaNIvj0Nqh+yrC9fXhivuGhINorZgQi8Z4/nCLcDBxyK4VcQxz49jYjT6GQxxyORw7erq3w64SpaOiWUQyzohY39Sk45QoqemSUVGqmOXdt8znl7rdHSqO03R73OO+JTd6fR4e653mHaOBNV5vq6ywweNeG+nZYXG7sVS25Mcddd2p3OJXozhqF5OLw41tZzbKBh6vjfWq1apuDhcERyHU1hiqfh3II96B03YWySTRAZaftOrzMb4phwtkl0pEZEQOEyOaMlyUW6rTLm/39Ou0ZoR0hTItQi5a10HrXCDB8YChRa+NKIs0jWZzpzG2CcLhTh3dCbaDkF4m0yOfzbY6MrjNZNIj6vLoFpcrAAUaTbsjsITxLQmGR0zmOpNpTnl4TEcbZs+aUSr1FGnBUzss5tU1NeM2W4PB0OkLjjPMZeLCzmCr4vmDjef2w7ifm3RTjqwrxewYSgoh8+CVAuZ87j8Do99wes3E0rKsi2KjX6IIw2yv7L6O56MkT9WEgneN+Bv3+XyR+mDw2oboLpaNIRT2eq6oat/hdPowT3Juz4F+f9PVLBupA5zGyE6OrUb9TevMZgvyuF2H5iy6k+OD5BNPSRinc2fv8C6XK1Ki4Czmdd0tEJww+73eq7uGb/X7o5InnqAAZ3fv3J1OEcdvsayFQULOfyZVKDESgYzs8aUHlC3LYERGDnnLN+SQs8rd7h0t/hX3Ar8QAvx7V/gbtns8kexLZJHbdnk8oex3fk2ONDU9s9C68JmmphHyw4+yfA77luZkNhkRt4HlzpW8mFhJi0uMS4alpbSMkSYPr9IyrSl10hXdi1YJh6brTcYNHc3rLGYbyWHxgFzfnKsdTsf0H/1kBqKmTzfTG8lnUXyGQjUN5iR8G4cqGq7m2KjH7thS33XIx4Qay8N3dgvPc8Ij2m6zpTqP49TVBn2TAShsAAp3g28pTkSBtWzirxjvpE3wrZUl/uImDr0ghOEzgP4cEyqKJAohHEV/EIbRs0IlehbV8l/w5Kw4bNrxmYl/wo+EV/4DdQP1N4IWo5YGBW9KaiK45+SoTdkKUedSbhosEWVwJ9NWyV/cbLojXBGL3m+6J/K98fHvRe4y3hOrilTcaryh8qEVKx+Kl9XEAncsWnCnv7qmojxw/9Il9/nLYzefMj829Isly3879KL5mfr+vvqnTM8Nfrhs/NeDj5pOtIyMYPniX/fXjcyp631v0fwfd7UtWdja+XMC49LJs/gIcIQkchOr9ClZSryUl+nkcj0tV+jQEar03AfC3YqyMoVCqyOgrl24Bd9JtZ2vy+RLE7VkiRZwJy8D06TFuvj0uQ+oUjR6oS7x9eRZ8g+gKx5xr4CYBDP+axuaxDOFygCfn5/P6j09ZaV61u3e3d6xn2HCEp702W2X19asgZNfpSpVs80SLpTJVTQMSA+EoWtdnXpDTGMeZLxrY+17PB7O53Lv6qgFfJvDYl1TU7HYbm83GRotljnCeJJ2LdCOJMJO8jWqJUU7nUHWlFmXzpgq2IwBTqH9Ni575kxTqW+OjjZ7wU+0d1zldDAkR9mMxuU1tStgI0mXlna59K7cnFm9IAwtTH86/ENLlUbDqZwL/YHt9a1Auz9xODa22mJxOsF9VNes9XqHHLqITteKrpXrEhWBWHT3JMIu4i4xGm9Ieg4Fx2EXh5xWA+dV7tpTf3mgrPwggXALaMYLsMKfCZiZFLfo5QqDQSHX+4p0uqJimp6cxHsBN06+SxiJwSBBZBODRJBcBvAg9CYA3ASQELkMSgaIWwlichKes9R0aB1KBDizK9YkEjVRLfyLMIsP4PvwWbF3lNk7q5UnR4OfT7JCJ47qGawlZ5PbiOL/3x4ePYNKYEOm15fL5cUYJ99DcnkJ/q2GDspkCoVMFqQ1+hC8FslkIQIRz0y+Ts0GekiCkEBkkpo9cZLjOLFHAl9JnsGPiCUISsgzcS++EooQ0YF/TB0is8+XUIfOvYB/nCgZhJKbMkpuOl+CS6h5eCgLOhFLaEU2g4f8aIZX0ve97/9D1LjnoTyeKBf5wdMKkkl+Y4zL8TQWUTiEp7OS1YePCv9EueI3tOqlrsXPZBUkzgXArJBecmMvh+xWQ4lp9uxZ1FeXjYsi18Rouhnq5FBX4ttTZwnS+sFziV0A1Ck2zs7JkdyyeIlYR1Wh1XcQCPJRjfgA8XuxjmFKnQMJtSoyzM7NW7B9h1hFGSo1doHw0bXUtWQt0GYiFk2OJCS/iNhLiCXHqCvJkSxRIxZ/S4QvJp4nRB7sgF5+l+il+D/64ad0mpsYnIKelZ/3Y/FVL77mp/ov8WtMvY7UO68290KP57mPs4gFCQpS3IbfC0VdRDcKVrIuqw9oJdCFZQOfPiefMu40f+FBNxYUSiNO55Y2af0qqzVYUJCH8gsKgpA0qpe2QswnUlgoxY2F/c+NzXu6t/cIa/Me7Oo6PTL8aEdJx6Mjw6e7uq7x2nxHe3ufmTfvOaBhOdCgSdHApnvO/oa7CIq0n9EgiBwAEZtbLxCB8s5T0bZFpEJagLnCvufmzXumt/eoz+a9BqgYHklQMTwCVBz02tgjvb1PzxsTqXhPeBXOfG4nss/fLoD5Ikv4FTL/LauR+6qey24W+fWK8Cr+LIUlExP12nz0yuefI1PWdu6rh7ns04DTJdSR72WFExHcFCfFYYnnEHyZrJSlFjZJqyZfL2xYb7E4EN6zevU+o8G8sTWvZ7fdBoDrduw8ihFkuHYJdc7iFh+zo/1fO+4oUty288vm7Yy/q8Sh6gsFjvZ/uftqSUxyYM+/Bo74gz1ASSdQ8i5QIpp1gndpEtg0XRm8Tq2y0tSJwu6Uwt0Yj0+roVfU1SzTl+oQioSsa+tyI4uNPh4hm6ms28v0lhqtCDkslnXCemdJKxu8eeRf4bm02U7GSItJN1bx5ZL7w7ZqhUMWsfA3DH3ZsNpUapsx015mXlX/r7YdsAMDao8Tj5Bq8kEiK5nxlSEGfYmMtcKvkakWu9FW4ZBUOARFJ4jvp/ESiWEWfVmLDMJvapGRfFDYLOxGa6QEIi4njlLD1KMJv5KfTMeLCyO8lRe86AyPPsBPo6+EaawwHX3JAv738I/JTy74MPKTiacSPgzD+ehJyk39A1rKndoWCXj4ICfUoCc4dG/xxFOkAZ0RvJzYATfxDscl72F8TOkou0iHVIEQMM2EUDb6mQltR9tNwpVooUm4TbjdhBaiPAPaK2wyoP1omUm4PvEleui1xL+pAWplYjWiTFKXOXPkZ7xTAxMl6NXzM0l6RnnI50P7U78n3k+9wMiOoYcpK3kVQZ4/Gy1+KOvEbnILfJo4TliS8O/3oCyKohzENBELmXj4klFUvNjjxn+euBNlhVC1TIaqg8IeL2A/iaZTasotYksBU4EU2ehJcmziLoRfr62Js2g62uJFm0PCy6Ua4WWRR2+ja8g/478lZokEd8k/T/wJf4SuQQtZ4UcARN7JneRbidUcIRHFvhyPhuJ3b8tyfP1TKC2B0oeTpQgx8BuPBuN3S45//dMshwgKEzvJPZJCsTwRM16ZCEzuTEV1JYQddp53JnLzDNECfnnp/+yUE/of1BEjxXYEx4YHy0MDcIwQIY1aM1BePqCBZRCSKeSQGa1RyGVIbLzG7amFFvCgWAGQ+gEJZbxzqBCQvN5ahbwwWcEjVpAJtXiFLX6UurmFXWq1cbzNNu5r8S2123h4XXZVi6UP8ixOWt9nhVeadtr1dF+8upUdt9lF5KW+VhE58bqj1dpP0w4HTffZWq19NETXAHk8yUqEm4W/4x0pSYCl4B2c8Pesp7+OiavqSijbAGVJbQP3yYsYlRz8gZIvfoX/HZ8h6ns3SGM/1QmyaCLmi1aeGU6beiSIy9h7ZS5RDZfYg5gKvzmPTLa4yTyptJpnamWlBShPLmsM8dWQKKLcSKFUDlQ2jhWr5JpSzUi4ckCplMfDXDB0+qpVD4Qaq2vr/Q+t3PlIBRvgKyoiPz687alYa3trW/VTW695K1pVgV5VRpRKPUKWMueo3lPaDWtmbXFJudLYri2zxBy2xRa3Y4PL4bPTuq7dbT9oah5rCzW/NDD8Zktl2/zO2tOdI6909K7qre15f+midzrqO5d0dD1HUEQHcGkPVU8oCBcRFvd/0kuMTXEJXhgYafIol9EkxoJYBgKNyRV/R11N9JW9B9+KRirb2yPPbN3yZLSzg4s1BH+wdtX3yhtq/KHQo1duORGKlaPBB24I3hWrB4Nc8Dp7Q0srgg0Lb8TKBW93tI4sbYMzcePvtVd1dkQ731s69FxruK25vOnl4e6TjY1zh6JNj7uEs0ie21beMRfH70TBv5ERf5E1L1+aiF4tIW+i2MR9scLkLowmSZFSKSO6KQbeSIGvOX68hr/PBy503QN+SbPQhIsFFr0R/1Nip/t+ICCUofehNbSV/BMJefYEvwj03+QV2mrQlvW63eJGzFBa1u1295ZpDbyqqChmMkHCsUSpKKo0GmNFxSrqZ+6+sjKjUcR3QXTebNJq+9zGqpJitaa4uNpgjBYXq1TFRTECET/CN1D+1K01lJgcDCaJlCYN2XiO8JULYVTgFf6E9smFq6aFsLBeSn4tPFmGaoSntSi8nz2MDggbdnMwukRe6hZoSZk4d0wy4ikN+NDQmFb8yLTiB+C8VEviL5r8TcgofDSKpgnN/mbhumZ/k/A6ss+FznIb/Y0zRtDyUXSrsAjd6sOzOHS3MCp+uPg/fSlY/J9gqYnz7TeB3+SIRmL+VA3kFYy45hFtF03d/mbEqFJLyqRpJpcmPErCLhJEdjJufl+ln7++O7TM6+k3H4meiIQ5imOExoNllSXFWqOOHvXHxg0GM2S0/aUuR69WZ0U31W13uwPIWFraanKiZ0vhpORi4eMyjbqXszcplZoSmYxVXafySqVyNNoPd4u8mpKSOuuxXw3/ZPXcZzuxfJMqajB0OSCQC1tZq3V1hBlzOHvNZtMQw6wVdtoscIfYf5nL2UWb4+9baoqKS6iVzByatmhV6ma7qa60zF+0Td9qtQ6ApLyTfweePU2MiDkExKUPgeHsrIJvPi3IcwVpXmRnwqUXrsVlZiIy3GB61iEzK1LXk7Tf9+SNN/yus29YImGaIu9+m+6wmBtVcmWVwdCgveHVUI1LkjXa0vWTFRu/wzBWCVZa5WGrwz1jJkUydD/TvQX249kkWZjbVWOqVqkcBWShVFpu97WoOPPEVyArzYIGc1DpQHmQc2lw+7hZOSQ+uwdNXzB3zZoFS4W37t8j/H1hz8LZs2aVFTrz1DNnzp7bNufc5SdRztC8+aO9vV8cDv2oyejmjMYOJfra6Ouoqnqgz7anq2JEr1E3QfBCozEy1s6/ZsfujfrqtEph0XTrEoezotXpu1W0iK1CPtUK9j5OHEidqoHnv360NBn1SPA1/QDk/xt5TnAbTcXOnhqyBelQrVa9YYxlV3jtc+z2NrVGW+UL3FDfcy3HhkmOhHuT9y9svzsa7RBdjodfaDK5kd1gmMdxK5nK/YFAI0L1gcA11QO3BoI1UAHO7hxb2HF3tLLdpteP+vwrbDZOmG5byHiH9bQVoVqfbzM3vMHrFTUSId5hX+EvYdCxSrjewxYWanJmqaQFbkjjco1LjXqa83gP9Cy828+HzFbrriFgt4ErnA5ObDQaXWA0+WXy0tn5Nlq/tK1thY4uc7vdh4bxkm9xvN9kte6cE51vAPxsfVnpXHR0llIq9eh0fYGq/hLIKynLCgo8Wu1AMDqoUqmoaeJympgER3KHeLs0eX41M4TNkIu5U5edgiQLpFsevgwuLKNYefjBZcseLA/HEIEQha8jX0/dTGMQr4AvGlEhJKG1SBIWfujD1+Eru7vi20k19FSHnqB2k+JpAwJNzele6tRHhoip3X4M2eg2vxFOyfiVZdV6Q4cT7oJptZjHkLxuC5iqSjUBpbYKDnA4Ywu0Whp/gbzDtN4mLyhwFqk5maxYTCKEGRCLTZYBs66CvXny/1fItmEjgRNRg9eJy1AkDben4W9MxjPgVBp+hpgO8IvbeW3ymQx4Vxr+NpGbAc9Jw98k7kKtAD8sVIv/9wHAKYBnET+SfgnQxL39ROtZKSqNKJKG21NwkcrJDDiVhp8hJAC/qB2g8tcoQuDJFwG+ECQqFeMBjHbKf1KQuMSRyAd7MyMD2vxfohWbXqhr6sSDjS2PrxWOCp8iKfILEyi44hRT34xxQ3XoxErhZXJB79AnW05eda6jZ5CMt3Ec3rIgMvDLtY+s/UVP4wiJrwM5JO/NJyibkRrhUhRJw+0puDjCP2TAqTT8DDEL4Be1AyN8XoQnb5on+J2b4ve3RH4nb5RnVwI8L9XvXNSdhkdTcLHff2bAi9PwMwQB8IvagX4fRd0ESeyYfIRaLvklYSACRF0q1iKlsy++hAZBOj49gUxxkyiBnHF/AoE382KH+9bKzeo6q21RcPvDPM8iVFBQwBm3Vy7irh3aeoov903sdXqcd6/jR2CxVBy/vcyRk5tLVmOPl7l1Zc92Nx426uA29fy3B1HWj6w1sD7aMjz04fg74SsrKta6f3OMj24cmvOHpe+OnOnpXqOERZT53MeOy/z8alTw7oKf9bWPh33U9LaTRHr0dHr0bxI3ovkAT9zuTUhDnuJuH4qk4fYUXOTuJxlwKg0/M/k1wC9qB7j7kAhP3pHNLgN4Sar9auQDeOJ2q+QTgKsSVvT6BiIN/TQNfWPGBehLaegZBfENLbz2VhqaVZiGvi2/gHsmBRVH/wMiB+CnhGrxtibANUlbpsGWk7cTJR8DtCxJ25LJNPSTNPQN4QL0xTT0zIzJb2jhtWcBmrp5JQXoz1O82EuY0vDCFBxaVqahYn8p6Bmz6aI2oOX3AJq87yR5E6CW1Pj2E7MAnrifJPkrwK3JkQwJaejHaegbX1yAvpCGnokL39DCaycFggToSqqSeiFxfzMqxgQyrCPDMfF09sUHOkRrMUwxFTChg3iwf3Vk1Le1IXH9CZVpSgeD/ZEmy5A3AWCD4nUoexst9DW0kDXJG1GxVU70ENMKJxmx13rlH5r/8jJtTF6MajgYqVhMP3yrtCDjdlR+3sQNta/dlLwfpdeS67XDfv+29BhF7llT3Dsqci95gyQhAXeSewEiDf00DX3jswvQl9LQM78hvqGF164FaPIWRgLqS7a7+AL0pTT0TOJa+SfUh/gDySeJuAFJS/EHD0efoD5EM4R/i6V/hdLfny9lpPie06FnJJ8I/0YzxNId1BfkZsmniVWAic6WMbD3IDf/1fzHyseeqKbO/uPznBdfhCLidkkWOUPyLGGAH5kprItn/pR8yRkcmZuTY1VboqVl1VZzhQzSKxyZJ4LMfpMuZjeH5fIiybMl4hkpY5HCpCoqjhpKHPn5hVplkaW0pLgK6HNItpAQjEpHFu+OH5RsYVkCo1ZJL1D+EsQGFVOzQZKMd9R6Po6Hnjr/Jjko106J8iVzKU+S07MK/4c73OeL5bJymhZTSMVyefKtiIOxWoqKzbk5eXk5uZaiInNObp5kka5CoVCpFIoKnS5SVKRWFxVFdEW2/LzCwrx8W5HCmpcHoZM8qyhXoYUUPbGSILR0dua6WJF5qAGPs8XqKrXKgJBXr+/QZtsX2Kx+2F5H9ZuoGbNnO0xWLjdvNvIgqUxW7zeHZIVFEjGjISWOkm+T+wkTsW5y/uRvQavXESfhX0S8n7hjFyQ0qbM2GRtTCDtNuVJT6PM57x2vW+OwR+Ukw2XZbfZ9Y33raL0GU8GzRlzffZm+rKyPfZcKxjd2HeW4SC0ciG8StflriEY/TT4I/a+frE9Y1XriW0T6/ikVnHr/NH0PN33xFuRG4zuomZKTmfc40uc8yYGYMAsJ/pPx+WhDmLwVF8V/Wfbmmx50XaeghF42QBTIC7scPqFbib9pNWYvTOy0jEl80gtaNj16lgwLIfQSfKLh8hOrAys4fnlg64vV1Y3oTfiDGmtqXtzqX85xy/2rj0P6HuF6/hm/ccUPY7EGaV4wJ7+rsfGNjXr/M7x345uNjV15uYH8/Kaq2OnlXkJC5MZ/Th2bNo8gQScZoDJEENNJCT01Ky5SSV8iHy6T0awU2EHCB8+L/wB34Rah5PVpM2fQ6hnKWbPyywxFFvwGshn0Y/7KRbTOoCgocMhngoSzXh+hsqiszgnPhId8+5wbNvhm/WxTkYIp8VW6+dqF2jKNSW9YXGmpVKn50jx1bp5p3QMPTDxIUTP2UxRIN/UHZxEokT9L5Ubh95j4O5VTFMsXE8T/A/8VTO4AAAEAAAADAABIn0ckXw889QALCAAAAAAAxPARLgAAAADa2D+r/AX91QZHCGIAAAAJAAIAAAAAAAB42mNgZGDgSPp7lYGB5ewf1n9tbO5AEVTACACWDQXjAHjaRdADjBhAAAXR+VsGdVQrrm3btm3bNoPatu2ebdv2RWcrL5o4U90FgL0EcAl7gonlFB/x5gAxZPKTz1wkk11EcZvNvGctSzjMXC7xnXA+8Z7HePIRH9L4JJHGTLy5QDAfdBJnbPBnOxO4ynTO8JpYNrOcBcRzl7N84KFeaq4WaZB6MoIBxSbSnTHUZhm+BBOIBd+5xRiWmZamPdmqoftmgjll+lJoeugf/wRTmGuayNJ0NXWVp8t6p6MlravaoFDZaZqm6r0+sIsX3MabbbzjIb9xU1c10QDam/FmMNOZwhrtx50BPKYr+ylUdUaxtwqXCC5TaI13ueJH5Y5ykffl5vK9Cp94XC6tXMmlKv7lpjNdyUrUUW6rgybKUsmgRoSTTRoAqC07gXogTN0ir+Z9fgAAeNoswQMQ40AAAMA2dlKkUXF627Zt27Zt27Ztc/S2bds2dn3/xHw9fTf9yfz5/VX9+/2X/K8oSOWjylHtqGHUdzozvZ5+ztRh2jOLmB3MDeY7a7Kp2bkcz1XjZnKP+Bg/mT/CfxJyCtWFNsIR4YdYTlwqfpWQNEE6Jn2Tg3I2uao8Qp6v+JWQUk05rDxSM6sz1dVaLm2Btkn7qLfQLxkpjEHGtkDJQMdgpuCAUIbQgtCVcIbwGjOp2dc8aX6LVI90jUyOvLHKW02sXtYwa7K12NplPbTe2X5bsz07lV3Urm/3tCfbC+w19hX7jv3ESe20cwY6k53Lbnq3sFvdbe/2cWe7e9wn7g/P9NJ6+byyXl2vbTQUhdEs0UOxHLH6sZWxk3EpvjhRHaQGJUEDsB7sBofAOXALPAOfIA116MFkMBPsDPvD0XA6XAzXw93wEDwHb6FKqB5qhbqhQWgcmoWWog1oNzqIzqAb6DF6h35iCZsY4tQ4Gy6Iy+IauDFuh3vi2/g5/kRoohGHEJKO5CVlSAMyh6wkp5N4SUr9Xj3JqCTTk6z5/9dOq0kDYZVak1qX2iQAb5yDOAB42mNgZGBgeMCwkUGMoZ2BFcxDAGYGRgA2rwI6eNp9kTVSBEAQRd8q7u5kuDskuLum2Cru7HU4AAkacgAyNOYk/JoaXGrsTcvvESCRU1w43DHAOVh2UMy5Zadi7i27aOTFsvtTjIdcR6ZlL4WOWsuJzDrGLSeT6TixnEK04xrDDoh33FiOE99ajv8UkyL7Mz1ssU2EXUIECLJPMfXUUkeTaFYWn9ZptljW2NcoZkzzpqFJdrWG8bFiMrs40BpkS/Y97UuRotq2du3UqAUImYgD6VUra4sNY91SC7COD79R32dP9t1PdTds1bK/TmNOGxJP4yPAgdSWpNBANbWmdTDAhNqA6LOGVaDqXWEen7lByHiKP2n8n2dva+96ZFo1S2xrrJi3rDZvE5B3nZBsPmXt4TO3HWWIHvoYZ0ZzFfWm6u+3tRVZwPf+c0MaS1Z33NTZQPtX485i/HjaY2BmAIP/WQwpQIqRAQ0AACowAdIAALgB/4WwBI0A";
        },
        702: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        933: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        756: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        }
    }, e = {};
    function n(i) {
        var r = e[i];
        if (void 0 !== r) return r.exports;
        var a = e[i] = {
            id: i,
            exports: {}
        };
        return t1[i].call(a.exports, a, a.exports, n), a.exports;
    }
    n.m = t1, n.amdO = {}, n.n = (t1)=>{
        var e = t1 && t1.__esModule ? ()=>t1.default : ()=>t1;
        return n.d(e, {
            a: e
        }), e;
    }, n.d = (t1, e)=>{
        for(var i in e)n.o(e, i) && !n.o(t1, i) && Object.defineProperty(t1, i, {
            enumerable: !0,
            get: e[i]
        });
    }, n.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t1) {
            if ("object" == typeof window) return window;
        }
    }(), n.o = (t1, e)=>Object.prototype.hasOwnProperty.call(t1, e), n.r = (t1)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t1, "__esModule", {
            value: !0
        });
    }, n.b = document.baseURI || self.location.href, n.nc = void 0;
    var i = {};
    (()=>{
        "use strict";
        n.r(i), n.d(i, {
            ApiStore: ()=>Ri,
            Widget: ()=>MC,
            rotationModes: ()=>Ji
        });
        var t1 = {};
        n.r(t1), n.d(t1, {
            ACESFilmicToneMapping: ()=>na,
            AddEquation: ()=>br,
            AddOperation: ()=>Jr,
            AdditiveAnimationBlendMode: ()=>Ps,
            AdditiveBlending: ()=>Ar,
            AlphaFormat: ()=>za,
            AlwaysCompare: ()=>_o,
            AlwaysDepth: ()=>Hr,
            AlwaysStencilFunc: ()=>go,
            AmbientLight: ()=>jA,
            AnimationAction: ()=>Cv,
            AnimationClip: ()=>uA,
            AnimationLoader: ()=>yA,
            AnimationMixer: ()=>Dv,
            AnimationObjectGroup: ()=>Iv,
            AnimationUtils: ()=>Jg,
            ArcCurve: ()=>gm,
            ArrayCamera: ()=>kp,
            ArrowHelper: ()=>xy,
            AttachedBindMode: ()=>ra,
            Audio: ()=>pv,
            AudioAnalyser: ()=>yv,
            AudioContext: ()=>tv,
            AudioListener: ()=>dv,
            AudioLoader: ()=>ev,
            AxesHelper: ()=>wy,
            BackSide: ()=>dr,
            BasicDepthPacking: ()=>Fs,
            BasicShadowMap: ()=>or,
            Bone: ()=>Nf,
            BooleanKeyframeTrack: ()=>iA,
            Box2: ()=>Vv,
            Box3: ()=>zl,
            Box3Helper: ()=>Ay,
            BoxGeometry: ()=>Xu,
            BoxHelper: ()=>gy,
            BufferAttribute: ()=>cu,
            BufferGeometry: ()=>Tu,
            BufferGeometryLoader: ()=>XA,
            ByteType: ()=>Sa,
            Cache: ()=>dA,
            Camera: ()=>$u,
            CameraHelper: ()=>py,
            CanvasTexture: ()=>pm,
            CapsuleGeometry: ()=>Um,
            CatmullRomCurve3: ()=>xm,
            CineonToneMapping: ()=>ea,
            CircleGeometry: ()=>km,
            ClampToEdgeWrapping: ()=>pa,
            Clock: ()=>sv,
            Color: ()=>Jc,
            ColorKeyframeTrack: ()=>rA,
            ColorManagement: ()=>fl,
            CompressedArrayTexture: ()=>hm,
            CompressedCubeTexture: ()=>dm,
            CompressedTexture: ()=>um,
            CompressedTextureLoader: ()=>MA,
            ConeGeometry: ()=>jm,
            ConstantAlphaFactor: ()=>Br,
            ConstantColorFactor: ()=>Ur,
            CubeCamera: ()=>nh,
            CubeReflectionMapping: ()=>oa,
            CubeRefractionMapping: ()=>la,
            CubeTexture: ()=>ih,
            CubeTextureLoader: ()=>xA,
            CubeUVReflectionMapping: ()=>ha,
            CubicBezierCurve: ()=>Sm,
            CubicBezierCurve3: ()=>Tm,
            CubicInterpolant: ()=>$g,
            CullFaceBack: ()=>rr,
            CullFaceFront: ()=>ar,
            CullFaceFrontBack: ()=>sr,
            CullFaceNone: ()=>ir,
            Curve: ()=>fm,
            CurvePath: ()=>Rm,
            CustomBlending: ()=>Mr,
            CustomToneMapping: ()=>ia,
            CylinderGeometry: ()=>Bm,
            Cylindrical: ()=>Fv,
            Data3DTexture: ()=>Cl,
            DataArrayTexture: ()=>Tl,
            DataTexture: ()=>Df,
            DataTextureLoader: ()=>wA,
            DataUtils: ()=>su,
            DecrementStencilOp: ()=>ro,
            DecrementWrapStencilOp: ()=>so,
            DefaultLoadingManager: ()=>fA,
            DepthFormat: ()=>ja,
            DepthStencilFormat: ()=>Fa,
            DepthTexture: ()=>Hp,
            DetachedBindMode: ()=>aa,
            DirectionalLight: ()=>BA,
            DirectionalLightHelper: ()=>uy,
            DiscreteInterpolant: ()=>eA,
            DisplayP3ColorSpace: ()=>Ys,
            DodecahedronGeometry: ()=>Hm,
            DoubleSide: ()=>pr,
            DstAlphaFactor: ()=>Lr,
            DstColorFactor: ()=>Rr,
            DynamicCopyUsage: ()=>Lo,
            DynamicDrawUsage: ()=>So,
            DynamicReadUsage: ()=>Co,
            EdgesGeometry: ()=>Xm,
            EllipseCurve: ()=>mm,
            EqualCompare: ()=>yo,
            EqualDepth: ()=>Gr,
            EqualStencilFunc: ()=>uo,
            EquirectangularReflectionMapping: ()=>ca,
            EquirectangularRefractionMapping: ()=>ua,
            Euler: ()=>yc,
            EventDispatcher: ()=>Bo,
            ExtrudeGeometry: ()=>xg,
            FileLoader: ()=>vA,
            Float16BufferAttribute: ()=>Au,
            Float32BufferAttribute: ()=>vu,
            Float64BufferAttribute: ()=>yu,
            FloatType: ()=>Da,
            Fog: ()=>Zp,
            FogExp2: ()=>Yp,
            FramebufferTexture: ()=>cm,
            FrontSide: ()=>hr,
            Frustum: ()=>hh,
            GLBufferAttribute: ()=>zv,
            GLSL1: ()=>Ro,
            GLSL3: ()=>Po,
            GreaterCompare: ()=>bo,
            GreaterDepth: ()=>Xr,
            GreaterEqualCompare: ()=>wo,
            GreaterEqualDepth: ()=>Wr,
            GreaterEqualStencilFunc: ()=>mo,
            GreaterStencilFunc: ()=>po,
            GridHelper: ()=>ay,
            Group: ()=>Bp,
            HalfFloatType: ()=>La,
            HemisphereLight: ()=>SA,
            HemisphereLightHelper: ()=>ry,
            IcosahedronGeometry: ()=>_g,
            ImageBitmapLoader: ()=>KA,
            ImageLoader: ()=>bA,
            ImageUtils: ()=>vl,
            IncrementStencilOp: ()=>io,
            IncrementWrapStencilOp: ()=>ao,
            InstancedBufferAttribute: ()=>Pf,
            InstancedBufferGeometry: ()=>WA,
            InstancedInterleavedBuffer: ()=>Pv,
            InstancedMesh: ()=>Vf,
            Int16BufferAttribute: ()=>pu,
            Int32BufferAttribute: ()=>mu,
            Int8BufferAttribute: ()=>uu,
            IntType: ()=>Ca,
            InterleavedBuffer: ()=>Jp,
            InterleavedBufferAttribute: ()=>$p,
            Interpolant: ()=>Kg,
            InterpolateDiscrete: ()=>Is,
            InterpolateLinear: ()=>Cs,
            InterpolateSmooth: ()=>Ns,
            InvertStencilOp: ()=>oo,
            KeepStencilOp: ()=>eo,
            KeyframeTrack: ()=>nA,
            LOD: ()=>yf,
            LatheGeometry: ()=>zm,
            Layers: ()=>Mc,
            LessCompare: ()=>vo,
            LessDepth: ()=>Vr,
            LessEqualCompare: ()=>Mo,
            LessEqualDepth: ()=>Qr,
            LessEqualStencilFunc: ()=>ho,
            LessStencilFunc: ()=>co,
            Light: ()=>EA,
            LightProbe: ()=>VA,
            Line: ()=>qf,
            Line3: ()=>Wv,
            LineBasicMaterial: ()=>Qf,
            LineCurve: ()=>Im,
            LineCurve3: ()=>Cm,
            LineDashedMaterial: ()=>Gg,
            LineLoop: ()=>tm,
            LineSegments: ()=>$f,
            LinearDisplayP3ColorSpace: ()=>Zs,
            LinearEncoding: ()=>Bs,
            LinearFilter: ()=>Ma,
            LinearInterpolant: ()=>tA,
            LinearMipMapLinearFilter: ()=>_a,
            LinearMipMapNearestFilter: ()=>xa,
            LinearMipmapLinearFilter: ()=>wa,
            LinearMipmapNearestFilter: ()=>ba,
            LinearSRGBColorSpace: ()=>Xs,
            LinearToneMapping: ()=>$r,
            LinearTransfer: ()=>qs,
            Loader: ()=>mA,
            LoaderUtils: ()=>GA,
            LoadingManager: ()=>pA,
            LoopOnce: ()=>Es,
            LoopPingPong: ()=>Ts,
            LoopRepeat: ()=>Ss,
            LuminanceAlphaFormat: ()=>Ba,
            LuminanceFormat: ()=>ka,
            MOUSE: ()=>er,
            Material: ()=>tu,
            MaterialLoader: ()=>QA,
            MathUtils: ()=>$o,
            Matrix3: ()=>el,
            Matrix4: ()=>cc,
            MaxEquation: ()=>Er,
            Mesh: ()=>Gu,
            MeshBasicMaterial: ()=>eu,
            MeshDepthMaterial: ()=>Lp,
            MeshDistanceMaterial: ()=>Op,
            MeshLambertMaterial: ()=>Vg,
            MeshMatcapMaterial: ()=>Qg,
            MeshNormalMaterial: ()=>Hg,
            MeshPhongMaterial: ()=>jg,
            MeshPhysicalMaterial: ()=>Bg,
            MeshStandardMaterial: ()=>kg,
            MeshToonMaterial: ()=>Fg,
            MinEquation: ()=>_r,
            MirroredRepeatWrapping: ()=>fa,
            MixOperation: ()=>qr,
            MultiplyBlending: ()=>yr,
            MultiplyOperation: ()=>Zr,
            NearestFilter: ()=>ma,
            NearestMipMapLinearFilter: ()=>ya,
            NearestMipMapNearestFilter: ()=>Aa,
            NearestMipmapLinearFilter: ()=>va,
            NearestMipmapNearestFilter: ()=>ga,
            NeverCompare: ()=>Ao,
            NeverDepth: ()=>Fr,
            NeverStencilFunc: ()=>lo,
            NoBlending: ()=>mr,
            NoColorSpace: ()=>Gs,
            NoToneMapping: ()=>Kr,
            NormalAnimationBlendMode: ()=>Rs,
            NormalBlending: ()=>gr,
            NotEqualCompare: ()=>xo,
            NotEqualDepth: ()=>Yr,
            NotEqualStencilFunc: ()=>fo,
            NumberKeyframeTrack: ()=>aA,
            Object3D: ()=>Rc,
            ObjectLoader: ()=>YA,
            ObjectSpaceNormalMap: ()=>Qs,
            OctahedronGeometry: ()=>Eg,
            OneFactor: ()=>Tr,
            OneMinusConstantAlphaFactor: ()=>jr,
            OneMinusConstantColorFactor: ()=>kr,
            OneMinusDstAlphaFactor: ()=>Or,
            OneMinusDstColorFactor: ()=>Pr,
            OneMinusSrcAlphaFactor: ()=>Dr,
            OneMinusSrcColorFactor: ()=>Cr,
            OrthographicCamera: ()=>Eh,
            P3Primaries: ()=>$s,
            PCFShadowMap: ()=>lr,
            PCFSoftShadowMap: ()=>cr,
            PMREMGenerator: ()=>Ph,
            Path: ()=>Pm,
            PerspectiveCamera: ()=>th,
            Plane: ()=>lh,
            PlaneGeometry: ()=>fh,
            PlaneHelper: ()=>vy,
            PointLight: ()=>UA,
            PointLightHelper: ()=>ty,
            Points: ()=>sm,
            PointsMaterial: ()=>em,
            PolarGridHelper: ()=>sy,
            PolyhedronGeometry: ()=>Fm,
            PositionalAudio: ()=>vv,
            PropertyBinding: ()=>Tv,
            PropertyMixer: ()=>Mv,
            QuadraticBezierCurve: ()=>Nm,
            QuadraticBezierCurve3: ()=>Dm,
            Quaternion: ()=>Ll,
            QuaternionKeyframeTrack: ()=>oA,
            QuaternionLinearInterpolant: ()=>sA,
            RED_GREEN_RGTC2_Format: ()=>ws,
            RED_RGTC1_Format: ()=>bs,
            REVISION: ()=>tr,
            RGBADepthPacking: ()=>Hs,
            RGBAFormat: ()=>Ua,
            RGBAIntegerFormat: ()=>Wa,
            RGBA_ASTC_10x10_Format: ()=>ms,
            RGBA_ASTC_10x5_Format: ()=>ds,
            RGBA_ASTC_10x6_Format: ()=>ps,
            RGBA_ASTC_10x8_Format: ()=>fs,
            RGBA_ASTC_12x10_Format: ()=>gs,
            RGBA_ASTC_12x12_Format: ()=>As,
            RGBA_ASTC_4x4_Format: ()=>rs,
            RGBA_ASTC_5x4_Format: ()=>as,
            RGBA_ASTC_5x5_Format: ()=>ss,
            RGBA_ASTC_6x5_Format: ()=>os,
            RGBA_ASTC_6x6_Format: ()=>ls,
            RGBA_ASTC_8x5_Format: ()=>cs,
            RGBA_ASTC_8x6_Format: ()=>us,
            RGBA_ASTC_8x8_Format: ()=>hs,
            RGBA_BPTC_Format: ()=>vs,
            RGBA_ETC2_EAC_Format: ()=>is,
            RGBA_PVRTC_2BPPV1_Format: ()=>ts,
            RGBA_PVRTC_4BPPV1_Format: ()=>$a,
            RGBA_S3TC_DXT1_Format: ()=>Ya,
            RGBA_S3TC_DXT3_Format: ()=>Za,
            RGBA_S3TC_DXT5_Format: ()=>qa,
            RGB_BPTC_SIGNED_Format: ()=>ys,
            RGB_BPTC_UNSIGNED_Format: ()=>Ms,
            RGB_ETC1_Format: ()=>es,
            RGB_ETC2_Format: ()=>ns,
            RGB_PVRTC_2BPPV1_Format: ()=>Ka,
            RGB_PVRTC_4BPPV1_Format: ()=>Ja,
            RGB_S3TC_DXT1_Format: ()=>Xa,
            RGFormat: ()=>Qa,
            RGIntegerFormat: ()=>Ga,
            RawShaderMaterial: ()=>Ug,
            Ray: ()=>lc,
            Raycaster: ()=>Uv,
            Rec709Primaries: ()=>Ks,
            RectAreaLight: ()=>FA,
            RedFormat: ()=>Ha,
            RedIntegerFormat: ()=>Va,
            ReinhardToneMapping: ()=>ta,
            RenderTarget: ()=>El,
            RepeatWrapping: ()=>da,
            ReplaceStencilOp: ()=>no,
            ReverseSubtractEquation: ()=>wr,
            RingGeometry: ()=>Sg,
            SIGNED_RED_GREEN_RGTC2_Format: ()=>_s,
            SIGNED_RED_RGTC1_Format: ()=>xs,
            SRGBColorSpace: ()=>Ws,
            SRGBTransfer: ()=>Js,
            Scene: ()=>qp,
            ShaderChunk: ()=>mh,
            ShaderLib: ()=>Ah,
            ShaderMaterial: ()=>Ku,
            ShadowMaterial: ()=>zg,
            Shape: ()=>Ym,
            ShapeGeometry: ()=>Tg,
            ShapePath: ()=>_y,
            ShapeUtils: ()=>yg,
            ShortType: ()=>Ta,
            Skeleton: ()=>Rf,
            SkeletonHelper: ()=>Kv,
            SkinnedMesh: ()=>Cf,
            Source: ()=>Ml,
            Sphere: ()=>tc,
            SphereGeometry: ()=>Ig,
            Spherical: ()=>jv,
            SphericalHarmonics3: ()=>HA,
            SplineCurve: ()=>Lm,
            SpotLight: ()=>LA,
            SpotLightHelper: ()=>Yv,
            Sprite: ()=>mf,
            SpriteMaterial: ()=>tf,
            SrcAlphaFactor: ()=>Nr,
            SrcAlphaSaturateFactor: ()=>zr,
            SrcColorFactor: ()=>Ir,
            StaticCopyUsage: ()=>Do,
            StaticDrawUsage: ()=>Eo,
            StaticReadUsage: ()=>Io,
            StereoCamera: ()=>av,
            StreamCopyUsage: ()=>Oo,
            StreamDrawUsage: ()=>To,
            StreamReadUsage: ()=>No,
            StringKeyframeTrack: ()=>lA,
            SubtractEquation: ()=>xr,
            SubtractiveBlending: ()=>vr,
            TOUCH: ()=>nr,
            TangentSpaceNormalMap: ()=>Vs,
            TetrahedronGeometry: ()=>Cg,
            Texture: ()=>wl,
            TextureLoader: ()=>_A,
            TorusGeometry: ()=>Ng,
            TorusKnotGeometry: ()=>Dg,
            Triangle: ()=>Wc,
            TriangleFanDrawMode: ()=>ks,
            TriangleStripDrawMode: ()=>Us,
            TrianglesDrawMode: ()=>zs,
            TubeGeometry: ()=>Lg,
            TwoPassDoubleSide: ()=>fr,
            UVMapping: ()=>sa,
            Uint16BufferAttribute: ()=>fu,
            Uint32BufferAttribute: ()=>gu,
            Uint8BufferAttribute: ()=>hu,
            Uint8ClampedBufferAttribute: ()=>du,
            Uniform: ()=>Lv,
            UniformsGroup: ()=>Rv,
            UniformsLib: ()=>gh,
            UniformsUtils: ()=>Ju,
            UnsignedByteType: ()=>Ea,
            UnsignedInt248Type: ()=>Pa,
            UnsignedIntType: ()=>Na,
            UnsignedShort4444Type: ()=>Oa,
            UnsignedShort5551Type: ()=>Ra,
            UnsignedShortType: ()=>Ia,
            VSMShadowMap: ()=>ur,
            Vector2: ()=>tl,
            Vector3: ()=>Ol,
            Vector4: ()=>_l,
            VectorKeyframeTrack: ()=>cA,
            VideoTexture: ()=>lm,
            WebGL1Renderer: ()=>Xp,
            WebGL3DRenderTarget: ()=>Nl,
            WebGLArrayRenderTarget: ()=>Il,
            WebGLCoordinateSystem: ()=>Uo,
            WebGLCubeRenderTarget: ()=>rh,
            WebGLMultipleRenderTargets: ()=>Dl,
            WebGLRenderTarget: ()=>Sl,
            WebGLRenderer: ()=>Wp,
            WebGLUtils: ()=>Up,
            WebGPUCoordinateSystem: ()=>ko,
            WireframeGeometry: ()=>Og,
            WrapAroundEnding: ()=>Os,
            ZeroCurvatureEnding: ()=>Ds,
            ZeroFactor: ()=>Sr,
            ZeroSlopeEnding: ()=>Ls,
            ZeroStencilOp: ()=>to,
            _SRGBAFormat: ()=>zo,
            createCanvasElement: ()=>ol,
            sRGBEncoding: ()=>js
        });
        var e = n(540), r = n(72), a = n.n(r), s = n(825), o = n.n(s), l = n(659), c = n.n(l), u = n(56), h = n.n(u), d = n(159), p = n.n(d), f = n(113), m = n.n(f), g = n(809), A = {};
        A.styleTagTransform = m(), A.setAttributes = h(), A.insert = c().bind(null, "head"), A.domAPI = o(), A.insertStyleElement = p(), a()(g.A, A), g.A && g.A.locals && g.A.locals;
        var v = n(875), y = {};
        y.styleTagTransform = m(), y.setAttributes = h(), y.insert = c().bind(null, "head"), y.domAPI = o(), y.insertStyleElement = p(), a()(v.A, y), v.A && v.A.locals && v.A.locals;
        var M = n(482), b = {};
        b.styleTagTransform = m(), b.setAttributes = h(), b.insert = c().bind(null, "head"), b.domAPI = o(), b.insertStyleElement = p(), a()(M.A, b), M.A && M.A.locals && M.A.locals;
        var x = n(928), w = {};
        w.styleTagTransform = m(), w.setAttributes = h(), w.insert = c().bind(null, "head"), w.domAPI = o(), w.insertStyleElement = p(), a()(x.A, w), x.A && x.A.locals && x.A.locals;
        var _ = n(761), E = {};
        function S(t1) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)n[i - 1] = arguments[i];
            throw new Error("number" == typeof t1 ? "[MobX] minified error nr: " + t1 + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + t1);
        }
        E.styleTagTransform = m(), E.setAttributes = h(), E.insert = c().bind(null, "head"), E.domAPI = o(), E.insertStyleElement = p(), a()(_.A, E), _.A && _.A.locals && _.A.locals;
        var T = {};
        function I() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : "undefined" != typeof self ? self : T;
        }
        var C = Object.assign, N = Object.getOwnPropertyDescriptor, D = Object.defineProperty, L = Object.prototype, O = [];
        Object.freeze(O);
        var R = {};
        Object.freeze(R);
        var P = "undefined" != typeof Proxy, z = Object.toString();
        function U() {
            P || S("Proxy not available");
        }
        function k(t1) {
            var e = !1;
            return function() {
                if (!e) return e = !0, t1.apply(this, arguments);
            };
        }
        var B = function() {};
        function j(t1) {
            return "function" == typeof t1;
        }
        function F(t1) {
            switch(typeof t1){
                case "string":
                case "symbol":
                case "number":
                    return !0;
            }
            return !1;
        }
        function H(t1) {
            return null !== t1 && "object" == typeof t1;
        }
        function V(t1) {
            if (!H(t1)) return !1;
            var e = Object.getPrototypeOf(t1);
            if (null == e) return !0;
            var n = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
            return "function" == typeof n && n.toString() === z;
        }
        function Q(t1) {
            var e = null == t1 ? void 0 : t1.constructor;
            return !!e && ("GeneratorFunction" === e.name || "GeneratorFunction" === e.displayName);
        }
        function G(t1, e, n) {
            D(t1, e, {
                enumerable: !1,
                writable: !0,
                configurable: !0,
                value: n
            });
        }
        function W(t1, e, n) {
            D(t1, e, {
                enumerable: !1,
                writable: !1,
                configurable: !0,
                value: n
            });
        }
        function X(t1, e) {
            var n = "isMobX" + t1;
            return e.prototype[n] = !0, function(t1) {
                return H(t1) && !0 === t1[n];
            };
        }
        function Y(t1) {
            return t1 instanceof Map;
        }
        function Z(t1) {
            return t1 instanceof Set;
        }
        var q = void 0 !== Object.getOwnPropertySymbols, J = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : q ? function(t1) {
            return Object.getOwnPropertyNames(t1).concat(Object.getOwnPropertySymbols(t1));
        } : Object.getOwnPropertyNames;
        function K(t1) {
            return null === t1 ? null : "object" == typeof t1 ? "" + t1 : t1;
        }
        function $(t1, e) {
            return L.hasOwnProperty.call(t1, e);
        }
        var tt = Object.getOwnPropertyDescriptors || function(t1) {
            var e = {};
            return J(t1).forEach(function(n) {
                e[n] = N(t1, n);
            }), e;
        };
        function et(t1, e) {
            for(var n = 0; n < e.length; n++){
                var i = e[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t1, "symbol" == typeof (r = function(t1, e) {
                    if ("object" != typeof t1 || null === t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(i.key)) ? r : String(r), i);
            }
            var r;
        }
        function nt(t1, e, n) {
            return e && et(t1.prototype, e), n && et(t1, n), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), t1;
        }
        function it() {
            return it = Object.assign ? Object.assign.bind() : function(t1) {
                for(var e = 1; e < arguments.length; e++){
                    var n = arguments[e];
                    for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t1[i] = n[i]);
                }
                return t1;
            }, it.apply(this, arguments);
        }
        function rt(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, at(t1, e);
        }
        function at(t1, e) {
            return at = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
                return t1.__proto__ = e, t1;
            }, at(t1, e);
        }
        function st(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }
        function ot(t1, e) {
            (null == e || e > t1.length) && (e = t1.length);
            for(var n = 0, i = new Array(e); n < e; n++)i[n] = t1[n];
            return i;
        }
        function lt(t1, e) {
            var n = "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (n) return (n = n.call(t1)).next.bind(n);
            if (Array.isArray(t1) || (n = function(t1, e) {
                if (t1) {
                    if ("string" == typeof t1) return ot(t1, e);
                    var n = Object.prototype.toString.call(t1).slice(8, -1);
                    return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ot(t1, e) : void 0;
                }
            }(t1)) || e && t1 && "number" == typeof t1.length) {
                n && (t1 = n);
                var i = 0;
                return function() {
                    return i >= t1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t1[i++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var ct = Symbol("mobx-stored-annotations");
        function ut(t1) {
            return Object.assign(function(e, n) {
                if (dt(n)) return t1.decorate_20223_(e, n);
                ht(e, n, t1);
            }, t1);
        }
        function ht(t1, e, n) {
            $(t1, ct) || G(t1, ct, it({}, t1[ct])), function(t1) {
                return t1.annotationType_ === Mt;
            }(n) || (t1[ct][e] = n);
        }
        function dt(t1) {
            return "object" == typeof t1 && "string" == typeof t1.kind;
        }
        var pt = Symbol("mobx administration"), ft = function() {
            function t1(t1) {
                void 0 === t1 && (t1 = "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = new Set, this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ve.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = t1;
            }
            var e = t1.prototype;
            return e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.reportObserved = function() {
                return Fe(this);
            }, e.reportChanged = function() {
                Be(), He(this), je();
            }, e.toString = function() {
                return this.name_;
            }, t1;
        }(), mt = X("Atom", ft);
        function gt(t1, e, n) {
            void 0 === e && (e = B), void 0 === n && (n = B);
            var i = new ft(t1);
            return e !== B && un(on, i, e, undefined), n !== B && cn(i, n), i;
        }
        var At = {
            identity: function(t1, e) {
                return t1 === e;
            },
            structural: function(t1, e) {
                return Ii(t1, e);
            },
            default: function(t1, e) {
                return Object.is ? Object.is(t1, e) : t1 === e ? 0 !== t1 || 1 / t1 == 1 / e : t1 != t1 && e != e;
            },
            shallow: function(t1, e) {
                return Ii(t1, e, 1);
            }
        };
        function vt(t1, e, n) {
            return xn(t1) ? t1 : Array.isArray(t1) ? ie.array(t1, {
                name: n
            }) : V(t1) ? ie.object(t1, void 0, {
                name: n
            }) : Y(t1) ? ie.map(t1, {
                name: n
            }) : Z(t1) ? ie.set(t1, {
                name: n
            }) : "function" != typeof t1 || an(t1) || bn(t1) ? t1 : Q(t1) ? yn(t1) : rn(n, t1);
        }
        function yt(t1) {
            return t1;
        }
        var Mt = "override";
        function bt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: xt,
                extend_: wt,
                decorate_20223_: _t
            };
        }
        function xt(t1, e, n, i) {
            var r;
            if (null != (r = this.options_) && r.bound) return null === this.extend_(t1, e, n, !1) ? 0 : 1;
            if (i === t1.target_) return null === this.extend_(t1, e, n, !1) ? 0 : 2;
            if (an(n.value)) return 1;
            var a = Et(t1, this, e, n, !1);
            return D(i, e, a), 2;
        }
        function wt(t1, e, n, i) {
            var r = Et(t1, this, e, n);
            return t1.defineProperty_(e, r, i);
        }
        function _t(t1, e) {
            var n = e.kind, i = e.name, r = e.addInitializer, a = this;
            if ("field" != n) {
                var s, o, l, c, u, h;
                if ("method" == n) return an(t1) || (o = t1, t1 = pe(null != (l = null == (c = a.options_) ? void 0 : c.name) ? l : i.toString(), o, null != (u = null == (h = a.options_) ? void 0 : h.autoAction) && u)), null != (s = this.options_) && s.bound && r(function() {
                    var t1 = this, e = t1[i].bind(t1);
                    e.isMobxAction = !0, t1[i] = e;
                }), t1;
                S("Cannot apply '" + a.annotationType_ + "' to '" + String(i) + "' (kind: " + n + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
            } else r(function() {
                ht(this, i, a);
            });
        }
        function Et(t1, e, n, i, r) {
            var a, s, o, l, c, u, h, d;
            void 0 === r && (r = ze.safeDescriptors), d = i, e.annotationType_, d.value;
            var p, f = i.value;
            return null != (a = e.options_) && a.bound && (f = f.bind(null != (p = t1.proxy_) ? p : t1.target_)), {
                value: pe(null != (s = null == (o = e.options_) ? void 0 : o.name) ? s : n.toString(), f, null != (l = null == (c = e.options_) ? void 0 : c.autoAction) && l, null != (u = e.options_) && u.bound ? null != (h = t1.proxy_) ? h : t1.target_ : void 0),
                configurable: !r || t1.isPlainObject_,
                enumerable: !1,
                writable: !r
            };
        }
        function St(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Tt,
                extend_: It,
                decorate_20223_: Ct
            };
        }
        function Tt(t1, e, n, i) {
            var r;
            if (i === t1.target_) return null === this.extend_(t1, e, n, !1) ? 0 : 2;
            if (null != (r = this.options_) && r.bound && (!$(t1.target_, e) || !bn(t1.target_[e])) && null === this.extend_(t1, e, n, !1)) return 0;
            if (bn(n.value)) return 1;
            var a = Nt(t1, this, 0, n, !1, !1);
            return D(i, e, a), 2;
        }
        function It(t1, e, n, i) {
            var r, a = Nt(t1, this, 0, n, null == (r = this.options_) ? void 0 : r.bound);
            return t1.defineProperty_(e, a, i);
        }
        function Ct(t1, e) {
            var n, i = e.name, r = e.addInitializer;
            return bn(t1) || (t1 = yn(t1)), null != (n = this.options_) && n.bound && r(function() {
                var t1 = this, e = t1[i].bind(t1);
                e.isMobXFlow = !0, t1[i] = e;
            }), t1;
        }
        function Nt(t1, e, n, i, r, a) {
            var s;
            void 0 === a && (a = ze.safeDescriptors), s = i, e.annotationType_, s.value;
            var o, l = i.value;
            return bn(l) || (l = yn(l)), r && ((l = l.bind(null != (o = t1.proxy_) ? o : t1.target_)).isMobXFlow = !0), {
                value: l,
                configurable: !a || t1.isPlainObject_,
                enumerable: !1,
                writable: !a
            };
        }
        function Dt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Lt,
                extend_: Ot,
                decorate_20223_: Rt
            };
        }
        function Lt(t1, e, n) {
            return null === this.extend_(t1, e, n, !1) ? 0 : 1;
        }
        function Ot(t1, e, n, i) {
            var r;
            return r = n, this.annotationType_, r.get, t1.defineComputedProperty_(e, it({}, this.options_, {
                get: n.get,
                set: n.set
            }), i);
        }
        function Rt(t1, e) {
            var n = this, i = e.name;
            return (0, e.addInitializer)(function() {
                var e = oi(this)[pt], r = it({}, n.options_, {
                    get: t1,
                    context: this
                });
                r.name || (r.name = "ObservableObject." + i.toString()), e.values_.set(i, new Me(r));
            }), function() {
                return this[pt].getObservablePropValue_(i);
            };
        }
        function Pt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: zt,
                extend_: Ut,
                decorate_20223_: kt
            };
        }
        function zt(t1, e, n) {
            return null === this.extend_(t1, e, n, !1) ? 0 : 1;
        }
        function Ut(t1, e, n, i) {
            var r, a;
            return this.annotationType_, t1.defineObservableProperty_(e, n.value, null != (r = null == (a = this.options_) ? void 0 : a.enhancer) ? r : vt, i);
        }
        function kt(t1, e) {
            var n = this, i = e.kind, r = e.name, a = new WeakSet;
            function s(t1, e) {
                var i, s, o = oi(t1)[pt], l = new Ae(e, null != (i = null == (s = n.options_) ? void 0 : s.enhancer) ? i : vt, "ObservableObject." + r.toString(), !1);
                o.values_.set(r, l), a.add(t1);
            }
            if ("accessor" == i) return {
                get: function() {
                    return a.has(this) || s(this, t1.get.call(this)), this[pt].getObservablePropValue_(r);
                },
                set: function(t1) {
                    return a.has(this) || s(this, t1), this[pt].setObservablePropValue_(r, t1);
                },
                init: function(t1) {
                    return a.has(this) || s(this, t1), t1;
                }
            };
        }
        var Bt = "true", jt = Ft();
        function Ft(t1) {
            return {
                annotationType_: Bt,
                options_: t1,
                make_: Ht,
                extend_: Vt,
                decorate_20223_: Qt
            };
        }
        function Ht(t1, e, n, i) {
            var r, a, s, o;
            if (n.get) return oe.make_(t1, e, n, i);
            if (n.set) {
                var l = pe(e.toString(), n.set);
                return i === t1.target_ ? null === t1.defineProperty_(e, {
                    configurable: !ze.safeDescriptors || t1.isPlainObject_,
                    set: l
                }) ? 0 : 2 : (D(i, e, {
                    configurable: !0,
                    set: l
                }), 2);
            }
            if (i !== t1.target_ && "function" == typeof n.value) return Q(n.value) ? (null != (o = this.options_) && o.autoBind ? yn.bound : yn).make_(t1, e, n, i) : (null != (s = this.options_) && s.autoBind ? rn.bound : rn).make_(t1, e, n, i);
            var c, u = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? ie.ref : ie;
            return "function" == typeof n.value && null != (a = this.options_) && a.autoBind && (n.value = n.value.bind(null != (c = t1.proxy_) ? c : t1.target_)), u.make_(t1, e, n, i);
        }
        function Vt(t1, e, n, i) {
            var r, a, s;
            return n.get ? oe.extend_(t1, e, n, i) : n.set ? t1.defineProperty_(e, {
                configurable: !ze.safeDescriptors || t1.isPlainObject_,
                set: pe(e.toString(), n.set)
            }, i) : ("function" == typeof n.value && null != (r = this.options_) && r.autoBind && (n.value = n.value.bind(null != (s = t1.proxy_) ? s : t1.target_)), (!1 === (null == (a = this.options_) ? void 0 : a.deep) ? ie.ref : ie).extend_(t1, e, n, i));
        }
        function Qt(t1, e) {
            S("'" + this.annotationType_ + "' cannot be used as a decorator");
        }
        var Gt = {
            deep: !0,
            name: void 0,
            defaultDecorator: void 0,
            proxy: !0
        };
        function Wt(t1) {
            return t1 || Gt;
        }
        Object.freeze(Gt);
        var Xt = Pt("observable"), Yt = Pt("observable.ref", {
            enhancer: yt
        }), Zt = Pt("observable.shallow", {
            enhancer: function(t1, e, n) {
                return null == t1 || ui(t1) || Xn(t1) || ti(t1) || ii(t1) ? t1 : Array.isArray(t1) ? ie.array(t1, {
                    name: n,
                    deep: !1
                }) : V(t1) ? ie.object(t1, void 0, {
                    name: n,
                    deep: !1
                }) : Y(t1) ? ie.map(t1, {
                    name: n,
                    deep: !1
                }) : Z(t1) ? ie.set(t1, {
                    name: n,
                    deep: !1
                }) : void 0;
            }
        }), qt = Pt("observable.struct", {
            enhancer: function(t1, e) {
                return Ii(t1, e) ? e : t1;
            }
        }), Jt = ut(Xt);
        function Kt(t1) {
            var e, n, i;
            return !0 === t1.deep ? vt : !1 === t1.deep ? yt : (e = t1.defaultDecorator) && null != (n = null == (i = e.options_) ? void 0 : i.enhancer) ? n : vt;
        }
        function $t(t1, e, n) {
            return dt(e) ? Xt.decorate_20223_(t1, e) : F(e) ? void ht(t1, e, Xt) : xn(t1) ? t1 : V(t1) ? ie.object(t1, e, n) : Array.isArray(t1) ? ie.array(t1, e) : Y(t1) ? ie.map(t1, e) : Z(t1) ? ie.set(t1, e) : "object" == typeof t1 && null !== t1 ? t1 : ie.box(t1, e);
        }
        C($t, Jt);
        var te, ee, ne = {
            box: function(t1, e) {
                var n = Wt(e);
                return new Ae(t1, Kt(n), n.name, !0, n.equals);
            },
            array: function(t1, e) {
                var n = Wt(e);
                return (!1 === ze.useProxies || !1 === n.proxy ? xi : kn)(t1, Kt(n), n.name);
            },
            map: function(t1, e) {
                var n = Wt(e);
                return new $n(t1, Kt(n), n.name);
            },
            set: function(t1, e) {
                var n = Wt(e);
                return new ni(t1, Kt(n), n.name);
            },
            object: function(t1, e, n) {
                return Si(function() {
                    return pn(!1 === ze.useProxies || !1 === (null == n ? void 0 : n.proxy) ? oi({}, n) : function(t1, e) {
                        var n, i;
                        return U(), null != (i = (n = (t1 = oi(t1, e))[pt]).proxy_) ? i : n.proxy_ = new Proxy(t1, En);
                    }({}, n), t1, e);
                });
            },
            ref: ut(Yt),
            shallow: ut(Zt),
            deep: Jt,
            struct: ut(qt)
        }, ie = C($t, ne), re = "computed", ae = Dt(re), se = Dt("computed.struct", {
            equals: At.structural
        }), oe = function(t1, e) {
            if (dt(e)) return ae.decorate_20223_(t1, e);
            if (F(e)) return ht(t1, e, ae);
            if (V(t1)) return ut(Dt(re, t1));
            var n = V(e) ? e : {};
            return n.get = t1, n.name || (n.name = t1.name || ""), new Me(n);
        };
        Object.assign(oe, ae), oe.struct = ut(se);
        var le, ce = 0, ue = 1, he = null != (te = null == (ee = N(function() {}, "name")) ? void 0 : ee.configurable) && te, de = {
            value: "action",
            configurable: !0,
            writable: !1,
            enumerable: !1
        };
        function pe(t1, e, n, i) {
            function r() {
                return function(t1, e, n, i, r) {
                    var a = function(t1, e, n, i) {
                        var r = !1, a = 0, s = ze.trackingDerivation, o = !e || !s;
                        Be();
                        var l = ze.allowStateChanges;
                        o && (Ie(), l = fe(!0));
                        var c = {
                            runAsAction_: o,
                            prevDerivation_: s,
                            prevAllowStateChanges_: l,
                            prevAllowStateReads_: Ne(!0),
                            notifySpy_: r,
                            startTime_: a,
                            actionId_: ue++,
                            parentActionId_: ce
                        };
                        return ce = c.actionId_, c;
                    }(0, e);
                    try {
                        return n.apply(i, r);
                    } catch (t1) {
                        throw a.error_ = t1, t1;
                    } finally{
                        !function(t1) {
                            ce !== t1.actionId_ && S(30), ce = t1.parentActionId_, void 0 !== t1.error_ && (ze.suppressReactionErrors = !0), me(t1.prevAllowStateChanges_), De(t1.prevAllowStateReads_), je(), t1.runAsAction_ && Ce(t1.prevDerivation_), ze.suppressReactionErrors = !1;
                        }(a);
                    }
                }(0, n, e, i || this, arguments);
            }
            return void 0 === n && (n = !1), r.isMobxAction = !0, r.toString = function() {
                return e.toString();
            }, he && (de.value = t1, D(r, "name", de)), r;
        }
        function fe(t1) {
            var e = ze.allowStateChanges;
            return ze.allowStateChanges = t1, e;
        }
        function me(t1) {
            ze.allowStateChanges = t1;
        }
        le = Symbol.toPrimitive;
        var ge, Ae = function(t1) {
            function e(e, n, i, r, a) {
                var s;
                return void 0 === i && (i = "ObservableValue"), void 0 === r && (r = !0), void 0 === a && (a = At.default), (s = t1.call(this, i) || this).enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = n, s.name_ = i, s.equals = a, s.value_ = n(e, void 0, i), s;
            }
            rt(e, t1);
            var n = e.prototype;
            return n.dehanceValue = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, n.set = function(t1) {
                this.value_, (t1 = this.prepareNewValue_(t1)) !== ze.UNCHANGED && this.setNewValue_(t1);
            }, n.prepareNewValue_ = function(t1) {
                if (Sn(this)) {
                    var e = In(this, {
                        object: this,
                        type: Pn,
                        newValue: t1
                    });
                    if (!e) return ze.UNCHANGED;
                    t1 = e.newValue;
                }
                return t1 = this.enhancer(t1, this.value_, this.name_), this.equals(this.value_, t1) ? ze.UNCHANGED : t1;
            }, n.setNewValue_ = function(t1) {
                var e = this.value_;
                this.value_ = t1, this.reportChanged(), Cn(this) && Dn(this, {
                    type: Pn,
                    object: this,
                    newValue: t1,
                    oldValue: e
                });
            }, n.get = function() {
                return this.reportObserved(), this.dehanceValue(this.value_);
            }, n.intercept_ = function(t1) {
                return Tn(this, t1);
            }, n.observe_ = function(t1, e) {
                return e && t1({
                    observableKind: "value",
                    debugObjectName: this.name_,
                    object: this,
                    type: Pn,
                    newValue: this.value_,
                    oldValue: void 0
                }), Nn(this, t1);
            }, n.raw = function() {
                return this.value_;
            }, n.toJSON = function() {
                return this.get();
            }, n.toString = function() {
                return this.name_ + "[" + this.value_ + "]";
            }, n.valueOf = function() {
                return K(this.get());
            }, n[le] = function() {
                return this.valueOf();
            }, e;
        }(ft);
        ge = Symbol.toPrimitive;
        var ve, ye, Me = function() {
            function t1(t1) {
                this.dependenciesState_ = ve.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = new Set, this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ve.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new xe(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = ye.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, t1.get || S(31), this.derivation = t1.get, this.name_ = t1.name || "ComputedValue", t1.set && (this.setter_ = pe("ComputedValue-setter", t1.set)), this.equals_ = t1.equals || (t1.compareStructural || t1.struct ? At.structural : At.default), this.scope_ = t1.context, this.requiresReaction_ = t1.requiresReaction, this.keepAlive_ = !!t1.keepAlive;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                var t1;
                (t1 = this).lowestObserverState_ === ve.UP_TO_DATE_ && (t1.lowestObserverState_ = ve.POSSIBLY_STALE_, t1.observers_.forEach(function(t1) {
                    t1.dependenciesState_ === ve.UP_TO_DATE_ && (t1.dependenciesState_ = ve.POSSIBLY_STALE_, t1.onBecomeStale_());
                }));
            }, e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.get = function() {
                if (this.isComputing_ && S(32, this.name_, this.derivation), 0 !== ze.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                    if (Fe(this), _e(this)) {
                        var t1 = ze.trackingContext;
                        this.keepAlive_ && !t1 && (ze.trackingContext = this), this.trackAndCompute() && (e = this).lowestObserverState_ !== ve.STALE_ && (e.lowestObserverState_ = ve.STALE_, e.observers_.forEach(function(t1) {
                            t1.dependenciesState_ === ve.POSSIBLY_STALE_ ? t1.dependenciesState_ = ve.STALE_ : t1.dependenciesState_ === ve.UP_TO_DATE_ && (e.lowestObserverState_ = ve.UP_TO_DATE_);
                        })), ze.trackingContext = t1;
                    }
                } else _e(this) && (this.warnAboutUntrackedRead_(), Be(), this.value_ = this.computeValue_(!1), je());
                var e, n = this.value_;
                if (we(n)) throw n.cause;
                return n;
            }, e.set = function(t1) {
                if (this.setter_) {
                    this.isRunningSetter_ && S(33, this.name_), this.isRunningSetter_ = !0;
                    try {
                        this.setter_.call(this.scope_, t1);
                    } finally{
                        this.isRunningSetter_ = !1;
                    }
                } else S(34, this.name_);
            }, e.trackAndCompute = function() {
                var t1 = this.value_, e = this.dependenciesState_ === ve.NOT_TRACKING_, n = this.computeValue_(!0), i = e || we(t1) || we(n) || !this.equals_(t1, n);
                return i && (this.value_ = n), i;
            }, e.computeValue_ = function(t1) {
                this.isComputing_ = !0;
                var e, n = fe(!1);
                if (t1) e = Ee(this, this.derivation, this.scope_);
                else if (!0 === ze.disableErrorBoundaries) e = this.derivation.call(this.scope_);
                else try {
                    e = this.derivation.call(this.scope_);
                } catch (t1) {
                    e = new xe(t1);
                }
                return me(n), this.isComputing_ = !1, e;
            }, e.suspend_ = function() {
                this.keepAlive_ || (Se(this), this.value_ = void 0);
            }, e.observe_ = function(t1, e) {
                var n = this, i = !0, r = void 0;
                return function(t1, e) {
                    var n, i, r, a, s;
                    void 0 === e && (e = R);
                    var o, l = null != (n = null == (i = e) ? void 0 : i.name) ? n : "Autorun";
                    if (e.scheduler || e.delay) {
                        var c = function(t1) {
                            return t1.scheduler ? t1.scheduler : t1.delay ? function(e) {
                                return setTimeout(e, t1.delay);
                            } : sn;
                        }(e), u = !1;
                        o = new Ve(l, function() {
                            u || (u = !0, c(function() {
                                u = !1, o.isDisposed_ || o.track(h);
                            }));
                        }, e.onError, e.requiresObservable);
                    } else o = new Ve(l, function() {
                        this.track(h);
                    }, e.onError, e.requiresObservable);
                    function h() {
                        t1(o);
                    }
                    return null != (r = e) && null != (a = r.signal) && a.aborted || o.schedule_(), o.getDisposer_(null == (s = e) ? void 0 : s.signal);
                }(function() {
                    var a = n.get();
                    if (!i || e) {
                        var s = Ie();
                        t1({
                            observableKind: "computed",
                            debugObjectName: n.name_,
                            type: Pn,
                            object: n,
                            newValue: a,
                            oldValue: r
                        }), Ce(s);
                    }
                    i = !1, r = a;
                });
            }, e.warnAboutUntrackedRead_ = function() {}, e.toString = function() {
                return this.name_ + "[" + this.derivation.toString() + "]";
            }, e.valueOf = function() {
                return K(this.get());
            }, e[ge] = function() {
                return this.valueOf();
            }, t1;
        }(), be = X("ComputedValue", Me);
        !function(t1) {
            t1[t1.NOT_TRACKING_ = -1] = "NOT_TRACKING_", t1[t1.UP_TO_DATE_ = 0] = "UP_TO_DATE_", t1[t1.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", t1[t1.STALE_ = 2] = "STALE_";
        }(ve || (ve = {})), function(t1) {
            t1[t1.NONE = 0] = "NONE", t1[t1.LOG = 1] = "LOG", t1[t1.BREAK = 2] = "BREAK";
        }(ye || (ye = {}));
        var xe = function(t1) {
            this.cause = void 0, this.cause = t1;
        };
        function we(t1) {
            return t1 instanceof xe;
        }
        function _e(t1) {
            switch(t1.dependenciesState_){
                case ve.UP_TO_DATE_:
                    return !1;
                case ve.NOT_TRACKING_:
                case ve.STALE_:
                    return !0;
                case ve.POSSIBLY_STALE_:
                    for(var e = Ne(!0), n = Ie(), i = t1.observing_, r = i.length, a = 0; a < r; a++){
                        var s = i[a];
                        if (be(s)) {
                            if (ze.disableErrorBoundaries) s.get();
                            else try {
                                s.get();
                            } catch (t1) {
                                return Ce(n), De(e), !0;
                            }
                            if (t1.dependenciesState_ === ve.STALE_) return Ce(n), De(e), !0;
                        }
                    }
                    return Le(t1), Ce(n), De(e), !1;
            }
        }
        function Ee(t1, e, n) {
            var i = Ne(!0);
            Le(t1), t1.newObserving_ = new Array(0 === t1.runId_ ? 100 : t1.observing_.length), t1.unboundDepsCount_ = 0, t1.runId_ = ++ze.runId;
            var r, a = ze.trackingDerivation;
            if (ze.trackingDerivation = t1, ze.inBatch++, !0 === ze.disableErrorBoundaries) r = e.call(n);
            else try {
                r = e.call(n);
            } catch (t1) {
                r = new xe(t1);
            }
            return ze.inBatch--, ze.trackingDerivation = a, function(t1) {
                for(var e = t1.observing_, n = t1.observing_ = t1.newObserving_, i = ve.UP_TO_DATE_, r = 0, a = t1.unboundDepsCount_, s = 0; s < a; s++){
                    var o = n[s];
                    0 === o.diffValue_ && (o.diffValue_ = 1, r !== s && (n[r] = o), r++), o.dependenciesState_ > i && (i = o.dependenciesState_);
                }
                for(n.length = r, t1.newObserving_ = null, a = e.length; a--;){
                    var l = e[a];
                    0 === l.diffValue_ && Ue(l, t1), l.diffValue_ = 0;
                }
                for(; r--;){
                    var c = n[r];
                    1 === c.diffValue_ && (c.diffValue_ = 0, h = t1, (u = c).observers_.add(h), u.lowestObserverState_ > h.dependenciesState_ && (u.lowestObserverState_ = h.dependenciesState_));
                }
                var u, h;
                i !== ve.UP_TO_DATE_ && (t1.dependenciesState_ = i, t1.onBecomeStale_());
            }(t1), De(i), r;
        }
        function Se(t1) {
            var e = t1.observing_;
            t1.observing_ = [];
            for(var n = e.length; n--;)Ue(e[n], t1);
            t1.dependenciesState_ = ve.NOT_TRACKING_;
        }
        function Te(t1) {
            var e = Ie();
            try {
                return t1();
            } finally{
                Ce(e);
            }
        }
        function Ie() {
            var t1 = ze.trackingDerivation;
            return ze.trackingDerivation = null, t1;
        }
        function Ce(t1) {
            ze.trackingDerivation = t1;
        }
        function Ne(t1) {
            var e = ze.allowStateReads;
            return ze.allowStateReads = t1, e;
        }
        function De(t1) {
            ze.allowStateReads = t1;
        }
        function Le(t1) {
            if (t1.dependenciesState_ !== ve.UP_TO_DATE_) {
                t1.dependenciesState_ = ve.UP_TO_DATE_;
                for(var e = t1.observing_, n = e.length; n--;)e[n].lowestObserverState_ = ve.UP_TO_DATE_;
            }
        }
        var Oe = function() {
            this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
        }, Re = !0, Pe = !1, ze = function() {
            var t1 = I();
            return t1.__mobxInstanceCount > 0 && !t1.__mobxGlobals && (Re = !1), t1.__mobxGlobals && t1.__mobxGlobals.version !== (new Oe).version && (Re = !1), Re ? t1.__mobxGlobals ? (t1.__mobxInstanceCount += 1, t1.__mobxGlobals.UNCHANGED || (t1.__mobxGlobals.UNCHANGED = {}), t1.__mobxGlobals) : (t1.__mobxInstanceCount = 1, t1.__mobxGlobals = new Oe) : (setTimeout(function() {
                Pe || S(35);
            }, 1), new Oe);
        }();
        function Ue(t1, e) {
            t1.observers_.delete(e), 0 === t1.observers_.size && ke(t1);
        }
        function ke(t1) {
            !1 === t1.isPendingUnobservation_ && (t1.isPendingUnobservation_ = !0, ze.pendingUnobservations.push(t1));
        }
        function Be() {
            ze.inBatch++;
        }
        function je() {
            if (0 == --ze.inBatch) {
                We();
                for(var t1 = ze.pendingUnobservations, e = 0; e < t1.length; e++){
                    var n = t1[e];
                    n.isPendingUnobservation_ = !1, 0 === n.observers_.size && (n.isBeingObserved_ && (n.isBeingObserved_ = !1, n.onBUO()), n instanceof Me && n.suspend_());
                }
                ze.pendingUnobservations = [];
            }
        }
        function Fe(t1) {
            var e = ze.trackingDerivation;
            return null !== e ? (e.runId_ !== t1.lastAccessedBy_ && (t1.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = t1, !t1.isBeingObserved_ && ze.trackingContext && (t1.isBeingObserved_ = !0, t1.onBO())), t1.isBeingObserved_) : (0 === t1.observers_.size && ze.inBatch > 0 && ke(t1), !1);
        }
        function He(t1) {
            t1.lowestObserverState_ !== ve.STALE_ && (t1.lowestObserverState_ = ve.STALE_, t1.observers_.forEach(function(t1) {
                t1.dependenciesState_ === ve.UP_TO_DATE_ && t1.onBecomeStale_(), t1.dependenciesState_ = ve.STALE_;
            }));
        }
        var Ve = function() {
            function t1(t1, e, n, i) {
                void 0 === t1 && (t1 = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = ve.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = ye.NONE, this.name_ = t1, this.onInvalidate_ = e, this.errorHandler_ = n, this.requiresObservable_ = i;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                this.schedule_();
            }, e.schedule_ = function() {
                this.isScheduled_ || (this.isScheduled_ = !0, ze.pendingReactions.push(this), We());
            }, e.isScheduled = function() {
                return this.isScheduled_;
            }, e.runReaction_ = function() {
                if (!this.isDisposed_) {
                    Be(), this.isScheduled_ = !1;
                    var t1 = ze.trackingContext;
                    if (ze.trackingContext = this, _e(this)) {
                        this.isTrackPending_ = !0;
                        try {
                            this.onInvalidate_();
                        } catch (t1) {
                            this.reportExceptionInDerivation_(t1);
                        }
                    }
                    ze.trackingContext = t1, je();
                }
            }, e.track = function(t1) {
                if (!this.isDisposed_) {
                    Be(), this.isRunning_ = !0;
                    var e = ze.trackingContext;
                    ze.trackingContext = this;
                    var n = Ee(this, t1, void 0);
                    ze.trackingContext = e, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && Se(this), we(n) && this.reportExceptionInDerivation_(n.cause), je();
                }
            }, e.reportExceptionInDerivation_ = function(t1) {
                var e = this;
                if (this.errorHandler_) this.errorHandler_(t1, this);
                else {
                    if (ze.disableErrorBoundaries) throw t1;
                    var n = "[mobx] uncaught error in '" + this + "'";
                    ze.suppressReactionErrors || console.error(n, t1), ze.globalReactionErrorHandlers.forEach(function(n) {
                        return n(t1, e);
                    });
                }
            }, e.dispose = function() {
                this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (Be(), Se(this), je()));
            }, e.getDisposer_ = function(t1) {
                var e = this, n = function n() {
                    e.dispose(), null == t1 || null == t1.removeEventListener || t1.removeEventListener("abort", n);
                };
                return null == t1 || null == t1.addEventListener || t1.addEventListener("abort", n), n[pt] = this, n;
            }, e.toString = function() {
                return "Reaction[" + this.name_ + "]";
            }, e.trace = function(t1) {
                void 0 === t1 && (t1 = !1);
            }, t1;
        }(), Qe = 100, Ge = function(t1) {
            return t1();
        };
        function We() {
            ze.inBatch > 0 || ze.isRunningReactions || Ge(Xe);
        }
        function Xe() {
            ze.isRunningReactions = !0;
            for(var t1 = ze.pendingReactions, e = 0; t1.length > 0;){
                ++e === Qe && (console.error("[mobx] cycle in reaction: " + t1[0]), t1.splice(0));
                for(var n = t1.splice(0), i = 0, r = n.length; i < r; i++)n[i].runReaction_();
            }
            ze.isRunningReactions = !1;
        }
        var Ye = X("Reaction", Ve), Ze = "action", qe = "autoAction", Je = bt(Ze), Ke = bt("action.bound", {
            bound: !0
        }), $e = bt(qe, {
            autoAction: !0
        }), tn = bt("autoAction.bound", {
            autoAction: !0,
            bound: !0
        });
        function en(t1) {
            return function(e, n) {
                return j(e) ? pe(e.name || "<unnamed action>", e, t1) : j(n) ? pe(e, n, t1) : dt(n) ? (t1 ? $e : Je).decorate_20223_(e, n) : F(n) ? ht(e, n, t1 ? $e : Je) : F(e) ? ut(bt(t1 ? qe : Ze, {
                    name: e,
                    autoAction: t1
                })) : void 0;
            };
        }
        var nn = en(!1);
        Object.assign(nn, Je);
        var rn = en(!0);
        function an(t1) {
            return j(t1) && !0 === t1.isMobxAction;
        }
        Object.assign(rn, $e), nn.bound = ut(Ke), rn.bound = ut(tn);
        var sn = function(t1) {
            return t1();
        };
        var on = "onBO", ln = "onBUO";
        function cn(t1, e, n) {
            return un(ln, t1, e, n);
        }
        function un(t1, e, n, i) {
            var r = "function" == typeof i ? wi(e, n) : wi(e), a = j(i) ? i : n, s = t1 + "L";
            return r[s] ? r[s].add(a) : r[s] = new Set([
                a
            ]), function() {
                var t1 = r[s];
                t1 && (t1.delete(a), 0 === t1.size && delete r[s]);
            };
        }
        var hn = "always";
        function dn(t1) {
            !0 === t1.isolateGlobalState && function() {
                if ((ze.pendingReactions.length || ze.inBatch || ze.isRunningReactions) && S(36), Pe = !0, Re) {
                    var t1 = I();
                    0 == --t1.__mobxInstanceCount && (t1.__mobxGlobals = void 0), ze = new Oe;
                }
            }();
            var e, n, i = t1.useProxies, r = t1.enforceActions;
            if (void 0 !== i && (ze.useProxies = i === hn || "never" !== i && "undefined" != typeof Proxy), "ifavailable" === i && (ze.verifyProxies = !0), void 0 !== r) {
                var a = r === hn ? hn : "observed" === r;
                ze.enforceActions = a, ze.allowStateChanges = !0 !== a && a !== hn;
            }
            [
                "computedRequiresReaction",
                "reactionRequiresObservable",
                "observableRequiresReaction",
                "disableErrorBoundaries",
                "safeDescriptors"
            ].forEach(function(e) {
                e in t1 && (ze[e] = !!t1[e]);
            }), ze.allowStateReads = !ze.observableRequiresReaction, t1.reactionScheduler && (e = t1.reactionScheduler, n = Ge, Ge = function(t1) {
                return e(function() {
                    return n(t1);
                });
            });
        }
        function pn(t1, e, n, i) {
            var r = tt(e);
            return Si(function() {
                var e = oi(t1, i)[pt];
                J(r).forEach(function(t1) {
                    e.extend_(t1, r[t1], !n || !(t1 in n) || n[t1]);
                });
            }), t1;
        }
        function fn(t1) {
            var e, n = {
                name: t1.name_
            };
            return t1.observing_ && t1.observing_.length > 0 && (n.dependencies = (e = t1.observing_, Array.from(new Set(e))).map(fn)), n;
        }
        var mn = 0;
        function gn() {
            this.message = "FLOW_CANCELLED";
        }
        gn.prototype = Object.create(Error.prototype);
        var An = St("flow"), vn = St("flow.bound", {
            bound: !0
        }), yn = Object.assign(function(t1, e) {
            if (dt(e)) return An.decorate_20223_(t1, e);
            if (F(e)) return ht(t1, e, An);
            var n = t1, i = n.name || "<unnamed flow>", r = function() {
                var t1, e = arguments, r = ++mn, a = nn(i + " - runid: " + r + " - init", n).apply(this, e), s = void 0, o = new Promise(function(e, n) {
                    var o = 0;
                    function l(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = nn(i + " - runid: " + r + " - yield " + o++, a.next).call(a, t1);
                        } catch (t1) {
                            return n(t1);
                        }
                        u(e);
                    }
                    function c(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = nn(i + " - runid: " + r + " - yield " + o++, a.throw).call(a, t1);
                        } catch (t1) {
                            return n(t1);
                        }
                        u(e);
                    }
                    function u(t1) {
                        if (!j(null == t1 ? void 0 : t1.then)) return t1.done ? e(t1.value) : (s = Promise.resolve(t1.value)).then(l, c);
                        t1.then(u, n);
                    }
                    t1 = n, l(void 0);
                });
                return o.cancel = nn(i + " - runid: " + r + " - cancel", function() {
                    try {
                        s && Mn(s);
                        var e = a.return(void 0), n = Promise.resolve(e.value);
                        n.then(B, B), Mn(n), t1(new gn);
                    } catch (e) {
                        t1(e);
                    }
                }), o;
            };
            return r.isMobXFlow = !0, r;
        }, An);
        function Mn(t1) {
            j(t1.cancel) && t1.cancel();
        }
        function bn(t1) {
            return !0 === (null == t1 ? void 0 : t1.isMobXFlow);
        }
        function xn(t1) {
            return function(t1, e) {
                return !!t1 && (void 0 !== e ? !!ui(t1) && t1[pt].values_.has(e) : ui(t1) || !!t1[pt] || mt(t1) || Ye(t1) || be(t1));
            }(t1);
        }
        function wn(t1, e) {
            void 0 === e && (e = void 0), Be();
            try {
                return t1.apply(e);
            } finally{
                je();
            }
        }
        function _n(t1) {
            return t1[pt];
        }
        yn.bound = ut(vn);
        var En = {
            has: function(t1, e) {
                return _n(t1).has_(e);
            },
            get: function(t1, e) {
                return _n(t1).get_(e);
            },
            set: function(t1, e, n) {
                var i;
                return !!F(e) && (null == (i = _n(t1).set_(e, n, !0)) || i);
            },
            deleteProperty: function(t1, e) {
                var n;
                return !!F(e) && (null == (n = _n(t1).delete_(e, !0)) || n);
            },
            defineProperty: function(t1, e, n) {
                var i;
                return null == (i = _n(t1).defineProperty_(e, n)) || i;
            },
            ownKeys: function(t1) {
                return _n(t1).ownKeys_();
            },
            preventExtensions: function(t1) {
                S(13);
            }
        };
        function Sn(t1) {
            return void 0 !== t1.interceptors_ && t1.interceptors_.length > 0;
        }
        function Tn(t1, e) {
            var n = t1.interceptors_ || (t1.interceptors_ = []);
            return n.push(e), k(function() {
                var t1 = n.indexOf(e);
                -1 !== t1 && n.splice(t1, 1);
            });
        }
        function In(t1, e) {
            var n = Ie();
            try {
                for(var i = [].concat(t1.interceptors_ || []), r = 0, a = i.length; r < a && ((e = i[r](e)) && !e.type && S(14), e); r++);
                return e;
            } finally{
                Ce(n);
            }
        }
        function Cn(t1) {
            return void 0 !== t1.changeListeners_ && t1.changeListeners_.length > 0;
        }
        function Nn(t1, e) {
            var n = t1.changeListeners_ || (t1.changeListeners_ = []);
            return n.push(e), k(function() {
                var t1 = n.indexOf(e);
                -1 !== t1 && n.splice(t1, 1);
            });
        }
        function Dn(t1, e) {
            var n = Ie(), i = t1.changeListeners_;
            if (i) {
                for(var r = 0, a = (i = i.slice()).length; r < a; r++)i[r](e);
                Ce(n);
            }
        }
        var Ln = Symbol("mobx-keys");
        function On(t1, e, n) {
            return V(t1) ? pn(t1, t1, e, n) : (Si(function() {
                var i = oi(t1, n)[pt];
                if (!t1[Ln]) {
                    var r = Object.getPrototypeOf(t1), a = new Set([].concat(J(t1), J(r)));
                    a.delete("constructor"), a.delete(pt), G(r, Ln, a);
                }
                t1[Ln].forEach(function(t1) {
                    return i.make_(t1, !e || !(t1 in e) || e[t1]);
                });
            }), t1);
        }
        var Rn = "splice", Pn = "update", zn = {
            get: function(t1, e) {
                var n = t1[pt];
                return e === pt ? n : "length" === e ? n.getArrayLength_() : "string" != typeof e || isNaN(e) ? $(Bn, e) ? Bn[e] : t1[e] : n.get_(parseInt(e));
            },
            set: function(t1, e, n) {
                var i = t1[pt];
                return "length" === e && i.setArrayLength_(n), "symbol" == typeof e || isNaN(e) ? t1[e] = n : i.set_(parseInt(e), n), !0;
            },
            preventExtensions: function() {
                S(15);
            }
        }, Un = function() {
            function t1(t1, e, n, i) {
                void 0 === t1 && (t1 = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = i, this.atom_ = new ft(t1), this.enhancer_ = function(t1, n) {
                    return e(t1, n, "ObservableArray[..]");
                };
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.dehanceValues_ = function(t1) {
                return void 0 !== this.dehancer && t1.length > 0 ? t1.map(this.dehancer) : t1;
            }, e.intercept_ = function(t1) {
                return Tn(this, t1);
            }, e.observe_ = function(t1, e) {
                return void 0 === e && (e = !1), e && t1({
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: "splice",
                    index: 0,
                    added: this.values_.slice(),
                    addedCount: this.values_.length,
                    removed: [],
                    removedCount: 0
                }), Nn(this, t1);
            }, e.getArrayLength_ = function() {
                return this.atom_.reportObserved(), this.values_.length;
            }, e.setArrayLength_ = function(t1) {
                ("number" != typeof t1 || isNaN(t1) || t1 < 0) && S("Out of range: " + t1);
                var e = this.values_.length;
                if (t1 !== e) {
                    if (t1 > e) {
                        for(var n = new Array(t1 - e), i = 0; i < t1 - e; i++)n[i] = void 0;
                        this.spliceWithArray_(e, 0, n);
                    } else this.spliceWithArray_(t1, e - t1);
                }
            }, e.updateArrayLength_ = function(t1, e) {
                t1 !== this.lastKnownLength_ && S(16), this.lastKnownLength_ += e, this.legacyMode_ && e > 0 && bi(t1 + e + 1);
            }, e.spliceWithArray_ = function(t1, e, n) {
                var i = this;
                this.atom_;
                var r = this.values_.length;
                if (void 0 === t1 ? t1 = 0 : t1 > r ? t1 = r : t1 < 0 && (t1 = Math.max(0, r + t1)), e = 1 === arguments.length ? r - t1 : null == e ? 0 : Math.max(0, Math.min(e, r - t1)), void 0 === n && (n = O), Sn(this)) {
                    var a = In(this, {
                        object: this.proxy_,
                        type: Rn,
                        index: t1,
                        removedCount: e,
                        added: n
                    });
                    if (!a) return O;
                    e = a.removedCount, n = a.added;
                }
                if (n = 0 === n.length ? n : n.map(function(t1) {
                    return i.enhancer_(t1, void 0);
                }), this.legacyMode_) {
                    var s = n.length - e;
                    this.updateArrayLength_(r, s);
                }
                var o = this.spliceItemsIntoValues_(t1, e, n);
                return 0 === e && 0 === n.length || this.notifyArraySplice_(t1, n, o), this.dehanceValues_(o);
            }, e.spliceItemsIntoValues_ = function(t1, e, n) {
                var i;
                if (n.length < 1e4) return (i = this.values_).splice.apply(i, [
                    t1,
                    e
                ].concat(n));
                var r = this.values_.slice(t1, t1 + e), a = this.values_.slice(t1 + e);
                this.values_.length += n.length - e;
                for(var s = 0; s < n.length; s++)this.values_[t1 + s] = n[s];
                for(var o = 0; o < a.length; o++)this.values_[t1 + n.length + o] = a[o];
                return r;
            }, e.notifyArrayChildUpdate_ = function(t1, e, n) {
                var i = !this.owned_ && !1, r = Cn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    type: Pn,
                    debugObjectName: this.atom_.name_,
                    index: t1,
                    newValue: e,
                    oldValue: n
                } : null;
                this.atom_.reportChanged(), r && Dn(this, a);
            }, e.notifyArraySplice_ = function(t1, e, n) {
                var i = !this.owned_ && !1, r = Cn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: Rn,
                    index: t1,
                    removed: n,
                    added: e,
                    removedCount: n.length,
                    addedCount: e.length
                } : null;
                this.atom_.reportChanged(), r && Dn(this, a);
            }, e.get_ = function(t1) {
                if (!(this.legacyMode_ && t1 >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[t1]);
                console.warn("[mobx] Out of bounds read: " + t1);
            }, e.set_ = function(t1, e) {
                var n = this.values_;
                if (this.legacyMode_ && t1 > n.length && S(17, t1, n.length), t1 < n.length) {
                    this.atom_;
                    var i = n[t1];
                    if (Sn(this)) {
                        var r = In(this, {
                            type: Pn,
                            object: this.proxy_,
                            index: t1,
                            newValue: e
                        });
                        if (!r) return;
                        e = r.newValue;
                    }
                    (e = this.enhancer_(e, i)) !== i && (n[t1] = e, this.notifyArrayChildUpdate_(t1, e, i));
                } else {
                    for(var a = new Array(t1 + 1 - n.length), s = 0; s < a.length - 1; s++)a[s] = void 0;
                    a[a.length - 1] = e, this.spliceWithArray_(n.length, 0, a);
                }
            }, t1;
        }();
        function kn(t1, e, n, i) {
            return void 0 === n && (n = "ObservableArray"), void 0 === i && (i = !1), U(), Si(function() {
                var r = new Un(n, e, i, !1);
                W(r.values_, pt, r);
                var a = new Proxy(r.values_, zn);
                return r.proxy_ = a, t1 && t1.length && r.spliceWithArray_(0, 0, t1), a;
            });
        }
        var Bn = {
            clear: function() {
                return this.splice(0);
            },
            replace: function(t1) {
                var e = this[pt];
                return e.spliceWithArray_(0, e.values_.length, t1);
            },
            toJSON: function() {
                return this.slice();
            },
            splice: function(t1, e) {
                for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)i[r - 2] = arguments[r];
                var a = this[pt];
                switch(arguments.length){
                    case 0:
                        return [];
                    case 1:
                        return a.spliceWithArray_(t1);
                    case 2:
                        return a.spliceWithArray_(t1, e);
                }
                return a.spliceWithArray_(t1, e, i);
            },
            spliceWithArray: function(t1, e, n) {
                return this[pt].spliceWithArray_(t1, e, n);
            },
            push: function() {
                for(var t1 = this[pt], e = arguments.length, n = new Array(e), i = 0; i < e; i++)n[i] = arguments[i];
                return t1.spliceWithArray_(t1.values_.length, 0, n), t1.values_.length;
            },
            pop: function() {
                return this.splice(Math.max(this[pt].values_.length - 1, 0), 1)[0];
            },
            shift: function() {
                return this.splice(0, 1)[0];
            },
            unshift: function() {
                for(var t1 = this[pt], e = arguments.length, n = new Array(e), i = 0; i < e; i++)n[i] = arguments[i];
                return t1.spliceWithArray_(0, 0, n), t1.values_.length;
            },
            reverse: function() {
                return ze.trackingDerivation && S(37, "reverse"), this.replace(this.slice().reverse()), this;
            },
            sort: function() {
                ze.trackingDerivation && S(37, "sort");
                var t1 = this.slice();
                return t1.sort.apply(t1, arguments), this.replace(t1), this;
            },
            remove: function(t1) {
                var e = this[pt], n = e.dehanceValues_(e.values_).indexOf(t1);
                return n > -1 && (this.splice(n, 1), !0);
            }
        };
        function jn(t1, e) {
            "function" == typeof Array.prototype[t1] && (Bn[t1] = e(t1));
        }
        function Fn(t1) {
            return function() {
                var e = this[pt];
                e.atom_.reportObserved();
                var n = e.dehanceValues_(e.values_);
                return n[t1].apply(n, arguments);
            };
        }
        function Hn(t1) {
            return function(e, n) {
                var i = this, r = this[pt];
                return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[t1](function(t1, r) {
                    return e.call(n, t1, r, i);
                });
            };
        }
        function Vn(t1) {
            return function() {
                var e = this, n = this[pt];
                n.atom_.reportObserved();
                var i = n.dehanceValues_(n.values_), r = arguments[0];
                return arguments[0] = function(t1, n, i) {
                    return r(t1, n, i, e);
                }, i[t1].apply(i, arguments);
            };
        }
        jn("at", Fn), jn("concat", Fn), jn("flat", Fn), jn("includes", Fn), jn("indexOf", Fn), jn("join", Fn), jn("lastIndexOf", Fn), jn("slice", Fn), jn("toString", Fn), jn("toLocaleString", Fn), jn("toSorted", Fn), jn("toSpliced", Fn), jn("with", Fn), jn("every", Hn), jn("filter", Hn), jn("find", Hn), jn("findIndex", Hn), jn("findLast", Hn), jn("findLastIndex", Hn), jn("flatMap", Hn), jn("forEach", Hn), jn("map", Hn), jn("some", Hn), jn("toReversed", Hn), jn("reduce", Vn), jn("reduceRight", Vn);
        var Qn, Gn, Wn = X("ObservableArrayAdministration", Un);
        function Xn(t1) {
            return H(t1) && Wn(t1[pt]);
        }
        var Yn = {}, Zn = "add", qn = "delete";
        Qn = Symbol.iterator, Gn = Symbol.toStringTag;
        var Jn, Kn, $n = function() {
            function t1(t1, e, n) {
                var i = this;
                void 0 === e && (e = vt), void 0 === n && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[pt] = Yn, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = e, this.name_ = n, j(Map) || S(18), Si(function() {
                    i.keysAtom_ = gt("ObservableMap.keys()"), i.data_ = new Map, i.hasMap_ = new Map, t1 && i.merge(t1);
                });
            }
            var e = t1.prototype;
            return e.has_ = function(t1) {
                return this.data_.has(t1);
            }, e.has = function(t1) {
                var e = this;
                if (!ze.trackingDerivation) return this.has_(t1);
                var n = this.hasMap_.get(t1);
                if (!n) {
                    var i = n = new Ae(this.has_(t1), yt, "ObservableMap.key?", !1);
                    this.hasMap_.set(t1, i), cn(i, function() {
                        return e.hasMap_.delete(t1);
                    });
                }
                return n.get();
            }, e.set = function(t1, e) {
                var n = this.has_(t1);
                if (Sn(this)) {
                    var i = In(this, {
                        type: n ? Pn : Zn,
                        object: this,
                        newValue: e,
                        name: t1
                    });
                    if (!i) return this;
                    e = i.newValue;
                }
                return n ? this.updateValue_(t1, e) : this.addValue_(t1, e), this;
            }, e.delete = function(t1) {
                var e = this;
                if (this.keysAtom_, Sn(this) && !In(this, {
                    type: qn,
                    object: this,
                    name: t1
                })) return !1;
                if (this.has_(t1)) {
                    var n = Cn(this), i = n ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: qn,
                        object: this,
                        oldValue: this.data_.get(t1).value_,
                        name: t1
                    } : null;
                    return wn(function() {
                        var n;
                        e.keysAtom_.reportChanged(), null == (n = e.hasMap_.get(t1)) || n.setNewValue_(!1), e.data_.get(t1).setNewValue_(void 0), e.data_.delete(t1);
                    }), n && Dn(this, i), !0;
                }
                return !1;
            }, e.updateValue_ = function(t1, e) {
                var n = this.data_.get(t1);
                if ((e = n.prepareNewValue_(e)) !== ze.UNCHANGED) {
                    var i = Cn(this), r = i ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Pn,
                        object: this,
                        oldValue: n.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    n.setNewValue_(e), i && Dn(this, r);
                }
            }, e.addValue_ = function(t1, e) {
                var n = this;
                this.keysAtom_, wn(function() {
                    var i, r = new Ae(e, n.enhancer_, "ObservableMap.key", !1);
                    n.data_.set(t1, r), e = r.value_, null == (i = n.hasMap_.get(t1)) || i.setNewValue_(!0), n.keysAtom_.reportChanged();
                });
                var i = Cn(this), r = i ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: Zn,
                    object: this,
                    name: t1,
                    newValue: e
                } : null;
                i && Dn(this, r);
            }, e.get = function(t1) {
                return this.has(t1) ? this.dehanceValue_(this.data_.get(t1).get()) : this.dehanceValue_(void 0);
            }, e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.keys = function() {
                return this.keysAtom_.reportObserved(), this.data_.keys();
            }, e.values = function() {
                var t1 = this, e = this.keys();
                return Di({
                    next: function() {
                        var n = e.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : t1.get(r)
                        };
                    }
                });
            }, e.entries = function() {
                var t1 = this, e = this.keys();
                return Di({
                    next: function() {
                        var n = e.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : [
                                r,
                                t1.get(r)
                            ]
                        };
                    }
                });
            }, e[Qn] = function() {
                return this.entries();
            }, e.forEach = function(t1, e) {
                for(var n, i = lt(this); !(n = i()).done;){
                    var r = n.value, a = r[0], s = r[1];
                    t1.call(e, s, a, this);
                }
            }, e.merge = function(t1) {
                var e = this;
                return ti(t1) && (t1 = new Map(t1)), wn(function() {
                    V(t1) ? (function(t1) {
                        var e = Object.keys(t1);
                        if (!q) return e;
                        var n = Object.getOwnPropertySymbols(t1);
                        return n.length ? [].concat(e, n.filter(function(e) {
                            return L.propertyIsEnumerable.call(t1, e);
                        })) : e;
                    })(t1).forEach(function(n) {
                        return e.set(n, t1[n]);
                    }) : Array.isArray(t1) ? t1.forEach(function(t1) {
                        var n = t1[0], i = t1[1];
                        return e.set(n, i);
                    }) : Y(t1) ? (t1.constructor !== Map && S(19, t1), t1.forEach(function(t1, n) {
                        return e.set(n, t1);
                    })) : null != t1 && S(20, t1);
                }), this;
            }, e.clear = function() {
                var t1 = this;
                wn(function() {
                    Te(function() {
                        for(var e, n = lt(t1.keys()); !(e = n()).done;){
                            var i = e.value;
                            t1.delete(i);
                        }
                    });
                });
            }, e.replace = function(t1) {
                var e = this;
                return wn(function() {
                    for(var n, i = function(t1) {
                        if (Y(t1) || ti(t1)) return t1;
                        if (Array.isArray(t1)) return new Map(t1);
                        if (V(t1)) {
                            var e = new Map;
                            for(var n in t1)e.set(n, t1[n]);
                            return e;
                        }
                        return S(21, t1);
                    }(t1), r = new Map, a = !1, s = lt(e.data_.keys()); !(n = s()).done;){
                        var o = n.value;
                        if (!i.has(o)) {
                            if (e.delete(o)) a = !0;
                            else {
                                var l = e.data_.get(o);
                                r.set(o, l);
                            }
                        }
                    }
                    for(var c, u = lt(i.entries()); !(c = u()).done;){
                        var h = c.value, d = h[0], p = h[1], f = e.data_.has(d);
                        if (e.set(d, p), e.data_.has(d)) {
                            var m = e.data_.get(d);
                            r.set(d, m), f || (a = !0);
                        }
                    }
                    if (!a) {
                        if (e.data_.size !== r.size) e.keysAtom_.reportChanged();
                        else for(var g = e.data_.keys(), A = r.keys(), v = g.next(), y = A.next(); !v.done;){
                            if (v.value !== y.value) {
                                e.keysAtom_.reportChanged();
                                break;
                            }
                            v = g.next(), y = A.next();
                        }
                    }
                    e.data_ = r;
                }), this;
            }, e.toString = function() {
                return "[object ObservableMap]";
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.observe_ = function(t1, e) {
                return Nn(this, t1);
            }, e.intercept_ = function(t1) {
                return Tn(this, t1);
            }, nt(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.keysAtom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Gn,
                    get: function() {
                        return "Map";
                    }
                }
            ]), t1;
        }(), ti = X("ObservableMap", $n), ei = {};
        Jn = Symbol.iterator, Kn = Symbol.toStringTag;
        var ni = function() {
            function t1(t1, e, n) {
                var i = this;
                void 0 === e && (e = vt), void 0 === n && (n = "ObservableSet"), this.name_ = void 0, this[pt] = ei, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, j(Set) || S(22), this.enhancer_ = function(t1, i) {
                    return e(t1, i, n);
                }, Si(function() {
                    i.atom_ = gt(i.name_), t1 && i.replace(t1);
                });
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.clear = function() {
                var t1 = this;
                wn(function() {
                    Te(function() {
                        for(var e, n = lt(t1.data_.values()); !(e = n()).done;){
                            var i = e.value;
                            t1.delete(i);
                        }
                    });
                });
            }, e.forEach = function(t1, e) {
                for(var n, i = lt(this); !(n = i()).done;){
                    var r = n.value;
                    t1.call(e, r, r, this);
                }
            }, e.add = function(t1) {
                var e = this;
                if (this.atom_, Sn(this) && !In(this, {
                    type: Zn,
                    object: this,
                    newValue: t1
                })) return this;
                if (!this.has(t1)) {
                    wn(function() {
                        e.data_.add(e.enhancer_(t1, void 0)), e.atom_.reportChanged();
                    });
                    var n = Cn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Zn,
                        object: this,
                        newValue: t1
                    } : null;
                    n && Dn(this, i);
                }
                return this;
            }, e.delete = function(t1) {
                var e = this;
                if (Sn(this) && !In(this, {
                    type: qn,
                    object: this,
                    oldValue: t1
                })) return !1;
                if (this.has(t1)) {
                    var n = Cn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: qn,
                        object: this,
                        oldValue: t1
                    } : null;
                    return wn(function() {
                        e.atom_.reportChanged(), e.data_.delete(t1);
                    }), n && Dn(this, i), !0;
                }
                return !1;
            }, e.has = function(t1) {
                return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(t1));
            }, e.entries = function() {
                var t1 = 0, e = Array.from(this.keys()), n = Array.from(this.values());
                return Di({
                    next: function() {
                        var i = t1;
                        return t1 += 1, i < n.length ? {
                            value: [
                                e[i],
                                n[i]
                            ],
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.keys = function() {
                return this.values();
            }, e.values = function() {
                this.atom_.reportObserved();
                var t1 = this, e = 0, n = Array.from(this.data_.values());
                return Di({
                    next: function() {
                        return e < n.length ? {
                            value: t1.dehanceValue_(n[e++]),
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.replace = function(t1) {
                var e = this;
                return ii(t1) && (t1 = new Set(t1)), wn(function() {
                    Array.isArray(t1) || Z(t1) ? (e.clear(), t1.forEach(function(t1) {
                        return e.add(t1);
                    })) : null != t1 && S("Cannot initialize set from " + t1);
                }), this;
            }, e.observe_ = function(t1, e) {
                return Nn(this, t1);
            }, e.intercept_ = function(t1) {
                return Tn(this, t1);
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.toString = function() {
                return "[object ObservableSet]";
            }, e[Jn] = function() {
                return this.values();
            }, nt(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.atom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Kn,
                    get: function() {
                        return "Set";
                    }
                }
            ]), t1;
        }(), ii = X("ObservableSet", ni), ri = Object.create(null), ai = "remove", si = function() {
            function t1(t1, e, n, i) {
                void 0 === e && (e = new Map), void 0 === i && (i = jt), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = t1, this.values_ = e, this.name_ = n, this.defaultAnnotation_ = i, this.keysAtom_ = new ft("ObservableObject.keys"), this.isPlainObject_ = V(this.target_);
            }
            var e = t1.prototype;
            return e.getObservablePropValue_ = function(t1) {
                return this.values_.get(t1).get();
            }, e.setObservablePropValue_ = function(t1, e) {
                var n = this.values_.get(t1);
                if (n instanceof Me) return n.set(e), !0;
                if (Sn(this)) {
                    var i = In(this, {
                        type: Pn,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    });
                    if (!i) return null;
                    e = i.newValue;
                }
                if ((e = n.prepareNewValue_(e)) !== ze.UNCHANGED) {
                    var r = Cn(this), a = r ? {
                        type: Pn,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        oldValue: n.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    n.setNewValue_(e), r && Dn(this, a);
                }
                return !0;
            }, e.get_ = function(t1) {
                return ze.trackingDerivation && !$(this.target_, t1) && this.has_(t1), this.target_[t1];
            }, e.set_ = function(t1, e, n) {
                return void 0 === n && (n = !1), $(this.target_, t1) ? this.values_.has(t1) ? this.setObservablePropValue_(t1, e) : n ? Reflect.set(this.target_, t1, e) : (this.target_[t1] = e, !0) : this.extend_(t1, {
                    value: e,
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                }, this.defaultAnnotation_, n);
            }, e.has_ = function(t1) {
                if (!ze.trackingDerivation) return t1 in this.target_;
                this.pendingKeys_ || (this.pendingKeys_ = new Map);
                var e = this.pendingKeys_.get(t1);
                return e || (e = new Ae(t1 in this.target_, yt, "ObservableObject.key?", !1), this.pendingKeys_.set(t1, e)), e.get();
            }, e.make_ = function(t1, e) {
                if (!0 === e && (e = this.defaultAnnotation_), !1 !== e) {
                    if (!(t1 in this.target_)) {
                        var n;
                        if (null != (n = this.target_[ct]) && n[t1]) return;
                        S(1, e.annotationType_, this.name_ + "." + t1.toString());
                    }
                    for(var i = this.target_; i && i !== L;){
                        var r = N(i, t1);
                        if (r) {
                            var a = e.make_(this, t1, r, i);
                            if (0 === a) return;
                            if (1 === a) break;
                        }
                        i = Object.getPrototypeOf(i);
                    }
                    hi(this, 0, t1);
                }
            }, e.extend_ = function(t1, e, n, i) {
                if (void 0 === i && (i = !1), !0 === n && (n = this.defaultAnnotation_), !1 === n) return this.defineProperty_(t1, e, i);
                var r = n.extend_(this, t1, e, i);
                return r && hi(this, 0, t1), r;
            }, e.defineProperty_ = function(t1, e, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    Be();
                    var i = this.delete_(t1);
                    if (!i) return i;
                    if (Sn(this)) {
                        var r = In(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Zn,
                            newValue: e.value
                        });
                        if (!r) return null;
                        var a = r.newValue;
                        e.value !== a && (e = it({}, e, {
                            value: a
                        }));
                    }
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, t1, e)) return !1;
                    } else D(this.target_, t1, e);
                    this.notifyPropertyAddition_(t1, e.value);
                } finally{
                    je();
                }
                return !0;
            }, e.defineObservableProperty_ = function(t1, e, n, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    Be();
                    var r = this.delete_(t1);
                    if (!r) return r;
                    if (Sn(this)) {
                        var a = In(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Zn,
                            newValue: e
                        });
                        if (!a) return null;
                        e = a.newValue;
                    }
                    var s = ci(t1), o = {
                        configurable: !ze.safeDescriptors || this.isPlainObject_,
                        enumerable: !0,
                        get: s.get,
                        set: s.set
                    };
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, t1, o)) return !1;
                    } else D(this.target_, t1, o);
                    var l = new Ae(e, n, "ObservableObject.key", !1);
                    this.values_.set(t1, l), this.notifyPropertyAddition_(t1, l.value_);
                } finally{
                    je();
                }
                return !0;
            }, e.defineComputedProperty_ = function(t1, e, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    Be();
                    var i = this.delete_(t1);
                    if (!i) return i;
                    if (Sn(this) && !In(this, {
                        object: this.proxy_ || this.target_,
                        name: t1,
                        type: Zn,
                        newValue: void 0
                    })) return null;
                    e.name || (e.name = "ObservableObject.key"), e.context = this.proxy_ || this.target_;
                    var r = ci(t1), a = {
                        configurable: !ze.safeDescriptors || this.isPlainObject_,
                        enumerable: !1,
                        get: r.get,
                        set: r.set
                    };
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, t1, a)) return !1;
                    } else D(this.target_, t1, a);
                    this.values_.set(t1, new Me(e)), this.notifyPropertyAddition_(t1, void 0);
                } finally{
                    je();
                }
                return !0;
            }, e.delete_ = function(t1, e) {
                if (void 0 === e && (e = !1), this.keysAtom_, !$(this.target_, t1)) return !0;
                if (Sn(this) && !In(this, {
                    object: this.proxy_ || this.target_,
                    name: t1,
                    type: ai
                })) return null;
                try {
                    var n, i;
                    Be();
                    var r, a = Cn(this), s = this.values_.get(t1), o = void 0;
                    if (!s && a && (o = null == (r = N(this.target_, t1)) ? void 0 : r.value), e) {
                        if (!Reflect.deleteProperty(this.target_, t1)) return !1;
                    } else delete this.target_[t1];
                    if (s && (this.values_.delete(t1), s instanceof Ae && (o = s.value_), He(s)), this.keysAtom_.reportChanged(), null == (n = this.pendingKeys_) || null == (i = n.get(t1)) || i.set(t1 in this.target_), a) {
                        var l = {
                            type: ai,
                            observableKind: "object",
                            object: this.proxy_ || this.target_,
                            debugObjectName: this.name_,
                            oldValue: o,
                            name: t1
                        };
                        a && Dn(this, l);
                    }
                } finally{
                    je();
                }
                return !0;
            }, e.observe_ = function(t1, e) {
                return Nn(this, t1);
            }, e.intercept_ = function(t1) {
                return Tn(this, t1);
            }, e.notifyPropertyAddition_ = function(t1, e) {
                var n, i, r = Cn(this);
                if (r) {
                    var a = r ? {
                        type: Zn,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    } : null;
                    r && Dn(this, a);
                }
                null == (n = this.pendingKeys_) || null == (i = n.get(t1)) || i.set(!0), this.keysAtom_.reportChanged();
            }, e.ownKeys_ = function() {
                return this.keysAtom_.reportObserved(), J(this.target_);
            }, e.keys_ = function() {
                return this.keysAtom_.reportObserved(), Object.keys(this.target_);
            }, t1;
        }();
        function oi(t1, e) {
            var n;
            if ($(t1, pt)) return t1;
            var i = null != (n = null == e ? void 0 : e.name) ? n : "ObservableObject", r = new si(t1, new Map, String(i), function(t1) {
                var e;
                return t1 ? null != (e = t1.defaultDecorator) ? e : Ft(t1) : void 0;
            }(e));
            return G(t1, pt, r), t1;
        }
        var li = X("ObservableObjectAdministration", si);
        function ci(t1) {
            return ri[t1] || (ri[t1] = {
                get: function() {
                    return this[pt].getObservablePropValue_(t1);
                },
                set: function(e) {
                    return this[pt].setObservablePropValue_(t1, e);
                }
            });
        }
        function ui(t1) {
            return !!H(t1) && li(t1[pt]);
        }
        function hi(t1, e, n) {
            var i;
            null == (i = t1.target_[ct]) || delete i[n];
        }
        var di, pi, fi = yi(0), mi = function() {
            var t1 = !1, e = {};
            return Object.defineProperty(e, "0", {
                set: function() {
                    t1 = !0;
                }
            }), Object.create(e)[0] = 1, !1 === t1;
        }(), gi = 0, Ai = function() {};
        di = Ai, pi = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(di.prototype, pi) : void 0 !== di.prototype.__proto__ ? di.prototype.__proto__ = pi : di.prototype = pi;
        var vi = function(t1, e, n) {
            function i(e, n, i, r) {
                var a;
                return void 0 === i && (i = "ObservableArray"), void 0 === r && (r = !1), a = t1.call(this) || this, Si(function() {
                    var t1 = new Un(i, n, r, !0);
                    t1.proxy_ = st(a), W(st(a), pt, t1), e && e.length && a.spliceWithArray(0, 0, e), mi && Object.defineProperty(st(a), "0", fi);
                }), a;
            }
            rt(i, t1);
            var r = i.prototype;
            return r.concat = function() {
                this[pt].atom_.reportObserved();
                for(var t1 = arguments.length, e = new Array(t1), n = 0; n < t1; n++)e[n] = arguments[n];
                return Array.prototype.concat.apply(this.slice(), e.map(function(t1) {
                    return Xn(t1) ? t1.slice() : t1;
                }));
            }, r[n] = function() {
                var t1 = this, e = 0;
                return Di({
                    next: function() {
                        return e < t1.length ? {
                            value: t1[e++],
                            done: !1
                        } : {
                            done: !0,
                            value: void 0
                        };
                    }
                });
            }, nt(i, [
                {
                    key: "length",
                    get: function() {
                        return this[pt].getArrayLength_();
                    },
                    set: function(t1) {
                        this[pt].setArrayLength_(t1);
                    }
                },
                {
                    key: e,
                    get: function() {
                        return "Array";
                    }
                }
            ]), i;
        }(Ai, Symbol.toStringTag, Symbol.iterator);
        function yi(t1) {
            return {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this[pt].get_(t1);
                },
                set: function(e) {
                    this[pt].set_(t1, e);
                }
            };
        }
        function Mi(t1) {
            D(vi.prototype, "" + t1, yi(t1));
        }
        function bi(t1) {
            if (t1 > gi) {
                for(var e = gi; e < t1 + 100; e++)Mi(e);
                gi = t1;
            }
        }
        function xi(t1, e, n) {
            return new vi(t1, e, n);
        }
        function wi(t1, e) {
            if ("object" == typeof t1 && null !== t1) {
                if (Xn(t1)) return void 0 !== e && S(23), t1[pt].atom_;
                if (ii(t1)) return t1.atom_;
                if (ti(t1)) {
                    if (void 0 === e) return t1.keysAtom_;
                    var n = t1.data_.get(e) || t1.hasMap_.get(e);
                    return n || S(25, e, Ei(t1)), n;
                }
                if (ui(t1)) {
                    if (!e) return S(26);
                    var i = t1[pt].values_.get(e);
                    return i || S(27, e, Ei(t1)), i;
                }
                if (mt(t1) || be(t1) || Ye(t1)) return t1;
            } else if (j(t1) && Ye(t1[pt])) return t1[pt];
            S(28);
        }
        function _i(t1, e) {
            return t1 || S(29), void 0 !== e ? _i(wi(t1, e)) : mt(t1) || be(t1) || Ye(t1) || ti(t1) || ii(t1) ? t1 : t1[pt] ? t1[pt] : void S(24, t1);
        }
        function Ei(t1, e) {
            var n;
            if (void 0 !== e) n = wi(t1, e);
            else {
                if (an(t1)) return t1.name;
                n = ui(t1) || ti(t1) || ii(t1) ? _i(t1) : wi(t1);
            }
            return n.name_;
        }
        function Si(t1) {
            var e = Ie(), n = fe(!0);
            Be();
            try {
                return t1();
            } finally{
                je(), me(n), Ce(e);
            }
        }
        Object.entries(Bn).forEach(function(t1) {
            var e = t1[0], n = t1[1];
            "concat" !== e && G(vi.prototype, e, n);
        }), bi(1e3);
        var Ti = L.toString;
        function Ii(t1, e, n) {
            return void 0 === n && (n = -1), Ci(t1, e, n);
        }
        function Ci(t1, e, n, i, r) {
            if (t1 === e) return 0 !== t1 || 1 / t1 == 1 / e;
            if (null == t1 || null == e) return !1;
            if (t1 != t1) return e != e;
            var a = typeof t1;
            if ("function" !== a && "object" !== a && "object" != typeof e) return !1;
            var s = Ti.call(t1);
            if (s !== Ti.call(e)) return !1;
            switch(s){
                case "[object RegExp]":
                case "[object String]":
                    return "" + t1 == "" + e;
                case "[object Number]":
                    return +t1 != +t1 ? +e != +e : 0 == +t1 ? 1 / +t1 == 1 / e : +t1 == +e;
                case "[object Date]":
                case "[object Boolean]":
                    return +t1 == +e;
                case "[object Symbol]":
                    return "undefined" != typeof Symbol && Symbol.valueOf.call(t1) === Symbol.valueOf.call(e);
                case "[object Map]":
                case "[object Set]":
                    n >= 0 && n++;
            }
            t1 = Ni(t1), e = Ni(e);
            var o = "[object Array]" === s;
            if (!o) {
                if ("object" != typeof t1 || "object" != typeof e) return !1;
                var l = t1.constructor, c = e.constructor;
                if (l !== c && !(j(l) && l instanceof l && j(c) && c instanceof c) && "constructor" in t1 && "constructor" in e) return !1;
            }
            if (0 === n) return !1;
            n < 0 && (n = -1), r = r || [];
            for(var u = (i = i || []).length; u--;)if (i[u] === t1) return r[u] === e;
            if (i.push(t1), r.push(e), o) {
                if ((u = t1.length) !== e.length) return !1;
                for(; u--;)if (!Ci(t1[u], e[u], n - 1, i, r)) return !1;
            } else {
                var h, d = Object.keys(t1);
                if (u = d.length, Object.keys(e).length !== u) return !1;
                for(; u--;)if (!$(e, h = d[u]) || !Ci(t1[h], e[h], n - 1, i, r)) return !1;
            }
            return i.pop(), r.pop(), !0;
        }
        function Ni(t1) {
            return Xn(t1) ? t1.slice() : Y(t1) || ti(t1) || Z(t1) || ii(t1) ? Array.from(t1.entries()) : t1;
        }
        function Di(t1) {
            return t1[Symbol.iterator] = Li, t1;
        }
        function Li() {
            return this;
        }
        function Oi(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        [
            "Symbol",
            "Map",
            "Set"
        ].forEach(function(t1) {
            void 0 === I()[t1] && S("MobX requires global '" + t1 + "' to be available or polyfilled");
        }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
            spy: function(t1) {
                return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
            },
            extras: {
                getDebugName: Ei
            },
            $mobx: pt
        }), dn({
            useProxies: "never"
        });
        const Ri = class {
            constructor(t1){
                Oi(this, "API_URL", null), Oi(this, "getBrandingData", (t1)=>t1 ? {
                        name: t1.company_name,
                        url: t1.company_url
                    } : null), Oi(this, "getParsedData", async (t1)=>{
                    var e, n;
                    const i = await this.loadJson(t1.json.value), r = this.getBrandingData(t1.widget_branding), a = t1.original_plans_img || [], s = t1.styled_plan_img || [], o = t1.floors.map((t1, e)=>{
                        var n, i;
                        return {
                            ...t1,
                            original_plan_img: null !== (n = null !== (i = s[e]) && void 0 !== i ? i : a[e]) && void 0 !== n ? n : null
                        };
                    });
                    return {
                        raw: t1,
                        parsed: {
                            locale: (null === (e = t1.widget_branding) || void 0 === e ? void 0 : e.widget_language) || "en",
                            logo: (null === (n = t1.widget_branding) || void 0 === n ? void 0 : n.logo_path) || null,
                            floors: o,
                            branding: r,
                            json: i
                        }
                    };
                }), Oi(this, "loadFurnitureData", async ()=>{
                    const t1 = "".concat(this.API_URL, "/api/furniture"), e = await fetch(t1);
                    return await e.json();
                }), Oi(this, "loadCrmWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/crm/plans/").concat(t1, "/widget"), n = await fetch(e, {
                        headers: {
                            "Widget-Version": "2.5.51"
                        }
                    }), i = await n.json();
                    return this.getParsedData(i);
                }), Oi(this, "loadWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/v2/widget"), n = await fetch(e, {
                        headers: {
                            "Widget-Version": "2.5.51"
                        }
                    }), i = await n.json();
                    return this.getParsedData(i);
                }), Oi(this, "loadEditorData", async (t1, e)=>{
                    const n = "".concat(this.API_URL, "/api/plans/").concat(t1, "/editor?token=").concat(e), i = await fetch(n);
                    return await i.json();
                }), Oi(this, "loadPanoramaData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/panorama"), n = await fetch(e);
                    return await n.json();
                }), Oi(this, "loadJson", async (t1)=>{
                    const e = await fetch(t1);
                    return await e.json();
                }), On(this), this.API_URL = t1;
            }
        }, Pi = JSON.parse('{"create-points":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","delete-points":"\u0423\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","research-plan":"\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","rotate-plan":"\u0412\u0440\u0430\u0449\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","ok":"\u041E\u043A","made-by-link":"https://hart-estate.ru/","made-by-text":"hart-estate.ru","instructions-hint-text":"","floor":"$0 \u044D\u0442\u0430\u0436"}'), zi = JSON.parse('{"create-points":"Create a point","delete-points":"Remove point","research-plan":"Research plan","rotate-plan":"Rotate plan","ok":"Ok","made-by-link":"https://getfloorplan.com/","made-by-text":"getfloorplan.com","instructions-hint-text":"","floor":"$0 floor","floorNumberEndings":{"1":"st","2":"nd","3":"d","rest":"th"}}'), Ui = JSON.parse('{"research-plan":"klicken","rotate-plan":"drehen","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 boden"}'), ki = JSON.parse('{"research-plan":"Explora el dise\xf1o","rotate-plan":"Girar dise\xf1o","rotate":"Comenzar","stop":"Detener","plan":"Disposici\xf3n","off":"Apagar","on":"Encender","ok":"Ok","menu":"Men\xfa","wasd":"WASD","view-from-above":"Vista desde arriba","free-camera":"Revisi\xf3n gratuita","shadows":"Oscuridad","hide-walls":"Ocultar paredes","show-walls":"Mostrar paredes","hide-doors":"Ocultar puertas","show-doors":"Mostrar puertas","material":"Material","texture":"Textura","color":"Color","wall-color":"Color de la pared","wall-texture":"Textura de la pared","upload-wall-texture":"Textura de la pared de carga","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 piso"}'), Bi = JSON.parse('{"create-points":"\u8A08\u6E2C\u958B\u59CB","delete-points":"\u78BA\u5B9A","research-plan":"\u30BF\u30C3\u30D7\u3057\u3066\u79FB\u52D5","rotate-plan":"\u30C9\u30E9\u30C3\u30B0\u3067\u79FB\u52D5","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 \u968E"}');
        function ji(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        dn({
            useProxies: "never"
        });
        const Fi = new class {
            constructor(){
                ji(this, "availableLocales", [
                    "ru",
                    "en",
                    "de",
                    "es",
                    "ja"
                ]), ji(this, "locales", {
                    ru: Pi,
                    en: zi,
                    de: Ui,
                    es: ki,
                    ja: Bi
                }), ji(this, "currentLocale", "en"), ji(this, "getLocaleText", (t1)=>this.localeData[t1]), ji(this, "setCurrentLocale", (t1)=>{
                    this.availableLocales.some((e)=>e === t1) && (this.currentLocale = t1);
                }), On(this);
            }
            get localeData() {
                return this.locales[this.currentLocale];
            }
        };
        function Hi(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        dn({
            useProxies: "never"
        });
        const Vi = new class {
            constructor(){
                Hi(this, "controlsVisible", !0), Hi(this, "currentFloorIndex", 0), Hi(this, "configParams", null), Hi(this, "listeners", {
                    resize: []
                }), On(this);
            }
            get primaryCameraPointId() {
                var t1;
                if (!this.config.json) return null;
                const e = this.config.json.Floors[this.currentFloorIndex];
                if (this.config.primaryCameraPointId && e.CameraPoints.some((t1)=>{
                    let { ID: e } = t1;
                    return e === this.config.primaryCameraPointId;
                })) return this.config.primaryCameraPointId;
                const n = e.PrimaryCameraPointId || null, i = (null === (t1 = this.config.json.Meta) || void 0 === t1 ? void 0 : t1.PrimaryCameraPointId) || null;
                return n || i;
            }
            get initialPanoramaRoomId() {
                if (!this.config.json) return null;
                const { Rooms: t1 } = this.config.json.Floors[this.currentFloorIndex].Units[0], e = [
                    ...t1
                ].sort((t1, e)=>e.Area - t1.Area), n = e.find((t1)=>{
                    let { Type: e } = t1;
                    return "Living" === e;
                }), i = e[0];
                return (null == n ? void 0 : n.ID) || (null == i ? void 0 : i.ID) || null;
            }
            get config() {
                return this.getFloorConfig(this.currentFloorIndex);
            }
            get prevFloorIndex() {
                const t1 = this.currentFloorIndex - 1;
                return t1 < 0 ? this.configParams.floors.length - 1 : t1;
            }
            get nextFloorIndex() {
                return (this.currentFloorIndex + 1) % this.configParams.floors.length;
            }
            get dictionaryOverrides() {
                return this.configParams.dictionaryOverrides;
            }
            get autoRotatePanarama() {
                return this.configParams.autoRotate;
            }
            get instructionVisible() {
                return this.configParams.instructionVisible;
            }
            get scales() {
                return this.config.scales;
            }
            getFloorConfig(t1) {
                const e = this.getFloorParamByKey("original_plan_img", t1), n = this.getFloorParamByKey("styled_plan_img", t1), i = this.getFloorParamByKey("original_plans_img", t1), r = this.getFloorParamByKey("top_view_img", t1), a = this.getFloorParamByKey("panorama", t1), s = this.getFloorParamByKey("rotate", t1);
                return {
                    ...this.configParams,
                    originalPlans: i,
                    planImage: n || e,
                    rotationData: s,
                    panoramaData: a,
                    topViewImage: r
                };
            }
            setCurrentFloorIndex(t1) {
                this.currentFloorIndex = t1;
            }
            setPrevFloorIndex() {
                this.setCurrentFloorIndex(this.prevFloorIndex);
            }
            setNextFloorIndex() {
                this.setCurrentFloorIndex(this.nextFloorIndex);
            }
            getFloorParamByKey(t1, e) {
                return this.configParams.floors[e][t1];
            }
            isTabIncluded(t1) {
                return this.config.tabs.find((e)=>e === t1);
            }
            setConfig(t1) {
                this.configParams = t1, Fi.setCurrentLocale(t1.locale), this.dispatchEvent("resize", {
                    width: t1.width,
                    height: t1.height
                });
            }
            hideControls() {
                this.controlsVisible = !1;
            }
            showControls() {
                this.controlsVisible = !0;
            }
            addEventListener(t1, e) {
                this.listeners[t1] && this.listeners[t1].push(e);
            }
            dispatchEvent(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.listeners[t1] && this.listeners[t1].forEach((t1)=>t1(e));
            }
        }, Qi = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ], Gi = (()=>{
            if ("undefined" == typeof document) return !1;
            const t1 = Qi[0], e = {};
            for (const n of Qi){
                const i = n?.[1];
                if (i in document) {
                    for (const [i, r] of n.entries())e[t1[i]] = r;
                    return e;
                }
            }
            return !1;
        })(), Wi = {
            change: Gi.fullscreenchange,
            error: Gi.fullscreenerror
        };
        let Xi = {
            request: (t1 = document.documentElement, e)=>new Promise((n, i)=>{
                    const r = ()=>{
                        Xi.off("change", r), n();
                    };
                    Xi.on("change", r);
                    const a = t1[Gi.requestFullscreen](e);
                    a instanceof Promise && a.then(r).catch(i);
                }),
            exit: ()=>new Promise((t1, e)=>{
                    if (!Xi.isFullscreen) return void t1();
                    const n = ()=>{
                        Xi.off("change", n), t1();
                    };
                    Xi.on("change", n);
                    const i = document[Gi.exitFullscreen]();
                    i instanceof Promise && i.then(n).catch(e);
                }),
            toggle: (t1, e)=>Xi.isFullscreen ? Xi.exit() : Xi.request(t1, e),
            onchange (t1) {
                Xi.on("change", t1);
            },
            onerror (t1) {
                Xi.on("error", t1);
            },
            on (t1, e) {
                const n = Wi[t1];
                n && document.addEventListener(n, e, !1);
            },
            off (t1, e) {
                const n = Wi[t1];
                n && document.removeEventListener(n, e, !1);
            },
            raw: Gi
        };
        Object.defineProperties(Xi, {
            isFullscreen: {
                get: ()=>Boolean(document[Gi.fullscreenElement])
            },
            element: {
                enumerable: !0,
                get: ()=>document[Gi.fullscreenElement] ?? void 0
            },
            isEnabled: {
                enumerable: !0,
                get: ()=>Boolean(document[Gi.fullscreenEnabled])
            }
        }), Gi || (Xi = {
            isEnabled: !1
        });
        const Yi = Xi;
        function Zi(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        dn({
            useProxies: "never"
        });
        const qi = new class {
            constructor(){
                Zi(this, "enabled", Yi.isEnabled), Zi(this, "active", !1), Zi(this, "element", null), Zi(this, "width", null), Zi(this, "height", null), On(this);
            }
            init() {
                this.element = document.querySelector("#widget-application"), this.enabled && (this.resize(Vi.config), Yi.on("change", ()=>{
                    setTimeout(()=>{
                        this.active = Yi.isFullscreen, this.active ? Vi.setConfig({
                            ...Vi.config,
                            width: window.innerWidth,
                            height: window.innerHeight
                        }) : Vi.setConfig({
                            ...Vi.config,
                            width: this.width,
                            height: this.height
                        });
                    }, 100);
                }));
            }
            async enter() {
                return await Yi.request(this.element);
            }
            async exit() {
                return await Yi.exit();
            }
            resize(t1) {
                let { width: e, height: n } = t1;
                this.width = e, this.height = n;
            }
        }, Ji = {
            DEFAULT: 0,
            THREESIXTY: 1
        }, Ki = {
            tabs: [
                "rotation",
                "panorama"
            ],
            logo: null,
            logoUrl: null,
            width: 1920,
            height: 1080,
            resizable: !0,
            rotationMode: Ji.DEFAULT,
            floors: [],
            panoramaFov: 75,
            enableCameraTransitionBetweenPanoramas: !0,
            primaryCameraPointId: null,
            json: null,
            locale: "en",
            API_URL: "https://backend.estate.hart-digital.com",
            branding: null,
            colors: {
                main: "#FAC62D",
                mainText: "#413E3E"
            },
            panoramaIcons: {
                spot: "data:image/png;base64,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",
                door: "data:image/png;base64,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"
            },
            dictionaryOverrides: null,
            instructionVisible: !0,
            autoRotate: !1,
            scales: [
                "x1",
                "x2",
                "x05"
            ],
            scaleButtonType: "img",
            floorNumberEndingsVisible: !1
        }, $i = Ki, tr = "158", er = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
        }, nr = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
        }, ir = 0, rr = 1, ar = 2, sr = 3, or = 0, lr = 1, cr = 2, ur = 3, hr = 0, dr = 1, pr = 2, fr = 2, mr = 0, gr = 1, Ar = 2, vr = 3, yr = 4, Mr = 5, br = 100, xr = 101, wr = 102, _r = 103, Er = 104, Sr = 200, Tr = 201, Ir = 202, Cr = 203, Nr = 204, Dr = 205, Lr = 206, Or = 207, Rr = 208, Pr = 209, zr = 210, Ur = 211, kr = 212, Br = 213, jr = 214, Fr = 0, Hr = 1, Vr = 2, Qr = 3, Gr = 4, Wr = 5, Xr = 6, Yr = 7, Zr = 0, qr = 1, Jr = 2, Kr = 0, $r = 1, ta = 2, ea = 3, na = 4, ia = 5, ra = "attached", aa = "detached", sa = 300, oa = 301, la = 302, ca = 303, ua = 304, ha = 306, da = 1e3, pa = 1001, fa = 1002, ma = 1003, ga = 1004, Aa = 1004, va = 1005, ya = 1005, Ma = 1006, ba = 1007, xa = 1007, wa = 1008, _a = 1008, Ea = 1009, Sa = 1010, Ta = 1011, Ia = 1012, Ca = 1013, Na = 1014, Da = 1015, La = 1016, Oa = 1017, Ra = 1018, Pa = 1020, za = 1021, Ua = 1023, ka = 1024, Ba = 1025, ja = 1026, Fa = 1027, Ha = 1028, Va = 1029, Qa = 1030, Ga = 1031, Wa = 1033, Xa = 33776, Ya = 33777, Za = 33778, qa = 33779, Ja = 35840, Ka = 35841, $a = 35842, ts = 35843, es = 36196, ns = 37492, is = 37496, rs = 37808, as = 37809, ss = 37810, os = 37811, ls = 37812, cs = 37813, us = 37814, hs = 37815, ds = 37816, ps = 37817, fs = 37818, ms = 37819, gs = 37820, As = 37821, vs = 36492, ys = 36494, Ms = 36495, bs = 36283, xs = 36284, ws = 36285, _s = 36286, Es = 2200, Ss = 2201, Ts = 2202, Is = 2300, Cs = 2301, Ns = 2302, Ds = 2400, Ls = 2401, Os = 2402, Rs = 2500, Ps = 2501, zs = 0, Us = 1, ks = 2, Bs = 3e3, js = 3001, Fs = 3200, Hs = 3201, Vs = 0, Qs = 1, Gs = "", Ws = "srgb", Xs = "srgb-linear", Ys = "display-p3", Zs = "display-p3-linear", qs = "linear", Js = "srgb", Ks = "rec709", $s = "p3", to = 0, eo = 7680, no = 7681, io = 7682, ro = 7683, ao = 34055, so = 34056, oo = 5386, lo = 512, co = 513, uo = 514, ho = 515, po = 516, fo = 517, mo = 518, go = 519, Ao = 512, vo = 513, yo = 514, Mo = 515, bo = 516, xo = 517, wo = 518, _o = 519, Eo = 35044, So = 35048, To = 35040, Io = 35045, Co = 35049, No = 35041, Do = 35046, Lo = 35050, Oo = 35042, Ro = "100", Po = "300 es", zo = 1035, Uo = 2e3, ko = 2001;
        class Bo {
            addEventListener(t1, e) {
                void 0 === this._listeners && (this._listeners = {});
                const n = this._listeners;
                void 0 === n[t1] && (n[t1] = []), -1 === n[t1].indexOf(e) && n[t1].push(e);
            }
            hasEventListener(t1, e) {
                if (void 0 === this._listeners) return !1;
                const n = this._listeners;
                return void 0 !== n[t1] && -1 !== n[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                if (void 0 === this._listeners) return;
                const n = this._listeners[t1];
                if (void 0 !== n) {
                    const t1 = n.indexOf(e);
                    -1 !== t1 && n.splice(t1, 1);
                }
            }
            dispatchEvent(t1) {
                if (void 0 === this._listeners) return;
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const n = e.slice(0);
                    for(let e = 0, i = n.length; e < i; e++)n[e].call(this, t1);
                    t1.target = null;
                }
            }
        }
        const jo = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        let Fo = 1234567;
        const Ho = Math.PI / 180, Vo = 180 / Math.PI;
        function Qo() {
            const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
            return (jo[255 & t1] + jo[t1 >> 8 & 255] + jo[t1 >> 16 & 255] + jo[t1 >> 24 & 255] + "-" + jo[255 & e] + jo[e >> 8 & 255] + "-" + jo[e >> 16 & 15 | 64] + jo[e >> 24 & 255] + "-" + jo[63 & n | 128] + jo[n >> 8 & 255] + "-" + jo[n >> 16 & 255] + jo[n >> 24 & 255] + jo[255 & i] + jo[i >> 8 & 255] + jo[i >> 16 & 255] + jo[i >> 24 & 255]).toLowerCase();
        }
        function Go(t1, e, n) {
            return Math.max(e, Math.min(n, t1));
        }
        function Wo(t1, e) {
            return (t1 % e + e) % e;
        }
        function Xo(t1, e, n) {
            return (1 - n) * t1 + n * e;
        }
        function Yo(t1) {
            return !(t1 & t1 - 1) && 0 !== t1;
        }
        function Zo(t1) {
            return Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function qo(t1) {
            return Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }
        function Jo(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return t1 / 4294967295;
                case Uint16Array:
                    return t1 / 65535;
                case Uint8Array:
                    return t1 / 255;
                case Int32Array:
                    return Math.max(t1 / 2147483647, -1);
                case Int16Array:
                    return Math.max(t1 / 32767, -1);
                case Int8Array:
                    return Math.max(t1 / 127, -1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        function Ko(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return Math.round(4294967295 * t1);
                case Uint16Array:
                    return Math.round(65535 * t1);
                case Uint8Array:
                    return Math.round(255 * t1);
                case Int32Array:
                    return Math.round(2147483647 * t1);
                case Int16Array:
                    return Math.round(32767 * t1);
                case Int8Array:
                    return Math.round(127 * t1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        const $o = {
            DEG2RAD: Ho,
            RAD2DEG: Vo,
            generateUUID: Qo,
            clamp: Go,
            euclideanModulo: Wo,
            mapLinear: function(t1, e, n, i, r) {
                return i + (t1 - e) * (r - i) / (n - e);
            },
            inverseLerp: function(t1, e, n) {
                return t1 !== e ? (n - t1) / (e - t1) : 0;
            },
            lerp: Xo,
            damp: function(t1, e, n, i) {
                return Xo(t1, e, 1 - Math.exp(-n * i));
            },
            pingpong: function(t1, e = 1) {
                return e - Math.abs(Wo(t1, 2 * e) - e);
            },
            smoothstep: function(t1, e, n) {
                return t1 <= e ? 0 : t1 >= n ? 1 : (t1 = (t1 - e) / (n - e)) * t1 * (3 - 2 * t1);
            },
            smootherstep: function(t1, e, n) {
                return t1 <= e ? 0 : t1 >= n ? 1 : (t1 = (t1 - e) / (n - e)) * t1 * t1 * (t1 * (6 * t1 - 15) + 10);
            },
            randInt: function(t1, e) {
                return t1 + Math.floor(Math.random() * (e - t1 + 1));
            },
            randFloat: function(t1, e) {
                return t1 + Math.random() * (e - t1);
            },
            randFloatSpread: function(t1) {
                return t1 * (.5 - Math.random());
            },
            seededRandom: function(t1) {
                void 0 !== t1 && (Fo = t1);
                let e = Fo += 1831565813;
                return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
            },
            degToRad: function(t1) {
                return t1 * Ho;
            },
            radToDeg: function(t1) {
                return t1 * Vo;
            },
            isPowerOfTwo: Yo,
            ceilPowerOfTwo: Zo,
            floorPowerOfTwo: qo,
            setQuaternionFromProperEuler: function(t1, e, n, i, r) {
                const a = Math.cos, s = Math.sin, o = a(n / 2), l = s(n / 2), c = a((e + i) / 2), u = s((e + i) / 2), h = a((e - i) / 2), d = s((e - i) / 2), p = a((i - e) / 2), f = s((i - e) / 2);
                switch(r){
                    case "XYX":
                        t1.set(o * u, l * h, l * d, o * c);
                        break;
                    case "YZY":
                        t1.set(l * d, o * u, l * h, o * c);
                        break;
                    case "ZXZ":
                        t1.set(l * h, l * d, o * u, o * c);
                        break;
                    case "XZX":
                        t1.set(o * u, l * f, l * p, o * c);
                        break;
                    case "YXY":
                        t1.set(l * p, o * u, l * f, o * c);
                        break;
                    case "ZYZ":
                        t1.set(l * f, l * p, o * u, o * c);
                        break;
                    default:
                        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
                }
            },
            normalize: Ko,
            denormalize: Jo
        };
        class tl {
            constructor(t1 = 0, e = 0){
                tl.prototype.isVector2 = !0, this.x = t1, this.y = e;
            }
            get width() {
                return this.x;
            }
            set width(t1) {
                this.x = t1;
            }
            get height() {
                return this.y;
            }
            set height(t1) {
                this.y = t1;
            }
            set(t1, e) {
                return this.x = t1, this.y = e, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this;
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            applyMatrix3(t1) {
                const e = this.x, n = this.y, i = t1.elements;
                return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
            }
            clampLength(t1, e) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y;
            }
            cross(t1) {
                return this.x * t1.y - this.y * t1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const n = this.dot(t1) / e;
                return Math.acos(Go(n, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, n = this.y - t1.y;
                return e * e + n * n;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
            }
            lerpVectors(t1, e, n) {
                return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this;
            }
            rotateAround(t1, e) {
                const n = Math.cos(e), i = Math.sin(e), r = this.x - t1.x, a = this.y - t1.y;
                return this.x = r * n - a * i + t1.x, this.y = r * i + a * n + t1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class el {
            constructor(t1, e, n, i, r, a, s, o, l){
                el.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, n, i, r, a, s, o, l);
            }
            set(t1, e, n, i, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = t1, c[1] = i, c[2] = s, c[3] = e, c[4] = r, c[5] = o, c[6] = n, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(t1) {
                const e = this.elements, n = t1.elements;
                return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
            }
            extractBasis(t1, e, n) {
                return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(t1) {
                const e = t1.elements;
                return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const n = t1.elements, i = e.elements, r = this.elements, a = n[0], s = n[3], o = n[6], l = n[1], c = n[4], u = n[7], h = n[2], d = n[5], p = n[8], f = i[0], m = i[3], g = i[6], A = i[1], v = i[4], y = i[7], M = i[2], b = i[5], x = i[8];
                return r[0] = a * f + s * A + o * M, r[3] = a * m + s * v + o * b, r[6] = a * g + s * y + o * x, r[1] = l * f + c * A + u * M, r[4] = l * m + c * v + u * b, r[7] = l * g + c * y + u * x, r[2] = h * f + d * A + p * M, r[5] = h * m + d * v + p * b, r[8] = h * g + d * y + p * x, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8];
                return e * a * c - e * s * l - n * r * c + n * s * o + i * r * l - i * a * o;
            }
            invert() {
                const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = e * u + n * h + i * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return t1[0] = u * f, t1[1] = (i * l - c * n) * f, t1[2] = (s * n - i * a) * f, t1[3] = h * f, t1[4] = (c * e - i * o) * f, t1[5] = (i * r - s * e) * f, t1[6] = d * f, t1[7] = (n * o - l * e) * f, t1[8] = (a * e - n * r) * f, this;
            }
            transpose() {
                let t1;
                const e = this.elements;
                return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
            }
            getNormalMatrix(t1) {
                return this.setFromMatrix4(t1).invert().transpose();
            }
            transposeIntoArray(t1) {
                const e = this.elements;
                return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
            }
            setUvTransform(t1, e, n, i, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(n * o, n * l, -n * (o * a + l * s) + a + t1, -i * l, i * o, -i * (-l * a + o * s) + s + e, 0, 0, 1), this;
            }
            scale(t1, e) {
                return this.premultiply(nl.makeScale(t1, e)), this;
            }
            rotate(t1) {
                return this.premultiply(nl.makeRotation(-t1)), this;
            }
            translate(t1, e) {
                return this.premultiply(nl.makeTranslation(t1, e)), this;
            }
            makeTranslation(t1, e) {
                return t1.isVector2 ? this.set(1, 0, t1.x, 0, 1, t1.y, 0, 0, 1) : this.set(1, 0, t1, 0, 1, e, 0, 0, 1), this;
            }
            makeRotation(t1) {
                const e = Math.cos(t1), n = Math.sin(t1);
                return this.set(e, -n, 0, n, e, 0, 0, 0, 1), this;
            }
            makeScale(t1, e) {
                return this.set(t1, 0, 0, 0, e, 0, 0, 0, 1), this;
            }
            equals(t1) {
                const e = this.elements, n = t1.elements;
                for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== n[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let n = 0; n < 9; n++)this.elements[n] = t1[n + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const n = this.elements;
                return t1[e] = n[0], t1[e + 1] = n[1], t1[e + 2] = n[2], t1[e + 3] = n[3], t1[e + 4] = n[4], t1[e + 5] = n[5], t1[e + 6] = n[6], t1[e + 7] = n[7], t1[e + 8] = n[8], t1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const nl = new el;
        function il(t1) {
            for(let e = t1.length - 1; e >= 0; --e)if (t1[e] >= 65535) return !0;
            return !1;
        }
        const rl = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
        };
        function al(t1, e) {
            return new rl[t1](e);
        }
        function sl(t1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
        }
        function ol() {
            const t1 = sl("canvas");
            return t1.style.display = "block", t1;
        }
        const ll = {};
        function cl(t1) {
            t1 in ll || (ll[t1] = !0, console.warn(t1));
        }
        const ul = (new el).set(.8224621, .177538, 0, .0331941, .9668058, 0, .0170827, .0723974, .9105199), hl = (new el).set(1.2249401, -0.2249404, 0, -0.0420569, 1.0420571, 0, -0.0196376, -0.0786361, 1.0982735), dl = {
            [Xs]: {
                transfer: qs,
                primaries: Ks,
                toReference: (t1)=>t1,
                fromReference: (t1)=>t1
            },
            [Ws]: {
                transfer: Js,
                primaries: Ks,
                toReference: (t1)=>t1.convertSRGBToLinear(),
                fromReference: (t1)=>t1.convertLinearToSRGB()
            },
            [Zs]: {
                transfer: qs,
                primaries: $s,
                toReference: (t1)=>t1.applyMatrix3(hl),
                fromReference: (t1)=>t1.applyMatrix3(ul)
            },
            [Ys]: {
                transfer: Js,
                primaries: $s,
                toReference: (t1)=>t1.convertSRGBToLinear().applyMatrix3(hl),
                fromReference: (t1)=>t1.applyMatrix3(ul).convertLinearToSRGB()
            }
        }, pl = new Set([
            Xs,
            Zs
        ]), fl = {
            enabled: !0,
            _workingColorSpace: Xs,
            get legacyMode () {
                return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
            },
            set legacyMode (t){
                console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !t;
            },
            get workingColorSpace () {
                return this._workingColorSpace;
            },
            set workingColorSpace (t){
                if (!pl.has(t)) throw new Error(`Unsupported working color space, "${t}".`);
                this._workingColorSpace = t;
            },
            convert: function(t1, e, n) {
                if (!1 === this.enabled || e === n || !e || !n) return t1;
                const i = dl[e].toReference;
                return (0, dl[n].fromReference)(i(t1));
            },
            fromWorkingColorSpace: function(t1, e) {
                return this.convert(t1, this._workingColorSpace, e);
            },
            toWorkingColorSpace: function(t1, e) {
                return this.convert(t1, e, this._workingColorSpace);
            },
            getPrimaries: function(t1) {
                return dl[t1].primaries;
            },
            getTransfer: function(t1) {
                return t1 === Gs ? qs : dl[t1].transfer;
            }
        };
        function ml(t1) {
            return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
        }
        function gl(t1) {
            return t1 < .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, .41666) - .055;
        }
        let Al;
        class vl {
            static getDataURL(t1) {
                if (/^data:/i.test(t1.src)) return t1.src;
                if ("undefined" == typeof HTMLCanvasElement) return t1.src;
                let e;
                if (t1 instanceof HTMLCanvasElement) e = t1;
                else {
                    void 0 === Al && (Al = sl("canvas")), Al.width = t1.width, Al.height = t1.height;
                    const n = Al.getContext("2d");
                    t1 instanceof ImageData ? n.putImageData(t1, 0, 0) : n.drawImage(t1, 0, 0, t1.width, t1.height), e = Al;
                }
                return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
            }
            static sRGBToLinear(t1) {
                if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                    const e = sl("canvas");
                    e.width = t1.width, e.height = t1.height;
                    const n = e.getContext("2d");
                    n.drawImage(t1, 0, 0, t1.width, t1.height);
                    const i = n.getImageData(0, 0, t1.width, t1.height), r = i.data;
                    for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * ml(r[t1] / 255);
                    return n.putImageData(i, 0, 0), e;
                }
                if (t1.data) {
                    const e = t1.data.slice(0);
                    for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * ml(e[t1] / 255)) : e[t1] = ml(e[t1]);
                    return {
                        data: e,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
            }
        }
        let yl = 0;
        class Ml {
            constructor(t1 = null){
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: yl++
                }), this.uuid = Qo(), this.data = t1, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
                const n = {
                    uuid: this.uuid,
                    url: ""
                }, i = this.data;
                if (null !== i) {
                    let t1;
                    if (Array.isArray(i)) {
                        t1 = [];
                        for(let e = 0, n = i.length; e < n; e++)i[e].isDataTexture ? t1.push(bl(i[e].image)) : t1.push(bl(i[e]));
                    } else t1 = bl(i);
                    n.url = t1;
                }
                return e || (t1.images[this.uuid] = n), n;
            }
        }
        function bl(t1) {
            return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? vl.getDataURL(t1) : t1.data ? {
                data: Array.from(t1.data),
                width: t1.width,
                height: t1.height,
                type: t1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let xl = 0;
        class wl extends Bo {
            constructor(t1 = wl.DEFAULT_IMAGE, e = wl.DEFAULT_MAPPING, n = pa, i = pa, r = Ma, a = wa, s = Ua, o = Ea, l = wl.DEFAULT_ANISOTROPY, c = Gs){
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: xl++
                }), this.uuid = Qo(), this.name = "", this.source = new Ml(t1), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new tl(0, 0), this.repeat = new tl(1, 1), this.center = new tl(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new el, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (cl("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === js ? Ws : Gs), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(t1 = null) {
                this.source.data = t1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.channel = t1.channel, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.colorSpace = t1.colorSpace, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(t1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (n.userData = this.userData), e || (t1.textures[this.uuid] = n), n;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(t1) {
                if (this.mapping !== sa) return t1;
                if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
                    case da:
                        t1.x = t1.x - Math.floor(t1.x);
                        break;
                    case pa:
                        t1.x = t1.x < 0 ? 0 : 1;
                        break;
                    case fa:
                        1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
                }
                if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
                    case da:
                        t1.y = t1.y - Math.floor(t1.y);
                        break;
                    case pa:
                        t1.y = t1.y < 0 ? 0 : 1;
                        break;
                    case fa:
                        1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
                }
                return this.flipY && (t1.y = 1 - t1.y), t1;
            }
            set needsUpdate(t1) {
                !0 === t1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return cl("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === Ws ? js : Bs;
            }
            set encoding(t1) {
                cl("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t1 === js ? Ws : Gs;
            }
        }
        wl.DEFAULT_IMAGE = null, wl.DEFAULT_MAPPING = sa, wl.DEFAULT_ANISOTROPY = 1;
        class _l {
            constructor(t1 = 0, e = 0, n = 0, i = 1){
                _l.prototype.isVector4 = !0, this.x = t1, this.y = e, this.z = n, this.w = i;
            }
            get width() {
                return this.z;
            }
            set width(t1) {
                this.z = t1;
            }
            get height() {
                return this.w;
            }
            set height(t1) {
                this.w = t1;
            }
            set(t1, e, n, i) {
                return this.x = t1, this.y = e, this.z = n, this.w = i, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setW(t1) {
                return this.w = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    case 3:
                        this.w = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
            }
            applyMatrix4(t1) {
                const e = this.x, n = this.y, i = this.z, r = this.w, a = t1.elements;
                return this.x = a[0] * e + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * e + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * e + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * e + a[7] * n + a[11] * i + a[15] * r, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            setAxisAngleFromQuaternion(t1) {
                this.w = 2 * Math.acos(t1.w);
                const e = Math.sqrt(1 - t1.w * t1.w);
                return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
            }
            setAxisAngleFromRotationMatrix(t1) {
                let e, n, i, r;
                const a = .01, s = .1, o = t1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], m = o[6], g = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - m) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + m) < s && Math.abs(l + d + g - 3) < s) return this.set(1, 0, 0, 0), this;
                    e = Math.PI;
                    const t1 = (l + 1) / 2, o = (d + 1) / 2, A = (g + 1) / 2, v = (c + h) / 4, y = (u + f) / 4, M = (p + m) / 4;
                    return t1 > o && t1 > A ? t1 < a ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(t1), i = v / n, r = y / n) : o > A ? o < a ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = v / i, r = M / i) : A < a ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(A), n = y / r, i = M / r), this.set(n, i, r, e), this;
                }
                let A = Math.sqrt((m - p) * (m - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(A) < .001 && (A = 1), this.x = (m - p) / A, this.y = (u - f) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + g - 1) / 2), this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
            }
            clampLength(t1, e) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
            }
            lerpVectors(t1, e, n) {
                return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this.z = t1.z + (e.z - t1.z) * n, this.w = t1.w + (e.w - t1.w) * n, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        class El extends Bo {
            constructor(t1 = 1, e = 1, n = {}){
                super(), this.isRenderTarget = !0, this.width = t1, this.height = e, this.depth = 1, this.scissor = new _l(0, 0, t1, e), this.scissorTest = !1, this.viewport = new _l(0, 0, t1, e);
                const i = {
                    width: t1,
                    height: e,
                    depth: 1
                };
                void 0 !== n.encoding && (cl("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), n.colorSpace = n.encoding === js ? Ws : Gs), n = Object.assign({
                    generateMipmaps: !1,
                    internalFormat: null,
                    minFilter: Ma,
                    depthBuffer: !0,
                    stencilBuffer: !1,
                    depthTexture: null,
                    samples: 0
                }, n), this.texture = new wl(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = n.generateMipmaps, this.texture.internalFormat = n.internalFormat, this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.depthTexture = n.depthTexture, this.samples = n.samples;
            }
            setSize(t1, e, n = 1) {
                this.width === t1 && this.height === e && this.depth === n || (this.width = t1, this.height = e, this.depth = n, this.texture.image.width = t1, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.texture = t1.texture.clone(), this.texture.isRenderTargetTexture = !0;
                const e = Object.assign({}, t1.texture.image);
                return this.texture.source = new Ml(e), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.samples = t1.samples, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Sl extends El {
            constructor(t1 = 1, e = 1, n = {}){
                super(t1, e, n), this.isWebGLRenderTarget = !0;
            }
        }
        class Tl extends wl {
            constructor(t1 = null, e = 1, n = 1, i = 1){
                super(null), this.isDataArrayTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: n,
                    depth: i
                }, this.magFilter = ma, this.minFilter = ma, this.wrapR = pa, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Il extends Sl {
            constructor(t1 = 1, e = 1, n = 1){
                super(t1, e), this.isWebGLArrayRenderTarget = !0, this.depth = n, this.texture = new Tl(null, t1, e, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Cl extends wl {
            constructor(t1 = null, e = 1, n = 1, i = 1){
                super(null), this.isData3DTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: n,
                    depth: i
                }, this.magFilter = ma, this.minFilter = ma, this.wrapR = pa, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Nl extends Sl {
            constructor(t1 = 1, e = 1, n = 1){
                super(t1, e), this.isWebGL3DRenderTarget = !0, this.depth = n, this.texture = new Cl(null, t1, e, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Dl extends Sl {
            constructor(t1 = 1, e = 1, n = 1, i = {}){
                super(t1, e, i), this.isWebGLMultipleRenderTargets = !0;
                const r = this.texture;
                this.texture = [];
                for(let t1 = 0; t1 < n; t1++)this.texture[t1] = r.clone(), this.texture[t1].isRenderTargetTexture = !0;
            }
            setSize(t1, e, n = 1) {
                if (this.width !== t1 || this.height !== e || this.depth !== n) {
                    this.width = t1, this.height = e, this.depth = n;
                    for(let i = 0, r = this.texture.length; i < r; i++)this.texture[i].image.width = t1, this.texture[i].image.height = e, this.texture[i].image.depth = n;
                    this.dispose();
                }
                this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            copy(t1) {
                this.dispose(), this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.texture.length = 0;
                for(let e = 0, n = t1.texture.length; e < n; e++)this.texture[e] = t1.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
                return this;
            }
        }
        class Ll {
            constructor(t1 = 0, e = 0, n = 0, i = 1){
                this.isQuaternion = !0, this._x = t1, this._y = e, this._z = n, this._w = i;
            }
            static slerpFlat(t1, e, n, i, r, a, s) {
                let o = n[i + 0], l = n[i + 1], c = n[i + 2], u = n[i + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = c, void (t1[e + 3] = u);
                if (1 === s) return t1[e + 0] = h, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let t1 = 1 - s;
                    const e = o * h + l * d + c * p + u * f, n = e >= 0 ? 1 : -1, i = 1 - e * e;
                    if (i > Number.EPSILON) {
                        const r = Math.sqrt(i), a = Math.atan2(r, e * n);
                        t1 = Math.sin(t1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * n;
                    if (o = o * t1 + h * r, l = l * t1 + d * r, c = c * t1 + p * r, u = u * t1 + f * r, t1 === 1 - s) {
                        const t1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= t1, l *= t1, c *= t1, u *= t1;
                    }
                }
                t1[e] = o, t1[e + 1] = l, t1[e + 2] = c, t1[e + 3] = u;
            }
            static multiplyQuaternionsFlat(t1, e, n, i, r, a) {
                const s = n[i], o = n[i + 1], l = n[i + 2], c = n[i + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return t1[e] = s * p + c * u + o * d - l * h, t1[e + 1] = o * p + c * h + l * u - s * d, t1[e + 2] = l * p + c * d + s * h - o * u, t1[e + 3] = c * p - s * u - o * h - l * d, t1;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(t1) {
                this._w = t1, this._onChangeCallback();
            }
            set(t1, e, n, i) {
                return this._x = t1, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(t1) {
                return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
            }
            setFromEuler(t1, e) {
                const n = t1._x, i = t1._y, r = t1._z, a = t1._order, s = Math.cos, o = Math.sin, l = s(n / 2), c = s(i / 2), u = s(r / 2), h = o(n / 2), d = o(i / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== e && this._onChangeCallback(), this;
            }
            setFromAxisAngle(t1, e) {
                const n = e / 2, i = Math.sin(n);
                return this._x = t1.x * i, this._y = t1.y * i, this._z = t1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1) {
                const e = t1.elements, n = e[0], i = e[4], r = e[8], a = e[1], s = e[5], o = e[9], l = e[2], c = e[6], u = e[10], h = n + s + u;
                if (h > 0) {
                    const t1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / t1, this._x = (c - o) * t1, this._y = (r - l) * t1, this._z = (a - i) * t1;
                } else if (n > s && n > u) {
                    const t1 = 2 * Math.sqrt(1 + n - s - u);
                    this._w = (c - o) / t1, this._x = .25 * t1, this._y = (i + a) / t1, this._z = (r + l) / t1;
                } else if (s > u) {
                    const t1 = 2 * Math.sqrt(1 + s - n - u);
                    this._w = (r - l) / t1, this._x = (i + a) / t1, this._y = .25 * t1, this._z = (o + c) / t1;
                } else {
                    const t1 = 2 * Math.sqrt(1 + u - n - s);
                    this._w = (a - i) / t1, this._x = (r + l) / t1, this._y = (o + c) / t1, this._z = .25 * t1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(t1, e) {
                let n = t1.dot(e) + 1;
                return n < Number.EPSILON ? (n = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = n)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = n), this.normalize();
            }
            angleTo(t1) {
                return 2 * Math.acos(Math.abs(Go(this.dot(t1), -1, 1)));
            }
            rotateTowards(t1, e) {
                const n = this.angleTo(t1);
                if (0 === n) return this;
                const i = Math.min(1, e / n);
                return this.slerp(t1, i), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(t1) {
                return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let t1 = this.length();
                return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
            }
            multiply(t1) {
                return this.multiplyQuaternions(this, t1);
            }
            premultiply(t1) {
                return this.multiplyQuaternions(t1, this);
            }
            multiplyQuaternions(t1, e) {
                const n = t1._x, i = t1._y, r = t1._z, a = t1._w, s = e._x, o = e._y, l = e._z, c = e._w;
                return this._x = n * c + a * s + i * l - r * o, this._y = i * c + a * o + r * s - n * l, this._z = r * c + a * l + n * o - i * s, this._w = a * c - n * s - i * o - r * l, this._onChangeCallback(), this;
            }
            slerp(t1, e) {
                if (0 === e) return this;
                if (1 === e) return this.copy(t1);
                const n = this._x, i = this._y, r = this._z, a = this._w;
                let s = a * t1._w + n * t1._x + i * t1._y + r * t1._z;
                if (s < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, s = -s) : this.copy(t1), s >= 1) return this._w = a, this._x = n, this._y = i, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const t1 = 1 - e;
                    return this._w = t1 * a + e * this._w, this._x = t1 * n + e * this._x, this._y = t1 * i + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - e) * c) / l, h = Math.sin(e * c) / l;
                return this._w = a * u + this._w * h, this._x = n * u + this._x * h, this._y = i * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(t1, e, n) {
                return this.copy(t1).slerp(e, n);
            }
            random() {
                const t1 = Math.random(), e = Math.sqrt(1 - t1), n = Math.sqrt(t1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(e * Math.cos(i), n * Math.sin(r), n * Math.cos(r), e * Math.sin(i));
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
            }
            fromArray(t1, e = 0) {
                return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class Ol {
            constructor(t1 = 0, e = 0, n = 0){
                Ol.prototype.isVector3 = !0, this.x = t1, this.y = e, this.z = n;
            }
            set(t1, e, n) {
                return void 0 === n && (n = this.z), this.x = t1, this.y = e, this.z = n, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this;
            }
            multiplyVectors(t1, e) {
                return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
            }
            applyEuler(t1) {
                return this.applyQuaternion(Pl.setFromEuler(t1));
            }
            applyAxisAngle(t1, e) {
                return this.applyQuaternion(Pl.setFromAxisAngle(t1, e));
            }
            applyMatrix3(t1) {
                const e = this.x, n = this.y, i = this.z, r = t1.elements;
                return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
            }
            applyNormalMatrix(t1) {
                return this.applyMatrix3(t1).normalize();
            }
            applyMatrix4(t1) {
                const e = this.x, n = this.y, i = this.z, r = t1.elements, a = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
                return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * a, this;
            }
            applyQuaternion(t1) {
                const e = this.x, n = this.y, i = this.z, r = t1.x, a = t1.y, s = t1.z, o = t1.w, l = 2 * (a * i - s * n), c = 2 * (s * e - r * i), u = 2 * (r * n - a * e);
                return this.x = e + o * l + a * u - s * c, this.y = n + o * c + s * l - r * u, this.z = i + o * u + r * c - a * l, this;
            }
            project(t1) {
                return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
            }
            unproject(t1) {
                return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
            }
            transformDirection(t1) {
                const e = this.x, n = this.y, i = this.z, r = t1.elements;
                return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
            }
            clampLength(t1, e) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
            }
            lerpVectors(t1, e, n) {
                return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this.z = t1.z + (e.z - t1.z) * n, this;
            }
            cross(t1) {
                return this.crossVectors(this, t1);
            }
            crossVectors(t1, e) {
                const n = t1.x, i = t1.y, r = t1.z, a = e.x, s = e.y, o = e.z;
                return this.x = i * o - r * s, this.y = r * a - n * o, this.z = n * s - i * a, this;
            }
            projectOnVector(t1) {
                const e = t1.lengthSq();
                if (0 === e) return this.set(0, 0, 0);
                const n = t1.dot(this) / e;
                return this.copy(t1).multiplyScalar(n);
            }
            projectOnPlane(t1) {
                return Rl.copy(this).projectOnVector(t1), this.sub(Rl);
            }
            reflect(t1) {
                return this.sub(Rl.copy(t1).multiplyScalar(2 * this.dot(t1)));
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const n = this.dot(t1) / e;
                return Math.acos(Go(n, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, n = this.y - t1.y, i = this.z - t1.z;
                return e * e + n * n + i * i;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
            }
            setFromSpherical(t1) {
                return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
            }
            setFromSphericalCoords(t1, e, n) {
                const i = Math.sin(e) * t1;
                return this.x = i * Math.sin(n), this.y = Math.cos(e) * t1, this.z = i * Math.cos(n), this;
            }
            setFromCylindrical(t1) {
                return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
            }
            setFromCylindricalCoords(t1, e, n) {
                return this.x = t1 * Math.sin(e), this.y = n, this.z = t1 * Math.cos(e), this;
            }
            setFromMatrixPosition(t1) {
                const e = t1.elements;
                return this.x = e[12], this.y = e[13], this.z = e[14], this;
            }
            setFromMatrixScale(t1) {
                const e = this.setFromMatrixColumn(t1, 0).length(), n = this.setFromMatrixColumn(t1, 1).length(), i = this.setFromMatrixColumn(t1, 2).length();
                return this.x = e, this.y = n, this.z = i, this;
            }
            setFromMatrixColumn(t1, e) {
                return this.fromArray(t1.elements, 4 * e);
            }
            setFromMatrix3Column(t1, e) {
                return this.fromArray(t1.elements, 3 * e);
            }
            setFromEuler(t1) {
                return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
            }
            setFromColor(t1) {
                return this.x = t1.r, this.y = t1.g, this.z = t1.b, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, n = Math.sqrt(1 - t1 ** 2);
                return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const Rl = new Ol, Pl = new Ll;
        class zl {
            constructor(t1 = new Ol(1 / 0, 1 / 0, 1 / 0), e = new Ol(-1 / 0, -1 / 0, -1 / 0)){
                this.isBox3 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromArray(t1) {
                this.makeEmpty();
                for(let e = 0, n = t1.length; e < n; e += 3)this.expandByPoint(kl.fromArray(t1, e));
                return this;
            }
            setFromBufferAttribute(t1) {
                this.makeEmpty();
                for(let e = 0, n = t1.count; e < n; e++)this.expandByPoint(kl.fromBufferAttribute(t1, e));
                return this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, n = t1.length; e < n; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const n = kl.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(n), this.max.copy(t1).add(n), this;
            }
            setFromObject(t1, e = !1) {
                return this.makeEmpty(), this.expandByObject(t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            expandByObject(t1, e = !1) {
                t1.updateWorldMatrix(!1, !1);
                const n = t1.geometry;
                if (void 0 !== n) {
                    const i = n.getAttribute("position");
                    if (!0 === e && void 0 !== i && !0 !== t1.isInstancedMesh) for(let e = 0, n = i.count; e < n; e++)!0 === t1.isMesh ? t1.getVertexPosition(e, kl) : kl.fromBufferAttribute(i, e), kl.applyMatrix4(t1.matrixWorld), this.expandByPoint(kl);
                    else void 0 !== t1.boundingBox ? (null === t1.boundingBox && t1.computeBoundingBox(), Bl.copy(t1.boundingBox)) : (null === n.boundingBox && n.computeBoundingBox(), Bl.copy(n.boundingBox)), Bl.applyMatrix4(t1.matrixWorld), this.union(Bl);
                }
                const i = t1.children;
                for(let t1 = 0, n = i.length; t1 < n; t1++)this.expandByObject(i[t1], e);
                return this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y || t1.z < this.min.z || t1.z > this.max.z);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y && this.min.z <= t1.min.z && t1.max.z <= this.max.z;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y), (t1.z - this.min.z) / (this.max.z - this.min.z));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y || t1.max.z < this.min.z || t1.min.z > this.max.z);
            }
            intersectsSphere(t1) {
                return this.clampPoint(t1.center, kl), kl.distanceToSquared(t1.center) <= t1.radius * t1.radius;
            }
            intersectsPlane(t1) {
                let e, n;
                return t1.normal.x > 0 ? (e = t1.normal.x * this.min.x, n = t1.normal.x * this.max.x) : (e = t1.normal.x * this.max.x, n = t1.normal.x * this.min.x), t1.normal.y > 0 ? (e += t1.normal.y * this.min.y, n += t1.normal.y * this.max.y) : (e += t1.normal.y * this.max.y, n += t1.normal.y * this.min.y), t1.normal.z > 0 ? (e += t1.normal.z * this.min.z, n += t1.normal.z * this.max.z) : (e += t1.normal.z * this.max.z, n += t1.normal.z * this.min.z), e <= -t1.constant && n >= -t1.constant;
            }
            intersectsTriangle(t1) {
                if (this.isEmpty()) return !1;
                this.getCenter(Wl), Xl.subVectors(this.max, Wl), jl.subVectors(t1.a, Wl), Fl.subVectors(t1.b, Wl), Hl.subVectors(t1.c, Wl), Vl.subVectors(Fl, jl), Ql.subVectors(Hl, Fl), Gl.subVectors(jl, Hl);
                let e = [
                    0,
                    -Vl.z,
                    Vl.y,
                    0,
                    -Ql.z,
                    Ql.y,
                    0,
                    -Gl.z,
                    Gl.y,
                    Vl.z,
                    0,
                    -Vl.x,
                    Ql.z,
                    0,
                    -Ql.x,
                    Gl.z,
                    0,
                    -Gl.x,
                    -Vl.y,
                    Vl.x,
                    0,
                    -Ql.y,
                    Ql.x,
                    0,
                    -Gl.y,
                    Gl.x,
                    0
                ];
                return !!ql(e, jl, Fl, Hl, Xl) && (e = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], !!ql(e, jl, Fl, Hl, Xl) && (Yl.crossVectors(Vl, Ql), e = [
                    Yl.x,
                    Yl.y,
                    Yl.z
                ], ql(e, jl, Fl, Hl, Xl)));
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, kl).distanceTo(t1);
            }
            getBoundingSphere(t1) {
                return this.isEmpty() ? t1.makeEmpty() : (this.getCenter(t1.center), t1.radius = .5 * this.getSize(kl).length()), t1;
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            applyMatrix4(t1) {
                return this.isEmpty() || (Ul[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t1), Ul[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t1), Ul[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t1), Ul[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t1), Ul[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t1), Ul[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t1), Ul[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t1), Ul[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t1), this.setFromPoints(Ul)), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const Ul = [
            new Ol,
            new Ol,
            new Ol,
            new Ol,
            new Ol,
            new Ol,
            new Ol,
            new Ol
        ], kl = new Ol, Bl = new zl, jl = new Ol, Fl = new Ol, Hl = new Ol, Vl = new Ol, Ql = new Ol, Gl = new Ol, Wl = new Ol, Xl = new Ol, Yl = new Ol, Zl = new Ol;
        function ql(t1, e, n, i, r) {
            for(let a = 0, s = t1.length - 3; a <= s; a += 3){
                Zl.fromArray(t1, a);
                const s = r.x * Math.abs(Zl.x) + r.y * Math.abs(Zl.y) + r.z * Math.abs(Zl.z), o = e.dot(Zl), l = n.dot(Zl), c = i.dot(Zl);
                if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
            }
            return !0;
        }
        const Jl = new zl, Kl = new Ol, $l = new Ol;
        class tc {
            constructor(t1 = new Ol, e = -1){
                this.center = t1, this.radius = e;
            }
            set(t1, e) {
                return this.center.copy(t1), this.radius = e, this;
            }
            setFromPoints(t1, e) {
                const n = this.center;
                void 0 !== e ? n.copy(e) : Jl.setFromPoints(t1).getCenter(n);
                let i = 0;
                for(let e = 0, r = t1.length; e < r; e++)i = Math.max(i, n.distanceToSquared(t1[e]));
                return this.radius = Math.sqrt(i), this;
            }
            copy(t1) {
                return this.center.copy(t1.center), this.radius = t1.radius, this;
            }
            isEmpty() {
                return this.radius < 0;
            }
            makeEmpty() {
                return this.center.set(0, 0, 0), this.radius = -1, this;
            }
            containsPoint(t1) {
                return t1.distanceToSquared(this.center) <= this.radius * this.radius;
            }
            distanceToPoint(t1) {
                return t1.distanceTo(this.center) - this.radius;
            }
            intersectsSphere(t1) {
                const e = this.radius + t1.radius;
                return t1.center.distanceToSquared(this.center) <= e * e;
            }
            intersectsBox(t1) {
                return t1.intersectsSphere(this);
            }
            intersectsPlane(t1) {
                return Math.abs(t1.distanceToPoint(this.center)) <= this.radius;
            }
            clampPoint(t1, e) {
                const n = this.center.distanceToSquared(t1);
                return e.copy(t1), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
            }
            getBoundingBox(t1) {
                return this.isEmpty() ? (t1.makeEmpty(), t1) : (t1.set(this.center, this.center), t1.expandByScalar(this.radius), t1);
            }
            applyMatrix4(t1) {
                return this.center.applyMatrix4(t1), this.radius = this.radius * t1.getMaxScaleOnAxis(), this;
            }
            translate(t1) {
                return this.center.add(t1), this;
            }
            expandByPoint(t1) {
                if (this.isEmpty()) return this.center.copy(t1), this.radius = 0, this;
                Kl.subVectors(t1, this.center);
                const e = Kl.lengthSq();
                if (e > this.radius * this.radius) {
                    const t1 = Math.sqrt(e), n = .5 * (t1 - this.radius);
                    this.center.addScaledVector(Kl, n / t1), this.radius += n;
                }
                return this;
            }
            union(t1) {
                return t1.isEmpty() ? this : this.isEmpty() ? (this.copy(t1), this) : (!0 === this.center.equals(t1.center) ? this.radius = Math.max(this.radius, t1.radius) : ($l.subVectors(t1.center, this.center).setLength(t1.radius), this.expandByPoint(Kl.copy(t1.center).add($l)), this.expandByPoint(Kl.copy(t1.center).sub($l))), this);
            }
            equals(t1) {
                return t1.center.equals(this.center) && t1.radius === this.radius;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const ec = new Ol, nc = new Ol, ic = new Ol, rc = new Ol, ac = new Ol, sc = new Ol, oc = new Ol;
        class lc {
            constructor(t1 = new Ol, e = new Ol(0, 0, -1)){
                this.origin = t1, this.direction = e;
            }
            set(t1, e) {
                return this.origin.copy(t1), this.direction.copy(e), this;
            }
            copy(t1) {
                return this.origin.copy(t1.origin), this.direction.copy(t1.direction), this;
            }
            at(t1, e) {
                return e.copy(this.origin).addScaledVector(this.direction, t1);
            }
            lookAt(t1) {
                return this.direction.copy(t1).sub(this.origin).normalize(), this;
            }
            recast(t1) {
                return this.origin.copy(this.at(t1, ec)), this;
            }
            closestPointToPoint(t1, e) {
                e.subVectors(t1, this.origin);
                const n = e.dot(this.direction);
                return n < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, n);
            }
            distanceToPoint(t1) {
                return Math.sqrt(this.distanceSqToPoint(t1));
            }
            distanceSqToPoint(t1) {
                const e = ec.subVectors(t1, this.origin).dot(this.direction);
                return e < 0 ? this.origin.distanceToSquared(t1) : (ec.copy(this.origin).addScaledVector(this.direction, e), ec.distanceToSquared(t1));
            }
            distanceSqToSegment(t1, e, n, i) {
                nc.copy(t1).add(e).multiplyScalar(.5), ic.copy(e).sub(t1).normalize(), rc.copy(this.origin).sub(nc);
                const r = .5 * t1.distanceTo(e), a = -this.direction.dot(ic), s = rc.dot(this.direction), o = -rc.dot(ic), l = rc.lengthSq(), c = Math.abs(1 - a * a);
                let u, h, d, p;
                if (c > 0) {
                    if (u = a * o - s, h = a * s - o, p = r * c, u >= 0) {
                        if (h >= -p) {
                            if (h <= p) {
                                const t1 = 1 / c;
                                u *= t1, h *= t1, d = u * (u + a * h + 2 * s) + h * (a * u + h + 2 * o) + l;
                            } else h = r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                        } else h = -r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                    } else h <= -p ? (u = Math.max(0, -(-a * r + s)), h = u > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-r, -o), r), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(a * r + s)), h = u > 0 ? r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l);
                } else h = a > 0 ? -r : r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                return n && n.copy(this.origin).addScaledVector(this.direction, u), i && i.copy(nc).addScaledVector(ic, h), d;
            }
            intersectSphere(t1, e) {
                ec.subVectors(t1.center, this.origin);
                const n = ec.dot(this.direction), i = ec.dot(ec) - n * n, r = t1.radius * t1.radius;
                if (i > r) return null;
                const a = Math.sqrt(r - i), s = n - a, o = n + a;
                return o < 0 ? null : s < 0 ? this.at(o, e) : this.at(s, e);
            }
            intersectsSphere(t1) {
                return this.distanceSqToPoint(t1.center) <= t1.radius * t1.radius;
            }
            distanceToPlane(t1) {
                const e = t1.normal.dot(this.direction);
                if (0 === e) return 0 === t1.distanceToPoint(this.origin) ? 0 : null;
                const n = -(this.origin.dot(t1.normal) + t1.constant) / e;
                return n >= 0 ? n : null;
            }
            intersectPlane(t1, e) {
                const n = this.distanceToPlane(t1);
                return null === n ? null : this.at(n, e);
            }
            intersectsPlane(t1) {
                const e = t1.distanceToPoint(this.origin);
                return 0 === e || t1.normal.dot(this.direction) * e < 0;
            }
            intersectBox(t1, e) {
                let n, i, r, a, s, o;
                const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
                return l >= 0 ? (n = (t1.min.x - h.x) * l, i = (t1.max.x - h.x) * l) : (n = (t1.max.x - h.x) * l, i = (t1.min.x - h.x) * l), c >= 0 ? (r = (t1.min.y - h.y) * c, a = (t1.max.y - h.y) * c) : (r = (t1.max.y - h.y) * c, a = (t1.min.y - h.y) * c), n > a || r > i ? null : ((r > n || isNaN(n)) && (n = r), (a < i || isNaN(i)) && (i = a), u >= 0 ? (s = (t1.min.z - h.z) * u, o = (t1.max.z - h.z) * u) : (s = (t1.max.z - h.z) * u, o = (t1.min.z - h.z) * u), n > o || s > i ? null : ((s > n || n != n) && (n = s), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, e)));
            }
            intersectsBox(t1) {
                return null !== this.intersectBox(t1, ec);
            }
            intersectTriangle(t1, e, n, i, r) {
                ac.subVectors(e, t1), sc.subVectors(n, t1), oc.crossVectors(ac, sc);
                let a, s = this.direction.dot(oc);
                if (s > 0) {
                    if (i) return null;
                    a = 1;
                } else {
                    if (!(s < 0)) return null;
                    a = -1, s = -s;
                }
                rc.subVectors(this.origin, t1);
                const o = a * this.direction.dot(sc.crossVectors(rc, sc));
                if (o < 0) return null;
                const l = a * this.direction.dot(ac.cross(rc));
                if (l < 0) return null;
                if (o + l > s) return null;
                const c = -a * rc.dot(oc);
                return c < 0 ? null : this.at(c / s, r);
            }
            applyMatrix4(t1) {
                return this.origin.applyMatrix4(t1), this.direction.transformDirection(t1), this;
            }
            equals(t1) {
                return t1.origin.equals(this.origin) && t1.direction.equals(this.direction);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class cc {
            constructor(t1, e, n, i, r, a, s, o, l, c, u, h, d, p, f, m){
                cc.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, n, i, r, a, s, o, l, c, u, h, d, p, f, m);
            }
            set(t1, e, n, i, r, a, s, o, l, c, u, h, d, p, f, m) {
                const g = this.elements;
                return g[0] = t1, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = a, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = d, g[7] = p, g[11] = f, g[15] = m, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new cc).fromArray(this.elements);
            }
            copy(t1) {
                const e = this.elements, n = t1.elements;
                return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
            }
            copyPosition(t1) {
                const e = this.elements, n = t1.elements;
                return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
            }
            setFromMatrix3(t1) {
                const e = t1.elements;
                return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(t1, e, n) {
                return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(t1, e, n) {
                return this.set(t1.x, e.x, n.x, 0, t1.y, e.y, n.y, 0, t1.z, e.z, n.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(t1) {
                const e = this.elements, n = t1.elements, i = 1 / uc.setFromMatrixColumn(t1, 0).length(), r = 1 / uc.setFromMatrixColumn(t1, 1).length(), a = 1 / uc.setFromMatrixColumn(t1, 2).length();
                return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * a, e[9] = n[9] * a, e[10] = n[10] * a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromEuler(t1) {
                const e = this.elements, n = t1.x, i = t1.y, r = t1.z, a = Math.cos(n), s = Math.sin(n), o = Math.cos(i), l = Math.sin(i), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === t1.order) {
                    const t1 = a * c, n = a * u, i = s * c, r = s * u;
                    e[0] = o * c, e[4] = -o * u, e[8] = l, e[1] = n + i * l, e[5] = t1 - r * l, e[9] = -s * o, e[2] = r - t1 * l, e[6] = i + n * l, e[10] = a * o;
                } else if ("YXZ" === t1.order) {
                    const t1 = o * c, n = o * u, i = l * c, r = l * u;
                    e[0] = t1 + r * s, e[4] = i * s - n, e[8] = a * l, e[1] = a * u, e[5] = a * c, e[9] = -s, e[2] = n * s - i, e[6] = r + t1 * s, e[10] = a * o;
                } else if ("ZXY" === t1.order) {
                    const t1 = o * c, n = o * u, i = l * c, r = l * u;
                    e[0] = t1 - r * s, e[4] = -a * u, e[8] = i + n * s, e[1] = n + i * s, e[5] = a * c, e[9] = r - t1 * s, e[2] = -a * l, e[6] = s, e[10] = a * o;
                } else if ("ZYX" === t1.order) {
                    const t1 = a * c, n = a * u, i = s * c, r = s * u;
                    e[0] = o * c, e[4] = i * l - n, e[8] = t1 * l + r, e[1] = o * u, e[5] = r * l + t1, e[9] = n * l - i, e[2] = -l, e[6] = s * o, e[10] = a * o;
                } else if ("YZX" === t1.order) {
                    const t1 = a * o, n = a * l, i = s * o, r = s * l;
                    e[0] = o * c, e[4] = r - t1 * u, e[8] = i * u + n, e[1] = u, e[5] = a * c, e[9] = -s * c, e[2] = -l * c, e[6] = n * u + i, e[10] = t1 - r * u;
                } else if ("XZY" === t1.order) {
                    const t1 = a * o, n = a * l, i = s * o, r = s * l;
                    e[0] = o * c, e[4] = -u, e[8] = l * c, e[1] = t1 * u + r, e[5] = a * c, e[9] = n * u - i, e[2] = i * u - n, e[6] = s * c, e[10] = r * u + t1;
                }
                return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromQuaternion(t1) {
                return this.compose(dc, t1, pc);
            }
            lookAt(t1, e, n) {
                const i = this.elements;
                return gc.subVectors(t1, e), 0 === gc.lengthSq() && (gc.z = 1), gc.normalize(), fc.crossVectors(n, gc), 0 === fc.lengthSq() && (1 === Math.abs(n.z) ? gc.x += 1e-4 : gc.z += 1e-4, gc.normalize(), fc.crossVectors(n, gc)), fc.normalize(), mc.crossVectors(gc, fc), i[0] = fc.x, i[4] = mc.x, i[8] = gc.x, i[1] = fc.y, i[5] = mc.y, i[9] = gc.y, i[2] = fc.z, i[6] = mc.z, i[10] = gc.z, this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const n = t1.elements, i = e.elements, r = this.elements, a = n[0], s = n[4], o = n[8], l = n[12], c = n[1], u = n[5], h = n[9], d = n[13], p = n[2], f = n[6], m = n[10], g = n[14], A = n[3], v = n[7], y = n[11], M = n[15], b = i[0], x = i[4], w = i[8], _ = i[12], E = i[1], S = i[5], T = i[9], I = i[13], C = i[2], N = i[6], D = i[10], L = i[14], O = i[3], R = i[7], P = i[11], z = i[15];
                return r[0] = a * b + s * E + o * C + l * O, r[4] = a * x + s * S + o * N + l * R, r[8] = a * w + s * T + o * D + l * P, r[12] = a * _ + s * I + o * L + l * z, r[1] = c * b + u * E + h * C + d * O, r[5] = c * x + u * S + h * N + d * R, r[9] = c * w + u * T + h * D + d * P, r[13] = c * _ + u * I + h * L + d * z, r[2] = p * b + f * E + m * C + g * O, r[6] = p * x + f * S + m * N + g * R, r[10] = p * w + f * T + m * D + g * P, r[14] = p * _ + f * I + m * L + g * z, r[3] = A * b + v * E + y * C + M * O, r[7] = A * x + v * S + y * N + M * R, r[11] = A * w + v * T + y * D + M * P, r[15] = A * _ + v * I + y * L + M * z, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], n = t1[4], i = t1[8], r = t1[12], a = t1[1], s = t1[5], o = t1[9], l = t1[13], c = t1[2], u = t1[6], h = t1[10], d = t1[14];
                return t1[3] * (+r * o * u - i * l * u - r * s * h + n * l * h + i * s * d - n * o * d) + t1[7] * (+e * o * d - e * l * h + r * a * h - i * a * d + i * l * c - r * o * c) + t1[11] * (+e * l * u - e * s * d - r * a * u + n * a * d + r * s * c - n * l * c) + t1[15] * (-i * s * c - e * o * u + e * s * h + i * a * u - n * a * h + n * o * c);
            }
            transpose() {
                const t1 = this.elements;
                let e;
                return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
            }
            setPosition(t1, e, n) {
                const i = this.elements;
                return t1.isVector3 ? (i[12] = t1.x, i[13] = t1.y, i[14] = t1.z) : (i[12] = t1, i[13] = e, i[14] = n), this;
            }
            invert() {
                const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11], p = t1[12], f = t1[13], m = t1[14], g = t1[15], A = u * m * l - f * h * l + f * o * d - s * m * d - u * o * g + s * h * g, v = p * h * l - c * m * l - p * o * d + a * m * d + c * o * g - a * h * g, y = c * f * l - p * u * l + p * s * d - a * f * d - c * s * g + a * u * g, M = p * u * o - c * f * o - p * s * h + a * f * h + c * s * m - a * u * m, b = e * A + n * v + i * y + r * M;
                if (0 === b) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const x = 1 / b;
                return t1[0] = A * x, t1[1] = (f * h * r - u * m * r - f * i * d + n * m * d + u * i * g - n * h * g) * x, t1[2] = (s * m * r - f * o * r + f * i * l - n * m * l - s * i * g + n * o * g) * x, t1[3] = (u * o * r - s * h * r - u * i * l + n * h * l + s * i * d - n * o * d) * x, t1[4] = v * x, t1[5] = (c * m * r - p * h * r + p * i * d - e * m * d - c * i * g + e * h * g) * x, t1[6] = (p * o * r - a * m * r - p * i * l + e * m * l + a * i * g - e * o * g) * x, t1[7] = (a * h * r - c * o * r + c * i * l - e * h * l - a * i * d + e * o * d) * x, t1[8] = y * x, t1[9] = (p * u * r - c * f * r - p * n * d + e * f * d + c * n * g - e * u * g) * x, t1[10] = (a * f * r - p * s * r + p * n * l - e * f * l - a * n * g + e * s * g) * x, t1[11] = (c * s * r - a * u * r - c * n * l + e * u * l + a * n * d - e * s * d) * x, t1[12] = M * x, t1[13] = (c * f * i - p * u * i + p * n * h - e * f * h - c * n * m + e * u * m) * x, t1[14] = (p * s * i - a * f * i - p * n * o + e * f * o + a * n * m - e * s * m) * x, t1[15] = (a * u * i - c * s * i + c * n * o - e * u * o - a * n * h + e * s * h) * x, this;
            }
            scale(t1) {
                const e = this.elements, n = t1.x, i = t1.y, r = t1.z;
                return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], n = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], i = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
                return Math.sqrt(Math.max(e, n, i));
            }
            makeTranslation(t1, e, n) {
                return t1.isVector3 ? this.set(1, 0, 0, t1.x, 0, 1, 0, t1.y, 0, 0, 1, t1.z, 0, 0, 0, 1) : this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
            }
            makeRotationX(t1) {
                const e = Math.cos(t1), n = Math.sin(t1);
                return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(t1) {
                const e = Math.cos(t1), n = Math.sin(t1);
                return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(t1) {
                const e = Math.cos(t1), n = Math.sin(t1);
                return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(t1, e) {
                const n = Math.cos(e), i = Math.sin(e), r = 1 - n, a = t1.x, s = t1.y, o = t1.z, l = r * a, c = r * s;
                return this.set(l * a + n, l * s - i * o, l * o + i * s, 0, l * s + i * o, c * s + n, c * o - i * a, 0, l * o - i * s, c * o + i * a, r * o * o + n, 0, 0, 0, 0, 1), this;
            }
            makeScale(t1, e, n) {
                return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            }
            makeShear(t1, e, n, i, r, a) {
                return this.set(1, n, r, 0, t1, 1, a, 0, e, i, 1, 0, 0, 0, 0, 1), this;
            }
            compose(t1, e, n) {
                const i = this.elements, r = e._x, a = e._y, s = e._z, o = e._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, m = a * u, g = s * u, A = o * l, v = o * c, y = o * u, M = n.x, b = n.y, x = n.z;
                return i[0] = (1 - (f + g)) * M, i[1] = (d + y) * M, i[2] = (p - v) * M, i[3] = 0, i[4] = (d - y) * b, i[5] = (1 - (h + g)) * b, i[6] = (m + A) * b, i[7] = 0, i[8] = (p + v) * x, i[9] = (m - A) * x, i[10] = (1 - (h + f)) * x, i[11] = 0, i[12] = t1.x, i[13] = t1.y, i[14] = t1.z, i[15] = 1, this;
            }
            decompose(t1, e, n) {
                const i = this.elements;
                let r = uc.set(i[0], i[1], i[2]).length();
                const a = uc.set(i[4], i[5], i[6]).length(), s = uc.set(i[8], i[9], i[10]).length();
                this.determinant() < 0 && (r = -r), t1.x = i[12], t1.y = i[13], t1.z = i[14], hc.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return hc.elements[0] *= o, hc.elements[1] *= o, hc.elements[2] *= o, hc.elements[4] *= l, hc.elements[5] *= l, hc.elements[6] *= l, hc.elements[8] *= c, hc.elements[9] *= c, hc.elements[10] *= c, e.setFromRotationMatrix(hc), n.x = r, n.y = a, n.z = s, this;
            }
            makePerspective(t1, e, n, i, r, a, s = Uo) {
                const o = this.elements, l = 2 * r / (e - t1), c = 2 * r / (n - i), u = (e + t1) / (e - t1), h = (n + i) / (n - i);
                let d, p;
                if (s === Uo) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (s !== ko) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(t1, e, n, i, r, a, s = Uo) {
                const o = this.elements, l = 1 / (e - t1), c = 1 / (n - i), u = 1 / (a - r), h = (e + t1) * l, d = (n + i) * c;
                let p, f;
                if (s === Uo) p = (a + r) * u, f = -2 * u;
                else {
                    if (s !== ko) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(t1) {
                const e = this.elements, n = t1.elements;
                for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== n[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let n = 0; n < 16; n++)this.elements[n] = t1[n + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const n = this.elements;
                return t1[e] = n[0], t1[e + 1] = n[1], t1[e + 2] = n[2], t1[e + 3] = n[3], t1[e + 4] = n[4], t1[e + 5] = n[5], t1[e + 6] = n[6], t1[e + 7] = n[7], t1[e + 8] = n[8], t1[e + 9] = n[9], t1[e + 10] = n[10], t1[e + 11] = n[11], t1[e + 12] = n[12], t1[e + 13] = n[13], t1[e + 14] = n[14], t1[e + 15] = n[15], t1;
            }
        }
        const uc = new Ol, hc = new cc, dc = new Ol(0, 0, 0), pc = new Ol(1, 1, 1), fc = new Ol, mc = new Ol, gc = new Ol, Ac = new cc, vc = new Ll;
        class yc {
            constructor(t1 = 0, e = 0, n = 0, i = yc.DEFAULT_ORDER){
                this.isEuler = !0, this._x = t1, this._y = e, this._z = n, this._order = i;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get order() {
                return this._order;
            }
            set order(t1) {
                this._order = t1, this._onChangeCallback();
            }
            set(t1, e, n, i = this._order) {
                return this._x = t1, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
            copy(t1) {
                return this._x = t1._x, this._y = t1._y, this._z = t1._z, this._order = t1._order, this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1, e = this._order, n = !0) {
                const i = t1.elements, r = i[0], a = i[4], s = i[8], o = i[1], l = i[5], c = i[9], u = i[2], h = i[6], d = i[10];
                switch(e){
                    case "XYZ":
                        this._y = Math.asin(Go(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(h, l), this._z = 0);
                        break;
                    case "YXZ":
                        this._x = Math.asin(-Go(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                        break;
                    case "ZXY":
                        this._x = Math.asin(Go(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                        break;
                    case "ZYX":
                        this._y = Math.asin(-Go(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-a, l));
                        break;
                    case "YZX":
                        this._z = Math.asin(Go(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(s, d));
                        break;
                    case "XZY":
                        this._z = Math.asin(-Go(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
                        break;
                    default:
                        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
                }
                return this._order = e, !0 === n && this._onChangeCallback(), this;
            }
            setFromQuaternion(t1, e, n) {
                return Ac.makeRotationFromQuaternion(t1), this.setFromRotationMatrix(Ac, e, n);
            }
            setFromVector3(t1, e = this._order) {
                return this.set(t1.x, t1.y, t1.z, e);
            }
            reorder(t1) {
                return vc.setFromEuler(this), this.setFromQuaternion(vc, t1);
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._order === this._order;
            }
            fromArray(t1) {
                return this._x = t1[0], this._y = t1[1], this._z = t1[2], void 0 !== t1[3] && (this._order = t1[3]), this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._order, t1;
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._order;
            }
        }
        yc.DEFAULT_ORDER = "XYZ";
        class Mc {
            constructor(){
                this.mask = 1;
            }
            set(t1) {
                this.mask = 1 << t1 >>> 0;
            }
            enable(t1) {
                this.mask |= 1 << t1;
            }
            enableAll() {
                this.mask = -1;
            }
            toggle(t1) {
                this.mask ^= 1 << t1;
            }
            disable(t1) {
                this.mask &= ~(1 << t1);
            }
            disableAll() {
                this.mask = 0;
            }
            test(t1) {
                return !!(this.mask & t1.mask);
            }
            isEnabled(t1) {
                return !!(this.mask & 1 << t1);
            }
        }
        let bc = 0;
        const xc = new Ol, wc = new Ll, _c = new cc, Ec = new Ol, Sc = new Ol, Tc = new Ol, Ic = new Ll, Cc = new Ol(1, 0, 0), Nc = new Ol(0, 1, 0), Dc = new Ol(0, 0, 1), Lc = {
            type: "added"
        }, Oc = {
            type: "removed"
        };
        class Rc extends Bo {
            constructor(){
                super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                    value: bc++
                }), this.uuid = Qo(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Rc.DEFAULT_UP.clone();
                const t1 = new Ol, e = new yc, n = new Ll, i = new Ol(1, 1, 1);
                e._onChange(function() {
                    n.setFromEuler(e, !1);
                }), n._onChange(function() {
                    e.setFromQuaternion(n, void 0, !1);
                }), Object.defineProperties(this, {
                    position: {
                        configurable: !0,
                        enumerable: !0,
                        value: t1
                    },
                    rotation: {
                        configurable: !0,
                        enumerable: !0,
                        value: e
                    },
                    quaternion: {
                        configurable: !0,
                        enumerable: !0,
                        value: n
                    },
                    scale: {
                        configurable: !0,
                        enumerable: !0,
                        value: i
                    },
                    modelViewMatrix: {
                        value: new cc
                    },
                    normalMatrix: {
                        value: new el
                    }
                }), this.matrix = new cc, this.matrixWorld = new cc, this.matrixAutoUpdate = Rc.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Rc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new Mc, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
            }
            onBeforeRender() {}
            onAfterRender() {}
            applyMatrix4(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t1), this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
            applyQuaternion(t1) {
                return this.quaternion.premultiply(t1), this;
            }
            setRotationFromAxisAngle(t1, e) {
                this.quaternion.setFromAxisAngle(t1, e);
            }
            setRotationFromEuler(t1) {
                this.quaternion.setFromEuler(t1, !0);
            }
            setRotationFromMatrix(t1) {
                this.quaternion.setFromRotationMatrix(t1);
            }
            setRotationFromQuaternion(t1) {
                this.quaternion.copy(t1);
            }
            rotateOnAxis(t1, e) {
                return wc.setFromAxisAngle(t1, e), this.quaternion.multiply(wc), this;
            }
            rotateOnWorldAxis(t1, e) {
                return wc.setFromAxisAngle(t1, e), this.quaternion.premultiply(wc), this;
            }
            rotateX(t1) {
                return this.rotateOnAxis(Cc, t1);
            }
            rotateY(t1) {
                return this.rotateOnAxis(Nc, t1);
            }
            rotateZ(t1) {
                return this.rotateOnAxis(Dc, t1);
            }
            translateOnAxis(t1, e) {
                return xc.copy(t1).applyQuaternion(this.quaternion), this.position.add(xc.multiplyScalar(e)), this;
            }
            translateX(t1) {
                return this.translateOnAxis(Cc, t1);
            }
            translateY(t1) {
                return this.translateOnAxis(Nc, t1);
            }
            translateZ(t1) {
                return this.translateOnAxis(Dc, t1);
            }
            localToWorld(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(this.matrixWorld);
            }
            worldToLocal(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(_c.copy(this.matrixWorld).invert());
            }
            lookAt(t1, e, n) {
                t1.isVector3 ? Ec.copy(t1) : Ec.set(t1, e, n);
                const i = this.parent;
                this.updateWorldMatrix(!0, !1), Sc.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? _c.lookAt(Sc, Ec, this.up) : _c.lookAt(Ec, Sc, this.up), this.quaternion.setFromRotationMatrix(_c), i && (_c.extractRotation(i.matrixWorld), wc.setFromRotationMatrix(_c), this.quaternion.premultiply(wc.invert()));
            }
            add(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.add(arguments[t1]);
                    return this;
                }
                return t1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t1), this) : (t1 && t1.isObject3D ? (null !== t1.parent && t1.parent.remove(t1), t1.parent = this, this.children.push(t1), t1.dispatchEvent(Lc)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t1), this);
            }
            remove(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.remove(arguments[t1]);
                    return this;
                }
                const e = this.children.indexOf(t1);
                return -1 !== e && (t1.parent = null, this.children.splice(e, 1), t1.dispatchEvent(Oc)), this;
            }
            removeFromParent() {
                const t1 = this.parent;
                return null !== t1 && t1.remove(this), this;
            }
            clear() {
                return this.remove(...this.children);
            }
            attach(t1) {
                return this.updateWorldMatrix(!0, !1), _c.copy(this.matrixWorld).invert(), null !== t1.parent && (t1.parent.updateWorldMatrix(!0, !1), _c.multiply(t1.parent.matrixWorld)), t1.applyMatrix4(_c), this.add(t1), t1.updateWorldMatrix(!1, !0), this;
            }
            getObjectById(t1) {
                return this.getObjectByProperty("id", t1);
            }
            getObjectByName(t1) {
                return this.getObjectByProperty("name", t1);
            }
            getObjectByProperty(t1, e) {
                if (this[t1] === e) return this;
                for(let n = 0, i = this.children.length; n < i; n++){
                    const i = this.children[n].getObjectByProperty(t1, e);
                    if (void 0 !== i) return i;
                }
            }
            getObjectsByProperty(t1, e) {
                let n = [];
                this[t1] === e && n.push(this);
                for(let i = 0, r = this.children.length; i < r; i++){
                    const r = this.children[i].getObjectsByProperty(t1, e);
                    r.length > 0 && (n = n.concat(r));
                }
                return n;
            }
            getWorldPosition(t1) {
                return this.updateWorldMatrix(!0, !1), t1.setFromMatrixPosition(this.matrixWorld);
            }
            getWorldQuaternion(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Sc, t1, Tc), t1;
            }
            getWorldScale(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Sc, Ic, t1), t1;
            }
            getWorldDirection(t1) {
                this.updateWorldMatrix(!0, !1);
                const e = this.matrixWorld.elements;
                return t1.set(e[8], e[9], e[10]).normalize();
            }
            raycast() {}
            traverse(t1) {
                t1(this);
                const e = this.children;
                for(let n = 0, i = e.length; n < i; n++)e[n].traverse(t1);
            }
            traverseVisible(t1) {
                if (!1 === this.visible) return;
                t1(this);
                const e = this.children;
                for(let n = 0, i = e.length; n < i; n++)e[n].traverseVisible(t1);
            }
            traverseAncestors(t1) {
                const e = this.parent;
                null !== e && (t1(e), e.traverseAncestors(t1));
            }
            updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            }
            updateMatrixWorld(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t1 = !0);
                const e = this.children;
                for(let n = 0, i = e.length; n < i; n++){
                    const i = e[n];
                    !0 !== i.matrixWorldAutoUpdate && !0 !== t1 || i.updateMatrixWorld(t1);
                }
            }
            updateWorldMatrix(t1, e) {
                const n = this.parent;
                if (!0 === t1 && null !== n && !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
                    const t1 = this.children;
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e];
                        !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!1, !0);
                    }
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1, n = {};
                e && (t1 = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                }, n.metadata = {
                    version: 4.6,
                    type: "Object",
                    generator: "Object3D.toJSON"
                });
                const i = {};
                function r(e, n) {
                    return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t1)), n.uuid;
                }
                if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (i.environment = this.environment.toJSON(t1).uuid);
                else if (this.isMesh || this.isLine || this.isPoints) {
                    i.geometry = r(t1.geometries, this.geometry);
                    const e = this.geometry.parameters;
                    if (void 0 !== e && void 0 !== e.shapes) {
                        const n = e.shapes;
                        if (Array.isArray(n)) for(let e = 0, i = n.length; e < i; e++){
                            const i = n[e];
                            r(t1.shapes, i);
                        }
                        else r(t1.shapes, n);
                    }
                }
                if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t1.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                    if (Array.isArray(this.material)) {
                        const e = [];
                        for(let n = 0, i = this.material.length; n < i; n++)e.push(r(t1.materials, this.material[n]));
                        i.material = e;
                    } else i.material = r(t1.materials, this.material);
                }
                if (this.children.length > 0) {
                    i.children = [];
                    for(let e = 0; e < this.children.length; e++)i.children.push(this.children[e].toJSON(t1).object);
                }
                if (this.animations.length > 0) {
                    i.animations = [];
                    for(let e = 0; e < this.animations.length; e++){
                        const n = this.animations[e];
                        i.animations.push(r(t1.animations, n));
                    }
                }
                if (e) {
                    const e = a(t1.geometries), i = a(t1.materials), r = a(t1.textures), s = a(t1.images), o = a(t1.shapes), l = a(t1.skeletons), c = a(t1.animations), u = a(t1.nodes);
                    e.length > 0 && (n.geometries = e), i.length > 0 && (n.materials = i), r.length > 0 && (n.textures = r), s.length > 0 && (n.images = s), o.length > 0 && (n.shapes = o), l.length > 0 && (n.skeletons = l), c.length > 0 && (n.animations = c), u.length > 0 && (n.nodes = u);
                }
                return n.object = i, n;
                function a(t1) {
                    const e = [];
                    for(const n in t1){
                        const i = t1[n];
                        delete i.metadata, e.push(i);
                    }
                    return e;
                }
            }
            clone(t1) {
                return (new this.constructor).copy(this, t1);
            }
            copy(t1, e = !0) {
                if (this.name = t1.name, this.up.copy(t1.up), this.position.copy(t1.position), this.rotation.order = t1.rotation.order, this.quaternion.copy(t1.quaternion), this.scale.copy(t1.scale), this.matrix.copy(t1.matrix), this.matrixWorld.copy(t1.matrixWorld), this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t1.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t1.matrixWorldAutoUpdate, this.layers.mask = t1.layers.mask, this.visible = t1.visible, this.castShadow = t1.castShadow, this.receiveShadow = t1.receiveShadow, this.frustumCulled = t1.frustumCulled, this.renderOrder = t1.renderOrder, this.animations = t1.animations.slice(), this.userData = JSON.parse(JSON.stringify(t1.userData)), !0 === e) for(let e = 0; e < t1.children.length; e++){
                    const n = t1.children[e];
                    this.add(n.clone());
                }
                return this;
            }
        }
        Rc.DEFAULT_UP = new Ol(0, 1, 0), Rc.DEFAULT_MATRIX_AUTO_UPDATE = !0, Rc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
        const Pc = new Ol, zc = new Ol, Uc = new Ol, kc = new Ol, Bc = new Ol, jc = new Ol, Fc = new Ol, Hc = new Ol, Vc = new Ol, Qc = new Ol;
        let Gc = !1;
        class Wc {
            constructor(t1 = new Ol, e = new Ol, n = new Ol){
                this.a = t1, this.b = e, this.c = n;
            }
            static getNormal(t1, e, n, i) {
                i.subVectors(n, e), Pc.subVectors(t1, e), i.cross(Pc);
                const r = i.lengthSq();
                return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
            }
            static getBarycoord(t1, e, n, i, r) {
                Pc.subVectors(i, e), zc.subVectors(n, e), Uc.subVectors(t1, e);
                const a = Pc.dot(Pc), s = Pc.dot(zc), o = Pc.dot(Uc), l = zc.dot(zc), c = zc.dot(Uc), u = a * l - s * s;
                if (0 === u) return r.set(-2, -1, -1);
                const h = 1 / u, d = (l * o - s * c) * h, p = (a * c - s * o) * h;
                return r.set(1 - d - p, p, d);
            }
            static containsPoint(t1, e, n, i) {
                return this.getBarycoord(t1, e, n, i, kc), kc.x >= 0 && kc.y >= 0 && kc.x + kc.y <= 1;
            }
            static getUV(t1, e, n, i, r, a, s, o) {
                return !1 === Gc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Gc = !0), this.getInterpolation(t1, e, n, i, r, a, s, o);
            }
            static getInterpolation(t1, e, n, i, r, a, s, o) {
                return this.getBarycoord(t1, e, n, i, kc), o.setScalar(0), o.addScaledVector(r, kc.x), o.addScaledVector(a, kc.y), o.addScaledVector(s, kc.z), o;
            }
            static isFrontFacing(t1, e, n, i) {
                return Pc.subVectors(n, e), zc.subVectors(t1, e), Pc.cross(zc).dot(i) < 0;
            }
            set(t1, e, n) {
                return this.a.copy(t1), this.b.copy(e), this.c.copy(n), this;
            }
            setFromPointsAndIndices(t1, e, n, i) {
                return this.a.copy(t1[e]), this.b.copy(t1[n]), this.c.copy(t1[i]), this;
            }
            setFromAttributeAndIndices(t1, e, n, i) {
                return this.a.fromBufferAttribute(t1, e), this.b.fromBufferAttribute(t1, n), this.c.fromBufferAttribute(t1, i), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.a.copy(t1.a), this.b.copy(t1.b), this.c.copy(t1.c), this;
            }
            getArea() {
                return Pc.subVectors(this.c, this.b), zc.subVectors(this.a, this.b), .5 * Pc.cross(zc).length();
            }
            getMidpoint(t1) {
                return t1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
            getNormal(t1) {
                return Wc.getNormal(this.a, this.b, this.c, t1);
            }
            getPlane(t1) {
                return t1.setFromCoplanarPoints(this.a, this.b, this.c);
            }
            getBarycoord(t1, e) {
                return Wc.getBarycoord(t1, this.a, this.b, this.c, e);
            }
            getUV(t1, e, n, i, r) {
                return !1 === Gc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Gc = !0), Wc.getInterpolation(t1, this.a, this.b, this.c, e, n, i, r);
            }
            getInterpolation(t1, e, n, i, r) {
                return Wc.getInterpolation(t1, this.a, this.b, this.c, e, n, i, r);
            }
            containsPoint(t1) {
                return Wc.containsPoint(t1, this.a, this.b, this.c);
            }
            isFrontFacing(t1) {
                return Wc.isFrontFacing(this.a, this.b, this.c, t1);
            }
            intersectsBox(t1) {
                return t1.intersectsTriangle(this);
            }
            closestPointToPoint(t1, e) {
                const n = this.a, i = this.b, r = this.c;
                let a, s;
                Bc.subVectors(i, n), jc.subVectors(r, n), Hc.subVectors(t1, n);
                const o = Bc.dot(Hc), l = jc.dot(Hc);
                if (o <= 0 && l <= 0) return e.copy(n);
                Vc.subVectors(t1, i);
                const c = Bc.dot(Vc), u = jc.dot(Vc);
                if (c >= 0 && u <= c) return e.copy(i);
                const h = o * u - c * l;
                if (h <= 0 && o >= 0 && c <= 0) return a = o / (o - c), e.copy(n).addScaledVector(Bc, a);
                Qc.subVectors(t1, r);
                const d = Bc.dot(Qc), p = jc.dot(Qc);
                if (p >= 0 && d <= p) return e.copy(r);
                const f = d * l - o * p;
                if (f <= 0 && l >= 0 && p <= 0) return s = l / (l - p), e.copy(n).addScaledVector(jc, s);
                const m = c * p - d * u;
                if (m <= 0 && u - c >= 0 && d - p >= 0) return Fc.subVectors(r, i), s = (u - c) / (u - c + (d - p)), e.copy(i).addScaledVector(Fc, s);
                const g = 1 / (m + f + h);
                return a = f * g, s = h * g, e.copy(n).addScaledVector(Bc, a).addScaledVector(jc, s);
            }
            equals(t1) {
                return t1.a.equals(this.a) && t1.b.equals(this.b) && t1.c.equals(this.c);
            }
        }
        const Xc = {
            aliceblue: 15792383,
            antiquewhite: 16444375,
            aqua: 65535,
            aquamarine: 8388564,
            azure: 15794175,
            beige: 16119260,
            bisque: 16770244,
            black: 0,
            blanchedalmond: 16772045,
            blue: 255,
            blueviolet: 9055202,
            brown: 10824234,
            burlywood: 14596231,
            cadetblue: 6266528,
            chartreuse: 8388352,
            chocolate: 13789470,
            coral: 16744272,
            cornflowerblue: 6591981,
            cornsilk: 16775388,
            crimson: 14423100,
            cyan: 65535,
            darkblue: 139,
            darkcyan: 35723,
            darkgoldenrod: 12092939,
            darkgray: 11119017,
            darkgreen: 25600,
            darkgrey: 11119017,
            darkkhaki: 12433259,
            darkmagenta: 9109643,
            darkolivegreen: 5597999,
            darkorange: 16747520,
            darkorchid: 10040012,
            darkred: 9109504,
            darksalmon: 15308410,
            darkseagreen: 9419919,
            darkslateblue: 4734347,
            darkslategray: 3100495,
            darkslategrey: 3100495,
            darkturquoise: 52945,
            darkviolet: 9699539,
            deeppink: 16716947,
            deepskyblue: 49151,
            dimgray: 6908265,
            dimgrey: 6908265,
            dodgerblue: 2003199,
            firebrick: 11674146,
            floralwhite: 16775920,
            forestgreen: 2263842,
            fuchsia: 16711935,
            gainsboro: 14474460,
            ghostwhite: 16316671,
            gold: 16766720,
            goldenrod: 14329120,
            gray: 8421504,
            green: 32768,
            greenyellow: 11403055,
            grey: 8421504,
            honeydew: 15794160,
            hotpink: 16738740,
            indianred: 13458524,
            indigo: 4915330,
            ivory: 16777200,
            khaki: 15787660,
            lavender: 15132410,
            lavenderblush: 16773365,
            lawngreen: 8190976,
            lemonchiffon: 16775885,
            lightblue: 11393254,
            lightcoral: 15761536,
            lightcyan: 14745599,
            lightgoldenrodyellow: 16448210,
            lightgray: 13882323,
            lightgreen: 9498256,
            lightgrey: 13882323,
            lightpink: 16758465,
            lightsalmon: 16752762,
            lightseagreen: 2142890,
            lightskyblue: 8900346,
            lightslategray: 7833753,
            lightslategrey: 7833753,
            lightsteelblue: 11584734,
            lightyellow: 16777184,
            lime: 65280,
            limegreen: 3329330,
            linen: 16445670,
            magenta: 16711935,
            maroon: 8388608,
            mediumaquamarine: 6737322,
            mediumblue: 205,
            mediumorchid: 12211667,
            mediumpurple: 9662683,
            mediumseagreen: 3978097,
            mediumslateblue: 8087790,
            mediumspringgreen: 64154,
            mediumturquoise: 4772300,
            mediumvioletred: 13047173,
            midnightblue: 1644912,
            mintcream: 16121850,
            mistyrose: 16770273,
            moccasin: 16770229,
            navajowhite: 16768685,
            navy: 128,
            oldlace: 16643558,
            olive: 8421376,
            olivedrab: 7048739,
            orange: 16753920,
            orangered: 16729344,
            orchid: 14315734,
            palegoldenrod: 15657130,
            palegreen: 10025880,
            paleturquoise: 11529966,
            palevioletred: 14381203,
            papayawhip: 16773077,
            peachpuff: 16767673,
            peru: 13468991,
            pink: 16761035,
            plum: 14524637,
            powderblue: 11591910,
            purple: 8388736,
            rebeccapurple: 6697881,
            red: 16711680,
            rosybrown: 12357519,
            royalblue: 4286945,
            saddlebrown: 9127187,
            salmon: 16416882,
            sandybrown: 16032864,
            seagreen: 3050327,
            seashell: 16774638,
            sienna: 10506797,
            silver: 12632256,
            skyblue: 8900331,
            slateblue: 6970061,
            slategray: 7372944,
            slategrey: 7372944,
            snow: 16775930,
            springgreen: 65407,
            steelblue: 4620980,
            tan: 13808780,
            teal: 32896,
            thistle: 14204888,
            tomato: 16737095,
            turquoise: 4251856,
            violet: 15631086,
            wheat: 16113331,
            white: 16777215,
            whitesmoke: 16119285,
            yellow: 16776960,
            yellowgreen: 10145074
        }, Yc = {
            h: 0,
            s: 0,
            l: 0
        }, Zc = {
            h: 0,
            s: 0,
            l: 0
        };
        function qc(t1, e, n) {
            return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t1 + 6 * (e - t1) * n : n < .5 ? e : n < 2 / 3 ? t1 + 6 * (e - t1) * (2 / 3 - n) : t1;
        }
        class Jc {
            constructor(t1, e, n){
                return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t1, e, n);
            }
            set(t1, e, n) {
                if (void 0 === e && void 0 === n) {
                    const e = t1;
                    e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e);
                } else this.setRGB(t1, e, n);
                return this;
            }
            setScalar(t1) {
                return this.r = t1, this.g = t1, this.b = t1, this;
            }
            setHex(t1, e = Ws) {
                return t1 = Math.floor(t1), this.r = (t1 >> 16 & 255) / 255, this.g = (t1 >> 8 & 255) / 255, this.b = (255 & t1) / 255, fl.toWorkingColorSpace(this, e), this;
            }
            setRGB(t1, e, n, i = fl.workingColorSpace) {
                return this.r = t1, this.g = e, this.b = n, fl.toWorkingColorSpace(this, i), this;
            }
            setHSL(t1, e, n, i = fl.workingColorSpace) {
                if (t1 = Wo(t1, 1), e = Go(e, 0, 1), n = Go(n, 0, 1), 0 === e) this.r = this.g = this.b = n;
                else {
                    const i = n <= .5 ? n * (1 + e) : n + e - n * e, r = 2 * n - i;
                    this.r = qc(r, i, t1 + 1 / 3), this.g = qc(r, i, t1), this.b = qc(r, i, t1 - 1 / 3);
                }
                return fl.toWorkingColorSpace(this, i), this;
            }
            setStyle(t1, e = Ws) {
                function n(e) {
                    void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t1 + " will be ignored.");
                }
                let i;
                if (i = /^(\w+)\(([^\)]*)\)/.exec(t1)) {
                    let r;
                    const a = i[1], s = i[2];
                    switch(a){
                        case "rgb":
                        case "rgba":
                            if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, e);
                            if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, e);
                            break;
                        case "hsl":
                        case "hsla":
                            if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, e);
                            break;
                        default:
                            console.warn("THREE.Color: Unknown color model " + t1);
                    }
                } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t1)) {
                    const n = i[1], r = n.length;
                    if (3 === r) return this.setRGB(parseInt(n.charAt(0), 16) / 15, parseInt(n.charAt(1), 16) / 15, parseInt(n.charAt(2), 16) / 15, e);
                    if (6 === r) return this.setHex(parseInt(n, 16), e);
                    console.warn("THREE.Color: Invalid hex color " + t1);
                } else if (t1 && t1.length > 0) return this.setColorName(t1, e);
                return this;
            }
            setColorName(t1, e = Ws) {
                const n = Xc[t1.toLowerCase()];
                return void 0 !== n ? this.setHex(n, e) : console.warn("THREE.Color: Unknown color " + t1), this;
            }
            clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
            copy(t1) {
                return this.r = t1.r, this.g = t1.g, this.b = t1.b, this;
            }
            copySRGBToLinear(t1) {
                return this.r = ml(t1.r), this.g = ml(t1.g), this.b = ml(t1.b), this;
            }
            copyLinearToSRGB(t1) {
                return this.r = gl(t1.r), this.g = gl(t1.g), this.b = gl(t1.b), this;
            }
            convertSRGBToLinear() {
                return this.copySRGBToLinear(this), this;
            }
            convertLinearToSRGB() {
                return this.copyLinearToSRGB(this), this;
            }
            getHex(t1 = Ws) {
                return fl.fromWorkingColorSpace(Kc.copy(this), t1), 65536 * Math.round(Go(255 * Kc.r, 0, 255)) + 256 * Math.round(Go(255 * Kc.g, 0, 255)) + Math.round(Go(255 * Kc.b, 0, 255));
            }
            getHexString(t1 = Ws) {
                return ("000000" + this.getHex(t1).toString(16)).slice(-6);
            }
            getHSL(t1, e = fl.workingColorSpace) {
                fl.fromWorkingColorSpace(Kc.copy(this), e);
                const n = Kc.r, i = Kc.g, r = Kc.b, a = Math.max(n, i, r), s = Math.min(n, i, r);
                let o, l;
                const c = (s + a) / 2;
                if (s === a) o = 0, l = 0;
                else {
                    const t1 = a - s;
                    switch(l = c <= .5 ? t1 / (a + s) : t1 / (2 - a - s), a){
                        case n:
                            o = (i - r) / t1 + (i < r ? 6 : 0);
                            break;
                        case i:
                            o = (r - n) / t1 + 2;
                            break;
                        case r:
                            o = (n - i) / t1 + 4;
                    }
                    o /= 6;
                }
                return t1.h = o, t1.s = l, t1.l = c, t1;
            }
            getRGB(t1, e = fl.workingColorSpace) {
                return fl.fromWorkingColorSpace(Kc.copy(this), e), t1.r = Kc.r, t1.g = Kc.g, t1.b = Kc.b, t1;
            }
            getStyle(t1 = Ws) {
                fl.fromWorkingColorSpace(Kc.copy(this), t1);
                const e = Kc.r, n = Kc.g, i = Kc.b;
                return t1 !== Ws ? `color(${t1} ${e.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(255 * e)},${Math.round(255 * n)},${Math.round(255 * i)})`;
            }
            offsetHSL(t1, e, n) {
                return this.getHSL(Yc), this.setHSL(Yc.h + t1, Yc.s + e, Yc.l + n);
            }
            add(t1) {
                return this.r += t1.r, this.g += t1.g, this.b += t1.b, this;
            }
            addColors(t1, e) {
                return this.r = t1.r + e.r, this.g = t1.g + e.g, this.b = t1.b + e.b, this;
            }
            addScalar(t1) {
                return this.r += t1, this.g += t1, this.b += t1, this;
            }
            sub(t1) {
                return this.r = Math.max(0, this.r - t1.r), this.g = Math.max(0, this.g - t1.g), this.b = Math.max(0, this.b - t1.b), this;
            }
            multiply(t1) {
                return this.r *= t1.r, this.g *= t1.g, this.b *= t1.b, this;
            }
            multiplyScalar(t1) {
                return this.r *= t1, this.g *= t1, this.b *= t1, this;
            }
            lerp(t1, e) {
                return this.r += (t1.r - this.r) * e, this.g += (t1.g - this.g) * e, this.b += (t1.b - this.b) * e, this;
            }
            lerpColors(t1, e, n) {
                return this.r = t1.r + (e.r - t1.r) * n, this.g = t1.g + (e.g - t1.g) * n, this.b = t1.b + (e.b - t1.b) * n, this;
            }
            lerpHSL(t1, e) {
                this.getHSL(Yc), t1.getHSL(Zc);
                const n = Xo(Yc.h, Zc.h, e), i = Xo(Yc.s, Zc.s, e), r = Xo(Yc.l, Zc.l, e);
                return this.setHSL(n, i, r), this;
            }
            setFromVector3(t1) {
                return this.r = t1.x, this.g = t1.y, this.b = t1.z, this;
            }
            applyMatrix3(t1) {
                const e = this.r, n = this.g, i = this.b, r = t1.elements;
                return this.r = r[0] * e + r[3] * n + r[6] * i, this.g = r[1] * e + r[4] * n + r[7] * i, this.b = r[2] * e + r[5] * n + r[8] * i, this;
            }
            equals(t1) {
                return t1.r === this.r && t1.g === this.g && t1.b === this.b;
            }
            fromArray(t1, e = 0) {
                return this.r = t1[e], this.g = t1[e + 1], this.b = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.r, t1[e + 1] = this.g, t1[e + 2] = this.b, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.r = t1.getX(e), this.g = t1.getY(e), this.b = t1.getZ(e), this;
            }
            toJSON() {
                return this.getHex();
            }
            *[Symbol.iterator]() {
                yield this.r, yield this.g, yield this.b;
            }
        }
        const Kc = new Jc;
        Jc.NAMES = Xc;
        let $c = 0;
        class tu extends Bo {
            constructor(){
                super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                    value: $c++
                }), this.uuid = Qo(), this.name = "", this.type = "Material", this.blending = gr, this.side = hr, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Nr, this.blendDst = Dr, this.blendEquation = br, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Jc(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Qr, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = go, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = eo, this.stencilZFail = eo, this.stencilZPass = eo, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
            }
            get alphaTest() {
                return this._alphaTest;
            }
            set alphaTest(t1) {
                this._alphaTest > 0 != t1 > 0 && this.version++, this._alphaTest = t1;
            }
            onBuild() {}
            onBeforeRender() {}
            onBeforeCompile() {}
            customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
            setValues(t1) {
                if (void 0 !== t1) for(const e in t1){
                    const n = t1[e];
                    if (void 0 === n) {
                        console.warn(`THREE.Material: parameter '${e}' has value of undefined.`);
                        continue;
                    }
                    const i = this[e];
                    void 0 !== i ? i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[e] = n : console.warn(`THREE.Material: '${e}' is not a property of THREE.${this.type}.`);
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                e && (t1 = {
                    textures: {},
                    images: {}
                });
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Material",
                        generator: "Material.toJSON"
                    }
                };
                function i(t1) {
                    const e = [];
                    for(const n in t1){
                        const i = t1[n];
                        delete i.metadata, e.push(i);
                    }
                    return e;
                }
                if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t1).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (n.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (n.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(t1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t1).uuid), void 0 !== this.anisotropy && (n.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(t1).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(t1).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t1).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t1).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t1).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t1).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t1).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t1).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t1).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t1).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t1).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t1).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t1).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t1).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== gr && (n.blending = this.blending), this.side !== hr && (n.side = this.side), !0 === this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = !0), this.blendSrc !== Nr && (n.blendSrc = this.blendSrc), this.blendDst !== Dr && (n.blendDst = this.blendDst), this.blendEquation !== br && (n.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (n.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (n.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (n.blendAlpha = this.blendAlpha), this.depthFunc !== Qr && (n.depthFunc = this.depthFunc), !1 === this.depthTest && (n.depthTest = this.depthTest), !1 === this.depthWrite && (n.depthWrite = this.depthWrite), !1 === this.colorWrite && (n.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== go && (n.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (n.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== eo && (n.stencilFail = this.stencilFail), this.stencilZFail !== eo && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== eo && (n.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (n.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaHash && (n.alphaHash = !0), !0 === this.alphaToCoverage && (n.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = !0), !0 === this.forceSinglePass && (n.forceSinglePass = !0), !0 === this.wireframe && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = !0), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), !1 === this.fog && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData), e) {
                    const e = i(t1.textures), r = i(t1.images);
                    e.length > 0 && (n.textures = e), r.length > 0 && (n.images = r);
                }
                return n;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.name = t1.name, this.blending = t1.blending, this.side = t1.side, this.vertexColors = t1.vertexColors, this.opacity = t1.opacity, this.transparent = t1.transparent, this.blendSrc = t1.blendSrc, this.blendDst = t1.blendDst, this.blendEquation = t1.blendEquation, this.blendSrcAlpha = t1.blendSrcAlpha, this.blendDstAlpha = t1.blendDstAlpha, this.blendEquationAlpha = t1.blendEquationAlpha, this.blendColor.copy(t1.blendColor), this.blendAlpha = t1.blendAlpha, this.depthFunc = t1.depthFunc, this.depthTest = t1.depthTest, this.depthWrite = t1.depthWrite, this.stencilWriteMask = t1.stencilWriteMask, this.stencilFunc = t1.stencilFunc, this.stencilRef = t1.stencilRef, this.stencilFuncMask = t1.stencilFuncMask, this.stencilFail = t1.stencilFail, this.stencilZFail = t1.stencilZFail, this.stencilZPass = t1.stencilZPass, this.stencilWrite = t1.stencilWrite;
                const e = t1.clippingPlanes;
                let n = null;
                if (null !== e) {
                    const t1 = e.length;
                    n = new Array(t1);
                    for(let i = 0; i !== t1; ++i)n[i] = e[i].clone();
                }
                return this.clippingPlanes = n, this.clipIntersection = t1.clipIntersection, this.clipShadows = t1.clipShadows, this.shadowSide = t1.shadowSide, this.colorWrite = t1.colorWrite, this.precision = t1.precision, this.polygonOffset = t1.polygonOffset, this.polygonOffsetFactor = t1.polygonOffsetFactor, this.polygonOffsetUnits = t1.polygonOffsetUnits, this.dithering = t1.dithering, this.alphaTest = t1.alphaTest, this.alphaHash = t1.alphaHash, this.alphaToCoverage = t1.alphaToCoverage, this.premultipliedAlpha = t1.premultipliedAlpha, this.forceSinglePass = t1.forceSinglePass, this.visible = t1.visible, this.toneMapped = t1.toneMapped, this.userData = JSON.parse(JSON.stringify(t1.userData)), this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
        }
        class eu extends tu {
            constructor(t1){
                super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Jc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Zr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        const nu = iu();
        function iu() {
            const t1 = new ArrayBuffer(4), e = new Float32Array(t1), n = new Uint32Array(t1), i = new Uint32Array(512), r = new Uint32Array(512);
            for(let t1 = 0; t1 < 256; ++t1){
                const e = t1 - 127;
                e < -27 ? (i[t1] = 0, i[256 | t1] = 32768, r[t1] = 24, r[256 | t1] = 24) : e < -14 ? (i[t1] = 1024 >> -e - 14, i[256 | t1] = 1024 >> -e - 14 | 32768, r[t1] = -e - 1, r[256 | t1] = -e - 1) : e <= 15 ? (i[t1] = e + 15 << 10, i[256 | t1] = e + 15 << 10 | 32768, r[t1] = 13, r[256 | t1] = 13) : e < 128 ? (i[t1] = 31744, i[256 | t1] = 64512, r[t1] = 24, r[256 | t1] = 24) : (i[t1] = 31744, i[256 | t1] = 64512, r[t1] = 13, r[256 | t1] = 13);
            }
            const a = new Uint32Array(2048), s = new Uint32Array(64), o = new Uint32Array(64);
            for(let t1 = 1; t1 < 1024; ++t1){
                let e = t1 << 13, n = 0;
                for(; !(8388608 & e);)e <<= 1, n -= 8388608;
                e &= -8388609, n += 947912704, a[t1] = e | n;
            }
            for(let t1 = 1024; t1 < 2048; ++t1)a[t1] = 939524096 + (t1 - 1024 << 13);
            for(let t1 = 1; t1 < 31; ++t1)s[t1] = t1 << 23;
            s[31] = 1199570944, s[32] = 2147483648;
            for(let t1 = 33; t1 < 63; ++t1)s[t1] = 2147483648 + (t1 - 32 << 23);
            s[63] = 3347054592;
            for(let t1 = 1; t1 < 64; ++t1)32 !== t1 && (o[t1] = 1024);
            return {
                floatView: e,
                uint32View: n,
                baseTable: i,
                shiftTable: r,
                mantissaTable: a,
                exponentTable: s,
                offsetTable: o
            };
        }
        function ru(t1) {
            Math.abs(t1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), t1 = Go(t1, -65504, 65504), nu.floatView[0] = t1;
            const e = nu.uint32View[0], n = e >> 23 & 511;
            return nu.baseTable[n] + ((8388607 & e) >> nu.shiftTable[n]);
        }
        function au(t1) {
            const e = t1 >> 10;
            return nu.uint32View[0] = nu.mantissaTable[nu.offsetTable[e] + (1023 & t1)] + nu.exponentTable[e], nu.floatView[0];
        }
        const su = {
            toHalfFloat: ru,
            fromHalfFloat: au
        }, ou = new Ol, lu = new tl;
        class cu {
            constructor(t1, e, n = !1){
                if (Array.isArray(t1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                this.isBufferAttribute = !0, this.name = "", this.array = t1, this.itemSize = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.normalized = n, this.usage = Eo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.gpuType = Da, this.version = 0;
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.name = t1.name, this.array = new t1.array.constructor(t1.array), this.itemSize = t1.itemSize, this.count = t1.count, this.normalized = t1.normalized, this.usage = t1.usage, this.gpuType = t1.gpuType, this;
            }
            copyAt(t1, e, n) {
                t1 *= this.itemSize, n *= e.itemSize;
                for(let i = 0, r = this.itemSize; i < r; i++)this.array[t1 + i] = e.array[n + i];
                return this;
            }
            copyArray(t1) {
                return this.array.set(t1), this;
            }
            applyMatrix3(t1) {
                if (2 === this.itemSize) for(let e = 0, n = this.count; e < n; e++)lu.fromBufferAttribute(this, e), lu.applyMatrix3(t1), this.setXY(e, lu.x, lu.y);
                else if (3 === this.itemSize) for(let e = 0, n = this.count; e < n; e++)ou.fromBufferAttribute(this, e), ou.applyMatrix3(t1), this.setXYZ(e, ou.x, ou.y, ou.z);
                return this;
            }
            applyMatrix4(t1) {
                for(let e = 0, n = this.count; e < n; e++)ou.fromBufferAttribute(this, e), ou.applyMatrix4(t1), this.setXYZ(e, ou.x, ou.y, ou.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, n = this.count; e < n; e++)ou.fromBufferAttribute(this, e), ou.applyNormalMatrix(t1), this.setXYZ(e, ou.x, ou.y, ou.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, n = this.count; e < n; e++)ou.fromBufferAttribute(this, e), ou.transformDirection(t1), this.setXYZ(e, ou.x, ou.y, ou.z);
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            getComponent(t1, e) {
                let n = this.array[t1 * this.itemSize + e];
                return this.normalized && (n = Jo(n, this.array)), n;
            }
            setComponent(t1, e, n) {
                return this.normalized && (n = Ko(n, this.array)), this.array[t1 * this.itemSize + e] = n, this;
            }
            getX(t1) {
                let e = this.array[t1 * this.itemSize];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize] = e, this;
            }
            getY(t1) {
                let e = this.array[t1 * this.itemSize + 1];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 1] = e, this;
            }
            getZ(t1) {
                let e = this.array[t1 * this.itemSize + 2];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 2] = e, this;
            }
            getW(t1) {
                let e = this.array[t1 * this.itemSize + 3];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 3] = e, this;
            }
            setXY(t1, e, n) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = n, this;
            }
            setXYZ(t1, e, n, i) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = n, this.array[t1 + 2] = i, this;
            }
            setXYZW(t1, e, n, i, r) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = n, this.array[t1 + 2] = i, this.array[t1 + 3] = r, this;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
            toJSON() {
                const t1 = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                return "" !== this.name && (t1.name = this.name), this.usage !== Eo && (t1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t1.updateRange = this.updateRange), t1;
            }
        }
        class uu extends cu {
            constructor(t1, e, n){
                super(new Int8Array(t1), e, n);
            }
        }
        class hu extends cu {
            constructor(t1, e, n){
                super(new Uint8Array(t1), e, n);
            }
        }
        class du extends cu {
            constructor(t1, e, n){
                super(new Uint8ClampedArray(t1), e, n);
            }
        }
        class pu extends cu {
            constructor(t1, e, n){
                super(new Int16Array(t1), e, n);
            }
        }
        class fu extends cu {
            constructor(t1, e, n){
                super(new Uint16Array(t1), e, n);
            }
        }
        class mu extends cu {
            constructor(t1, e, n){
                super(new Int32Array(t1), e, n);
            }
        }
        class gu extends cu {
            constructor(t1, e, n){
                super(new Uint32Array(t1), e, n);
            }
        }
        class Au extends cu {
            constructor(t1, e, n){
                super(new Uint16Array(t1), e, n), this.isFloat16BufferAttribute = !0;
            }
            getX(t1) {
                let e = au(this.array[t1 * this.itemSize]);
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize] = ru(e), this;
            }
            getY(t1) {
                let e = au(this.array[t1 * this.itemSize + 1]);
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 1] = ru(e), this;
            }
            getZ(t1) {
                let e = au(this.array[t1 * this.itemSize + 2]);
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 2] = ru(e), this;
            }
            getW(t1) {
                let e = au(this.array[t1 * this.itemSize + 3]);
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.array[t1 * this.itemSize + 3] = ru(e), this;
            }
            setXY(t1, e, n) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array)), this.array[t1 + 0] = ru(e), this.array[t1 + 1] = ru(n), this;
            }
            setXYZ(t1, e, n, i) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.array[t1 + 0] = ru(e), this.array[t1 + 1] = ru(n), this.array[t1 + 2] = ru(i), this;
            }
            setXYZW(t1, e, n, i, r) {
                return t1 *= this.itemSize, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.array[t1 + 0] = ru(e), this.array[t1 + 1] = ru(n), this.array[t1 + 2] = ru(i), this.array[t1 + 3] = ru(r), this;
            }
        }
        class vu extends cu {
            constructor(t1, e, n){
                super(new Float32Array(t1), e, n);
            }
        }
        class yu extends cu {
            constructor(t1, e, n){
                super(new Float64Array(t1), e, n);
            }
        }
        let Mu = 0;
        const bu = new cc, xu = new Rc, wu = new Ol, _u = new zl, Eu = new zl, Su = new Ol;
        class Tu extends Bo {
            constructor(){
                super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                    value: Mu++
                }), this.uuid = Qo(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                    start: 0,
                    count: 1 / 0
                }, this.userData = {};
            }
            getIndex() {
                return this.index;
            }
            setIndex(t1) {
                return Array.isArray(t1) ? this.index = new (il(t1) ? gu : fu)(t1, 1) : this.index = t1, this;
            }
            getAttribute(t1) {
                return this.attributes[t1];
            }
            setAttribute(t1, e) {
                return this.attributes[t1] = e, this;
            }
            deleteAttribute(t1) {
                return delete this.attributes[t1], this;
            }
            hasAttribute(t1) {
                return void 0 !== this.attributes[t1];
            }
            addGroup(t1, e, n = 0) {
                this.groups.push({
                    start: t1,
                    count: e,
                    materialIndex: n
                });
            }
            clearGroups() {
                this.groups = [];
            }
            setDrawRange(t1, e) {
                this.drawRange.start = t1, this.drawRange.count = e;
            }
            applyMatrix4(t1) {
                const e = this.attributes.position;
                void 0 !== e && (e.applyMatrix4(t1), e.needsUpdate = !0);
                const n = this.attributes.normal;
                if (void 0 !== n) {
                    const e = (new el).getNormalMatrix(t1);
                    n.applyNormalMatrix(e), n.needsUpdate = !0;
                }
                const i = this.attributes.tangent;
                return void 0 !== i && (i.transformDirection(t1), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            }
            applyQuaternion(t1) {
                return bu.makeRotationFromQuaternion(t1), this.applyMatrix4(bu), this;
            }
            rotateX(t1) {
                return bu.makeRotationX(t1), this.applyMatrix4(bu), this;
            }
            rotateY(t1) {
                return bu.makeRotationY(t1), this.applyMatrix4(bu), this;
            }
            rotateZ(t1) {
                return bu.makeRotationZ(t1), this.applyMatrix4(bu), this;
            }
            translate(t1, e, n) {
                return bu.makeTranslation(t1, e, n), this.applyMatrix4(bu), this;
            }
            scale(t1, e, n) {
                return bu.makeScale(t1, e, n), this.applyMatrix4(bu), this;
            }
            lookAt(t1) {
                return xu.lookAt(t1), xu.updateMatrix(), this.applyMatrix4(xu.matrix), this;
            }
            center() {
                return this.computeBoundingBox(), this.boundingBox.getCenter(wu).negate(), this.translate(wu.x, wu.y, wu.z), this;
            }
            setFromPoints(t1) {
                const e = [];
                for(let n = 0, i = t1.length; n < i; n++){
                    const i = t1[n];
                    e.push(i.x, i.y, i.z || 0);
                }
                return this.setAttribute("position", new vu(e, 3)), this;
            }
            computeBoundingBox() {
                null === this.boundingBox && (this.boundingBox = new zl);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new Ol(-1 / 0, -1 / 0, -1 / 0), new Ol(1 / 0, 1 / 0, 1 / 0));
                if (void 0 !== t1) {
                    if (this.boundingBox.setFromBufferAttribute(t1), e) for(let t1 = 0, n = e.length; t1 < n; t1++){
                        const n = e[t1];
                        _u.setFromBufferAttribute(n), this.morphTargetsRelative ? (Su.addVectors(this.boundingBox.min, _u.min), this.boundingBox.expandByPoint(Su), Su.addVectors(this.boundingBox.max, _u.max), this.boundingBox.expandByPoint(Su)) : (this.boundingBox.expandByPoint(_u.min), this.boundingBox.expandByPoint(_u.max));
                    }
                } else this.boundingBox.makeEmpty();
                (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
            computeBoundingSphere() {
                null === this.boundingSphere && (this.boundingSphere = new tc);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new Ol, 1 / 0);
                if (t1) {
                    const n = this.boundingSphere.center;
                    if (_u.setFromBufferAttribute(t1), e) for(let t1 = 0, n = e.length; t1 < n; t1++){
                        const n = e[t1];
                        Eu.setFromBufferAttribute(n), this.morphTargetsRelative ? (Su.addVectors(_u.min, Eu.min), _u.expandByPoint(Su), Su.addVectors(_u.max, Eu.max), _u.expandByPoint(Su)) : (_u.expandByPoint(Eu.min), _u.expandByPoint(Eu.max));
                    }
                    _u.getCenter(n);
                    let i = 0;
                    for(let e = 0, r = t1.count; e < r; e++)Su.fromBufferAttribute(t1, e), i = Math.max(i, n.distanceToSquared(Su));
                    if (e) for(let r = 0, a = e.length; r < a; r++){
                        const a = e[r], s = this.morphTargetsRelative;
                        for(let e = 0, r = a.count; e < r; e++)Su.fromBufferAttribute(a, e), s && (wu.fromBufferAttribute(t1, e), Su.add(wu)), i = Math.max(i, n.distanceToSquared(Su));
                    }
                    this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
            computeTangents() {
                const t1 = this.index, e = this.attributes;
                if (null === t1 || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                const n = t1.array, i = e.position.array, r = e.normal.array, a = e.uv.array, s = i.length / 3;
                !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new cu(new Float32Array(4 * s), 4));
                const o = this.getAttribute("tangent").array, l = [], c = [];
                for(let t1 = 0; t1 < s; t1++)l[t1] = new Ol, c[t1] = new Ol;
                const u = new Ol, h = new Ol, d = new Ol, p = new tl, f = new tl, m = new tl, g = new Ol, A = new Ol;
                function v(t1, e, n) {
                    u.fromArray(i, 3 * t1), h.fromArray(i, 3 * e), d.fromArray(i, 3 * n), p.fromArray(a, 2 * t1), f.fromArray(a, 2 * e), m.fromArray(a, 2 * n), h.sub(u), d.sub(u), f.sub(p), m.sub(p);
                    const r = 1 / (f.x * m.y - m.x * f.y);
                    isFinite(r) && (g.copy(h).multiplyScalar(m.y).addScaledVector(d, -f.y).multiplyScalar(r), A.copy(d).multiplyScalar(f.x).addScaledVector(h, -m.x).multiplyScalar(r), l[t1].add(g), l[e].add(g), l[n].add(g), c[t1].add(A), c[e].add(A), c[n].add(A));
                }
                let y = this.groups;
                0 === y.length && (y = [
                    {
                        start: 0,
                        count: n.length
                    }
                ]);
                for(let t1 = 0, e = y.length; t1 < e; ++t1){
                    const e = y[t1], i = e.start;
                    for(let t1 = i, r = i + e.count; t1 < r; t1 += 3)v(n[t1 + 0], n[t1 + 1], n[t1 + 2]);
                }
                const M = new Ol, b = new Ol, x = new Ol, w = new Ol;
                function _(t1) {
                    x.fromArray(r, 3 * t1), w.copy(x);
                    const e = l[t1];
                    M.copy(e), M.sub(x.multiplyScalar(x.dot(e))).normalize(), b.crossVectors(w, e);
                    const n = b.dot(c[t1]) < 0 ? -1 : 1;
                    o[4 * t1] = M.x, o[4 * t1 + 1] = M.y, o[4 * t1 + 2] = M.z, o[4 * t1 + 3] = n;
                }
                for(let t1 = 0, e = y.length; t1 < e; ++t1){
                    const e = y[t1], i = e.start;
                    for(let t1 = i, r = i + e.count; t1 < r; t1 += 3)_(n[t1 + 0]), _(n[t1 + 1]), _(n[t1 + 2]);
                }
            }
            computeVertexNormals() {
                const t1 = this.index, e = this.getAttribute("position");
                if (void 0 !== e) {
                    let n = this.getAttribute("normal");
                    if (void 0 === n) n = new cu(new Float32Array(3 * e.count), 3), this.setAttribute("normal", n);
                    else for(let t1 = 0, e = n.count; t1 < e; t1++)n.setXYZ(t1, 0, 0, 0);
                    const i = new Ol, r = new Ol, a = new Ol, s = new Ol, o = new Ol, l = new Ol, c = new Ol, u = new Ol;
                    if (t1) for(let h = 0, d = t1.count; h < d; h += 3){
                        const d = t1.getX(h + 0), p = t1.getX(h + 1), f = t1.getX(h + 2);
                        i.fromBufferAttribute(e, d), r.fromBufferAttribute(e, p), a.fromBufferAttribute(e, f), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), s.fromBufferAttribute(n, d), o.fromBufferAttribute(n, p), l.fromBufferAttribute(n, f), s.add(c), o.add(c), l.add(c), n.setXYZ(d, s.x, s.y, s.z), n.setXYZ(p, o.x, o.y, o.z), n.setXYZ(f, l.x, l.y, l.z);
                    }
                    else for(let t1 = 0, s = e.count; t1 < s; t1 += 3)i.fromBufferAttribute(e, t1 + 0), r.fromBufferAttribute(e, t1 + 1), a.fromBufferAttribute(e, t1 + 2), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), n.setXYZ(t1 + 0, c.x, c.y, c.z), n.setXYZ(t1 + 1, c.x, c.y, c.z), n.setXYZ(t1 + 2, c.x, c.y, c.z);
                    this.normalizeNormals(), n.needsUpdate = !0;
                }
            }
            normalizeNormals() {
                const t1 = this.attributes.normal;
                for(let e = 0, n = t1.count; e < n; e++)Su.fromBufferAttribute(t1, e), Su.normalize(), t1.setXYZ(e, Su.x, Su.y, Su.z);
            }
            toNonIndexed() {
                function t1(t1, e) {
                    const n = t1.array, i = t1.itemSize, r = t1.normalized, a = new n.constructor(e.length * i);
                    let s = 0, o = 0;
                    for(let r = 0, l = e.length; r < l; r++){
                        s = t1.isInterleavedBufferAttribute ? e[r] * t1.data.stride + t1.offset : e[r] * i;
                        for(let t1 = 0; t1 < i; t1++)a[o++] = n[s++];
                    }
                    return new cu(a, i, r);
                }
                if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                const e = new Tu, n = this.index.array, i = this.attributes;
                for(const r in i){
                    const a = t1(i[r], n);
                    e.setAttribute(r, a);
                }
                const r = this.morphAttributes;
                for(const i in r){
                    const a = [], s = r[i];
                    for(let e = 0, i = s.length; e < i; e++){
                        const i = t1(s[e], n);
                        a.push(i);
                    }
                    e.morphAttributes[i] = a;
                }
                e.morphTargetsRelative = this.morphTargetsRelative;
                const a = this.groups;
                for(let t1 = 0, n = a.length; t1 < n; t1++){
                    const n = a[t1];
                    e.addGroup(n.start, n.count, n.materialIndex);
                }
                return e;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "BufferGeometry",
                        generator: "BufferGeometry.toJSON"
                    }
                };
                if (t1.uuid = this.uuid, t1.type = this.type, "" !== this.name && (t1.name = this.name), Object.keys(this.userData).length > 0 && (t1.userData = this.userData), void 0 !== this.parameters) {
                    const e = this.parameters;
                    for(const n in e)void 0 !== e[n] && (t1[n] = e[n]);
                    return t1;
                }
                t1.data = {
                    attributes: {}
                };
                const e = this.index;
                null !== e && (t1.data.index = {
                    type: e.array.constructor.name,
                    array: Array.prototype.slice.call(e.array)
                });
                const n = this.attributes;
                for(const e in n){
                    const i = n[e];
                    t1.data.attributes[e] = i.toJSON(t1.data);
                }
                const i = {};
                let r = !1;
                for(const e in this.morphAttributes){
                    const n = this.morphAttributes[e], a = [];
                    for(let e = 0, i = n.length; e < i; e++){
                        const i = n[e];
                        a.push(i.toJSON(t1.data));
                    }
                    a.length > 0 && (i[e] = a, r = !0);
                }
                r && (t1.data.morphAttributes = i, t1.data.morphTargetsRelative = this.morphTargetsRelative);
                const a = this.groups;
                a.length > 0 && (t1.data.groups = JSON.parse(JSON.stringify(a)));
                const s = this.boundingSphere;
                return null !== s && (t1.data.boundingSphere = {
                    center: s.center.toArray(),
                    radius: s.radius
                }), t1;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                const e = {};
                this.name = t1.name;
                const n = t1.index;
                null !== n && this.setIndex(n.clone(e));
                const i = t1.attributes;
                for(const t1 in i){
                    const n = i[t1];
                    this.setAttribute(t1, n.clone(e));
                }
                const r = t1.morphAttributes;
                for(const t1 in r){
                    const n = [], i = r[t1];
                    for(let t1 = 0, r = i.length; t1 < r; t1++)n.push(i[t1].clone(e));
                    this.morphAttributes[t1] = n;
                }
                this.morphTargetsRelative = t1.morphTargetsRelative;
                const a = t1.groups;
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = a[t1];
                    this.addGroup(e.start, e.count, e.materialIndex);
                }
                const s = t1.boundingBox;
                null !== s && (this.boundingBox = s.clone());
                const o = t1.boundingSphere;
                return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t1.drawRange.start, this.drawRange.count = t1.drawRange.count, this.userData = t1.userData, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        const Iu = new cc, Cu = new lc, Nu = new tc, Du = new Ol, Lu = new Ol, Ou = new Ol, Ru = new Ol, Pu = new Ol, zu = new Ol, Uu = new tl, ku = new tl, Bu = new tl, ju = new Ol, Fu = new Ol, Hu = new Ol, Vu = new Ol, Qu = new Ol;
        class Gu extends Rc {
            constructor(t1 = new Tu, e = new eu){
                super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.morphTargetInfluences && (this.morphTargetInfluences = t1.morphTargetInfluences.slice()), void 0 !== t1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t1.morphTargetDictionary)), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const n = t1[e[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = n.length; t1 < e; t1++){
                            const e = n[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
            getVertexPosition(t1, e) {
                const n = this.geometry, i = n.attributes.position, r = n.morphAttributes.position, a = n.morphTargetsRelative;
                e.fromBufferAttribute(i, t1);
                const s = this.morphTargetInfluences;
                if (r && s) {
                    zu.set(0, 0, 0);
                    for(let n = 0, i = r.length; n < i; n++){
                        const i = s[n], o = r[n];
                        0 !== i && (Pu.fromBufferAttribute(o, t1), a ? zu.addScaledVector(Pu, i) : zu.addScaledVector(Pu.sub(e), i));
                    }
                    e.add(zu);
                }
                return e;
            }
            raycast(t1, e) {
                const n = this.geometry, i = this.material, r = this.matrixWorld;
                if (void 0 !== i) {
                    if (null === n.boundingSphere && n.computeBoundingSphere(), Nu.copy(n.boundingSphere), Nu.applyMatrix4(r), Cu.copy(t1.ray).recast(t1.near), !1 === Nu.containsPoint(Cu.origin)) {
                        if (null === Cu.intersectSphere(Nu, Du)) return;
                        if (Cu.origin.distanceToSquared(Du) > (t1.far - t1.near) ** 2) return;
                    }
                    Iu.copy(r).invert(), Cu.copy(t1.ray).applyMatrix4(Iu), null !== n.boundingBox && !1 === Cu.intersectsBox(n.boundingBox) || this._computeIntersections(t1, e, Cu);
                }
            }
            _computeIntersections(t1, e, n) {
                let i;
                const r = this.geometry, a = this.material, s = r.index, o = r.attributes.position, l = r.attributes.uv, c = r.attributes.uv1, u = r.attributes.normal, h = r.groups, d = r.drawRange;
                if (null !== s) {
                    if (Array.isArray(a)) for(let r = 0, o = h.length; r < o; r++){
                        const o = h[r], p = a[o.materialIndex];
                        for(let r = Math.max(o.start, d.start), a = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); r < a; r += 3)i = Wu(this, p, t1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = o.materialIndex, e.push(i));
                    }
                    else for(let r = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); r < o; r += 3)i = Wu(this, a, t1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), e.push(i));
                } else if (void 0 !== o) {
                    if (Array.isArray(a)) for(let r = 0, s = h.length; r < s; r++){
                        const s = h[r], p = a[s.materialIndex];
                        for(let r = Math.max(s.start, d.start), a = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); r < a; r += 3)i = Wu(this, p, t1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = s.materialIndex, e.push(i));
                    }
                    else for(let r = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); r < s; r += 3)i = Wu(this, a, t1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), e.push(i));
                }
            }
        }
        function Wu(t1, e, n, i, r, a, s, o, l, c) {
            t1.getVertexPosition(o, Lu), t1.getVertexPosition(l, Ou), t1.getVertexPosition(c, Ru);
            const u = function(t1, e, n, i, r, a, s, o) {
                let l;
                if (l = e.side === dr ? i.intersectTriangle(s, a, r, !0, o) : i.intersectTriangle(r, a, s, e.side === hr, o), null === l) return null;
                Qu.copy(o), Qu.applyMatrix4(t1.matrixWorld);
                const c = n.ray.origin.distanceTo(Qu);
                return c < n.near || c > n.far ? null : {
                    distance: c,
                    point: Qu.clone(),
                    object: t1
                };
            }(t1, e, n, i, Lu, Ou, Ru, Vu);
            if (u) {
                r && (Uu.fromBufferAttribute(r, o), ku.fromBufferAttribute(r, l), Bu.fromBufferAttribute(r, c), u.uv = Wc.getInterpolation(Vu, Lu, Ou, Ru, Uu, ku, Bu, new tl)), a && (Uu.fromBufferAttribute(a, o), ku.fromBufferAttribute(a, l), Bu.fromBufferAttribute(a, c), u.uv1 = Wc.getInterpolation(Vu, Lu, Ou, Ru, Uu, ku, Bu, new tl), u.uv2 = u.uv1), s && (ju.fromBufferAttribute(s, o), Fu.fromBufferAttribute(s, l), Hu.fromBufferAttribute(s, c), u.normal = Wc.getInterpolation(Vu, Lu, Ou, Ru, ju, Fu, Hu, new Ol), u.normal.dot(i.direction) > 0 && u.normal.multiplyScalar(-1));
                const t1 = {
                    a: o,
                    b: l,
                    c: c,
                    normal: new Ol,
                    materialIndex: 0
                };
                Wc.getNormal(Lu, Ou, Ru, t1.normal), u.face = t1;
            }
            return u;
        }
        class Xu extends Tu {
            constructor(t1 = 1, e = 1, n = 1, i = 1, r = 1, a = 1){
                super(), this.type = "BoxGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    depth: n,
                    widthSegments: i,
                    heightSegments: r,
                    depthSegments: a
                };
                const s = this;
                i = Math.floor(i), r = Math.floor(r), a = Math.floor(a);
                const o = [], l = [], c = [], u = [];
                let h = 0, d = 0;
                function p(t1, e, n, i, r, a, p, f, m, g, A) {
                    const v = a / m, y = p / g, M = a / 2, b = p / 2, x = f / 2, w = m + 1, _ = g + 1;
                    let E = 0, S = 0;
                    const T = new Ol;
                    for(let a = 0; a < _; a++){
                        const s = a * y - b;
                        for(let o = 0; o < w; o++){
                            const h = o * v - M;
                            T[t1] = h * i, T[e] = s * r, T[n] = x, l.push(T.x, T.y, T.z), T[t1] = 0, T[e] = 0, T[n] = f > 0 ? 1 : -1, c.push(T.x, T.y, T.z), u.push(o / m), u.push(1 - a / g), E += 1;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++)for(let e = 0; e < m; e++){
                        const n = h + e + w * t1, i = h + e + w * (t1 + 1), r = h + (e + 1) + w * (t1 + 1), a = h + (e + 1) + w * t1;
                        o.push(n, i, a), o.push(i, r, a), S += 6;
                    }
                    s.addGroup(d, S, A), d += S, h += E;
                }
                p("z", "y", "x", -1, -1, n, e, t1, a, r, 0), p("z", "y", "x", 1, -1, n, e, -t1, a, r, 1), p("x", "z", "y", 1, 1, t1, n, e, i, a, 2), p("x", "z", "y", 1, -1, t1, n, -e, i, a, 3), p("x", "y", "z", 1, -1, t1, e, n, i, r, 4), p("x", "y", "z", -1, -1, t1, e, -n, i, r, 5), this.setIndex(o), this.setAttribute("position", new vu(l, 3)), this.setAttribute("normal", new vu(c, 3)), this.setAttribute("uv", new vu(u, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Xu(t1.width, t1.height, t1.depth, t1.widthSegments, t1.heightSegments, t1.depthSegments);
            }
        }
        function Yu(t1) {
            const e = {};
            for(const n in t1){
                e[n] = {};
                for(const i in t1[n]){
                    const r = t1[n][i];
                    r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[n][i] = null) : e[n][i] = r.clone() : Array.isArray(r) ? e[n][i] = r.slice() : e[n][i] = r;
                }
            }
            return e;
        }
        function Zu(t1) {
            const e = {};
            for(let n = 0; n < t1.length; n++){
                const i = Yu(t1[n]);
                for(const t1 in i)e[t1] = i[t1];
            }
            return e;
        }
        function qu(t1) {
            return null === t1.getRenderTarget() ? t1.outputColorSpace : fl.workingColorSpace;
        }
        const Ju = {
            clone: Yu,
            merge: Zu
        };
        class Ku extends tu {
            constructor(t1){
                super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                    derivatives: !1,
                    fragDepth: !1,
                    drawBuffers: !1,
                    shaderTextureLOD: !1
                }, this.defaultAttributeValues = {
                    color: [
                        1,
                        1,
                        1
                    ],
                    uv: [
                        0,
                        0
                    ],
                    uv1: [
                        0,
                        0
                    ]
                }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t1 && this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.fragmentShader = t1.fragmentShader, this.vertexShader = t1.vertexShader, this.uniforms = Yu(t1.uniforms), this.uniformsGroups = function(t1) {
                    const e = [];
                    for(let n = 0; n < t1.length; n++)e.push(t1[n].clone());
                    return e;
                }(t1.uniformsGroups), this.defines = Object.assign({}, t1.defines), this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.fog = t1.fog, this.lights = t1.lights, this.clipping = t1.clipping, this.extensions = Object.assign({}, t1.extensions), this.glslVersion = t1.glslVersion, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                e.glslVersion = this.glslVersion, e.uniforms = {};
                for(const n in this.uniforms){
                    const i = this.uniforms[n].value;
                    i && i.isTexture ? e.uniforms[n] = {
                        type: "t",
                        value: i.toJSON(t1).uuid
                    } : i && i.isColor ? e.uniforms[n] = {
                        type: "c",
                        value: i.getHex()
                    } : i && i.isVector2 ? e.uniforms[n] = {
                        type: "v2",
                        value: i.toArray()
                    } : i && i.isVector3 ? e.uniforms[n] = {
                        type: "v3",
                        value: i.toArray()
                    } : i && i.isVector4 ? e.uniforms[n] = {
                        type: "v4",
                        value: i.toArray()
                    } : i && i.isMatrix3 ? e.uniforms[n] = {
                        type: "m3",
                        value: i.toArray()
                    } : i && i.isMatrix4 ? e.uniforms[n] = {
                        type: "m4",
                        value: i.toArray()
                    } : e.uniforms[n] = {
                        value: i
                    };
                }
                Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.lights = this.lights, e.clipping = this.clipping;
                const n = {};
                for(const t1 in this.extensions)!0 === this.extensions[t1] && (n[t1] = !0);
                return Object.keys(n).length > 0 && (e.extensions = n), e;
            }
        }
        class $u extends Rc {
            constructor(){
                super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new cc, this.projectionMatrix = new cc, this.projectionMatrixInverse = new cc, this.coordinateSystem = Uo;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.matrixWorldInverse.copy(t1.matrixWorldInverse), this.projectionMatrix.copy(t1.projectionMatrix), this.projectionMatrixInverse.copy(t1.projectionMatrixInverse), this.coordinateSystem = t1.coordinateSystem, this;
            }
            getWorldDirection(t1) {
                return super.getWorldDirection(t1).negate();
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            updateWorldMatrix(t1, e) {
                super.updateWorldMatrix(t1, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class th extends $u {
            constructor(t1 = 50, e = 1, n = .1, i = 2e3){
                super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t1, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.fov = t1.fov, this.zoom = t1.zoom, this.near = t1.near, this.far = t1.far, this.focus = t1.focus, this.aspect = t1.aspect, this.view = null === t1.view ? null : Object.assign({}, t1.view), this.filmGauge = t1.filmGauge, this.filmOffset = t1.filmOffset, this;
            }
            setFocalLength(t1) {
                const e = .5 * this.getFilmHeight() / t1;
                this.fov = 2 * Vo * Math.atan(e), this.updateProjectionMatrix();
            }
            getFocalLength() {
                const t1 = Math.tan(.5 * Ho * this.fov);
                return .5 * this.getFilmHeight() / t1;
            }
            getEffectiveFOV() {
                return 2 * Vo * Math.atan(Math.tan(.5 * Ho * this.fov) / this.zoom);
            }
            getFilmWidth() {
                return this.filmGauge * Math.min(this.aspect, 1);
            }
            getFilmHeight() {
                return this.filmGauge / Math.max(this.aspect, 1);
            }
            setViewOffset(t1, e, n, i, r, a) {
                this.aspect = t1 / e, null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = this.near;
                let e = t1 * Math.tan(.5 * Ho * this.fov) / this.zoom, n = 2 * e, i = this.aspect * n, r = -0.5 * i;
                const a = this.view;
                if (null !== this.view && this.view.enabled) {
                    const t1 = a.fullWidth, s = a.fullHeight;
                    r += a.offsetX * i / t1, e -= a.offsetY * n / s, i *= a.width / t1, n *= a.height / s;
                }
                const s = this.filmOffset;
                0 !== s && (r += t1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t1, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
            }
        }
        const eh = -90;
        class nh extends Rc {
            constructor(t1, e, n){
                super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                const i = new th(eh, 1, t1, e);
                i.layers = this.layers, this.add(i);
                const r = new th(eh, 1, t1, e);
                r.layers = this.layers, this.add(r);
                const a = new th(eh, 1, t1, e);
                a.layers = this.layers, this.add(a);
                const s = new th(eh, 1, t1, e);
                s.layers = this.layers, this.add(s);
                const o = new th(eh, 1, t1, e);
                o.layers = this.layers, this.add(o);
                const l = new th(eh, 1, t1, e);
                l.layers = this.layers, this.add(l);
            }
            updateCoordinateSystem() {
                const t1 = this.coordinateSystem, e = this.children.concat(), [n, i, r, a, s, o] = e;
                for (const t1 of e)this.remove(t1);
                if (t1 === Uo) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
                else {
                    if (t1 !== ko) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t1);
                    n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
                }
                for (const t1 of e)this.add(t1), t1.updateMatrixWorld();
            }
            update(t1, e) {
                null === this.parent && this.updateMatrixWorld();
                const { renderTarget: n, activeMipmapLevel: i } = this;
                this.coordinateSystem !== t1.coordinateSystem && (this.coordinateSystem = t1.coordinateSystem, this.updateCoordinateSystem());
                const [r, a, s, o, l, c] = this.children, u = t1.getRenderTarget(), h = t1.getActiveCubeFace(), d = t1.getActiveMipmapLevel(), p = t1.xr.enabled;
                t1.xr.enabled = !1;
                const f = n.texture.generateMipmaps;
                n.texture.generateMipmaps = !1, t1.setRenderTarget(n, 0, i), t1.render(e, r), t1.setRenderTarget(n, 1, i), t1.render(e, a), t1.setRenderTarget(n, 2, i), t1.render(e, s), t1.setRenderTarget(n, 3, i), t1.render(e, o), t1.setRenderTarget(n, 4, i), t1.render(e, l), n.texture.generateMipmaps = f, t1.setRenderTarget(n, 5, i), t1.render(e, c), t1.setRenderTarget(u, h, d), t1.xr.enabled = p, n.texture.needsPMREMUpdate = !0;
            }
        }
        class ih extends wl {
            constructor(t1, e, n, i, r, a, s, o, l, c){
                super(t1 = void 0 !== t1 ? t1 : [], e = void 0 !== e ? e : oa, n, i, r, a, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
            }
            get images() {
                return this.image;
            }
            set images(t1) {
                this.image = t1;
            }
        }
        class rh extends Sl {
            constructor(t1 = 1, e = {}){
                super(t1, t1, e), this.isWebGLCubeRenderTarget = !0;
                const n = {
                    width: t1,
                    height: t1,
                    depth: 1
                }, i = [
                    n,
                    n,
                    n,
                    n,
                    n,
                    n
                ];
                void 0 !== e.encoding && (cl("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), e.colorSpace = e.encoding === js ? Ws : Gs), this.texture = new ih(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, this.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : Ma;
            }
            fromEquirectangularTexture(t1, e) {
                this.texture.type = e.type, this.texture.colorSpace = e.colorSpace, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
                const n = {
                    tEquirect: {
                        value: null
                    }
                }, i = "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			", r = "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			", a = new Xu(5, 5, 5), s = new Ku({
                    name: "CubemapFromEquirect",
                    uniforms: Yu(n),
                    vertexShader: i,
                    fragmentShader: r,
                    side: dr,
                    blending: mr
                });
                s.uniforms.tEquirect.value = e;
                const o = new Gu(a, s), l = e.minFilter;
                return e.minFilter === wa && (e.minFilter = Ma), new nh(1, 10, this).update(t1, o), e.minFilter = l, o.geometry.dispose(), o.material.dispose(), this;
            }
            clear(t1, e, n, i) {
                const r = t1.getRenderTarget();
                for(let r = 0; r < 6; r++)t1.setRenderTarget(this, r), t1.clear(e, n, i);
                t1.setRenderTarget(r);
            }
        }
        const ah = new Ol, sh = new Ol, oh = new el;
        class lh {
            constructor(t1 = new Ol(1, 0, 0), e = 0){
                this.isPlane = !0, this.normal = t1, this.constant = e;
            }
            set(t1, e) {
                return this.normal.copy(t1), this.constant = e, this;
            }
            setComponents(t1, e, n, i) {
                return this.normal.set(t1, e, n), this.constant = i, this;
            }
            setFromNormalAndCoplanarPoint(t1, e) {
                return this.normal.copy(t1), this.constant = -e.dot(this.normal), this;
            }
            setFromCoplanarPoints(t1, e, n) {
                const i = ah.subVectors(n, e).cross(sh.subVectors(t1, e)).normalize();
                return this.setFromNormalAndCoplanarPoint(i, t1), this;
            }
            copy(t1) {
                return this.normal.copy(t1.normal), this.constant = t1.constant, this;
            }
            normalize() {
                const t1 = 1 / this.normal.length();
                return this.normal.multiplyScalar(t1), this.constant *= t1, this;
            }
            negate() {
                return this.constant *= -1, this.normal.negate(), this;
            }
            distanceToPoint(t1) {
                return this.normal.dot(t1) + this.constant;
            }
            distanceToSphere(t1) {
                return this.distanceToPoint(t1.center) - t1.radius;
            }
            projectPoint(t1, e) {
                return e.copy(t1).addScaledVector(this.normal, -this.distanceToPoint(t1));
            }
            intersectLine(t1, e) {
                const n = t1.delta(ah), i = this.normal.dot(n);
                if (0 === i) return 0 === this.distanceToPoint(t1.start) ? e.copy(t1.start) : null;
                const r = -(t1.start.dot(this.normal) + this.constant) / i;
                return r < 0 || r > 1 ? null : e.copy(t1.start).addScaledVector(n, r);
            }
            intersectsLine(t1) {
                const e = this.distanceToPoint(t1.start), n = this.distanceToPoint(t1.end);
                return e < 0 && n > 0 || n < 0 && e > 0;
            }
            intersectsBox(t1) {
                return t1.intersectsPlane(this);
            }
            intersectsSphere(t1) {
                return t1.intersectsPlane(this);
            }
            coplanarPoint(t1) {
                return t1.copy(this.normal).multiplyScalar(-this.constant);
            }
            applyMatrix4(t1, e) {
                const n = e || oh.getNormalMatrix(t1), i = this.coplanarPoint(ah).applyMatrix4(t1), r = this.normal.applyMatrix3(n).normalize();
                return this.constant = -i.dot(r), this;
            }
            translate(t1) {
                return this.constant -= t1.dot(this.normal), this;
            }
            equals(t1) {
                return t1.normal.equals(this.normal) && t1.constant === this.constant;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const ch = new tc, uh = new Ol;
        class hh {
            constructor(t1 = new lh, e = new lh, n = new lh, i = new lh, r = new lh, a = new lh){
                this.planes = [
                    t1,
                    e,
                    n,
                    i,
                    r,
                    a
                ];
            }
            set(t1, e, n, i, r, a) {
                const s = this.planes;
                return s[0].copy(t1), s[1].copy(e), s[2].copy(n), s[3].copy(i), s[4].copy(r), s[5].copy(a), this;
            }
            copy(t1) {
                const e = this.planes;
                for(let n = 0; n < 6; n++)e[n].copy(t1.planes[n]);
                return this;
            }
            setFromProjectionMatrix(t1, e = Uo) {
                const n = this.planes, i = t1.elements, r = i[0], a = i[1], s = i[2], o = i[3], l = i[4], c = i[5], u = i[6], h = i[7], d = i[8], p = i[9], f = i[10], m = i[11], g = i[12], A = i[13], v = i[14], y = i[15];
                if (n[0].setComponents(o - r, h - l, m - d, y - g).normalize(), n[1].setComponents(o + r, h + l, m + d, y + g).normalize(), n[2].setComponents(o + a, h + c, m + p, y + A).normalize(), n[3].setComponents(o - a, h - c, m - p, y - A).normalize(), n[4].setComponents(o - s, h - u, m - f, y - v).normalize(), e === Uo) n[5].setComponents(o + s, h + u, m + f, y + v).normalize();
                else {
                    if (e !== ko) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + e);
                    n[5].setComponents(s, u, f, v).normalize();
                }
                return this;
            }
            intersectsObject(t1) {
                if (void 0 !== t1.boundingSphere) null === t1.boundingSphere && t1.computeBoundingSphere(), ch.copy(t1.boundingSphere).applyMatrix4(t1.matrixWorld);
                else {
                    const e = t1.geometry;
                    null === e.boundingSphere && e.computeBoundingSphere(), ch.copy(e.boundingSphere).applyMatrix4(t1.matrixWorld);
                }
                return this.intersectsSphere(ch);
            }
            intersectsSprite(t1) {
                return ch.center.set(0, 0, 0), ch.radius = .7071067811865476, ch.applyMatrix4(t1.matrixWorld), this.intersectsSphere(ch);
            }
            intersectsSphere(t1) {
                const e = this.planes, n = t1.center, i = -t1.radius;
                for(let t1 = 0; t1 < 6; t1++)if (e[t1].distanceToPoint(n) < i) return !1;
                return !0;
            }
            intersectsBox(t1) {
                const e = this.planes;
                for(let n = 0; n < 6; n++){
                    const i = e[n];
                    if (uh.x = i.normal.x > 0 ? t1.max.x : t1.min.x, uh.y = i.normal.y > 0 ? t1.max.y : t1.min.y, uh.z = i.normal.z > 0 ? t1.max.z : t1.min.z, i.distanceToPoint(uh) < 0) return !1;
                }
                return !0;
            }
            containsPoint(t1) {
                const e = this.planes;
                for(let n = 0; n < 6; n++)if (e[n].distanceToPoint(t1) < 0) return !1;
                return !0;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        function dh() {
            let t1 = null, e = !1, n = null, i = null;
            function r(e, a) {
                n(e, a), i = t1.requestAnimationFrame(r);
            }
            return {
                start: function() {
                    !0 !== e && null !== n && (i = t1.requestAnimationFrame(r), e = !0);
                },
                stop: function() {
                    t1.cancelAnimationFrame(i), e = !1;
                },
                setAnimationLoop: function(t1) {
                    n = t1;
                },
                setContext: function(e) {
                    t1 = e;
                }
            };
        }
        function ph(t1, e) {
            const n = e.isWebGL2, i = new WeakMap;
            return {
                get: function(t1) {
                    return t1.isInterleavedBufferAttribute && (t1 = t1.data), i.get(t1);
                },
                remove: function(e) {
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const n = i.get(e);
                    n && (t1.deleteBuffer(n.buffer), i.delete(e));
                },
                update: function(e, r) {
                    if (e.isGLBufferAttribute) {
                        const t1 = i.get(e);
                        return void ((!t1 || t1.version < e.version) && i.set(e, {
                            buffer: e.buffer,
                            type: e.type,
                            bytesPerElement: e.elementSize,
                            version: e.version
                        }));
                    }
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const a = i.get(e);
                    void 0 === a ? i.set(e, function(e, i) {
                        const r = e.array, a = e.usage, s = t1.createBuffer();
                        let o;
                        if (t1.bindBuffer(i, s), t1.bufferData(i, r, a), e.onUploadCallback(), r instanceof Float32Array) o = t1.FLOAT;
                        else if (r instanceof Uint16Array) {
                            if (e.isFloat16BufferAttribute) {
                                if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                                o = t1.HALF_FLOAT;
                            } else o = t1.UNSIGNED_SHORT;
                        } else if (r instanceof Int16Array) o = t1.SHORT;
                        else if (r instanceof Uint32Array) o = t1.UNSIGNED_INT;
                        else if (r instanceof Int32Array) o = t1.INT;
                        else if (r instanceof Int8Array) o = t1.BYTE;
                        else if (r instanceof Uint8Array) o = t1.UNSIGNED_BYTE;
                        else {
                            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                            o = t1.UNSIGNED_BYTE;
                        }
                        return {
                            buffer: s,
                            type: o,
                            bytesPerElement: r.BYTES_PER_ELEMENT,
                            version: e.version
                        };
                    }(e, r)) : a.version < e.version && (function(e, i, r) {
                        const a = i.array, s = i.updateRange;
                        t1.bindBuffer(r, e), -1 === s.count ? t1.bufferSubData(r, 0, a) : (n ? t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a, s.offset, s.count) : t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a.subarray(s.offset, s.offset + s.count)), s.count = -1), i.onUploadCallback();
                    }(a.buffer, e, r), a.version = e.version);
                }
            };
        }
        class fh extends Tu {
            constructor(t1 = 1, e = 1, n = 1, i = 1){
                super(), this.type = "PlaneGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    widthSegments: n,
                    heightSegments: i
                };
                const r = t1 / 2, a = e / 2, s = Math.floor(n), o = Math.floor(i), l = s + 1, c = o + 1, u = t1 / s, h = e / o, d = [], p = [], f = [], m = [];
                for(let t1 = 0; t1 < c; t1++){
                    const e = t1 * h - a;
                    for(let n = 0; n < l; n++){
                        const i = n * u - r;
                        p.push(i, -e, 0), f.push(0, 0, 1), m.push(n / s), m.push(1 - t1 / o);
                    }
                }
                for(let t1 = 0; t1 < o; t1++)for(let e = 0; e < s; e++){
                    const n = e + l * t1, i = e + l * (t1 + 1), r = e + 1 + l * (t1 + 1), a = e + 1 + l * t1;
                    d.push(n, i, a), d.push(i, r, a);
                }
                this.setIndex(d), this.setAttribute("position", new vu(p, 3)), this.setAttribute("normal", new vu(f, 3)), this.setAttribute("uv", new vu(m, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new fh(t1.width, t1.height, t1.widthSegments, t1.heightSegments);
            }
        }
        const mh = {
            alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
            alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
            alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
            alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            alphatest_fragment: "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif",
            alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
            aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
            aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
            begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
            beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
            bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
            iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
            bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
            clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif",
            clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
            clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
            clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
            color_fragment: "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif",
            color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif",
            color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif",
            color_vertex: "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif",
            common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
            cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
            defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif",
            displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
            displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
            emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
            emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
            colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
            colorspace_pars_fragment: "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return sRGBTransferOETF( value );\n}",
            envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif",
            envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif",
            envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
            envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
            envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
            envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
            fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
            fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
            fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
            fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
            gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
            lightmap_fragment: "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
            lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
            lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
            lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
            lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif",
            lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
            lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
            lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
            lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
            lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
            lights_physical_pars_fragment: "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
            lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
            lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
            lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
            logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
            logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
            logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif",
            logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif",
            map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
            map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
            map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
            map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
            metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
            morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
            morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif",
            morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif",
            morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif",
            normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
            normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
            normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif",
            normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
            clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
            clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
            clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
            iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
            opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
            packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}",
            premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
            project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
            dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
            dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
            roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
            roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
            shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif",
            shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
            shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
            shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
            skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
            skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif",
            skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
            skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
            specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
            specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
            tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
            tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
            transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
            transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
            uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
            worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
            background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
            background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
            depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}",
            distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
            distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}",
            equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
            equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
            meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
            meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
            meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
            meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
            meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
            points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}",
            sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
        }, gh = {
            common: {
                diffuse: {
                    value: new Jc(16777215)
                },
                opacity: {
                    value: 1
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new el
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                }
            },
            specularmap: {
                specularMap: {
                    value: null
                },
                specularMapTransform: {
                    value: new el
                }
            },
            envmap: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                },
                reflectivity: {
                    value: 1
                },
                ior: {
                    value: 1.5
                },
                refractionRatio: {
                    value: .98
                }
            },
            aomap: {
                aoMap: {
                    value: null
                },
                aoMapIntensity: {
                    value: 1
                },
                aoMapTransform: {
                    value: new el
                }
            },
            lightmap: {
                lightMap: {
                    value: null
                },
                lightMapIntensity: {
                    value: 1
                },
                lightMapTransform: {
                    value: new el
                }
            },
            bumpmap: {
                bumpMap: {
                    value: null
                },
                bumpMapTransform: {
                    value: new el
                },
                bumpScale: {
                    value: 1
                }
            },
            normalmap: {
                normalMap: {
                    value: null
                },
                normalMapTransform: {
                    value: new el
                },
                normalScale: {
                    value: new tl(1, 1)
                }
            },
            displacementmap: {
                displacementMap: {
                    value: null
                },
                displacementMapTransform: {
                    value: new el
                },
                displacementScale: {
                    value: 1
                },
                displacementBias: {
                    value: 0
                }
            },
            emissivemap: {
                emissiveMap: {
                    value: null
                },
                emissiveMapTransform: {
                    value: new el
                }
            },
            metalnessmap: {
                metalnessMap: {
                    value: null
                },
                metalnessMapTransform: {
                    value: new el
                }
            },
            roughnessmap: {
                roughnessMap: {
                    value: null
                },
                roughnessMapTransform: {
                    value: new el
                }
            },
            gradientmap: {
                gradientMap: {
                    value: null
                }
            },
            fog: {
                fogDensity: {
                    value: 25e-5
                },
                fogNear: {
                    value: 1
                },
                fogFar: {
                    value: 2e3
                },
                fogColor: {
                    value: new Jc(16777215)
                }
            },
            lights: {
                ambientLightColor: {
                    value: []
                },
                lightProbe: {
                    value: []
                },
                directionalLights: {
                    value: [],
                    properties: {
                        direction: {},
                        color: {}
                    }
                },
                directionalLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                directionalShadowMap: {
                    value: []
                },
                directionalShadowMatrix: {
                    value: []
                },
                spotLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        direction: {},
                        distance: {},
                        coneCos: {},
                        penumbraCos: {},
                        decay: {}
                    }
                },
                spotLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                spotLightMap: {
                    value: []
                },
                spotShadowMap: {
                    value: []
                },
                spotLightMatrix: {
                    value: []
                },
                pointLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        decay: {},
                        distance: {}
                    }
                },
                pointLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {},
                        shadowCameraNear: {},
                        shadowCameraFar: {}
                    }
                },
                pointShadowMap: {
                    value: []
                },
                pointShadowMatrix: {
                    value: []
                },
                hemisphereLights: {
                    value: [],
                    properties: {
                        direction: {},
                        skyColor: {},
                        groundColor: {}
                    }
                },
                rectAreaLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        width: {},
                        height: {}
                    }
                },
                ltc_1: {
                    value: null
                },
                ltc_2: {
                    value: null
                }
            },
            points: {
                diffuse: {
                    value: new Jc(16777215)
                },
                opacity: {
                    value: 1
                },
                size: {
                    value: 1
                },
                scale: {
                    value: 1
                },
                map: {
                    value: null
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                },
                uvTransform: {
                    value: new el
                }
            },
            sprite: {
                diffuse: {
                    value: new Jc(16777215)
                },
                opacity: {
                    value: 1
                },
                center: {
                    value: new tl(.5, .5)
                },
                rotation: {
                    value: 0
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new el
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                }
            }
        }, Ah = {
            basic: {
                uniforms: Zu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.fog
                ]),
                vertexShader: mh.meshbasic_vert,
                fragmentShader: mh.meshbasic_frag
            },
            lambert: {
                uniforms: Zu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new Jc(0)
                        }
                    }
                ]),
                vertexShader: mh.meshlambert_vert,
                fragmentShader: mh.meshlambert_frag
            },
            phong: {
                uniforms: Zu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new Jc(0)
                        },
                        specular: {
                            value: new Jc(1118481)
                        },
                        shininess: {
                            value: 30
                        }
                    }
                ]),
                vertexShader: mh.meshphong_vert,
                fragmentShader: mh.meshphong_frag
            },
            standard: {
                uniforms: Zu([
                    gh.common,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.roughnessmap,
                    gh.metalnessmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new Jc(0)
                        },
                        roughness: {
                            value: 1
                        },
                        metalness: {
                            value: 0
                        },
                        envMapIntensity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: mh.meshphysical_vert,
                fragmentShader: mh.meshphysical_frag
            },
            toon: {
                uniforms: Zu([
                    gh.common,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.gradientmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new Jc(0)
                        }
                    }
                ]),
                vertexShader: mh.meshtoon_vert,
                fragmentShader: mh.meshtoon_frag
            },
            matcap: {
                uniforms: Zu([
                    gh.common,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    {
                        matcap: {
                            value: null
                        }
                    }
                ]),
                vertexShader: mh.meshmatcap_vert,
                fragmentShader: mh.meshmatcap_frag
            },
            points: {
                uniforms: Zu([
                    gh.points,
                    gh.fog
                ]),
                vertexShader: mh.points_vert,
                fragmentShader: mh.points_frag
            },
            dashed: {
                uniforms: Zu([
                    gh.common,
                    gh.fog,
                    {
                        scale: {
                            value: 1
                        },
                        dashSize: {
                            value: 1
                        },
                        totalSize: {
                            value: 2
                        }
                    }
                ]),
                vertexShader: mh.linedashed_vert,
                fragmentShader: mh.linedashed_frag
            },
            depth: {
                uniforms: Zu([
                    gh.common,
                    gh.displacementmap
                ]),
                vertexShader: mh.depth_vert,
                fragmentShader: mh.depth_frag
            },
            normal: {
                uniforms: Zu([
                    gh.common,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    {
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: mh.meshnormal_vert,
                fragmentShader: mh.meshnormal_frag
            },
            sprite: {
                uniforms: Zu([
                    gh.sprite,
                    gh.fog
                ]),
                vertexShader: mh.sprite_vert,
                fragmentShader: mh.sprite_frag
            },
            background: {
                uniforms: {
                    uvTransform: {
                        value: new el
                    },
                    t2D: {
                        value: null
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: mh.background_vert,
                fragmentShader: mh.background_frag
            },
            backgroundCube: {
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    },
                    backgroundBlurriness: {
                        value: 0
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: mh.backgroundCube_vert,
                fragmentShader: mh.backgroundCube_frag
            },
            cube: {
                uniforms: {
                    tCube: {
                        value: null
                    },
                    tFlip: {
                        value: -1
                    },
                    opacity: {
                        value: 1
                    }
                },
                vertexShader: mh.cube_vert,
                fragmentShader: mh.cube_frag
            },
            equirect: {
                uniforms: {
                    tEquirect: {
                        value: null
                    }
                },
                vertexShader: mh.equirect_vert,
                fragmentShader: mh.equirect_frag
            },
            distanceRGBA: {
                uniforms: Zu([
                    gh.common,
                    gh.displacementmap,
                    {
                        referencePosition: {
                            value: new Ol
                        },
                        nearDistance: {
                            value: 1
                        },
                        farDistance: {
                            value: 1e3
                        }
                    }
                ]),
                vertexShader: mh.distanceRGBA_vert,
                fragmentShader: mh.distanceRGBA_frag
            },
            shadow: {
                uniforms: Zu([
                    gh.lights,
                    gh.fog,
                    {
                        color: {
                            value: new Jc(0)
                        },
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: mh.shadow_vert,
                fragmentShader: mh.shadow_frag
            }
        };
        Ah.physical = {
            uniforms: Zu([
                Ah.standard.uniforms,
                {
                    clearcoat: {
                        value: 0
                    },
                    clearcoatMap: {
                        value: null
                    },
                    clearcoatMapTransform: {
                        value: new el
                    },
                    clearcoatNormalMap: {
                        value: null
                    },
                    clearcoatNormalMapTransform: {
                        value: new el
                    },
                    clearcoatNormalScale: {
                        value: new tl(1, 1)
                    },
                    clearcoatRoughness: {
                        value: 0
                    },
                    clearcoatRoughnessMap: {
                        value: null
                    },
                    clearcoatRoughnessMapTransform: {
                        value: new el
                    },
                    iridescence: {
                        value: 0
                    },
                    iridescenceMap: {
                        value: null
                    },
                    iridescenceMapTransform: {
                        value: new el
                    },
                    iridescenceIOR: {
                        value: 1.3
                    },
                    iridescenceThicknessMinimum: {
                        value: 100
                    },
                    iridescenceThicknessMaximum: {
                        value: 400
                    },
                    iridescenceThicknessMap: {
                        value: null
                    },
                    iridescenceThicknessMapTransform: {
                        value: new el
                    },
                    sheen: {
                        value: 0
                    },
                    sheenColor: {
                        value: new Jc(0)
                    },
                    sheenColorMap: {
                        value: null
                    },
                    sheenColorMapTransform: {
                        value: new el
                    },
                    sheenRoughness: {
                        value: 1
                    },
                    sheenRoughnessMap: {
                        value: null
                    },
                    sheenRoughnessMapTransform: {
                        value: new el
                    },
                    transmission: {
                        value: 0
                    },
                    transmissionMap: {
                        value: null
                    },
                    transmissionMapTransform: {
                        value: new el
                    },
                    transmissionSamplerSize: {
                        value: new tl
                    },
                    transmissionSamplerMap: {
                        value: null
                    },
                    thickness: {
                        value: 0
                    },
                    thicknessMap: {
                        value: null
                    },
                    thicknessMapTransform: {
                        value: new el
                    },
                    attenuationDistance: {
                        value: 0
                    },
                    attenuationColor: {
                        value: new Jc(0)
                    },
                    specularColor: {
                        value: new Jc(1, 1, 1)
                    },
                    specularColorMap: {
                        value: null
                    },
                    specularColorMapTransform: {
                        value: new el
                    },
                    specularIntensity: {
                        value: 1
                    },
                    specularIntensityMap: {
                        value: null
                    },
                    specularIntensityMapTransform: {
                        value: new el
                    },
                    anisotropyVector: {
                        value: new tl
                    },
                    anisotropyMap: {
                        value: null
                    },
                    anisotropyMapTransform: {
                        value: new el
                    }
                }
            ]),
            vertexShader: mh.meshphysical_vert,
            fragmentShader: mh.meshphysical_frag
        };
        const vh = {
            r: 0,
            b: 0,
            g: 0
        };
        function yh(t1, e, n, i, r, a, s) {
            const o = new Jc(0);
            let l, c, u = !0 === a ? 0 : 1, h = null, d = 0, p = null;
            function f(e, n) {
                e.getRGB(vh, qu(t1)), i.buffers.color.setClear(vh.r, vh.g, vh.b, n, s);
            }
            return {
                getClearColor: function() {
                    return o;
                },
                setClearColor: function(t1, e = 1) {
                    o.set(t1), u = e, f(o, u);
                },
                getClearAlpha: function() {
                    return u;
                },
                setClearAlpha: function(t1) {
                    u = t1, f(o, u);
                },
                render: function(a, m) {
                    let g = !1, A = !0 === m.isScene ? m.background : null;
                    A && A.isTexture && (A = (m.backgroundBlurriness > 0 ? n : e).get(A)), null === A ? f(o, u) : A && A.isColor && (f(A, 1), g = !0);
                    const v = t1.xr.getEnvironmentBlendMode();
                    "additive" === v ? i.buffers.color.setClear(0, 0, 0, 1, s) : "alpha-blend" === v && i.buffers.color.setClear(0, 0, 0, 0, s), (t1.autoClear || g) && t1.clear(t1.autoClearColor, t1.autoClearDepth, t1.autoClearStencil), A && (A.isCubeTexture || A.mapping === ha) ? (void 0 === c && (c = new Gu(new Xu(1, 1, 1), new Ku({
                        name: "BackgroundCubeMaterial",
                        uniforms: Yu(Ah.backgroundCube.uniforms),
                        vertexShader: Ah.backgroundCube.vertexShader,
                        fragmentShader: Ah.backgroundCube.fragmentShader,
                        side: dr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(t1, e, n) {
                        this.matrixWorld.copyPosition(n.matrixWorld);
                    }, Object.defineProperty(c.material, "envMap", {
                        get: function() {
                            return this.uniforms.envMap.value;
                        }
                    }), r.update(c)), c.material.uniforms.envMap.value = A, c.material.uniforms.flipEnvMap.value = A.isCubeTexture && !1 === A.isRenderTargetTexture ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = m.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = m.backgroundIntensity, c.material.toneMapped = fl.getTransfer(A.colorSpace) !== Js, h === A && d === A.version && p === t1.toneMapping || (c.material.needsUpdate = !0, h = A, d = A.version, p = t1.toneMapping), c.layers.enableAll(), a.unshift(c, c.geometry, c.material, 0, 0, null)) : A && A.isTexture && (void 0 === l && (l = new Gu(new fh(2, 2), new Ku({
                        name: "BackgroundMaterial",
                        uniforms: Yu(Ah.background.uniforms),
                        vertexShader: Ah.background.vertexShader,
                        fragmentShader: Ah.background.fragmentShader,
                        side: hr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
                        get: function() {
                            return this.uniforms.t2D.value;
                        }
                    }), r.update(l)), l.material.uniforms.t2D.value = A, l.material.uniforms.backgroundIntensity.value = m.backgroundIntensity, l.material.toneMapped = fl.getTransfer(A.colorSpace) !== Js, !0 === A.matrixAutoUpdate && A.updateMatrix(), l.material.uniforms.uvTransform.value.copy(A.matrix), h === A && d === A.version && p === t1.toneMapping || (l.material.needsUpdate = !0, h = A, d = A.version, p = t1.toneMapping), l.layers.enableAll(), a.unshift(l, l.geometry, l.material, 0, 0, null));
                }
            };
        }
        function Mh(t1, e, n, i) {
            const r = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), a = i.isWebGL2 ? null : e.get("OES_vertex_array_object"), s = i.isWebGL2 || null !== a, o = {}, l = p(null);
            let c = l, u = !1;
            function h(e) {
                return i.isWebGL2 ? t1.bindVertexArray(e) : a.bindVertexArrayOES(e);
            }
            function d(e) {
                return i.isWebGL2 ? t1.deleteVertexArray(e) : a.deleteVertexArrayOES(e);
            }
            function p(t1) {
                const e = [], n = [], i = [];
                for(let t1 = 0; t1 < r; t1++)e[t1] = 0, n[t1] = 0, i[t1] = 0;
                return {
                    geometry: null,
                    program: null,
                    wireframe: !1,
                    newAttributes: e,
                    enabledAttributes: n,
                    attributeDivisors: i,
                    object: t1,
                    attributes: {},
                    index: null
                };
            }
            function f() {
                const t1 = c.newAttributes;
                for(let e = 0, n = t1.length; e < n; e++)t1[e] = 0;
            }
            function m(t1) {
                g(t1, 0);
            }
            function g(n, r) {
                const a = c.newAttributes, s = c.enabledAttributes, o = c.attributeDivisors;
                a[n] = 1, 0 === s[n] && (t1.enableVertexAttribArray(n), s[n] = 1), o[n] !== r && ((i.isWebGL2 ? t1 : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r);
            }
            function A() {
                const e = c.newAttributes, n = c.enabledAttributes;
                for(let i = 0, r = n.length; i < r; i++)n[i] !== e[i] && (t1.disableVertexAttribArray(i), n[i] = 0);
            }
            function v(e, n, i, r, a, s, o) {
                !0 === o ? t1.vertexAttribIPointer(e, n, i, a, s) : t1.vertexAttribPointer(e, n, i, r, a, s);
            }
            function y() {
                M(), u = !0, c !== l && (c = l, h(c.object));
            }
            function M() {
                l.geometry = null, l.program = null, l.wireframe = !1;
            }
            return {
                setup: function(r, l, d, y, M) {
                    let b = !1;
                    if (s) {
                        const e = function(e, n, r) {
                            const s = !0 === r.wireframe;
                            let l = o[e.id];
                            void 0 === l && (l = {}, o[e.id] = l);
                            let c = l[n.id];
                            void 0 === c && (c = {}, l[n.id] = c);
                            let u = c[s];
                            return void 0 === u && (u = p(i.isWebGL2 ? t1.createVertexArray() : a.createVertexArrayOES()), c[s] = u), u;
                        }(y, d, l);
                        c !== e && (c = e, h(c.object)), b = function(t1, e, n, i) {
                            const r = c.attributes, a = e.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                const n = r[e];
                                let i = a[e];
                                if (void 0 === i && ("instanceMatrix" === e && t1.instanceMatrix && (i = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (i = t1.instanceColor)), void 0 === n) return !0;
                                if (n.attribute !== i) return !0;
                                if (i && n.data !== i.data) return !0;
                                s++;
                            }
                            return c.attributesNum !== s || c.index !== i;
                        }(r, y, d, M), b && function(t1, e, n, i) {
                            const r = {}, a = e.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                let n = a[e];
                                void 0 === n && ("instanceMatrix" === e && t1.instanceMatrix && (n = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (n = t1.instanceColor));
                                const i = {};
                                i.attribute = n, n && n.data && (i.data = n.data), r[e] = i, s++;
                            }
                            c.attributes = r, c.attributesNum = s, c.index = i;
                        }(r, y, d, M);
                    } else {
                        const t1 = !0 === l.wireframe;
                        c.geometry === y.id && c.program === d.id && c.wireframe === t1 || (c.geometry = y.id, c.program = d.id, c.wireframe = t1, b = !0);
                    }
                    null !== M && n.update(M, t1.ELEMENT_ARRAY_BUFFER), (b || u) && (u = !1, function(r, a, s, o) {
                        if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
                        f();
                        const l = o.attributes, c = s.getAttributes(), u = a.defaultAttributeValues;
                        for(const e in c){
                            const a = c[e];
                            if (a.location >= 0) {
                                let s = l[e];
                                if (void 0 === s && ("instanceMatrix" === e && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === e && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                                    const e = s.normalized, l = s.itemSize, c = n.get(s);
                                    if (void 0 === c) continue;
                                    const u = c.buffer, h = c.type, d = c.bytesPerElement, p = !0 === i.isWebGL2 && (h === t1.INT || h === t1.UNSIGNED_INT || s.gpuType === Ca);
                                    if (s.isInterleavedBufferAttribute) {
                                        const n = s.data, i = n.stride, c = s.offset;
                                        if (n.isInstancedInterleavedBuffer) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)g(a.location + t1, n.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = n.meshPerAttribute * n.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)m(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)v(a.location + t1, l / a.locationSize, h, e, i * d, (c + l / a.locationSize * t1) * d, p);
                                    } else {
                                        if (s.isInstancedBufferAttribute) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)g(a.location + t1, s.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)m(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)v(a.location + t1, l / a.locationSize, h, e, l * d, l / a.locationSize * t1 * d, p);
                                    }
                                } else if (void 0 !== u) {
                                    const n = u[e];
                                    if (void 0 !== n) switch(n.length){
                                        case 2:
                                            t1.vertexAttrib2fv(a.location, n);
                                            break;
                                        case 3:
                                            t1.vertexAttrib3fv(a.location, n);
                                            break;
                                        case 4:
                                            t1.vertexAttrib4fv(a.location, n);
                                            break;
                                        default:
                                            t1.vertexAttrib1fv(a.location, n);
                                    }
                                }
                            }
                        }
                        A();
                    }(r, l, d, y), null !== M && t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, n.get(M).buffer));
                },
                reset: y,
                resetDefaultState: M,
                dispose: function() {
                    y();
                    for(const t1 in o){
                        const e = o[t1];
                        for(const t1 in e){
                            const n = e[t1];
                            for(const t1 in n)d(n[t1].object), delete n[t1];
                            delete e[t1];
                        }
                        delete o[t1];
                    }
                },
                releaseStatesOfGeometry: function(t1) {
                    if (void 0 === o[t1.id]) return;
                    const e = o[t1.id];
                    for(const t1 in e){
                        const n = e[t1];
                        for(const t1 in n)d(n[t1].object), delete n[t1];
                        delete e[t1];
                    }
                    delete o[t1.id];
                },
                releaseStatesOfProgram: function(t1) {
                    for(const e in o){
                        const n = o[e];
                        if (void 0 === n[t1.id]) continue;
                        const i = n[t1.id];
                        for(const t1 in i)d(i[t1].object), delete i[t1];
                        delete n[t1.id];
                    }
                },
                initAttributes: f,
                enableAttribute: m,
                disableUnusedAttributes: A
            };
        }
        function bh(t1, e, n, i) {
            const r = i.isWebGL2;
            let a;
            this.setMode = function(t1) {
                a = t1;
            }, this.render = function(e, i) {
                t1.drawArrays(a, e, i), n.update(i, a, 1);
            }, this.renderInstances = function(i, s, o) {
                if (0 === o) return;
                let l, c;
                if (r) l = t1, c = "drawArraysInstanced";
                else if (l = e.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                l[c](a, i, s, o), n.update(s, a, o);
            };
        }
        function xh(t1, e, n) {
            let i;
            function r(e) {
                if ("highp" === e) {
                    if (t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.HIGH_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.HIGH_FLOAT).precision > 0) return "highp";
                    e = "mediump";
                }
                return "mediump" === e && t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.MEDIUM_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
            }
            const a = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === t1.constructor.name;
            let s = void 0 !== n.precision ? n.precision : "highp";
            const o = r(s);
            o !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
            const l = a || e.has("WEBGL_draw_buffers"), c = !0 === n.logarithmicDepthBuffer, u = t1.getParameter(t1.MAX_TEXTURE_IMAGE_UNITS), h = t1.getParameter(t1.MAX_VERTEX_TEXTURE_IMAGE_UNITS), d = t1.getParameter(t1.MAX_TEXTURE_SIZE), p = t1.getParameter(t1.MAX_CUBE_MAP_TEXTURE_SIZE), f = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), m = t1.getParameter(t1.MAX_VERTEX_UNIFORM_VECTORS), g = t1.getParameter(t1.MAX_VARYING_VECTORS), A = t1.getParameter(t1.MAX_FRAGMENT_UNIFORM_VECTORS), v = h > 0, y = a || e.has("OES_texture_float");
            return {
                isWebGL2: a,
                drawBuffers: l,
                getMaxAnisotropy: function() {
                    if (void 0 !== i) return i;
                    if (!0 === e.has("EXT_texture_filter_anisotropic")) {
                        const n = e.get("EXT_texture_filter_anisotropic");
                        i = t1.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                    } else i = 0;
                    return i;
                },
                getMaxPrecision: r,
                precision: s,
                logarithmicDepthBuffer: c,
                maxTextures: u,
                maxVertexTextures: h,
                maxTextureSize: d,
                maxCubemapSize: p,
                maxAttributes: f,
                maxVertexUniforms: m,
                maxVaryings: g,
                maxFragmentUniforms: A,
                vertexTextures: v,
                floatFragmentTextures: y,
                floatVertexTextures: v && y,
                maxSamples: a ? t1.getParameter(t1.MAX_SAMPLES) : 0
            };
        }
        function wh(t1) {
            const e = this;
            let n = null, i = 0, r = !1, a = !1;
            const s = new lh, o = new el, l = {
                value: null,
                needsUpdate: !1
            };
            function c(t1, n, i, r) {
                const a = null !== t1 ? t1.length : 0;
                let c = null;
                if (0 !== a) {
                    if (c = l.value, !0 !== r || null === c) {
                        const e = i + 4 * a, r = n.matrixWorldInverse;
                        o.getNormalMatrix(r), (null === c || c.length < e) && (c = new Float32Array(e));
                        for(let e = 0, n = i; e !== a; ++e, n += 4)s.copy(t1[e]).applyMatrix4(r, o), s.normal.toArray(c, n), c[n + 3] = s.constant;
                    }
                    l.value = c, l.needsUpdate = !0;
                }
                return e.numPlanes = a, e.numIntersection = 0, c;
            }
            this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(t1, e) {
                const n = 0 !== t1.length || e || 0 !== i || r;
                return r = e, i = t1.length, n;
            }, this.beginShadows = function() {
                a = !0, c(null);
            }, this.endShadows = function() {
                a = !1;
            }, this.setGlobalState = function(t1, e) {
                n = c(t1, e, 0);
            }, this.setState = function(s, o, u) {
                const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, f = t1.get(s);
                if (!r || null === h || 0 === h.length || a && !p) a ? c(null) : (l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0);
                else {
                    const t1 = a ? 0 : i, e = 4 * t1;
                    let r = f.clippingState || null;
                    l.value = r, r = c(h, o, e, u);
                    for(let t1 = 0; t1 !== e; ++t1)r[t1] = n[t1];
                    f.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += t1;
                }
            };
        }
        function _h(t1) {
            let e = new WeakMap;
            function n(t1, e) {
                return e === ca ? t1.mapping = oa : e === ua && (t1.mapping = la), t1;
            }
            function i(t1) {
                const n = t1.target;
                n.removeEventListener("dispose", i);
                const r = e.get(n);
                void 0 !== r && (e.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                        const a = r.mapping;
                        if (a === ca || a === ua) {
                            if (e.has(r)) return n(e.get(r).texture, r.mapping);
                            {
                                const a = r.image;
                                if (a && a.height > 0) {
                                    const s = new rh(a.height / 2);
                                    return s.fromEquirectangularTexture(t1, r), e.set(r, s), r.addEventListener("dispose", i), n(s.texture, r.mapping);
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap;
                }
            };
        }
        class Eh extends $u {
            constructor(t1 = -1, e = 1, n = 1, i = -1, r = .1, a = 2e3){
                super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t1, this.right = e, this.top = n, this.bottom = i, this.near = r, this.far = a, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.left = t1.left, this.right = t1.right, this.top = t1.top, this.bottom = t1.bottom, this.near = t1.near, this.far = t1.far, this.zoom = t1.zoom, this.view = null === t1.view ? null : Object.assign({}, t1.view), this;
            }
            setViewOffset(t1, e, n, i, r, a) {
                null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
                let r = n - t1, a = n + t1, s = i + e, o = i - e;
                if (null !== this.view && this.view.enabled) {
                    const t1 = (this.right - this.left) / this.view.fullWidth / this.zoom, e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    r += t1 * this.view.offsetX, a = r + t1 * this.view.width, s -= e * this.view.offsetY, o = s - e * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
            }
        }
        const Sh = [
            .125,
            .215,
            .35,
            .446,
            .526,
            .582
        ], Th = new Eh, Ih = new Jc;
        let Ch = null, Nh = 0, Dh = 0;
        const Lh = (1 + Math.sqrt(5)) / 2, Oh = 1 / Lh, Rh = [
            new Ol(1, 1, 1),
            new Ol(-1, 1, 1),
            new Ol(1, 1, -1),
            new Ol(-1, 1, -1),
            new Ol(0, Lh, Oh),
            new Ol(0, Lh, -Oh),
            new Ol(Oh, 0, Lh),
            new Ol(-Oh, 0, Lh),
            new Ol(Lh, Oh, 0),
            new Ol(-Lh, Oh, 0)
        ];
        class Ph {
            constructor(t1){
                this._renderer = t1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
            }
            fromScene(t1, e = 0, n = .1, i = 100) {
                Ch = this._renderer.getRenderTarget(), Nh = this._renderer.getActiveCubeFace(), Dh = this._renderer.getActiveMipmapLevel(), this._setSize(256);
                const r = this._allocateTargets();
                return r.depthBuffer = !0, this._sceneToCubeUV(t1, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
            }
            fromEquirectangular(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            fromCubemap(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            compileCubemapShader() {
                null === this._cubemapMaterial && (this._cubemapMaterial = Bh(), this._compileMaterial(this._cubemapMaterial));
            }
            compileEquirectangularShader() {
                null === this._equirectMaterial && (this._equirectMaterial = kh(), this._compileMaterial(this._equirectMaterial));
            }
            dispose() {
                this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
            }
            _setSize(t1) {
                this._lodMax = Math.floor(Math.log2(t1)), this._cubeSize = Math.pow(2, this._lodMax);
            }
            _dispose() {
                null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                for(let t1 = 0; t1 < this._lodPlanes.length; t1++)this._lodPlanes[t1].dispose();
            }
            _cleanup(t1) {
                this._renderer.setRenderTarget(Ch, Nh, Dh), t1.scissorTest = !1, Uh(t1, 0, 0, t1.width, t1.height);
            }
            _fromTexture(t1, e) {
                t1.mapping === oa || t1.mapping === la ? this._setSize(0 === t1.image.length ? 16 : t1.image[0].width || t1.image[0].image.width) : this._setSize(t1.image.width / 4), Ch = this._renderer.getRenderTarget(), Nh = this._renderer.getActiveCubeFace(), Dh = this._renderer.getActiveMipmapLevel();
                const n = e || this._allocateTargets();
                return this._textureToCubeUV(t1, n), this._applyPMREM(n), this._cleanup(n), n;
            }
            _allocateTargets() {
                const t1 = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, n = {
                    magFilter: Ma,
                    minFilter: Ma,
                    generateMipmaps: !1,
                    type: La,
                    format: Ua,
                    colorSpace: Xs,
                    depthBuffer: !1
                }, i = zh(t1, e, n);
                if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t1 || this._pingPongRenderTarget.height !== e) {
                    null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = zh(t1, e, n);
                    const { _lodMax: i } = this;
                    ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(t1) {
                        const e = [], n = [], i = [];
                        let r = t1;
                        const a = t1 - 4 + 1 + Sh.length;
                        for(let s = 0; s < a; s++){
                            const a = Math.pow(2, r);
                            n.push(a);
                            let o = 1 / a;
                            s > t1 - 4 ? o = Sh[s - t1 + 4 - 1] : 0 === s && (o = 0), i.push(o);
                            const l = 1 / (a - 2), c = -l, u = 1 + l, h = [
                                c,
                                c,
                                u,
                                c,
                                u,
                                u,
                                c,
                                c,
                                u,
                                u,
                                c,
                                u
                            ], d = 6, p = 6, f = 3, m = 2, g = 1, A = new Float32Array(f * p * d), v = new Float32Array(m * p * d), y = new Float32Array(g * p * d);
                            for(let t1 = 0; t1 < d; t1++){
                                const e = t1 % 3 * 2 / 3 - 1, n = t1 > 2 ? 0 : -1, i = [
                                    e,
                                    n,
                                    0,
                                    e + 2 / 3,
                                    n,
                                    0,
                                    e + 2 / 3,
                                    n + 1,
                                    0,
                                    e,
                                    n,
                                    0,
                                    e + 2 / 3,
                                    n + 1,
                                    0,
                                    e,
                                    n + 1,
                                    0
                                ];
                                A.set(i, f * p * t1), v.set(h, m * p * t1);
                                const r = [
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1
                                ];
                                y.set(r, g * p * t1);
                            }
                            const M = new Tu;
                            M.setAttribute("position", new cu(A, f)), M.setAttribute("uv", new cu(v, m)), M.setAttribute("faceIndex", new cu(y, g)), e.push(M), r > 4 && r--;
                        }
                        return {
                            lodPlanes: e,
                            sizeLods: n,
                            sigmas: i
                        };
                    }(i)), this._blurMaterial = function(t1, e, n) {
                        const i = new Float32Array(20), r = new Ol(0, 1, 0);
                        return new Ku({
                            name: "SphericalGaussianBlur",
                            defines: {
                                n: 20,
                                CUBEUV_TEXEL_WIDTH: 1 / e,
                                CUBEUV_TEXEL_HEIGHT: 1 / n,
                                CUBEUV_MAX_MIP: `${t1}.0`
                            },
                            uniforms: {
                                envMap: {
                                    value: null
                                },
                                samples: {
                                    value: 1
                                },
                                weights: {
                                    value: i
                                },
                                latitudinal: {
                                    value: !1
                                },
                                dTheta: {
                                    value: 0
                                },
                                mipInt: {
                                    value: 0
                                },
                                poleAxis: {
                                    value: r
                                }
                            },
                            vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                            fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
                            blending: mr,
                            depthTest: !1,
                            depthWrite: !1
                        });
                    }(i, t1, e);
                }
                return i;
            }
            _compileMaterial(t1) {
                const e = new Gu(this._lodPlanes[0], t1);
                this._renderer.compile(e, Th);
            }
            _sceneToCubeUV(t1, e, n, i) {
                const r = new th(90, 1, e, n), a = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ], s = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ], o = this._renderer, l = o.autoClear, c = o.toneMapping;
                o.getClearColor(Ih), o.toneMapping = Kr, o.autoClear = !1;
                const u = new eu({
                    name: "PMREM.Background",
                    side: dr,
                    depthWrite: !1,
                    depthTest: !1
                }), h = new Gu(new Xu, u);
                let d = !1;
                const p = t1.background;
                p ? p.isColor && (u.color.copy(p), t1.background = null, d = !0) : (u.color.copy(Ih), d = !0);
                for(let e = 0; e < 6; e++){
                    const n = e % 3;
                    0 === n ? (r.up.set(0, a[e], 0), r.lookAt(s[e], 0, 0)) : 1 === n ? (r.up.set(0, 0, a[e]), r.lookAt(0, s[e], 0)) : (r.up.set(0, a[e], 0), r.lookAt(0, 0, s[e]));
                    const l = this._cubeSize;
                    Uh(i, n * l, e > 2 ? l : 0, l, l), o.setRenderTarget(i), d && o.render(h, r), o.render(t1, r);
                }
                h.geometry.dispose(), h.material.dispose(), o.toneMapping = c, o.autoClear = l, t1.background = p;
            }
            _textureToCubeUV(t1, e) {
                const n = this._renderer, i = t1.mapping === oa || t1.mapping === la;
                i ? (null === this._cubemapMaterial && (this._cubemapMaterial = Bh()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = kh());
                const r = i ? this._cubemapMaterial : this._equirectMaterial, a = new Gu(this._lodPlanes[0], r);
                r.uniforms.envMap.value = t1;
                const s = this._cubeSize;
                Uh(e, 0, 0, 3 * s, 2 * s), n.setRenderTarget(e), n.render(a, Th);
            }
            _applyPMREM(t1) {
                const e = this._renderer, n = e.autoClear;
                e.autoClear = !1;
                for(let e = 1; e < this._lodPlanes.length; e++){
                    const n = Math.sqrt(this._sigmas[e] * this._sigmas[e] - this._sigmas[e - 1] * this._sigmas[e - 1]), i = Rh[(e - 1) % Rh.length];
                    this._blur(t1, e - 1, e, n, i);
                }
                e.autoClear = n;
            }
            _blur(t1, e, n, i, r) {
                const a = this._pingPongRenderTarget;
                this._halfBlur(t1, a, e, n, i, "latitudinal", r), this._halfBlur(a, t1, n, n, i, "longitudinal", r);
            }
            _halfBlur(t1, e, n, i, r, a, s) {
                const o = this._renderer, l = this._blurMaterial;
                "latitudinal" !== a && "longitudinal" !== a && console.error("blur direction must be either latitudinal or longitudinal!");
                const c = new Gu(this._lodPlanes[i], l), u = l.uniforms, h = this._sizeLods[n] - 1, d = isFinite(r) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = r / d, f = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
                f > 20 && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${f} samples when the maximum is set to 20`);
                const m = [];
                let g = 0;
                for(let t1 = 0; t1 < 20; ++t1){
                    const e = t1 / p, n = Math.exp(-e * e / 2);
                    m.push(n), 0 === t1 ? g += n : t1 < f && (g += 2 * n);
                }
                for(let t1 = 0; t1 < m.length; t1++)m[t1] = m[t1] / g;
                u.envMap.value = t1.texture, u.samples.value = f, u.weights.value = m, u.latitudinal.value = "latitudinal" === a, s && (u.poleAxis.value = s);
                const { _lodMax: A } = this;
                u.dTheta.value = d, u.mipInt.value = A - n;
                const v = this._sizeLods[i];
                Uh(e, 3 * v * (i > A - 4 ? i - A + 4 : 0), 4 * (this._cubeSize - v), 3 * v, 2 * v), o.setRenderTarget(e), o.render(c, Th);
            }
        }
        function zh(t1, e, n) {
            const i = new Sl(t1, e, n);
            return i.texture.mapping = ha, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
        }
        function Uh(t1, e, n, i, r) {
            t1.viewport.set(e, n, i, r), t1.scissor.set(e, n, i, r);
        }
        function kh() {
            return new Ku({
                name: "EquirectangularToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
                blending: mr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function Bh() {
            return new Ku({
                name: "CubemapToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
                blending: mr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function jh(t1) {
            let e = new WeakMap, n = null;
            function i(t1) {
                const n = t1.target;
                n.removeEventListener("dispose", i);
                const r = e.get(n);
                void 0 !== r && (e.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture) {
                        const a = r.mapping, s = a === ca || a === ua, o = a === oa || a === la;
                        if (s || o) {
                            if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                                r.needsPMREMUpdate = !1;
                                let i = e.get(r);
                                return null === n && (n = new Ph(t1)), i = s ? n.fromEquirectangular(r, i) : n.fromCubemap(r, i), e.set(r, i), i.texture;
                            }
                            if (e.has(r)) return e.get(r).texture;
                            {
                                const a = r.image;
                                if (s && a && a.height > 0 || o && a && function(t1) {
                                    let e = 0;
                                    for(let n = 0; n < 6; n++)void 0 !== t1[n] && e++;
                                    return 6 === e;
                                }(a)) {
                                    null === n && (n = new Ph(t1));
                                    const a = s ? n.fromEquirectangular(r) : n.fromCubemap(r);
                                    return e.set(r, a), r.addEventListener("dispose", i), a.texture;
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap, null !== n && (n.dispose(), n = null);
                }
            };
        }
        function Fh(t1) {
            const e = {};
            function n(n) {
                if (void 0 !== e[n]) return e[n];
                let i;
                switch(n){
                    case "WEBGL_depth_texture":
                        i = t1.getExtension("WEBGL_depth_texture") || t1.getExtension("MOZ_WEBGL_depth_texture") || t1.getExtension("WEBKIT_WEBGL_depth_texture");
                        break;
                    case "EXT_texture_filter_anisotropic":
                        i = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                        break;
                    case "WEBGL_compressed_texture_s3tc":
                        i = t1.getExtension("WEBGL_compressed_texture_s3tc") || t1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                        break;
                    case "WEBGL_compressed_texture_pvrtc":
                        i = t1.getExtension("WEBGL_compressed_texture_pvrtc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                        break;
                    default:
                        i = t1.getExtension(n);
                }
                return e[n] = i, i;
            }
            return {
                has: function(t1) {
                    return null !== n(t1);
                },
                init: function(t1) {
                    t1.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
                },
                get: function(t1) {
                    const e = n(t1);
                    return null === e && console.warn("THREE.WebGLRenderer: " + t1 + " extension not supported."), e;
                }
            };
        }
        function Hh(t1, e, n, i) {
            const r = {}, a = new WeakMap;
            function s(t1) {
                const o = t1.target;
                null !== o.index && e.remove(o.index);
                for(const t1 in o.attributes)e.remove(o.attributes[t1]);
                for(const t1 in o.morphAttributes){
                    const n = o.morphAttributes[t1];
                    for(let t1 = 0, i = n.length; t1 < i; t1++)e.remove(n[t1]);
                }
                o.removeEventListener("dispose", s), delete r[o.id];
                const l = a.get(o);
                l && (e.remove(l), a.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
            }
            function o(t1) {
                const n = [], i = t1.index, r = t1.attributes.position;
                let s = 0;
                if (null !== i) {
                    const t1 = i.array;
                    s = i.version;
                    for(let e = 0, i = t1.length; e < i; e += 3){
                        const i = t1[e + 0], r = t1[e + 1], a = t1[e + 2];
                        n.push(i, r, r, a, a, i);
                    }
                } else {
                    if (void 0 === r) return;
                    {
                        const t1 = r.array;
                        s = r.version;
                        for(let e = 0, i = t1.length / 3 - 1; e < i; e += 3){
                            const t1 = e + 0, i = e + 1, r = e + 2;
                            n.push(t1, i, i, r, r, t1);
                        }
                    }
                }
                const o = new (il(n) ? gu : fu)(n, 1);
                o.version = s;
                const l = a.get(t1);
                l && e.remove(l), a.set(t1, o);
            }
            return {
                get: function(t1, e) {
                    return !0 === r[e.id] || (e.addEventListener("dispose", s), r[e.id] = !0, n.memory.geometries++), e;
                },
                update: function(n) {
                    const i = n.attributes;
                    for(const n in i)e.update(i[n], t1.ARRAY_BUFFER);
                    const r = n.morphAttributes;
                    for(const n in r){
                        const i = r[n];
                        for(let n = 0, r = i.length; n < r; n++)e.update(i[n], t1.ARRAY_BUFFER);
                    }
                },
                getWireframeAttribute: function(t1) {
                    const e = a.get(t1);
                    if (e) {
                        const n = t1.index;
                        null !== n && e.version < n.version && o(t1);
                    } else o(t1);
                    return a.get(t1);
                }
            };
        }
        function Vh(t1, e, n, i) {
            const r = i.isWebGL2;
            let a, s, o;
            this.setMode = function(t1) {
                a = t1;
            }, this.setIndex = function(t1) {
                s = t1.type, o = t1.bytesPerElement;
            }, this.render = function(e, i) {
                t1.drawElements(a, i, s, e * o), n.update(i, a, 1);
            }, this.renderInstances = function(i, l, c) {
                if (0 === c) return;
                let u, h;
                if (r) u = t1, h = "drawElementsInstanced";
                else if (u = e.get("ANGLE_instanced_arrays"), h = "drawElementsInstancedANGLE", null === u) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                u[h](a, l, s, i * o, c), n.update(l, a, c);
            };
        }
        function Qh(t1) {
            const e = {
                frame: 0,
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0
            };
            return {
                memory: {
                    geometries: 0,
                    textures: 0
                },
                render: e,
                programs: null,
                autoReset: !0,
                reset: function() {
                    e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
                },
                update: function(n, i, r) {
                    switch(e.calls++, i){
                        case t1.TRIANGLES:
                            e.triangles += r * (n / 3);
                            break;
                        case t1.LINES:
                            e.lines += r * (n / 2);
                            break;
                        case t1.LINE_STRIP:
                            e.lines += r * (n - 1);
                            break;
                        case t1.LINE_LOOP:
                            e.lines += r * n;
                            break;
                        case t1.POINTS:
                            e.points += r * n;
                            break;
                        default:
                            console.error("THREE.WebGLInfo: Unknown draw mode:", i);
                    }
                }
            };
        }
        function Gh(t1, e) {
            return t1[0] - e[0];
        }
        function Wh(t1, e) {
            return Math.abs(e[1]) - Math.abs(t1[1]);
        }
        function Xh(t1, e, n) {
            const i = {}, r = new Float32Array(8), a = new WeakMap, s = new _l, o = [];
            for(let t1 = 0; t1 < 8; t1++)o[t1] = [
                t1,
                0
            ];
            return {
                update: function(l, c, u) {
                    const h = l.morphTargetInfluences;
                    if (!0 === e.isWebGL2) {
                        const d = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = void 0 !== d ? d.length : 0;
                        let f = a.get(c);
                        if (void 0 === f || f.count !== p) {
                            void 0 !== f && f.texture.dispose();
                            const A = void 0 !== c.morphAttributes.position, v = void 0 !== c.morphAttributes.normal, y = void 0 !== c.morphAttributes.color, M = c.morphAttributes.position || [], b = c.morphAttributes.normal || [], x = c.morphAttributes.color || [];
                            let w = 0;
                            !0 === A && (w = 1), !0 === v && (w = 2), !0 === y && (w = 3);
                            let _ = c.attributes.position.count * w, E = 1;
                            _ > e.maxTextureSize && (E = Math.ceil(_ / e.maxTextureSize), _ = e.maxTextureSize);
                            const S = new Float32Array(_ * E * 4 * p), T = new Tl(S, _, E, p);
                            T.type = Da, T.needsUpdate = !0;
                            const I = 4 * w;
                            for(let N = 0; N < p; N++){
                                const D = M[N], L = b[N], O = x[N], R = _ * E * 4 * N;
                                for(let P = 0; P < D.count; P++){
                                    const z = P * I;
                                    !0 === A && (s.fromBufferAttribute(D, P), S[R + z + 0] = s.x, S[R + z + 1] = s.y, S[R + z + 2] = s.z, S[R + z + 3] = 0), !0 === v && (s.fromBufferAttribute(L, P), S[R + z + 4] = s.x, S[R + z + 5] = s.y, S[R + z + 6] = s.z, S[R + z + 7] = 0), !0 === y && (s.fromBufferAttribute(O, P), S[R + z + 8] = s.x, S[R + z + 9] = s.y, S[R + z + 10] = s.z, S[R + z + 11] = 4 === O.itemSize ? s.w : 1);
                                }
                            }
                            function C() {
                                T.dispose(), a.delete(c), c.removeEventListener("dispose", C);
                            }
                            f = {
                                count: p,
                                texture: T,
                                size: new tl(_, E)
                            }, a.set(c, f), c.addEventListener("dispose", C);
                        }
                        let m = 0;
                        for(let U = 0; U < h.length; U++)m += h[U];
                        const g = c.morphTargetsRelative ? 1 : 1 - m;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", g), u.getUniforms().setValue(t1, "morphTargetInfluences", h), u.getUniforms().setValue(t1, "morphTargetsTexture", f.texture, n), u.getUniforms().setValue(t1, "morphTargetsTextureSize", f.size);
                    } else {
                        const k = void 0 === h ? 0 : h.length;
                        let B = i[c.id];
                        if (void 0 === B || B.length !== k) {
                            B = [];
                            for(let Q = 0; Q < k; Q++)B[Q] = [
                                Q,
                                0
                            ];
                            i[c.id] = B;
                        }
                        for(let G = 0; G < k; G++){
                            const W = B[G];
                            W[0] = G, W[1] = h[G];
                        }
                        B.sort(Wh);
                        for(let X = 0; X < 8; X++)X < k && B[X][1] ? (o[X][0] = B[X][0], o[X][1] = B[X][1]) : (o[X][0] = Number.MAX_SAFE_INTEGER, o[X][1] = 0);
                        o.sort(Gh);
                        const j = c.morphAttributes.position, F = c.morphAttributes.normal;
                        let H = 0;
                        for(let Y = 0; Y < 8; Y++){
                            const Z = o[Y], q = Z[0], J = Z[1];
                            q !== Number.MAX_SAFE_INTEGER && J ? (j && c.getAttribute("morphTarget" + Y) !== j[q] && c.setAttribute("morphTarget" + Y, j[q]), F && c.getAttribute("morphNormal" + Y) !== F[q] && c.setAttribute("morphNormal" + Y, F[q]), r[Y] = J, H += J) : (j && !0 === c.hasAttribute("morphTarget" + Y) && c.deleteAttribute("morphTarget" + Y), F && !0 === c.hasAttribute("morphNormal" + Y) && c.deleteAttribute("morphNormal" + Y), r[Y] = 0);
                        }
                        const V = c.morphTargetsRelative ? 1 : 1 - H;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", V), u.getUniforms().setValue(t1, "morphTargetInfluences", r);
                    }
                }
            };
        }
        function Yh(t1, e, n, i) {
            let r = new WeakMap;
            function a(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", a), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
            }
            return {
                update: function(s) {
                    const o = i.render.frame, l = s.geometry, c = e.get(s, l);
                    if (r.get(c) !== o && (e.update(c), r.set(c, o)), s.isInstancedMesh && (!1 === s.hasEventListener("dispose", a) && s.addEventListener("dispose", a), r.get(s) !== o && (n.update(s.instanceMatrix, t1.ARRAY_BUFFER), null !== s.instanceColor && n.update(s.instanceColor, t1.ARRAY_BUFFER), r.set(s, o))), s.isSkinnedMesh) {
                        const t1 = s.skeleton;
                        r.get(t1) !== o && (t1.update(), r.set(t1, o));
                    }
                    return c;
                },
                dispose: function() {
                    r = new WeakMap;
                }
            };
        }
        const Zh = new wl, qh = new Tl, Jh = new Cl, Kh = new ih, $h = [], td = [], ed = new Float32Array(16), nd = new Float32Array(9), id = new Float32Array(4);
        function rd(t1, e, n) {
            const i = t1[0];
            if (i <= 0 || i > 0) return t1;
            const r = e * n;
            let a = $h[r];
            if (void 0 === a && (a = new Float32Array(r), $h[r] = a), 0 !== e) {
                i.toArray(a, 0);
                for(let i = 1, r = 0; i !== e; ++i)r += n, t1[i].toArray(a, r);
            }
            return a;
        }
        function ad(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let n = 0, i = t1.length; n < i; n++)if (t1[n] !== e[n]) return !1;
            return !0;
        }
        function sd(t1, e) {
            for(let n = 0, i = e.length; n < i; n++)t1[n] = e[n];
        }
        function od(t1, e) {
            let n = td[e];
            void 0 === n && (n = new Int32Array(e), td[e] = n);
            for(let i = 0; i !== e; ++i)n[i] = t1.allocateTextureUnit();
            return n;
        }
        function ld(t1, e) {
            const n = this.cache;
            n[0] !== e && (t1.uniform1f(this.addr, e), n[0] = e);
        }
        function cd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t1.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
            else {
                if (ad(n, e)) return;
                t1.uniform2fv(this.addr, e), sd(n, e);
            }
        }
        function ud(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t1.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
            else if (void 0 !== e.r) n[0] === e.r && n[1] === e.g && n[2] === e.b || (t1.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);
            else {
                if (ad(n, e)) return;
                t1.uniform3fv(this.addr, e), sd(n, e);
            }
        }
        function hd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t1.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
            else {
                if (ad(n, e)) return;
                t1.uniform4fv(this.addr, e), sd(n, e);
            }
        }
        function dd(t1, e) {
            const n = this.cache, i = e.elements;
            if (void 0 === i) {
                if (ad(n, e)) return;
                t1.uniformMatrix2fv(this.addr, !1, e), sd(n, e);
            } else {
                if (ad(n, i)) return;
                id.set(i), t1.uniformMatrix2fv(this.addr, !1, id), sd(n, i);
            }
        }
        function pd(t1, e) {
            const n = this.cache, i = e.elements;
            if (void 0 === i) {
                if (ad(n, e)) return;
                t1.uniformMatrix3fv(this.addr, !1, e), sd(n, e);
            } else {
                if (ad(n, i)) return;
                nd.set(i), t1.uniformMatrix3fv(this.addr, !1, nd), sd(n, i);
            }
        }
        function fd(t1, e) {
            const n = this.cache, i = e.elements;
            if (void 0 === i) {
                if (ad(n, e)) return;
                t1.uniformMatrix4fv(this.addr, !1, e), sd(n, e);
            } else {
                if (ad(n, i)) return;
                ed.set(i), t1.uniformMatrix4fv(this.addr, !1, ed), sd(n, i);
            }
        }
        function md(t1, e) {
            const n = this.cache;
            n[0] !== e && (t1.uniform1i(this.addr, e), n[0] = e);
        }
        function gd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t1.uniform2i(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
            else {
                if (ad(n, e)) return;
                t1.uniform2iv(this.addr, e), sd(n, e);
            }
        }
        function Ad(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t1.uniform3i(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
            else {
                if (ad(n, e)) return;
                t1.uniform3iv(this.addr, e), sd(n, e);
            }
        }
        function vd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t1.uniform4i(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
            else {
                if (ad(n, e)) return;
                t1.uniform4iv(this.addr, e), sd(n, e);
            }
        }
        function yd(t1, e) {
            const n = this.cache;
            n[0] !== e && (t1.uniform1ui(this.addr, e), n[0] = e);
        }
        function Md(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t1.uniform2ui(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
            else {
                if (ad(n, e)) return;
                t1.uniform2uiv(this.addr, e), sd(n, e);
            }
        }
        function bd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t1.uniform3ui(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
            else {
                if (ad(n, e)) return;
                t1.uniform3uiv(this.addr, e), sd(n, e);
            }
        }
        function xd(t1, e) {
            const n = this.cache;
            if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t1.uniform4ui(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
            else {
                if (ad(n, e)) return;
                t1.uniform4uiv(this.addr, e), sd(n, e);
            }
        }
        function wd(t1, e, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(e || Zh, r);
        }
        function _d(t1, e, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || Jh, r);
        }
        function Ed(t1, e, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(e || Kh, r);
        }
        function Sd(t1, e, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || qh, r);
        }
        function Td(t1, e) {
            t1.uniform1fv(this.addr, e);
        }
        function Id(t1, e) {
            const n = rd(e, this.size, 2);
            t1.uniform2fv(this.addr, n);
        }
        function Cd(t1, e) {
            const n = rd(e, this.size, 3);
            t1.uniform3fv(this.addr, n);
        }
        function Nd(t1, e) {
            const n = rd(e, this.size, 4);
            t1.uniform4fv(this.addr, n);
        }
        function Dd(t1, e) {
            const n = rd(e, this.size, 4);
            t1.uniformMatrix2fv(this.addr, !1, n);
        }
        function Ld(t1, e) {
            const n = rd(e, this.size, 9);
            t1.uniformMatrix3fv(this.addr, !1, n);
        }
        function Od(t1, e) {
            const n = rd(e, this.size, 16);
            t1.uniformMatrix4fv(this.addr, !1, n);
        }
        function Rd(t1, e) {
            t1.uniform1iv(this.addr, e);
        }
        function Pd(t1, e) {
            t1.uniform2iv(this.addr, e);
        }
        function zd(t1, e) {
            t1.uniform3iv(this.addr, e);
        }
        function Ud(t1, e) {
            t1.uniform4iv(this.addr, e);
        }
        function kd(t1, e) {
            t1.uniform1uiv(this.addr, e);
        }
        function Bd(t1, e) {
            t1.uniform2uiv(this.addr, e);
        }
        function jd(t1, e) {
            t1.uniform3uiv(this.addr, e);
        }
        function Fd(t1, e) {
            t1.uniform4uiv(this.addr, e);
        }
        function Hd(t1, e, n) {
            const i = this.cache, r = e.length, a = od(n, r);
            ad(i, a) || (t1.uniform1iv(this.addr, a), sd(i, a));
            for(let t1 = 0; t1 !== r; ++t1)n.setTexture2D(e[t1] || Zh, a[t1]);
        }
        function Vd(t1, e, n) {
            const i = this.cache, r = e.length, a = od(n, r);
            ad(i, a) || (t1.uniform1iv(this.addr, a), sd(i, a));
            for(let t1 = 0; t1 !== r; ++t1)n.setTexture3D(e[t1] || Jh, a[t1]);
        }
        function Qd(t1, e, n) {
            const i = this.cache, r = e.length, a = od(n, r);
            ad(i, a) || (t1.uniform1iv(this.addr, a), sd(i, a));
            for(let t1 = 0; t1 !== r; ++t1)n.setTextureCube(e[t1] || Kh, a[t1]);
        }
        function Gd(t1, e, n) {
            const i = this.cache, r = e.length, a = od(n, r);
            ad(i, a) || (t1.uniform1iv(this.addr, a), sd(i, a));
            for(let t1 = 0; t1 !== r; ++t1)n.setTexture2DArray(e[t1] || qh, a[t1]);
        }
        class Wd {
            constructor(t1, e, n){
                this.id = t1, this.addr = n, this.cache = [], this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return ld;
                        case 35664:
                            return cd;
                        case 35665:
                            return ud;
                        case 35666:
                            return hd;
                        case 35674:
                            return dd;
                        case 35675:
                            return pd;
                        case 35676:
                            return fd;
                        case 5124:
                        case 35670:
                            return md;
                        case 35667:
                        case 35671:
                            return gd;
                        case 35668:
                        case 35672:
                            return Ad;
                        case 35669:
                        case 35673:
                            return vd;
                        case 5125:
                            return yd;
                        case 36294:
                            return Md;
                        case 36295:
                            return bd;
                        case 36296:
                            return xd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return wd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return _d;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Ed;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Sd;
                    }
                }(e.type);
            }
        }
        class Xd {
            constructor(t1, e, n){
                this.id = t1, this.addr = n, this.cache = [], this.size = e.size, this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return Td;
                        case 35664:
                            return Id;
                        case 35665:
                            return Cd;
                        case 35666:
                            return Nd;
                        case 35674:
                            return Dd;
                        case 35675:
                            return Ld;
                        case 35676:
                            return Od;
                        case 5124:
                        case 35670:
                            return Rd;
                        case 35667:
                        case 35671:
                            return Pd;
                        case 35668:
                        case 35672:
                            return zd;
                        case 35669:
                        case 35673:
                            return Ud;
                        case 5125:
                            return kd;
                        case 36294:
                            return Bd;
                        case 36295:
                            return jd;
                        case 36296:
                            return Fd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return Hd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return Vd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Qd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Gd;
                    }
                }(e.type);
            }
        }
        class Yd {
            constructor(t1){
                this.id = t1, this.seq = [], this.map = {};
            }
            setValue(t1, e, n) {
                const i = this.seq;
                for(let r = 0, a = i.length; r !== a; ++r){
                    const a = i[r];
                    a.setValue(t1, e[a.id], n);
                }
            }
        }
        const Zd = /(\w+)(\])?(\[|\.)?/g;
        function qd(t1, e) {
            t1.seq.push(e), t1.map[e.id] = e;
        }
        function Jd(t1, e, n) {
            const i = t1.name, r = i.length;
            for(Zd.lastIndex = 0;;){
                const a = Zd.exec(i), s = Zd.lastIndex;
                let o = a[1];
                const l = "]" === a[2], c = a[3];
                if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === r) {
                    qd(n, void 0 === c ? new Wd(o, t1, e) : new Xd(o, t1, e));
                    break;
                }
                {
                    let t1 = n.map[o];
                    void 0 === t1 && (t1 = new Yd(o), qd(n, t1)), n = t1;
                }
            }
        }
        class Kd {
            constructor(t1, e){
                this.seq = [], this.map = {};
                const n = t1.getProgramParameter(e, t1.ACTIVE_UNIFORMS);
                for(let i = 0; i < n; ++i){
                    const n = t1.getActiveUniform(e, i);
                    Jd(n, t1.getUniformLocation(e, n.name), this);
                }
            }
            setValue(t1, e, n, i) {
                const r = this.map[e];
                void 0 !== r && r.setValue(t1, n, i);
            }
            setOptional(t1, e, n) {
                const i = e[n];
                void 0 !== i && this.setValue(t1, n, i);
            }
            static upload(t1, e, n, i) {
                for(let r = 0, a = e.length; r !== a; ++r){
                    const a = e[r], s = n[a.id];
                    !1 !== s.needsUpdate && a.setValue(t1, s.value, i);
                }
            }
            static seqWithValue(t1, e) {
                const n = [];
                for(let i = 0, r = t1.length; i !== r; ++i){
                    const r = t1[i];
                    r.id in e && n.push(r);
                }
                return n;
            }
        }
        function $d(t1, e, n) {
            const i = t1.createShader(e);
            return t1.shaderSource(i, n), t1.compileShader(i), i;
        }
        const tp = 37297;
        let ep = 0;
        function np(t1, e, n) {
            const i = t1.getShaderParameter(e, t1.COMPILE_STATUS), r = t1.getShaderInfoLog(e).trim();
            if (i && "" === r) return "";
            const a = /ERROR: 0:(\d+)/.exec(r);
            if (a) {
                const i = parseInt(a[1]);
                return n.toUpperCase() + "\n\n" + r + "\n\n" + function(t1, e) {
                    const n = t1.split("\n"), i = [], r = Math.max(e - 6, 0), a = Math.min(e + 6, n.length);
                    for(let t1 = r; t1 < a; t1++){
                        const r = t1 + 1;
                        i.push(`${r === e ? ">" : " "} ${r}: ${n[t1]}`);
                    }
                    return i.join("\n");
                }(t1.getShaderSource(e), i);
            }
            return r;
        }
        function ip(t1, e) {
            const n = function(t1) {
                const e = fl.getPrimaries(fl.workingColorSpace), n = fl.getPrimaries(t1);
                let i;
                switch(e === n ? i = "" : e === $s && n === Ks ? i = "LinearDisplayP3ToLinearSRGB" : e === Ks && n === $s && (i = "LinearSRGBToLinearDisplayP3"), t1){
                    case Xs:
                    case Zs:
                        return [
                            i,
                            "LinearTransferOETF"
                        ];
                    case Ws:
                    case Ys:
                        return [
                            i,
                            "sRGBTransferOETF"
                        ];
                    default:
                        return console.warn("THREE.WebGLProgram: Unsupported color space:", t1), [
                            i,
                            "LinearTransferOETF"
                        ];
                }
            }(e);
            return `vec4 ${t1}( vec4 value ) { return ${n[0]}( ${n[1]}( value ) ); }`;
        }
        function rp(t1, e) {
            let n;
            switch(e){
                case $r:
                    n = "Linear";
                    break;
                case ta:
                    n = "Reinhard";
                    break;
                case ea:
                    n = "OptimizedCineon";
                    break;
                case na:
                    n = "ACESFilmic";
                    break;
                case ia:
                    n = "Custom";
                    break;
                default:
                    console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
            }
            return "vec3 " + t1 + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
        }
        function ap(t1) {
            return "" !== t1;
        }
        function sp(t1, e) {
            const n = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
            return t1.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
        }
        function op(t1, e) {
            return t1.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
        }
        const lp = /^[ \t]*#include +<([\w\d./]+)>/gm;
        function cp(t1) {
            return t1.replace(lp, hp);
        }
        const up = new Map([
            [
                "encodings_fragment",
                "colorspace_fragment"
            ],
            [
                "encodings_pars_fragment",
                "colorspace_pars_fragment"
            ],
            [
                "output_fragment",
                "opaque_fragment"
            ]
        ]);
        function hp(t1, e) {
            let n = mh[e];
            if (void 0 === n) {
                const t1 = up.get(e);
                if (void 0 === t1) throw new Error("Can not resolve #include <" + e + ">");
                n = mh[t1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, t1);
            }
            return cp(n);
        }
        const dp = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
        function pp(t1) {
            return t1.replace(dp, fp);
        }
        function fp(t1, e, n, i) {
            let r = "";
            for(let t1 = parseInt(e); t1 < parseInt(n); t1++)r += i.replace(/\[\s*i\s*\]/g, "[ " + t1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, t1);
            return r;
        }
        function mp(t1) {
            let e = "precision " + t1.precision + " float;\nprecision " + t1.precision + " int;";
            return "highp" === t1.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t1.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t1.precision && (e += "\n#define LOW_PRECISION"), e;
        }
        function gp(t1, e, n, i) {
            const r = t1.getContext(), a = n.defines;
            let s = n.vertexShader, o = n.fragmentShader;
            const l = function(t1) {
                let e = "SHADOWMAP_TYPE_BASIC";
                return t1.shadowMapType === lr ? e = "SHADOWMAP_TYPE_PCF" : t1.shadowMapType === cr ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t1.shadowMapType === ur && (e = "SHADOWMAP_TYPE_VSM"), e;
            }(n), c = function(t1) {
                let e = "ENVMAP_TYPE_CUBE";
                if (t1.envMap) switch(t1.envMapMode){
                    case oa:
                    case la:
                        e = "ENVMAP_TYPE_CUBE";
                        break;
                    case ha:
                        e = "ENVMAP_TYPE_CUBE_UV";
                }
                return e;
            }(n), u = function(t1) {
                let e = "ENVMAP_MODE_REFLECTION";
                return t1.envMap && t1.envMapMode === la && (e = "ENVMAP_MODE_REFRACTION"), e;
            }(n), h = function(t1) {
                let e = "ENVMAP_BLENDING_NONE";
                if (t1.envMap) switch(t1.combine){
                    case Zr:
                        e = "ENVMAP_BLENDING_MULTIPLY";
                        break;
                    case qr:
                        e = "ENVMAP_BLENDING_MIX";
                        break;
                    case Jr:
                        e = "ENVMAP_BLENDING_ADD";
                }
                return e;
            }(n), d = function(t1) {
                const e = t1.envMapCubeUVHeight;
                if (null === e) return null;
                const n = Math.log2(e) - 2, i = 1 / e;
                return {
                    texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
                    texelHeight: i,
                    maxMip: n
                };
            }(n), p = n.isWebGL2 ? "" : function(t1) {
                return [
                    t1.extensionDerivatives || t1.envMapCubeUVHeight || t1.bumpMap || t1.normalMapTangentSpace || t1.clearcoatNormalMap || t1.flatShading || "physical" === t1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
                    (t1.extensionFragDepth || t1.logarithmicDepthBuffer) && t1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
                    t1.extensionDrawBuffers && t1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
                    (t1.extensionShaderTextureLOD || t1.envMap || t1.transmission) && t1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
                ].filter(ap).join("\n");
            }(n), f = function(t1) {
                const e = [];
                for(const n in t1){
                    const i = t1[n];
                    !1 !== i && e.push("#define " + n + " " + i);
                }
                return e.join("\n");
            }(a), m = r.createProgram();
            let g, A, v = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
            n.isRawShaderMaterial ? (g = [
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(ap).join("\n"), g.length > 0 && (g += "\n"), A = [
                p,
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(ap).join("\n"), A.length > 0 && (A += "\n")) : (g = [
                mp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.instancing ? "#define USE_INSTANCING" : "",
                n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + u : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.mapUv ? "#define MAP_UV " + n.mapUv : "",
                n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
                n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
                n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
                n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
                n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
                n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
                n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
                n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
                n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
                n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
                n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
                n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
                n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
                n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
                n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
                n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
                n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
                n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
                n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
                n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
                n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
                n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.skinning ? "#define USE_SKINNING" : "",
                n.morphTargets ? "#define USE_MORPHTARGETS" : "",
                n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "",
                n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 modelMatrix;",
                "uniform mat4 modelViewMatrix;",
                "uniform mat4 projectionMatrix;",
                "uniform mat4 viewMatrix;",
                "uniform mat3 normalMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                "#ifdef USE_INSTANCING",
                "	attribute mat4 instanceMatrix;",
                "#endif",
                "#ifdef USE_INSTANCING_COLOR",
                "	attribute vec3 instanceColor;",
                "#endif",
                "attribute vec3 position;",
                "attribute vec3 normal;",
                "attribute vec2 uv;",
                "#ifdef USE_UV1",
                "	attribute vec2 uv1;",
                "#endif",
                "#ifdef USE_UV2",
                "	attribute vec2 uv2;",
                "#endif",
                "#ifdef USE_UV3",
                "	attribute vec2 uv3;",
                "#endif",
                "#ifdef USE_TANGENT",
                "	attribute vec4 tangent;",
                "#endif",
                "#if defined( USE_COLOR_ALPHA )",
                "	attribute vec4 color;",
                "#elif defined( USE_COLOR )",
                "	attribute vec3 color;",
                "#endif",
                "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
                "	attribute vec3 morphTarget0;",
                "	attribute vec3 morphTarget1;",
                "	attribute vec3 morphTarget2;",
                "	attribute vec3 morphTarget3;",
                "	#ifdef USE_MORPHNORMALS",
                "		attribute vec3 morphNormal0;",
                "		attribute vec3 morphNormal1;",
                "		attribute vec3 morphNormal2;",
                "		attribute vec3 morphNormal3;",
                "	#else",
                "		attribute vec3 morphTarget4;",
                "		attribute vec3 morphTarget5;",
                "		attribute vec3 morphTarget6;",
                "		attribute vec3 morphTarget7;",
                "	#endif",
                "#endif",
                "#ifdef USE_SKINNING",
                "	attribute vec4 skinIndex;",
                "	attribute vec4 skinWeight;",
                "#endif",
                "\n"
            ].filter(ap).join("\n"), A = [
                p,
                mp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.matcap ? "#define USE_MATCAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + c : "",
                n.envMap ? "#define " + u : "",
                n.envMap ? "#define " + h : "",
                d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
                d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
                d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoat ? "#define USE_CLEARCOAT" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescence ? "#define USE_IRIDESCENCE" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaTest ? "#define USE_ALPHATEST" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.sheen ? "#define USE_SHEEN" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.gradientMap ? "#define USE_GRADIENTMAP" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 viewMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                n.toneMapping !== Kr ? "#define TONE_MAPPING" : "",
                n.toneMapping !== Kr ? mh.tonemapping_pars_fragment : "",
                n.toneMapping !== Kr ? rp("toneMapping", n.toneMapping) : "",
                n.dithering ? "#define DITHERING" : "",
                n.opaque ? "#define OPAQUE" : "",
                mh.colorspace_pars_fragment,
                ip("linearToOutputTexel", n.outputColorSpace),
                n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
                "\n"
            ].filter(ap).join("\n")), s = cp(s), s = sp(s, n), s = op(s, n), o = cp(o), o = sp(o, n), o = op(o, n), s = pp(s), o = pp(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (v = "#version 300 es\n", g = [
                "precision mediump sampler2DArray;",
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") + "\n" + g, A = [
                "precision mediump sampler2DArray;",
                "#define varying in",
                n.glslVersion === Po ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                n.glslVersion === Po ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") + "\n" + A);
            const y = v + g + s, M = v + A + o, b = $d(r, r.VERTEX_SHADER, y), x = $d(r, r.FRAGMENT_SHADER, M);
            function w(e) {
                if (t1.debug.checkShaderErrors) {
                    const n = r.getProgramInfoLog(m).trim(), i = r.getShaderInfoLog(b).trim(), a = r.getShaderInfoLog(x).trim();
                    let s = !0, o = !0;
                    if (!1 === r.getProgramParameter(m, r.LINK_STATUS)) {
                        if (s = !1, "function" == typeof t1.debug.onShaderError) t1.debug.onShaderError(r, m, b, x);
                        else {
                            const t1 = np(r, b, "vertex"), e = np(r, x, "fragment");
                            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(m, r.VALIDATE_STATUS) + "\n\nProgram Info Log: " + n + "\n" + t1 + "\n" + e);
                        }
                    } else "" !== n ? console.warn("THREE.WebGLProgram: Program Info Log:", n) : "" !== i && "" !== a || (o = !1);
                    o && (e.diagnostics = {
                        runnable: s,
                        programLog: n,
                        vertexShader: {
                            log: i,
                            prefix: g
                        },
                        fragmentShader: {
                            log: a,
                            prefix: A
                        }
                    });
                }
                r.deleteShader(b), r.deleteShader(x), _ = new Kd(r, m), E = function(t1, e) {
                    const n = {}, i = t1.getProgramParameter(e, t1.ACTIVE_ATTRIBUTES);
                    for(let r = 0; r < i; r++){
                        const i = t1.getActiveAttrib(e, r), a = i.name;
                        let s = 1;
                        i.type === t1.FLOAT_MAT2 && (s = 2), i.type === t1.FLOAT_MAT3 && (s = 3), i.type === t1.FLOAT_MAT4 && (s = 4), n[a] = {
                            type: i.type,
                            location: t1.getAttribLocation(e, a),
                            locationSize: s
                        };
                    }
                    return n;
                }(r, m);
            }
            let _, E;
            r.attachShader(m, b), r.attachShader(m, x), void 0 !== n.index0AttributeName ? r.bindAttribLocation(m, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(m, 0, "position"), r.linkProgram(m), this.getUniforms = function() {
                return void 0 === _ && w(this), _;
            }, this.getAttributes = function() {
                return void 0 === E && w(this), E;
            };
            let S = !1 === n.rendererExtensionParallelShaderCompile;
            return this.isReady = function() {
                return !1 === S && (S = r.getProgramParameter(m, tp)), S;
            }, this.destroy = function() {
                i.releaseStatesOfProgram(this), r.deleteProgram(m), this.program = void 0;
            }, this.type = n.shaderType, this.name = n.shaderName, this.id = ep++, this.cacheKey = e, this.usedTimes = 1, this.program = m, this.vertexShader = b, this.fragmentShader = x, this;
        }
        let Ap = 0;
        class vp {
            constructor(){
                this.shaderCache = new Map, this.materialCache = new Map;
            }
            update(t1) {
                const e = t1.vertexShader, n = t1.fragmentShader, i = this._getShaderStage(e), r = this._getShaderStage(n), a = this._getShaderCacheForMaterial(t1);
                return !1 === a.has(i) && (a.add(i), i.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
            }
            remove(t1) {
                const e = this.materialCache.get(t1);
                for (const t1 of e)t1.usedTimes--, 0 === t1.usedTimes && this.shaderCache.delete(t1.code);
                return this.materialCache.delete(t1), this;
            }
            getVertexShaderID(t1) {
                return this._getShaderStage(t1.vertexShader).id;
            }
            getFragmentShaderID(t1) {
                return this._getShaderStage(t1.fragmentShader).id;
            }
            dispose() {
                this.shaderCache.clear(), this.materialCache.clear();
            }
            _getShaderCacheForMaterial(t1) {
                const e = this.materialCache;
                let n = e.get(t1);
                return void 0 === n && (n = new Set, e.set(t1, n)), n;
            }
            _getShaderStage(t1) {
                const e = this.shaderCache;
                let n = e.get(t1);
                return void 0 === n && (n = new yp(t1), e.set(t1, n)), n;
            }
        }
        class yp {
            constructor(t1){
                this.id = Ap++, this.code = t1, this.usedTimes = 0;
            }
        }
        function Mp(t1, e, n, i, r, a, s) {
            const o = new Mc, l = new vp, c = [], u = r.isWebGL2, h = r.logarithmicDepthBuffer, d = r.vertexTextures;
            let p = r.precision;
            const f = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "toon",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                MeshMatcapMaterial: "matcap",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
            };
            function m(t1) {
                return 0 === t1 ? "uv" : `uv${t1}`;
            }
            return {
                getParameters: function(a, o, c, g, A) {
                    const v = g.fog, y = A.geometry, M = a.isMeshStandardMaterial ? g.environment : null, b = (a.isMeshStandardMaterial ? n : e).get(a.envMap || M), x = b && b.mapping === ha ? b.image.height : null, w = f[a.type];
                    null !== a.precision && (p = r.getMaxPrecision(a.precision), p !== a.precision && console.warn("THREE.WebGLProgram.getParameters:", a.precision, "not supported, using", p, "instead."));
                    const _ = y.morphAttributes.position || y.morphAttributes.normal || y.morphAttributes.color, E = void 0 !== _ ? _.length : 0;
                    let S, T, I, C, N = 0;
                    if (void 0 !== y.morphAttributes.position && (N = 1), void 0 !== y.morphAttributes.normal && (N = 2), void 0 !== y.morphAttributes.color && (N = 3), w) {
                        const t1 = Ah[w];
                        S = t1.vertexShader, T = t1.fragmentShader;
                    } else S = a.vertexShader, T = a.fragmentShader, l.update(a), I = l.getVertexShaderID(a), C = l.getFragmentShaderID(a);
                    const D = t1.getRenderTarget(), L = !0 === A.isInstancedMesh, O = !!a.map, R = !!a.matcap, P = !!b, z = !!a.aoMap, U = !!a.lightMap, k = !!a.bumpMap, B = !!a.normalMap, j = !!a.displacementMap, F = !!a.emissiveMap, H = !!a.metalnessMap, V = !!a.roughnessMap, Q = a.anisotropy > 0, G = a.clearcoat > 0, W = a.iridescence > 0, X = a.sheen > 0, Y = a.transmission > 0, Z = Q && !!a.anisotropyMap, q = G && !!a.clearcoatMap, J = G && !!a.clearcoatNormalMap, K = G && !!a.clearcoatRoughnessMap, $ = W && !!a.iridescenceMap, tt = W && !!a.iridescenceThicknessMap, et = X && !!a.sheenColorMap, nt = X && !!a.sheenRoughnessMap, it = !!a.specularMap, rt = !!a.specularColorMap, at = !!a.specularIntensityMap, st = Y && !!a.transmissionMap, ot = Y && !!a.thicknessMap, lt = !!a.gradientMap, ct = !!a.alphaMap, ut = a.alphaTest > 0, ht = !!a.alphaHash, dt = !!a.extensions, pt = !!y.attributes.uv1, ft = !!y.attributes.uv2, mt = !!y.attributes.uv3;
                    let gt = Kr;
                    return a.toneMapped && (null !== D && !0 !== D.isXRRenderTarget || (gt = t1.toneMapping)), {
                        isWebGL2: u,
                        shaderID: w,
                        shaderType: a.type,
                        shaderName: a.name,
                        vertexShader: S,
                        fragmentShader: T,
                        defines: a.defines,
                        customVertexShaderID: I,
                        customFragmentShaderID: C,
                        isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                        glslVersion: a.glslVersion,
                        precision: p,
                        instancing: L,
                        instancingColor: L && null !== A.instanceColor,
                        supportsVertexTextures: d,
                        outputColorSpace: null === D ? t1.outputColorSpace : !0 === D.isXRRenderTarget ? D.texture.colorSpace : Xs,
                        map: O,
                        matcap: R,
                        envMap: P,
                        envMapMode: P && b.mapping,
                        envMapCubeUVHeight: x,
                        aoMap: z,
                        lightMap: U,
                        bumpMap: k,
                        normalMap: B,
                        displacementMap: d && j,
                        emissiveMap: F,
                        normalMapObjectSpace: B && a.normalMapType === Qs,
                        normalMapTangentSpace: B && a.normalMapType === Vs,
                        metalnessMap: H,
                        roughnessMap: V,
                        anisotropy: Q,
                        anisotropyMap: Z,
                        clearcoat: G,
                        clearcoatMap: q,
                        clearcoatNormalMap: J,
                        clearcoatRoughnessMap: K,
                        iridescence: W,
                        iridescenceMap: $,
                        iridescenceThicknessMap: tt,
                        sheen: X,
                        sheenColorMap: et,
                        sheenRoughnessMap: nt,
                        specularMap: it,
                        specularColorMap: rt,
                        specularIntensityMap: at,
                        transmission: Y,
                        transmissionMap: st,
                        thicknessMap: ot,
                        gradientMap: lt,
                        opaque: !1 === a.transparent && a.blending === gr,
                        alphaMap: ct,
                        alphaTest: ut,
                        alphaHash: ht,
                        combine: a.combine,
                        mapUv: O && m(a.map.channel),
                        aoMapUv: z && m(a.aoMap.channel),
                        lightMapUv: U && m(a.lightMap.channel),
                        bumpMapUv: k && m(a.bumpMap.channel),
                        normalMapUv: B && m(a.normalMap.channel),
                        displacementMapUv: j && m(a.displacementMap.channel),
                        emissiveMapUv: F && m(a.emissiveMap.channel),
                        metalnessMapUv: H && m(a.metalnessMap.channel),
                        roughnessMapUv: V && m(a.roughnessMap.channel),
                        anisotropyMapUv: Z && m(a.anisotropyMap.channel),
                        clearcoatMapUv: q && m(a.clearcoatMap.channel),
                        clearcoatNormalMapUv: J && m(a.clearcoatNormalMap.channel),
                        clearcoatRoughnessMapUv: K && m(a.clearcoatRoughnessMap.channel),
                        iridescenceMapUv: $ && m(a.iridescenceMap.channel),
                        iridescenceThicknessMapUv: tt && m(a.iridescenceThicknessMap.channel),
                        sheenColorMapUv: et && m(a.sheenColorMap.channel),
                        sheenRoughnessMapUv: nt && m(a.sheenRoughnessMap.channel),
                        specularMapUv: it && m(a.specularMap.channel),
                        specularColorMapUv: rt && m(a.specularColorMap.channel),
                        specularIntensityMapUv: at && m(a.specularIntensityMap.channel),
                        transmissionMapUv: st && m(a.transmissionMap.channel),
                        thicknessMapUv: ot && m(a.thicknessMap.channel),
                        alphaMapUv: ct && m(a.alphaMap.channel),
                        vertexTangents: !!y.attributes.tangent && (B || Q),
                        vertexColors: a.vertexColors,
                        vertexAlphas: !0 === a.vertexColors && !!y.attributes.color && 4 === y.attributes.color.itemSize,
                        vertexUv1s: pt,
                        vertexUv2s: ft,
                        vertexUv3s: mt,
                        pointsUvs: !0 === A.isPoints && !!y.attributes.uv && (O || ct),
                        fog: !!v,
                        useFog: !0 === a.fog,
                        fogExp2: v && v.isFogExp2,
                        flatShading: !0 === a.flatShading,
                        sizeAttenuation: !0 === a.sizeAttenuation,
                        logarithmicDepthBuffer: h,
                        skinning: !0 === A.isSkinnedMesh,
                        morphTargets: void 0 !== y.morphAttributes.position,
                        morphNormals: void 0 !== y.morphAttributes.normal,
                        morphColors: void 0 !== y.morphAttributes.color,
                        morphTargetsCount: E,
                        morphTextureStride: N,
                        numDirLights: o.directional.length,
                        numPointLights: o.point.length,
                        numSpotLights: o.spot.length,
                        numSpotLightMaps: o.spotLightMap.length,
                        numRectAreaLights: o.rectArea.length,
                        numHemiLights: o.hemi.length,
                        numDirLightShadows: o.directionalShadowMap.length,
                        numPointLightShadows: o.pointShadowMap.length,
                        numSpotLightShadows: o.spotShadowMap.length,
                        numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
                        numLightProbes: o.numLightProbes,
                        numClippingPlanes: s.numPlanes,
                        numClipIntersection: s.numIntersection,
                        dithering: a.dithering,
                        shadowMapEnabled: t1.shadowMap.enabled && c.length > 0,
                        shadowMapType: t1.shadowMap.type,
                        toneMapping: gt,
                        useLegacyLights: t1._useLegacyLights,
                        decodeVideoTexture: O && !0 === a.map.isVideoTexture && fl.getTransfer(a.map.colorSpace) === Js,
                        premultipliedAlpha: a.premultipliedAlpha,
                        doubleSided: a.side === pr,
                        flipSided: a.side === dr,
                        useDepthPacking: a.depthPacking >= 0,
                        depthPacking: a.depthPacking || 0,
                        index0AttributeName: a.index0AttributeName,
                        extensionDerivatives: dt && !0 === a.extensions.derivatives,
                        extensionFragDepth: dt && !0 === a.extensions.fragDepth,
                        extensionDrawBuffers: dt && !0 === a.extensions.drawBuffers,
                        extensionShaderTextureLOD: dt && !0 === a.extensions.shaderTextureLOD,
                        rendererExtensionFragDepth: u || i.has("EXT_frag_depth"),
                        rendererExtensionDrawBuffers: u || i.has("WEBGL_draw_buffers"),
                        rendererExtensionShaderTextureLod: u || i.has("EXT_shader_texture_lod"),
                        rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                        customProgramCacheKey: a.customProgramCacheKey()
                    };
                },
                getProgramCacheKey: function(e) {
                    const n = [];
                    if (e.shaderID ? n.push(e.shaderID) : (n.push(e.customVertexShaderID), n.push(e.customFragmentShaderID)), void 0 !== e.defines) for(const t1 in e.defines)n.push(t1), n.push(e.defines[t1]);
                    return !1 === e.isRawShaderMaterial && (function(t1, e) {
                        t1.push(e.precision), t1.push(e.outputColorSpace), t1.push(e.envMapMode), t1.push(e.envMapCubeUVHeight), t1.push(e.mapUv), t1.push(e.alphaMapUv), t1.push(e.lightMapUv), t1.push(e.aoMapUv), t1.push(e.bumpMapUv), t1.push(e.normalMapUv), t1.push(e.displacementMapUv), t1.push(e.emissiveMapUv), t1.push(e.metalnessMapUv), t1.push(e.roughnessMapUv), t1.push(e.anisotropyMapUv), t1.push(e.clearcoatMapUv), t1.push(e.clearcoatNormalMapUv), t1.push(e.clearcoatRoughnessMapUv), t1.push(e.iridescenceMapUv), t1.push(e.iridescenceThicknessMapUv), t1.push(e.sheenColorMapUv), t1.push(e.sheenRoughnessMapUv), t1.push(e.specularMapUv), t1.push(e.specularColorMapUv), t1.push(e.specularIntensityMapUv), t1.push(e.transmissionMapUv), t1.push(e.thicknessMapUv), t1.push(e.combine), t1.push(e.fogExp2), t1.push(e.sizeAttenuation), t1.push(e.morphTargetsCount), t1.push(e.morphAttributeCount), t1.push(e.numDirLights), t1.push(e.numPointLights), t1.push(e.numSpotLights), t1.push(e.numSpotLightMaps), t1.push(e.numHemiLights), t1.push(e.numRectAreaLights), t1.push(e.numDirLightShadows), t1.push(e.numPointLightShadows), t1.push(e.numSpotLightShadows), t1.push(e.numSpotLightShadowsWithMaps), t1.push(e.numLightProbes), t1.push(e.shadowMapType), t1.push(e.toneMapping), t1.push(e.numClippingPlanes), t1.push(e.numClipIntersection), t1.push(e.depthPacking);
                    }(n, e), function(t1, e) {
                        o.disableAll(), e.isWebGL2 && o.enable(0), e.supportsVertexTextures && o.enable(1), e.instancing && o.enable(2), e.instancingColor && o.enable(3), e.matcap && o.enable(4), e.envMap && o.enable(5), e.normalMapObjectSpace && o.enable(6), e.normalMapTangentSpace && o.enable(7), e.clearcoat && o.enable(8), e.iridescence && o.enable(9), e.alphaTest && o.enable(10), e.vertexColors && o.enable(11), e.vertexAlphas && o.enable(12), e.vertexUv1s && o.enable(13), e.vertexUv2s && o.enable(14), e.vertexUv3s && o.enable(15), e.vertexTangents && o.enable(16), e.anisotropy && o.enable(17), e.alphaHash && o.enable(18), t1.push(o.mask), o.disableAll(), e.fog && o.enable(0), e.useFog && o.enable(1), e.flatShading && o.enable(2), e.logarithmicDepthBuffer && o.enable(3), e.skinning && o.enable(4), e.morphTargets && o.enable(5), e.morphNormals && o.enable(6), e.morphColors && o.enable(7), e.premultipliedAlpha && o.enable(8), e.shadowMapEnabled && o.enable(9), e.useLegacyLights && o.enable(10), e.doubleSided && o.enable(11), e.flipSided && o.enable(12), e.useDepthPacking && o.enable(13), e.dithering && o.enable(14), e.transmission && o.enable(15), e.sheen && o.enable(16), e.opaque && o.enable(17), e.pointsUvs && o.enable(18), e.decodeVideoTexture && o.enable(19), t1.push(o.mask);
                    }(n, e), n.push(t1.outputColorSpace)), n.push(e.customProgramCacheKey), n.join();
                },
                getUniforms: function(t1) {
                    const e = f[t1.type];
                    let n;
                    if (e) {
                        const t1 = Ah[e];
                        n = Ju.clone(t1.uniforms);
                    } else n = t1.uniforms;
                    return n;
                },
                acquireProgram: function(e, n) {
                    let i;
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        if (e.cacheKey === n) {
                            i = e, ++i.usedTimes;
                            break;
                        }
                    }
                    return void 0 === i && (i = new gp(t1, n, e, a), c.push(i)), i;
                },
                releaseProgram: function(t1) {
                    if (0 == --t1.usedTimes) {
                        const e = c.indexOf(t1);
                        c[e] = c[c.length - 1], c.pop(), t1.destroy();
                    }
                },
                releaseShaderCache: function(t1) {
                    l.remove(t1);
                },
                programs: c,
                dispose: function() {
                    l.dispose();
                }
            };
        }
        function bp() {
            let t1 = new WeakMap;
            return {
                get: function(e) {
                    let n = t1.get(e);
                    return void 0 === n && (n = {}, t1.set(e, n)), n;
                },
                remove: function(e) {
                    t1.delete(e);
                },
                update: function(e, n, i) {
                    t1.get(e)[n] = i;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function xp(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.material.id !== e.material.id ? t1.material.id - e.material.id : t1.z !== e.z ? t1.z - e.z : t1.id - e.id;
        }
        function wp(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.z !== e.z ? e.z - t1.z : t1.id - e.id;
        }
        function _p() {
            const t1 = [];
            let e = 0;
            const n = [], i = [], r = [];
            function a(n, i, r, a, s, o) {
                let l = t1[e];
                return void 0 === l ? (l = {
                    id: n.id,
                    object: n,
                    geometry: i,
                    material: r,
                    groupOrder: a,
                    renderOrder: n.renderOrder,
                    z: s,
                    group: o
                }, t1[e] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = s, l.group = o), e++, l;
            }
            return {
                opaque: n,
                transmissive: i,
                transparent: r,
                init: function() {
                    e = 0, n.length = 0, i.length = 0, r.length = 0;
                },
                push: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? i.push(u) : !0 === s.transparent ? r.push(u) : n.push(u);
                },
                unshift: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? i.unshift(u) : !0 === s.transparent ? r.unshift(u) : n.unshift(u);
                },
                finish: function() {
                    for(let n = e, i = t1.length; n < i; n++){
                        const e = t1[n];
                        if (null === e.id) break;
                        e.id = null, e.object = null, e.geometry = null, e.material = null, e.group = null;
                    }
                },
                sort: function(t1, e) {
                    n.length > 1 && n.sort(t1 || xp), i.length > 1 && i.sort(e || wp), r.length > 1 && r.sort(e || wp);
                }
            };
        }
        function Ep() {
            let t1 = new WeakMap;
            return {
                get: function(e, n) {
                    const i = t1.get(e);
                    let r;
                    return void 0 === i ? (r = new _p, t1.set(e, [
                        r
                    ])) : n >= i.length ? (r = new _p, i.push(r)) : r = i[n], r;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function Sp() {
            const t1 = {};
            return {
                get: function(e) {
                    if (void 0 !== t1[e.id]) return t1[e.id];
                    let n;
                    switch(e.type){
                        case "DirectionalLight":
                            n = {
                                direction: new Ol,
                                color: new Jc
                            };
                            break;
                        case "SpotLight":
                            n = {
                                position: new Ol,
                                direction: new Ol,
                                color: new Jc,
                                distance: 0,
                                coneCos: 0,
                                penumbraCos: 0,
                                decay: 0
                            };
                            break;
                        case "PointLight":
                            n = {
                                position: new Ol,
                                color: new Jc,
                                distance: 0,
                                decay: 0
                            };
                            break;
                        case "HemisphereLight":
                            n = {
                                direction: new Ol,
                                skyColor: new Jc,
                                groundColor: new Jc
                            };
                            break;
                        case "RectAreaLight":
                            n = {
                                color: new Jc,
                                position: new Ol,
                                halfWidth: new Ol,
                                halfHeight: new Ol
                            };
                    }
                    return t1[e.id] = n, n;
                }
            };
        }
        let Tp = 0;
        function Ip(t1, e) {
            return (e.castShadow ? 2 : 0) - (t1.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t1.map ? 1 : 0);
        }
        function Cp(t1, e) {
            const n = new Sp, i = function() {
                const t1 = {};
                return {
                    get: function(e) {
                        if (void 0 !== t1[e.id]) return t1[e.id];
                        let n;
                        switch(e.type){
                            case "DirectionalLight":
                            case "SpotLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new tl
                                };
                                break;
                            case "PointLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new tl,
                                    shadowCameraNear: 1,
                                    shadowCameraFar: 1e3
                                };
                        }
                        return t1[e.id] = n, n;
                    }
                };
            }(), r = {
                version: 0,
                hash: {
                    directionalLength: -1,
                    pointLength: -1,
                    spotLength: -1,
                    rectAreaLength: -1,
                    hemiLength: -1,
                    numDirectionalShadows: -1,
                    numPointShadows: -1,
                    numSpotShadows: -1,
                    numSpotMaps: -1,
                    numLightProbes: -1
                },
                ambient: [
                    0,
                    0,
                    0
                ],
                probe: [],
                directional: [],
                directionalShadow: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotLightMap: [],
                spotShadow: [],
                spotShadowMap: [],
                spotLightMatrix: [],
                rectArea: [],
                rectAreaLTC1: null,
                rectAreaLTC2: null,
                point: [],
                pointShadow: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: [],
                numSpotLightShadowsWithMaps: 0,
                numLightProbes: 0
            };
            for(let t1 = 0; t1 < 9; t1++)r.probe.push(new Ol);
            const a = new Ol, s = new cc, o = new cc;
            return {
                setup: function(a, s) {
                    let o = 0, l = 0, c = 0;
                    for(let t1 = 0; t1 < 9; t1++)r.probe[t1].set(0, 0, 0);
                    let u = 0, h = 0, d = 0, p = 0, f = 0, m = 0, g = 0, A = 0, v = 0, y = 0, M = 0;
                    a.sort(Ip);
                    const b = !0 === s ? Math.PI : 1;
                    for(let t1 = 0, e = a.length; t1 < e; t1++){
                        const e = a[t1], s = e.color, x = e.intensity, w = e.distance, _ = e.shadow && e.shadow.map ? e.shadow.map.texture : null;
                        if (e.isAmbientLight) o += s.r * x * b, l += s.g * x * b, c += s.b * x * b;
                        else if (e.isLightProbe) {
                            for(let t1 = 0; t1 < 9; t1++)r.probe[t1].addScaledVector(e.sh.coefficients[t1], x);
                            M++;
                        } else if (e.isDirectionalLight) {
                            const t1 = n.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * b), e.castShadow) {
                                const t1 = e.shadow, n = i.get(e);
                                n.shadowBias = t1.bias, n.shadowNormalBias = t1.normalBias, n.shadowRadius = t1.radius, n.shadowMapSize = t1.mapSize, r.directionalShadow[u] = n, r.directionalShadowMap[u] = _, r.directionalShadowMatrix[u] = e.shadow.matrix, m++;
                            }
                            r.directional[u] = t1, u++;
                        } else if (e.isSpotLight) {
                            const t1 = n.get(e);
                            t1.position.setFromMatrixPosition(e.matrixWorld), t1.color.copy(s).multiplyScalar(x * b), t1.distance = w, t1.coneCos = Math.cos(e.angle), t1.penumbraCos = Math.cos(e.angle * (1 - e.penumbra)), t1.decay = e.decay, r.spot[d] = t1;
                            const a = e.shadow;
                            if (e.map && (r.spotLightMap[v] = e.map, v++, a.updateMatrices(e), e.castShadow && y++), r.spotLightMatrix[d] = a.matrix, e.castShadow) {
                                const t1 = i.get(e);
                                t1.shadowBias = a.bias, t1.shadowNormalBias = a.normalBias, t1.shadowRadius = a.radius, t1.shadowMapSize = a.mapSize, r.spotShadow[d] = t1, r.spotShadowMap[d] = _, A++;
                            }
                            d++;
                        } else if (e.isRectAreaLight) {
                            const t1 = n.get(e);
                            t1.color.copy(s).multiplyScalar(x), t1.halfWidth.set(.5 * e.width, 0, 0), t1.halfHeight.set(0, .5 * e.height, 0), r.rectArea[p] = t1, p++;
                        } else if (e.isPointLight) {
                            const t1 = n.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * b), t1.distance = e.distance, t1.decay = e.decay, e.castShadow) {
                                const t1 = e.shadow, n = i.get(e);
                                n.shadowBias = t1.bias, n.shadowNormalBias = t1.normalBias, n.shadowRadius = t1.radius, n.shadowMapSize = t1.mapSize, n.shadowCameraNear = t1.camera.near, n.shadowCameraFar = t1.camera.far, r.pointShadow[h] = n, r.pointShadowMap[h] = _, r.pointShadowMatrix[h] = e.shadow.matrix, g++;
                            }
                            r.point[h] = t1, h++;
                        } else if (e.isHemisphereLight) {
                            const t1 = n.get(e);
                            t1.skyColor.copy(e.color).multiplyScalar(x * b), t1.groundColor.copy(e.groundColor).multiplyScalar(x * b), r.hemi[f] = t1, f++;
                        }
                    }
                    p > 0 && (e.isWebGL2 || !0 === t1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = gh.LTC_FLOAT_1, r.rectAreaLTC2 = gh.LTC_FLOAT_2) : !0 === t1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = gh.LTC_HALF_1, r.rectAreaLTC2 = gh.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
                    const x = r.hash;
                    x.directionalLength === u && x.pointLength === h && x.spotLength === d && x.rectAreaLength === p && x.hemiLength === f && x.numDirectionalShadows === m && x.numPointShadows === g && x.numSpotShadows === A && x.numSpotMaps === v && x.numLightProbes === M || (r.directional.length = u, r.spot.length = d, r.rectArea.length = p, r.point.length = h, r.hemi.length = f, r.directionalShadow.length = m, r.directionalShadowMap.length = m, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = A, r.spotShadowMap.length = A, r.directionalShadowMatrix.length = m, r.pointShadowMatrix.length = g, r.spotLightMatrix.length = A + v - y, r.spotLightMap.length = v, r.numSpotLightShadowsWithMaps = y, r.numLightProbes = M, x.directionalLength = u, x.pointLength = h, x.spotLength = d, x.rectAreaLength = p, x.hemiLength = f, x.numDirectionalShadows = m, x.numPointShadows = g, x.numSpotShadows = A, x.numSpotMaps = v, x.numLightProbes = M, r.version = Tp++);
                },
                setupView: function(t1, e) {
                    let n = 0, i = 0, l = 0, c = 0, u = 0;
                    const h = e.matrixWorldInverse;
                    for(let e = 0, d = t1.length; e < d; e++){
                        const d = t1[e];
                        if (d.isDirectionalLight) {
                            const t1 = r.directional[n];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), n++;
                        } else if (d.isSpotLight) {
                            const t1 = r.spot[l];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), l++;
                        } else if (d.isRectAreaLight) {
                            const t1 = r.rectArea[c];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), o.identity(), s.copy(d.matrixWorld), s.premultiply(h), o.extractRotation(s), t1.halfWidth.set(.5 * d.width, 0, 0), t1.halfHeight.set(0, .5 * d.height, 0), t1.halfWidth.applyMatrix4(o), t1.halfHeight.applyMatrix4(o), c++;
                        } else if (d.isPointLight) {
                            const t1 = r.point[i];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), i++;
                        } else if (d.isHemisphereLight) {
                            const t1 = r.hemi[u];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), t1.direction.transformDirection(h), u++;
                        }
                    }
                },
                state: r
            };
        }
        function Np(t1, e) {
            const n = new Cp(t1, e), i = [], r = [];
            return {
                init: function() {
                    i.length = 0, r.length = 0;
                },
                state: {
                    lightsArray: i,
                    shadowsArray: r,
                    lights: n
                },
                setupLights: function(t1) {
                    n.setup(i, t1);
                },
                setupLightsView: function(t1) {
                    n.setupView(i, t1);
                },
                pushLight: function(t1) {
                    i.push(t1);
                },
                pushShadow: function(t1) {
                    r.push(t1);
                }
            };
        }
        function Dp(t1, e) {
            let n = new WeakMap;
            return {
                get: function(i, r = 0) {
                    const a = n.get(i);
                    let s;
                    return void 0 === a ? (s = new Np(t1, e), n.set(i, [
                        s
                    ])) : r >= a.length ? (s = new Np(t1, e), a.push(s)) : s = a[r], s;
                },
                dispose: function() {
                    n = new WeakMap;
                }
            };
        }
        class Lp extends tu {
            constructor(t1){
                super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Fs, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.depthPacking = t1.depthPacking, this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this;
            }
        }
        class Op extends tu {
            constructor(t1){
                super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this;
            }
        }
        function Rp(t1, e, n) {
            let i = new hh;
            const r = new tl, a = new tl, s = new _l, o = new Lp({
                depthPacking: Hs
            }), l = new Op, c = {}, u = n.maxTextureSize, h = {
                [hr]: dr,
                [dr]: hr,
                [pr]: pr
            }, d = new Ku({
                defines: {
                    VSM_SAMPLES: 8
                },
                uniforms: {
                    shadow_pass: {
                        value: null
                    },
                    resolution: {
                        value: new tl
                    },
                    radius: {
                        value: 4
                    }
                },
                vertexShader: "void main() {\n	gl_Position = vec4( position, 1.0 );\n}",
                fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
            }), p = d.clone();
            p.defines.HORIZONTAL_PASS = 1;
            const f = new Tu;
            f.setAttribute("position", new cu(new Float32Array([
                -1,
                -1,
                .5,
                3,
                -1,
                .5,
                -1,
                3,
                .5
            ]), 3));
            const m = new Gu(f, d), g = this;
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = lr;
            let A = this.type;
            function v(n, i) {
                const a = e.update(m);
                d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === n.mapPass && (n.mapPass = new Sl(r.x, r.y)), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t1.setRenderTarget(n.mapPass), t1.clear(), t1.renderBufferDirect(i, null, a, d, m, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, t1.setRenderTarget(n.map), t1.clear(), t1.renderBufferDirect(i, null, a, p, m, null);
            }
            function y(e, n, i, r) {
                let a = null;
                const s = !0 === i.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;
                if (void 0 !== s) a = s;
                else if (a = !0 === i.isPointLight ? l : o, t1.localClippingEnabled && !0 === n.clipShadows && Array.isArray(n.clippingPlanes) && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0) {
                    const t1 = a.uuid, e = n.uuid;
                    let i = c[t1];
                    void 0 === i && (i = {}, c[t1] = i);
                    let r = i[e];
                    void 0 === r && (r = a.clone(), i[e] = r), a = r;
                }
                return a.visible = n.visible, a.wireframe = n.wireframe, a.side = r === ur ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : h[n.side], a.alphaMap = n.alphaMap, a.alphaTest = n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, !0 === i.isPointLight && !0 === a.isMeshDistanceMaterial && (t1.properties.get(a).light = i), a;
            }
            function M(n, r, a, s, o) {
                if (!1 === n.visible) return;
                if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && o === ur) && (!n.frustumCulled || i.intersectsObject(n))) {
                    n.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, n.matrixWorld);
                    const i = e.update(n), r = n.material;
                    if (Array.isArray(r)) {
                        const e = i.groups;
                        for(let l = 0, c = e.length; l < c; l++){
                            const c = e[l], u = r[c.materialIndex];
                            if (u && u.visible) {
                                const e = y(n, u, s, o);
                                t1.renderBufferDirect(a, null, i, e, n, c);
                            }
                        }
                    } else if (r.visible) {
                        const e = y(n, r, s, o);
                        t1.renderBufferDirect(a, null, i, e, n, null);
                    }
                }
                const l = n.children;
                for(let t1 = 0, e = l.length; t1 < e; t1++)M(l[t1], r, a, s, o);
            }
            this.render = function(e, n, o) {
                if (!1 === g.enabled) return;
                if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
                if (0 === e.length) return;
                const l = t1.getRenderTarget(), c = t1.getActiveCubeFace(), h = t1.getActiveMipmapLevel(), d = t1.state;
                d.setBlending(mr), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
                const p = A !== ur && this.type === ur, f = A === ur && this.type !== ur;
                for(let l = 0, c = e.length; l < c; l++){
                    const c = e[l], h = c.shadow;
                    if (void 0 === h) {
                        console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                        continue;
                    }
                    if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
                    r.copy(h.mapSize);
                    const m = h.getFrameExtents();
                    if (r.multiply(m), a.copy(h.mapSize), (r.x > u || r.y > u) && (r.x > u && (a.x = Math.floor(u / m.x), r.x = a.x * m.x, h.mapSize.x = a.x), r.y > u && (a.y = Math.floor(u / m.y), r.y = a.y * m.y, h.mapSize.y = a.y)), null === h.map || !0 === p || !0 === f) {
                        const t1 = this.type !== ur ? {
                            minFilter: ma,
                            magFilter: ma
                        } : {};
                        null !== h.map && h.map.dispose(), h.map = new Sl(r.x, r.y, t1), h.map.texture.name = c.name + ".shadowMap", h.camera.updateProjectionMatrix();
                    }
                    t1.setRenderTarget(h.map), t1.clear();
                    const g = h.getViewportCount();
                    for(let t1 = 0; t1 < g; t1++){
                        const e = h.getViewport(t1);
                        s.set(a.x * e.x, a.y * e.y, a.x * e.z, a.y * e.w), d.viewport(s), h.updateMatrices(c, t1), i = h.getFrustum(), M(n, o, h.camera, c, this.type);
                    }
                    !0 !== h.isPointLightShadow && this.type === ur && v(h, o), h.needsUpdate = !1;
                }
                A = this.type, g.needsUpdate = !1, t1.setRenderTarget(l, c, h);
            };
        }
        function Pp(t1, e, n) {
            const i = n.isWebGL2, r = new function() {
                let e = !1;
                const n = new _l;
                let i = null;
                const r = new _l(0, 0, 0, 0);
                return {
                    setMask: function(n) {
                        i === n || e || (t1.colorMask(n, n, n, n), i = n);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e, i, a, s, o) {
                        !0 === o && (e *= s, i *= s, a *= s), n.set(e, i, a, s), !1 === r.equals(n) && (t1.clearColor(e, i, a, s), r.copy(n));
                    },
                    reset: function() {
                        e = !1, i = null, r.set(-1, 0, 0, 0);
                    }
                };
            }, a = new function() {
                let e = !1, n = null, i = null, r = null;
                return {
                    setTest: function(e) {
                        e ? H(t1.DEPTH_TEST) : V(t1.DEPTH_TEST);
                    },
                    setMask: function(i) {
                        n === i || e || (t1.depthMask(i), n = i);
                    },
                    setFunc: function(e) {
                        if (i !== e) {
                            switch(e){
                                case Fr:
                                    t1.depthFunc(t1.NEVER);
                                    break;
                                case Hr:
                                    t1.depthFunc(t1.ALWAYS);
                                    break;
                                case Vr:
                                    t1.depthFunc(t1.LESS);
                                    break;
                                case Qr:
                                    t1.depthFunc(t1.LEQUAL);
                                    break;
                                case Gr:
                                    t1.depthFunc(t1.EQUAL);
                                    break;
                                case Wr:
                                    t1.depthFunc(t1.GEQUAL);
                                    break;
                                case Xr:
                                    t1.depthFunc(t1.GREATER);
                                    break;
                                case Yr:
                                    t1.depthFunc(t1.NOTEQUAL);
                                    break;
                                default:
                                    t1.depthFunc(t1.LEQUAL);
                            }
                            i = e;
                        }
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        r !== e && (t1.clearDepth(e), r = e);
                    },
                    reset: function() {
                        e = !1, n = null, i = null, r = null;
                    }
                };
            }, s = new function() {
                let e = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                return {
                    setTest: function(n) {
                        e || (n ? H(t1.STENCIL_TEST) : V(t1.STENCIL_TEST));
                    },
                    setMask: function(i) {
                        n === i || e || (t1.stencilMask(i), n = i);
                    },
                    setFunc: function(e, n, s) {
                        i === e && r === n && a === s || (t1.stencilFunc(e, n, s), i = e, r = n, a = s);
                    },
                    setOp: function(e, n, i) {
                        s === e && o === n && l === i || (t1.stencilOp(e, n, i), s = e, o = n, l = i);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        c !== e && (t1.clearStencil(e), c = e);
                    },
                    reset: function() {
                        e = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                    }
                };
            }, o = new WeakMap, l = new WeakMap;
            let c = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, m = null, g = null, A = null, v = null, y = null, M = null, b = null, x = new Jc(0, 0, 0), w = 0, _ = !1, E = null, S = null, T = null, I = null, C = null;
            const N = t1.getParameter(t1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
            let D = !1, L = 0;
            const O = t1.getParameter(t1.VERSION);
            -1 !== O.indexOf("WebGL") ? (L = parseFloat(/^WebGL (\d)/.exec(O)[1]), D = L >= 1) : -1 !== O.indexOf("OpenGL ES") && (L = parseFloat(/^OpenGL ES (\d)/.exec(O)[1]), D = L >= 2);
            let R = null, P = {};
            const z = t1.getParameter(t1.SCISSOR_BOX), U = t1.getParameter(t1.VIEWPORT), k = (new _l).fromArray(z), B = (new _l).fromArray(U);
            function j(e, n, r, a) {
                const s = new Uint8Array(4), o = t1.createTexture();
                t1.bindTexture(e, o), t1.texParameteri(e, t1.TEXTURE_MIN_FILTER, t1.NEAREST), t1.texParameteri(e, t1.TEXTURE_MAG_FILTER, t1.NEAREST);
                for(let o = 0; o < r; o++)!i || e !== t1.TEXTURE_3D && e !== t1.TEXTURE_2D_ARRAY ? t1.texImage2D(n + o, 0, t1.RGBA, 1, 1, 0, t1.RGBA, t1.UNSIGNED_BYTE, s) : t1.texImage3D(n, 0, t1.RGBA, 1, 1, a, 0, t1.RGBA, t1.UNSIGNED_BYTE, s);
                return o;
            }
            const F = {};
            function H(e) {
                !0 !== c[e] && (t1.enable(e), c[e] = !0);
            }
            function V(e) {
                !1 !== c[e] && (t1.disable(e), c[e] = !1);
            }
            F[t1.TEXTURE_2D] = j(t1.TEXTURE_2D, t1.TEXTURE_2D, 1), F[t1.TEXTURE_CUBE_MAP] = j(t1.TEXTURE_CUBE_MAP, t1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), i && (F[t1.TEXTURE_2D_ARRAY] = j(t1.TEXTURE_2D_ARRAY, t1.TEXTURE_2D_ARRAY, 1, 1), F[t1.TEXTURE_3D] = j(t1.TEXTURE_3D, t1.TEXTURE_3D, 1, 1)), r.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), H(t1.DEPTH_TEST), a.setFunc(Qr), X(!1), Y(rr), H(t1.CULL_FACE), W(mr);
            const Q = {
                [br]: t1.FUNC_ADD,
                [xr]: t1.FUNC_SUBTRACT,
                [wr]: t1.FUNC_REVERSE_SUBTRACT
            };
            if (i) Q[_r] = t1.MIN, Q[Er] = t1.MAX;
            else {
                const t1 = e.get("EXT_blend_minmax");
                null !== t1 && (Q[_r] = t1.MIN_EXT, Q[Er] = t1.MAX_EXT);
            }
            const G = {
                [Sr]: t1.ZERO,
                [Tr]: t1.ONE,
                [Ir]: t1.SRC_COLOR,
                [Nr]: t1.SRC_ALPHA,
                [zr]: t1.SRC_ALPHA_SATURATE,
                [Rr]: t1.DST_COLOR,
                [Lr]: t1.DST_ALPHA,
                [Cr]: t1.ONE_MINUS_SRC_COLOR,
                [Dr]: t1.ONE_MINUS_SRC_ALPHA,
                [Pr]: t1.ONE_MINUS_DST_COLOR,
                [Or]: t1.ONE_MINUS_DST_ALPHA,
                [Ur]: t1.CONSTANT_COLOR,
                [kr]: t1.ONE_MINUS_CONSTANT_COLOR,
                [Br]: t1.CONSTANT_ALPHA,
                [jr]: t1.ONE_MINUS_CONSTANT_ALPHA
            };
            function W(e, n, i, r, a, s, o, l, c, u) {
                if (e !== mr) {
                    if (!1 === f && (H(t1.BLEND), f = !0), e === Mr) a = a || n, s = s || i, o = o || r, n === g && a === y || (t1.blendEquationSeparate(Q[n], Q[a]), g = n, y = a), i === A && r === v && s === M && o === b || (t1.blendFuncSeparate(G[i], G[r], G[s], G[o]), A = i, v = r, M = s, b = o), !1 !== l.equals(x) && c === w || (t1.blendColor(l.r, l.g, l.b, c), x.copy(l), w = c), m = e, _ = !1;
                    else if (e !== m || u !== _) {
                        if (g === br && y === br || (t1.blendEquation(t1.FUNC_ADD), g = br, y = br), u) switch(e){
                            case gr:
                                t1.blendFuncSeparate(t1.ONE, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case Ar:
                                t1.blendFunc(t1.ONE, t1.ONE);
                                break;
                            case vr:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case yr:
                                t1.blendFuncSeparate(t1.ZERO, t1.SRC_COLOR, t1.ZERO, t1.SRC_ALPHA);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        else switch(e){
                            case gr:
                                t1.blendFuncSeparate(t1.SRC_ALPHA, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case Ar:
                                t1.blendFunc(t1.SRC_ALPHA, t1.ONE);
                                break;
                            case vr:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case yr:
                                t1.blendFunc(t1.ZERO, t1.SRC_COLOR);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        A = null, v = null, M = null, b = null, x.set(0, 0, 0), w = 0, m = e, _ = u;
                    }
                } else !0 === f && (V(t1.BLEND), f = !1);
            }
            function X(e) {
                E !== e && (e ? t1.frontFace(t1.CW) : t1.frontFace(t1.CCW), E = e);
            }
            function Y(e) {
                e !== ir ? (H(t1.CULL_FACE), e !== S && (e === rr ? t1.cullFace(t1.BACK) : e === ar ? t1.cullFace(t1.FRONT) : t1.cullFace(t1.FRONT_AND_BACK))) : V(t1.CULL_FACE), S = e;
            }
            function Z(e, n, i) {
                e ? (H(t1.POLYGON_OFFSET_FILL), I === n && C === i || (t1.polygonOffset(n, i), I = n, C = i)) : V(t1.POLYGON_OFFSET_FILL);
            }
            return {
                buffers: {
                    color: r,
                    depth: a,
                    stencil: s
                },
                enable: H,
                disable: V,
                bindFramebuffer: function(e, n) {
                    return u[e] !== n && (t1.bindFramebuffer(e, n), u[e] = n, i && (e === t1.DRAW_FRAMEBUFFER && (u[t1.FRAMEBUFFER] = n), e === t1.FRAMEBUFFER && (u[t1.DRAW_FRAMEBUFFER] = n)), !0);
                },
                drawBuffers: function(i, r) {
                    let a = d, s = !1;
                    if (i) {
                        if (a = h.get(r), void 0 === a && (a = [], h.set(r, a)), i.isWebGLMultipleRenderTargets) {
                            const e = i.texture;
                            if (a.length !== e.length || a[0] !== t1.COLOR_ATTACHMENT0) {
                                for(let n = 0, i = e.length; n < i; n++)a[n] = t1.COLOR_ATTACHMENT0 + n;
                                a.length = e.length, s = !0;
                            }
                        } else a[0] !== t1.COLOR_ATTACHMENT0 && (a[0] = t1.COLOR_ATTACHMENT0, s = !0);
                    } else a[0] !== t1.BACK && (a[0] = t1.BACK, s = !0);
                    s && (n.isWebGL2 ? t1.drawBuffers(a) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(a));
                },
                useProgram: function(e) {
                    return p !== e && (t1.useProgram(e), p = e, !0);
                },
                setBlending: W,
                setMaterial: function(e, n) {
                    e.side === pr ? V(t1.CULL_FACE) : H(t1.CULL_FACE);
                    let i = e.side === dr;
                    n && (i = !i), X(i), e.blending === gr && !1 === e.transparent ? W(mr) : W(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.blendColor, e.blendAlpha, e.premultipliedAlpha), a.setFunc(e.depthFunc), a.setTest(e.depthTest), a.setMask(e.depthWrite), r.setMask(e.colorWrite);
                    const o = e.stencilWrite;
                    s.setTest(o), o && (s.setMask(e.stencilWriteMask), s.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), s.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), Z(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), !0 === e.alphaToCoverage ? H(t1.SAMPLE_ALPHA_TO_COVERAGE) : V(t1.SAMPLE_ALPHA_TO_COVERAGE);
                },
                setFlipSided: X,
                setCullFace: Y,
                setLineWidth: function(e) {
                    e !== T && (D && t1.lineWidth(e), T = e);
                },
                setPolygonOffset: Z,
                setScissorTest: function(e) {
                    e ? H(t1.SCISSOR_TEST) : V(t1.SCISSOR_TEST);
                },
                activeTexture: function(e) {
                    void 0 === e && (e = t1.TEXTURE0 + N - 1), R !== e && (t1.activeTexture(e), R = e);
                },
                bindTexture: function(e, n, i) {
                    void 0 === i && (i = null === R ? t1.TEXTURE0 + N - 1 : R);
                    let r = P[i];
                    void 0 === r && (r = {
                        type: void 0,
                        texture: void 0
                    }, P[i] = r), r.type === e && r.texture === n || (R !== i && (t1.activeTexture(i), R = i), t1.bindTexture(e, n || F[e]), r.type = e, r.texture = n);
                },
                unbindTexture: function() {
                    const e = P[R];
                    void 0 !== e && void 0 !== e.type && (t1.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
                },
                compressedTexImage2D: function() {
                    try {
                        t1.compressedTexImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexImage3D: function() {
                    try {
                        t1.compressedTexImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage2D: function() {
                    try {
                        t1.texImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage3D: function() {
                    try {
                        t1.texImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                updateUBOMapping: function(e, n) {
                    let i = l.get(n);
                    void 0 === i && (i = new WeakMap, l.set(n, i));
                    let r = i.get(e);
                    void 0 === r && (r = t1.getUniformBlockIndex(n, e.name), i.set(e, r));
                },
                uniformBlockBinding: function(e, n) {
                    const i = l.get(n).get(e);
                    o.get(n) !== i && (t1.uniformBlockBinding(n, i, e.__bindingPointIndex), o.set(n, i));
                },
                texStorage2D: function() {
                    try {
                        t1.texStorage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texStorage3D: function() {
                    try {
                        t1.texStorage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage2D: function() {
                    try {
                        t1.texSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage3D: function() {
                    try {
                        t1.texSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage2D: function() {
                    try {
                        t1.compressedTexSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage3D: function() {
                    try {
                        t1.compressedTexSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                scissor: function(e) {
                    !1 === k.equals(e) && (t1.scissor(e.x, e.y, e.z, e.w), k.copy(e));
                },
                viewport: function(e) {
                    !1 === B.equals(e) && (t1.viewport(e.x, e.y, e.z, e.w), B.copy(e));
                },
                reset: function() {
                    t1.disable(t1.BLEND), t1.disable(t1.CULL_FACE), t1.disable(t1.DEPTH_TEST), t1.disable(t1.POLYGON_OFFSET_FILL), t1.disable(t1.SCISSOR_TEST), t1.disable(t1.STENCIL_TEST), t1.disable(t1.SAMPLE_ALPHA_TO_COVERAGE), t1.blendEquation(t1.FUNC_ADD), t1.blendFunc(t1.ONE, t1.ZERO), t1.blendFuncSeparate(t1.ONE, t1.ZERO, t1.ONE, t1.ZERO), t1.blendColor(0, 0, 0, 0), t1.colorMask(!0, !0, !0, !0), t1.clearColor(0, 0, 0, 0), t1.depthMask(!0), t1.depthFunc(t1.LESS), t1.clearDepth(1), t1.stencilMask(4294967295), t1.stencilFunc(t1.ALWAYS, 0, 4294967295), t1.stencilOp(t1.KEEP, t1.KEEP, t1.KEEP), t1.clearStencil(0), t1.cullFace(t1.BACK), t1.frontFace(t1.CCW), t1.polygonOffset(0, 0), t1.activeTexture(t1.TEXTURE0), t1.bindFramebuffer(t1.FRAMEBUFFER, null), !0 === i && (t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null)), t1.useProgram(null), t1.lineWidth(1), t1.scissor(0, 0, t1.canvas.width, t1.canvas.height), t1.viewport(0, 0, t1.canvas.width, t1.canvas.height), c = {}, R = null, P = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, m = null, g = null, A = null, v = null, y = null, M = null, b = null, x = new Jc(0, 0, 0), w = 0, _ = !1, E = null, S = null, T = null, I = null, C = null, k.set(0, 0, t1.canvas.width, t1.canvas.height), B.set(0, 0, t1.canvas.width, t1.canvas.height), r.reset(), a.reset(), s.reset();
                }
            };
        }
        function zp(t1, e, n, i, r, a, s) {
            const o = r.isWebGL2, l = r.maxTextures, c = r.maxCubemapSize, u = r.maxTextureSize, h = r.maxSamples, d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, p = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), f = new WeakMap;
            let m;
            const g = new WeakMap;
            let A = !1;
            try {
                A = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
            } catch (t1) {}
            function v(t1, e) {
                return A ? new OffscreenCanvas(t1, e) : sl("canvas");
            }
            function y(t1, e, n, i) {
                let r = 1;
                if ((t1.width > i || t1.height > i) && (r = i / Math.max(t1.width, t1.height)), r < 1 || !0 === e) {
                    if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                        const i = e ? qo : Math.floor, a = i(r * t1.width), s = i(r * t1.height);
                        void 0 === m && (m = v(a, s));
                        const o = n ? v(a, s) : m;
                        return o.width = a, o.height = s, o.getContext("2d").drawImage(t1, 0, 0, a, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t1.width + "x" + t1.height + ") to (" + a + "x" + s + ")."), o;
                    }
                    return "data" in t1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t1.width + "x" + t1.height + ")."), t1;
                }
                return t1;
            }
            function M(t1) {
                return Yo(t1.width) && Yo(t1.height);
            }
            function b(t1, e) {
                return t1.generateMipmaps && e && t1.minFilter !== ma && t1.minFilter !== Ma;
            }
            function x(e) {
                t1.generateMipmap(e);
            }
            function w(n, i, r, a, s = !1) {
                if (!1 === o) return i;
                if (null !== n) {
                    if (void 0 !== t1[n]) return t1[n];
                    console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
                }
                let l = i;
                if (i === t1.RED && (r === t1.FLOAT && (l = t1.R32F), r === t1.HALF_FLOAT && (l = t1.R16F), r === t1.UNSIGNED_BYTE && (l = t1.R8)), i === t1.RED_INTEGER && (r === t1.UNSIGNED_BYTE && (l = t1.R8UI), r === t1.UNSIGNED_SHORT && (l = t1.R16UI), r === t1.UNSIGNED_INT && (l = t1.R32UI), r === t1.BYTE && (l = t1.R8I), r === t1.SHORT && (l = t1.R16I), r === t1.INT && (l = t1.R32I)), i === t1.RG && (r === t1.FLOAT && (l = t1.RG32F), r === t1.HALF_FLOAT && (l = t1.RG16F), r === t1.UNSIGNED_BYTE && (l = t1.RG8)), i === t1.RGBA) {
                    const e = s ? qs : fl.getTransfer(a);
                    r === t1.FLOAT && (l = t1.RGBA32F), r === t1.HALF_FLOAT && (l = t1.RGBA16F), r === t1.UNSIGNED_BYTE && (l = e === Js ? t1.SRGB8_ALPHA8 : t1.RGBA8), r === t1.UNSIGNED_SHORT_4_4_4_4 && (l = t1.RGBA4), r === t1.UNSIGNED_SHORT_5_5_5_1 && (l = t1.RGB5_A1);
                }
                return l !== t1.R16F && l !== t1.R32F && l !== t1.RG16F && l !== t1.RG32F && l !== t1.RGBA16F && l !== t1.RGBA32F || e.get("EXT_color_buffer_float"), l;
            }
            function _(t1, e, n) {
                return !0 === b(t1, n) || t1.isFramebufferTexture && t1.minFilter !== ma && t1.minFilter !== Ma ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t1.mipmaps && t1.mipmaps.length > 0 ? t1.mipmaps.length : t1.isCompressedTexture && Array.isArray(t1.image) ? e.mipmaps.length : 1;
            }
            function E(e) {
                return e === ma || e === ga || e === va ? t1.NEAREST : t1.LINEAR;
            }
            function S(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", S), function(t1) {
                    const e = i.get(t1);
                    if (void 0 === e.__webglInit) return;
                    const n = t1.source, r = g.get(n);
                    if (r) {
                        const i = r[e.__cacheKey];
                        i.usedTimes--, 0 === i.usedTimes && I(t1), 0 === Object.keys(r).length && g.delete(n);
                    }
                    i.remove(t1);
                }(e), e.isVideoTexture && f.delete(e);
            }
            function T(e) {
                const n = e.target;
                n.removeEventListener("dispose", T), function(e) {
                    const n = e.texture, r = i.get(e), a = i.get(n);
                    if (void 0 !== a.__webglTexture && (t1.deleteTexture(a.__webglTexture), s.memory.textures--), e.depthTexture && e.depthTexture.dispose(), e.isWebGLCubeRenderTarget) for(let e = 0; e < 6; e++){
                        if (Array.isArray(r.__webglFramebuffer[e])) for(let n = 0; n < r.__webglFramebuffer[e].length; n++)t1.deleteFramebuffer(r.__webglFramebuffer[e][n]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer[e]);
                    }
                    else {
                        if (Array.isArray(r.__webglFramebuffer)) for(let e = 0; e < r.__webglFramebuffer.length; e++)t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer);
                        if (r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for(let e = 0; e < r.__webglColorRenderbuffer.length; e++)r.__webglColorRenderbuffer[e] && t1.deleteRenderbuffer(r.__webglColorRenderbuffer[e]);
                        r.__webglDepthRenderbuffer && t1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
                    }
                    if (e.isWebGLMultipleRenderTargets) for(let e = 0, r = n.length; e < r; e++){
                        const r = i.get(n[e]);
                        r.__webglTexture && (t1.deleteTexture(r.__webglTexture), s.memory.textures--), i.remove(n[e]);
                    }
                    i.remove(n), i.remove(e);
                }(n);
            }
            function I(e) {
                const n = i.get(e);
                t1.deleteTexture(n.__webglTexture);
                const r = e.source;
                delete g.get(r)[n.__cacheKey], s.memory.textures--;
            }
            let C = 0;
            function N(e, r) {
                const a = i.get(e);
                if (e.isVideoTexture && function(t1) {
                    const e = s.render.frame;
                    f.get(t1) !== e && (f.set(t1, e), t1.update());
                }(e), !1 === e.isRenderTargetTexture && e.version > 0 && a.__version !== e.version) {
                    const t1 = e.image;
                    if (null === t1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                    else {
                        if (!1 !== t1.complete) return void z(a, e, r);
                        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                    }
                }
                n.bindTexture(t1.TEXTURE_2D, a.__webglTexture, t1.TEXTURE0 + r);
            }
            const D = {
                [da]: t1.REPEAT,
                [pa]: t1.CLAMP_TO_EDGE,
                [fa]: t1.MIRRORED_REPEAT
            }, L = {
                [ma]: t1.NEAREST,
                [ga]: t1.NEAREST_MIPMAP_NEAREST,
                [va]: t1.NEAREST_MIPMAP_LINEAR,
                [Ma]: t1.LINEAR,
                [ba]: t1.LINEAR_MIPMAP_NEAREST,
                [wa]: t1.LINEAR_MIPMAP_LINEAR
            }, O = {
                [Ao]: t1.NEVER,
                [_o]: t1.ALWAYS,
                [vo]: t1.LESS,
                [Mo]: t1.LEQUAL,
                [yo]: t1.EQUAL,
                [wo]: t1.GEQUAL,
                [bo]: t1.GREATER,
                [xo]: t1.NOTEQUAL
            };
            function R(n, a, s) {
                if (s ? (t1.texParameteri(n, t1.TEXTURE_WRAP_S, D[a.wrapS]), t1.texParameteri(n, t1.TEXTURE_WRAP_T, D[a.wrapT]), n !== t1.TEXTURE_3D && n !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(n, t1.TEXTURE_WRAP_R, D[a.wrapR]), t1.texParameteri(n, t1.TEXTURE_MAG_FILTER, L[a.magFilter]), t1.texParameteri(n, t1.TEXTURE_MIN_FILTER, L[a.minFilter])) : (t1.texParameteri(n, t1.TEXTURE_WRAP_S, t1.CLAMP_TO_EDGE), t1.texParameteri(n, t1.TEXTURE_WRAP_T, t1.CLAMP_TO_EDGE), n !== t1.TEXTURE_3D && n !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(n, t1.TEXTURE_WRAP_R, t1.CLAMP_TO_EDGE), a.wrapS === pa && a.wrapT === pa || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t1.texParameteri(n, t1.TEXTURE_MAG_FILTER, E(a.magFilter)), t1.texParameteri(n, t1.TEXTURE_MIN_FILTER, E(a.minFilter)), a.minFilter !== ma && a.minFilter !== Ma && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), a.compareFunction && (t1.texParameteri(n, t1.TEXTURE_COMPARE_MODE, t1.COMPARE_REF_TO_TEXTURE), t1.texParameteri(n, t1.TEXTURE_COMPARE_FUNC, O[a.compareFunction])), !0 === e.has("EXT_texture_filter_anisotropic")) {
                    const s = e.get("EXT_texture_filter_anisotropic");
                    if (a.magFilter === ma) return;
                    if (a.minFilter !== va && a.minFilter !== wa) return;
                    if (a.type === Da && !1 === e.has("OES_texture_float_linear")) return;
                    if (!1 === o && a.type === La && !1 === e.has("OES_texture_half_float_linear")) return;
                    (a.anisotropy > 1 || i.get(a).__currentAnisotropy) && (t1.texParameterf(n, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, r.getMaxAnisotropy())), i.get(a).__currentAnisotropy = a.anisotropy);
                }
            }
            function P(e, n) {
                let i = !1;
                void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", S));
                const r = n.source;
                let a = g.get(r);
                void 0 === a && (a = {}, g.set(r, a));
                const o = function(t1) {
                    const e = [];
                    return e.push(t1.wrapS), e.push(t1.wrapT), e.push(t1.wrapR || 0), e.push(t1.magFilter), e.push(t1.minFilter), e.push(t1.anisotropy), e.push(t1.internalFormat), e.push(t1.format), e.push(t1.type), e.push(t1.generateMipmaps), e.push(t1.premultiplyAlpha), e.push(t1.flipY), e.push(t1.unpackAlignment), e.push(t1.colorSpace), e.join();
                }(n);
                if (o !== e.__cacheKey) {
                    void 0 === a[o] && (a[o] = {
                        texture: t1.createTexture(),
                        usedTimes: 0
                    }, s.memory.textures++, i = !0), a[o].usedTimes++;
                    const r = a[e.__cacheKey];
                    void 0 !== r && (a[e.__cacheKey].usedTimes--, 0 === r.usedTimes && I(n)), e.__cacheKey = o, e.__webglTexture = a[o].texture;
                }
                return i;
            }
            function z(e, r, s) {
                let l = t1.TEXTURE_2D;
                (r.isDataArrayTexture || r.isCompressedArrayTexture) && (l = t1.TEXTURE_2D_ARRAY), r.isData3DTexture && (l = t1.TEXTURE_3D);
                const c = P(e, r), h = r.source;
                n.bindTexture(l, e.__webglTexture, t1.TEXTURE0 + s);
                const d = i.get(h);
                if (h.version !== d.__version || !0 === c) {
                    n.activeTexture(t1.TEXTURE0 + s);
                    const e = fl.getPrimaries(fl.workingColorSpace), i = r.colorSpace === Gs ? null : fl.getPrimaries(r.colorSpace), p = r.colorSpace === Gs || e === i ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                    t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, p);
                    const f = function(t1) {
                        return !o && (t1.wrapS !== pa || t1.wrapT !== pa || t1.minFilter !== ma && t1.minFilter !== Ma);
                    }(r) && !1 === M(r.image);
                    let m = y(r.image, f, !1, u);
                    m = H(r, m);
                    const g = M(m) || o, A = a.convert(r.format, r.colorSpace);
                    let v, E = a.convert(r.type), S = w(r.internalFormat, A, E, r.colorSpace, r.isVideoTexture);
                    R(l, r, g);
                    const T = r.mipmaps, I = o && !0 !== r.isVideoTexture, C = void 0 === d.__version || !0 === c, N = _(r, m, g);
                    if (r.isDepthTexture) S = t1.DEPTH_COMPONENT, o ? S = r.type === Da ? t1.DEPTH_COMPONENT32F : r.type === Na ? t1.DEPTH_COMPONENT24 : r.type === Pa ? t1.DEPTH24_STENCIL8 : t1.DEPTH_COMPONENT16 : r.type === Da && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === ja && S === t1.DEPTH_COMPONENT && r.type !== Ia && r.type !== Na && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = Na, E = a.convert(r.type)), r.format === Fa && S === t1.DEPTH_COMPONENT && (S = t1.DEPTH_STENCIL, r.type !== Pa && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = Pa, E = a.convert(r.type))), C && (I ? n.texStorage2D(t1.TEXTURE_2D, 1, S, m.width, m.height) : n.texImage2D(t1.TEXTURE_2D, 0, S, m.width, m.height, 0, A, E, null));
                    else if (r.isDataTexture) {
                        if (T.length > 0 && g) {
                            I && C && n.texStorage2D(t1.TEXTURE_2D, N, S, T[0].width, T[0].height);
                            for(let e = 0, i = T.length; e < i; e++)v = T[e], I ? n.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, v.width, v.height, A, E, v.data) : n.texImage2D(t1.TEXTURE_2D, e, S, v.width, v.height, 0, A, E, v.data);
                            r.generateMipmaps = !1;
                        } else I ? (C && n.texStorage2D(t1.TEXTURE_2D, N, S, m.width, m.height), n.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, m.width, m.height, A, E, m.data)) : n.texImage2D(t1.TEXTURE_2D, 0, S, m.width, m.height, 0, A, E, m.data);
                    } else if (r.isCompressedTexture) {
                        if (r.isCompressedArrayTexture) {
                            I && C && n.texStorage3D(t1.TEXTURE_2D_ARRAY, N, S, T[0].width, T[0].height, m.depth);
                            for(let e = 0, i = T.length; e < i; e++)v = T[e], r.format !== Ua ? null !== A ? I ? n.compressedTexSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, v.width, v.height, m.depth, A, v.data, 0, 0) : n.compressedTexImage3D(t1.TEXTURE_2D_ARRAY, e, S, v.width, v.height, m.depth, 0, v.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : I ? n.texSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, v.width, v.height, m.depth, A, E, v.data) : n.texImage3D(t1.TEXTURE_2D_ARRAY, e, S, v.width, v.height, m.depth, 0, A, E, v.data);
                        } else {
                            I && C && n.texStorage2D(t1.TEXTURE_2D, N, S, T[0].width, T[0].height);
                            for(let e = 0, i = T.length; e < i; e++)v = T[e], r.format !== Ua ? null !== A ? I ? n.compressedTexSubImage2D(t1.TEXTURE_2D, e, 0, 0, v.width, v.height, A, v.data) : n.compressedTexImage2D(t1.TEXTURE_2D, e, S, v.width, v.height, 0, v.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : I ? n.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, v.width, v.height, A, E, v.data) : n.texImage2D(t1.TEXTURE_2D, e, S, v.width, v.height, 0, A, E, v.data);
                        }
                    } else if (r.isDataArrayTexture) I ? (C && n.texStorage3D(t1.TEXTURE_2D_ARRAY, N, S, m.width, m.height, m.depth), n.texSubImage3D(t1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, m.width, m.height, m.depth, A, E, m.data)) : n.texImage3D(t1.TEXTURE_2D_ARRAY, 0, S, m.width, m.height, m.depth, 0, A, E, m.data);
                    else if (r.isData3DTexture) I ? (C && n.texStorage3D(t1.TEXTURE_3D, N, S, m.width, m.height, m.depth), n.texSubImage3D(t1.TEXTURE_3D, 0, 0, 0, 0, m.width, m.height, m.depth, A, E, m.data)) : n.texImage3D(t1.TEXTURE_3D, 0, S, m.width, m.height, m.depth, 0, A, E, m.data);
                    else if (r.isFramebufferTexture) {
                        if (C) {
                            if (I) n.texStorage2D(t1.TEXTURE_2D, N, S, m.width, m.height);
                            else {
                                let e = m.width, i = m.height;
                                for(let r = 0; r < N; r++)n.texImage2D(t1.TEXTURE_2D, r, S, e, i, 0, A, E, null), e >>= 1, i >>= 1;
                            }
                        }
                    } else if (T.length > 0 && g) {
                        I && C && n.texStorage2D(t1.TEXTURE_2D, N, S, T[0].width, T[0].height);
                        for(let e = 0, i = T.length; e < i; e++)v = T[e], I ? n.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, A, E, v) : n.texImage2D(t1.TEXTURE_2D, e, S, A, E, v);
                        r.generateMipmaps = !1;
                    } else I ? (C && n.texStorage2D(t1.TEXTURE_2D, N, S, m.width, m.height), n.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, A, E, m)) : n.texImage2D(t1.TEXTURE_2D, 0, S, A, E, m);
                    b(r, g) && x(l), d.__version = h.version, r.onUpdate && r.onUpdate(r);
                }
                e.__version = r.version;
            }
            function U(e, r, s, o, l, c) {
                const u = a.convert(s.format, s.colorSpace), h = a.convert(s.type), p = w(s.internalFormat, u, h, s.colorSpace);
                if (!i.get(r).__hasExternalTextures) {
                    const e = Math.max(1, r.width >> c), i = Math.max(1, r.height >> c);
                    l === t1.TEXTURE_3D || l === t1.TEXTURE_2D_ARRAY ? n.texImage3D(l, c, p, e, i, r.depth, 0, u, h, null) : n.texImage2D(l, c, p, e, i, 0, u, h, null);
                }
                n.bindFramebuffer(t1.FRAMEBUFFER, e), F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, 0, j(r)) : (l === t1.TEXTURE_2D || l >= t1.TEXTURE_CUBE_MAP_POSITIVE_X && l <= t1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t1.framebufferTexture2D(t1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, c), n.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function k(e, n, i) {
                if (t1.bindRenderbuffer(t1.RENDERBUFFER, e), n.depthBuffer && !n.stencilBuffer) {
                    let r = !0 === o ? t1.DEPTH_COMPONENT24 : t1.DEPTH_COMPONENT16;
                    if (i || F(n)) {
                        const e = n.depthTexture;
                        e && e.isDepthTexture && (e.type === Da ? r = t1.DEPTH_COMPONENT32F : e.type === Na && (r = t1.DEPTH_COMPONENT24));
                        const i = j(n);
                        F(n) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, i, r, n.width, n.height) : t1.renderbufferStorageMultisample(t1.RENDERBUFFER, i, r, n.width, n.height);
                    } else t1.renderbufferStorage(t1.RENDERBUFFER, r, n.width, n.height);
                    t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.RENDERBUFFER, e);
                } else if (n.depthBuffer && n.stencilBuffer) {
                    const r = j(n);
                    i && !1 === F(n) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, n.width, n.height) : t1.renderbufferStorage(t1.RENDERBUFFER, t1.DEPTH_STENCIL, n.width, n.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.RENDERBUFFER, e);
                } else {
                    const e = !0 === n.isWebGLMultipleRenderTargets ? n.texture : [
                        n.texture
                    ];
                    for(let r = 0; r < e.length; r++){
                        const s = e[r], o = a.convert(s.format, s.colorSpace), l = a.convert(s.type), c = w(s.internalFormat, o, l, s.colorSpace), u = j(n);
                        i && !1 === F(n) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, c, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, u, c, n.width, n.height) : t1.renderbufferStorage(t1.RENDERBUFFER, c, n.width, n.height);
                    }
                }
                t1.bindRenderbuffer(t1.RENDERBUFFER, null);
            }
            function B(e) {
                const r = i.get(e), a = !0 === e.isWebGLCubeRenderTarget;
                if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
                    if (a) throw new Error("target.depthTexture not supported in Cube render targets");
                    !function(e, r) {
                        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (n.bindFramebuffer(t1.FRAMEBUFFER, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), N(r.depthTexture, 0);
                        const a = i.get(r.depthTexture).__webglTexture, s = j(r);
                        if (r.depthTexture.format === ja) F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        else {
                            if (r.depthTexture.format !== Fa) throw new Error("Unknown depthTexture format");
                            F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        }
                    }(r.__webglFramebuffer, e);
                } else if (a) {
                    r.__webglDepthbuffer = [];
                    for(let i = 0; i < 6; i++)n.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer[i]), r.__webglDepthbuffer[i] = t1.createRenderbuffer(), k(r.__webglDepthbuffer[i], e, !1);
                } else n.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = t1.createRenderbuffer(), k(r.__webglDepthbuffer, e, !1);
                n.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function j(t1) {
                return Math.min(h, t1.samples);
            }
            function F(t1) {
                const n = i.get(t1);
                return o && t1.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
            }
            function H(t1, n) {
                const i = t1.colorSpace, r = t1.format, a = t1.type;
                return !0 === t1.isCompressedTexture || !0 === t1.isVideoTexture || t1.format === zo || i !== Xs && i !== Gs && (fl.getTransfer(i) === Js ? !1 === o ? !0 === e.has("EXT_sRGB") && r === Ua ? (t1.format = zo, t1.minFilter = Ma, t1.generateMipmaps = !1) : n = vl.sRGBToLinear(n) : r === Ua && a === Ea || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", i)), n;
            }
            this.allocateTextureUnit = function() {
                const t1 = C;
                return t1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + t1 + " texture units while this GPU supports only " + l), C += 1, t1;
            }, this.resetTextureUnits = function() {
                C = 0;
            }, this.setTexture2D = N, this.setTexture2DArray = function(e, r) {
                const a = i.get(e);
                e.version > 0 && a.__version !== e.version ? z(a, e, r) : n.bindTexture(t1.TEXTURE_2D_ARRAY, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTexture3D = function(e, r) {
                const a = i.get(e);
                e.version > 0 && a.__version !== e.version ? z(a, e, r) : n.bindTexture(t1.TEXTURE_3D, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTextureCube = function(e, r) {
                const s = i.get(e);
                e.version > 0 && s.__version !== e.version ? function(e, r, s) {
                    if (6 !== r.image.length) return;
                    const l = P(e, r), u = r.source;
                    n.bindTexture(t1.TEXTURE_CUBE_MAP, e.__webglTexture, t1.TEXTURE0 + s);
                    const h = i.get(u);
                    if (u.version !== h.__version || !0 === l) {
                        n.activeTexture(t1.TEXTURE0 + s);
                        const e = fl.getPrimaries(fl.workingColorSpace), i = r.colorSpace === Gs ? null : fl.getPrimaries(r.colorSpace), d = r.colorSpace === Gs || e === i ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                        t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
                        const p = r.isCompressedTexture || r.image[0].isCompressedTexture, f = r.image[0] && r.image[0].isDataTexture, m = [];
                        for(let t1 = 0; t1 < 6; t1++)m[t1] = p || f ? f ? r.image[t1].image : r.image[t1] : y(r.image[t1], !1, !0, c), m[t1] = H(r, m[t1]);
                        const g = m[0], A = M(g) || o, v = a.convert(r.format, r.colorSpace), E = a.convert(r.type), S = w(r.internalFormat, v, E, r.colorSpace), T = o && !0 !== r.isVideoTexture, I = void 0 === h.__version || !0 === l;
                        let C, N = _(r, g, A);
                        if (R(t1.TEXTURE_CUBE_MAP, r, A), p) {
                            T && I && n.texStorage2D(t1.TEXTURE_CUBE_MAP, N, S, g.width, g.height);
                            for(let e = 0; e < 6; e++){
                                C = m[e].mipmaps;
                                for(let i = 0; i < C.length; i++){
                                    const a = C[i];
                                    r.format !== Ua ? null !== v ? T ? n.compressedTexSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, 0, 0, a.width, a.height, v, a.data) : n.compressedTexImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, S, a.width, a.height, 0, a.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : T ? n.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, 0, 0, a.width, a.height, v, E, a.data) : n.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, S, a.width, a.height, 0, v, E, a.data);
                                }
                            }
                        } else {
                            C = r.mipmaps, T && I && (C.length > 0 && N++, n.texStorage2D(t1.TEXTURE_CUBE_MAP, N, S, m[0].width, m[0].height));
                            for(let e = 0; e < 6; e++)if (f) {
                                T ? n.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, m[e].width, m[e].height, v, E, m[e].data) : n.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, S, m[e].width, m[e].height, 0, v, E, m[e].data);
                                for(let i = 0; i < C.length; i++){
                                    const r = C[i].image[e].image;
                                    T ? n.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, 0, 0, r.width, r.height, v, E, r.data) : n.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, S, r.width, r.height, 0, v, E, r.data);
                                }
                            } else {
                                T ? n.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, v, E, m[e]) : n.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, S, v, E, m[e]);
                                for(let i = 0; i < C.length; i++){
                                    const r = C[i];
                                    T ? n.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, 0, 0, v, E, r.image[e]) : n.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, S, v, E, r.image[e]);
                                }
                            }
                        }
                        b(r, A) && x(t1.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
                    }
                    e.__version = r.version;
                }(s, e, r) : n.bindTexture(t1.TEXTURE_CUBE_MAP, s.__webglTexture, t1.TEXTURE0 + r);
            }, this.rebindTextures = function(e, n, r) {
                const a = i.get(e);
                void 0 !== n && U(a.__webglFramebuffer, e, e.texture, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, 0), void 0 !== r && B(e);
            }, this.setupRenderTarget = function(e) {
                const l = e.texture, c = i.get(e), u = i.get(l);
                e.addEventListener("dispose", T), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === u.__webglTexture && (u.__webglTexture = t1.createTexture()), u.__version = l.version, s.memory.textures++);
                const h = !0 === e.isWebGLCubeRenderTarget, d = !0 === e.isWebGLMultipleRenderTargets, p = M(e) || o;
                if (h) {
                    c.__webglFramebuffer = [];
                    for(let e = 0; e < 6; e++)if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer[e] = [];
                        for(let n = 0; n < l.mipmaps.length; n++)c.__webglFramebuffer[e][n] = t1.createFramebuffer();
                    } else c.__webglFramebuffer[e] = t1.createFramebuffer();
                } else {
                    if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer = [];
                        for(let e = 0; e < l.mipmaps.length; e++)c.__webglFramebuffer[e] = t1.createFramebuffer();
                    } else c.__webglFramebuffer = t1.createFramebuffer();
                    if (d) {
                        if (r.drawBuffers) {
                            const n = e.texture;
                            for(let e = 0, r = n.length; e < r; e++){
                                const r = i.get(n[e]);
                                void 0 === r.__webglTexture && (r.__webglTexture = t1.createTexture(), s.memory.textures++);
                            }
                        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
                    }
                    if (o && e.samples > 0 && !1 === F(e)) {
                        const i = d ? l : [
                            l
                        ];
                        c.__webglMultisampledFramebuffer = t1.createFramebuffer(), c.__webglColorRenderbuffer = [], n.bindFramebuffer(t1.FRAMEBUFFER, c.__webglMultisampledFramebuffer);
                        for(let n = 0; n < i.length; n++){
                            const r = i[n];
                            c.__webglColorRenderbuffer[n] = t1.createRenderbuffer(), t1.bindRenderbuffer(t1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                            const s = a.convert(r.format, r.colorSpace), o = a.convert(r.type), l = w(r.internalFormat, s, o, r.colorSpace, !0 === e.isXRRenderTarget), u = j(e);
                            t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, l, e.width, e.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + n, t1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                        }
                        t1.bindRenderbuffer(t1.RENDERBUFFER, null), e.depthBuffer && (c.__webglDepthRenderbuffer = t1.createRenderbuffer(), k(c.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(t1.FRAMEBUFFER, null);
                    }
                }
                if (h) {
                    n.bindTexture(t1.TEXTURE_CUBE_MAP, u.__webglTexture), R(t1.TEXTURE_CUBE_MAP, l, p);
                    for(let n = 0; n < 6; n++)if (o && l.mipmaps && l.mipmaps.length > 0) for(let i = 0; i < l.mipmaps.length; i++)U(c.__webglFramebuffer[n][i], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + n, i);
                    else U(c.__webglFramebuffer[n], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0);
                    b(l, p) && x(t1.TEXTURE_CUBE_MAP), n.unbindTexture();
                } else if (d) {
                    const r = e.texture;
                    for(let a = 0, s = r.length; a < s; a++){
                        const s = r[a], o = i.get(s);
                        n.bindTexture(t1.TEXTURE_2D, o.__webglTexture), R(t1.TEXTURE_2D, s, p), U(c.__webglFramebuffer, e, s, t1.COLOR_ATTACHMENT0 + a, t1.TEXTURE_2D, 0), b(s, p) && x(t1.TEXTURE_2D);
                    }
                    n.unbindTexture();
                } else {
                    let i = t1.TEXTURE_2D;
                    if ((e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? i = e.isWebGL3DRenderTarget ? t1.TEXTURE_3D : t1.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(i, u.__webglTexture), R(i, l, p), o && l.mipmaps && l.mipmaps.length > 0) for(let n = 0; n < l.mipmaps.length; n++)U(c.__webglFramebuffer[n], e, l, t1.COLOR_ATTACHMENT0, i, n);
                    else U(c.__webglFramebuffer, e, l, t1.COLOR_ATTACHMENT0, i, 0);
                    b(l, p) && x(i), n.unbindTexture();
                }
                e.depthBuffer && B(e);
            }, this.updateRenderTargetMipmap = function(e) {
                const r = M(e) || o, a = !0 === e.isWebGLMultipleRenderTargets ? e.texture : [
                    e.texture
                ];
                for(let s = 0, o = a.length; s < o; s++){
                    const o = a[s];
                    if (b(o, r)) {
                        const r = e.isWebGLCubeRenderTarget ? t1.TEXTURE_CUBE_MAP : t1.TEXTURE_2D, a = i.get(o).__webglTexture;
                        n.bindTexture(r, a), x(r), n.unbindTexture();
                    }
                }
            }, this.updateMultisampleRenderTarget = function(e) {
                if (o && e.samples > 0 && !1 === F(e)) {
                    const r = e.isWebGLMultipleRenderTargets ? e.texture : [
                        e.texture
                    ], a = e.width, s = e.height;
                    let o = t1.COLOR_BUFFER_BIT;
                    const l = [], c = e.stencilBuffer ? t1.DEPTH_STENCIL_ATTACHMENT : t1.DEPTH_ATTACHMENT, u = i.get(e), h = !0 === e.isWebGLMultipleRenderTargets;
                    if (h) for(let e = 0; e < r.length; e++)n.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, null), n.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, null, 0);
                    n.bindFramebuffer(t1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer), n.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                    for(let n = 0; n < r.length; n++){
                        l.push(t1.COLOR_ATTACHMENT0 + n), e.depthBuffer && l.push(c);
                        const d = void 0 !== u.__ignoreDepthValues && u.__ignoreDepthValues;
                        if (!1 === d && (e.depthBuffer && (o |= t1.DEPTH_BUFFER_BIT), e.stencilBuffer && (o |= t1.STENCIL_BUFFER_BIT)), h && t1.framebufferRenderbuffer(t1.READ_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.RENDERBUFFER, u.__webglColorRenderbuffer[n]), !0 === d && (t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, [
                            c
                        ]), t1.invalidateFramebuffer(t1.DRAW_FRAMEBUFFER, [
                            c
                        ])), h) {
                            const e = i.get(r[n]).__webglTexture;
                            t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0);
                        }
                        t1.blitFramebuffer(0, 0, a, s, 0, 0, a, s, o, t1.NEAREST), p && t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, l);
                    }
                    if (n.bindFramebuffer(t1.READ_FRAMEBUFFER, null), n.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), h) for(let e = 0; e < r.length; e++){
                        n.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, u.__webglColorRenderbuffer[e]);
                        const a = i.get(r[e]).__webglTexture;
                        n.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, a, 0);
                    }
                    n.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                }
            }, this.setupDepthRenderbuffer = B, this.setupFrameBufferTexture = U, this.useMultisampledRTT = F;
        }
        function Up(t1, e, n) {
            const i = n.isWebGL2;
            return {
                convert: function(n, r = Gs) {
                    let a;
                    const s = fl.getTransfer(r);
                    if (n === Ea) return t1.UNSIGNED_BYTE;
                    if (n === Oa) return t1.UNSIGNED_SHORT_4_4_4_4;
                    if (n === Ra) return t1.UNSIGNED_SHORT_5_5_5_1;
                    if (n === Sa) return t1.BYTE;
                    if (n === Ta) return t1.SHORT;
                    if (n === Ia) return t1.UNSIGNED_SHORT;
                    if (n === Ca) return t1.INT;
                    if (n === Na) return t1.UNSIGNED_INT;
                    if (n === Da) return t1.FLOAT;
                    if (n === La) return i ? t1.HALF_FLOAT : (a = e.get("OES_texture_half_float"), null !== a ? a.HALF_FLOAT_OES : null);
                    if (n === za) return t1.ALPHA;
                    if (n === Ua) return t1.RGBA;
                    if (n === ka) return t1.LUMINANCE;
                    if (n === Ba) return t1.LUMINANCE_ALPHA;
                    if (n === ja) return t1.DEPTH_COMPONENT;
                    if (n === Fa) return t1.DEPTH_STENCIL;
                    if (n === zo) return a = e.get("EXT_sRGB"), null !== a ? a.SRGB_ALPHA_EXT : null;
                    if (n === Ha) return t1.RED;
                    if (n === Va) return t1.RED_INTEGER;
                    if (n === Qa) return t1.RG;
                    if (n === Ga) return t1.RG_INTEGER;
                    if (n === Wa) return t1.RGBA_INTEGER;
                    if (n === Xa || n === Ya || n === Za || n === qa) {
                        if (s === Js) {
                            if (a = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === a) return null;
                            if (n === Xa) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                            if (n === Ya) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                            if (n === Za) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                            if (n === qa) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        } else {
                            if (a = e.get("WEBGL_compressed_texture_s3tc"), null === a) return null;
                            if (n === Xa) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                            if (n === Ya) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                            if (n === Za) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                            if (n === qa) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                        }
                    }
                    if (n === Ja || n === Ka || n === $a || n === ts) {
                        if (a = e.get("WEBGL_compressed_texture_pvrtc"), null === a) return null;
                        if (n === Ja) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                        if (n === Ka) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                        if (n === $a) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                        if (n === ts) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                    }
                    if (n === es) return a = e.get("WEBGL_compressed_texture_etc1"), null !== a ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
                    if (n === ns || n === is) {
                        if (a = e.get("WEBGL_compressed_texture_etc"), null === a) return null;
                        if (n === ns) return s === Js ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                        if (n === is) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
                    }
                    if (n === rs || n === as || n === ss || n === os || n === ls || n === cs || n === us || n === hs || n === ds || n === ps || n === fs || n === ms || n === gs || n === As) {
                        if (a = e.get("WEBGL_compressed_texture_astc"), null === a) return null;
                        if (n === rs) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                        if (n === as) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                        if (n === ss) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                        if (n === os) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                        if (n === ls) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                        if (n === cs) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                        if (n === us) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                        if (n === hs) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                        if (n === ds) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                        if (n === ps) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                        if (n === fs) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                        if (n === ms) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                        if (n === gs) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                        if (n === As) return s === Js ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
                    }
                    if (n === vs || n === ys || n === Ms) {
                        if (a = e.get("EXT_texture_compression_bptc"), null === a) return null;
                        if (n === vs) return s === Js ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                        if (n === ys) return a.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                        if (n === Ms) return a.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                    }
                    if (n === bs || n === xs || n === ws || n === _s) {
                        if (a = e.get("EXT_texture_compression_rgtc"), null === a) return null;
                        if (n === vs) return a.COMPRESSED_RED_RGTC1_EXT;
                        if (n === xs) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                        if (n === ws) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                        if (n === _s) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                    }
                    return n === Pa ? i ? t1.UNSIGNED_INT_24_8 : (a = e.get("WEBGL_depth_texture"), null !== a ? a.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== t1[n] ? t1[n] : null;
                }
            };
        }
        class kp extends th {
            constructor(t1 = []){
                super(), this.isArrayCamera = !0, this.cameras = t1;
            }
        }
        class Bp extends Rc {
            constructor(){
                super(), this.isGroup = !0, this.type = "Group";
            }
        }
        const jp = {
            type: "move"
        };
        class Fp {
            constructor(){
                this._targetRay = null, this._grip = null, this._hand = null;
            }
            getHandSpace() {
                return null === this._hand && (this._hand = new Bp, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                    pinching: !1
                }), this._hand;
            }
            getTargetRaySpace() {
                return null === this._targetRay && (this._targetRay = new Bp, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Ol, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Ol), this._targetRay;
            }
            getGripSpace() {
                return null === this._grip && (this._grip = new Bp, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Ol, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Ol), this._grip;
            }
            dispatchEvent(t1) {
                return null !== this._targetRay && this._targetRay.dispatchEvent(t1), null !== this._grip && this._grip.dispatchEvent(t1), null !== this._hand && this._hand.dispatchEvent(t1), this;
            }
            connect(t1) {
                if (t1 && t1.hand) {
                    const e = this._hand;
                    if (e) for (const n of t1.hand.values())this._getHandJoint(e, n);
                }
                return this.dispatchEvent({
                    type: "connected",
                    data: t1
                }), this;
            }
            disconnect(t1) {
                return this.dispatchEvent({
                    type: "disconnected",
                    data: t1
                }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
            }
            update(t1, e, n) {
                let i = null, r = null, a = null;
                const s = this._targetRay, o = this._grip, l = this._hand;
                if (t1 && "visible-blurred" !== e.session.visibilityState) {
                    if (l && t1.hand) {
                        a = !0;
                        for (const i of t1.hand.values()){
                            const t1 = e.getJointPose(i, n), r = this._getHandJoint(l, i);
                            null !== t1 && (r.matrix.fromArray(t1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = t1.radius), r.visible = null !== t1;
                        }
                        const i = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], s = i.position.distanceTo(r.position), o = .02, c = .005;
                        l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                            type: "pinchend",
                            handedness: t1.handedness,
                            target: this
                        })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                            type: "pinchstart",
                            handedness: t1.handedness,
                            target: this
                        }));
                    } else null !== o && t1.gripSpace && (r = e.getPose(t1.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
                    null !== s && (i = e.getPose(t1.targetRaySpace, n), null === i && null !== r && (i = r), null !== i && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(jp)));
                }
                return null !== s && (s.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== a), this;
            }
            _getHandJoint(t1, e) {
                if (void 0 === t1.joints[e.jointName]) {
                    const n = new Bp;
                    n.matrixAutoUpdate = !1, n.visible = !1, t1.joints[e.jointName] = n, t1.add(n);
                }
                return t1.joints[e.jointName];
            }
        }
        class Hp extends wl {
            constructor(t1, e, n, i, r, a, s, o, l, c){
                if ((c = void 0 !== c ? c : ja) !== ja && c !== Fa) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                void 0 === n && c === ja && (n = Na), void 0 === n && c === Fa && (n = Pa), super(null, i, r, a, s, o, c, n, l), this.isDepthTexture = !0, this.image = {
                    width: t1,
                    height: e
                }, this.magFilter = void 0 !== s ? s : ma, this.minFilter = void 0 !== o ? o : ma, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
            }
            copy(t1) {
                return super.copy(t1), this.compareFunction = t1.compareFunction, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.compareFunction && (e.compareFunction = this.compareFunction), e;
            }
        }
        class Vp extends Bo {
            constructor(t1, e){
                super();
                const n = this;
                let i = null, r = 1, a = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
                const f = e.getContextAttributes();
                let m = null, g = null;
                const A = [], v = [], y = new th;
                y.layers.enable(1), y.viewport = new _l;
                const M = new th;
                M.layers.enable(2), M.viewport = new _l;
                const b = [
                    y,
                    M
                ], x = new kp;
                x.layers.enable(1), x.layers.enable(2);
                let w = null, _ = null;
                function E(t1) {
                    const e = v.indexOf(t1.inputSource);
                    if (-1 === e) return;
                    const n = A[e];
                    void 0 !== n && (n.update(t1.inputSource, t1.frame, l || a), n.dispatchEvent({
                        type: t1.type,
                        data: t1.inputSource
                    }));
                }
                function S() {
                    i.removeEventListener("select", E), i.removeEventListener("selectstart", E), i.removeEventListener("selectend", E), i.removeEventListener("squeeze", E), i.removeEventListener("squeezestart", E), i.removeEventListener("squeezeend", E), i.removeEventListener("end", S), i.removeEventListener("inputsourceschange", T);
                    for(let t1 = 0; t1 < A.length; t1++){
                        const e = v[t1];
                        null !== e && (v[t1] = null, A[t1].disconnect(e));
                    }
                    w = null, _ = null, t1.setRenderTarget(m), d = null, h = null, u = null, i = null, g = null, L.stop(), n.isPresenting = !1, n.dispatchEvent({
                        type: "sessionend"
                    });
                }
                function T(t1) {
                    for(let e = 0; e < t1.removed.length; e++){
                        const n = t1.removed[e], i = v.indexOf(n);
                        i >= 0 && (v[i] = null, A[i].disconnect(n));
                    }
                    for(let e = 0; e < t1.added.length; e++){
                        const n = t1.added[e];
                        let i = v.indexOf(n);
                        if (-1 === i) {
                            for(let t1 = 0; t1 < A.length; t1++){
                                if (t1 >= v.length) {
                                    v.push(n), i = t1;
                                    break;
                                }
                                if (null === v[t1]) {
                                    v[t1] = n, i = t1;
                                    break;
                                }
                            }
                            if (-1 === i) break;
                        }
                        const r = A[i];
                        r && r.connect(n);
                    }
                }
                this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(t1) {
                    let e = A[t1];
                    return void 0 === e && (e = new Fp, A[t1] = e), e.getTargetRaySpace();
                }, this.getControllerGrip = function(t1) {
                    let e = A[t1];
                    return void 0 === e && (e = new Fp, A[t1] = e), e.getGripSpace();
                }, this.getHand = function(t1) {
                    let e = A[t1];
                    return void 0 === e && (e = new Fp, A[t1] = e), e.getHandSpace();
                }, this.setFramebufferScaleFactor = function(t1) {
                    r = t1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                }, this.setReferenceSpaceType = function(t1) {
                    s = t1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                }, this.getReferenceSpace = function() {
                    return l || a;
                }, this.setReferenceSpace = function(t1) {
                    l = t1;
                }, this.getBaseLayer = function() {
                    return null !== h ? h : d;
                }, this.getBinding = function() {
                    return u;
                }, this.getFrame = function() {
                    return p;
                }, this.getSession = function() {
                    return i;
                }, this.setSession = async function(c) {
                    if (i = c, null !== i) {
                        if (m = t1.getRenderTarget(), i.addEventListener("select", E), i.addEventListener("selectstart", E), i.addEventListener("selectend", E), i.addEventListener("squeeze", E), i.addEventListener("squeezestart", E), i.addEventListener("squeezeend", E), i.addEventListener("end", S), i.addEventListener("inputsourceschange", T), !0 !== f.xrCompatible && await e.makeXRCompatible(), void 0 === i.renderState.layers || !1 === t1.capabilities.isWebGL2) {
                            const n = {
                                antialias: void 0 !== i.renderState.layers || f.antialias,
                                alpha: !0,
                                depth: f.depth,
                                stencil: f.stencil,
                                framebufferScaleFactor: r
                            };
                            d = new XRWebGLLayer(i, e, n), i.updateRenderState({
                                baseLayer: d
                            }), g = new Sl(d.framebufferWidth, d.framebufferHeight, {
                                format: Ua,
                                type: Ea,
                                colorSpace: t1.outputColorSpace,
                                stencilBuffer: f.stencil
                            });
                        } else {
                            let n = null, a = null, s = null;
                            f.depth && (s = f.stencil ? e.DEPTH24_STENCIL8 : e.DEPTH_COMPONENT24, n = f.stencil ? Fa : ja, a = f.stencil ? Pa : Na);
                            const o = {
                                colorFormat: e.RGBA8,
                                depthFormat: s,
                                scaleFactor: r
                            };
                            u = new XRWebGLBinding(i, e), h = u.createProjectionLayer(o), i.updateRenderState({
                                layers: [
                                    h
                                ]
                            }), g = new Sl(h.textureWidth, h.textureHeight, {
                                format: Ua,
                                type: Ea,
                                depthTexture: new Hp(h.textureWidth, h.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, n),
                                stencilBuffer: f.stencil,
                                colorSpace: t1.outputColorSpace,
                                samples: f.antialias ? 4 : 0
                            }), t1.properties.get(g).__ignoreDepthValues = h.ignoreDepthValues;
                        }
                        g.isXRRenderTarget = !0, this.setFoveation(o), l = null, a = await i.requestReferenceSpace(s), L.setContext(i), L.start(), n.isPresenting = !0, n.dispatchEvent({
                            type: "sessionstart"
                        });
                    }
                }, this.getEnvironmentBlendMode = function() {
                    if (null !== i) return i.environmentBlendMode;
                };
                const I = new Ol, C = new Ol;
                function N(t1, e) {
                    null === e ? t1.matrixWorld.copy(t1.matrix) : t1.matrixWorld.multiplyMatrices(e.matrixWorld, t1.matrix), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                }
                this.updateCamera = function(t1) {
                    if (null === i) return;
                    x.near = M.near = y.near = t1.near, x.far = M.far = y.far = t1.far, w === x.near && _ === x.far || (i.updateRenderState({
                        depthNear: x.near,
                        depthFar: x.far
                    }), w = x.near, _ = x.far);
                    const e = t1.parent, n = x.cameras;
                    N(x, e);
                    for(let t1 = 0; t1 < n.length; t1++)N(n[t1], e);
                    2 === n.length ? function(t1, e, n) {
                        I.setFromMatrixPosition(e.matrixWorld), C.setFromMatrixPosition(n.matrixWorld);
                        const i = I.distanceTo(C), r = e.projectionMatrix.elements, a = n.projectionMatrix.elements, s = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], u = (r[8] - 1) / r[0], h = (a[8] + 1) / a[0], d = s * u, p = s * h, f = i / (-u + h), m = f * -u;
                        e.matrixWorld.decompose(t1.position, t1.quaternion, t1.scale), t1.translateX(m), t1.translateZ(f), t1.matrixWorld.compose(t1.position, t1.quaternion, t1.scale), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                        const g = s + f, A = o + f, v = d - m, y = p + (i - m), M = l * o / A * g, b = c * o / A * g;
                        t1.projectionMatrix.makePerspective(v, y, M, b, g, A), t1.projectionMatrixInverse.copy(t1.projectionMatrix).invert();
                    }(x, y, M) : x.projectionMatrix.copy(y.projectionMatrix), function(t1, e, n) {
                        null === n ? t1.matrix.copy(e.matrixWorld) : (t1.matrix.copy(n.matrixWorld), t1.matrix.invert(), t1.matrix.multiply(e.matrixWorld)), t1.matrix.decompose(t1.position, t1.quaternion, t1.scale), t1.updateMatrixWorld(!0), t1.projectionMatrix.copy(e.projectionMatrix), t1.projectionMatrixInverse.copy(e.projectionMatrixInverse), t1.isPerspectiveCamera && (t1.fov = 2 * Vo * Math.atan(1 / t1.projectionMatrix.elements[5]), t1.zoom = 1);
                    }(t1, x, e);
                }, this.getCamera = function() {
                    return x;
                }, this.getFoveation = function() {
                    if (null !== h || null !== d) return o;
                }, this.setFoveation = function(t1) {
                    o = t1, null !== h && (h.fixedFoveation = t1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = t1);
                };
                let D = null;
                const L = new dh;
                L.setAnimationLoop(function(e, i) {
                    if (c = i.getViewerPose(l || a), p = i, null !== c) {
                        const e = c.views;
                        null !== d && (t1.setRenderTargetFramebuffer(g, d.framebuffer), t1.setRenderTarget(g));
                        let n = !1;
                        e.length !== x.cameras.length && (x.cameras.length = 0, n = !0);
                        for(let i = 0; i < e.length; i++){
                            const r = e[i];
                            let a = null;
                            if (null !== d) a = d.getViewport(r);
                            else {
                                const e = u.getViewSubImage(h, r);
                                a = e.viewport, 0 === i && (t1.setRenderTargetTextures(g, e.colorTexture, h.ignoreDepthValues ? void 0 : e.depthStencilTexture), t1.setRenderTarget(g));
                            }
                            let s = b[i];
                            void 0 === s && (s = new th, s.layers.enable(i), s.viewport = new _l, b[i] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(a.x, a.y, a.width, a.height), 0 === i && (x.matrix.copy(s.matrix), x.matrix.decompose(x.position, x.quaternion, x.scale)), !0 === n && x.cameras.push(s);
                        }
                    }
                    for(let t1 = 0; t1 < A.length; t1++){
                        const e = v[t1], n = A[t1];
                        null !== e && void 0 !== n && n.update(e, i, l || a);
                    }
                    D && D(e, i), i.detectedPlanes && n.dispatchEvent({
                        type: "planesdetected",
                        data: i
                    }), p = null;
                }), this.setAnimationLoop = function(t1) {
                    D = t1;
                }, this.dispose = function() {};
            }
        }
        function Qp(t1, e) {
            function n(t1, e) {
                !0 === t1.matrixAutoUpdate && t1.updateMatrix(), e.value.copy(t1.matrix);
            }
            function i(i, r) {
                i.opacity.value = r.opacity, r.color && i.diffuse.value.copy(r.color), r.emissive && i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (i.map.value = r.map, n(r.map, i.mapTransform)), r.alphaMap && (i.alphaMap.value = r.alphaMap, n(r.alphaMap, i.alphaMapTransform)), r.bumpMap && (i.bumpMap.value = r.bumpMap, n(r.bumpMap, i.bumpMapTransform), i.bumpScale.value = r.bumpScale, r.side === dr && (i.bumpScale.value *= -1)), r.normalMap && (i.normalMap.value = r.normalMap, n(r.normalMap, i.normalMapTransform), i.normalScale.value.copy(r.normalScale), r.side === dr && i.normalScale.value.negate()), r.displacementMap && (i.displacementMap.value = r.displacementMap, n(r.displacementMap, i.displacementMapTransform), i.displacementScale.value = r.displacementScale, i.displacementBias.value = r.displacementBias), r.emissiveMap && (i.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, i.emissiveMapTransform)), r.specularMap && (i.specularMap.value = r.specularMap, n(r.specularMap, i.specularMapTransform)), r.alphaTest > 0 && (i.alphaTest.value = r.alphaTest);
                const a = e.get(r).envMap;
                if (a && (i.envMap.value = a, i.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, i.reflectivity.value = r.reflectivity, i.ior.value = r.ior, i.refractionRatio.value = r.refractionRatio), r.lightMap) {
                    i.lightMap.value = r.lightMap;
                    const e = !0 === t1._useLegacyLights ? Math.PI : 1;
                    i.lightMapIntensity.value = r.lightMapIntensity * e, n(r.lightMap, i.lightMapTransform);
                }
                r.aoMap && (i.aoMap.value = r.aoMap, i.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, i.aoMapTransform));
            }
            return {
                refreshFogUniforms: function(e, n) {
                    n.color.getRGB(e.fogColor.value, qu(t1)), n.isFog ? (e.fogNear.value = n.near, e.fogFar.value = n.far) : n.isFogExp2 && (e.fogDensity.value = n.density);
                },
                refreshMaterialUniforms: function(t1, r, a, s, o) {
                    r.isMeshBasicMaterial || r.isMeshLambertMaterial ? i(t1, r) : r.isMeshToonMaterial ? (i(t1, r), function(t1, e) {
                        e.gradientMap && (t1.gradientMap.value = e.gradientMap);
                    }(t1, r)) : r.isMeshPhongMaterial ? (i(t1, r), function(t1, e) {
                        t1.specular.value.copy(e.specular), t1.shininess.value = Math.max(e.shininess, 1e-4);
                    }(t1, r)) : r.isMeshStandardMaterial ? (i(t1, r), function(t1, i) {
                        t1.metalness.value = i.metalness, i.metalnessMap && (t1.metalnessMap.value = i.metalnessMap, n(i.metalnessMap, t1.metalnessMapTransform)), t1.roughness.value = i.roughness, i.roughnessMap && (t1.roughnessMap.value = i.roughnessMap, n(i.roughnessMap, t1.roughnessMapTransform));
                        e.get(i).envMap && (t1.envMapIntensity.value = i.envMapIntensity);
                    }(t1, r), r.isMeshPhysicalMaterial && function(t1, e, i) {
                        t1.ior.value = e.ior, e.sheen > 0 && (t1.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t1.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t1.sheenColorMap.value = e.sheenColorMap, n(e.sheenColorMap, t1.sheenColorMapTransform)), e.sheenRoughnessMap && (t1.sheenRoughnessMap.value = e.sheenRoughnessMap, n(e.sheenRoughnessMap, t1.sheenRoughnessMapTransform))), e.clearcoat > 0 && (t1.clearcoat.value = e.clearcoat, t1.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t1.clearcoatMap.value = e.clearcoatMap, n(e.clearcoatMap, t1.clearcoatMapTransform)), e.clearcoatRoughnessMap && (t1.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap, n(e.clearcoatRoughnessMap, t1.clearcoatRoughnessMapTransform)), e.clearcoatNormalMap && (t1.clearcoatNormalMap.value = e.clearcoatNormalMap, n(e.clearcoatNormalMap, t1.clearcoatNormalMapTransform), t1.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), e.side === dr && t1.clearcoatNormalScale.value.negate())), e.iridescence > 0 && (t1.iridescence.value = e.iridescence, t1.iridescenceIOR.value = e.iridescenceIOR, t1.iridescenceThicknessMinimum.value = e.iridescenceThicknessRange[0], t1.iridescenceThicknessMaximum.value = e.iridescenceThicknessRange[1], e.iridescenceMap && (t1.iridescenceMap.value = e.iridescenceMap, n(e.iridescenceMap, t1.iridescenceMapTransform)), e.iridescenceThicknessMap && (t1.iridescenceThicknessMap.value = e.iridescenceThicknessMap, n(e.iridescenceThicknessMap, t1.iridescenceThicknessMapTransform))), e.transmission > 0 && (t1.transmission.value = e.transmission, t1.transmissionSamplerMap.value = i.texture, t1.transmissionSamplerSize.value.set(i.width, i.height), e.transmissionMap && (t1.transmissionMap.value = e.transmissionMap, n(e.transmissionMap, t1.transmissionMapTransform)), t1.thickness.value = e.thickness, e.thicknessMap && (t1.thicknessMap.value = e.thicknessMap, n(e.thicknessMap, t1.thicknessMapTransform)), t1.attenuationDistance.value = e.attenuationDistance, t1.attenuationColor.value.copy(e.attenuationColor)), e.anisotropy > 0 && (t1.anisotropyVector.value.set(e.anisotropy * Math.cos(e.anisotropyRotation), e.anisotropy * Math.sin(e.anisotropyRotation)), e.anisotropyMap && (t1.anisotropyMap.value = e.anisotropyMap, n(e.anisotropyMap, t1.anisotropyMapTransform))), t1.specularIntensity.value = e.specularIntensity, t1.specularColor.value.copy(e.specularColor), e.specularColorMap && (t1.specularColorMap.value = e.specularColorMap, n(e.specularColorMap, t1.specularColorMapTransform)), e.specularIntensityMap && (t1.specularIntensityMap.value = e.specularIntensityMap, n(e.specularIntensityMap, t1.specularIntensityMapTransform));
                    }(t1, r, o)) : r.isMeshMatcapMaterial ? (i(t1, r), function(t1, e) {
                        e.matcap && (t1.matcap.value = e.matcap);
                    }(t1, r)) : r.isMeshDepthMaterial ? i(t1, r) : r.isMeshDistanceMaterial ? (i(t1, r), function(t1, n) {
                        const i = e.get(n).light;
                        t1.referencePosition.value.setFromMatrixPosition(i.matrixWorld), t1.nearDistance.value = i.shadow.camera.near, t1.farDistance.value = i.shadow.camera.far;
                    }(t1, r)) : r.isMeshNormalMaterial ? i(t1, r) : r.isLineBasicMaterial ? (function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, e.map && (t1.map.value = e.map, n(e.map, t1.mapTransform));
                    }(t1, r), r.isLineDashedMaterial && function(t1, e) {
                        t1.dashSize.value = e.dashSize, t1.totalSize.value = e.dashSize + e.gapSize, t1.scale.value = e.scale;
                    }(t1, r)) : r.isPointsMaterial ? function(t1, e, i, r) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.size.value = e.size * i, t1.scale.value = .5 * r, e.map && (t1.map.value = e.map, n(e.map, t1.uvTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, n(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r, a, s) : r.isSpriteMaterial ? function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.rotation.value = e.rotation, e.map && (t1.map.value = e.map, n(e.map, t1.mapTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, n(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r) : r.isShadowMaterial ? (t1.color.value.copy(r.color), t1.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
                }
            };
        }
        function Gp(t1, e, n, i) {
            let r = {}, a = {}, s = [];
            const o = n.isWebGL2 ? t1.getParameter(t1.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
            function l(t1, e, n) {
                const i = t1.value;
                if (void 0 === n[e]) {
                    if ("number" == typeof i) n[e] = i;
                    else {
                        const t1 = Array.isArray(i) ? i : [
                            i
                        ], r = [];
                        for(let e = 0; e < t1.length; e++)r.push(t1[e].clone());
                        n[e] = r;
                    }
                    return !0;
                }
                if ("number" == typeof i) {
                    if (n[e] !== i) return n[e] = i, !0;
                } else {
                    const t1 = Array.isArray(n[e]) ? n[e] : [
                        n[e]
                    ], r = Array.isArray(i) ? i : [
                        i
                    ];
                    for(let e = 0; e < t1.length; e++){
                        const n = t1[e];
                        if (!1 === n.equals(r[e])) return n.copy(r[e]), !0;
                    }
                }
                return !1;
            }
            function c(t1) {
                const e = {
                    boundary: 0,
                    storage: 0
                };
                return "number" == typeof t1 ? (e.boundary = 4, e.storage = 4) : t1.isVector2 ? (e.boundary = 8, e.storage = 8) : t1.isVector3 || t1.isColor ? (e.boundary = 16, e.storage = 12) : t1.isVector4 ? (e.boundary = 16, e.storage = 16) : t1.isMatrix3 ? (e.boundary = 48, e.storage = 48) : t1.isMatrix4 ? (e.boundary = 64, e.storage = 64) : t1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", t1), e;
            }
            function u(e) {
                const n = e.target;
                n.removeEventListener("dispose", u);
                const i = s.indexOf(n.__bindingPointIndex);
                s.splice(i, 1), t1.deleteBuffer(r[n.id]), delete r[n.id], delete a[n.id];
            }
            return {
                bind: function(t1, e) {
                    const n = e.program;
                    i.uniformBlockBinding(t1, n);
                },
                update: function(n, h) {
                    let d = r[n.id];
                    void 0 === d && (function(t1) {
                        const e = t1.uniforms;
                        let n = 0;
                        let i = 0;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = {
                                boundary: 0,
                                storage: 0
                            }, s = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            for(let t1 = 0, e = s.length; t1 < e; t1++){
                                const e = c(s[t1]);
                                a.boundary += e.boundary, a.storage += e.storage;
                            }
                            r.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = n, t1 > 0 && (i = n % 16, 0 !== i && 16 - i - a.boundary < 0 && (n += 16 - i, r.__offset = n)), n += a.storage;
                        }
                        i = n % 16, i > 0 && (n += 16 - i), t1.__size = n, t1.__cache = {};
                    }(n), d = function(e) {
                        const n = function() {
                            for(let t1 = 0; t1 < o; t1++)if (-1 === s.indexOf(t1)) return s.push(t1), t1;
                            return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                        }();
                        e.__bindingPointIndex = n;
                        const i = t1.createBuffer(), r = e.__size, a = e.usage;
                        return t1.bindBuffer(t1.UNIFORM_BUFFER, i), t1.bufferData(t1.UNIFORM_BUFFER, r, a), t1.bindBuffer(t1.UNIFORM_BUFFER, null), t1.bindBufferBase(t1.UNIFORM_BUFFER, n, i), i;
                    }(n), r[n.id] = d, n.addEventListener("dispose", u));
                    const p = h.program;
                    i.updateUBOMapping(n, p);
                    const f = e.render.frame;
                    a[n.id] !== f && (function(e) {
                        const n = r[e.id], i = e.uniforms, a = e.__cache;
                        t1.bindBuffer(t1.UNIFORM_BUFFER, n);
                        for(let e = 0, n = i.length; e < n; e++){
                            const n = i[e];
                            if (!0 === l(n, e, a)) {
                                const e = n.__offset, i = Array.isArray(n.value) ? n.value : [
                                    n.value
                                ];
                                let r = 0;
                                for(let a = 0; a < i.length; a++){
                                    const s = i[a], o = c(s);
                                    "number" == typeof s ? (n.__data[0] = s, t1.bufferSubData(t1.UNIFORM_BUFFER, e + r, n.__data)) : s.isMatrix3 ? (n.__data[0] = s.elements[0], n.__data[1] = s.elements[1], n.__data[2] = s.elements[2], n.__data[3] = s.elements[0], n.__data[4] = s.elements[3], n.__data[5] = s.elements[4], n.__data[6] = s.elements[5], n.__data[7] = s.elements[0], n.__data[8] = s.elements[6], n.__data[9] = s.elements[7], n.__data[10] = s.elements[8], n.__data[11] = s.elements[0]) : (s.toArray(n.__data, r), r += o.storage / Float32Array.BYTES_PER_ELEMENT);
                                }
                                t1.bufferSubData(t1.UNIFORM_BUFFER, e, n.__data);
                            }
                        }
                        t1.bindBuffer(t1.UNIFORM_BUFFER, null);
                    }(n), a[n.id] = f);
                },
                dispose: function() {
                    for(const e in r)t1.deleteBuffer(r[e]);
                    s = [], r = {}, a = {};
                }
            };
        }
        class Wp {
            constructor(t1 = {}){
                const { canvas: e = ol(), context: n = null, depth: i = !0, stencil: r = !0, alpha: a = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1 } = t1;
                let h;
                this.isWebGLRenderer = !0, h = null !== n ? n.getContextAttributes().alpha : a;
                const d = new Uint32Array(4), p = new Int32Array(4);
                let f = null, m = null;
                const g = [], A = [];
                this.domElement = e, this.debug = {
                    checkShaderErrors: !0,
                    onShaderError: null
                }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = Ws, this._useLegacyLights = !1, this.toneMapping = Kr, this.toneMappingExposure = 1;
                const v = this;
                let y = !1, M = 0, b = 0, x = null, w = -1, _ = null;
                const E = new _l, S = new _l;
                let T = null;
                const I = new Jc(0);
                let C = 0, N = e.width, D = e.height, L = 1, O = null, R = null;
                const P = new _l(0, 0, N, D), z = new _l(0, 0, N, D);
                let U = !1;
                const k = new hh;
                let B = !1, j = !1, F = null;
                const H = new cc, V = new tl, Q = new Ol, G = {
                    background: null,
                    fog: null,
                    environment: null,
                    overrideMaterial: null,
                    isScene: !0
                };
                function W() {
                    return null === x ? L : 1;
                }
                let X, Y, Z, q, J, K, $, tt, et, nt, it, rt, at, st, ot, lt, ct, ut, ht, dt, pt, ft, mt, gt, At = n;
                function vt(t1, n) {
                    for(let i = 0; i < t1.length; i++){
                        const r = t1[i], a = e.getContext(r, n);
                        if (null !== a) return a;
                    }
                    return null;
                }
                try {
                    const t1 = {
                        alpha: !0,
                        depth: i,
                        stencil: r,
                        antialias: s,
                        premultipliedAlpha: o,
                        preserveDrawingBuffer: l,
                        powerPreference: c,
                        failIfMajorPerformanceCaveat: u
                    };
                    if ("setAttribute" in e && e.setAttribute("data-engine", `three.js r${tr}`), e.addEventListener("webglcontextlost", bt, !1), e.addEventListener("webglcontextrestored", xt, !1), e.addEventListener("webglcontextcreationerror", wt, !1), null === At) {
                        const e = [
                            "webgl2",
                            "webgl",
                            "experimental-webgl"
                        ];
                        if (!0 === v.isWebGL1Renderer && e.shift(), At = vt(e, t1), null === At) throw vt(e) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                    }
                    "undefined" != typeof WebGLRenderingContext && At instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === At.getShaderPrecisionFormat && (At.getShaderPrecisionFormat = function() {
                        return {
                            rangeMin: 1,
                            rangeMax: 1,
                            precision: 1
                        };
                    });
                } catch (t1) {
                    throw console.error("THREE.WebGLRenderer: " + t1.message), t1;
                }
                function yt() {
                    X = new Fh(At), Y = new xh(At, X, t1), X.init(Y), ft = new Up(At, X, Y), Z = new Pp(At, X, Y), q = new Qh(At), J = new bp, K = new zp(At, X, Z, J, Y, ft, q), $ = new _h(v), tt = new jh(v), et = new ph(At, Y), mt = new Mh(At, X, et, Y), nt = new Hh(At, et, q, mt), it = new Yh(At, nt, et, q), ht = new Xh(At, Y, K), lt = new wh(J), rt = new Mp(v, $, tt, X, Y, mt, lt), at = new Qp(v, J), st = new Ep, ot = new Dp(X, Y), ut = new yh(v, $, tt, Z, it, h, o), ct = new Rp(v, it, Y), gt = new Gp(At, q, Y, Z), dt = new bh(At, X, q, Y), pt = new Vh(At, X, q, Y), q.programs = rt.programs, v.capabilities = Y, v.extensions = X, v.properties = J, v.renderLists = st, v.shadowMap = ct, v.state = Z, v.info = q;
                }
                yt();
                const Mt = new Vp(v, At);
                function bt(t1) {
                    t1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), y = !0;
                }
                function xt() {
                    console.log("THREE.WebGLRenderer: Context Restored."), y = !1;
                    const t1 = q.autoReset, e = ct.enabled, n = ct.autoUpdate, i = ct.needsUpdate, r = ct.type;
                    yt(), q.autoReset = t1, ct.enabled = e, ct.autoUpdate = n, ct.needsUpdate = i, ct.type = r;
                }
                function wt(t1) {
                    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", t1.statusMessage);
                }
                function _t(t1) {
                    const e = t1.target;
                    e.removeEventListener("dispose", _t), function(t1) {
                        (function(t1) {
                            const e = J.get(t1).programs;
                            void 0 !== e && (e.forEach(function(t1) {
                                rt.releaseProgram(t1);
                            }), t1.isShaderMaterial && rt.releaseShaderCache(t1));
                        })(t1), J.remove(t1);
                    }(e);
                }
                function Et(t1, e, n) {
                    !0 === t1.transparent && t1.side === pr && !1 === t1.forceSinglePass ? (t1.side = dr, t1.needsUpdate = !0, Rt(t1, e, n), t1.side = hr, t1.needsUpdate = !0, Rt(t1, e, n), t1.side = pr) : Rt(t1, e, n);
                }
                this.xr = Mt, this.getContext = function() {
                    return At;
                }, this.getContextAttributes = function() {
                    return At.getContextAttributes();
                }, this.forceContextLoss = function() {
                    const t1 = X.get("WEBGL_lose_context");
                    t1 && t1.loseContext();
                }, this.forceContextRestore = function() {
                    const t1 = X.get("WEBGL_lose_context");
                    t1 && t1.restoreContext();
                }, this.getPixelRatio = function() {
                    return L;
                }, this.setPixelRatio = function(t1) {
                    void 0 !== t1 && (L = t1, this.setSize(N, D, !1));
                }, this.getSize = function(t1) {
                    return t1.set(N, D);
                }, this.setSize = function(t1, n, i = !0) {
                    Mt.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (N = t1, D = n, e.width = Math.floor(t1 * L), e.height = Math.floor(n * L), !0 === i && (e.style.width = t1 + "px", e.style.height = n + "px"), this.setViewport(0, 0, t1, n));
                }, this.getDrawingBufferSize = function(t1) {
                    return t1.set(N * L, D * L).floor();
                }, this.setDrawingBufferSize = function(t1, n, i) {
                    N = t1, D = n, L = i, e.width = Math.floor(t1 * i), e.height = Math.floor(n * i), this.setViewport(0, 0, t1, n);
                }, this.getCurrentViewport = function(t1) {
                    return t1.copy(E);
                }, this.getViewport = function(t1) {
                    return t1.copy(P);
                }, this.setViewport = function(t1, e, n, i) {
                    t1.isVector4 ? P.set(t1.x, t1.y, t1.z, t1.w) : P.set(t1, e, n, i), Z.viewport(E.copy(P).multiplyScalar(L).floor());
                }, this.getScissor = function(t1) {
                    return t1.copy(z);
                }, this.setScissor = function(t1, e, n, i) {
                    t1.isVector4 ? z.set(t1.x, t1.y, t1.z, t1.w) : z.set(t1, e, n, i), Z.scissor(S.copy(z).multiplyScalar(L).floor());
                }, this.getScissorTest = function() {
                    return U;
                }, this.setScissorTest = function(t1) {
                    Z.setScissorTest(U = t1);
                }, this.setOpaqueSort = function(t1) {
                    O = t1;
                }, this.setTransparentSort = function(t1) {
                    R = t1;
                }, this.getClearColor = function(t1) {
                    return t1.copy(ut.getClearColor());
                }, this.setClearColor = function() {
                    ut.setClearColor.apply(ut, arguments);
                }, this.getClearAlpha = function() {
                    return ut.getClearAlpha();
                }, this.setClearAlpha = function() {
                    ut.setClearAlpha.apply(ut, arguments);
                }, this.clear = function(t1 = !0, e = !0, n = !0) {
                    let i = 0;
                    if (t1) {
                        let t1 = !1;
                        if (null !== x) {
                            const e = x.texture.format;
                            t1 = e === Wa || e === Ga || e === Va;
                        }
                        if (t1) {
                            const t1 = x.texture.type, e = t1 === Ea || t1 === Na || t1 === Ia || t1 === Pa || t1 === Oa || t1 === Ra, n = ut.getClearColor(), i = ut.getClearAlpha(), r = n.r, a = n.g, s = n.b;
                            e ? (d[0] = r, d[1] = a, d[2] = s, d[3] = i, At.clearBufferuiv(At.COLOR, 0, d)) : (p[0] = r, p[1] = a, p[2] = s, p[3] = i, At.clearBufferiv(At.COLOR, 0, p));
                        } else i |= At.COLOR_BUFFER_BIT;
                    }
                    e && (i |= At.DEPTH_BUFFER_BIT), n && (i |= At.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), At.clear(i);
                }, this.clearColor = function() {
                    this.clear(!0, !1, !1);
                }, this.clearDepth = function() {
                    this.clear(!1, !0, !1);
                }, this.clearStencil = function() {
                    this.clear(!1, !1, !0);
                }, this.dispose = function() {
                    e.removeEventListener("webglcontextlost", bt, !1), e.removeEventListener("webglcontextrestored", xt, !1), e.removeEventListener("webglcontextcreationerror", wt, !1), st.dispose(), ot.dispose(), J.dispose(), $.dispose(), tt.dispose(), it.dispose(), mt.dispose(), gt.dispose(), rt.dispose(), Mt.dispose(), Mt.removeEventListener("sessionstart", Tt), Mt.removeEventListener("sessionend", It), F && (F.dispose(), F = null), Ct.stop();
                }, this.renderBufferDirect = function(t1, e, n, i, r, a) {
                    null === e && (e = G);
                    const s = r.isMesh && r.matrixWorld.determinant() < 0, o = function(t1, e, n, i, r) {
                        !0 !== e.isScene && (e = G), K.resetTextureUnits();
                        const a = e.fog, s = i.isMeshStandardMaterial ? e.environment : null, o = null === x ? v.outputColorSpace : !0 === x.isXRRenderTarget ? x.texture.colorSpace : Xs, l = (i.isMeshStandardMaterial ? tt : $).get(i.envMap || s), c = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize, u = !!n.attributes.tangent && (!!i.normalMap || i.anisotropy > 0), h = !!n.morphAttributes.position, d = !!n.morphAttributes.normal, p = !!n.morphAttributes.color;
                        let f = Kr;
                        i.toneMapped && (null !== x && !0 !== x.isXRRenderTarget || (f = v.toneMapping));
                        const g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, A = void 0 !== g ? g.length : 0, y = J.get(i), M = m.state.lights;
                        if (!0 === B && (!0 === j || t1 !== _)) {
                            const e = t1 === _ && i.id === w;
                            lt.setState(i, t1, e);
                        }
                        let b = !1;
                        i.version === y.__version ? y.needsLights && y.lightsStateVersion !== M.state.version || y.outputColorSpace !== o || r.isInstancedMesh && !1 === y.instancing ? b = !0 : r.isInstancedMesh || !0 !== y.instancing ? r.isSkinnedMesh && !1 === y.skinning ? b = !0 : r.isSkinnedMesh || !0 !== y.skinning ? r.isInstancedMesh && !0 === y.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === y.instancingColor && null !== r.instanceColor || y.envMap !== l || !0 === i.fog && y.fog !== a ? b = !0 : void 0 === y.numClippingPlanes || y.numClippingPlanes === lt.numPlanes && y.numIntersection === lt.numIntersection ? (y.vertexAlphas !== c || y.vertexTangents !== u || y.morphTargets !== h || y.morphNormals !== d || y.morphColors !== p || y.toneMapping !== f || !0 === Y.isWebGL2 && y.morphTargetsCount !== A) && (b = !0) : b = !0 : b = !0 : b = !0 : (b = !0, y.__version = i.version);
                        let E = y.currentProgram;
                        !0 === b && (E = Rt(i, e, r));
                        let S = !1, T = !1, I = !1;
                        const C = E.getUniforms(), N = y.uniforms;
                        if (Z.useProgram(E.program) && (S = !0, T = !0, I = !0), i.id !== w && (w = i.id, T = !0), S || _ !== t1) {
                            C.setValue(At, "projectionMatrix", t1.projectionMatrix), C.setValue(At, "viewMatrix", t1.matrixWorldInverse);
                            const e = C.map.cameraPosition;
                            void 0 !== e && e.setValue(At, Q.setFromMatrixPosition(t1.matrixWorld)), Y.logarithmicDepthBuffer && C.setValue(At, "logDepthBufFC", 2 / (Math.log(t1.far + 1) / Math.LN2)), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && C.setValue(At, "isOrthographic", !0 === t1.isOrthographicCamera), _ !== t1 && (_ = t1, T = !0, I = !0);
                        }
                        if (r.isSkinnedMesh) {
                            C.setOptional(At, r, "bindMatrix"), C.setOptional(At, r, "bindMatrixInverse");
                            const t1 = r.skeleton;
                            t1 && (Y.floatVertexTextures ? (null === t1.boneTexture && t1.computeBoneTexture(), C.setValue(At, "boneTexture", t1.boneTexture, K), C.setValue(At, "boneTextureSize", t1.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
                        }
                        const O = n.morphAttributes;
                        var R, P;
                        if ((void 0 !== O.position || void 0 !== O.normal || void 0 !== O.color && !0 === Y.isWebGL2) && ht.update(r, n, E), (T || y.receiveShadow !== r.receiveShadow) && (y.receiveShadow = r.receiveShadow, C.setValue(At, "receiveShadow", r.receiveShadow)), i.isMeshGouraudMaterial && null !== i.envMap && (N.envMap.value = l, N.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), T && (C.setValue(At, "toneMappingExposure", v.toneMappingExposure), y.needsLights && (P = I, (R = N).ambientLightColor.needsUpdate = P, R.lightProbe.needsUpdate = P, R.directionalLights.needsUpdate = P, R.directionalLightShadows.needsUpdate = P, R.pointLights.needsUpdate = P, R.pointLightShadows.needsUpdate = P, R.spotLights.needsUpdate = P, R.spotLightShadows.needsUpdate = P, R.rectAreaLights.needsUpdate = P, R.hemisphereLights.needsUpdate = P), a && !0 === i.fog && at.refreshFogUniforms(N, a), at.refreshMaterialUniforms(N, i, L, D, F), Kd.upload(At, Pt(y), N, K)), i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (Kd.upload(At, Pt(y), N, K), i.uniformsNeedUpdate = !1), i.isSpriteMaterial && C.setValue(At, "center", r.center), C.setValue(At, "modelViewMatrix", r.modelViewMatrix), C.setValue(At, "normalMatrix", r.normalMatrix), C.setValue(At, "modelMatrix", r.matrixWorld), i.isShaderMaterial || i.isRawShaderMaterial) {
                            const t1 = i.uniformsGroups;
                            for(let e = 0, n = t1.length; e < n; e++)if (Y.isWebGL2) {
                                const n = t1[e];
                                gt.update(n, E), gt.bind(n, E);
                            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
                        }
                        return E;
                    }(t1, e, n, i, r);
                    Z.setMaterial(i, s);
                    let l = n.index, c = 1;
                    if (!0 === i.wireframe) {
                        if (l = nt.getWireframeAttribute(n), void 0 === l) return;
                        c = 2;
                    }
                    const u = n.drawRange, h = n.attributes.position;
                    let d = u.start * c, p = (u.start + u.count) * c;
                    null !== a && (d = Math.max(d, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
                    const f = p - d;
                    if (f < 0 || f === 1 / 0) return;
                    let g;
                    mt.setup(r, i, o, n, l);
                    let A = dt;
                    if (null !== l && (g = et.get(l), A = pt, A.setIndex(g)), r.isMesh) !0 === i.wireframe ? (Z.setLineWidth(i.wireframeLinewidth * W()), A.setMode(At.LINES)) : A.setMode(At.TRIANGLES);
                    else if (r.isLine) {
                        let t1 = i.linewidth;
                        void 0 === t1 && (t1 = 1), Z.setLineWidth(t1 * W()), r.isLineSegments ? A.setMode(At.LINES) : r.isLineLoop ? A.setMode(At.LINE_LOOP) : A.setMode(At.LINE_STRIP);
                    } else r.isPoints ? A.setMode(At.POINTS) : r.isSprite && A.setMode(At.TRIANGLES);
                    if (r.isInstancedMesh) A.renderInstances(d, f, r.count);
                    else if (n.isInstancedBufferGeometry) {
                        const t1 = void 0 !== n._maxInstanceCount ? n._maxInstanceCount : 1 / 0, e = Math.min(n.instanceCount, t1);
                        A.renderInstances(d, f, e);
                    } else A.render(d, f);
                }, this.compile = function(t1, e, n = null) {
                    null === n && (n = t1), m = ot.get(n), m.init(), A.push(m), n.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (m.pushLight(t1), t1.castShadow && m.pushShadow(t1));
                    }), t1 !== n && t1.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (m.pushLight(t1), t1.castShadow && m.pushShadow(t1));
                    }), m.setupLights(v._useLegacyLights);
                    const i = new Set;
                    return t1.traverse(function(t1) {
                        const e = t1.material;
                        if (e) {
                            if (Array.isArray(e)) for(let r = 0; r < e.length; r++){
                                const a = e[r];
                                Et(a, n, t1), i.add(a);
                            }
                            else Et(e, n, t1), i.add(e);
                        }
                    }), A.pop(), m = null, i;
                }, this.compileAsync = function(t1, e, n = null) {
                    const i = this.compile(t1, e, n);
                    return new Promise((e)=>{
                        function n() {
                            i.forEach(function(t1) {
                                J.get(t1).currentProgram.isReady() && i.delete(t1);
                            }), 0 !== i.size ? setTimeout(n, 10) : e(t1);
                        }
                        null !== X.get("KHR_parallel_shader_compile") ? n() : setTimeout(n, 10);
                    });
                };
                let St = null;
                function Tt() {
                    Ct.stop();
                }
                function It() {
                    Ct.start();
                }
                const Ct = new dh;
                function Nt(t1, e, n, i) {
                    if (!1 === t1.visible) return;
                    if (t1.layers.test(e.layers)) {
                        if (t1.isGroup) n = t1.renderOrder;
                        else if (t1.isLOD) !0 === t1.autoUpdate && t1.update(e);
                        else if (t1.isLight) m.pushLight(t1), t1.castShadow && m.pushShadow(t1);
                        else if (t1.isSprite) {
                            if (!t1.frustumCulled || k.intersectsSprite(t1)) {
                                i && Q.setFromMatrixPosition(t1.matrixWorld).applyMatrix4(H);
                                const e = it.update(t1), r = t1.material;
                                r.visible && f.push(t1, e, r, n, Q.z, null);
                            }
                        } else if ((t1.isMesh || t1.isLine || t1.isPoints) && (!t1.frustumCulled || k.intersectsObject(t1))) {
                            const e = it.update(t1), r = t1.material;
                            if (i && (void 0 !== t1.boundingSphere ? (null === t1.boundingSphere && t1.computeBoundingSphere(), Q.copy(t1.boundingSphere.center)) : (null === e.boundingSphere && e.computeBoundingSphere(), Q.copy(e.boundingSphere.center)), Q.applyMatrix4(t1.matrixWorld).applyMatrix4(H)), Array.isArray(r)) {
                                const i = e.groups;
                                for(let a = 0, s = i.length; a < s; a++){
                                    const s = i[a], o = r[s.materialIndex];
                                    o && o.visible && f.push(t1, e, o, n, Q.z, s);
                                }
                            } else r.visible && f.push(t1, e, r, n, Q.z, null);
                        }
                    }
                    const r = t1.children;
                    for(let t1 = 0, a = r.length; t1 < a; t1++)Nt(r[t1], e, n, i);
                }
                function Dt(t1, e, n, i) {
                    const r = t1.opaque, a = t1.transmissive, s = t1.transparent;
                    m.setupLightsView(n), !0 === B && lt.setGlobalState(v.clippingPlanes, n), a.length > 0 && function(t1, e, n, i) {
                        if (null !== (!0 === n.isScene ? n.overrideMaterial : null)) return;
                        const r = Y.isWebGL2;
                        null === F && (F = new Sl(1, 1, {
                            generateMipmaps: !0,
                            type: X.has("EXT_color_buffer_half_float") ? La : Ea,
                            minFilter: wa,
                            samples: r ? 4 : 0
                        })), v.getDrawingBufferSize(V), r ? F.setSize(V.x, V.y) : F.setSize(qo(V.x), qo(V.y));
                        const a = v.getRenderTarget();
                        v.setRenderTarget(F), v.getClearColor(I), C = v.getClearAlpha(), C < 1 && v.setClearColor(16777215, .5), v.clear();
                        const s = v.toneMapping;
                        v.toneMapping = Kr, Lt(t1, n, i), K.updateMultisampleRenderTarget(F), K.updateRenderTargetMipmap(F);
                        let o = !1;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = r.object, s = r.geometry, l = r.material, c = r.group;
                            if (l.side === pr && a.layers.test(i.layers)) {
                                const t1 = l.side;
                                l.side = dr, l.needsUpdate = !0, Ot(a, n, i, s, l, c), l.side = t1, l.needsUpdate = !0, o = !0;
                            }
                        }
                        !0 === o && (K.updateMultisampleRenderTarget(F), K.updateRenderTargetMipmap(F)), v.setRenderTarget(a), v.setClearColor(I, C), v.toneMapping = s;
                    }(r, a, e, n), i && Z.viewport(E.copy(i)), r.length > 0 && Lt(r, e, n), a.length > 0 && Lt(a, e, n), s.length > 0 && Lt(s, e, n), Z.buffers.depth.setTest(!0), Z.buffers.depth.setMask(!0), Z.buffers.color.setMask(!0), Z.setPolygonOffset(!1);
                }
                function Lt(t1, e, n) {
                    const i = !0 === e.isScene ? e.overrideMaterial : null;
                    for(let r = 0, a = t1.length; r < a; r++){
                        const a = t1[r], s = a.object, o = a.geometry, l = null === i ? a.material : i, c = a.group;
                        s.layers.test(n.layers) && Ot(s, e, n, o, l, c);
                    }
                }
                function Ot(t1, e, n, i, r, a) {
                    t1.onBeforeRender(v, e, n, i, r, a), t1.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t1.matrixWorld), t1.normalMatrix.getNormalMatrix(t1.modelViewMatrix), r.onBeforeRender(v, e, n, i, t1, a), !0 === r.transparent && r.side === pr && !1 === r.forceSinglePass ? (r.side = dr, r.needsUpdate = !0, v.renderBufferDirect(n, e, i, r, t1, a), r.side = hr, r.needsUpdate = !0, v.renderBufferDirect(n, e, i, r, t1, a), r.side = pr) : v.renderBufferDirect(n, e, i, r, t1, a), t1.onAfterRender(v, e, n, i, r, a);
                }
                function Rt(t1, e, n) {
                    !0 !== e.isScene && (e = G);
                    const i = J.get(t1), r = m.state.lights, a = m.state.shadowsArray, s = r.state.version, o = rt.getParameters(t1, r.state, a, e, n), l = rt.getProgramCacheKey(o);
                    let c = i.programs;
                    i.environment = t1.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t1.isMeshStandardMaterial ? tt : $).get(t1.envMap || i.environment), void 0 === c && (t1.addEventListener("dispose", _t), c = new Map, i.programs = c);
                    let u = c.get(l);
                    if (void 0 !== u) {
                        if (i.currentProgram === u && i.lightsStateVersion === s) return zt(t1, o), u;
                    } else o.uniforms = rt.getUniforms(t1), t1.onBuild(n, o, v), t1.onBeforeCompile(o, v), u = rt.acquireProgram(o, l), c.set(l, u), i.uniforms = o.uniforms;
                    const h = i.uniforms;
                    return (t1.isShaderMaterial || t1.isRawShaderMaterial) && !0 !== t1.clipping || (h.clippingPlanes = lt.uniform), zt(t1, o), i.needsLights = function(t1) {
                        return t1.isMeshLambertMaterial || t1.isMeshToonMaterial || t1.isMeshPhongMaterial || t1.isMeshStandardMaterial || t1.isShadowMaterial || t1.isShaderMaterial && !0 === t1.lights;
                    }(t1), i.lightsStateVersion = s, i.needsLights && (h.ambientLightColor.value = r.state.ambient, h.lightProbe.value = r.state.probe, h.directionalLights.value = r.state.directional, h.directionalLightShadows.value = r.state.directionalShadow, h.spotLights.value = r.state.spot, h.spotLightShadows.value = r.state.spotShadow, h.rectAreaLights.value = r.state.rectArea, h.ltc_1.value = r.state.rectAreaLTC1, h.ltc_2.value = r.state.rectAreaLTC2, h.pointLights.value = r.state.point, h.pointLightShadows.value = r.state.pointShadow, h.hemisphereLights.value = r.state.hemi, h.directionalShadowMap.value = r.state.directionalShadowMap, h.directionalShadowMatrix.value = r.state.directionalShadowMatrix, h.spotShadowMap.value = r.state.spotShadowMap, h.spotLightMatrix.value = r.state.spotLightMatrix, h.spotLightMap.value = r.state.spotLightMap, h.pointShadowMap.value = r.state.pointShadowMap, h.pointShadowMatrix.value = r.state.pointShadowMatrix), i.currentProgram = u, i.uniformsList = null, u;
                }
                function Pt(t1) {
                    if (null === t1.uniformsList) {
                        const e = t1.currentProgram.getUniforms();
                        t1.uniformsList = Kd.seqWithValue(e.seq, t1.uniforms);
                    }
                    return t1.uniformsList;
                }
                function zt(t1, e) {
                    const n = J.get(t1);
                    n.outputColorSpace = e.outputColorSpace, n.instancing = e.instancing, n.instancingColor = e.instancingColor, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.morphColors = e.morphColors, n.morphTargetsCount = e.morphTargetsCount, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents, n.toneMapping = e.toneMapping;
                }
                Ct.setAnimationLoop(function(t1) {
                    St && St(t1);
                }), "undefined" != typeof self && Ct.setContext(self), this.setAnimationLoop = function(t1) {
                    St = t1, Mt.setAnimationLoop(t1), null === t1 ? Ct.stop() : Ct.start();
                }, Mt.addEventListener("sessionstart", Tt), Mt.addEventListener("sessionend", It), this.render = function(t1, e) {
                    if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                    if (!0 === y) return;
                    !0 === t1.matrixWorldAutoUpdate && t1.updateMatrixWorld(), null === e.parent && !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), !0 === Mt.enabled && !0 === Mt.isPresenting && (!0 === Mt.cameraAutoUpdate && Mt.updateCamera(e), e = Mt.getCamera()), !0 === t1.isScene && t1.onBeforeRender(v, t1, e, x), m = ot.get(t1, A.length), m.init(), A.push(m), H.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), k.setFromProjectionMatrix(H), j = this.localClippingEnabled, B = lt.init(this.clippingPlanes, j), f = st.get(t1, g.length), f.init(), g.push(f), Nt(t1, e, 0, v.sortObjects), f.finish(), !0 === v.sortObjects && f.sort(O, R), this.info.render.frame++, !0 === B && lt.beginShadows();
                    const n = m.state.shadowsArray;
                    if (ct.render(n, t1, e), !0 === B && lt.endShadows(), !0 === this.info.autoReset && this.info.reset(), ut.render(f, t1), m.setupLights(v._useLegacyLights), e.isArrayCamera) {
                        const n = e.cameras;
                        for(let e = 0, i = n.length; e < i; e++){
                            const i = n[e];
                            Dt(f, t1, i, i.viewport);
                        }
                    } else Dt(f, t1, e);
                    null !== x && (K.updateMultisampleRenderTarget(x), K.updateRenderTargetMipmap(x)), !0 === t1.isScene && t1.onAfterRender(v, t1, e), mt.resetDefaultState(), w = -1, _ = null, A.pop(), m = A.length > 0 ? A[A.length - 1] : null, g.pop(), f = g.length > 0 ? g[g.length - 1] : null;
                }, this.getActiveCubeFace = function() {
                    return M;
                }, this.getActiveMipmapLevel = function() {
                    return b;
                }, this.getRenderTarget = function() {
                    return x;
                }, this.setRenderTargetTextures = function(t1, e, n) {
                    J.get(t1.texture).__webglTexture = e, J.get(t1.depthTexture).__webglTexture = n;
                    const i = J.get(t1);
                    i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === X.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
                }, this.setRenderTargetFramebuffer = function(t1, e) {
                    const n = J.get(t1);
                    n.__webglFramebuffer = e, n.__useDefaultFramebuffer = void 0 === e;
                }, this.setRenderTarget = function(t1, e = 0, n = 0) {
                    x = t1, M = e, b = n;
                    let i = !0, r = null, a = !1, s = !1;
                    if (t1) {
                        const o = J.get(t1);
                        void 0 !== o.__useDefaultFramebuffer ? (Z.bindFramebuffer(At.FRAMEBUFFER, null), i = !1) : void 0 === o.__webglFramebuffer ? K.setupRenderTarget(t1) : o.__hasExternalTextures && K.rebindTextures(t1, J.get(t1.texture).__webglTexture, J.get(t1.depthTexture).__webglTexture);
                        const l = t1.texture;
                        (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (s = !0);
                        const c = J.get(t1).__webglFramebuffer;
                        t1.isWebGLCubeRenderTarget ? (r = Array.isArray(c[e]) ? c[e][n] : c[e], a = !0) : r = Y.isWebGL2 && t1.samples > 0 && !1 === K.useMultisampledRTT(t1) ? J.get(t1).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, E.copy(t1.viewport), S.copy(t1.scissor), T = t1.scissorTest;
                    } else E.copy(P).multiplyScalar(L).floor(), S.copy(z).multiplyScalar(L).floor(), T = U;
                    if (Z.bindFramebuffer(At.FRAMEBUFFER, r) && Y.drawBuffers && i && Z.drawBuffers(t1, r), Z.viewport(E), Z.scissor(S), Z.setScissorTest(T), a) {
                        const i = J.get(t1.texture);
                        At.framebufferTexture2D(At.FRAMEBUFFER, At.COLOR_ATTACHMENT0, At.TEXTURE_CUBE_MAP_POSITIVE_X + e, i.__webglTexture, n);
                    } else if (s) {
                        const i = J.get(t1.texture), r = e || 0;
                        At.framebufferTextureLayer(At.FRAMEBUFFER, At.COLOR_ATTACHMENT0, i.__webglTexture, n || 0, r);
                    }
                    w = -1;
                }, this.readRenderTargetPixels = function(t1, e, n, i, r, a, s) {
                    if (!t1 || !t1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                    let o = J.get(t1).__webglFramebuffer;
                    if (t1.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o) {
                        Z.bindFramebuffer(At.FRAMEBUFFER, o);
                        try {
                            const s = t1.texture, o = s.format, l = s.type;
                            if (o !== Ua && ft.convert(o) !== At.getParameter(At.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                            const c = l === La && (X.has("EXT_color_buffer_half_float") || Y.isWebGL2 && X.has("EXT_color_buffer_float"));
                            if (!(l === Ea || ft.convert(l) === At.getParameter(At.IMPLEMENTATION_COLOR_READ_TYPE) || l === Da && (Y.isWebGL2 || X.has("OES_texture_float") || X.has("WEBGL_color_buffer_float")) || c)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                            e >= 0 && e <= t1.width - i && n >= 0 && n <= t1.height - r && At.readPixels(e, n, i, r, ft.convert(o), ft.convert(l), a);
                        } finally{
                            const t1 = null !== x ? J.get(x).__webglFramebuffer : null;
                            Z.bindFramebuffer(At.FRAMEBUFFER, t1);
                        }
                    }
                }, this.copyFramebufferToTexture = function(t1, e, n = 0) {
                    const i = Math.pow(2, -n), r = Math.floor(e.image.width * i), a = Math.floor(e.image.height * i);
                    K.setTexture2D(e, 0), At.copyTexSubImage2D(At.TEXTURE_2D, n, 0, 0, t1.x, t1.y, r, a), Z.unbindTexture();
                }, this.copyTextureToTexture = function(t1, e, n, i = 0) {
                    const r = e.image.width, a = e.image.height, s = ft.convert(n.format), o = ft.convert(n.type);
                    K.setTexture2D(n, 0), At.pixelStorei(At.UNPACK_FLIP_Y_WEBGL, n.flipY), At.pixelStorei(At.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), At.pixelStorei(At.UNPACK_ALIGNMENT, n.unpackAlignment), e.isDataTexture ? At.texSubImage2D(At.TEXTURE_2D, i, t1.x, t1.y, r, a, s, o, e.image.data) : e.isCompressedTexture ? At.compressedTexSubImage2D(At.TEXTURE_2D, i, t1.x, t1.y, e.mipmaps[0].width, e.mipmaps[0].height, s, e.mipmaps[0].data) : At.texSubImage2D(At.TEXTURE_2D, i, t1.x, t1.y, s, o, e.image), 0 === i && n.generateMipmaps && At.generateMipmap(At.TEXTURE_2D), Z.unbindTexture();
                }, this.copyTextureToTexture3D = function(t1, e, n, i, r = 0) {
                    if (v.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                    const a = t1.max.x - t1.min.x + 1, s = t1.max.y - t1.min.y + 1, o = t1.max.z - t1.min.z + 1, l = ft.convert(i.format), c = ft.convert(i.type);
                    let u;
                    if (i.isData3DTexture) K.setTexture3D(i, 0), u = At.TEXTURE_3D;
                    else {
                        if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                        K.setTexture2DArray(i, 0), u = At.TEXTURE_2D_ARRAY;
                    }
                    At.pixelStorei(At.UNPACK_FLIP_Y_WEBGL, i.flipY), At.pixelStorei(At.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), At.pixelStorei(At.UNPACK_ALIGNMENT, i.unpackAlignment);
                    const h = At.getParameter(At.UNPACK_ROW_LENGTH), d = At.getParameter(At.UNPACK_IMAGE_HEIGHT), p = At.getParameter(At.UNPACK_SKIP_PIXELS), f = At.getParameter(At.UNPACK_SKIP_ROWS), m = At.getParameter(At.UNPACK_SKIP_IMAGES), g = n.isCompressedTexture ? n.mipmaps[0] : n.image;
                    At.pixelStorei(At.UNPACK_ROW_LENGTH, g.width), At.pixelStorei(At.UNPACK_IMAGE_HEIGHT, g.height), At.pixelStorei(At.UNPACK_SKIP_PIXELS, t1.min.x), At.pixelStorei(At.UNPACK_SKIP_ROWS, t1.min.y), At.pixelStorei(At.UNPACK_SKIP_IMAGES, t1.min.z), n.isDataTexture || n.isData3DTexture ? At.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, g.data) : n.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), At.compressedTexSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, g.data)) : At.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, g), At.pixelStorei(At.UNPACK_ROW_LENGTH, h), At.pixelStorei(At.UNPACK_IMAGE_HEIGHT, d), At.pixelStorei(At.UNPACK_SKIP_PIXELS, p), At.pixelStorei(At.UNPACK_SKIP_ROWS, f), At.pixelStorei(At.UNPACK_SKIP_IMAGES, m), 0 === r && i.generateMipmaps && At.generateMipmap(u), Z.unbindTexture();
                }, this.initTexture = function(t1) {
                    t1.isCubeTexture ? K.setTextureCube(t1, 0) : t1.isData3DTexture ? K.setTexture3D(t1, 0) : t1.isDataArrayTexture || t1.isCompressedArrayTexture ? K.setTexture2DArray(t1, 0) : K.setTexture2D(t1, 0), Z.unbindTexture();
                }, this.resetState = function() {
                    M = 0, b = 0, x = null, Z.reset(), mt.reset();
                }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            get coordinateSystem() {
                return Uo;
            }
            get outputColorSpace() {
                return this._outputColorSpace;
            }
            set outputColorSpace(t1) {
                this._outputColorSpace = t1;
                const e = this.getContext();
                e.drawingBufferColorSpace = t1 === Ys ? "display-p3" : "srgb", e.unpackColorSpace = fl.workingColorSpace === Zs ? "display-p3" : "srgb";
            }
            get physicallyCorrectLights() {
                return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
            }
            set physicallyCorrectLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !t1;
            }
            get outputEncoding() {
                return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === Ws ? js : Bs;
            }
            set outputEncoding(t1) {
                console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = t1 === js ? Ws : Xs;
            }
            get useLegacyLights() {
                return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
            }
            set useLegacyLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = t1;
            }
        }
        class Xp extends Wp {
        }
        Xp.prototype.isWebGL1Renderer = !0;
        class Yp {
            constructor(t1, e = 25e-5){
                this.isFogExp2 = !0, this.name = "", this.color = new Jc(t1), this.density = e;
            }
            clone() {
                return new Yp(this.color, this.density);
            }
            toJSON() {
                return {
                    type: "FogExp2",
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
        class Zp {
            constructor(t1, e = 1, n = 1e3){
                this.isFog = !0, this.name = "", this.color = new Jc(t1), this.near = e, this.far = n;
            }
            clone() {
                return new Zp(this.color, this.near, this.far);
            }
            toJSON() {
                return {
                    type: "Fog",
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
        class qp extends Rc {
            constructor(){
                super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            copy(t1, e) {
                return super.copy(t1, e), null !== t1.background && (this.background = t1.background.clone()), null !== t1.environment && (this.environment = t1.environment.clone()), null !== t1.fog && (this.fog = t1.fog.clone()), this.backgroundBlurriness = t1.backgroundBlurriness, this.backgroundIntensity = t1.backgroundIntensity, null !== t1.overrideMaterial && (this.overrideMaterial = t1.overrideMaterial.clone()), this.matrixAutoUpdate = t1.matrixAutoUpdate, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.fog && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (e.object.backgroundIntensity = this.backgroundIntensity), e;
            }
        }
        class Jp {
            constructor(t1, e){
                this.isInterleavedBuffer = !0, this.array = t1, this.stride = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.usage = Eo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.version = 0, this.uuid = Qo();
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.array = new t1.array.constructor(t1.array), this.count = t1.count, this.stride = t1.stride, this.usage = t1.usage, this;
            }
            copyAt(t1, e, n) {
                t1 *= this.stride, n *= e.stride;
                for(let i = 0, r = this.stride; i < r; i++)this.array[t1 + i] = e.array[n + i];
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            clone(t1) {
                void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Qo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
                const e = new this.array.constructor(t1.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(e, this.stride);
                return n.setUsage(this.usage), n;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            toJSON(t1) {
                return void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Qo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
        const Kp = new Ol;
        class $p {
            constructor(t1, e, n, i = !1){
                this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t1, this.itemSize = e, this.offset = n, this.normalized = i;
            }
            get count() {
                return this.data.count;
            }
            get array() {
                return this.data.array;
            }
            set needsUpdate(t1) {
                this.data.needsUpdate = t1;
            }
            applyMatrix4(t1) {
                for(let e = 0, n = this.data.count; e < n; e++)Kp.fromBufferAttribute(this, e), Kp.applyMatrix4(t1), this.setXYZ(e, Kp.x, Kp.y, Kp.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, n = this.count; e < n; e++)Kp.fromBufferAttribute(this, e), Kp.applyNormalMatrix(t1), this.setXYZ(e, Kp.x, Kp.y, Kp.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, n = this.count; e < n; e++)Kp.fromBufferAttribute(this, e), Kp.transformDirection(t1), this.setXYZ(e, Kp.x, Kp.y, Kp.z);
                return this;
            }
            setX(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.data.array[t1 * this.data.stride + this.offset] = e, this;
            }
            setY(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 1] = e, this;
            }
            setZ(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 2] = e, this;
            }
            setW(t1, e) {
                return this.normalized && (e = Ko(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 3] = e, this;
            }
            getX(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            getY(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 1];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            getZ(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 2];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            getW(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 3];
                return this.normalized && (e = Jo(e, this.array)), e;
            }
            setXY(t1, e, n) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this;
            }
            setXYZ(t1, e, n, i) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this.data.array[t1 + 2] = i, this;
            }
            setXYZW(t1, e, n, i, r) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Ko(e, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this.data.array[t1 + 2] = i, this.data.array[t1 + 3] = r, this;
            }
            clone(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const n = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[n + e]);
                    }
                    return new cu(new this.array.constructor(t1), this.itemSize, this.normalized);
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.clone(t1)), new $p(t1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
            }
            toJSON(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const n = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[n + e]);
                    }
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: t1,
                        normalized: this.normalized
                    };
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.toJSON(t1)), {
                    isInterleavedBufferAttribute: !0,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                };
            }
        }
        class tf extends tu {
            constructor(t1){
                super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Jc(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.rotation = t1.rotation, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        let ef;
        const nf = new Ol, rf = new Ol, af = new Ol, sf = new tl, of = new tl, lf = new cc, cf = new Ol, uf = new Ol, hf = new Ol, df = new tl, pf = new tl, ff = new tl;
        class mf extends Rc {
            constructor(t1 = new tf){
                if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === ef) {
                    ef = new Tu;
                    const t1 = new Float32Array([
                        -0.5,
                        -0.5,
                        0,
                        0,
                        0,
                        .5,
                        -0.5,
                        0,
                        1,
                        0,
                        .5,
                        .5,
                        0,
                        1,
                        1,
                        -0.5,
                        .5,
                        0,
                        0,
                        1
                    ]), e = new Jp(t1, 5);
                    ef.setIndex([
                        0,
                        1,
                        2,
                        0,
                        2,
                        3
                    ]), ef.setAttribute("position", new $p(e, 3, 0, !1)), ef.setAttribute("uv", new $p(e, 2, 3, !1));
                }
                this.geometry = ef, this.material = t1, this.center = new tl(.5, .5);
            }
            raycast(t1, e) {
                null === t1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), rf.setFromMatrixScale(this.matrixWorld), lf.copy(t1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t1.camera.matrixWorldInverse, this.matrixWorld), af.setFromMatrixPosition(this.modelViewMatrix), t1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && rf.multiplyScalar(-af.z);
                const n = this.material.rotation;
                let i, r;
                0 !== n && (r = Math.cos(n), i = Math.sin(n));
                const a = this.center;
                gf(cf.set(-0.5, -0.5, 0), af, a, rf, i, r), gf(uf.set(.5, -0.5, 0), af, a, rf, i, r), gf(hf.set(.5, .5, 0), af, a, rf, i, r), df.set(0, 0), pf.set(1, 0), ff.set(1, 1);
                let s = t1.ray.intersectTriangle(cf, uf, hf, !1, nf);
                if (null === s && (gf(uf.set(-0.5, .5, 0), af, a, rf, i, r), pf.set(0, 1), s = t1.ray.intersectTriangle(cf, hf, uf, !1, nf), null === s)) return;
                const o = t1.ray.origin.distanceTo(nf);
                o < t1.near || o > t1.far || e.push({
                    distance: o,
                    point: nf.clone(),
                    uv: Wc.getInterpolation(nf, cf, uf, hf, df, pf, ff, new tl),
                    face: null,
                    object: this
                });
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.center && this.center.copy(t1.center), this.material = t1.material, this;
            }
        }
        function gf(t1, e, n, i, r, a) {
            sf.subVectors(t1, n).addScalar(.5).multiply(i), void 0 !== r ? (of.x = a * sf.x - r * sf.y, of.y = r * sf.x + a * sf.y) : of.copy(sf), t1.copy(e), t1.x += of.x, t1.y += of.y, t1.applyMatrix4(lf);
        }
        const Af = new Ol, vf = new Ol;
        class yf extends Rc {
            constructor(){
                super(), this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
                    levels: {
                        enumerable: !0,
                        value: []
                    },
                    isLOD: {
                        value: !0
                    }
                }), this.autoUpdate = !0;
            }
            copy(t1) {
                super.copy(t1, !1);
                const e = t1.levels;
                for(let t1 = 0, n = e.length; t1 < n; t1++){
                    const n = e[t1];
                    this.addLevel(n.object.clone(), n.distance, n.hysteresis);
                }
                return this.autoUpdate = t1.autoUpdate, this;
            }
            addLevel(t1, e = 0, n = 0) {
                e = Math.abs(e);
                const i = this.levels;
                let r;
                for(r = 0; r < i.length && !(e < i[r].distance); r++);
                return i.splice(r, 0, {
                    distance: e,
                    hysteresis: n,
                    object: t1
                }), this.add(t1), this;
            }
            getCurrentLevel() {
                return this._currentLevel;
            }
            getObjectForDistance(t1) {
                const e = this.levels;
                if (e.length > 0) {
                    let n, i;
                    for(n = 1, i = e.length; n < i; n++){
                        let i = e[n].distance;
                        if (e[n].object.visible && (i -= i * e[n].hysteresis), t1 < i) break;
                    }
                    return e[n - 1].object;
                }
                return null;
            }
            raycast(t1, e) {
                if (this.levels.length > 0) {
                    Af.setFromMatrixPosition(this.matrixWorld);
                    const n = t1.ray.origin.distanceTo(Af);
                    this.getObjectForDistance(n).raycast(t1, e);
                }
            }
            update(t1) {
                const e = this.levels;
                if (e.length > 1) {
                    Af.setFromMatrixPosition(t1.matrixWorld), vf.setFromMatrixPosition(this.matrixWorld);
                    const n = Af.distanceTo(vf) / t1.zoom;
                    let i, r;
                    for(e[0].object.visible = !0, i = 1, r = e.length; i < r; i++){
                        let t1 = e[i].distance;
                        if (e[i].object.visible && (t1 -= t1 * e[i].hysteresis), !(n >= t1)) break;
                        e[i - 1].object.visible = !1, e[i].object.visible = !0;
                    }
                    for(this._currentLevel = i - 1; i < r; i++)e[i].object.visible = !1;
                }
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                !1 === this.autoUpdate && (e.object.autoUpdate = !1), e.object.levels = [];
                const n = this.levels;
                for(let t1 = 0, i = n.length; t1 < i; t1++){
                    const i = n[t1];
                    e.object.levels.push({
                        object: i.object.uuid,
                        distance: i.distance,
                        hysteresis: i.hysteresis
                    });
                }
                return e;
            }
        }
        const Mf = new Ol, bf = new _l, xf = new _l, wf = new Ol, _f = new cc, Ef = new Ol, Sf = new tc, Tf = new cc, If = new lc;
        class Cf extends Gu {
            constructor(t1, e){
                super(t1, e), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = ra, this.bindMatrix = new cc, this.bindMatrixInverse = new cc, this.boundingBox = null, this.boundingSphere = null;
            }
            computeBoundingBox() {
                const t1 = this.geometry;
                null === this.boundingBox && (this.boundingBox = new zl), this.boundingBox.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, Ef), this.boundingBox.expandByPoint(Ef);
            }
            computeBoundingSphere() {
                const t1 = this.geometry;
                null === this.boundingSphere && (this.boundingSphere = new tc), this.boundingSphere.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, Ef), this.boundingSphere.expandByPoint(Ef);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.bindMode = t1.bindMode, this.bindMatrix.copy(t1.bindMatrix), this.bindMatrixInverse.copy(t1.bindMatrixInverse), this.skeleton = t1.skeleton, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            raycast(t1, e) {
                const n = this.material, i = this.matrixWorld;
                void 0 !== n && (null === this.boundingSphere && this.computeBoundingSphere(), Sf.copy(this.boundingSphere), Sf.applyMatrix4(i), !1 !== t1.ray.intersectsSphere(Sf) && (Tf.copy(i).invert(), If.copy(t1.ray).applyMatrix4(Tf), null !== this.boundingBox && !1 === If.intersectsBox(this.boundingBox) || this._computeIntersections(t1, e, If)));
            }
            getVertexPosition(t1, e) {
                return super.getVertexPosition(t1, e), this.applyBoneTransform(t1, e), e;
            }
            bind(t1, e) {
                this.skeleton = t1, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
            }
            pose() {
                this.skeleton.pose();
            }
            normalizeSkinWeights() {
                const t1 = new _l, e = this.geometry.attributes.skinWeight;
                for(let n = 0, i = e.count; n < i; n++){
                    t1.fromBufferAttribute(e, n);
                    const i = 1 / t1.manhattanLength();
                    i !== 1 / 0 ? t1.multiplyScalar(i) : t1.set(1, 0, 0, 0), e.setXYZW(n, t1.x, t1.y, t1.z, t1.w);
                }
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.bindMode === ra ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === aa ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            }
            applyBoneTransform(t1, e) {
                const n = this.skeleton, i = this.geometry;
                bf.fromBufferAttribute(i.attributes.skinIndex, t1), xf.fromBufferAttribute(i.attributes.skinWeight, t1), Mf.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);
                for(let t1 = 0; t1 < 4; t1++){
                    const i = xf.getComponent(t1);
                    if (0 !== i) {
                        const r = bf.getComponent(t1);
                        _f.multiplyMatrices(n.bones[r].matrixWorld, n.boneInverses[r]), e.addScaledVector(wf.copy(Mf).applyMatrix4(_f), i);
                    }
                }
                return e.applyMatrix4(this.bindMatrixInverse);
            }
            boneTransform(t1, e) {
                return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(t1, e);
            }
        }
        class Nf extends Rc {
            constructor(){
                super(), this.isBone = !0, this.type = "Bone";
            }
        }
        class Df extends wl {
            constructor(t1 = null, e = 1, n = 1, i, r, a, s, o, l = ma, c = ma, u, h){
                super(null, a, s, o, l, c, i, r, u, h), this.isDataTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: n
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        const Lf = new cc, Of = new cc;
        class Rf {
            constructor(t1 = [], e = []){
                this.uuid = Qo(), this.bones = t1.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
            }
            init() {
                const t1 = this.bones, e = this.boneInverses;
                if (this.boneMatrices = new Float32Array(16 * t1.length), 0 === e.length) this.calculateInverses();
                else if (t1.length !== e.length) {
                    console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
                    for(let t1 = 0, e = this.bones.length; t1 < e; t1++)this.boneInverses.push(new cc);
                }
            }
            calculateInverses() {
                this.boneInverses.length = 0;
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = new cc;
                    this.bones[t1] && e.copy(this.bones[t1].matrixWorld).invert(), this.boneInverses.push(e);
                }
            }
            pose() {
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && e.matrixWorld.copy(this.boneInverses[t1]).invert();
                }
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && (e.parent && e.parent.isBone ? (e.matrix.copy(e.parent.matrixWorld).invert(), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
                }
            }
            update() {
                const t1 = this.bones, e = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
                for(let i = 0, r = t1.length; i < r; i++){
                    const r = t1[i] ? t1[i].matrixWorld : Of;
                    Lf.multiplyMatrices(r, e[i]), Lf.toArray(n, 16 * i);
                }
                null !== i && (i.needsUpdate = !0);
            }
            clone() {
                return new Rf(this.bones, this.boneInverses);
            }
            computeBoneTexture() {
                let t1 = Math.sqrt(4 * this.bones.length);
                t1 = Zo(t1), t1 = Math.max(t1, 4);
                const e = new Float32Array(t1 * t1 * 4);
                e.set(this.boneMatrices);
                const n = new Df(e, t1, t1, Ua, Da);
                return n.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = n, this.boneTextureSize = t1, this;
            }
            getBoneByName(t1) {
                for(let e = 0, n = this.bones.length; e < n; e++){
                    const n = this.bones[e];
                    if (n.name === t1) return n;
                }
            }
            dispose() {
                null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
            }
            fromJSON(t1, e) {
                this.uuid = t1.uuid;
                for(let n = 0, i = t1.bones.length; n < i; n++){
                    const i = t1.bones[n];
                    let r = e[i];
                    void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", i), r = new Nf), this.bones.push(r), this.boneInverses.push((new cc).fromArray(t1.boneInverses[n]));
                }
                return this.init(), this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Skeleton",
                        generator: "Skeleton.toJSON"
                    },
                    bones: [],
                    boneInverses: []
                };
                t1.uuid = this.uuid;
                const e = this.bones, n = this.boneInverses;
                for(let i = 0, r = e.length; i < r; i++){
                    const r = e[i];
                    t1.bones.push(r.uuid);
                    const a = n[i];
                    t1.boneInverses.push(a.toArray());
                }
                return t1;
            }
        }
        class Pf extends cu {
            constructor(t1, e, n, i = 1){
                super(t1, e, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.meshPerAttribute = this.meshPerAttribute, t1.isInstancedBufferAttribute = !0, t1;
            }
        }
        const zf = new cc, Uf = new cc, kf = [], Bf = new zl, jf = new cc, Ff = new Gu, Hf = new tc;
        class Vf extends Gu {
            constructor(t1, e, n){
                super(t1, e), this.isInstancedMesh = !0, this.instanceMatrix = new Pf(new Float32Array(16 * n), 16), this.instanceColor = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
                for(let t1 = 0; t1 < n; t1++)this.setMatrixAt(t1, jf);
            }
            computeBoundingBox() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingBox && (this.boundingBox = new zl), null === t1.boundingBox && t1.computeBoundingBox(), this.boundingBox.makeEmpty();
                for(let n = 0; n < e; n++)this.getMatrixAt(n, zf), Bf.copy(t1.boundingBox).applyMatrix4(zf), this.boundingBox.union(Bf);
            }
            computeBoundingSphere() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingSphere && (this.boundingSphere = new tc), null === t1.boundingSphere && t1.computeBoundingSphere(), this.boundingSphere.makeEmpty();
                for(let n = 0; n < e; n++)this.getMatrixAt(n, zf), Hf.copy(t1.boundingSphere).applyMatrix4(zf), this.boundingSphere.union(Hf);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.instanceMatrix.copy(t1.instanceMatrix), null !== t1.instanceColor && (this.instanceColor = t1.instanceColor.clone()), this.count = t1.count, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            getColorAt(t1, e) {
                e.fromArray(this.instanceColor.array, 3 * t1);
            }
            getMatrixAt(t1, e) {
                e.fromArray(this.instanceMatrix.array, 16 * t1);
            }
            raycast(t1, e) {
                const n = this.matrixWorld, i = this.count;
                if (Ff.geometry = this.geometry, Ff.material = this.material, void 0 !== Ff.material && (null === this.boundingSphere && this.computeBoundingSphere(), Hf.copy(this.boundingSphere), Hf.applyMatrix4(n), !1 !== t1.ray.intersectsSphere(Hf))) for(let r = 0; r < i; r++){
                    this.getMatrixAt(r, zf), Uf.multiplyMatrices(n, zf), Ff.matrixWorld = Uf, Ff.raycast(t1, kf);
                    for(let t1 = 0, n = kf.length; t1 < n; t1++){
                        const n = kf[t1];
                        n.instanceId = r, n.object = this, e.push(n);
                    }
                    kf.length = 0;
                }
            }
            setColorAt(t1, e) {
                null === this.instanceColor && (this.instanceColor = new Pf(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t1);
            }
            setMatrixAt(t1, e) {
                e.toArray(this.instanceMatrix.array, 16 * t1);
            }
            updateMorphTargets() {}
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Qf extends tu {
            constructor(t1){
                super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Jc(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.linewidth = t1.linewidth, this.linecap = t1.linecap, this.linejoin = t1.linejoin, this.fog = t1.fog, this;
            }
        }
        const Gf = new Ol, Wf = new Ol, Xf = new cc, Yf = new lc, Zf = new tc;
        class qf extends Rc {
            constructor(t1 = new Tu, e = new Qf){
                super(), this.isLine = !0, this.type = "Line", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, n = [
                        0
                    ];
                    for(let t1 = 1, i = e.count; t1 < i; t1++)Gf.fromBufferAttribute(e, t1 - 1), Wf.fromBufferAttribute(e, t1), n[t1] = n[t1 - 1], n[t1] += Gf.distanceTo(Wf);
                    t1.setAttribute("lineDistance", new vu(n, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
            raycast(t1, e) {
                const n = this.geometry, i = this.matrixWorld, r = t1.params.Line.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), Zf.copy(n.boundingSphere), Zf.applyMatrix4(i), Zf.radius += r, !1 === t1.ray.intersectsSphere(Zf)) return;
                Xf.copy(i).invert(), Yf.copy(t1.ray).applyMatrix4(Xf);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = new Ol, c = new Ol, u = new Ol, h = new Ol, d = this.isLineSegments ? 2 : 1, p = n.index, f = n.attributes.position;
                if (null !== p) for(let n = Math.max(0, a.start), i = Math.min(p.count, a.start + a.count) - 1; n < i; n += d){
                    const i = p.getX(n), r = p.getX(n + 1);
                    if (l.fromBufferAttribute(f, i), c.fromBufferAttribute(f, r), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const a = t1.ray.origin.distanceTo(h);
                    a < t1.near || a > t1.far || e.push({
                        distance: a,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
                else for(let n = Math.max(0, a.start), i = Math.min(f.count, a.start + a.count) - 1; n < i; n += d){
                    if (l.fromBufferAttribute(f, n), c.fromBufferAttribute(f, n + 1), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const i = t1.ray.origin.distanceTo(h);
                    i < t1.near || i > t1.far || e.push({
                        distance: i,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const n = t1[e[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = n.length; t1 < e; t1++){
                            const e = n[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        const Jf = new Ol, Kf = new Ol;
        class $f extends qf {
            constructor(t1, e){
                super(t1, e), this.isLineSegments = !0, this.type = "LineSegments";
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, n = [];
                    for(let t1 = 0, i = e.count; t1 < i; t1 += 2)Jf.fromBufferAttribute(e, t1), Kf.fromBufferAttribute(e, t1 + 1), n[t1] = 0 === t1 ? 0 : n[t1 - 1], n[t1 + 1] = n[t1] + Jf.distanceTo(Kf);
                    t1.setAttribute("lineDistance", new vu(n, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
        }
        class tm extends qf {
            constructor(t1, e){
                super(t1, e), this.isLineLoop = !0, this.type = "LineLoop";
            }
        }
        class em extends tu {
            constructor(t1){
                super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Jc(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.size = t1.size, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        const nm = new cc, im = new lc, rm = new tc, am = new Ol;
        class sm extends Rc {
            constructor(t1 = new Tu, e = new em){
                super(), this.isPoints = !0, this.type = "Points", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            raycast(t1, e) {
                const n = this.geometry, i = this.matrixWorld, r = t1.params.Points.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), rm.copy(n.boundingSphere), rm.applyMatrix4(i), rm.radius += r, !1 === t1.ray.intersectsSphere(rm)) return;
                nm.copy(i).invert(), im.copy(t1.ray).applyMatrix4(nm);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = n.index, c = n.attributes.position;
                if (null !== l) for(let n = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count); n < r; n++){
                    const r = l.getX(n);
                    am.fromBufferAttribute(c, r), om(am, r, o, i, t1, e, this);
                }
                else for(let n = Math.max(0, a.start), r = Math.min(c.count, a.start + a.count); n < r; n++)am.fromBufferAttribute(c, n), om(am, n, o, i, t1, e, this);
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const n = t1[e[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = n.length; t1 < e; t1++){
                            const e = n[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        function om(t1, e, n, i, r, a, s) {
            const o = im.distanceSqToPoint(t1);
            if (o < n) {
                const n = new Ol;
                im.closestPointToPoint(t1, n), n.applyMatrix4(i);
                const l = r.ray.origin.distanceTo(n);
                if (l < r.near || l > r.far) return;
                a.push({
                    distance: l,
                    distanceToRay: Math.sqrt(o),
                    point: n,
                    index: e,
                    face: null,
                    object: s
                });
            }
        }
        class lm extends wl {
            constructor(t1, e, n, i, r, a, s, o, l){
                super(t1, e, n, i, r, a, s, o, l), this.isVideoTexture = !0, this.minFilter = void 0 !== a ? a : Ma, this.magFilter = void 0 !== r ? r : Ma, this.generateMipmaps = !1;
                const c = this;
                "requestVideoFrameCallback" in t1 && t1.requestVideoFrameCallback(function e() {
                    c.needsUpdate = !0, t1.requestVideoFrameCallback(e);
                });
            }
            clone() {
                return new this.constructor(this.image).copy(this);
            }
            update() {
                const t1 = this.image;
                !1 == "requestVideoFrameCallback" in t1 && t1.readyState >= t1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
        }
        class cm extends wl {
            constructor(t1, e){
                super({
                    width: t1,
                    height: e
                }), this.isFramebufferTexture = !0, this.magFilter = ma, this.minFilter = ma, this.generateMipmaps = !1, this.needsUpdate = !0;
            }
        }
        class um extends wl {
            constructor(t1, e, n, i, r, a, s, o, l, c, u, h){
                super(null, a, s, o, l, c, i, r, u, h), this.isCompressedTexture = !0, this.image = {
                    width: e,
                    height: n
                }, this.mipmaps = t1, this.flipY = !1, this.generateMipmaps = !1;
            }
        }
        class hm extends um {
            constructor(t1, e, n, i, r, a){
                super(t1, e, n, r, a), this.isCompressedArrayTexture = !0, this.image.depth = i, this.wrapR = pa;
            }
        }
        class dm extends um {
            constructor(t1, e, n){
                super(void 0, t1[0].width, t1[0].height, e, n, oa), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = t1;
            }
        }
        class pm extends wl {
            constructor(t1, e, n, i, r, a, s, o, l){
                super(t1, e, n, i, r, a, s, o, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
            }
        }
        class fm {
            constructor(){
                this.type = "Curve", this.arcLengthDivisions = 200;
            }
            getPoint() {
                return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            }
            getPointAt(t1, e) {
                const n = this.getUtoTmapping(t1);
                return this.getPoint(n, e);
            }
            getPoints(t1 = 5) {
                const e = [];
                for(let n = 0; n <= t1; n++)e.push(this.getPoint(n / t1));
                return e;
            }
            getSpacedPoints(t1 = 5) {
                const e = [];
                for(let n = 0; n <= t1; n++)e.push(this.getPointAt(n / t1));
                return e;
            }
            getLength() {
                const t1 = this.getLengths();
                return t1[t1.length - 1];
            }
            getLengths(t1 = this.arcLengthDivisions) {
                if (this.cacheArcLengths && this.cacheArcLengths.length === t1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = !1;
                const e = [];
                let n, i = this.getPoint(0), r = 0;
                e.push(0);
                for(let a = 1; a <= t1; a++)n = this.getPoint(a / t1), r += n.distanceTo(i), e.push(r), i = n;
                return this.cacheArcLengths = e, e;
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.getLengths();
            }
            getUtoTmapping(t1, e) {
                const n = this.getLengths();
                let i = 0;
                const r = n.length;
                let a;
                a = e || t1 * n[r - 1];
                let s, o = 0, l = r - 1;
                for(; o <= l;)if (i = Math.floor(o + (l - o) / 2), s = n[i] - a, s < 0) o = i + 1;
                else {
                    if (!(s > 0)) {
                        l = i;
                        break;
                    }
                    l = i - 1;
                }
                if (i = l, n[i] === a) return i / (r - 1);
                const c = n[i];
                return (i + (a - c) / (n[i + 1] - c)) / (r - 1);
            }
            getTangent(t1, e) {
                const n = 1e-4;
                let i = t1 - n, r = t1 + n;
                i < 0 && (i = 0), r > 1 && (r = 1);
                const a = this.getPoint(i), s = this.getPoint(r), o = e || (a.isVector2 ? new tl : new Ol);
                return o.copy(s).sub(a).normalize(), o;
            }
            getTangentAt(t1, e) {
                const n = this.getUtoTmapping(t1);
                return this.getTangent(n, e);
            }
            computeFrenetFrames(t1, e) {
                const n = new Ol, i = [], r = [], a = [], s = new Ol, o = new cc;
                for(let e = 0; e <= t1; e++){
                    const n = e / t1;
                    i[e] = this.getTangentAt(n, new Ol);
                }
                r[0] = new Ol, a[0] = new Ol;
                let l = Number.MAX_VALUE;
                const c = Math.abs(i[0].x), u = Math.abs(i[0].y), h = Math.abs(i[0].z);
                c <= l && (l = c, n.set(1, 0, 0)), u <= l && (l = u, n.set(0, 1, 0)), h <= l && n.set(0, 0, 1), s.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], s), a[0].crossVectors(i[0], r[0]);
                for(let e = 1; e <= t1; e++){
                    if (r[e] = r[e - 1].clone(), a[e] = a[e - 1].clone(), s.crossVectors(i[e - 1], i[e]), s.length() > Number.EPSILON) {
                        s.normalize();
                        const t1 = Math.acos(Go(i[e - 1].dot(i[e]), -1, 1));
                        r[e].applyMatrix4(o.makeRotationAxis(s, t1));
                    }
                    a[e].crossVectors(i[e], r[e]);
                }
                if (!0 === e) {
                    let e = Math.acos(Go(r[0].dot(r[t1]), -1, 1));
                    e /= t1, i[0].dot(s.crossVectors(r[0], r[t1])) > 0 && (e = -e);
                    for(let n = 1; n <= t1; n++)r[n].applyMatrix4(o.makeRotationAxis(i[n], e * n)), a[n].crossVectors(i[n], r[n]);
                }
                return {
                    tangents: i,
                    normals: r,
                    binormals: a
                };
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Curve",
                        generator: "Curve.toJSON"
                    }
                };
                return t1.arcLengthDivisions = this.arcLengthDivisions, t1.type = this.type, t1;
            }
            fromJSON(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
        }
        class mm extends fm {
            constructor(t1 = 0, e = 0, n = 1, i = 1, r = 0, a = 2 * Math.PI, s = !1, o = 0){
                super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t1, this.aY = e, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = a, this.aClockwise = s, this.aRotation = o;
            }
            getPoint(t1, e) {
                const n = e || new tl, i = 2 * Math.PI;
                let r = this.aEndAngle - this.aStartAngle;
                const a = Math.abs(r) < Number.EPSILON;
                for(; r < 0;)r += i;
                for(; r > i;)r -= i;
                r < Number.EPSILON && (r = a ? 0 : i), !0 !== this.aClockwise || a || (r === i ? r = -i : r -= i);
                const s = this.aStartAngle + t1 * r;
                let o = this.aX + this.xRadius * Math.cos(s), l = this.aY + this.yRadius * Math.sin(s);
                if (0 !== this.aRotation) {
                    const t1 = Math.cos(this.aRotation), e = Math.sin(this.aRotation), n = o - this.aX, i = l - this.aY;
                    o = n * t1 - i * e + this.aX, l = n * e + i * t1 + this.aY;
                }
                return n.set(o, l);
            }
            copy(t1) {
                return super.copy(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.aX = this.aX, t1.aY = this.aY, t1.xRadius = this.xRadius, t1.yRadius = this.yRadius, t1.aStartAngle = this.aStartAngle, t1.aEndAngle = this.aEndAngle, t1.aClockwise = this.aClockwise, t1.aRotation = this.aRotation, t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
        }
        class gm extends mm {
            constructor(t1, e, n, i, r, a){
                super(t1, e, n, n, i, r, a), this.isArcCurve = !0, this.type = "ArcCurve";
            }
        }
        function Am() {
            let t1 = 0, e = 0, n = 0, i = 0;
            function r(r, a, s, o) {
                t1 = r, e = s, n = -3 * r + 3 * a - 2 * s - o, i = 2 * r - 2 * a + s + o;
            }
            return {
                initCatmullRom: function(t1, e, n, i, a) {
                    r(e, n, a * (n - t1), a * (i - e));
                },
                initNonuniformCatmullRom: function(t1, e, n, i, a, s, o) {
                    let l = (e - t1) / a - (n - t1) / (a + s) + (n - e) / s, c = (n - e) / s - (i - e) / (s + o) + (i - n) / o;
                    l *= s, c *= s, r(e, n, l, c);
                },
                calc: function(r) {
                    const a = r * r;
                    return t1 + e * r + n * a + i * (a * r);
                }
            };
        }
        const vm = new Ol, ym = new Am, Mm = new Am, bm = new Am;
        class xm extends fm {
            constructor(t1 = [], e = !1, n = "centripetal", i = .5){
                super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t1, this.closed = e, this.curveType = n, this.tension = i;
            }
            getPoint(t1, e = new Ol) {
                const n = e, i = this.points, r = i.length, a = (r - (this.closed ? 0 : 1)) * t1;
                let s, o, l = Math.floor(a), c = a - l;
                this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === c && l === r - 1 && (l = r - 2, c = 1), this.closed || l > 0 ? s = i[(l - 1) % r] : (vm.subVectors(i[0], i[1]).add(i[0]), s = vm);
                const u = i[l % r], h = i[(l + 1) % r];
                if (this.closed || l + 2 < r ? o = i[(l + 2) % r] : (vm.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), o = vm), "centripetal" === this.curveType || "chordal" === this.curveType) {
                    const t1 = "chordal" === this.curveType ? .5 : .25;
                    let e = Math.pow(s.distanceToSquared(u), t1), n = Math.pow(u.distanceToSquared(h), t1), i = Math.pow(h.distanceToSquared(o), t1);
                    n < 1e-4 && (n = 1), e < 1e-4 && (e = n), i < 1e-4 && (i = n), ym.initNonuniformCatmullRom(s.x, u.x, h.x, o.x, e, n, i), Mm.initNonuniformCatmullRom(s.y, u.y, h.y, o.y, e, n, i), bm.initNonuniformCatmullRom(s.z, u.z, h.z, o.z, e, n, i);
                } else "catmullrom" === this.curveType && (ym.initCatmullRom(s.x, u.x, h.x, o.x, this.tension), Mm.initCatmullRom(s.y, u.y, h.y, o.y, this.tension), bm.initCatmullRom(s.z, u.z, h.z, o.z, this.tension));
                return n.set(ym.calc(c), Mm.calc(c), bm.calc(c)), n;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, n = t1.points.length; e < n; e++){
                    const n = t1.points[e];
                    this.points.push(n.clone());
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, n = this.points.length; e < n; e++){
                    const n = this.points[e];
                    t1.points.push(n.toArray());
                }
                return t1.closed = this.closed, t1.curveType = this.curveType, t1.tension = this.tension, t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, n = t1.points.length; e < n; e++){
                    const n = t1.points[e];
                    this.points.push((new Ol).fromArray(n));
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
        }
        function wm(t1, e, n, i, r) {
            const a = .5 * (i - e), s = .5 * (r - n), o = t1 * t1;
            return (2 * n - 2 * i + a + s) * (t1 * o) + (-3 * n + 3 * i - 2 * a - s) * o + a * t1 + n;
        }
        function _m(t1, e, n, i) {
            return function(t1, e) {
                const n = 1 - t1;
                return n * n * e;
            }(t1, e) + function(t1, e) {
                return 2 * (1 - t1) * t1 * e;
            }(t1, n) + function(t1, e) {
                return t1 * t1 * e;
            }(t1, i);
        }
        function Em(t1, e, n, i, r) {
            return function(t1, e) {
                const n = 1 - t1;
                return n * n * n * e;
            }(t1, e) + function(t1, e) {
                const n = 1 - t1;
                return 3 * n * n * t1 * e;
            }(t1, n) + function(t1, e) {
                return 3 * (1 - t1) * t1 * t1 * e;
            }(t1, i) + function(t1, e) {
                return t1 * t1 * t1 * e;
            }(t1, r);
        }
        class Sm extends fm {
            constructor(t1 = new tl, e = new tl, n = new tl, i = new tl){
                super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = n, this.v3 = i;
            }
            getPoint(t1, e = new tl) {
                const n = e, i = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return n.set(Em(t1, i.x, r.x, a.x, s.x), Em(t1, i.y, r.y, a.y, s.y)), n;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class Tm extends fm {
            constructor(t1 = new Ol, e = new Ol, n = new Ol, i = new Ol){
                super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = n, this.v3 = i;
            }
            getPoint(t1, e = new Ol) {
                const n = e, i = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return n.set(Em(t1, i.x, r.x, a.x, s.x), Em(t1, i.y, r.y, a.y, s.y), Em(t1, i.z, r.z, a.z, s.z)), n;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class Im extends fm {
            constructor(t1 = new tl, e = new tl){
                super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new tl) {
                const n = e;
                return 1 === t1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t1).add(this.v1)), n;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new tl) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Cm extends fm {
            constructor(t1 = new Ol, e = new Ol){
                super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new Ol) {
                const n = e;
                return 1 === t1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t1).add(this.v1)), n;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new Ol) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Nm extends fm {
            constructor(t1 = new tl, e = new tl, n = new tl){
                super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = n;
            }
            getPoint(t1, e = new tl) {
                const n = e, i = this.v0, r = this.v1, a = this.v2;
                return n.set(_m(t1, i.x, r.x, a.x), _m(t1, i.y, r.y, a.y)), n;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Dm extends fm {
            constructor(t1 = new Ol, e = new Ol, n = new Ol){
                super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = n;
            }
            getPoint(t1, e = new Ol) {
                const n = e, i = this.v0, r = this.v1, a = this.v2;
                return n.set(_m(t1, i.x, r.x, a.x), _m(t1, i.y, r.y, a.y), _m(t1, i.z, r.z, a.z)), n;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Lm extends fm {
            constructor(t1 = []){
                super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t1;
            }
            getPoint(t1, e = new tl) {
                const n = e, i = this.points, r = (i.length - 1) * t1, a = Math.floor(r), s = r - a, o = i[0 === a ? a : a - 1], l = i[a], c = i[a > i.length - 2 ? i.length - 1 : a + 1], u = i[a > i.length - 3 ? i.length - 1 : a + 2];
                return n.set(wm(s, o.x, l.x, c.x, u.x), wm(s, o.y, l.y, c.y, u.y)), n;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, n = t1.points.length; e < n; e++){
                    const n = t1.points[e];
                    this.points.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, n = this.points.length; e < n; e++){
                    const n = this.points[e];
                    t1.points.push(n.toArray());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, n = t1.points.length; e < n; e++){
                    const n = t1.points[e];
                    this.points.push((new tl).fromArray(n));
                }
                return this;
            }
        }
        var Om = Object.freeze({
            __proto__: null,
            ArcCurve: gm,
            CatmullRomCurve3: xm,
            CubicBezierCurve: Sm,
            CubicBezierCurve3: Tm,
            EllipseCurve: mm,
            LineCurve: Im,
            LineCurve3: Cm,
            QuadraticBezierCurve: Nm,
            QuadraticBezierCurve3: Dm,
            SplineCurve: Lm
        });
        class Rm extends fm {
            constructor(){
                super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
            }
            add(t1) {
                this.curves.push(t1);
            }
            closePath() {
                const t1 = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
                if (!t1.equals(e)) {
                    const n = !0 === t1.isVector2 ? "LineCurve" : "LineCurve3";
                    this.curves.push(new Om[n](e, t1));
                }
                return this;
            }
            getPoint(t1, e) {
                const n = t1 * this.getLength(), i = this.getCurveLengths();
                let r = 0;
                for(; r < i.length;){
                    if (i[r] >= n) {
                        const t1 = i[r] - n, a = this.curves[r], s = a.getLength(), o = 0 === s ? 0 : 1 - t1 / s;
                        return a.getPointAt(o, e);
                    }
                    r++;
                }
                return null;
            }
            getLength() {
                const t1 = this.getCurveLengths();
                return t1[t1.length - 1];
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            }
            getCurveLengths() {
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                const t1 = [];
                let e = 0;
                for(let n = 0, i = this.curves.length; n < i; n++)e += this.curves[n].getLength(), t1.push(e);
                return this.cacheLengths = t1, t1;
            }
            getSpacedPoints(t1 = 40) {
                const e = [];
                for(let n = 0; n <= t1; n++)e.push(this.getPoint(n / t1));
                return this.autoClose && e.push(e[0]), e;
            }
            getPoints(t1 = 12) {
                const e = [];
                let n;
                for(let i = 0, r = this.curves; i < r.length; i++){
                    const a = r[i], s = a.isEllipseCurve ? 2 * t1 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? t1 * a.points.length : t1, o = a.getPoints(s);
                    for(let t1 = 0; t1 < o.length; t1++){
                        const i = o[t1];
                        n && n.equals(i) || (e.push(i), n = i);
                    }
                }
                return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
            }
            copy(t1) {
                super.copy(t1), this.curves = [];
                for(let e = 0, n = t1.curves.length; e < n; e++){
                    const n = t1.curves[e];
                    this.curves.push(n.clone());
                }
                return this.autoClose = t1.autoClose, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.autoClose = this.autoClose, t1.curves = [];
                for(let e = 0, n = this.curves.length; e < n; e++){
                    const n = this.curves[e];
                    t1.curves.push(n.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.autoClose = t1.autoClose, this.curves = [];
                for(let e = 0, n = t1.curves.length; e < n; e++){
                    const n = t1.curves[e];
                    this.curves.push((new Om[n.type]).fromJSON(n));
                }
                return this;
            }
        }
        class Pm extends Rm {
            constructor(t1){
                super(), this.type = "Path", this.currentPoint = new tl, t1 && this.setFromPoints(t1);
            }
            setFromPoints(t1) {
                this.moveTo(t1[0].x, t1[0].y);
                for(let e = 1, n = t1.length; e < n; e++)this.lineTo(t1[e].x, t1[e].y);
                return this;
            }
            moveTo(t1, e) {
                return this.currentPoint.set(t1, e), this;
            }
            lineTo(t1, e) {
                const n = new Im(this.currentPoint.clone(), new tl(t1, e));
                return this.curves.push(n), this.currentPoint.set(t1, e), this;
            }
            quadraticCurveTo(t1, e, n, i) {
                const r = new Nm(this.currentPoint.clone(), new tl(t1, e), new tl(n, i));
                return this.curves.push(r), this.currentPoint.set(n, i), this;
            }
            bezierCurveTo(t1, e, n, i, r, a) {
                const s = new Sm(this.currentPoint.clone(), new tl(t1, e), new tl(n, i), new tl(r, a));
                return this.curves.push(s), this.currentPoint.set(r, a), this;
            }
            splineThru(t1) {
                const e = [
                    this.currentPoint.clone()
                ].concat(t1), n = new Lm(e);
                return this.curves.push(n), this.currentPoint.copy(t1[t1.length - 1]), this;
            }
            arc(t1, e, n, i, r, a) {
                const s = this.currentPoint.x, o = this.currentPoint.y;
                return this.absarc(t1 + s, e + o, n, i, r, a), this;
            }
            absarc(t1, e, n, i, r, a) {
                return this.absellipse(t1, e, n, n, i, r, a), this;
            }
            ellipse(t1, e, n, i, r, a, s, o) {
                const l = this.currentPoint.x, c = this.currentPoint.y;
                return this.absellipse(t1 + l, e + c, n, i, r, a, s, o), this;
            }
            absellipse(t1, e, n, i, r, a, s, o) {
                const l = new mm(t1, e, n, i, r, a, s, o);
                if (this.curves.length > 0) {
                    const t1 = l.getPoint(0);
                    t1.equals(this.currentPoint) || this.lineTo(t1.x, t1.y);
                }
                this.curves.push(l);
                const c = l.getPoint(1);
                return this.currentPoint.copy(c), this;
            }
            copy(t1) {
                return super.copy(t1), this.currentPoint.copy(t1.currentPoint), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.currentPoint = this.currentPoint.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.currentPoint.fromArray(t1.currentPoint), this;
            }
        }
        class zm extends Tu {
            constructor(t1 = [
                new tl(0, -0.5),
                new tl(.5, 0),
                new tl(0, .5)
            ], e = 12, n = 0, i = 2 * Math.PI){
                super(), this.type = "LatheGeometry", this.parameters = {
                    points: t1,
                    segments: e,
                    phiStart: n,
                    phiLength: i
                }, e = Math.floor(e), i = Go(i, 0, 2 * Math.PI);
                const r = [], a = [], s = [], o = [], l = [], c = 1 / e, u = new Ol, h = new tl, d = new Ol, p = new Ol, f = new Ol;
                let m = 0, g = 0;
                for(let e = 0; e <= t1.length - 1; e++)switch(e){
                    case 0:
                        m = t1[e + 1].x - t1[e].x, g = t1[e + 1].y - t1[e].y, d.x = 1 * g, d.y = -m, d.z = 0 * g, f.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                        break;
                    case t1.length - 1:
                        o.push(f.x, f.y, f.z);
                        break;
                    default:
                        m = t1[e + 1].x - t1[e].x, g = t1[e + 1].y - t1[e].y, d.x = 1 * g, d.y = -m, d.z = 0 * g, p.copy(d), d.x += f.x, d.y += f.y, d.z += f.z, d.normalize(), o.push(d.x, d.y, d.z), f.copy(p);
                }
                for(let r = 0; r <= e; r++){
                    const d = n + r * c * i, p = Math.sin(d), f = Math.cos(d);
                    for(let n = 0; n <= t1.length - 1; n++){
                        u.x = t1[n].x * p, u.y = t1[n].y, u.z = t1[n].x * f, a.push(u.x, u.y, u.z), h.x = r / e, h.y = n / (t1.length - 1), s.push(h.x, h.y);
                        const i = o[3 * n + 0] * p, c = o[3 * n + 1], d = o[3 * n + 0] * f;
                        l.push(i, c, d);
                    }
                }
                for(let n = 0; n < e; n++)for(let e = 0; e < t1.length - 1; e++){
                    const i = e + n * t1.length, a = i, s = i + t1.length, o = i + t1.length + 1, l = i + 1;
                    r.push(a, s, l), r.push(o, l, s);
                }
                this.setIndex(r), this.setAttribute("position", new vu(a, 3)), this.setAttribute("uv", new vu(s, 2)), this.setAttribute("normal", new vu(l, 3));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new zm(t1.points, t1.segments, t1.phiStart, t1.phiLength);
            }
        }
        class Um extends zm {
            constructor(t1 = 1, e = 1, n = 4, i = 8){
                const r = new Pm;
                r.absarc(0, -e / 2, t1, 1.5 * Math.PI, 0), r.absarc(0, e / 2, t1, 0, .5 * Math.PI), super(r.getPoints(n), i), this.type = "CapsuleGeometry", this.parameters = {
                    radius: t1,
                    length: e,
                    capSegments: n,
                    radialSegments: i
                };
            }
            static fromJSON(t1) {
                return new Um(t1.radius, t1.length, t1.capSegments, t1.radialSegments);
            }
        }
        class km extends Tu {
            constructor(t1 = 1, e = 32, n = 0, i = 2 * Math.PI){
                super(), this.type = "CircleGeometry", this.parameters = {
                    radius: t1,
                    segments: e,
                    thetaStart: n,
                    thetaLength: i
                }, e = Math.max(3, e);
                const r = [], a = [], s = [], o = [], l = new Ol, c = new tl;
                a.push(0, 0, 0), s.push(0, 0, 1), o.push(.5, .5);
                for(let r = 0, u = 3; r <= e; r++, u += 3){
                    const h = n + r / e * i;
                    l.x = t1 * Math.cos(h), l.y = t1 * Math.sin(h), a.push(l.x, l.y, l.z), s.push(0, 0, 1), c.x = (a[u] / t1 + 1) / 2, c.y = (a[u + 1] / t1 + 1) / 2, o.push(c.x, c.y);
                }
                for(let t1 = 1; t1 <= e; t1++)r.push(t1, t1 + 1, 0);
                this.setIndex(r), this.setAttribute("position", new vu(a, 3)), this.setAttribute("normal", new vu(s, 3)), this.setAttribute("uv", new vu(o, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new km(t1.radius, t1.segments, t1.thetaStart, t1.thetaLength);
            }
        }
        class Bm extends Tu {
            constructor(t1 = 1, e = 1, n = 1, i = 32, r = 1, a = !1, s = 0, o = 2 * Math.PI){
                super(), this.type = "CylinderGeometry", this.parameters = {
                    radiusTop: t1,
                    radiusBottom: e,
                    height: n,
                    radialSegments: i,
                    heightSegments: r,
                    openEnded: a,
                    thetaStart: s,
                    thetaLength: o
                };
                const l = this;
                i = Math.floor(i), r = Math.floor(r);
                const c = [], u = [], h = [], d = [];
                let p = 0;
                const f = [], m = n / 2;
                let g = 0;
                function A(n) {
                    const r = p, a = new tl, f = new Ol;
                    let A = 0;
                    const v = !0 === n ? t1 : e, y = !0 === n ? 1 : -1;
                    for(let t1 = 1; t1 <= i; t1++)u.push(0, m * y, 0), h.push(0, y, 0), d.push(.5, .5), p++;
                    const M = p;
                    for(let t1 = 0; t1 <= i; t1++){
                        const e = t1 / i * o + s, n = Math.cos(e), r = Math.sin(e);
                        f.x = v * r, f.y = m * y, f.z = v * n, u.push(f.x, f.y, f.z), h.push(0, y, 0), a.x = .5 * n + .5, a.y = .5 * r * y + .5, d.push(a.x, a.y), p++;
                    }
                    for(let t1 = 0; t1 < i; t1++){
                        const e = r + t1, i = M + t1;
                        !0 === n ? c.push(i, i + 1, e) : c.push(i + 1, i, e), A += 3;
                    }
                    l.addGroup(g, A, !0 === n ? 1 : 2), g += A;
                }
                !function() {
                    const a = new Ol, A = new Ol;
                    let v = 0;
                    const y = (e - t1) / n;
                    for(let l = 0; l <= r; l++){
                        const c = [], g = l / r, v = g * (e - t1) + t1;
                        for(let t1 = 0; t1 <= i; t1++){
                            const e = t1 / i, r = e * o + s, l = Math.sin(r), f = Math.cos(r);
                            A.x = v * l, A.y = -g * n + m, A.z = v * f, u.push(A.x, A.y, A.z), a.set(l, y, f).normalize(), h.push(a.x, a.y, a.z), d.push(e, 1 - g), c.push(p++);
                        }
                        f.push(c);
                    }
                    for(let t1 = 0; t1 < i; t1++)for(let e = 0; e < r; e++){
                        const n = f[e][t1], i = f[e + 1][t1], r = f[e + 1][t1 + 1], a = f[e][t1 + 1];
                        c.push(n, i, a), c.push(i, r, a), v += 6;
                    }
                    l.addGroup(g, v, 0), g += v;
                }(), !1 === a && (t1 > 0 && A(!0), e > 0 && A(!1)), this.setIndex(c), this.setAttribute("position", new vu(u, 3)), this.setAttribute("normal", new vu(h, 3)), this.setAttribute("uv", new vu(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Bm(t1.radiusTop, t1.radiusBottom, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class jm extends Bm {
            constructor(t1 = 1, e = 1, n = 32, i = 1, r = !1, a = 0, s = 2 * Math.PI){
                super(0, t1, e, n, i, r, a, s), this.type = "ConeGeometry", this.parameters = {
                    radius: t1,
                    height: e,
                    radialSegments: n,
                    heightSegments: i,
                    openEnded: r,
                    thetaStart: a,
                    thetaLength: s
                };
            }
            static fromJSON(t1) {
                return new jm(t1.radius, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class Fm extends Tu {
            constructor(t1 = [], e = [], n = 1, i = 0){
                super(), this.type = "PolyhedronGeometry", this.parameters = {
                    vertices: t1,
                    indices: e,
                    radius: n,
                    detail: i
                };
                const r = [], a = [];
                function s(t1, e, n, i) {
                    const r = i + 1, a = [];
                    for(let i = 0; i <= r; i++){
                        a[i] = [];
                        const s = t1.clone().lerp(n, i / r), o = e.clone().lerp(n, i / r), l = r - i;
                        for(let t1 = 0; t1 <= l; t1++)a[i][t1] = 0 === t1 && i === r ? s : s.clone().lerp(o, t1 / l);
                    }
                    for(let t1 = 0; t1 < r; t1++)for(let e = 0; e < 2 * (r - t1) - 1; e++){
                        const n = Math.floor(e / 2);
                        e % 2 == 0 ? (o(a[t1][n + 1]), o(a[t1 + 1][n]), o(a[t1][n])) : (o(a[t1][n + 1]), o(a[t1 + 1][n + 1]), o(a[t1 + 1][n]));
                    }
                }
                function o(t1) {
                    r.push(t1.x, t1.y, t1.z);
                }
                function l(e, n) {
                    const i = 3 * e;
                    n.x = t1[i + 0], n.y = t1[i + 1], n.z = t1[i + 2];
                }
                function c(t1, e, n, i) {
                    i < 0 && 1 === t1.x && (a[e] = t1.x - 1), 0 === n.x && 0 === n.z && (a[e] = i / 2 / Math.PI + .5);
                }
                function u(t1) {
                    return Math.atan2(t1.z, -t1.x);
                }
                !function(t1) {
                    const n = new Ol, i = new Ol, r = new Ol;
                    for(let a = 0; a < e.length; a += 3)l(e[a + 0], n), l(e[a + 1], i), l(e[a + 2], r), s(n, i, r, t1);
                }(i), function(t1) {
                    const e = new Ol;
                    for(let n = 0; n < r.length; n += 3)e.x = r[n + 0], e.y = r[n + 1], e.z = r[n + 2], e.normalize().multiplyScalar(t1), r[n + 0] = e.x, r[n + 1] = e.y, r[n + 2] = e.z;
                }(n), function() {
                    const t1 = new Ol;
                    for(let n = 0; n < r.length; n += 3){
                        t1.x = r[n + 0], t1.y = r[n + 1], t1.z = r[n + 2];
                        const i = u(t1) / 2 / Math.PI + .5, s = (e = t1, Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z)) / Math.PI + .5);
                        a.push(i, 1 - s);
                    }
                    var e;
                    (function() {
                        const t1 = new Ol, e = new Ol, n = new Ol, i = new Ol, s = new tl, o = new tl, l = new tl;
                        for(let h = 0, d = 0; h < r.length; h += 9, d += 6){
                            t1.set(r[h + 0], r[h + 1], r[h + 2]), e.set(r[h + 3], r[h + 4], r[h + 5]), n.set(r[h + 6], r[h + 7], r[h + 8]), s.set(a[d + 0], a[d + 1]), o.set(a[d + 2], a[d + 3]), l.set(a[d + 4], a[d + 5]), i.copy(t1).add(e).add(n).divideScalar(3);
                            const p = u(i);
                            c(s, d + 0, t1, p), c(o, d + 2, e, p), c(l, d + 4, n, p);
                        }
                    })(), function() {
                        for(let t1 = 0; t1 < a.length; t1 += 6){
                            const e = a[t1 + 0], n = a[t1 + 2], i = a[t1 + 4], r = Math.max(e, n, i), s = Math.min(e, n, i);
                            r > .9 && s < .1 && (e < .2 && (a[t1 + 0] += 1), n < .2 && (a[t1 + 2] += 1), i < .2 && (a[t1 + 4] += 1));
                        }
                    }();
                }(), this.setAttribute("position", new vu(r, 3)), this.setAttribute("normal", new vu(r.slice(), 3)), this.setAttribute("uv", new vu(a, 2)), 0 === i ? this.computeVertexNormals() : this.normalizeNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Fm(t1.vertices, t1.indices, t1.radius, t1.details);
            }
        }
        class Hm extends Fm {
            constructor(t1 = 1, e = 0){
                const n = (1 + Math.sqrt(5)) / 2, i = 1 / n;
                super([
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    0,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    -i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    i
                ], [
                    3,
                    11,
                    7,
                    3,
                    7,
                    15,
                    3,
                    15,
                    13,
                    7,
                    19,
                    17,
                    7,
                    17,
                    6,
                    7,
                    6,
                    15,
                    17,
                    4,
                    8,
                    17,
                    8,
                    10,
                    17,
                    10,
                    6,
                    8,
                    0,
                    16,
                    8,
                    16,
                    2,
                    8,
                    2,
                    10,
                    0,
                    12,
                    1,
                    0,
                    1,
                    18,
                    0,
                    18,
                    16,
                    6,
                    10,
                    2,
                    6,
                    2,
                    13,
                    6,
                    13,
                    15,
                    2,
                    16,
                    18,
                    2,
                    18,
                    3,
                    2,
                    3,
                    13,
                    18,
                    1,
                    9,
                    18,
                    9,
                    11,
                    18,
                    11,
                    3,
                    4,
                    14,
                    12,
                    4,
                    12,
                    0,
                    4,
                    0,
                    8,
                    11,
                    9,
                    5,
                    11,
                    5,
                    19,
                    11,
                    19,
                    7,
                    19,
                    5,
                    14,
                    19,
                    14,
                    4,
                    19,
                    4,
                    17,
                    1,
                    12,
                    14,
                    1,
                    14,
                    5,
                    1,
                    5,
                    9
                ], t1, e), this.type = "DodecahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new Hm(t1.radius, t1.detail);
            }
        }
        const Vm = new Ol, Qm = new Ol, Gm = new Ol, Wm = new Wc;
        class Xm extends Tu {
            constructor(t1 = null, e = 1){
                if (super(), this.type = "EdgesGeometry", this.parameters = {
                    geometry: t1,
                    thresholdAngle: e
                }, null !== t1) {
                    const n = 4, i = Math.pow(10, n), r = Math.cos(Ho * e), a = t1.getIndex(), s = t1.getAttribute("position"), o = a ? a.count : s.count, l = [
                        0,
                        0,
                        0
                    ], c = [
                        "a",
                        "b",
                        "c"
                    ], u = new Array(3), h = {}, d = [];
                    for(let t1 = 0; t1 < o; t1 += 3){
                        a ? (l[0] = a.getX(t1), l[1] = a.getX(t1 + 1), l[2] = a.getX(t1 + 2)) : (l[0] = t1, l[1] = t1 + 1, l[2] = t1 + 2);
                        const { a: e, b: n, c: o } = Wm;
                        if (e.fromBufferAttribute(s, l[0]), n.fromBufferAttribute(s, l[1]), o.fromBufferAttribute(s, l[2]), Wm.getNormal(Gm), u[0] = `${Math.round(e.x * i)},${Math.round(e.y * i)},${Math.round(e.z * i)}`, u[1] = `${Math.round(n.x * i)},${Math.round(n.y * i)},${Math.round(n.z * i)}`, u[2] = `${Math.round(o.x * i)},${Math.round(o.y * i)},${Math.round(o.z * i)}`, u[0] !== u[1] && u[1] !== u[2] && u[2] !== u[0]) for(let t1 = 0; t1 < 3; t1++){
                            const e = (t1 + 1) % 3, n = u[t1], i = u[e], a = Wm[c[t1]], s = Wm[c[e]], o = `${n}_${i}`, p = `${i}_${n}`;
                            p in h && h[p] ? (Gm.dot(h[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)), h[p] = null) : o in h || (h[o] = {
                                index0: l[t1],
                                index1: l[e],
                                normal: Gm.clone()
                            });
                        }
                    }
                    for(const t1 in h)if (h[t1]) {
                        const { index0: e, index1: n } = h[t1];
                        Vm.fromBufferAttribute(s, e), Qm.fromBufferAttribute(s, n), d.push(Vm.x, Vm.y, Vm.z), d.push(Qm.x, Qm.y, Qm.z);
                    }
                    this.setAttribute("position", new vu(d, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        class Ym extends Pm {
            constructor(t1){
                super(t1), this.uuid = Qo(), this.type = "Shape", this.holes = [];
            }
            getPointsHoles(t1) {
                const e = [];
                for(let n = 0, i = this.holes.length; n < i; n++)e[n] = this.holes[n].getPoints(t1);
                return e;
            }
            extractPoints(t1) {
                return {
                    shape: this.getPoints(t1),
                    holes: this.getPointsHoles(t1)
                };
            }
            copy(t1) {
                super.copy(t1), this.holes = [];
                for(let e = 0, n = t1.holes.length; e < n; e++){
                    const n = t1.holes[e];
                    this.holes.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.uuid = this.uuid, t1.holes = [];
                for(let e = 0, n = this.holes.length; e < n; e++){
                    const n = this.holes[e];
                    t1.holes.push(n.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.uuid = t1.uuid, this.holes = [];
                for(let e = 0, n = t1.holes.length; e < n; e++){
                    const n = t1.holes[e];
                    this.holes.push((new Pm).fromJSON(n));
                }
                return this;
            }
        }
        function Zm(t1, e, n, i, r) {
            let a, s;
            if (r === function(t1, e, n, i) {
                let r = 0;
                for(let a = e, s = n - i; a < n; a += i)r += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
                return r;
            }(t1, e, n, i) > 0) for(a = e; a < n; a += i)s = gg(a, t1[a], t1[a + 1], s);
            else for(a = n - i; a >= e; a -= i)s = gg(a, t1[a], t1[a + 1], s);
            return s && ug(s, s.next) && (Ag(s), s = s.next), s;
        }
        function qm(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let n, i = t1;
            do if (n = !1, i.steiner || !ug(i, i.next) && 0 !== cg(i.prev, i, i.next)) i = i.next;
            else {
                if (Ag(i), i = e = i.prev, i === i.next) break;
                n = !0;
            }
            while (n || i !== e);
            return e;
        }
        function Jm(t1, e, n, i, r, a, s) {
            if (!t1) return;
            !s && a && function(t1, e, n, i) {
                let r = t1;
                do 0 === r.z && (r.z = ag(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== t1);
                r.prevZ.nextZ = null, r.prevZ = null, function(t1) {
                    let e, n, i, r, a, s, o, l, c = 1;
                    do {
                        for(n = t1, t1 = null, a = null, s = 0; n;){
                            for(s++, i = n, o = 0, e = 0; e < c && (o++, i = i.nextZ, i); e++);
                            for(l = c; o > 0 || l > 0 && i;)0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), a ? a.nextZ = r : t1 = r, r.prevZ = a, a = r;
                            n = i;
                        }
                        a.nextZ = null, c *= 2;
                    }while (s > 1);
                }(r);
            }(t1, i, r, a);
            let o, l, c = t1;
            for(; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, a ? $m(t1, i, r, a) : Km(t1)) e.push(o.i / n | 0), e.push(t1.i / n | 0), e.push(l.i / n | 0), Ag(t1), t1 = l.next, c = l.next;
            else if ((t1 = l) === c) {
                s ? 1 === s ? Jm(t1 = tg(qm(t1), e, n), e, n, i, r, a, 2) : 2 === s && eg(t1, e, n, i, r, a) : Jm(qm(t1), e, n, i, r, a, 1);
                break;
            }
        }
        function Km(t1) {
            const e = t1.prev, n = t1, i = t1.next;
            if (cg(e, n, i) >= 0) return !1;
            const r = e.x, a = n.x, s = i.x, o = e.y, l = n.y, c = i.y, u = r < a ? r < s ? r : s : a < s ? a : s, h = o < l ? o < c ? o : c : l < c ? l : c, d = r > a ? r > s ? r : s : a > s ? a : s, p = o > l ? o > c ? o : c : l > c ? l : c;
            let f = i.next;
            for(; f !== e;){
                if (f.x >= u && f.x <= d && f.y >= h && f.y <= p && og(r, o, a, l, s, c, f.x, f.y) && cg(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function $m(t1, e, n, i) {
            const r = t1.prev, a = t1, s = t1.next;
            if (cg(r, a, s) >= 0) return !1;
            const o = r.x, l = a.x, c = s.x, u = r.y, h = a.y, d = s.y, p = o < l ? o < c ? o : c : l < c ? l : c, f = u < h ? u < d ? u : d : h < d ? h : d, m = o > l ? o > c ? o : c : l > c ? l : c, g = u > h ? u > d ? u : d : h > d ? h : d, A = ag(p, f, e, n, i), v = ag(m, g, e, n, i);
            let y = t1.prevZ, M = t1.nextZ;
            for(; y && y.z >= A && M && M.z <= v;){
                if (y.x >= p && y.x <= m && y.y >= f && y.y <= g && y !== r && y !== s && og(o, u, l, h, c, d, y.x, y.y) && cg(y.prev, y, y.next) >= 0) return !1;
                if (y = y.prevZ, M.x >= p && M.x <= m && M.y >= f && M.y <= g && M !== r && M !== s && og(o, u, l, h, c, d, M.x, M.y) && cg(M.prev, M, M.next) >= 0) return !1;
                M = M.nextZ;
            }
            for(; y && y.z >= A;){
                if (y.x >= p && y.x <= m && y.y >= f && y.y <= g && y !== r && y !== s && og(o, u, l, h, c, d, y.x, y.y) && cg(y.prev, y, y.next) >= 0) return !1;
                y = y.prevZ;
            }
            for(; M && M.z <= v;){
                if (M.x >= p && M.x <= m && M.y >= f && M.y <= g && M !== r && M !== s && og(o, u, l, h, c, d, M.x, M.y) && cg(M.prev, M, M.next) >= 0) return !1;
                M = M.nextZ;
            }
            return !0;
        }
        function tg(t1, e, n) {
            let i = t1;
            do {
                const r = i.prev, a = i.next.next;
                !ug(r, a) && hg(r, i, i.next, a) && fg(r, a) && fg(a, r) && (e.push(r.i / n | 0), e.push(i.i / n | 0), e.push(a.i / n | 0), Ag(i), Ag(i.next), i = t1 = a), i = i.next;
            }while (i !== t1);
            return qm(i);
        }
        function eg(t1, e, n, i, r, a) {
            let s = t1;
            do {
                let t1 = s.next.next;
                for(; t1 !== s.prev;){
                    if (s.i !== t1.i && lg(s, t1)) {
                        let o = mg(s, t1);
                        return s = qm(s, s.next), o = qm(o, o.next), Jm(s, e, n, i, r, a, 0), void Jm(o, e, n, i, r, a, 0);
                    }
                    t1 = t1.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function ng(t1, e) {
            return t1.x - e.x;
        }
        function ig(t1, e) {
            const n = function(t1, e) {
                let n, i = e, r = -1 / 0;
                const a = t1.x, s = t1.y;
                do {
                    if (s <= i.y && s >= i.next.y && i.next.y !== i.y) {
                        const t1 = i.x + (s - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                        if (t1 <= a && t1 > r && (r = t1, n = i.x < i.next.x ? i : i.next, t1 === a)) return n;
                    }
                    i = i.next;
                }while (i !== e);
                if (!n) return null;
                const o = n, l = n.x, c = n.y;
                let u, h = 1 / 0;
                i = n;
                do a >= i.x && i.x >= l && a !== i.x && og(s < c ? a : r, s, l, c, s < c ? r : a, s, i.x, i.y) && (u = Math.abs(s - i.y) / (a - i.x), fg(i, t1) && (u < h || u === h && (i.x > n.x || i.x === n.x && rg(n, i))) && (n = i, h = u)), i = i.next;
                while (i !== o);
                return n;
            }(t1, e);
            if (!n) return e;
            const i = mg(n, t1);
            return qm(i, i.next), qm(n, n.next);
        }
        function rg(t1, e) {
            return cg(t1.prev, t1, e.prev) < 0 && cg(e.next, t1, t1.next) < 0;
        }
        function ag(t1, e, n, i, r) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - n) * r | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - i) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function sg(t1) {
            let e = t1, n = t1;
            do (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
            while (e !== t1);
            return n;
        }
        function og(t1, e, n, i, r, a, s, o) {
            return (r - s) * (e - o) >= (t1 - s) * (a - o) && (t1 - s) * (i - o) >= (n - s) * (e - o) && (n - s) * (a - o) >= (r - s) * (i - o);
        }
        function lg(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let n = t1;
                do {
                    if (n.i !== t1.i && n.next.i !== t1.i && n.i !== e.i && n.next.i !== e.i && hg(n, n.next, t1, e)) return !0;
                    n = n.next;
                }while (n !== t1);
                return !1;
            }(t1, e) && (fg(t1, e) && fg(e, t1) && function(t1, e) {
                let n = t1, i = !1;
                const r = (t1.x + e.x) / 2, a = (t1.y + e.y) / 2;
                do n.y > a != n.next.y > a && n.next.y !== n.y && r < (n.next.x - n.x) * (a - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
                while (n !== t1);
                return i;
            }(t1, e) && (cg(t1.prev, t1, e.prev) || cg(t1, e.prev, e)) || ug(t1, e) && cg(t1.prev, t1, t1.next) > 0 && cg(e.prev, e, e.next) > 0);
        }
        function cg(t1, e, n) {
            return (e.y - t1.y) * (n.x - e.x) - (e.x - t1.x) * (n.y - e.y);
        }
        function ug(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function hg(t1, e, n, i) {
            const r = pg(cg(t1, e, n)), a = pg(cg(t1, e, i)), s = pg(cg(n, i, t1)), o = pg(cg(n, i, e));
            return r !== a && s !== o || !(0 !== r || !dg(t1, n, e)) || !(0 !== a || !dg(t1, i, e)) || !(0 !== s || !dg(n, t1, i)) || !(0 !== o || !dg(n, e, i));
        }
        function dg(t1, e, n) {
            return e.x <= Math.max(t1.x, n.x) && e.x >= Math.min(t1.x, n.x) && e.y <= Math.max(t1.y, n.y) && e.y >= Math.min(t1.y, n.y);
        }
        function pg(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function fg(t1, e) {
            return cg(t1.prev, t1, t1.next) < 0 ? cg(t1, e, t1.next) >= 0 && cg(t1, t1.prev, e) >= 0 : cg(t1, e, t1.prev) < 0 || cg(t1, t1.next, e) < 0;
        }
        function mg(t1, e) {
            const n = new vg(t1.i, t1.x, t1.y), i = new vg(e.i, e.x, e.y), r = t1.next, a = e.prev;
            return t1.next = e, e.prev = t1, n.next = r, r.prev = n, i.next = n, n.prev = i, a.next = i, i.prev = a, i;
        }
        function gg(t1, e, n, i) {
            const r = new vg(t1, e, n);
            return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
        }
        function Ag(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function vg(t1, e, n) {
            this.i = t1, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        class yg {
            static area(t1) {
                const e = t1.length;
                let n = 0;
                for(let i = e - 1, r = 0; r < e; i = r++)n += t1[i].x * t1[r].y - t1[r].x * t1[i].y;
                return .5 * n;
            }
            static isClockWise(t1) {
                return yg.area(t1) < 0;
            }
            static triangulateShape(t1, e) {
                const n = [], i = [], r = [];
                Mg(t1), bg(n, t1);
                let a = t1.length;
                e.forEach(Mg);
                for(let t1 = 0; t1 < e.length; t1++)i.push(a), a += e[t1].length, bg(n, e[t1]);
                const s = function(t1, e, n = 2) {
                    const i = e && e.length, r = i ? e[0] * n : t1.length;
                    let a = Zm(t1, 0, r, n, !0);
                    const s = [];
                    if (!a || a.next === a.prev) return s;
                    let o, l, c, u, h, d, p;
                    if (i && (a = function(t1, e, n, i) {
                        const r = [];
                        let a, s, o, l, c;
                        for(a = 0, s = e.length; a < s; a++)o = e[a] * i, l = a < s - 1 ? e[a + 1] * i : t1.length, c = Zm(t1, o, l, i, !1), c === c.next && (c.steiner = !0), r.push(sg(c));
                        for(r.sort(ng), a = 0; a < r.length; a++)n = ig(r[a], n);
                        return n;
                    }(t1, e, a, n)), t1.length > 80 * n) {
                        o = c = t1[0], l = u = t1[1];
                        for(let e = n; e < r; e += n)h = t1[e], d = t1[e + 1], h < o && (o = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
                        p = Math.max(c - o, u - l), p = 0 !== p ? 32767 / p : 0;
                    }
                    return Jm(a, s, n, o, l, p, 0), s;
                }(n, i);
                for(let t1 = 0; t1 < s.length; t1 += 3)r.push(s.slice(t1, t1 + 3));
                return r;
            }
        }
        function Mg(t1) {
            const e = t1.length;
            e > 2 && t1[e - 1].equals(t1[0]) && t1.pop();
        }
        function bg(t1, e) {
            for(let n = 0; n < e.length; n++)t1.push(e[n].x), t1.push(e[n].y);
        }
        class xg extends Tu {
            constructor(t1 = new Ym([
                new tl(.5, .5),
                new tl(-0.5, .5),
                new tl(-0.5, -0.5),
                new tl(.5, -0.5)
            ]), e = {}){
                super(), this.type = "ExtrudeGeometry", this.parameters = {
                    shapes: t1,
                    options: e
                }, t1 = Array.isArray(t1) ? t1 : [
                    t1
                ];
                const n = this, i = [], r = [];
                for(let e = 0, n = t1.length; e < n; e++)a(t1[e]);
                function a(t1) {
                    const a = [], s = void 0 !== e.curveSegments ? e.curveSegments : 12, o = void 0 !== e.steps ? e.steps : 1, l = void 0 !== e.depth ? e.depth : 1;
                    let c = void 0 === e.bevelEnabled || e.bevelEnabled, u = void 0 !== e.bevelThickness ? e.bevelThickness : .2, h = void 0 !== e.bevelSize ? e.bevelSize : u - .1, d = void 0 !== e.bevelOffset ? e.bevelOffset : 0, p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
                    const f = e.extrudePath, m = void 0 !== e.UVGenerator ? e.UVGenerator : wg;
                    let g, A, v, y, M, b = !1;
                    f && (g = f.getSpacedPoints(o), b = !0, c = !1, A = f.computeFrenetFrames(o, !1), v = new Ol, y = new Ol, M = new Ol), c || (p = 0, u = 0, h = 0, d = 0);
                    const x = t1.extractPoints(s);
                    let w = x.shape;
                    const _ = x.holes;
                    if (!yg.isClockWise(w)) {
                        w = w.reverse();
                        for(let t1 = 0, e = _.length; t1 < e; t1++){
                            const e = _[t1];
                            yg.isClockWise(e) && (_[t1] = e.reverse());
                        }
                    }
                    const E = yg.triangulateShape(w, _), S = w;
                    for(let t1 = 0, e = _.length; t1 < e; t1++){
                        const e = _[t1];
                        w = w.concat(e);
                    }
                    function T(t1, e, n) {
                        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), t1.clone().addScaledVector(e, n);
                    }
                    const I = w.length, C = E.length;
                    function N(t1, e, n) {
                        let i, r, a;
                        const s = t1.x - e.x, o = t1.y - e.y, l = n.x - t1.x, c = n.y - t1.y, u = s * s + o * o, h = s * c - o * l;
                        if (Math.abs(h) > Number.EPSILON) {
                            const h = Math.sqrt(u), d = Math.sqrt(l * l + c * c), p = e.x - o / h, f = e.y + s / h, m = ((n.x - c / d - p) * c - (n.y + l / d - f) * l) / (s * c - o * l);
                            i = p + s * m - t1.x, r = f + o * m - t1.y;
                            const g = i * i + r * r;
                            if (g <= 2) return new tl(i, r);
                            a = Math.sqrt(g / 2);
                        } else {
                            let t1 = !1;
                            s > Number.EPSILON ? l > Number.EPSILON && (t1 = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (t1 = !0) : Math.sign(o) === Math.sign(c) && (t1 = !0), t1 ? (i = -o, r = s, a = Math.sqrt(u)) : (i = s, r = o, a = Math.sqrt(u / 2));
                        }
                        return new tl(i / a, r / a);
                    }
                    const D = [];
                    for(let t1 = 0, e = S.length, n = e - 1, i = t1 + 1; t1 < e; t1++, n++, i++)n === e && (n = 0), i === e && (i = 0), D[t1] = N(S[t1], S[n], S[i]);
                    const L = [];
                    let O, R = D.concat();
                    for(let t1 = 0, e = _.length; t1 < e; t1++){
                        const e = _[t1];
                        O = [];
                        for(let t1 = 0, n = e.length, i = n - 1, r = t1 + 1; t1 < n; t1++, i++, r++)i === n && (i = 0), r === n && (r = 0), O[t1] = N(e[t1], e[i], e[r]);
                        L.push(O), R = R.concat(O);
                    }
                    for(let t1 = 0; t1 < p; t1++){
                        const e = t1 / p, n = u * Math.cos(e * Math.PI / 2), i = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = S.length; t1 < e; t1++){
                            const e = T(S[t1], D[t1], i);
                            U(e.x, e.y, -n);
                        }
                        for(let t1 = 0, e = _.length; t1 < e; t1++){
                            const e = _[t1];
                            O = L[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = T(e[t1], O[t1], i);
                                U(r.x, r.y, -n);
                            }
                        }
                    }
                    const P = h + d;
                    for(let t1 = 0; t1 < I; t1++){
                        const e = c ? T(w[t1], R[t1], P) : w[t1];
                        b ? (y.copy(A.normals[0]).multiplyScalar(e.x), v.copy(A.binormals[0]).multiplyScalar(e.y), M.copy(g[0]).add(y).add(v), U(M.x, M.y, M.z)) : U(e.x, e.y, 0);
                    }
                    for(let t1 = 1; t1 <= o; t1++)for(let e = 0; e < I; e++){
                        const n = c ? T(w[e], R[e], P) : w[e];
                        b ? (y.copy(A.normals[t1]).multiplyScalar(n.x), v.copy(A.binormals[t1]).multiplyScalar(n.y), M.copy(g[t1]).add(y).add(v), U(M.x, M.y, M.z)) : U(n.x, n.y, l / o * t1);
                    }
                    for(let t1 = p - 1; t1 >= 0; t1--){
                        const e = t1 / p, n = u * Math.cos(e * Math.PI / 2), i = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = S.length; t1 < e; t1++){
                            const e = T(S[t1], D[t1], i);
                            U(e.x, e.y, l + n);
                        }
                        for(let t1 = 0, e = _.length; t1 < e; t1++){
                            const e = _[t1];
                            O = L[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = T(e[t1], O[t1], i);
                                b ? U(r.x, r.y + g[o - 1].y, g[o - 1].x + n) : U(r.x, r.y, l + n);
                            }
                        }
                    }
                    function z(t1, e) {
                        let n = t1.length;
                        for(; --n >= 0;){
                            const i = n;
                            let r = n - 1;
                            r < 0 && (r = t1.length - 1);
                            for(let t1 = 0, n = o + 2 * p; t1 < n; t1++){
                                const n = I * t1, a = I * (t1 + 1);
                                B(e + i + n, e + r + n, e + r + a, e + i + a);
                            }
                        }
                    }
                    function U(t1, e, n) {
                        a.push(t1), a.push(e), a.push(n);
                    }
                    function k(t1, e, r) {
                        j(t1), j(e), j(r);
                        const a = i.length / 3, s = m.generateTopUV(n, i, a - 3, a - 2, a - 1);
                        F(s[0]), F(s[1]), F(s[2]);
                    }
                    function B(t1, e, r, a) {
                        j(t1), j(e), j(a), j(e), j(r), j(a);
                        const s = i.length / 3, o = m.generateSideWallUV(n, i, s - 6, s - 3, s - 2, s - 1);
                        F(o[0]), F(o[1]), F(o[3]), F(o[1]), F(o[2]), F(o[3]);
                    }
                    function j(t1) {
                        i.push(a[3 * t1 + 0]), i.push(a[3 * t1 + 1]), i.push(a[3 * t1 + 2]);
                    }
                    function F(t1) {
                        r.push(t1.x), r.push(t1.y);
                    }
                    !function() {
                        const t1 = i.length / 3;
                        if (c) {
                            let t1 = 0, e = I * t1;
                            for(let t1 = 0; t1 < C; t1++){
                                const n = E[t1];
                                k(n[2] + e, n[1] + e, n[0] + e);
                            }
                            t1 = o + 2 * p, e = I * t1;
                            for(let t1 = 0; t1 < C; t1++){
                                const n = E[t1];
                                k(n[0] + e, n[1] + e, n[2] + e);
                            }
                        } else {
                            for(let t1 = 0; t1 < C; t1++){
                                const e = E[t1];
                                k(e[2], e[1], e[0]);
                            }
                            for(let t1 = 0; t1 < C; t1++){
                                const e = E[t1];
                                k(e[0] + I * o, e[1] + I * o, e[2] + I * o);
                            }
                        }
                        n.addGroup(t1, i.length / 3 - t1, 0);
                    }(), function() {
                        const t1 = i.length / 3;
                        let e = 0;
                        z(S, e), e += S.length;
                        for(let t1 = 0, n = _.length; t1 < n; t1++){
                            const n = _[t1];
                            z(n, e), e += n.length;
                        }
                        n.addGroup(t1, i.length / 3 - t1, 1);
                    }();
                }
                this.setAttribute("position", new vu(i, 3)), this.setAttribute("uv", new vu(r, 2)), this.computeVertexNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e, n) {
                    if (n.shapes = [], Array.isArray(t1)) for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e];
                        n.shapes.push(i.uuid);
                    }
                    else n.shapes.push(t1.uuid);
                    return n.options = Object.assign({}, e), void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON()), n;
                }(this.parameters.shapes, this.parameters.options, t1);
            }
            static fromJSON(t1, e) {
                const n = [];
                for(let i = 0, r = t1.shapes.length; i < r; i++){
                    const r = e[t1.shapes[i]];
                    n.push(r);
                }
                const i = t1.options.extrudePath;
                return void 0 !== i && (t1.options.extrudePath = (new Om[i.type]).fromJSON(i)), new xg(n, t1.options);
            }
        }
        const wg = {
            generateTopUV: function(t1, e, n, i, r) {
                const a = e[3 * n], s = e[3 * n + 1], o = e[3 * i], l = e[3 * i + 1], c = e[3 * r], u = e[3 * r + 1];
                return [
                    new tl(a, s),
                    new tl(o, l),
                    new tl(c, u)
                ];
            },
            generateSideWallUV: function(t1, e, n, i, r, a) {
                const s = e[3 * n], o = e[3 * n + 1], l = e[3 * n + 2], c = e[3 * i], u = e[3 * i + 1], h = e[3 * i + 2], d = e[3 * r], p = e[3 * r + 1], f = e[3 * r + 2], m = e[3 * a], g = e[3 * a + 1], A = e[3 * a + 2];
                return Math.abs(o - u) < Math.abs(s - c) ? [
                    new tl(s, 1 - l),
                    new tl(c, 1 - h),
                    new tl(d, 1 - f),
                    new tl(m, 1 - A)
                ] : [
                    new tl(o, 1 - l),
                    new tl(u, 1 - h),
                    new tl(p, 1 - f),
                    new tl(g, 1 - A)
                ];
            }
        };
        class _g extends Fm {
            constructor(t1 = 1, e = 0){
                const n = (1 + Math.sqrt(5)) / 2;
                super([
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    0,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    n,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    -n,
                    0,
                    -1,
                    -n,
                    0,
                    1
                ], [
                    0,
                    11,
                    5,
                    0,
                    5,
                    1,
                    0,
                    1,
                    7,
                    0,
                    7,
                    10,
                    0,
                    10,
                    11,
                    1,
                    5,
                    9,
                    5,
                    11,
                    4,
                    11,
                    10,
                    2,
                    10,
                    7,
                    6,
                    7,
                    1,
                    8,
                    3,
                    9,
                    4,
                    3,
                    4,
                    2,
                    3,
                    2,
                    6,
                    3,
                    6,
                    8,
                    3,
                    8,
                    9,
                    4,
                    9,
                    5,
                    2,
                    4,
                    11,
                    6,
                    2,
                    10,
                    8,
                    6,
                    7,
                    9,
                    8,
                    1
                ], t1, e), this.type = "IcosahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new _g(t1.radius, t1.detail);
            }
        }
        class Eg extends Fm {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1
                ], [
                    0,
                    2,
                    4,
                    0,
                    4,
                    3,
                    0,
                    3,
                    5,
                    0,
                    5,
                    2,
                    1,
                    2,
                    5,
                    1,
                    5,
                    3,
                    1,
                    3,
                    4,
                    1,
                    4,
                    2
                ], t1, e), this.type = "OctahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new Eg(t1.radius, t1.detail);
            }
        }
        class Sg extends Tu {
            constructor(t1 = .5, e = 1, n = 32, i = 1, r = 0, a = 2 * Math.PI){
                super(), this.type = "RingGeometry", this.parameters = {
                    innerRadius: t1,
                    outerRadius: e,
                    thetaSegments: n,
                    phiSegments: i,
                    thetaStart: r,
                    thetaLength: a
                }, n = Math.max(3, n);
                const s = [], o = [], l = [], c = [];
                let u = t1;
                const h = (e - t1) / (i = Math.max(1, i)), d = new Ol, p = new tl;
                for(let t1 = 0; t1 <= i; t1++){
                    for(let t1 = 0; t1 <= n; t1++){
                        const i = r + t1 / n * a;
                        d.x = u * Math.cos(i), d.y = u * Math.sin(i), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / e + 1) / 2, p.y = (d.y / e + 1) / 2, c.push(p.x, p.y);
                    }
                    u += h;
                }
                for(let t1 = 0; t1 < i; t1++){
                    const e = t1 * (n + 1);
                    for(let t1 = 0; t1 < n; t1++){
                        const i = t1 + e, r = i, a = i + n + 1, o = i + n + 2, l = i + 1;
                        s.push(r, a, l), s.push(a, o, l);
                    }
                }
                this.setIndex(s), this.setAttribute("position", new vu(o, 3)), this.setAttribute("normal", new vu(l, 3)), this.setAttribute("uv", new vu(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Sg(t1.innerRadius, t1.outerRadius, t1.thetaSegments, t1.phiSegments, t1.thetaStart, t1.thetaLength);
            }
        }
        class Tg extends Tu {
            constructor(t1 = new Ym([
                new tl(0, .5),
                new tl(-0.5, -0.5),
                new tl(.5, -0.5)
            ]), e = 12){
                super(), this.type = "ShapeGeometry", this.parameters = {
                    shapes: t1,
                    curveSegments: e
                };
                const n = [], i = [], r = [], a = [];
                let s = 0, o = 0;
                if (!1 === Array.isArray(t1)) l(t1);
                else for(let e = 0; e < t1.length; e++)l(t1[e]), this.addGroup(s, o, e), s += o, o = 0;
                function l(t1) {
                    const s = i.length / 3, l = t1.extractPoints(e);
                    let c = l.shape;
                    const u = l.holes;
                    !1 === yg.isClockWise(c) && (c = c.reverse());
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        !0 === yg.isClockWise(e) && (u[t1] = e.reverse());
                    }
                    const h = yg.triangulateShape(c, u);
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        c = c.concat(e);
                    }
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        i.push(e.x, e.y, 0), r.push(0, 0, 1), a.push(e.x, e.y);
                    }
                    for(let t1 = 0, e = h.length; t1 < e; t1++){
                        const e = h[t1], i = e[0] + s, r = e[1] + s, a = e[2] + s;
                        n.push(i, r, a), o += 3;
                    }
                }
                this.setIndex(n), this.setAttribute("position", new vu(i, 3)), this.setAttribute("normal", new vu(r, 3)), this.setAttribute("uv", new vu(a, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e) {
                    if (e.shapes = [], Array.isArray(t1)) for(let n = 0, i = t1.length; n < i; n++){
                        const i = t1[n];
                        e.shapes.push(i.uuid);
                    }
                    else e.shapes.push(t1.uuid);
                    return e;
                }(this.parameters.shapes, t1);
            }
            static fromJSON(t1, e) {
                const n = [];
                for(let i = 0, r = t1.shapes.length; i < r; i++){
                    const r = e[t1.shapes[i]];
                    n.push(r);
                }
                return new Tg(n, t1.curveSegments);
            }
        }
        class Ig extends Tu {
            constructor(t1 = 1, e = 32, n = 16, i = 0, r = 2 * Math.PI, a = 0, s = Math.PI){
                super(), this.type = "SphereGeometry", this.parameters = {
                    radius: t1,
                    widthSegments: e,
                    heightSegments: n,
                    phiStart: i,
                    phiLength: r,
                    thetaStart: a,
                    thetaLength: s
                }, e = Math.max(3, Math.floor(e)), n = Math.max(2, Math.floor(n));
                const o = Math.min(a + s, Math.PI);
                let l = 0;
                const c = [], u = new Ol, h = new Ol, d = [], p = [], f = [], m = [];
                for(let d = 0; d <= n; d++){
                    const g = [], A = d / n;
                    let v = 0;
                    0 === d && 0 === a ? v = .5 / e : d === n && o === Math.PI && (v = -0.5 / e);
                    for(let n = 0; n <= e; n++){
                        const o = n / e;
                        u.x = -t1 * Math.cos(i + o * r) * Math.sin(a + A * s), u.y = t1 * Math.cos(a + A * s), u.z = t1 * Math.sin(i + o * r) * Math.sin(a + A * s), p.push(u.x, u.y, u.z), h.copy(u).normalize(), f.push(h.x, h.y, h.z), m.push(o + v, 1 - A), g.push(l++);
                    }
                    c.push(g);
                }
                for(let t1 = 0; t1 < n; t1++)for(let i = 0; i < e; i++){
                    const e = c[t1][i + 1], r = c[t1][i], s = c[t1 + 1][i], l = c[t1 + 1][i + 1];
                    (0 !== t1 || a > 0) && d.push(e, r, l), (t1 !== n - 1 || o < Math.PI) && d.push(r, s, l);
                }
                this.setIndex(d), this.setAttribute("position", new vu(p, 3)), this.setAttribute("normal", new vu(f, 3)), this.setAttribute("uv", new vu(m, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Ig(t1.radius, t1.widthSegments, t1.heightSegments, t1.phiStart, t1.phiLength, t1.thetaStart, t1.thetaLength);
            }
        }
        class Cg extends Fm {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ], [
                    2,
                    1,
                    0,
                    0,
                    3,
                    2,
                    1,
                    3,
                    0,
                    2,
                    3,
                    1
                ], t1, e), this.type = "TetrahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new Cg(t1.radius, t1.detail);
            }
        }
        class Ng extends Tu {
            constructor(t1 = 1, e = .4, n = 12, i = 48, r = 2 * Math.PI){
                super(), this.type = "TorusGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    radialSegments: n,
                    tubularSegments: i,
                    arc: r
                }, n = Math.floor(n), i = Math.floor(i);
                const a = [], s = [], o = [], l = [], c = new Ol, u = new Ol, h = new Ol;
                for(let a = 0; a <= n; a++)for(let d = 0; d <= i; d++){
                    const p = d / i * r, f = a / n * Math.PI * 2;
                    u.x = (t1 + e * Math.cos(f)) * Math.cos(p), u.y = (t1 + e * Math.cos(f)) * Math.sin(p), u.z = e * Math.sin(f), s.push(u.x, u.y, u.z), c.x = t1 * Math.cos(p), c.y = t1 * Math.sin(p), h.subVectors(u, c).normalize(), o.push(h.x, h.y, h.z), l.push(d / i), l.push(a / n);
                }
                for(let t1 = 1; t1 <= n; t1++)for(let e = 1; e <= i; e++){
                    const n = (i + 1) * t1 + e - 1, r = (i + 1) * (t1 - 1) + e - 1, s = (i + 1) * (t1 - 1) + e, o = (i + 1) * t1 + e;
                    a.push(n, r, o), a.push(r, s, o);
                }
                this.setIndex(a), this.setAttribute("position", new vu(s, 3)), this.setAttribute("normal", new vu(o, 3)), this.setAttribute("uv", new vu(l, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Ng(t1.radius, t1.tube, t1.radialSegments, t1.tubularSegments, t1.arc);
            }
        }
        class Dg extends Tu {
            constructor(t1 = 1, e = .4, n = 64, i = 8, r = 2, a = 3){
                super(), this.type = "TorusKnotGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    tubularSegments: n,
                    radialSegments: i,
                    p: r,
                    q: a
                }, n = Math.floor(n), i = Math.floor(i);
                const s = [], o = [], l = [], c = [], u = new Ol, h = new Ol, d = new Ol, p = new Ol, f = new Ol, m = new Ol, g = new Ol;
                for(let s = 0; s <= n; ++s){
                    const v = s / n * r * Math.PI * 2;
                    A(v, r, a, t1, d), A(v + .01, r, a, t1, p), m.subVectors(p, d), g.addVectors(p, d), f.crossVectors(m, g), g.crossVectors(f, m), f.normalize(), g.normalize();
                    for(let t1 = 0; t1 <= i; ++t1){
                        const r = t1 / i * Math.PI * 2, a = -e * Math.cos(r), p = e * Math.sin(r);
                        u.x = d.x + (a * g.x + p * f.x), u.y = d.y + (a * g.y + p * f.y), u.z = d.z + (a * g.z + p * f.z), o.push(u.x, u.y, u.z), h.subVectors(u, d).normalize(), l.push(h.x, h.y, h.z), c.push(s / n), c.push(t1 / i);
                    }
                }
                for(let t1 = 1; t1 <= n; t1++)for(let e = 1; e <= i; e++){
                    const n = (i + 1) * (t1 - 1) + (e - 1), r = (i + 1) * t1 + (e - 1), a = (i + 1) * t1 + e, o = (i + 1) * (t1 - 1) + e;
                    s.push(n, r, o), s.push(r, a, o);
                }
                function A(t1, e, n, i, r) {
                    const a = Math.cos(t1), s = Math.sin(t1), o = n / e * t1, l = Math.cos(o);
                    r.x = i * (2 + l) * .5 * a, r.y = i * (2 + l) * s * .5, r.z = i * Math.sin(o) * .5;
                }
                this.setIndex(s), this.setAttribute("position", new vu(o, 3)), this.setAttribute("normal", new vu(l, 3)), this.setAttribute("uv", new vu(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Dg(t1.radius, t1.tube, t1.tubularSegments, t1.radialSegments, t1.p, t1.q);
            }
        }
        class Lg extends Tu {
            constructor(t1 = new Dm(new Ol(-1, -1, 0), new Ol(-1, 1, 0), new Ol(1, 1, 0)), e = 64, n = 1, i = 8, r = !1){
                super(), this.type = "TubeGeometry", this.parameters = {
                    path: t1,
                    tubularSegments: e,
                    radius: n,
                    radialSegments: i,
                    closed: r
                };
                const a = t1.computeFrenetFrames(e, r);
                this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals;
                const s = new Ol, o = new Ol, l = new tl;
                let c = new Ol;
                const u = [], h = [], d = [], p = [];
                function f(r) {
                    c = t1.getPointAt(r / e, c);
                    const l = a.normals[r], d = a.binormals[r];
                    for(let t1 = 0; t1 <= i; t1++){
                        const e = t1 / i * Math.PI * 2, r = Math.sin(e), a = -Math.cos(e);
                        o.x = a * l.x + r * d.x, o.y = a * l.y + r * d.y, o.z = a * l.z + r * d.z, o.normalize(), h.push(o.x, o.y, o.z), s.x = c.x + n * o.x, s.y = c.y + n * o.y, s.z = c.z + n * o.z, u.push(s.x, s.y, s.z);
                    }
                }
                !function() {
                    for(let t1 = 0; t1 < e; t1++)f(t1);
                    f(!1 === r ? e : 0), function() {
                        for(let t1 = 0; t1 <= e; t1++)for(let n = 0; n <= i; n++)l.x = t1 / e, l.y = n / i, d.push(l.x, l.y);
                    }(), function() {
                        for(let t1 = 1; t1 <= e; t1++)for(let e = 1; e <= i; e++){
                            const n = (i + 1) * (t1 - 1) + (e - 1), r = (i + 1) * t1 + (e - 1), a = (i + 1) * t1 + e, s = (i + 1) * (t1 - 1) + e;
                            p.push(n, r, s), p.push(r, a, s);
                        }
                    }();
                }(), this.setIndex(p), this.setAttribute("position", new vu(u, 3)), this.setAttribute("normal", new vu(h, 3)), this.setAttribute("uv", new vu(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.path = this.parameters.path.toJSON(), t1;
            }
            static fromJSON(t1) {
                return new Lg((new Om[t1.path.type]).fromJSON(t1.path), t1.tubularSegments, t1.radius, t1.radialSegments, t1.closed);
            }
        }
        class Og extends Tu {
            constructor(t1 = null){
                if (super(), this.type = "WireframeGeometry", this.parameters = {
                    geometry: t1
                }, null !== t1) {
                    const e = [], n = new Set, i = new Ol, r = new Ol;
                    if (null !== t1.index) {
                        const a = t1.attributes.position, s = t1.index;
                        let o = t1.groups;
                        0 === o.length && (o = [
                            {
                                start: 0,
                                count: s.count,
                                materialIndex: 0
                            }
                        ]);
                        for(let t1 = 0, l = o.length; t1 < l; ++t1){
                            const l = o[t1], c = l.start;
                            for(let t1 = c, o = c + l.count; t1 < o; t1 += 3)for(let o = 0; o < 3; o++){
                                const l = s.getX(t1 + o), c = s.getX(t1 + (o + 1) % 3);
                                i.fromBufferAttribute(a, l), r.fromBufferAttribute(a, c), !0 === Rg(i, r, n) && (e.push(i.x, i.y, i.z), e.push(r.x, r.y, r.z));
                            }
                        }
                    } else {
                        const a = t1.attributes.position;
                        for(let t1 = 0, s = a.count / 3; t1 < s; t1++)for(let s = 0; s < 3; s++){
                            const o = 3 * t1 + s, l = 3 * t1 + (s + 1) % 3;
                            i.fromBufferAttribute(a, o), r.fromBufferAttribute(a, l), !0 === Rg(i, r, n) && (e.push(i.x, i.y, i.z), e.push(r.x, r.y, r.z));
                        }
                    }
                    this.setAttribute("position", new vu(e, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        function Rg(t1, e, n) {
            const i = `${t1.x},${t1.y},${t1.z}-${e.x},${e.y},${e.z}`, r = `${e.x},${e.y},${e.z}-${t1.x},${t1.y},${t1.z}`;
            return !0 !== n.has(i) && !0 !== n.has(r) && (n.add(i), n.add(r), !0);
        }
        var Pg = Object.freeze({
            __proto__: null,
            BoxGeometry: Xu,
            CapsuleGeometry: Um,
            CircleGeometry: km,
            ConeGeometry: jm,
            CylinderGeometry: Bm,
            DodecahedronGeometry: Hm,
            EdgesGeometry: Xm,
            ExtrudeGeometry: xg,
            IcosahedronGeometry: _g,
            LatheGeometry: zm,
            OctahedronGeometry: Eg,
            PlaneGeometry: fh,
            PolyhedronGeometry: Fm,
            RingGeometry: Sg,
            ShapeGeometry: Tg,
            SphereGeometry: Ig,
            TetrahedronGeometry: Cg,
            TorusGeometry: Ng,
            TorusKnotGeometry: Dg,
            TubeGeometry: Lg,
            WireframeGeometry: Og
        });
        class zg extends tu {
            constructor(t1){
                super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new Jc(0), this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.fog = t1.fog, this;
            }
        }
        class Ug extends Ku {
            constructor(t1){
                super(t1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
            }
        }
        class kg extends tu {
            constructor(t1){
                super(), this.isMeshStandardMaterial = !0, this.defines = {
                    STANDARD: ""
                }, this.type = "MeshStandardMaterial", this.color = new Jc(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Jc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: ""
                }, this.color.copy(t1.color), this.roughness = t1.roughness, this.metalness = t1.metalness, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.roughnessMap = t1.roughnessMap, this.metalnessMap = t1.metalnessMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.envMapIntensity = t1.envMapIntensity, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Bg extends kg {
            constructor(t1){
                super(), this.isMeshPhysicalMaterial = !0, this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new tl(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
                    get: function() {
                        return Go(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                    },
                    set: function(t1) {
                        this.ior = (1 + .4 * t1) / (1 - .4 * t1);
                    }
                }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
                    100,
                    400
                ], this.iridescenceThicknessMap = null, this.sheenColor = new Jc(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new Jc(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Jc(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(t1);
            }
            get anisotropy() {
                return this._anisotropy;
            }
            set anisotropy(t1) {
                this._anisotropy > 0 != t1 > 0 && this.version++, this._anisotropy = t1;
            }
            get clearcoat() {
                return this._clearcoat;
            }
            set clearcoat(t1) {
                this._clearcoat > 0 != t1 > 0 && this.version++, this._clearcoat = t1;
            }
            get iridescence() {
                return this._iridescence;
            }
            set iridescence(t1) {
                this._iridescence > 0 != t1 > 0 && this.version++, this._iridescence = t1;
            }
            get sheen() {
                return this._sheen;
            }
            set sheen(t1) {
                this._sheen > 0 != t1 > 0 && this.version++, this._sheen = t1;
            }
            get transmission() {
                return this._transmission;
            }
            set transmission(t1) {
                this._transmission > 0 != t1 > 0 && this.version++, this._transmission = t1;
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.anisotropy = t1.anisotropy, this.anisotropyRotation = t1.anisotropyRotation, this.anisotropyMap = t1.anisotropyMap, this.clearcoat = t1.clearcoat, this.clearcoatMap = t1.clearcoatMap, this.clearcoatRoughness = t1.clearcoatRoughness, this.clearcoatRoughnessMap = t1.clearcoatRoughnessMap, this.clearcoatNormalMap = t1.clearcoatNormalMap, this.clearcoatNormalScale.copy(t1.clearcoatNormalScale), this.ior = t1.ior, this.iridescence = t1.iridescence, this.iridescenceMap = t1.iridescenceMap, this.iridescenceIOR = t1.iridescenceIOR, this.iridescenceThicknessRange = [
                    ...t1.iridescenceThicknessRange
                ], this.iridescenceThicknessMap = t1.iridescenceThicknessMap, this.sheen = t1.sheen, this.sheenColor.copy(t1.sheenColor), this.sheenColorMap = t1.sheenColorMap, this.sheenRoughness = t1.sheenRoughness, this.sheenRoughnessMap = t1.sheenRoughnessMap, this.transmission = t1.transmission, this.transmissionMap = t1.transmissionMap, this.thickness = t1.thickness, this.thicknessMap = t1.thicknessMap, this.attenuationDistance = t1.attenuationDistance, this.attenuationColor.copy(t1.attenuationColor), this.specularIntensity = t1.specularIntensity, this.specularIntensityMap = t1.specularIntensityMap, this.specularColor.copy(t1.specularColor), this.specularColorMap = t1.specularColorMap, this;
            }
        }
        class jg extends tu {
            constructor(t1){
                super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new Jc(16777215), this.specular = new Jc(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Jc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Zr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.specular.copy(t1.specular), this.shininess = t1.shininess, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Fg extends tu {
            constructor(t1){
                super(), this.isMeshToonMaterial = !0, this.defines = {
                    TOON: ""
                }, this.type = "MeshToonMaterial", this.color = new Jc(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Jc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.gradientMap = t1.gradientMap, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        class Hg extends tu {
            constructor(t1){
                super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.flatShading = t1.flatShading, this;
            }
        }
        class Vg extends tu {
            constructor(t1){
                super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Jc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Jc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Zr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Qg extends tu {
            constructor(t1){
                super(), this.isMeshMatcapMaterial = !0, this.defines = {
                    MATCAP: ""
                }, this.type = "MeshMatcapMaterial", this.color = new Jc(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Vs, this.normalScale = new tl(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    MATCAP: ""
                }, this.color.copy(t1.color), this.matcap = t1.matcap, this.map = t1.map, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Gg extends Qf {
            constructor(t1){
                super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.scale = t1.scale, this.dashSize = t1.dashSize, this.gapSize = t1.gapSize, this;
            }
        }
        function Wg(t1, e, n) {
            return !t1 || !n && t1.constructor === e ? t1 : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t1) : Array.prototype.slice.call(t1);
        }
        function Xg(t1) {
            return ArrayBuffer.isView(t1) && !(t1 instanceof DataView);
        }
        function Yg(t1) {
            const e = t1.length, n = new Array(e);
            for(let t1 = 0; t1 !== e; ++t1)n[t1] = t1;
            return n.sort(function(e, n) {
                return t1[e] - t1[n];
            }), n;
        }
        function Zg(t1, e, n) {
            const i = t1.length, r = new t1.constructor(i);
            for(let a = 0, s = 0; s !== i; ++a){
                const i = n[a] * e;
                for(let n = 0; n !== e; ++n)r[s++] = t1[i + n];
            }
            return r;
        }
        function qg(t1, e, n, i) {
            let r = 1, a = t1[0];
            for(; void 0 !== a && void 0 === a[i];)a = t1[r++];
            if (void 0 === a) return;
            let s = a[i];
            if (void 0 !== s) {
                if (Array.isArray(s)) do s = a[i], void 0 !== s && (e.push(a.time), n.push.apply(n, s)), a = t1[r++];
                while (void 0 !== a);
                else if (void 0 !== s.toArray) do s = a[i], void 0 !== s && (e.push(a.time), s.toArray(n, n.length)), a = t1[r++];
                while (void 0 !== a);
                else do s = a[i], void 0 !== s && (e.push(a.time), n.push(s)), a = t1[r++];
                while (void 0 !== a);
            }
        }
        const Jg = {
            convertArray: Wg,
            isTypedArray: Xg,
            getKeyframeOrder: Yg,
            sortedArray: Zg,
            flattenJSON: qg,
            subclip: function(t1, e, n, i, r = 30) {
                const a = t1.clone();
                a.name = e;
                const s = [];
                for(let t1 = 0; t1 < a.tracks.length; ++t1){
                    const e = a.tracks[t1], o = e.getValueSize(), l = [], c = [];
                    for(let t1 = 0; t1 < e.times.length; ++t1){
                        const a = e.times[t1] * r;
                        if (!(a < n || a >= i)) {
                            l.push(e.times[t1]);
                            for(let n = 0; n < o; ++n)c.push(e.values[t1 * o + n]);
                        }
                    }
                    0 !== l.length && (e.times = Wg(l, e.times.constructor), e.values = Wg(c, e.values.constructor), s.push(e));
                }
                a.tracks = s;
                let o = 1 / 0;
                for(let t1 = 0; t1 < a.tracks.length; ++t1)o > a.tracks[t1].times[0] && (o = a.tracks[t1].times[0]);
                for(let t1 = 0; t1 < a.tracks.length; ++t1)a.tracks[t1].shift(-1 * o);
                return a.resetDuration(), a;
            },
            makeClipAdditive: function(t1, e = 0, n = t1, i = 30) {
                i <= 0 && (i = 30);
                const r = n.tracks.length, a = e / i;
                for(let e = 0; e < r; ++e){
                    const i = n.tracks[e], r = i.ValueTypeName;
                    if ("bool" === r || "string" === r) continue;
                    const s = t1.tracks.find(function(t1) {
                        return t1.name === i.name && t1.ValueTypeName === r;
                    });
                    if (void 0 === s) continue;
                    let o = 0;
                    const l = i.getValueSize();
                    i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
                    let c = 0;
                    const u = s.getValueSize();
                    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = u / 3);
                    const h = i.times.length - 1;
                    let d;
                    if (a <= i.times[0]) {
                        const t1 = o, e = l - o;
                        d = i.values.slice(t1, e);
                    } else if (a >= i.times[h]) {
                        const t1 = h * l + o, e = t1 + l - o;
                        d = i.values.slice(t1, e);
                    } else {
                        const t1 = i.createInterpolant(), e = o, n = l - o;
                        t1.evaluate(a), d = t1.resultBuffer.slice(e, n);
                    }
                    "quaternion" === r && (new Ll).fromArray(d).normalize().conjugate().toArray(d);
                    const p = s.times.length;
                    for(let t1 = 0; t1 < p; ++t1){
                        const e = t1 * u + c;
                        if ("quaternion" === r) Ll.multiplyQuaternionsFlat(s.values, e, d, 0, s.values, e);
                        else {
                            const t1 = u - 2 * c;
                            for(let n = 0; n < t1; ++n)s.values[e + n] -= d[n];
                        }
                    }
                }
                return t1.blendMode = Ps, t1;
            }
        };
        class Kg {
            constructor(t1, e, n, i){
                this.parameterPositions = t1, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
            }
            evaluate(t1) {
                const e = this.parameterPositions;
                let n = this._cachedIndex, i = e[n], r = e[n - 1];
                t: {
                    e: {
                        let a;
                        n: {
                            i: if (!(t1 < i)) {
                                for(let a = n + 2;;){
                                    if (void 0 === i) {
                                        if (t1 < r) break i;
                                        return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                                    }
                                    if (n === a) break;
                                    if (r = i, i = e[++n], t1 < i) break e;
                                }
                                a = e.length;
                                break n;
                            }
                            if (t1 >= r) break t;
                            {
                                const s = e[1];
                                t1 < s && (n = 2, r = s);
                                for(let a = n - 2;;){
                                    if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                                    if (n === a) break;
                                    if (i = r, r = e[--n - 1], t1 >= r) break e;
                                }
                                a = n, n = 0;
                            }
                        }
                        for(; n < a;){
                            const i = n + a >>> 1;
                            t1 < e[i] ? a = i : n = i + 1;
                        }
                        if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                        if (void 0 === i) return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                    }
                    this._cachedIndex = n, this.intervalChanged_(n, r, i);
                }
                return this.interpolate_(n, r, t1, i);
            }
            getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = t1 * i;
                for(let t1 = 0; t1 !== i; ++t1)e[t1] = n[r + t1];
                return e;
            }
            interpolate_() {
                throw new Error("call to abstract method");
            }
            intervalChanged_() {}
        }
        class $g extends Kg {
            constructor(t1, e, n, i){
                super(t1, e, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                    endingStart: Ds,
                    endingEnd: Ds
                };
            }
            intervalChanged_(t1, e, n) {
                const i = this.parameterPositions;
                let r = t1 - 2, a = t1 + 1, s = i[r], o = i[a];
                if (void 0 === s) switch(this.getSettings_().endingStart){
                    case Ls:
                        r = t1, s = 2 * e - n;
                        break;
                    case Os:
                        r = i.length - 2, s = e + i[r] - i[r + 1];
                        break;
                    default:
                        r = t1, s = n;
                }
                if (void 0 === o) switch(this.getSettings_().endingEnd){
                    case Ls:
                        a = t1, o = 2 * n - e;
                        break;
                    case Os:
                        a = 1, o = n + i[1] - i[0];
                        break;
                    default:
                        a = t1 - 1, o = e;
                }
                const l = .5 * (n - e), c = this.valueSize;
                this._weightPrev = l / (e - s), this._weightNext = l / (o - n), this._offsetPrev = r * c, this._offsetNext = a * c;
            }
            interpolate_(t1, e, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, d = this._weightNext, p = (n - e) / (i - e), f = p * p, m = f * p, g = -h * m + 2 * h * f - h * p, A = (1 + h) * m + (-1.5 - 2 * h) * f + (-0.5 + h) * p + 1, v = (-1 - d) * m + (1.5 + d) * f + .5 * p, y = d * m - d * f;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = g * a[c + t1] + A * a[l + t1] + v * a[o + t1] + y * a[u + t1];
                return r;
            }
        }
        class tA extends Kg {
            constructor(t1, e, n, i){
                super(t1, e, n, i);
            }
            interpolate_(t1, e, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = (n - e) / (i - e), u = 1 - c;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = a[l + t1] * u + a[o + t1] * c;
                return r;
            }
        }
        class eA extends Kg {
            constructor(t1, e, n, i){
                super(t1, e, n, i);
            }
            interpolate_(t1) {
                return this.copySampleValue_(t1 - 1);
            }
        }
        class nA {
            constructor(t1, e, n, i){
                if (void 0 === t1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t1);
                this.name = t1, this.times = Wg(e, this.TimeBufferType), this.values = Wg(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
            }
            static toJSON(t1) {
                const e = t1.constructor;
                let n;
                if (e.toJSON !== this.toJSON) n = e.toJSON(t1);
                else {
                    n = {
                        name: t1.name,
                        times: Wg(t1.times, Array),
                        values: Wg(t1.values, Array)
                    };
                    const e = t1.getInterpolation();
                    e !== t1.DefaultInterpolation && (n.interpolation = e);
                }
                return n.type = t1.ValueTypeName, n;
            }
            InterpolantFactoryMethodDiscrete(t1) {
                return new eA(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodLinear(t1) {
                return new tA(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodSmooth(t1) {
                return new $g(this.times, this.values, this.getValueSize(), t1);
            }
            setInterpolation(t1) {
                let e;
                switch(t1){
                    case Is:
                        e = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case Cs:
                        e = this.InterpolantFactoryMethodLinear;
                        break;
                    case Ns:
                        e = this.InterpolantFactoryMethodSmooth;
                }
                if (void 0 === e) {
                    const e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                    if (void 0 === this.createInterpolant) {
                        if (t1 === this.DefaultInterpolation) throw new Error(e);
                        this.setInterpolation(this.DefaultInterpolation);
                    }
                    return console.warn("THREE.KeyframeTrack:", e), this;
                }
                return this.createInterpolant = e, this;
            }
            getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return Is;
                    case this.InterpolantFactoryMethodLinear:
                        return Cs;
                    case this.InterpolantFactoryMethodSmooth:
                        return Ns;
                }
            }
            getValueSize() {
                return this.values.length / this.times.length;
            }
            shift(t1) {
                if (0 !== t1) {
                    const e = this.times;
                    for(let n = 0, i = e.length; n !== i; ++n)e[n] += t1;
                }
                return this;
            }
            scale(t1) {
                if (1 !== t1) {
                    const e = this.times;
                    for(let n = 0, i = e.length; n !== i; ++n)e[n] *= t1;
                }
                return this;
            }
            trim(t1, e) {
                const n = this.times, i = n.length;
                let r = 0, a = i - 1;
                for(; r !== i && n[r] < t1;)++r;
                for(; -1 !== a && n[a] > e;)--a;
                if (++a, 0 !== r || a !== i) {
                    r >= a && (a = Math.max(a, 1), r = a - 1);
                    const t1 = this.getValueSize();
                    this.times = n.slice(r, a), this.values = this.values.slice(r * t1, a * t1);
                }
                return this;
            }
            validate() {
                let t1 = !0;
                const e = this.getValueSize();
                e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t1 = !1);
                const n = this.times, i = this.values, r = n.length;
                0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t1 = !1);
                let a = null;
                for(let e = 0; e !== r; e++){
                    const i = n[e];
                    if ("number" == typeof i && isNaN(i)) {
                        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, e, i), t1 = !1;
                        break;
                    }
                    if (null !== a && a > i) {
                        console.error("THREE.KeyframeTrack: Out of order keys.", this, e, i, a), t1 = !1;
                        break;
                    }
                    a = i;
                }
                if (void 0 !== i && Xg(i)) for(let e = 0, n = i.length; e !== n; ++e){
                    const n = i[e];
                    if (isNaN(n)) {
                        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, e, n), t1 = !1;
                        break;
                    }
                }
                return t1;
            }
            optimize() {
                const t1 = this.times.slice(), e = this.values.slice(), n = this.getValueSize(), i = this.getInterpolation() === Ns, r = t1.length - 1;
                let a = 1;
                for(let s = 1; s < r; ++s){
                    let r = !1;
                    const o = t1[s];
                    if (o !== t1[s + 1] && (1 !== s || o !== t1[0])) {
                        if (i) r = !0;
                        else {
                            const t1 = s * n, i = t1 - n, a = t1 + n;
                            for(let s = 0; s !== n; ++s){
                                const n = e[t1 + s];
                                if (n !== e[i + s] || n !== e[a + s]) {
                                    r = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (r) {
                        if (s !== a) {
                            t1[a] = t1[s];
                            const i = s * n, r = a * n;
                            for(let t1 = 0; t1 !== n; ++t1)e[r + t1] = e[i + t1];
                        }
                        ++a;
                    }
                }
                if (r > 0) {
                    t1[a] = t1[r];
                    for(let t1 = r * n, i = a * n, s = 0; s !== n; ++s)e[i + s] = e[t1 + s];
                    ++a;
                }
                return a !== t1.length ? (this.times = t1.slice(0, a), this.values = e.slice(0, a * n)) : (this.times = t1, this.values = e), this;
            }
            clone() {
                const t1 = this.times.slice(), e = this.values.slice(), n = new this.constructor(this.name, t1, e);
                return n.createInterpolant = this.createInterpolant, n;
            }
        }
        nA.prototype.TimeBufferType = Float32Array, nA.prototype.ValueBufferType = Float32Array, nA.prototype.DefaultInterpolation = Cs;
        class iA extends nA {
        }
        iA.prototype.ValueTypeName = "bool", iA.prototype.ValueBufferType = Array, iA.prototype.DefaultInterpolation = Is, iA.prototype.InterpolantFactoryMethodLinear = void 0, iA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class rA extends nA {
        }
        rA.prototype.ValueTypeName = "color";
        class aA extends nA {
        }
        aA.prototype.ValueTypeName = "number";
        class sA extends Kg {
            constructor(t1, e, n, i){
                super(t1, e, n, i);
            }
            interpolate_(t1, e, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = (n - e) / (i - e);
                let l = t1 * s;
                for(let t1 = l + s; l !== t1; l += 4)Ll.slerpFlat(r, 0, a, l - s, a, l, o);
                return r;
            }
        }
        class oA extends nA {
            InterpolantFactoryMethodLinear(t1) {
                return new sA(this.times, this.values, this.getValueSize(), t1);
            }
        }
        oA.prototype.ValueTypeName = "quaternion", oA.prototype.DefaultInterpolation = Cs, oA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class lA extends nA {
        }
        lA.prototype.ValueTypeName = "string", lA.prototype.ValueBufferType = Array, lA.prototype.DefaultInterpolation = Is, lA.prototype.InterpolantFactoryMethodLinear = void 0, lA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class cA extends nA {
        }
        cA.prototype.ValueTypeName = "vector";
        class uA {
            constructor(t1, e = -1, n, i = Rs){
                this.name = t1, this.tracks = n, this.duration = e, this.blendMode = i, this.uuid = Qo(), this.duration < 0 && this.resetDuration();
            }
            static parse(t1) {
                const e = [], n = t1.tracks, i = 1 / (t1.fps || 1);
                for(let t1 = 0, r = n.length; t1 !== r; ++t1)e.push(hA(n[t1]).scale(i));
                const r = new this(t1.name, t1.duration, e, t1.blendMode);
                return r.uuid = t1.uuid, r;
            }
            static toJSON(t1) {
                const e = [], n = t1.tracks, i = {
                    name: t1.name,
                    duration: t1.duration,
                    tracks: e,
                    uuid: t1.uuid,
                    blendMode: t1.blendMode
                };
                for(let t1 = 0, i = n.length; t1 !== i; ++t1)e.push(nA.toJSON(n[t1]));
                return i;
            }
            static CreateFromMorphTargetSequence(t1, e, n, i) {
                const r = e.length, a = [];
                for(let t1 = 0; t1 < r; t1++){
                    let s = [], o = [];
                    s.push((t1 + r - 1) % r, t1, (t1 + 1) % r), o.push(0, 1, 0);
                    const l = Yg(s);
                    s = Zg(s, 1, l), o = Zg(o, 1, l), i || 0 !== s[0] || (s.push(r), o.push(o[0])), a.push(new aA(".morphTargetInfluences[" + e[t1].name + "]", s, o).scale(1 / n));
                }
                return new this(t1, -1, a);
            }
            static findByName(t1, e) {
                let n = t1;
                if (!Array.isArray(t1)) {
                    const e = t1;
                    n = e.geometry && e.geometry.animations || e.animations;
                }
                for(let t1 = 0; t1 < n.length; t1++)if (n[t1].name === e) return n[t1];
                return null;
            }
            static CreateClipsFromMorphTargetSequences(t1, e, n) {
                const i = {}, r = /^([\w-]*?)([\d]+)$/;
                for(let e = 0, n = t1.length; e < n; e++){
                    const n = t1[e], a = n.name.match(r);
                    if (a && a.length > 1) {
                        const t1 = a[1];
                        let e = i[t1];
                        e || (i[t1] = e = []), e.push(n);
                    }
                }
                const a = [];
                for(const t1 in i)a.push(this.CreateFromMorphTargetSequence(t1, i[t1], e, n));
                return a;
            }
            static parseAnimation(t1, e) {
                if (!t1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
                const n = function(t1, e, n, i, r) {
                    if (0 !== n.length) {
                        const a = [], s = [];
                        qg(n, a, s, i), 0 !== a.length && r.push(new t1(e, a, s));
                    }
                }, i = [], r = t1.name || "default", a = t1.fps || 30, s = t1.blendMode;
                let o = t1.length || -1;
                const l = t1.hierarchy || [];
                for(let t1 = 0; t1 < l.length; t1++){
                    const r = l[t1].keys;
                    if (r && 0 !== r.length) {
                        if (r[0].morphTargets) {
                            const t1 = {};
                            let e;
                            for(e = 0; e < r.length; e++)if (r[e].morphTargets) for(let n = 0; n < r[e].morphTargets.length; n++)t1[r[e].morphTargets[n]] = -1;
                            for(const n in t1){
                                const t1 = [], a = [];
                                for(let i = 0; i !== r[e].morphTargets.length; ++i){
                                    const i = r[e];
                                    t1.push(i.time), a.push(i.morphTarget === n ? 1 : 0);
                                }
                                i.push(new aA(".morphTargetInfluence[" + n + "]", t1, a));
                            }
                            o = t1.length * a;
                        } else {
                            const a = ".bones[" + e[t1].name + "]";
                            n(cA, a + ".position", r, "pos", i), n(oA, a + ".quaternion", r, "rot", i), n(cA, a + ".scale", r, "scl", i);
                        }
                    }
                }
                return 0 === i.length ? null : new this(r, o, i, s);
            }
            resetDuration() {
                let t1 = 0;
                for(let e = 0, n = this.tracks.length; e !== n; ++e){
                    const n = this.tracks[e];
                    t1 = Math.max(t1, n.times[n.times.length - 1]);
                }
                return this.duration = t1, this;
            }
            trim() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].trim(0, this.duration);
                return this;
            }
            validate() {
                let t1 = !0;
                for(let e = 0; e < this.tracks.length; e++)t1 = t1 && this.tracks[e].validate();
                return t1;
            }
            optimize() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].optimize();
                return this;
            }
            clone() {
                const t1 = [];
                for(let e = 0; e < this.tracks.length; e++)t1.push(this.tracks[e].clone());
                return new this.constructor(this.name, this.duration, t1, this.blendMode);
            }
            toJSON() {
                return this.constructor.toJSON(this);
            }
        }
        function hA(t1) {
            if (void 0 === t1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            const e = function(t1) {
                switch(t1.toLowerCase()){
                    case "scalar":
                    case "double":
                    case "float":
                    case "number":
                    case "integer":
                        return aA;
                    case "vector":
                    case "vector2":
                    case "vector3":
                    case "vector4":
                        return cA;
                    case "color":
                        return rA;
                    case "quaternion":
                        return oA;
                    case "bool":
                    case "boolean":
                        return iA;
                    case "string":
                        return lA;
                }
                throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t1);
            }(t1.type);
            if (void 0 === t1.times) {
                const e = [], n = [];
                qg(t1.keys, e, n, "value"), t1.times = e, t1.values = n;
            }
            return void 0 !== e.parse ? e.parse(t1) : new e(t1.name, t1.times, t1.values, t1.interpolation);
        }
        const dA = {
            enabled: !1,
            files: {},
            add: function(t1, e) {
                !1 !== this.enabled && (this.files[t1] = e);
            },
            get: function(t1) {
                if (!1 !== this.enabled) return this.files[t1];
            },
            remove: function(t1) {
                delete this.files[t1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class pA {
            constructor(t1, e, n){
                const i = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = n, this.itemStart = function(t1) {
                    o++, !1 === a && void 0 !== i.onStart && i.onStart(t1, s, o), a = !0;
                }, this.itemEnd = function(t1) {
                    s++, void 0 !== i.onProgress && i.onProgress(t1, s, o), s === o && (a = !1, void 0 !== i.onLoad && i.onLoad());
                }, this.itemError = function(t1) {
                    void 0 !== i.onError && i.onError(t1);
                }, this.resolveURL = function(t1) {
                    return r ? r(t1) : t1;
                }, this.setURLModifier = function(t1) {
                    return r = t1, this;
                }, this.addHandler = function(t1, e) {
                    return l.push(t1, e), this;
                }, this.removeHandler = function(t1) {
                    const e = l.indexOf(t1);
                    return -1 !== e && l.splice(e, 2), this;
                }, this.getHandler = function(t1) {
                    for(let e = 0, n = l.length; e < n; e += 2){
                        const n = l[e], i = l[e + 1];
                        if (n.global && (n.lastIndex = 0), n.test(t1)) return i;
                    }
                    return null;
                };
            }
        }
        const fA = new pA;
        class mA {
            constructor(t1){
                this.manager = void 0 !== t1 ? t1 : fA, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(t1, e) {
                const n = this;
                return new Promise(function(i, r) {
                    n.load(t1, i, e, r);
                });
            }
            parse() {}
            setCrossOrigin(t1) {
                return this.crossOrigin = t1, this;
            }
            setWithCredentials(t1) {
                return this.withCredentials = t1, this;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            setResourcePath(t1) {
                return this.resourcePath = t1, this;
            }
            setRequestHeader(t1) {
                return this.requestHeader = t1, this;
            }
        }
        mA.DEFAULT_MATERIAL_NAME = "__DEFAULT";
        const gA = {};
        class AA extends Error {
            constructor(t1, e){
                super(t1), this.response = e;
            }
        }
        class vA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = dA.get(t1);
                if (void 0 !== r) return this.manager.itemStart(t1), setTimeout(()=>{
                    e && e(r), this.manager.itemEnd(t1);
                }, 0), r;
                if (void 0 !== gA[t1]) return void gA[t1].push({
                    onLoad: e,
                    onProgress: n,
                    onError: i
                });
                gA[t1] = [], gA[t1].push({
                    onLoad: e,
                    onProgress: n,
                    onError: i
                });
                const a = new Request(t1, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? "include" : "same-origin"
                }), s = this.mimeType, o = this.responseType;
                fetch(a).then((e)=>{
                    if (200 === e.status || 0 === e.status) {
                        if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;
                        const n = gA[t1], i = e.body.getReader(), r = e.headers.get("Content-Length") || e.headers.get("X-File-Size"), a = r ? parseInt(r) : 0, s = 0 !== a;
                        let o = 0;
                        const l = new ReadableStream({
                            start (t1) {
                                !function e() {
                                    i.read().then(({ done: i, value: r })=>{
                                        if (i) t1.close();
                                        else {
                                            o += r.byteLength;
                                            const i = new ProgressEvent("progress", {
                                                lengthComputable: s,
                                                loaded: o,
                                                total: a
                                            });
                                            for(let t1 = 0, e = n.length; t1 < e; t1++){
                                                const e = n[t1];
                                                e.onProgress && e.onProgress(i);
                                            }
                                            t1.enqueue(r), e();
                                        }
                                    });
                                }();
                            }
                        });
                        return new Response(l);
                    }
                    throw new AA(`fetch for "${e.url}" responded with ${e.status}: ${e.statusText}`, e);
                }).then((t1)=>{
                    switch(o){
                        case "arraybuffer":
                            return t1.arrayBuffer();
                        case "blob":
                            return t1.blob();
                        case "document":
                            return t1.text().then((t1)=>(new DOMParser).parseFromString(t1, s));
                        case "json":
                            return t1.json();
                        default:
                            if (void 0 === s) return t1.text();
                            {
                                const e = /charset="?([^;"\s]*)"?/i.exec(s), n = e && e[1] ? e[1].toLowerCase() : void 0, i = new TextDecoder(n);
                                return t1.arrayBuffer().then((t1)=>i.decode(t1));
                            }
                    }
                }).then((e)=>{
                    dA.add(t1, e);
                    const n = gA[t1];
                    delete gA[t1];
                    for(let t1 = 0, i = n.length; t1 < i; t1++){
                        const i = n[t1];
                        i.onLoad && i.onLoad(e);
                    }
                }).catch((e)=>{
                    const n = gA[t1];
                    if (void 0 === n) throw this.manager.itemError(t1), e;
                    delete gA[t1];
                    for(let t1 = 0, i = n.length; t1 < i; t1++){
                        const i = n[t1];
                        i.onError && i.onError(e);
                    }
                    this.manager.itemError(t1);
                }).finally(()=>{
                    this.manager.itemEnd(t1);
                }), this.manager.itemStart(t1);
            }
            setResponseType(t1) {
                return this.responseType = t1, this;
            }
            setMimeType(t1) {
                return this.mimeType = t1, this;
            }
        }
        class yA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = new vA(this.manager);
                a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(n) {
                    try {
                        e(r.parse(JSON.parse(n)));
                    } catch (e) {
                        i ? i(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, n, i);
            }
            parse(t1) {
                const e = [];
                for(let n = 0; n < t1.length; n++){
                    const i = uA.parse(t1[n]);
                    e.push(i);
                }
                return e;
            }
        }
        class MA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = [], s = new um, o = new vA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
                let l = 0;
                function c(c) {
                    o.load(t1[c], function(t1) {
                        const n = r.parse(t1, !0);
                        a[c] = {
                            width: n.width,
                            height: n.height,
                            format: n.format,
                            mipmaps: n.mipmaps
                        }, l += 1, 6 === l && (1 === n.mipmapCount && (s.minFilter = Ma), s.image = a, s.format = n.format, s.needsUpdate = !0, e && e(s));
                    }, n, i);
                }
                if (Array.isArray(t1)) for(let e = 0, n = t1.length; e < n; ++e)c(e);
                else o.load(t1, function(t1) {
                    const n = r.parse(t1, !0);
                    if (n.isCubemap) {
                        const t1 = n.mipmaps.length / n.mipmapCount;
                        for(let e = 0; e < t1; e++){
                            a[e] = {
                                mipmaps: []
                            };
                            for(let t1 = 0; t1 < n.mipmapCount; t1++)a[e].mipmaps.push(n.mipmaps[e * n.mipmapCount + t1]), a[e].format = n.format, a[e].width = n.width, a[e].height = n.height;
                        }
                        s.image = a;
                    } else s.image.width = n.width, s.image.height = n.height, s.mipmaps = n.mipmaps;
                    1 === n.mipmapCount && (s.minFilter = Ma), s.format = n.format, s.needsUpdate = !0, e && e(s);
                }, n, i);
                return s;
            }
        }
        class bA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = dA.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = sl("img");
                function o() {
                    c(), dA.add(t1, this), e && e(this), r.manager.itemEnd(t1);
                }
                function l(e) {
                    c(), i && i(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), s.src = t1, s;
            }
        }
        class xA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = new ih;
                r.colorSpace = Ws;
                const a = new bA(this.manager);
                a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
                let s = 0;
                function o(n) {
                    a.load(t1[n], function(t1) {
                        r.images[n] = t1, s++, 6 === s && (r.needsUpdate = !0, e && e(r));
                    }, void 0, i);
                }
                for(let e = 0; e < t1.length; ++e)o(e);
                return r;
            }
        }
        class wA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = new Df, s = new vA(this.manager);
                return s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setPath(this.path), s.setWithCredentials(r.withCredentials), s.load(t1, function(t1) {
                    let n;
                    try {
                        n = r.parse(t1);
                    } catch (t1) {
                        if (void 0 === i) return void console.error(t1);
                        i(t1);
                    }
                    void 0 !== n.image ? a.image = n.image : void 0 !== n.data && (a.image.width = n.width, a.image.height = n.height, a.image.data = n.data), a.wrapS = void 0 !== n.wrapS ? n.wrapS : pa, a.wrapT = void 0 !== n.wrapT ? n.wrapT : pa, a.magFilter = void 0 !== n.magFilter ? n.magFilter : Ma, a.minFilter = void 0 !== n.minFilter ? n.minFilter : Ma, a.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.colorSpace ? a.colorSpace = n.colorSpace : void 0 !== n.encoding && (a.encoding = n.encoding), void 0 !== n.flipY && (a.flipY = n.flipY), void 0 !== n.format && (a.format = n.format), void 0 !== n.type && (a.type = n.type), void 0 !== n.mipmaps && (a.mipmaps = n.mipmaps, a.minFilter = wa), 1 === n.mipmapCount && (a.minFilter = Ma), void 0 !== n.generateMipmaps && (a.generateMipmaps = n.generateMipmaps), a.needsUpdate = !0, e && e(a, n);
                }, n, i), a;
            }
        }
        class _A extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = new wl, a = new bA(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(t1, function(t1) {
                    r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
                }, n, i), r;
            }
        }
        class EA extends Rc {
            constructor(t1, e = 1){
                super(), this.isLight = !0, this.type = "Light", this.color = new Jc(t1), this.intensity = e;
            }
            dispose() {}
            copy(t1, e) {
                return super.copy(t1, e), this.color.copy(t1.color), this.intensity = t1.intensity, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
            }
        }
        class SA extends EA {
            constructor(t1, e, n){
                super(t1, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Rc.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Jc(e);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.groundColor.copy(t1.groundColor), this;
            }
        }
        const TA = new cc, IA = new Ol, CA = new Ol;
        class NA {
            constructor(t1){
                this.camera = t1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new tl(512, 512), this.map = null, this.mapPass = null, this.matrix = new cc, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new hh, this._frameExtents = new tl(1, 1), this._viewportCount = 1, this._viewports = [
                    new _l(0, 0, 1, 1)
                ];
            }
            getViewportCount() {
                return this._viewportCount;
            }
            getFrustum() {
                return this._frustum;
            }
            updateMatrices(t1) {
                const e = this.camera, n = this.matrix;
                IA.setFromMatrixPosition(t1.matrixWorld), e.position.copy(IA), CA.setFromMatrixPosition(t1.target.matrixWorld), e.lookAt(CA), e.updateMatrixWorld(), TA.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(TA), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(TA);
            }
            getViewport(t1) {
                return this._viewports[t1];
            }
            getFrameExtents() {
                return this._frameExtents;
            }
            dispose() {
                this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
            }
            copy(t1) {
                return this.camera = t1.camera.clone(), this.bias = t1.bias, this.radius = t1.radius, this.mapSize.copy(t1.mapSize), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            toJSON() {
                const t1 = {};
                return 0 !== this.bias && (t1.bias = this.bias), 0 !== this.normalBias && (t1.normalBias = this.normalBias), 1 !== this.radius && (t1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t1.mapSize = this.mapSize.toArray()), t1.camera = this.camera.toJSON(!1).object, delete t1.camera.matrix, t1;
            }
        }
        class DA extends NA {
            constructor(){
                super(new th(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
            }
            updateMatrices(t1) {
                const e = this.camera, n = 2 * Vo * t1.angle * this.focus, i = this.mapSize.width / this.mapSize.height, r = t1.distance || e.far;
                n === e.fov && i === e.aspect && r === e.far || (e.fov = n, e.aspect = i, e.far = r, e.updateProjectionMatrix()), super.updateMatrices(t1);
            }
            copy(t1) {
                return super.copy(t1), this.focus = t1.focus, this;
            }
        }
        class LA extends EA {
            constructor(t1, e, n = 0, i = Math.PI / 3, r = 0, a = 2){
                super(t1, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Rc.DEFAULT_UP), this.updateMatrix(), this.target = new Rc, this.distance = n, this.angle = i, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new DA;
            }
            get power() {
                return this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / Math.PI;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.angle = t1.angle, this.penumbra = t1.penumbra, this.decay = t1.decay, this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        const OA = new cc, RA = new Ol, PA = new Ol;
        class zA extends NA {
            constructor(){
                super(new th(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new tl(4, 2), this._viewportCount = 6, this._viewports = [
                    new _l(2, 1, 1, 1),
                    new _l(0, 1, 1, 1),
                    new _l(3, 1, 1, 1),
                    new _l(1, 1, 1, 1),
                    new _l(3, 0, 1, 1),
                    new _l(1, 0, 1, 1)
                ], this._cubeDirections = [
                    new Ol(1, 0, 0),
                    new Ol(-1, 0, 0),
                    new Ol(0, 0, 1),
                    new Ol(0, 0, -1),
                    new Ol(0, 1, 0),
                    new Ol(0, -1, 0)
                ], this._cubeUps = [
                    new Ol(0, 1, 0),
                    new Ol(0, 1, 0),
                    new Ol(0, 1, 0),
                    new Ol(0, 1, 0),
                    new Ol(0, 0, 1),
                    new Ol(0, 0, -1)
                ];
            }
            updateMatrices(t1, e = 0) {
                const n = this.camera, i = this.matrix, r = t1.distance || n.far;
                r !== n.far && (n.far = r, n.updateProjectionMatrix()), RA.setFromMatrixPosition(t1.matrixWorld), n.position.copy(RA), PA.copy(n.position), PA.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt(PA), n.updateMatrixWorld(), i.makeTranslation(-RA.x, -RA.y, -RA.z), OA.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(OA);
            }
        }
        class UA extends EA {
            constructor(t1, e, n = 0, i = 2){
                super(t1, e), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new zA;
            }
            get power() {
                return 4 * this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (4 * Math.PI);
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.decay = t1.decay, this.shadow = t1.shadow.clone(), this;
            }
        }
        class kA extends NA {
            constructor(){
                super(new Eh(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
            }
        }
        class BA extends EA {
            constructor(t1, e){
                super(t1, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Rc.DEFAULT_UP), this.updateMatrix(), this.target = new Rc, this.shadow = new kA;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1) {
                return super.copy(t1), this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        class jA extends EA {
            constructor(t1, e){
                super(t1, e), this.isAmbientLight = !0, this.type = "AmbientLight";
            }
        }
        class FA extends EA {
            constructor(t1, e, n = 10, i = 10){
                super(t1, e), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = n, this.height = i;
            }
            get power() {
                return this.intensity * this.width * this.height * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (this.width * this.height * Math.PI);
            }
            copy(t1) {
                return super.copy(t1), this.width = t1.width, this.height = t1.height, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.width = this.width, e.object.height = this.height, e;
            }
        }
        class HA {
            constructor(){
                this.isSphericalHarmonics3 = !0, this.coefficients = [];
                for(let t1 = 0; t1 < 9; t1++)this.coefficients.push(new Ol);
            }
            set(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].copy(t1[e]);
                return this;
            }
            zero() {
                for(let t1 = 0; t1 < 9; t1++)this.coefficients[t1].set(0, 0, 0);
                return this;
            }
            getAt(t1, e) {
                const n = t1.x, i = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.282095), e.addScaledVector(a[1], .488603 * i), e.addScaledVector(a[2], .488603 * r), e.addScaledVector(a[3], .488603 * n), e.addScaledVector(a[4], n * i * 1.092548), e.addScaledVector(a[5], i * r * 1.092548), e.addScaledVector(a[6], .315392 * (3 * r * r - 1)), e.addScaledVector(a[7], n * r * 1.092548), e.addScaledVector(a[8], .546274 * (n * n - i * i)), e;
            }
            getIrradianceAt(t1, e) {
                const n = t1.x, i = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.886227), e.addScaledVector(a[1], 1.023328 * i), e.addScaledVector(a[2], 1.023328 * r), e.addScaledVector(a[3], 1.023328 * n), e.addScaledVector(a[4], .858086 * n * i), e.addScaledVector(a[5], .858086 * i * r), e.addScaledVector(a[6], .743125 * r * r - .247708), e.addScaledVector(a[7], .858086 * n * r), e.addScaledVector(a[8], .429043 * (n * n - i * i)), e;
            }
            add(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].add(t1.coefficients[e]);
                return this;
            }
            addScaledSH(t1, e) {
                for(let n = 0; n < 9; n++)this.coefficients[n].addScaledVector(t1.coefficients[n], e);
                return this;
            }
            scale(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].multiplyScalar(t1);
                return this;
            }
            lerp(t1, e) {
                for(let n = 0; n < 9; n++)this.coefficients[n].lerp(t1.coefficients[n], e);
                return this;
            }
            equals(t1) {
                for(let e = 0; e < 9; e++)if (!this.coefficients[e].equals(t1.coefficients[e])) return !1;
                return !0;
            }
            copy(t1) {
                return this.set(t1.coefficients);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            fromArray(t1, e = 0) {
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].fromArray(t1, e + 3 * i);
                return this;
            }
            toArray(t1 = [], e = 0) {
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].toArray(t1, e + 3 * i);
                return t1;
            }
            static getBasisAt(t1, e) {
                const n = t1.x, i = t1.y, r = t1.z;
                e[0] = .282095, e[1] = .488603 * i, e[2] = .488603 * r, e[3] = .488603 * n, e[4] = 1.092548 * n * i, e[5] = 1.092548 * i * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * n * r, e[8] = .546274 * (n * n - i * i);
            }
        }
        class VA extends EA {
            constructor(t1 = new HA, e = 1){
                super(void 0, e), this.isLightProbe = !0, this.sh = t1;
            }
            copy(t1) {
                return super.copy(t1), this.sh.copy(t1.sh), this;
            }
            fromJSON(t1) {
                return this.intensity = t1.intensity, this.sh.fromArray(t1.sh), this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.sh = this.sh.toArray(), e;
            }
        }
        class QA extends mA {
            constructor(t1){
                super(t1), this.textures = {};
            }
            load(t1, e, n, i) {
                const r = this, a = new vA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(n) {
                    try {
                        e(r.parse(JSON.parse(n)));
                    } catch (e) {
                        i ? i(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, n, i);
            }
            parse(t1) {
                const e = this.textures;
                function n(t1) {
                    return void 0 === e[t1] && console.warn("THREE.MaterialLoader: Undefined texture", t1), e[t1];
                }
                const i = QA.createMaterialFromType(t1.type);
                if (void 0 !== t1.uuid && (i.uuid = t1.uuid), void 0 !== t1.name && (i.name = t1.name), void 0 !== t1.color && void 0 !== i.color && i.color.setHex(t1.color), void 0 !== t1.roughness && (i.roughness = t1.roughness), void 0 !== t1.metalness && (i.metalness = t1.metalness), void 0 !== t1.sheen && (i.sheen = t1.sheen), void 0 !== t1.sheenColor && (i.sheenColor = (new Jc).setHex(t1.sheenColor)), void 0 !== t1.sheenRoughness && (i.sheenRoughness = t1.sheenRoughness), void 0 !== t1.emissive && void 0 !== i.emissive && i.emissive.setHex(t1.emissive), void 0 !== t1.specular && void 0 !== i.specular && i.specular.setHex(t1.specular), void 0 !== t1.specularIntensity && (i.specularIntensity = t1.specularIntensity), void 0 !== t1.specularColor && void 0 !== i.specularColor && i.specularColor.setHex(t1.specularColor), void 0 !== t1.shininess && (i.shininess = t1.shininess), void 0 !== t1.clearcoat && (i.clearcoat = t1.clearcoat), void 0 !== t1.clearcoatRoughness && (i.clearcoatRoughness = t1.clearcoatRoughness), void 0 !== t1.iridescence && (i.iridescence = t1.iridescence), void 0 !== t1.iridescenceIOR && (i.iridescenceIOR = t1.iridescenceIOR), void 0 !== t1.iridescenceThicknessRange && (i.iridescenceThicknessRange = t1.iridescenceThicknessRange), void 0 !== t1.transmission && (i.transmission = t1.transmission), void 0 !== t1.thickness && (i.thickness = t1.thickness), void 0 !== t1.attenuationDistance && (i.attenuationDistance = t1.attenuationDistance), void 0 !== t1.attenuationColor && void 0 !== i.attenuationColor && i.attenuationColor.setHex(t1.attenuationColor), void 0 !== t1.anisotropy && (i.anisotropy = t1.anisotropy), void 0 !== t1.anisotropyRotation && (i.anisotropyRotation = t1.anisotropyRotation), void 0 !== t1.fog && (i.fog = t1.fog), void 0 !== t1.flatShading && (i.flatShading = t1.flatShading), void 0 !== t1.blending && (i.blending = t1.blending), void 0 !== t1.combine && (i.combine = t1.combine), void 0 !== t1.side && (i.side = t1.side), void 0 !== t1.shadowSide && (i.shadowSide = t1.shadowSide), void 0 !== t1.opacity && (i.opacity = t1.opacity), void 0 !== t1.transparent && (i.transparent = t1.transparent), void 0 !== t1.alphaTest && (i.alphaTest = t1.alphaTest), void 0 !== t1.alphaHash && (i.alphaHash = t1.alphaHash), void 0 !== t1.depthFunc && (i.depthFunc = t1.depthFunc), void 0 !== t1.depthTest && (i.depthTest = t1.depthTest), void 0 !== t1.depthWrite && (i.depthWrite = t1.depthWrite), void 0 !== t1.colorWrite && (i.colorWrite = t1.colorWrite), void 0 !== t1.blendSrc && (i.blendSrc = t1.blendSrc), void 0 !== t1.blendDst && (i.blendDst = t1.blendDst), void 0 !== t1.blendEquation && (i.blendEquation = t1.blendEquation), void 0 !== t1.blendSrcAlpha && (i.blendSrcAlpha = t1.blendSrcAlpha), void 0 !== t1.blendDstAlpha && (i.blendDstAlpha = t1.blendDstAlpha), void 0 !== t1.blendEquationAlpha && (i.blendEquationAlpha = t1.blendEquationAlpha), void 0 !== t1.blendColor && void 0 !== i.blendColor && i.blendColor.setHex(t1.blendColor), void 0 !== t1.blendAlpha && (i.blendAlpha = t1.blendAlpha), void 0 !== t1.stencilWriteMask && (i.stencilWriteMask = t1.stencilWriteMask), void 0 !== t1.stencilFunc && (i.stencilFunc = t1.stencilFunc), void 0 !== t1.stencilRef && (i.stencilRef = t1.stencilRef), void 0 !== t1.stencilFuncMask && (i.stencilFuncMask = t1.stencilFuncMask), void 0 !== t1.stencilFail && (i.stencilFail = t1.stencilFail), void 0 !== t1.stencilZFail && (i.stencilZFail = t1.stencilZFail), void 0 !== t1.stencilZPass && (i.stencilZPass = t1.stencilZPass), void 0 !== t1.stencilWrite && (i.stencilWrite = t1.stencilWrite), void 0 !== t1.wireframe && (i.wireframe = t1.wireframe), void 0 !== t1.wireframeLinewidth && (i.wireframeLinewidth = t1.wireframeLinewidth), void 0 !== t1.wireframeLinecap && (i.wireframeLinecap = t1.wireframeLinecap), void 0 !== t1.wireframeLinejoin && (i.wireframeLinejoin = t1.wireframeLinejoin), void 0 !== t1.rotation && (i.rotation = t1.rotation), void 0 !== t1.linewidth && (i.linewidth = t1.linewidth), void 0 !== t1.dashSize && (i.dashSize = t1.dashSize), void 0 !== t1.gapSize && (i.gapSize = t1.gapSize), void 0 !== t1.scale && (i.scale = t1.scale), void 0 !== t1.polygonOffset && (i.polygonOffset = t1.polygonOffset), void 0 !== t1.polygonOffsetFactor && (i.polygonOffsetFactor = t1.polygonOffsetFactor), void 0 !== t1.polygonOffsetUnits && (i.polygonOffsetUnits = t1.polygonOffsetUnits), void 0 !== t1.dithering && (i.dithering = t1.dithering), void 0 !== t1.alphaToCoverage && (i.alphaToCoverage = t1.alphaToCoverage), void 0 !== t1.premultipliedAlpha && (i.premultipliedAlpha = t1.premultipliedAlpha), void 0 !== t1.forceSinglePass && (i.forceSinglePass = t1.forceSinglePass), void 0 !== t1.visible && (i.visible = t1.visible), void 0 !== t1.toneMapped && (i.toneMapped = t1.toneMapped), void 0 !== t1.userData && (i.userData = t1.userData), void 0 !== t1.vertexColors && ("number" == typeof t1.vertexColors ? i.vertexColors = t1.vertexColors > 0 : i.vertexColors = t1.vertexColors), void 0 !== t1.uniforms) for(const e in t1.uniforms){
                    const r = t1.uniforms[e];
                    switch(i.uniforms[e] = {}, r.type){
                        case "t":
                            i.uniforms[e].value = n(r.value);
                            break;
                        case "c":
                            i.uniforms[e].value = (new Jc).setHex(r.value);
                            break;
                        case "v2":
                            i.uniforms[e].value = (new tl).fromArray(r.value);
                            break;
                        case "v3":
                            i.uniforms[e].value = (new Ol).fromArray(r.value);
                            break;
                        case "v4":
                            i.uniforms[e].value = (new _l).fromArray(r.value);
                            break;
                        case "m3":
                            i.uniforms[e].value = (new el).fromArray(r.value);
                            break;
                        case "m4":
                            i.uniforms[e].value = (new cc).fromArray(r.value);
                            break;
                        default:
                            i.uniforms[e].value = r.value;
                    }
                }
                if (void 0 !== t1.defines && (i.defines = t1.defines), void 0 !== t1.vertexShader && (i.vertexShader = t1.vertexShader), void 0 !== t1.fragmentShader && (i.fragmentShader = t1.fragmentShader), void 0 !== t1.glslVersion && (i.glslVersion = t1.glslVersion), void 0 !== t1.extensions) for(const e in t1.extensions)i.extensions[e] = t1.extensions[e];
                if (void 0 !== t1.lights && (i.lights = t1.lights), void 0 !== t1.clipping && (i.clipping = t1.clipping), void 0 !== t1.size && (i.size = t1.size), void 0 !== t1.sizeAttenuation && (i.sizeAttenuation = t1.sizeAttenuation), void 0 !== t1.map && (i.map = n(t1.map)), void 0 !== t1.matcap && (i.matcap = n(t1.matcap)), void 0 !== t1.alphaMap && (i.alphaMap = n(t1.alphaMap)), void 0 !== t1.bumpMap && (i.bumpMap = n(t1.bumpMap)), void 0 !== t1.bumpScale && (i.bumpScale = t1.bumpScale), void 0 !== t1.normalMap && (i.normalMap = n(t1.normalMap)), void 0 !== t1.normalMapType && (i.normalMapType = t1.normalMapType), void 0 !== t1.normalScale) {
                    let e = t1.normalScale;
                    !1 === Array.isArray(e) && (e = [
                        e,
                        e
                    ]), i.normalScale = (new tl).fromArray(e);
                }
                return void 0 !== t1.displacementMap && (i.displacementMap = n(t1.displacementMap)), void 0 !== t1.displacementScale && (i.displacementScale = t1.displacementScale), void 0 !== t1.displacementBias && (i.displacementBias = t1.displacementBias), void 0 !== t1.roughnessMap && (i.roughnessMap = n(t1.roughnessMap)), void 0 !== t1.metalnessMap && (i.metalnessMap = n(t1.metalnessMap)), void 0 !== t1.emissiveMap && (i.emissiveMap = n(t1.emissiveMap)), void 0 !== t1.emissiveIntensity && (i.emissiveIntensity = t1.emissiveIntensity), void 0 !== t1.specularMap && (i.specularMap = n(t1.specularMap)), void 0 !== t1.specularIntensityMap && (i.specularIntensityMap = n(t1.specularIntensityMap)), void 0 !== t1.specularColorMap && (i.specularColorMap = n(t1.specularColorMap)), void 0 !== t1.envMap && (i.envMap = n(t1.envMap)), void 0 !== t1.envMapIntensity && (i.envMapIntensity = t1.envMapIntensity), void 0 !== t1.reflectivity && (i.reflectivity = t1.reflectivity), void 0 !== t1.refractionRatio && (i.refractionRatio = t1.refractionRatio), void 0 !== t1.lightMap && (i.lightMap = n(t1.lightMap)), void 0 !== t1.lightMapIntensity && (i.lightMapIntensity = t1.lightMapIntensity), void 0 !== t1.aoMap && (i.aoMap = n(t1.aoMap)), void 0 !== t1.aoMapIntensity && (i.aoMapIntensity = t1.aoMapIntensity), void 0 !== t1.gradientMap && (i.gradientMap = n(t1.gradientMap)), void 0 !== t1.clearcoatMap && (i.clearcoatMap = n(t1.clearcoatMap)), void 0 !== t1.clearcoatRoughnessMap && (i.clearcoatRoughnessMap = n(t1.clearcoatRoughnessMap)), void 0 !== t1.clearcoatNormalMap && (i.clearcoatNormalMap = n(t1.clearcoatNormalMap)), void 0 !== t1.clearcoatNormalScale && (i.clearcoatNormalScale = (new tl).fromArray(t1.clearcoatNormalScale)), void 0 !== t1.iridescenceMap && (i.iridescenceMap = n(t1.iridescenceMap)), void 0 !== t1.iridescenceThicknessMap && (i.iridescenceThicknessMap = n(t1.iridescenceThicknessMap)), void 0 !== t1.transmissionMap && (i.transmissionMap = n(t1.transmissionMap)), void 0 !== t1.thicknessMap && (i.thicknessMap = n(t1.thicknessMap)), void 0 !== t1.anisotropyMap && (i.anisotropyMap = n(t1.anisotropyMap)), void 0 !== t1.sheenColorMap && (i.sheenColorMap = n(t1.sheenColorMap)), void 0 !== t1.sheenRoughnessMap && (i.sheenRoughnessMap = n(t1.sheenRoughnessMap)), i;
            }
            setTextures(t1) {
                return this.textures = t1, this;
            }
            static createMaterialFromType(t1) {
                return new ({
                    ShadowMaterial: zg,
                    SpriteMaterial: tf,
                    RawShaderMaterial: Ug,
                    ShaderMaterial: Ku,
                    PointsMaterial: em,
                    MeshPhysicalMaterial: Bg,
                    MeshStandardMaterial: kg,
                    MeshPhongMaterial: jg,
                    MeshToonMaterial: Fg,
                    MeshNormalMaterial: Hg,
                    MeshLambertMaterial: Vg,
                    MeshDepthMaterial: Lp,
                    MeshDistanceMaterial: Op,
                    MeshBasicMaterial: eu,
                    MeshMatcapMaterial: Qg,
                    LineDashedMaterial: Gg,
                    LineBasicMaterial: Qf,
                    Material: tu
                })[t1];
            }
        }
        class GA {
            static decodeText(t1) {
                if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(t1);
                let e = "";
                for(let n = 0, i = t1.length; n < i; n++)e += String.fromCharCode(t1[n]);
                try {
                    return decodeURIComponent(escape(e));
                } catch (t1) {
                    return e;
                }
            }
            static extractUrlBase(t1) {
                const e = t1.lastIndexOf("/");
                return -1 === e ? "./" : t1.slice(0, e + 1);
            }
            static resolveURL(t1, e) {
                return "string" != typeof t1 || "" === t1 ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t1) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t1) || /^data:.*,.*$/i.test(t1) || /^blob:.*$/i.test(t1) ? t1 : e + t1);
            }
        }
        class WA extends Tu {
            constructor(){
                super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
            }
            copy(t1) {
                return super.copy(t1), this.instanceCount = t1.instanceCount, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.instanceCount = this.instanceCount, t1.isInstancedBufferGeometry = !0, t1;
            }
        }
        class XA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = new vA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(n) {
                    try {
                        e(r.parse(JSON.parse(n)));
                    } catch (e) {
                        i ? i(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, n, i);
            }
            parse(t1) {
                const e = {}, n = {};
                function i(t1, i) {
                    if (void 0 !== e[i]) return e[i];
                    const r = t1.interleavedBuffers[i], a = function(t1, e) {
                        if (void 0 !== n[e]) return n[e];
                        const i = t1.arrayBuffers[e], r = new Uint32Array(i).buffer;
                        return n[e] = r, r;
                    }(t1, r.buffer), s = al(r.type, a), o = new Jp(s, r.stride);
                    return o.uuid = r.uuid, e[i] = o, o;
                }
                const r = t1.isInstancedBufferGeometry ? new WA : new Tu, a = t1.data.index;
                if (void 0 !== a) {
                    const t1 = al(a.type, a.array);
                    r.setIndex(new cu(t1, 1));
                }
                const s = t1.data.attributes;
                for(const e in s){
                    const n = s[e];
                    let a;
                    if (n.isInterleavedBufferAttribute) {
                        const e = i(t1.data, n.data);
                        a = new $p(e, n.itemSize, n.offset, n.normalized);
                    } else {
                        const t1 = al(n.type, n.array);
                        a = new (n.isInstancedBufferAttribute ? Pf : cu)(t1, n.itemSize, n.normalized);
                    }
                    void 0 !== n.name && (a.name = n.name), void 0 !== n.usage && a.setUsage(n.usage), void 0 !== n.updateRange && (a.updateRange.offset = n.updateRange.offset, a.updateRange.count = n.updateRange.count), r.setAttribute(e, a);
                }
                const o = t1.data.morphAttributes;
                if (o) for(const e in o){
                    const n = o[e], a = [];
                    for(let e = 0, r = n.length; e < r; e++){
                        const r = n[e];
                        let s;
                        if (r.isInterleavedBufferAttribute) {
                            const e = i(t1.data, r.data);
                            s = new $p(e, r.itemSize, r.offset, r.normalized);
                        } else {
                            const t1 = al(r.type, r.array);
                            s = new cu(t1, r.itemSize, r.normalized);
                        }
                        void 0 !== r.name && (s.name = r.name), a.push(s);
                    }
                    r.morphAttributes[e] = a;
                }
                t1.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
                const l = t1.data.groups || t1.data.drawcalls || t1.data.offsets;
                if (void 0 !== l) for(let t1 = 0, e = l.length; t1 !== e; ++t1){
                    const e = l[t1];
                    r.addGroup(e.start, e.count, e.materialIndex);
                }
                const c = t1.data.boundingSphere;
                if (void 0 !== c) {
                    const t1 = new Ol;
                    void 0 !== c.center && t1.fromArray(c.center), r.boundingSphere = new tc(t1, c.radius);
                }
                return t1.name && (r.name = t1.name), t1.userData && (r.userData = t1.userData), r;
            }
        }
        class YA extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = "" === this.path ? GA.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || a;
                const s = new vA(this.manager);
                s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t1, function(n) {
                    let a = null;
                    try {
                        a = JSON.parse(n);
                    } catch (e) {
                        return void 0 !== i && i(e), void console.error("THREE:ObjectLoader: Can't parse " + t1 + ".", e.message);
                    }
                    const s = a.metadata;
                    if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) return void 0 !== i && i(new Error("THREE.ObjectLoader: Can't load " + t1)), void console.error("THREE.ObjectLoader: Can't load " + t1);
                    r.parse(a, e);
                }, n, i);
            }
            async loadAsync(t1, e) {
                const n = "" === this.path ? GA.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || n;
                const i = new vA(this.manager);
                i.setPath(this.path), i.setRequestHeader(this.requestHeader), i.setWithCredentials(this.withCredentials);
                const r = await i.loadAsync(t1, e), a = JSON.parse(r), s = a.metadata;
                if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + t1);
                return await this.parseAsync(a);
            }
            parse(t1, e) {
                const n = this.parseAnimations(t1.animations), i = this.parseShapes(t1.shapes), r = this.parseGeometries(t1.geometries, i), a = this.parseImages(t1.images, function() {
                    void 0 !== e && e(l);
                }), s = this.parseTextures(t1.textures, a), o = this.parseMaterials(t1.materials, s), l = this.parseObject(t1.object, r, o, s, n), c = this.parseSkeletons(t1.skeletons, l);
                if (this.bindSkeletons(l, c), void 0 !== e) {
                    let t1 = !1;
                    for(const e in a)if (a[e].data instanceof HTMLImageElement) {
                        t1 = !0;
                        break;
                    }
                    !1 === t1 && e(l);
                }
                return l;
            }
            async parseAsync(t1) {
                const e = this.parseAnimations(t1.animations), n = this.parseShapes(t1.shapes), i = this.parseGeometries(t1.geometries, n), r = await this.parseImagesAsync(t1.images), a = this.parseTextures(t1.textures, r), s = this.parseMaterials(t1.materials, a), o = this.parseObject(t1.object, i, s, a, e), l = this.parseSkeletons(t1.skeletons, o);
                return this.bindSkeletons(o, l), o;
            }
            parseShapes(t1) {
                const e = {};
                if (void 0 !== t1) for(let n = 0, i = t1.length; n < i; n++){
                    const i = (new Ym).fromJSON(t1[n]);
                    e[i.uuid] = i;
                }
                return e;
            }
            parseSkeletons(t1, e) {
                const n = {}, i = {};
                if (e.traverse(function(t1) {
                    t1.isBone && (i[t1.uuid] = t1);
                }), void 0 !== t1) for(let e = 0, r = t1.length; e < r; e++){
                    const r = (new Rf).fromJSON(t1[e], i);
                    n[r.uuid] = r;
                }
                return n;
            }
            parseGeometries(t1, e) {
                const n = {};
                if (void 0 !== t1) {
                    const i = new XA;
                    for(let r = 0, a = t1.length; r < a; r++){
                        let a;
                        const s = t1[r];
                        switch(s.type){
                            case "BufferGeometry":
                            case "InstancedBufferGeometry":
                                a = i.parse(s);
                                break;
                            default:
                                s.type in Pg ? a = Pg[s.type].fromJSON(s, e) : console.warn(`THREE.ObjectLoader: Unsupported geometry type "${s.type}"`);
                        }
                        a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.userData && (a.userData = s.userData), n[s.uuid] = a;
                    }
                }
                return n;
            }
            parseMaterials(t1, e) {
                const n = {}, i = {};
                if (void 0 !== t1) {
                    const r = new QA;
                    r.setTextures(e);
                    for(let e = 0, a = t1.length; e < a; e++){
                        const a = t1[e];
                        void 0 === n[a.uuid] && (n[a.uuid] = r.parse(a)), i[a.uuid] = n[a.uuid];
                    }
                }
                return i;
            }
            parseAnimations(t1) {
                const e = {};
                if (void 0 !== t1) for(let n = 0; n < t1.length; n++){
                    const i = t1[n], r = uA.parse(i);
                    e[r.uuid] = r;
                }
                return e;
            }
            parseImages(t1, e) {
                const n = this, i = {};
                let r;
                function a(t1) {
                    if ("string" == typeof t1) {
                        const e = t1;
                        return function(t1) {
                            return n.manager.itemStart(t1), r.load(t1, function() {
                                n.manager.itemEnd(t1);
                            }, void 0, function() {
                                n.manager.itemError(t1), n.manager.itemEnd(t1);
                            });
                        }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(e) ? e : n.resourcePath + e);
                    }
                    return t1.data ? {
                        data: al(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    const n = new pA(e);
                    r = new bA(n), r.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e], r = n.url;
                        if (Array.isArray(r)) {
                            const t1 = [];
                            for(let e = 0, n = r.length; e < n; e++){
                                const n = a(r[e]);
                                null !== n && (n instanceof HTMLImageElement ? t1.push(n) : t1.push(new Df(n.data, n.width, n.height)));
                            }
                            i[n.uuid] = new Ml(t1);
                        } else {
                            const t1 = a(n.url);
                            i[n.uuid] = new Ml(t1);
                        }
                    }
                }
                return i;
            }
            async parseImagesAsync(t1) {
                const e = this, n = {};
                let i;
                async function r(t1) {
                    if ("string" == typeof t1) {
                        const n = t1, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(n) ? n : e.resourcePath + n;
                        return await i.loadAsync(r);
                    }
                    return t1.data ? {
                        data: al(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    i = new bA(this.manager), i.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e], a = i.url;
                        if (Array.isArray(a)) {
                            const t1 = [];
                            for(let e = 0, n = a.length; e < n; e++){
                                const n = a[e], i = await r(n);
                                null !== i && (i instanceof HTMLImageElement ? t1.push(i) : t1.push(new Df(i.data, i.width, i.height)));
                            }
                            n[i.uuid] = new Ml(t1);
                        } else {
                            const t1 = await r(i.url);
                            n[i.uuid] = new Ml(t1);
                        }
                    }
                }
                return n;
            }
            parseTextures(t1, e) {
                function n(t1, e) {
                    return "number" == typeof t1 ? t1 : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", t1), e[t1]);
                }
                const i = {};
                if (void 0 !== t1) for(let r = 0, a = t1.length; r < a; r++){
                    const a = t1[r];
                    void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid), void 0 === e[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
                    const s = e[a.image], o = s.data;
                    let l;
                    Array.isArray(o) ? (l = new ih, 6 === o.length && (l.needsUpdate = !0)) : (l = o && o.data ? new Df : new wl, o && (l.needsUpdate = !0)), l.source = s, l.uuid = a.uuid, void 0 !== a.name && (l.name = a.name), void 0 !== a.mapping && (l.mapping = n(a.mapping, ZA)), void 0 !== a.channel && (l.channel = a.channel), void 0 !== a.offset && l.offset.fromArray(a.offset), void 0 !== a.repeat && l.repeat.fromArray(a.repeat), void 0 !== a.center && l.center.fromArray(a.center), void 0 !== a.rotation && (l.rotation = a.rotation), void 0 !== a.wrap && (l.wrapS = n(a.wrap[0], qA), l.wrapT = n(a.wrap[1], qA)), void 0 !== a.format && (l.format = a.format), void 0 !== a.internalFormat && (l.internalFormat = a.internalFormat), void 0 !== a.type && (l.type = a.type), void 0 !== a.colorSpace && (l.colorSpace = a.colorSpace), void 0 !== a.encoding && (l.encoding = a.encoding), void 0 !== a.minFilter && (l.minFilter = n(a.minFilter, JA)), void 0 !== a.magFilter && (l.magFilter = n(a.magFilter, JA)), void 0 !== a.anisotropy && (l.anisotropy = a.anisotropy), void 0 !== a.flipY && (l.flipY = a.flipY), void 0 !== a.generateMipmaps && (l.generateMipmaps = a.generateMipmaps), void 0 !== a.premultiplyAlpha && (l.premultiplyAlpha = a.premultiplyAlpha), void 0 !== a.unpackAlignment && (l.unpackAlignment = a.unpackAlignment), void 0 !== a.compareFunction && (l.compareFunction = a.compareFunction), void 0 !== a.userData && (l.userData = a.userData), i[a.uuid] = l;
                }
                return i;
            }
            parseObject(t1, e, n, i, r) {
                let a, s, o;
                function l(t1) {
                    return void 0 === e[t1] && console.warn("THREE.ObjectLoader: Undefined geometry", t1), e[t1];
                }
                function c(t1) {
                    if (void 0 !== t1) {
                        if (Array.isArray(t1)) {
                            const e = [];
                            for(let i = 0, r = t1.length; i < r; i++){
                                const r = t1[i];
                                void 0 === n[r] && console.warn("THREE.ObjectLoader: Undefined material", r), e.push(n[r]);
                            }
                            return e;
                        }
                        return void 0 === n[t1] && console.warn("THREE.ObjectLoader: Undefined material", t1), n[t1];
                    }
                }
                function u(t1) {
                    return void 0 === i[t1] && console.warn("THREE.ObjectLoader: Undefined texture", t1), i[t1];
                }
                switch(t1.type){
                    case "Scene":
                        a = new qp, void 0 !== t1.background && (Number.isInteger(t1.background) ? a.background = new Jc(t1.background) : a.background = u(t1.background)), void 0 !== t1.environment && (a.environment = u(t1.environment)), void 0 !== t1.fog && ("Fog" === t1.fog.type ? a.fog = new Zp(t1.fog.color, t1.fog.near, t1.fog.far) : "FogExp2" === t1.fog.type && (a.fog = new Yp(t1.fog.color, t1.fog.density)), "" !== t1.fog.name && (a.fog.name = t1.fog.name)), void 0 !== t1.backgroundBlurriness && (a.backgroundBlurriness = t1.backgroundBlurriness), void 0 !== t1.backgroundIntensity && (a.backgroundIntensity = t1.backgroundIntensity);
                        break;
                    case "PerspectiveCamera":
                        a = new th(t1.fov, t1.aspect, t1.near, t1.far), void 0 !== t1.focus && (a.focus = t1.focus), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.filmGauge && (a.filmGauge = t1.filmGauge), void 0 !== t1.filmOffset && (a.filmOffset = t1.filmOffset), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "OrthographicCamera":
                        a = new Eh(t1.left, t1.right, t1.top, t1.bottom, t1.near, t1.far), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "AmbientLight":
                        a = new jA(t1.color, t1.intensity);
                        break;
                    case "DirectionalLight":
                        a = new BA(t1.color, t1.intensity);
                        break;
                    case "PointLight":
                        a = new UA(t1.color, t1.intensity, t1.distance, t1.decay);
                        break;
                    case "RectAreaLight":
                        a = new FA(t1.color, t1.intensity, t1.width, t1.height);
                        break;
                    case "SpotLight":
                        a = new LA(t1.color, t1.intensity, t1.distance, t1.angle, t1.penumbra, t1.decay);
                        break;
                    case "HemisphereLight":
                        a = new SA(t1.color, t1.groundColor, t1.intensity);
                        break;
                    case "LightProbe":
                        a = (new VA).fromJSON(t1);
                        break;
                    case "SkinnedMesh":
                        s = l(t1.geometry), o = c(t1.material), a = new Cf(s, o), void 0 !== t1.bindMode && (a.bindMode = t1.bindMode), void 0 !== t1.bindMatrix && a.bindMatrix.fromArray(t1.bindMatrix), void 0 !== t1.skeleton && (a.skeleton = t1.skeleton);
                        break;
                    case "Mesh":
                        s = l(t1.geometry), o = c(t1.material), a = new Gu(s, o);
                        break;
                    case "InstancedMesh":
                        s = l(t1.geometry), o = c(t1.material);
                        const e1 = t1.count, n1 = t1.instanceMatrix, i1 = t1.instanceColor;
                        a = new Vf(s, o, e1), a.instanceMatrix = new Pf(new Float32Array(n1.array), 16), void 0 !== i1 && (a.instanceColor = new Pf(new Float32Array(i1.array), i1.itemSize));
                        break;
                    case "LOD":
                        a = new yf;
                        break;
                    case "Line":
                        a = new qf(l(t1.geometry), c(t1.material));
                        break;
                    case "LineLoop":
                        a = new tm(l(t1.geometry), c(t1.material));
                        break;
                    case "LineSegments":
                        a = new $f(l(t1.geometry), c(t1.material));
                        break;
                    case "PointCloud":
                    case "Points":
                        a = new sm(l(t1.geometry), c(t1.material));
                        break;
                    case "Sprite":
                        a = new mf(c(t1.material));
                        break;
                    case "Group":
                        a = new Bp;
                        break;
                    case "Bone":
                        a = new Nf;
                        break;
                    default:
                        a = new Rc;
                }
                if (a.uuid = t1.uuid, void 0 !== t1.name && (a.name = t1.name), void 0 !== t1.matrix ? (a.matrix.fromArray(t1.matrix), void 0 !== t1.matrixAutoUpdate && (a.matrixAutoUpdate = t1.matrixAutoUpdate), a.matrixAutoUpdate && a.matrix.decompose(a.position, a.quaternion, a.scale)) : (void 0 !== t1.position && a.position.fromArray(t1.position), void 0 !== t1.rotation && a.rotation.fromArray(t1.rotation), void 0 !== t1.quaternion && a.quaternion.fromArray(t1.quaternion), void 0 !== t1.scale && a.scale.fromArray(t1.scale)), void 0 !== t1.up && a.up.fromArray(t1.up), void 0 !== t1.castShadow && (a.castShadow = t1.castShadow), void 0 !== t1.receiveShadow && (a.receiveShadow = t1.receiveShadow), t1.shadow && (void 0 !== t1.shadow.bias && (a.shadow.bias = t1.shadow.bias), void 0 !== t1.shadow.normalBias && (a.shadow.normalBias = t1.shadow.normalBias), void 0 !== t1.shadow.radius && (a.shadow.radius = t1.shadow.radius), void 0 !== t1.shadow.mapSize && a.shadow.mapSize.fromArray(t1.shadow.mapSize), void 0 !== t1.shadow.camera && (a.shadow.camera = this.parseObject(t1.shadow.camera))), void 0 !== t1.visible && (a.visible = t1.visible), void 0 !== t1.frustumCulled && (a.frustumCulled = t1.frustumCulled), void 0 !== t1.renderOrder && (a.renderOrder = t1.renderOrder), void 0 !== t1.userData && (a.userData = t1.userData), void 0 !== t1.layers && (a.layers.mask = t1.layers), void 0 !== t1.children) {
                    const s = t1.children;
                    for(let t1 = 0; t1 < s.length; t1++)a.add(this.parseObject(s[t1], e, n, i, r));
                }
                if (void 0 !== t1.animations) {
                    const e = t1.animations;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const n = e[t1];
                        a.animations.push(r[n]);
                    }
                }
                if ("LOD" === t1.type) {
                    void 0 !== t1.autoUpdate && (a.autoUpdate = t1.autoUpdate);
                    const e = t1.levels;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const n = e[t1], i = a.getObjectByProperty("uuid", n.object);
                        void 0 !== i && a.addLevel(i, n.distance, n.hysteresis);
                    }
                }
                return a;
            }
            bindSkeletons(t1, e) {
                0 !== Object.keys(e).length && t1.traverse(function(t1) {
                    if (!0 === t1.isSkinnedMesh && void 0 !== t1.skeleton) {
                        const n = e[t1.skeleton];
                        void 0 === n ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", t1.skeleton) : t1.bind(n, t1.bindMatrix);
                    }
                });
            }
        }
        const ZA = {
            UVMapping: sa,
            CubeReflectionMapping: oa,
            CubeRefractionMapping: la,
            EquirectangularReflectionMapping: ca,
            EquirectangularRefractionMapping: ua,
            CubeUVReflectionMapping: ha
        }, qA = {
            RepeatWrapping: da,
            ClampToEdgeWrapping: pa,
            MirroredRepeatWrapping: fa
        }, JA = {
            NearestFilter: ma,
            NearestMipmapNearestFilter: ga,
            NearestMipmapLinearFilter: va,
            LinearFilter: Ma,
            LinearMipmapNearestFilter: ba,
            LinearMipmapLinearFilter: wa
        };
        class KA extends mA {
            constructor(t1){
                super(t1), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
                    premultiplyAlpha: "none"
                };
            }
            setOptions(t1) {
                return this.options = t1, this;
            }
            load(t1, e, n, i) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = dA.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = {};
                s.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", s.headers = this.requestHeader, fetch(t1, s).then(function(t1) {
                    return t1.blob();
                }).then(function(t1) {
                    return createImageBitmap(t1, Object.assign(r.options, {
                        colorSpaceConversion: "none"
                    }));
                }).then(function(n) {
                    dA.add(t1, n), e && e(n), r.manager.itemEnd(t1);
                }).catch(function(e) {
                    i && i(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }), r.manager.itemStart(t1);
            }
        }
        let $A;
        class tv {
            static getContext() {
                return void 0 === $A && ($A = new (window.AudioContext || window.webkitAudioContext)), $A;
            }
            static setContext(t1) {
                $A = t1;
            }
        }
        class ev extends mA {
            constructor(t1){
                super(t1);
            }
            load(t1, e, n, i) {
                const r = this, a = new vA(this.manager);
                function s(e) {
                    i ? i(e) : console.error(e), r.manager.itemError(t1);
                }
                a.setResponseType("arraybuffer"), a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(t1) {
                    try {
                        const n = t1.slice(0);
                        tv.getContext().decodeAudioData(n, function(t1) {
                            e(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, n, i);
            }
        }
        const nv = new cc, iv = new cc, rv = new cc;
        class av {
            constructor(){
                this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new th, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new th, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
                    focus: null,
                    fov: null,
                    aspect: null,
                    near: null,
                    far: null,
                    zoom: null,
                    eyeSep: null
                };
            }
            update(t1) {
                const e = this._cache;
                if (e.focus !== t1.focus || e.fov !== t1.fov || e.aspect !== t1.aspect * this.aspect || e.near !== t1.near || e.far !== t1.far || e.zoom !== t1.zoom || e.eyeSep !== this.eyeSep) {
                    e.focus = t1.focus, e.fov = t1.fov, e.aspect = t1.aspect * this.aspect, e.near = t1.near, e.far = t1.far, e.zoom = t1.zoom, e.eyeSep = this.eyeSep, rv.copy(t1.projectionMatrix);
                    const n = e.eyeSep / 2, i = n * e.near / e.focus, r = e.near * Math.tan(Ho * e.fov * .5) / e.zoom;
                    let a, s;
                    iv.elements[12] = -n, nv.elements[12] = n, a = -r * e.aspect + i, s = r * e.aspect + i, rv.elements[0] = 2 * e.near / (s - a), rv.elements[8] = (s + a) / (s - a), this.cameraL.projectionMatrix.copy(rv), a = -r * e.aspect - i, s = r * e.aspect - i, rv.elements[0] = 2 * e.near / (s - a), rv.elements[8] = (s + a) / (s - a), this.cameraR.projectionMatrix.copy(rv);
                }
                this.cameraL.matrixWorld.copy(t1.matrixWorld).multiply(iv), this.cameraR.matrixWorld.copy(t1.matrixWorld).multiply(nv);
            }
        }
        class sv {
            constructor(t1 = !0){
                this.autoStart = t1, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
            }
            start() {
                this.startTime = ov(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            }
            stop() {
                this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            }
            getElapsedTime() {
                return this.getDelta(), this.elapsedTime;
            }
            getDelta() {
                let t1 = 0;
                if (this.autoStart && !this.running) return this.start(), 0;
                if (this.running) {
                    const e = ov();
                    t1 = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t1;
                }
                return t1;
            }
        }
        function ov() {
            return ("undefined" == typeof performance ? Date : performance).now();
        }
        const lv = new Ol, cv = new Ll, uv = new Ol, hv = new Ol;
        class dv extends Rc {
            constructor(){
                super(), this.type = "AudioListener", this.context = tv.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new sv;
            }
            getInput() {
                return this.gain;
            }
            removeFilter() {
                return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            }
            getFilter() {
                return this.filter;
            }
            setFilter(t1) {
                return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = t1, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            }
            getMasterVolume() {
                return this.gain.gain.value;
            }
            setMasterVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1);
                const e = this.context.listener, n = this.up;
                if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(lv, cv, uv), hv.set(0, 0, -1).applyQuaternion(cv), e.positionX) {
                    const t1 = this.context.currentTime + this.timeDelta;
                    e.positionX.linearRampToValueAtTime(lv.x, t1), e.positionY.linearRampToValueAtTime(lv.y, t1), e.positionZ.linearRampToValueAtTime(lv.z, t1), e.forwardX.linearRampToValueAtTime(hv.x, t1), e.forwardY.linearRampToValueAtTime(hv.y, t1), e.forwardZ.linearRampToValueAtTime(hv.z, t1), e.upX.linearRampToValueAtTime(n.x, t1), e.upY.linearRampToValueAtTime(n.y, t1), e.upZ.linearRampToValueAtTime(n.z, t1);
                } else e.setPosition(lv.x, lv.y, lv.z), e.setOrientation(hv.x, hv.y, hv.z, n.x, n.y, n.z);
            }
        }
        class pv extends Rc {
            constructor(t1){
                super(), this.type = "Audio", this.listener = t1, this.context = t1.context, this.gain = this.context.createGain(), this.gain.connect(t1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
            }
            getOutput() {
                return this.gain;
            }
            setNodeSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t1, this.connect(), this;
            }
            setMediaElementSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t1), this.connect(), this;
            }
            setMediaStreamSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t1), this.connect(), this;
            }
            setBuffer(t1) {
                return this.buffer = t1, this.sourceType = "buffer", this.autoplay && this.play(), this;
            }
            play(t1 = 0) {
                if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
                if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
                this._startedAt = this.context.currentTime + t1;
                const e = this.context.createBufferSource();
                return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
            }
            pause() {
                if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            stop() {
                if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(), this.source.onended = null), this.isPlaying = !1, this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].connect(this.filters[t1]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                return this._connected = !0, this;
            }
            disconnect() {
                if (!1 !== this._connected) {
                    if (this.filters.length > 0) {
                        this.source.disconnect(this.filters[0]);
                        for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].disconnect(this.filters[t1]);
                        this.filters[this.filters.length - 1].disconnect(this.getOutput());
                    } else this.source.disconnect(this.getOutput());
                    return this._connected = !1, this;
                }
            }
            getFilters() {
                return this.filters;
            }
            setFilters(t1) {
                return t1 || (t1 = []), !0 === this._connected ? (this.disconnect(), this.filters = t1.slice(), this.connect()) : this.filters = t1.slice(), this;
            }
            setDetune(t1) {
                if (this.detune = t1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
            }
            getDetune() {
                return this.detune;
            }
            getFilter() {
                return this.getFilters()[0];
            }
            setFilter(t1) {
                return this.setFilters(t1 ? [
                    t1
                ] : []);
            }
            setPlaybackRate(t1) {
                if (!1 !== this.hasPlaybackControl) return this.playbackRate = t1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            getPlaybackRate() {
                return this.playbackRate;
            }
            onEnded() {
                this.isPlaying = !1;
            }
            getLoop() {
                return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            }
            setLoop(t1) {
                if (!1 !== this.hasPlaybackControl) return this.loop = t1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            setLoopStart(t1) {
                return this.loopStart = t1, this;
            }
            setLoopEnd(t1) {
                return this.loopEnd = t1, this;
            }
            getVolume() {
                return this.gain.gain.value;
            }
            setVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
        }
        const fv = new Ol, mv = new Ll, gv = new Ol, Av = new Ol;
        class vv extends pv {
            constructor(t1){
                super(t1), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
            }
            connect() {
                super.connect(), this.panner.connect(this.gain);
            }
            disconnect() {
                super.disconnect(), this.panner.disconnect(this.gain);
            }
            getOutput() {
                return this.panner;
            }
            getRefDistance() {
                return this.panner.refDistance;
            }
            setRefDistance(t1) {
                return this.panner.refDistance = t1, this;
            }
            getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
            setRolloffFactor(t1) {
                return this.panner.rolloffFactor = t1, this;
            }
            getDistanceModel() {
                return this.panner.distanceModel;
            }
            setDistanceModel(t1) {
                return this.panner.distanceModel = t1, this;
            }
            getMaxDistance() {
                return this.panner.maxDistance;
            }
            setMaxDistance(t1) {
                return this.panner.maxDistance = t1, this;
            }
            setDirectionalCone(t1, e, n) {
                return this.panner.coneInnerAngle = t1, this.panner.coneOuterAngle = e, this.panner.coneOuterGain = n, this;
            }
            updateMatrixWorld(t1) {
                if (super.updateMatrixWorld(t1), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
                this.matrixWorld.decompose(fv, mv, gv), Av.set(0, 0, 1).applyQuaternion(mv);
                const e = this.panner;
                if (e.positionX) {
                    const t1 = this.context.currentTime + this.listener.timeDelta;
                    e.positionX.linearRampToValueAtTime(fv.x, t1), e.positionY.linearRampToValueAtTime(fv.y, t1), e.positionZ.linearRampToValueAtTime(fv.z, t1), e.orientationX.linearRampToValueAtTime(Av.x, t1), e.orientationY.linearRampToValueAtTime(Av.y, t1), e.orientationZ.linearRampToValueAtTime(Av.z, t1);
                } else e.setPosition(fv.x, fv.y, fv.z), e.setOrientation(Av.x, Av.y, Av.z);
            }
        }
        class yv {
            constructor(t1, e = 2048){
                this.analyser = t1.context.createAnalyser(), this.analyser.fftSize = e, this.data = new Uint8Array(this.analyser.frequencyBinCount), t1.getOutput().connect(this.analyser);
            }
            getFrequencyData() {
                return this.analyser.getByteFrequencyData(this.data), this.data;
            }
            getAverageFrequency() {
                let t1 = 0;
                const e = this.getFrequencyData();
                for(let n = 0; n < e.length; n++)t1 += e[n];
                return t1 / e.length;
            }
        }
        class Mv {
            constructor(t1, e, n){
                let i, r, a;
                switch(this.binding = t1, this.valueSize = n, e){
                    case "quaternion":
                        i = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
                        break;
                    case "string":
                    case "bool":
                        i = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
                        break;
                    default:
                        i = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
                }
                this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
            }
            accumulate(t1, e) {
                const n = this.buffer, i = this.valueSize, r = t1 * i + i;
                let a = this.cumulativeWeight;
                if (0 === a) {
                    for(let t1 = 0; t1 !== i; ++t1)n[r + t1] = n[t1];
                    a = e;
                } else {
                    a += e;
                    const t1 = e / a;
                    this._mixBufferRegion(n, r, 0, t1, i);
                }
                this.cumulativeWeight = a;
            }
            accumulateAdditive(t1) {
                const e = this.buffer, n = this.valueSize, i = n * this._addIndex;
                0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t1, n), this.cumulativeWeightAdditive += t1;
            }
            apply(t1) {
                const e = this.valueSize, n = this.buffer, i = t1 * e + e, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, s = this.binding;
                if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
                    const t1 = e * this._origIndex;
                    this._mixBufferRegion(n, i, t1, 1 - r, e);
                }
                a > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * e, 1, e);
                for(let t1 = e, r = e + e; t1 !== r; ++t1)if (n[t1] !== n[t1 + e]) {
                    s.setValue(n, i);
                    break;
                }
            }
            saveOriginalState() {
                const t1 = this.binding, e = this.buffer, n = this.valueSize, i = n * this._origIndex;
                t1.getValue(e, i);
                for(let t1 = n, r = i; t1 !== r; ++t1)e[t1] = e[i + t1 % n];
                this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
            }
            restoreOriginalState() {
                const t1 = 3 * this.valueSize;
                this.binding.setValue(this.buffer, t1);
            }
            _setAdditiveIdentityNumeric() {
                const t1 = this._addIndex * this.valueSize, e = t1 + this.valueSize;
                for(let n = t1; n < e; n++)this.buffer[n] = 0;
            }
            _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
            _setAdditiveIdentityOther() {
                const t1 = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
                for(let n = 0; n < this.valueSize; n++)this.buffer[e + n] = this.buffer[t1 + n];
            }
            _select(t1, e, n, i, r) {
                if (i >= .5) for(let i = 0; i !== r; ++i)t1[e + i] = t1[n + i];
            }
            _slerp(t1, e, n, i) {
                Ll.slerpFlat(t1, e, t1, e, t1, n, i);
            }
            _slerpAdditive(t1, e, n, i, r) {
                const a = this._workIndex * r;
                Ll.multiplyQuaternionsFlat(t1, a, t1, e, t1, n), Ll.slerpFlat(t1, e, t1, e, t1, a, i);
            }
            _lerp(t1, e, n, i, r) {
                const a = 1 - i;
                for(let s = 0; s !== r; ++s){
                    const r = e + s;
                    t1[r] = t1[r] * a + t1[n + s] * i;
                }
            }
            _lerpAdditive(t1, e, n, i, r) {
                for(let a = 0; a !== r; ++a){
                    const r = e + a;
                    t1[r] = t1[r] + t1[n + a] * i;
                }
            }
        }
        const bv = "\\[\\]\\.:\\/", xv = new RegExp("[" + bv + "]", "g"), wv = "[^" + bv + "]", _v = "[^" + bv.replace("\\.", "") + "]", Ev = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", wv) + /(WCOD+)?/.source.replace("WCOD", _v) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", wv) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", wv) + "$"), Sv = [
            "material",
            "materials",
            "bones",
            "map"
        ];
        class Tv {
            constructor(t1, e, n){
                this.path = e, this.parsedPath = n || Tv.parseTrackName(e), this.node = Tv.findNode(t1, this.parsedPath.nodeName), this.rootNode = t1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
            static create(t1, e, n) {
                return t1 && t1.isAnimationObjectGroup ? new Tv.Composite(t1, e, n) : new Tv(t1, e, n);
            }
            static sanitizeNodeName(t1) {
                return t1.replace(/\s/g, "_").replace(xv, "");
            }
            static parseTrackName(t1) {
                const e = Ev.exec(t1);
                if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t1);
                const n = {
                    nodeName: e[2],
                    objectName: e[3],
                    objectIndex: e[4],
                    propertyName: e[5],
                    propertyIndex: e[6]
                }, i = n.nodeName && n.nodeName.lastIndexOf(".");
                if (void 0 !== i && -1 !== i) {
                    const t1 = n.nodeName.substring(i + 1);
                    -1 !== Sv.indexOf(t1) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = t1);
                }
                if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t1);
                return n;
            }
            static findNode(t1, e) {
                if (void 0 === e || "" === e || "." === e || -1 === e || e === t1.name || e === t1.uuid) return t1;
                if (t1.skeleton) {
                    const n = t1.skeleton.getBoneByName(e);
                    if (void 0 !== n) return n;
                }
                if (t1.children) {
                    const n = function(t1) {
                        for(let i = 0; i < t1.length; i++){
                            const r = t1[i];
                            if (r.name === e || r.uuid === e) return r;
                            const a = n(r.children);
                            if (a) return a;
                        }
                        return null;
                    }, i = n(t1.children);
                    if (i) return i;
                }
                return null;
            }
            _getValue_unavailable() {}
            _setValue_unavailable() {}
            _getValue_direct(t1, e) {
                t1[e] = this.targetObject[this.propertyName];
            }
            _getValue_array(t1, e) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)t1[e++] = n[i];
            }
            _getValue_arrayElement(t1, e) {
                t1[e] = this.resolvedProperty[this.propertyIndex];
            }
            _getValue_toArray(t1, e) {
                this.resolvedProperty.toArray(t1, e);
            }
            _setValue_direct(t1, e) {
                this.targetObject[this.propertyName] = t1[e];
            }
            _setValue_direct_setNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_direct_setMatrixWorldNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_array(t1, e) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
            }
            _setValue_array_setNeedsUpdate(t1, e) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
                this.targetObject.needsUpdate = !0;
            }
            _setValue_array_setMatrixWorldNeedsUpdate(t1, e) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
                this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_arrayElement(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e];
            }
            _setValue_arrayElement_setNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_arrayElement_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_fromArray(t1, e) {
                this.resolvedProperty.fromArray(t1, e);
            }
            _setValue_fromArray_setNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.needsUpdate = !0;
            }
            _setValue_fromArray_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _getValue_unbound(t1, e) {
                this.bind(), this.getValue(t1, e);
            }
            _setValue_unbound(t1, e) {
                this.bind(), this.setValue(t1, e);
            }
            bind() {
                let t1 = this.node;
                const e = this.parsedPath, n = e.objectName, i = e.propertyName;
                let r = e.propertyIndex;
                if (t1 || (t1 = Tv.findNode(this.rootNode, e.nodeName), this.node = t1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                if (n) {
                    let i = e.objectIndex;
                    switch(n){
                        case "materials":
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                            t1 = t1.material.materials;
                            break;
                        case "bones":
                            if (!t1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                            t1 = t1.skeleton.bones;
                            for(let e = 0; e < t1.length; e++)if (t1[e].name === i) {
                                i = e;
                                break;
                            }
                            break;
                        case "map":
                            if ("map" in t1) {
                                t1 = t1.map;
                                break;
                            }
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                            t1 = t1.material.map;
                            break;
                        default:
                            if (void 0 === t1[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                            t1 = t1[n];
                    }
                    if (void 0 !== i) {
                        if (void 0 === t1[i]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t1);
                        t1 = t1[i];
                    }
                }
                const a = t1[i];
                if (void 0 === a) {
                    const n = e.nodeName;
                    return void console.error("THREE.PropertyBinding: Trying to update property for track: " + n + "." + i + " but it wasn't found.", t1);
                }
                let s = this.Versioning.None;
                this.targetObject = t1, void 0 !== t1.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== t1.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
                let o = this.BindingType.Direct;
                if (void 0 !== r) {
                    if ("morphTargetInfluences" === i) {
                        if (!t1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                        if (!t1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        void 0 !== t1.morphTargetDictionary[r] && (r = t1.morphTargetDictionary[r]);
                    }
                    o = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
                } else void 0 !== a.fromArray && void 0 !== a.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (o = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = i;
                this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][s];
            }
            unbind() {
                this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
        }
        Tv.Composite = class {
            constructor(t1, e, n){
                const i = n || Tv.parseTrackName(e);
                this._targetGroup = t1, this._bindings = t1.subscribe_(e, i);
            }
            getValue(t1, e) {
                this.bind();
                const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
                void 0 !== i && i.getValue(t1, e);
            }
            setValue(t1, e) {
                const n = this._bindings;
                for(let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)n[i].setValue(t1, e);
            }
            bind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, n = t1.length; e !== n; ++e)t1[e].bind();
            }
            unbind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, n = t1.length; e !== n; ++e)t1[e].unbind();
            }
        }, Tv.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
        }, Tv.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
        }, Tv.prototype.GetterByBindingType = [
            Tv.prototype._getValue_direct,
            Tv.prototype._getValue_array,
            Tv.prototype._getValue_arrayElement,
            Tv.prototype._getValue_toArray
        ], Tv.prototype.SetterByBindingTypeAndVersioning = [
            [
                Tv.prototype._setValue_direct,
                Tv.prototype._setValue_direct_setNeedsUpdate,
                Tv.prototype._setValue_direct_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_array,
                Tv.prototype._setValue_array_setNeedsUpdate,
                Tv.prototype._setValue_array_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_arrayElement,
                Tv.prototype._setValue_arrayElement_setNeedsUpdate,
                Tv.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_fromArray,
                Tv.prototype._setValue_fromArray_setNeedsUpdate,
                Tv.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
            ]
        ];
        class Iv {
            constructor(){
                this.isAnimationObjectGroup = !0, this.uuid = Qo(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
                const t1 = {};
                this._indicesByUUID = t1;
                for(let e = 0, n = arguments.length; e !== n; ++e)t1[arguments[e].uuid] = e;
                this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
                const e = this;
                this.stats = {
                    objects: {
                        get total () {
                            return e._objects.length;
                        },
                        get inUse () {
                            return this.total - e.nCachedObjects_;
                        }
                    },
                    get bindingsPerObject () {
                        return e._bindings.length;
                    }
                };
            }
            add() {
                const t1 = this._objects, e = this._indicesByUUID, n = this._paths, i = this._parsedPaths, r = this._bindings, a = r.length;
                let s, o = t1.length, l = this.nCachedObjects_;
                for(let c = 0, u = arguments.length; c !== u; ++c){
                    const u = arguments[c], h = u.uuid;
                    let d = e[h];
                    if (void 0 === d) {
                        d = o++, e[h] = d, t1.push(u);
                        for(let t1 = 0, e = a; t1 !== e; ++t1)r[t1].push(new Tv(u, n[t1], i[t1]));
                    } else if (d < l) {
                        s = t1[d];
                        const o = --l, c = t1[o];
                        e[c.uuid] = d, t1[d] = c, e[h] = o, t1[o] = u;
                        for(let t1 = 0, e = a; t1 !== e; ++t1){
                            const e = r[t1], a = e[o];
                            let s = e[d];
                            e[d] = a, void 0 === s && (s = new Tv(u, n[t1], i[t1])), e[o] = s;
                        }
                    } else t1[d] !== s && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                }
                this.nCachedObjects_ = l;
            }
            remove() {
                const t1 = this._objects, e = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_;
                for(let a = 0, s = arguments.length; a !== s; ++a){
                    const s = arguments[a], o = s.uuid, l = e[o];
                    if (void 0 !== l && l >= r) {
                        const a = r++, c = t1[a];
                        e[c.uuid] = l, t1[l] = c, e[o] = a, t1[a] = s;
                        for(let t1 = 0, e = i; t1 !== e; ++t1){
                            const e = n[t1], i = e[a], r = e[l];
                            e[l] = i, e[a] = r;
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            uncache() {
                const t1 = this._objects, e = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_, a = t1.length;
                for(let s = 0, o = arguments.length; s !== o; ++s){
                    const o = arguments[s].uuid, l = e[o];
                    if (void 0 !== l) {
                        if (delete e[o], l < r) {
                            const s = --r, o = t1[s], c = --a, u = t1[c];
                            e[o.uuid] = l, t1[l] = o, e[u.uuid] = s, t1[s] = u, t1.pop();
                            for(let t1 = 0, e = i; t1 !== e; ++t1){
                                const e = n[t1], i = e[s], r = e[c];
                                e[l] = i, e[s] = r, e.pop();
                            }
                        } else {
                            const r = --a, s = t1[r];
                            r > 0 && (e[s.uuid] = l), t1[l] = s, t1.pop();
                            for(let t1 = 0, e = i; t1 !== e; ++t1){
                                const e = n[t1];
                                e[l] = e[r], e.pop();
                            }
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            subscribe_(t1, e) {
                const n = this._bindingsIndicesByPath;
                let i = n[t1];
                const r = this._bindings;
                if (void 0 !== i) return r[i];
                const a = this._paths, s = this._parsedPaths, o = this._objects, l = o.length, c = this.nCachedObjects_, u = new Array(l);
                i = r.length, n[t1] = i, a.push(t1), s.push(e), r.push(u);
                for(let n = c, i = o.length; n !== i; ++n){
                    const i = o[n];
                    u[n] = new Tv(i, t1, e);
                }
                return u;
            }
            unsubscribe_(t1) {
                const e = this._bindingsIndicesByPath, n = e[t1];
                if (void 0 !== n) {
                    const i = this._paths, r = this._parsedPaths, a = this._bindings, s = a.length - 1, o = a[s];
                    e[t1[s]] = n, a[n] = o, a.pop(), r[n] = r[s], r.pop(), i[n] = i[s], i.pop();
                }
            }
        }
        class Cv {
            constructor(t1, e, n = null, i = e.blendMode){
                this._mixer = t1, this._clip = e, this._localRoot = n, this.blendMode = i;
                const r = e.tracks, a = r.length, s = new Array(a), o = {
                    endingStart: Ds,
                    endingEnd: Ds
                };
                for(let t1 = 0; t1 !== a; ++t1){
                    const e = r[t1].createInterpolant(null);
                    s[t1] = e, e.settings = o;
                }
                this._interpolantSettings = o, this._interpolants = s, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = Ss, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
            }
            play() {
                return this._mixer._activateAction(this), this;
            }
            stop() {
                return this._mixer._deactivateAction(this), this.reset();
            }
            reset() {
                return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            }
            isRunning() {
                return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            }
            isScheduled() {
                return this._mixer._isActiveAction(this);
            }
            startAt(t1) {
                return this._startTime = t1, this;
            }
            setLoop(t1, e) {
                return this.loop = t1, this.repetitions = e, this;
            }
            setEffectiveWeight(t1) {
                return this.weight = t1, this._effectiveWeight = this.enabled ? t1 : 0, this.stopFading();
            }
            getEffectiveWeight() {
                return this._effectiveWeight;
            }
            fadeIn(t1) {
                return this._scheduleFading(t1, 0, 1);
            }
            fadeOut(t1) {
                return this._scheduleFading(t1, 1, 0);
            }
            crossFadeFrom(t1, e, n) {
                if (t1.fadeOut(e), this.fadeIn(e), n) {
                    const n = this._clip.duration, i = t1._clip.duration, r = i / n, a = n / i;
                    t1.warp(1, r, e), this.warp(a, 1, e);
                }
                return this;
            }
            crossFadeTo(t1, e, n) {
                return t1.crossFadeFrom(this, e, n);
            }
            stopFading() {
                const t1 = this._weightInterpolant;
                return null !== t1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            setEffectiveTimeScale(t1) {
                return this.timeScale = t1, this._effectiveTimeScale = this.paused ? 0 : t1, this.stopWarping();
            }
            getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
            setDuration(t1) {
                return this.timeScale = this._clip.duration / t1, this.stopWarping();
            }
            syncWith(t1) {
                return this.time = t1.time, this.timeScale = t1.timeScale, this.stopWarping();
            }
            halt(t1) {
                return this.warp(this._effectiveTimeScale, 0, t1);
            }
            warp(t1, e, n) {
                const i = this._mixer, r = i.time, a = this.timeScale;
                let s = this._timeScaleInterpolant;
                null === s && (s = i._lendControlInterpolant(), this._timeScaleInterpolant = s);
                const o = s.parameterPositions, l = s.sampleValues;
                return o[0] = r, o[1] = r + n, l[0] = t1 / a, l[1] = e / a, this;
            }
            stopWarping() {
                const t1 = this._timeScaleInterpolant;
                return null !== t1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            getMixer() {
                return this._mixer;
            }
            getClip() {
                return this._clip;
            }
            getRoot() {
                return this._localRoot || this._mixer._root;
            }
            _update(t1, e, n, i) {
                if (!this.enabled) return void this._updateWeight(t1);
                const r = this._startTime;
                if (null !== r) {
                    const i = (t1 - r) * n;
                    i < 0 || 0 === n ? e = 0 : (this._startTime = null, e = n * i);
                }
                e *= this._updateTimeScale(t1);
                const a = this._updateTime(e), s = this._updateWeight(t1);
                if (s > 0) {
                    const t1 = this._interpolants, e = this._propertyBindings;
                    if (this.blendMode === Ps) for(let n = 0, i = t1.length; n !== i; ++n)t1[n].evaluate(a), e[n].accumulateAdditive(s);
                    else for(let n = 0, r = t1.length; n !== r; ++n)t1[n].evaluate(a), e[n].accumulate(i, s);
                }
            }
            _updateWeight(t1) {
                let e = 0;
                if (this.enabled) {
                    e = this.weight;
                    const n = this._weightInterpolant;
                    if (null !== n) {
                        const i = n.evaluate(t1)[0];
                        e *= i, t1 > n.parameterPositions[1] && (this.stopFading(), 0 === i && (this.enabled = !1));
                    }
                }
                return this._effectiveWeight = e, e;
            }
            _updateTimeScale(t1) {
                let e = 0;
                if (!this.paused) {
                    e = this.timeScale;
                    const n = this._timeScaleInterpolant;
                    null !== n && (e *= n.evaluate(t1)[0], t1 > n.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e));
                }
                return this._effectiveTimeScale = e, e;
            }
            _updateTime(t1) {
                const e = this._clip.duration, n = this.loop;
                let i = this.time + t1, r = this._loopCount;
                const a = n === Ts;
                if (0 === t1) return -1 === r || !a || 1 & ~r ? i : e - i;
                if (n === Es) {
                    -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                    t: {
                        if (i >= e) i = e;
                        else {
                            if (!(i < 0)) {
                                this.time = i;
                                break t;
                            }
                            i = 0;
                        }
                        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (-1 === r && (t1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), i >= e || i < 0) {
                        const n = Math.floor(i / e);
                        i -= e * n, r += Math.abs(n);
                        const s = this.repetitions - r;
                        if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t1 > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 > 0 ? 1 : -1
                        });
                        else {
                            if (1 === s) {
                                const e = t1 < 0;
                                this._setEndings(e, !e, a);
                            } else this._setEndings(!1, !1, a);
                            this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                                type: "loop",
                                action: this,
                                loopDelta: n
                            });
                        }
                    } else this.time = i;
                    if (a && !(1 & ~r)) return e - i;
                }
                return i;
            }
            _setEndings(t1, e, n) {
                const i = this._interpolantSettings;
                n ? (i.endingStart = Ls, i.endingEnd = Ls) : (i.endingStart = t1 ? this.zeroSlopeAtStart ? Ls : Ds : Os, i.endingEnd = e ? this.zeroSlopeAtEnd ? Ls : Ds : Os);
            }
            _scheduleFading(t1, e, n) {
                const i = this._mixer, r = i.time;
                let a = this._weightInterpolant;
                null === a && (a = i._lendControlInterpolant(), this._weightInterpolant = a);
                const s = a.parameterPositions, o = a.sampleValues;
                return s[0] = r, o[0] = e, s[1] = r + t1, o[1] = n, this;
            }
        }
        const Nv = new Float32Array(1);
        class Dv extends Bo {
            constructor(t1){
                super(), this._root = t1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
            }
            _bindAction(t1, e) {
                const n = t1._localRoot || this._root, i = t1._clip.tracks, r = i.length, a = t1._propertyBindings, s = t1._interpolants, o = n.uuid, l = this._bindingsByRootAndName;
                let c = l[o];
                void 0 === c && (c = {}, l[o] = c);
                for(let t1 = 0; t1 !== r; ++t1){
                    const r = i[t1], l = r.name;
                    let u = c[l];
                    if (void 0 !== u) ++u.referenceCount, a[t1] = u;
                    else {
                        if (u = a[t1], void 0 !== u) {
                            null === u._cacheIndex && (++u.referenceCount, this._addInactiveBinding(u, o, l));
                            continue;
                        }
                        const i = e && e._propertyBindings[t1].binding.parsedPath;
                        u = new Mv(Tv.create(n, l, i), r.ValueTypeName, r.getValueSize()), ++u.referenceCount, this._addInactiveBinding(u, o, l), a[t1] = u;
                    }
                    s[t1].resultBuffer = u.buffer;
                }
            }
            _activateAction(t1) {
                if (!this._isActiveAction(t1)) {
                    if (null === t1._cacheIndex) {
                        const e = (t1._localRoot || this._root).uuid, n = t1._clip.uuid, i = this._actionsByClip[n];
                        this._bindAction(t1, i && i.knownActions[0]), this._addInactiveAction(t1, n, e);
                    }
                    const e = t1._propertyBindings;
                    for(let t1 = 0, n = e.length; t1 !== n; ++t1){
                        const n = e[t1];
                        0 == n.useCount++ && (this._lendBinding(n), n.saveOriginalState());
                    }
                    this._lendAction(t1);
                }
            }
            _deactivateAction(t1) {
                if (this._isActiveAction(t1)) {
                    const e = t1._propertyBindings;
                    for(let t1 = 0, n = e.length; t1 !== n; ++t1){
                        const n = e[t1];
                        0 == --n.useCount && (n.restoreOriginalState(), this._takeBackBinding(n));
                    }
                    this._takeBackAction(t1);
                }
            }
            _initMemoryManager() {
                this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
                const t1 = this;
                this.stats = {
                    actions: {
                        get total () {
                            return t1._actions.length;
                        },
                        get inUse () {
                            return t1._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return t1._bindings.length;
                        },
                        get inUse () {
                            return t1._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return t1._controlInterpolants.length;
                        },
                        get inUse () {
                            return t1._nActiveControlInterpolants;
                        }
                    }
                };
            }
            _isActiveAction(t1) {
                const e = t1._cacheIndex;
                return null !== e && e < this._nActiveActions;
            }
            _addInactiveAction(t1, e, n) {
                const i = this._actions, r = this._actionsByClip;
                let a = r[e];
                if (void 0 === a) a = {
                    knownActions: [
                        t1
                    ],
                    actionByRoot: {}
                }, t1._byClipCacheIndex = 0, r[e] = a;
                else {
                    const e = a.knownActions;
                    t1._byClipCacheIndex = e.length, e.push(t1);
                }
                t1._cacheIndex = i.length, i.push(t1), a.actionByRoot[n] = t1;
            }
            _removeInactiveAction(t1) {
                const e = this._actions, n = e[e.length - 1], i = t1._cacheIndex;
                n._cacheIndex = i, e[i] = n, e.pop(), t1._cacheIndex = null;
                const r = t1._clip.uuid, a = this._actionsByClip, s = a[r], o = s.knownActions, l = o[o.length - 1], c = t1._byClipCacheIndex;
                l._byClipCacheIndex = c, o[c] = l, o.pop(), t1._byClipCacheIndex = null, delete s.actionByRoot[(t1._localRoot || this._root).uuid], 0 === o.length && delete a[r], this._removeInactiveBindingsForAction(t1);
            }
            _removeInactiveBindingsForAction(t1) {
                const e = t1._propertyBindings;
                for(let t1 = 0, n = e.length; t1 !== n; ++t1){
                    const n = e[t1];
                    0 == --n.referenceCount && this._removeInactiveBinding(n);
                }
            }
            _lendAction(t1) {
                const e = this._actions, n = t1._cacheIndex, i = this._nActiveActions++, r = e[i];
                t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
            }
            _takeBackAction(t1) {
                const e = this._actions, n = t1._cacheIndex, i = --this._nActiveActions, r = e[i];
                t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
            }
            _addInactiveBinding(t1, e, n) {
                const i = this._bindingsByRootAndName, r = this._bindings;
                let a = i[e];
                void 0 === a && (a = {}, i[e] = a), a[n] = t1, t1._cacheIndex = r.length, r.push(t1);
            }
            _removeInactiveBinding(t1) {
                const e = this._bindings, n = t1.binding, i = n.rootNode.uuid, r = n.path, a = this._bindingsByRootAndName, s = a[i], o = e[e.length - 1], l = t1._cacheIndex;
                o._cacheIndex = l, e[l] = o, e.pop(), delete s[r], 0 === Object.keys(s).length && delete a[i];
            }
            _lendBinding(t1) {
                const e = this._bindings, n = t1._cacheIndex, i = this._nActiveBindings++, r = e[i];
                t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
            }
            _takeBackBinding(t1) {
                const e = this._bindings, n = t1._cacheIndex, i = --this._nActiveBindings, r = e[i];
                t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
            }
            _lendControlInterpolant() {
                const t1 = this._controlInterpolants, e = this._nActiveControlInterpolants++;
                let n = t1[e];
                return void 0 === n && (n = new tA(new Float32Array(2), new Float32Array(2), 1, Nv), n.__cacheIndex = e, t1[e] = n), n;
            }
            _takeBackControlInterpolant(t1) {
                const e = this._controlInterpolants, n = t1.__cacheIndex, i = --this._nActiveControlInterpolants, r = e[i];
                t1.__cacheIndex = i, e[i] = t1, r.__cacheIndex = n, e[n] = r;
            }
            clipAction(t1, e, n) {
                const i = e || this._root, r = i.uuid;
                let a = "string" == typeof t1 ? uA.findByName(i, t1) : t1;
                const s = null !== a ? a.uuid : t1, o = this._actionsByClip[s];
                let l = null;
                if (void 0 === n && (n = null !== a ? a.blendMode : Rs), void 0 !== o) {
                    const t1 = o.actionByRoot[r];
                    if (void 0 !== t1 && t1.blendMode === n) return t1;
                    l = o.knownActions[0], null === a && (a = l._clip);
                }
                if (null === a) return null;
                const c = new Cv(this, a, e, n);
                return this._bindAction(c, l), this._addInactiveAction(c, s, r), c;
            }
            existingAction(t1, e) {
                const n = e || this._root, i = n.uuid, r = "string" == typeof t1 ? uA.findByName(n, t1) : t1, a = r ? r.uuid : t1, s = this._actionsByClip[a];
                return void 0 !== s && s.actionByRoot[i] || null;
            }
            stopAllAction() {
                const t1 = this._actions;
                for(let e = this._nActiveActions - 1; e >= 0; --e)t1[e].stop();
                return this;
            }
            update(t1) {
                t1 *= this.timeScale;
                const e = this._actions, n = this._nActiveActions, i = this.time += t1, r = Math.sign(t1), a = this._accuIndex ^= 1;
                for(let s = 0; s !== n; ++s)e[s]._update(i, t1, r, a);
                const s = this._bindings, o = this._nActiveBindings;
                for(let t1 = 0; t1 !== o; ++t1)s[t1].apply(a);
                return this;
            }
            setTime(t1) {
                this.time = 0;
                for(let t1 = 0; t1 < this._actions.length; t1++)this._actions[t1].time = 0;
                return this.update(t1);
            }
            getRoot() {
                return this._root;
            }
            uncacheClip(t1) {
                const e = this._actions, n = t1.uuid, i = this._actionsByClip, r = i[n];
                if (void 0 !== r) {
                    const t1 = r.knownActions;
                    for(let n = 0, i = t1.length; n !== i; ++n){
                        const i = t1[n];
                        this._deactivateAction(i);
                        const r = i._cacheIndex, a = e[e.length - 1];
                        i._cacheIndex = null, i._byClipCacheIndex = null, a._cacheIndex = r, e[r] = a, e.pop(), this._removeInactiveBindingsForAction(i);
                    }
                    delete i[n];
                }
            }
            uncacheRoot(t1) {
                const e = t1.uuid, n = this._actionsByClip;
                for(const t1 in n){
                    const i = n[t1].actionByRoot[e];
                    void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
                }
                const i = this._bindingsByRootAndName[e];
                if (void 0 !== i) for(const t1 in i){
                    const e = i[t1];
                    e.restoreOriginalState(), this._removeInactiveBinding(e);
                }
            }
            uncacheAction(t1, e) {
                const n = this.existingAction(t1, e);
                null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
            }
        }
        class Lv {
            constructor(t1){
                this.value = t1;
            }
            clone() {
                return new Lv(void 0 === this.value.clone ? this.value : this.value.clone());
            }
        }
        let Ov = 0;
        class Rv extends Bo {
            constructor(){
                super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
                    value: Ov++
                }), this.name = "", this.usage = Eo, this.uniforms = [];
            }
            add(t1) {
                return this.uniforms.push(t1), this;
            }
            remove(t1) {
                const e = this.uniforms.indexOf(t1);
                return -1 !== e && this.uniforms.splice(e, 1), this;
            }
            setName(t1) {
                return this.name = t1, this;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            dispose() {
                return this.dispatchEvent({
                    type: "dispose"
                }), this;
            }
            copy(t1) {
                this.name = t1.name, this.usage = t1.usage;
                const e = t1.uniforms;
                this.uniforms.length = 0;
                for(let t1 = 0, n = e.length; t1 < n; t1++)this.uniforms.push(e[t1].clone());
                return this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Pv extends Jp {
            constructor(t1, e, n = 1){
                super(t1, e), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            clone(t1) {
                const e = super.clone(t1);
                return e.meshPerAttribute = this.meshPerAttribute, e;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
            }
        }
        class zv {
            constructor(t1, e, n, i, r){
                this.isGLBufferAttribute = !0, this.name = "", this.buffer = t1, this.type = e, this.itemSize = n, this.elementSize = i, this.count = r, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setBuffer(t1) {
                return this.buffer = t1, this;
            }
            setType(t1, e) {
                return this.type = t1, this.elementSize = e, this;
            }
            setItemSize(t1) {
                return this.itemSize = t1, this;
            }
            setCount(t1) {
                return this.count = t1, this;
            }
        }
        class Uv {
            constructor(t1, e, n = 0, i = 1 / 0){
                this.ray = new lc(t1, e), this.near = n, this.far = i, this.camera = null, this.layers = new Mc, this.params = {
                    Mesh: {},
                    Line: {
                        threshold: 1
                    },
                    LOD: {},
                    Points: {
                        threshold: 1
                    },
                    Sprite: {}
                };
            }
            set(t1, e) {
                this.ray.set(t1, e);
            }
            setFromCamera(t1, e) {
                e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t1.x, t1.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t1.x, t1.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
            }
            intersectObject(t1, e = !0, n = []) {
                return Bv(t1, this, n, e), n.sort(kv), n;
            }
            intersectObjects(t1, e = !0, n = []) {
                for(let i = 0, r = t1.length; i < r; i++)Bv(t1[i], this, n, e);
                return n.sort(kv), n;
            }
        }
        function kv(t1, e) {
            return t1.distance - e.distance;
        }
        function Bv(t1, e, n, i) {
            if (t1.layers.test(e.layers) && t1.raycast(e, n), !0 === i) {
                const i = t1.children;
                for(let t1 = 0, r = i.length; t1 < r; t1++)Bv(i[t1], e, n, !0);
            }
        }
        class jv {
            constructor(t1 = 1, e = 0, n = 0){
                return this.radius = t1, this.phi = e, this.theta = n, this;
            }
            set(t1, e, n) {
                return this.radius = t1, this.phi = e, this.theta = n, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.phi = t1.phi, this.theta = t1.theta, this;
            }
            makeSafe() {
                const t1 = 1e-6;
                return this.phi = Math.max(t1, Math.min(Math.PI - t1, this.phi)), this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, n) {
                return this.radius = Math.sqrt(t1 * t1 + e * e + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t1, n), this.phi = Math.acos(Go(e / this.radius, -1, 1))), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Fv {
            constructor(t1 = 1, e = 0, n = 0){
                return this.radius = t1, this.theta = e, this.y = n, this;
            }
            set(t1, e, n) {
                return this.radius = t1, this.theta = e, this.y = n, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.theta = t1.theta, this.y = t1.y, this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, n) {
                return this.radius = Math.sqrt(t1 * t1 + n * n), this.theta = Math.atan2(t1, n), this.y = e, this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Hv = new tl;
        class Vv {
            constructor(t1 = new tl(1 / 0, 1 / 0), e = new tl(-1 / 0, -1 / 0)){
                this.isBox2 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, n = t1.length; e < n; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const n = Hv.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(n), this.max.copy(t1).add(n), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y);
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, Hv).distanceTo(t1);
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const Qv = new Ol, Gv = new Ol;
        class Wv {
            constructor(t1 = new Ol, e = new Ol){
                this.start = t1, this.end = e;
            }
            set(t1, e) {
                return this.start.copy(t1), this.end.copy(e), this;
            }
            copy(t1) {
                return this.start.copy(t1.start), this.end.copy(t1.end), this;
            }
            getCenter(t1) {
                return t1.addVectors(this.start, this.end).multiplyScalar(.5);
            }
            delta(t1) {
                return t1.subVectors(this.end, this.start);
            }
            distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
            distance() {
                return this.start.distanceTo(this.end);
            }
            at(t1, e) {
                return this.delta(e).multiplyScalar(t1).add(this.start);
            }
            closestPointToPointParameter(t1, e) {
                Qv.subVectors(t1, this.start), Gv.subVectors(this.end, this.start);
                const n = Gv.dot(Gv);
                let i = Gv.dot(Qv) / n;
                return e && (i = Go(i, 0, 1)), i;
            }
            closestPointToPoint(t1, e, n) {
                const i = this.closestPointToPointParameter(t1, e);
                return this.delta(n).multiplyScalar(i).add(this.start);
            }
            applyMatrix4(t1) {
                return this.start.applyMatrix4(t1), this.end.applyMatrix4(t1), this;
            }
            equals(t1) {
                return t1.start.equals(this.start) && t1.end.equals(this.end);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Xv = new Ol;
        class Yv extends Rc {
            constructor(t1, e){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
                const n = new Tu, i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1
                ];
                for(let t1 = 0, e = 1, n = 32; t1 < n; t1++, e++){
                    const r = t1 / n * Math.PI * 2, a = e / n * Math.PI * 2;
                    i.push(Math.cos(r), Math.sin(r), 1, Math.cos(a), Math.sin(a), 1);
                }
                n.setAttribute("position", new vu(i, 3));
                const r = new Qf({
                    fog: !1,
                    toneMapped: !1
                });
                this.cone = new $f(n, r), this.add(this.cone), this.update();
            }
            dispose() {
                this.cone.geometry.dispose(), this.cone.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
                const t1 = this.light.distance ? this.light.distance : 1e3, e = t1 * Math.tan(this.light.angle);
                this.cone.scale.set(e, e, t1), Xv.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(Xv), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
            }
        }
        const Zv = new Ol, qv = new cc, Jv = new cc;
        class Kv extends $f {
            constructor(t1){
                const e = $v(t1), n = new Tu, i = [], r = [], a = new Jc(0, 0, 1), s = new Jc(0, 1, 0);
                for(let t1 = 0; t1 < e.length; t1++){
                    const n = e[t1];
                    n.parent && n.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(a.r, a.g, a.b), r.push(s.r, s.g, s.b));
                }
                n.setAttribute("position", new vu(i, 3)), n.setAttribute("color", new vu(r, 3)), super(n, new Qf({
                    vertexColors: !0,
                    depthTest: !1,
                    depthWrite: !1,
                    toneMapped: !1,
                    transparent: !0
                })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = t1, this.bones = e, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1;
            }
            updateMatrixWorld(t1) {
                const e = this.bones, n = this.geometry, i = n.getAttribute("position");
                Jv.copy(this.root.matrixWorld).invert();
                for(let t1 = 0, n = 0; t1 < e.length; t1++){
                    const r = e[t1];
                    r.parent && r.parent.isBone && (qv.multiplyMatrices(Jv, r.matrixWorld), Zv.setFromMatrixPosition(qv), i.setXYZ(n, Zv.x, Zv.y, Zv.z), qv.multiplyMatrices(Jv, r.parent.matrixWorld), Zv.setFromMatrixPosition(qv), i.setXYZ(n + 1, Zv.x, Zv.y, Zv.z), n += 2);
                }
                n.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function $v(t1) {
            const e = [];
            !0 === t1.isBone && e.push(t1);
            for(let n = 0; n < t1.children.length; n++)e.push.apply(e, $v(t1.children[n]));
            return e;
        }
        class ty extends Gu {
            constructor(t1, e, n){
                super(new Ig(e, 4, 2), new eu({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                })), this.light = t1, this.color = n, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
            }
        }
        const ey = new Ol, ny = new Jc, iy = new Jc;
        class ry extends Rc {
            constructor(t1, e, n){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "HemisphereLightHelper";
                const i = new Eg(e);
                i.rotateY(.5 * Math.PI), this.material = new eu({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                }), void 0 === this.color && (this.material.vertexColors = !0);
                const r = i.getAttribute("position"), a = new Float32Array(3 * r.count);
                i.setAttribute("color", new cu(a, 3)), this.add(new Gu(i, this.material)), this.update();
            }
            dispose() {
                this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
            update() {
                const t1 = this.children[0];
                if (void 0 !== this.color) this.material.color.set(this.color);
                else {
                    const e = t1.geometry.getAttribute("color");
                    ny.copy(this.light.color), iy.copy(this.light.groundColor);
                    for(let t1 = 0, n = e.count; t1 < n; t1++){
                        const i = t1 < n / 2 ? ny : iy;
                        e.setXYZ(t1, i.r, i.g, i.b);
                    }
                    e.needsUpdate = !0;
                }
                this.light.updateWorldMatrix(!0, !1), t1.lookAt(ey.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
        class ay extends $f {
            constructor(t1 = 10, e = 10, n = 4473924, i = 8947848){
                n = new Jc(n), i = new Jc(i);
                const r = e / 2, a = t1 / e, s = t1 / 2, o = [], l = [];
                for(let t1 = 0, c = 0, u = -s; t1 <= e; t1++, u += a){
                    o.push(-s, 0, u, s, 0, u), o.push(u, 0, -s, u, 0, s);
                    const e = t1 === r ? n : i;
                    e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3;
                }
                const c = new Tu;
                c.setAttribute("position", new vu(o, 3)), c.setAttribute("color", new vu(l, 3)), super(c, new Qf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "GridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class sy extends $f {
            constructor(t1 = 10, e = 16, n = 8, i = 64, r = 4473924, a = 8947848){
                r = new Jc(r), a = new Jc(a);
                const s = [], o = [];
                if (e > 1) for(let n = 0; n < e; n++){
                    const i = n / e * (2 * Math.PI), l = Math.sin(i) * t1, c = Math.cos(i) * t1;
                    s.push(0, 0, 0), s.push(l, 0, c);
                    const u = 1 & n ? r : a;
                    o.push(u.r, u.g, u.b), o.push(u.r, u.g, u.b);
                }
                for(let e = 0; e < n; e++){
                    const l = 1 & e ? r : a, c = t1 - t1 / n * e;
                    for(let t1 = 0; t1 < i; t1++){
                        let e = t1 / i * (2 * Math.PI), n = Math.sin(e) * c, r = Math.cos(e) * c;
                        s.push(n, 0, r), o.push(l.r, l.g, l.b), e = (t1 + 1) / i * (2 * Math.PI), n = Math.sin(e) * c, r = Math.cos(e) * c, s.push(n, 0, r), o.push(l.r, l.g, l.b);
                    }
                }
                const l = new Tu;
                l.setAttribute("position", new vu(s, 3)), l.setAttribute("color", new vu(o, 3)), super(l, new Qf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "PolarGridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        const oy = new Ol, ly = new Ol, cy = new Ol;
        class uy extends Rc {
            constructor(t1, e, n){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "DirectionalLightHelper", void 0 === e && (e = 1);
                let i = new Tu;
                i.setAttribute("position", new vu([
                    -e,
                    e,
                    0,
                    e,
                    e,
                    0,
                    e,
                    -e,
                    0,
                    -e,
                    -e,
                    0,
                    -e,
                    e,
                    0
                ], 3));
                const r = new Qf({
                    fog: !1,
                    toneMapped: !1
                });
                this.lightPlane = new qf(i, r), this.add(this.lightPlane), i = new Tu, i.setAttribute("position", new vu([
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ], 3)), this.targetLine = new qf(i, r), this.add(this.targetLine), this.update();
            }
            dispose() {
                this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), oy.setFromMatrixPosition(this.light.matrixWorld), ly.setFromMatrixPosition(this.light.target.matrixWorld), cy.subVectors(ly, oy), this.lightPlane.lookAt(ly), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(ly), this.targetLine.scale.z = cy.length();
            }
        }
        const hy = new Ol, dy = new $u;
        class py extends $f {
            constructor(t1){
                const e = new Tu, n = new Qf({
                    color: 16777215,
                    vertexColors: !0,
                    toneMapped: !1
                }), i = [], r = [], a = {};
                function s(t1, e) {
                    o(t1), o(e);
                }
                function o(t1) {
                    i.push(0, 0, 0), r.push(0, 0, 0), void 0 === a[t1] && (a[t1] = []), a[t1].push(i.length / 3 - 1);
                }
                s("n1", "n2"), s("n2", "n4"), s("n4", "n3"), s("n3", "n1"), s("f1", "f2"), s("f2", "f4"), s("f4", "f3"), s("f3", "f1"), s("n1", "f1"), s("n2", "f2"), s("n3", "f3"), s("n4", "f4"), s("p", "n1"), s("p", "n2"), s("p", "n3"), s("p", "n4"), s("u1", "u2"), s("u2", "u3"), s("u3", "u1"), s("c", "t"), s("p", "c"), s("cn1", "cn2"), s("cn3", "cn4"), s("cf1", "cf2"), s("cf3", "cf4"), e.setAttribute("position", new vu(i, 3)), e.setAttribute("color", new vu(r, 3)), super(e, n), this.type = "CameraHelper", this.camera = t1, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
                const l = new Jc(16755200), c = new Jc(16711680), u = new Jc(43775), h = new Jc(16777215), d = new Jc(3355443);
                this.setColors(l, c, u, h, d);
            }
            setColors(t1, e, n, i, r) {
                const a = this.geometry.getAttribute("color");
                a.setXYZ(0, t1.r, t1.g, t1.b), a.setXYZ(1, t1.r, t1.g, t1.b), a.setXYZ(2, t1.r, t1.g, t1.b), a.setXYZ(3, t1.r, t1.g, t1.b), a.setXYZ(4, t1.r, t1.g, t1.b), a.setXYZ(5, t1.r, t1.g, t1.b), a.setXYZ(6, t1.r, t1.g, t1.b), a.setXYZ(7, t1.r, t1.g, t1.b), a.setXYZ(8, t1.r, t1.g, t1.b), a.setXYZ(9, t1.r, t1.g, t1.b), a.setXYZ(10, t1.r, t1.g, t1.b), a.setXYZ(11, t1.r, t1.g, t1.b), a.setXYZ(12, t1.r, t1.g, t1.b), a.setXYZ(13, t1.r, t1.g, t1.b), a.setXYZ(14, t1.r, t1.g, t1.b), a.setXYZ(15, t1.r, t1.g, t1.b), a.setXYZ(16, t1.r, t1.g, t1.b), a.setXYZ(17, t1.r, t1.g, t1.b), a.setXYZ(18, t1.r, t1.g, t1.b), a.setXYZ(19, t1.r, t1.g, t1.b), a.setXYZ(20, t1.r, t1.g, t1.b), a.setXYZ(21, t1.r, t1.g, t1.b), a.setXYZ(22, t1.r, t1.g, t1.b), a.setXYZ(23, t1.r, t1.g, t1.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, n.r, n.g, n.b), a.setXYZ(33, n.r, n.g, n.b), a.setXYZ(34, n.r, n.g, n.b), a.setXYZ(35, n.r, n.g, n.b), a.setXYZ(36, n.r, n.g, n.b), a.setXYZ(37, n.r, n.g, n.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, r.r, r.g, r.b), a.setXYZ(41, r.r, r.g, r.b), a.setXYZ(42, r.r, r.g, r.b), a.setXYZ(43, r.r, r.g, r.b), a.setXYZ(44, r.r, r.g, r.b), a.setXYZ(45, r.r, r.g, r.b), a.setXYZ(46, r.r, r.g, r.b), a.setXYZ(47, r.r, r.g, r.b), a.setXYZ(48, r.r, r.g, r.b), a.setXYZ(49, r.r, r.g, r.b), a.needsUpdate = !0;
            }
            update() {
                const t1 = this.geometry, e = this.pointMap;
                dy.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), fy("c", e, t1, dy, 0, 0, -1), fy("t", e, t1, dy, 0, 0, 1), fy("n1", e, t1, dy, -1, -1, -1), fy("n2", e, t1, dy, 1, -1, -1), fy("n3", e, t1, dy, -1, 1, -1), fy("n4", e, t1, dy, 1, 1, -1), fy("f1", e, t1, dy, -1, -1, 1), fy("f2", e, t1, dy, 1, -1, 1), fy("f3", e, t1, dy, -1, 1, 1), fy("f4", e, t1, dy, 1, 1, 1), fy("u1", e, t1, dy, .7, 1.1, -1), fy("u2", e, t1, dy, -0.7, 1.1, -1), fy("u3", e, t1, dy, 0, 2, -1), fy("cf1", e, t1, dy, -1, 0, 1), fy("cf2", e, t1, dy, 1, 0, 1), fy("cf3", e, t1, dy, 0, -1, 1), fy("cf4", e, t1, dy, 0, 1, 1), fy("cn1", e, t1, dy, -1, 0, -1), fy("cn2", e, t1, dy, 1, 0, -1), fy("cn3", e, t1, dy, 0, -1, -1), fy("cn4", e, t1, dy, 0, 1, -1), t1.getAttribute("position").needsUpdate = !0;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function fy(t1, e, n, i, r, a, s) {
            hy.set(r, a, s).unproject(i);
            const o = e[t1];
            if (void 0 !== o) {
                const t1 = n.getAttribute("position");
                for(let e = 0, n = o.length; e < n; e++)t1.setXYZ(o[e], hy.x, hy.y, hy.z);
            }
        }
        const my = new zl;
        class gy extends $f {
            constructor(t1, e = 16776960){
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Float32Array(24), r = new Tu;
                r.setIndex(new cu(n, 1)), r.setAttribute("position", new cu(i, 3)), super(r, new Qf({
                    color: e,
                    toneMapped: !1
                })), this.object = t1, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
            }
            update(t1) {
                if (void 0 !== t1 && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && my.setFromObject(this.object), my.isEmpty()) return;
                const e = my.min, n = my.max, i = this.geometry.attributes.position, r = i.array;
                r[0] = n.x, r[1] = n.y, r[2] = n.z, r[3] = e.x, r[4] = n.y, r[5] = n.z, r[6] = e.x, r[7] = e.y, r[8] = n.z, r[9] = n.x, r[10] = e.y, r[11] = n.z, r[12] = n.x, r[13] = n.y, r[14] = e.z, r[15] = e.x, r[16] = n.y, r[17] = e.z, r[18] = e.x, r[19] = e.y, r[20] = e.z, r[21] = n.x, r[22] = e.y, r[23] = e.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
            setFromObject(t1) {
                return this.object = t1, this.update(), this;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.object = t1.object, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class Ay extends $f {
            constructor(t1, e = 16776960){
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Tu;
                i.setIndex(new cu(n, 1)), i.setAttribute("position", new vu([
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1
                ], 3)), super(i, new Qf({
                    color: e,
                    toneMapped: !1
                })), this.box = t1, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
            }
            updateMatrixWorld(t1) {
                const e = this.box;
                e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t1));
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class vy extends qf {
            constructor(t1, e = 1, n = 16776960){
                const i = n, r = new Tu;
                r.setAttribute("position", new vu([
                    1,
                    -1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0,
                    1,
                    1,
                    0
                ], 3)), r.computeBoundingSphere(), super(r, new Qf({
                    color: i,
                    toneMapped: !1
                })), this.type = "PlaneHelper", this.plane = t1, this.size = e;
                const a = new Tu;
                a.setAttribute("position", new vu([
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ], 3)), a.computeBoundingSphere(), this.add(new Gu(a, new eu({
                    color: i,
                    opacity: .2,
                    transparent: !0,
                    depthWrite: !1,
                    toneMapped: !1
                })));
            }
            updateMatrixWorld(t1) {
                this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
        }
        const yy = new Ol;
        let My, by;
        class xy extends Rc {
            constructor(t1 = new Ol(0, 0, 1), e = new Ol(0, 0, 0), n = 1, i = 16776960, r = .2 * n, a = .2 * r){
                super(), this.type = "ArrowHelper", void 0 === My && (My = new Tu, My.setAttribute("position", new vu([
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ], 3)), by = new Bm(0, .5, 1, 5, 1), by.translate(0, -0.5, 0)), this.position.copy(e), this.line = new qf(My, new Qf({
                    color: i,
                    toneMapped: !1
                })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Gu(by, new eu({
                    color: i,
                    toneMapped: !1
                })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(t1), this.setLength(n, r, a);
            }
            setDirection(t1) {
                if (t1.y > .99999) this.quaternion.set(0, 0, 0, 1);
                else if (t1.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    yy.set(t1.z, 0, -t1.x).normalize();
                    const e = Math.acos(t1.y);
                    this.quaternion.setFromAxisAngle(yy, e);
                }
            }
            setLength(t1, e = .2 * t1, n = .2 * e) {
                this.line.scale.set(1, Math.max(1e-4, t1 - e), 1), this.line.updateMatrix(), this.cone.scale.set(n, e, n), this.cone.position.y = t1, this.cone.updateMatrix();
            }
            setColor(t1) {
                this.line.material.color.set(t1), this.cone.material.color.set(t1);
            }
            copy(t1) {
                return super.copy(t1, !1), this.line.copy(t1.line), this.cone.copy(t1.cone), this;
            }
            dispose() {
                this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
            }
        }
        class wy extends $f {
            constructor(t1 = 1){
                const e = [
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1
                ], n = new Tu;
                n.setAttribute("position", new vu(e, 3)), n.setAttribute("color", new vu([
                    1,
                    0,
                    0,
                    1,
                    .6,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1
                ], 3)), super(n, new Qf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "AxesHelper";
            }
            setColors(t1, e, n) {
                const i = new Jc, r = this.geometry.attributes.color.array;
                return i.set(t1), i.toArray(r, 0), i.toArray(r, 3), i.set(e), i.toArray(r, 6), i.toArray(r, 9), i.set(n), i.toArray(r, 12), i.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class _y {
            constructor(){
                this.type = "ShapePath", this.color = new Jc, this.subPaths = [], this.currentPath = null;
            }
            moveTo(t1, e) {
                return this.currentPath = new Pm, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t1, e), this;
            }
            lineTo(t1, e) {
                return this.currentPath.lineTo(t1, e), this;
            }
            quadraticCurveTo(t1, e, n, i) {
                return this.currentPath.quadraticCurveTo(t1, e, n, i), this;
            }
            bezierCurveTo(t1, e, n, i, r, a) {
                return this.currentPath.bezierCurveTo(t1, e, n, i, r, a), this;
            }
            splineThru(t1) {
                return this.currentPath.splineThru(t1), this;
            }
            toShapes(t1) {
                function e(t1, e) {
                    const n = e.length;
                    let i = !1;
                    for(let r = n - 1, a = 0; a < n; r = a++){
                        let n = e[r], s = e[a], o = s.x - n.x, l = s.y - n.y;
                        if (Math.abs(l) > Number.EPSILON) {
                            if (l < 0 && (n = e[a], o = -o, s = e[r], l = -l), t1.y < n.y || t1.y > s.y) continue;
                            if (t1.y === n.y) {
                                if (t1.x === n.x) return !0;
                            } else {
                                const e = l * (t1.x - n.x) - o * (t1.y - n.y);
                                if (0 === e) return !0;
                                if (e < 0) continue;
                                i = !i;
                            }
                        } else {
                            if (t1.y !== n.y) continue;
                            if (s.x <= t1.x && t1.x <= n.x || n.x <= t1.x && t1.x <= s.x) return !0;
                        }
                    }
                    return i;
                }
                const n = yg.isClockWise, i = this.subPaths;
                if (0 === i.length) return [];
                let r, a, s;
                const o = [];
                if (1 === i.length) return a = i[0], s = new Ym, s.curves = a.curves, o.push(s), o;
                let l = !n(i[0].getPoints());
                l = t1 ? !l : l;
                const c = [], u = [];
                let h, d, p = [], f = 0;
                u[f] = void 0, p[f] = [];
                for(let e = 0, s = i.length; e < s; e++)a = i[e], h = a.getPoints(), r = n(h), r = t1 ? !r : r, r ? (!l && u[f] && f++, u[f] = {
                    s: new Ym,
                    p: h
                }, u[f].s.curves = a.curves, l && f++, p[f] = []) : p[f].push({
                    h: a,
                    p: h[0]
                });
                if (!u[0]) return function(t1) {
                    const e = [];
                    for(let n = 0, i = t1.length; n < i; n++){
                        const i = t1[n], r = new Ym;
                        r.curves = i.curves, e.push(r);
                    }
                    return e;
                }(i);
                if (u.length > 1) {
                    let t1 = !1, n = 0;
                    for(let t1 = 0, e = u.length; t1 < e; t1++)c[t1] = [];
                    for(let i = 0, r = u.length; i < r; i++){
                        const r = p[i];
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            let o = !0;
                            for(let r = 0; r < u.length; r++)e(s.p, u[r].p) && (i !== r && n++, o ? (o = !1, c[r].push(s)) : t1 = !0);
                            o && c[i].push(s);
                        }
                    }
                    n > 0 && !1 === t1 && (p = c);
                }
                for(let t1 = 0, e = u.length; t1 < e; t1++){
                    s = u[t1].s, o.push(s), d = p[t1];
                    for(let t1 = 0, e = d.length; t1 < e; t1++)s.holes.push(d[t1].h);
                }
                return o;
            }
        }
        function Ey(t1, e) {
            if (e === zs) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), t1;
            if (e === ks || e === Us) {
                let n = t1.getIndex();
                if (null === n) {
                    const e = [], i = t1.getAttribute("position");
                    if (void 0 === i) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t1;
                    for(let t1 = 0; t1 < i.count; t1++)e.push(t1);
                    t1.setIndex(e), n = t1.getIndex();
                }
                const i = n.count - 2, r = [];
                if (e === ks) for(let t1 = 1; t1 <= i; t1++)r.push(n.getX(0)), r.push(n.getX(t1)), r.push(n.getX(t1 + 1));
                else for(let t1 = 0; t1 < i; t1++)t1 % 2 == 0 ? (r.push(n.getX(t1)), r.push(n.getX(t1 + 1)), r.push(n.getX(t1 + 2))) : (r.push(n.getX(t1 + 2)), r.push(n.getX(t1 + 1)), r.push(n.getX(t1)));
                r.length / 3 !== i && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
                const a = t1.clone();
                return a.setIndex(r), a.clearGroups(), a;
            }
            return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), t1;
        }
        "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
            detail: {
                revision: tr
            }
        })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = tr);
        class Sy extends mA {
            constructor(t1){
                super(t1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t1) {
                    return new Ly(t1);
                }), this.register(function(t1) {
                    return new jy(t1);
                }), this.register(function(t1) {
                    return new Fy(t1);
                }), this.register(function(t1) {
                    return new Hy(t1);
                }), this.register(function(t1) {
                    return new Ry(t1);
                }), this.register(function(t1) {
                    return new Py(t1);
                }), this.register(function(t1) {
                    return new zy(t1);
                }), this.register(function(t1) {
                    return new Uy(t1);
                }), this.register(function(t1) {
                    return new Dy(t1);
                }), this.register(function(t1) {
                    return new ky(t1);
                }), this.register(function(t1) {
                    return new Oy(t1);
                }), this.register(function(t1) {
                    return new By(t1);
                }), this.register(function(t1) {
                    return new Cy(t1);
                }), this.register(function(t1) {
                    return new Vy(t1);
                }), this.register(function(t1) {
                    return new Qy(t1);
                });
            }
            load(t1, e, n, i) {
                const r = this;
                let a;
                a = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : GA.extractUrlBase(t1), this.manager.itemStart(t1);
                const s = function(e) {
                    i ? i(e) : console.error(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }, o = new vA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t1, function(n) {
                    try {
                        r.parse(n, a, function(n) {
                            e(n), r.manager.itemEnd(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, n, s);
            }
            setDRACOLoader(t1) {
                return this.dracoLoader = t1, this;
            }
            setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
            }
            setKTX2Loader(t1) {
                return this.ktx2Loader = t1, this;
            }
            setMeshoptDecoder(t1) {
                return this.meshoptDecoder = t1, this;
            }
            register(t1) {
                return -1 === this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.push(t1), this;
            }
            unregister(t1) {
                return -1 !== this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t1), 1), this;
            }
            parse(t1, e, n, i) {
                let r;
                const a = {}, s = {}, o = new TextDecoder;
                if ("string" == typeof t1) r = JSON.parse(t1);
                else if (t1 instanceof ArrayBuffer) {
                    if (o.decode(new Uint8Array(t1, 0, 4)) === Gy) {
                        try {
                            a[Iy.KHR_BINARY_GLTF] = new Wy(t1);
                        } catch (t1) {
                            return void (i && i(t1));
                        }
                        r = JSON.parse(a[Iy.KHR_BINARY_GLTF].content);
                    } else r = JSON.parse(o.decode(t1));
                } else r = t1;
                if (void 0 === r.asset || r.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
                const l = new fM(r, {
                    path: e || this.resourcePath || "",
                    crossOrigin: this.crossOrigin,
                    requestHeader: this.requestHeader,
                    manager: this.manager,
                    ktx2Loader: this.ktx2Loader,
                    meshoptDecoder: this.meshoptDecoder
                });
                l.fileLoader.setRequestHeader(this.requestHeader);
                for(let t1 = 0; t1 < this.pluginCallbacks.length; t1++){
                    const e = this.pluginCallbacks[t1](l);
                    e.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), s[e.name] = e, a[e.name] = !0;
                }
                if (r.extensionsUsed) for(let t1 = 0; t1 < r.extensionsUsed.length; ++t1){
                    const e = r.extensionsUsed[t1], n = r.extensionsRequired || [];
                    switch(e){
                        case Iy.KHR_MATERIALS_UNLIT:
                            a[e] = new Ny;
                            break;
                        case Iy.KHR_DRACO_MESH_COMPRESSION:
                            a[e] = new Xy(r, this.dracoLoader);
                            break;
                        case Iy.KHR_TEXTURE_TRANSFORM:
                            a[e] = new Yy;
                            break;
                        case Iy.KHR_MESH_QUANTIZATION:
                            a[e] = new Zy;
                            break;
                        default:
                            n.indexOf(e) >= 0 && void 0 === s[e] && console.warn('THREE.GLTFLoader: Unknown extension "' + e + '".');
                    }
                }
                l.setExtensions(a), l.setPlugins(s), l.parse(n, i);
            }
            parseAsync(t1, e) {
                const n = this;
                return new Promise(function(i, r) {
                    n.parse(t1, e, i, r);
                });
            }
        }
        function Ty() {
            let t1 = {};
            return {
                get: function(e) {
                    return t1[e];
                },
                add: function(e, n) {
                    t1[e] = n;
                },
                remove: function(e) {
                    delete t1[e];
                },
                removeAll: function() {
                    t1 = {};
                }
            };
        }
        const Iy = {
            KHR_BINARY_GLTF: "KHR_binary_glTF",
            KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
            KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
            KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
            KHR_MATERIALS_IOR: "KHR_materials_ior",
            KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
            KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
            KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
            KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
            KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
            KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
            KHR_MATERIALS_VOLUME: "KHR_materials_volume",
            KHR_TEXTURE_BASISU: "KHR_texture_basisu",
            KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
            KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
            KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
            EXT_TEXTURE_WEBP: "EXT_texture_webp",
            EXT_TEXTURE_AVIF: "EXT_texture_avif",
            EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
            EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
        };
        class Cy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_LIGHTS_PUNCTUAL, this.cache = {
                    refs: {},
                    uses: {}
                };
            }
            _markDefs() {
                const t1 = this.parser, e = this.parser.json.nodes || [];
                for(let n = 0, i = e.length; n < i; n++){
                    const i = e[n];
                    i.extensions && i.extensions[this.name] && void 0 !== i.extensions[this.name].light && t1._addNodeRef(this.cache, i.extensions[this.name].light);
                }
            }
            _loadLight(t1) {
                const e = this.parser, n = "light:" + t1;
                let i = e.cache.get(n);
                if (i) return i;
                const r = e.json, a = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t1];
                let s;
                const o = new Jc(16777215);
                void 0 !== a.color && o.setRGB(a.color[0], a.color[1], a.color[2], Xs);
                const l = void 0 !== a.range ? a.range : 0;
                switch(a.type){
                    case "directional":
                        s = new BA(o), s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    case "point":
                        s = new UA(o), s.distance = l;
                        break;
                    case "spot":
                        s = new LA(o), s.distance = l, a.spot = a.spot || {}, a.spot.innerConeAngle = void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = void 0 !== a.spot.outerConeAngle ? a.spot.outerConeAngle : Math.PI / 4, s.angle = a.spot.outerConeAngle, s.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    default:
                        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
                }
                return s.position.set(0, 0, 0), s.decay = 2, lM(s, a), void 0 !== a.intensity && (s.intensity = a.intensity), s.name = e.createUniqueName(a.name || "light_" + t1), i = Promise.resolve(s), e.cache.add(n, i), i;
            }
            getDependency(t1, e) {
                if ("light" === t1) return this._loadLight(e);
            }
            createNodeAttachment(t1) {
                const e = this, n = this.parser, i = n.json.nodes[t1], r = (i.extensions && i.extensions[this.name] || {}).light;
                return void 0 === r ? null : this._loadLight(r).then(function(t1) {
                    return n._getNodeRef(e.cache, r, t1);
                });
            }
        }
        class Ny {
            constructor(){
                this.name = Iy.KHR_MATERIALS_UNLIT;
            }
            getMaterialType() {
                return eu;
            }
            extendParams(t1, e, n) {
                const i = [];
                t1.color = new Jc(1, 1, 1), t1.opacity = 1;
                const r = e.pbrMetallicRoughness;
                if (r) {
                    if (Array.isArray(r.baseColorFactor)) {
                        const e = r.baseColorFactor;
                        t1.color.setRGB(e[0], e[1], e[2], Xs), t1.opacity = e[3];
                    }
                    void 0 !== r.baseColorTexture && i.push(n.assignTexture(t1, "map", r.baseColorTexture, Ws));
                }
                return Promise.all(i);
            }
        }
        class Dy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name].emissiveStrength;
                return void 0 !== i && (e.emissiveIntensity = i), Promise.resolve();
            }
        }
        class Ly {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_CLEARCOAT;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                if (void 0 !== a.clearcoatFactor && (e.clearcoat = a.clearcoatFactor), void 0 !== a.clearcoatTexture && r.push(n.assignTexture(e, "clearcoatMap", a.clearcoatTexture)), void 0 !== a.clearcoatRoughnessFactor && (e.clearcoatRoughness = a.clearcoatRoughnessFactor), void 0 !== a.clearcoatRoughnessTexture && r.push(n.assignTexture(e, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), void 0 !== a.clearcoatNormalTexture && (r.push(n.assignTexture(e, "clearcoatNormalMap", a.clearcoatNormalTexture)), void 0 !== a.clearcoatNormalTexture.scale)) {
                    const t1 = a.clearcoatNormalTexture.scale;
                    e.clearcoatNormalScale = new tl(t1, t1);
                }
                return Promise.all(r);
            }
        }
        class Oy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_IRIDESCENCE;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.iridescenceFactor && (e.iridescence = a.iridescenceFactor), void 0 !== a.iridescenceTexture && r.push(n.assignTexture(e, "iridescenceMap", a.iridescenceTexture)), void 0 !== a.iridescenceIor && (e.iridescenceIOR = a.iridescenceIor), void 0 === e.iridescenceThicknessRange && (e.iridescenceThicknessRange = [
                    100,
                    400
                ]), void 0 !== a.iridescenceThicknessMinimum && (e.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), void 0 !== a.iridescenceThicknessMaximum && (e.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), void 0 !== a.iridescenceThicknessTexture && r.push(n.assignTexture(e, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
            }
        }
        class Ry {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_SHEEN;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [];
                e.sheenColor = new Jc(0, 0, 0), e.sheenRoughness = 0, e.sheen = 1;
                const a = i.extensions[this.name];
                if (void 0 !== a.sheenColorFactor) {
                    const t1 = a.sheenColorFactor;
                    e.sheenColor.setRGB(t1[0], t1[1], t1[2], Xs);
                }
                return void 0 !== a.sheenRoughnessFactor && (e.sheenRoughness = a.sheenRoughnessFactor), void 0 !== a.sheenColorTexture && r.push(n.assignTexture(e, "sheenColorMap", a.sheenColorTexture, Ws)), void 0 !== a.sheenRoughnessTexture && r.push(n.assignTexture(e, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
            }
        }
        class Py {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_TRANSMISSION;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.transmissionFactor && (e.transmission = a.transmissionFactor), void 0 !== a.transmissionTexture && r.push(n.assignTexture(e, "transmissionMap", a.transmissionTexture)), Promise.all(r);
            }
        }
        class zy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_VOLUME;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                e.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0, void 0 !== a.thicknessTexture && r.push(n.assignTexture(e, "thicknessMap", a.thicknessTexture)), e.attenuationDistance = a.attenuationDistance || 1 / 0;
                const s = a.attenuationColor || [
                    1,
                    1,
                    1
                ];
                return e.attenuationColor = (new Jc).setRGB(s[0], s[1], s[2], Xs), Promise.all(r);
            }
        }
        class Uy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_IOR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name];
                return e.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
            }
        }
        class ky {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_SPECULAR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                e.specularIntensity = void 0 !== a.specularFactor ? a.specularFactor : 1, void 0 !== a.specularTexture && r.push(n.assignTexture(e, "specularIntensityMap", a.specularTexture));
                const s = a.specularColorFactor || [
                    1,
                    1,
                    1
                ];
                return e.specularColor = (new Jc).setRGB(s[0], s[1], s[2], Xs), void 0 !== a.specularColorTexture && r.push(n.assignTexture(e, "specularColorMap", a.specularColorTexture, Ws)), Promise.all(r);
            }
        }
        class By {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_MATERIALS_ANISOTROPY;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Bg : null;
            }
            extendMaterialParams(t1, e) {
                const n = this.parser, i = n.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.anisotropyStrength && (e.anisotropy = a.anisotropyStrength), void 0 !== a.anisotropyRotation && (e.anisotropyRotation = a.anisotropyRotation), void 0 !== a.anisotropyTexture && r.push(n.assignTexture(e, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
            }
        }
        class jy {
            constructor(t1){
                this.parser = t1, this.name = Iy.KHR_TEXTURE_BASISU;
            }
            loadTexture(t1) {
                const e = this.parser, n = e.json, i = n.textures[t1];
                if (!i.extensions || !i.extensions[this.name]) return null;
                const r = i.extensions[this.name], a = e.options.ktx2Loader;
                if (!a) {
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
                    return null;
                }
                return e.loadTextureImage(t1, r.source, a);
            }
        }
        class Fy {
            constructor(t1){
                this.parser = t1, this.name = Iy.EXT_TEXTURE_WEBP, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, n = this.parser, i = n.json, r = i.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const t1 = n.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(t1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
                    return n.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class Hy {
            constructor(t1){
                this.parser = t1, this.name = Iy.EXT_TEXTURE_AVIF, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, n = this.parser, i = n.json, r = i.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const t1 = n.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(t1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
                    return n.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class Vy {
            constructor(t1){
                this.name = Iy.EXT_MESHOPT_COMPRESSION, this.parser = t1;
            }
            loadBufferView(t1) {
                const e = this.parser.json, n = e.bufferViews[t1];
                if (n.extensions && n.extensions[this.name]) {
                    const t1 = n.extensions[this.name], i = this.parser.getDependency("buffer", t1.buffer), r = this.parser.options.meshoptDecoder;
                    if (!r || !r.supported) {
                        if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                        return null;
                    }
                    return i.then(function(e) {
                        const n = t1.byteOffset || 0, i = t1.byteLength || 0, a = t1.count, s = t1.byteStride, o = new Uint8Array(e, n, i);
                        return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(a, s, o, t1.mode, t1.filter).then(function(t1) {
                            return t1.buffer;
                        }) : r.ready.then(function() {
                            const e = new ArrayBuffer(a * s);
                            return r.decodeGltfBuffer(new Uint8Array(e), a, s, o, t1.mode, t1.filter), e;
                        });
                    });
                }
                return null;
            }
        }
        class Qy {
            constructor(t1){
                this.name = Iy.EXT_MESH_GPU_INSTANCING, this.parser = t1;
            }
            createNodeMesh(t1) {
                const e = this.parser.json, n = e.nodes[t1];
                if (!n.extensions || !n.extensions[this.name] || void 0 === n.mesh) return null;
                const i = e.meshes[n.mesh];
                for (const t1 of i.primitives)if (t1.mode !== $y.TRIANGLES && t1.mode !== $y.TRIANGLE_STRIP && t1.mode !== $y.TRIANGLE_FAN && void 0 !== t1.mode) return null;
                const r = n.extensions[this.name].attributes, a = [], s = {};
                for(const t1 in r)a.push(this.parser.getDependency("accessor", r[t1]).then((e)=>(s[t1] = e, s[t1])));
                return a.length < 1 ? null : (a.push(this.parser.createNodeMesh(t1)), Promise.all(a).then((t1)=>{
                    const e = t1.pop(), n = e.isGroup ? e.children : [
                        e
                    ], i = t1[0].count, r = [];
                    for (const t1 of n){
                        const e = new cc, n = new Ol, a = new Ll, o = new Ol(1, 1, 1), l = new Vf(t1.geometry, t1.material, i);
                        for(let t1 = 0; t1 < i; t1++)s.TRANSLATION && n.fromBufferAttribute(s.TRANSLATION, t1), s.ROTATION && a.fromBufferAttribute(s.ROTATION, t1), s.SCALE && o.fromBufferAttribute(s.SCALE, t1), l.setMatrixAt(t1, e.compose(n, a, o));
                        for(const e in s)if ("_COLOR_0" === e) {
                            const t1 = s[e];
                            l.instanceColor = new Pf(t1.array, t1.itemSize, t1.normalized);
                        } else "TRANSLATION" !== e && "ROTATION" !== e && "SCALE" !== e && t1.geometry.setAttribute(e, s[e]);
                        Rc.prototype.copy.call(l, t1), this.parser.assignFinalMaterial(l), r.push(l);
                    }
                    return e.isGroup ? (e.clear(), e.add(...r), e) : r[0];
                }));
            }
        }
        const Gy = "glTF";
        class Wy {
            constructor(t1){
                this.name = Iy.KHR_BINARY_GLTF, this.content = null, this.body = null;
                const e = new DataView(t1, 0, 12), n = new TextDecoder;
                if (this.header = {
                    magic: n.decode(new Uint8Array(t1.slice(0, 4))),
                    version: e.getUint32(4, !0),
                    length: e.getUint32(8, !0)
                }, this.header.magic !== Gy) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
                if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
                const i = this.header.length - 12, r = new DataView(t1, 12);
                let a = 0;
                for(; a < i;){
                    const e = r.getUint32(a, !0);
                    a += 4;
                    const i = r.getUint32(a, !0);
                    if (a += 4, 1313821514 === i) {
                        const i = new Uint8Array(t1, 12 + a, e);
                        this.content = n.decode(i);
                    } else if (5130562 === i) {
                        const n = 12 + a;
                        this.body = t1.slice(n, n + e);
                    }
                    a += e;
                }
                if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
            }
        }
        class Xy {
            constructor(t1, e){
                if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
                this.name = Iy.KHR_DRACO_MESH_COMPRESSION, this.json = t1, this.dracoLoader = e, this.dracoLoader.preload();
            }
            decodePrimitive(t1, e) {
                const n = this.json, i = this.dracoLoader, r = t1.extensions[this.name].bufferView, a = t1.extensions[this.name].attributes, s = {}, o = {}, l = {};
                for(const t1 in a){
                    const e = rM[t1] || t1.toLowerCase();
                    s[e] = a[t1];
                }
                for(const e in t1.attributes){
                    const i = rM[e] || e.toLowerCase();
                    if (void 0 !== a[e]) {
                        const r = n.accessors[t1.attributes[e]], a = tM[r.componentType];
                        l[i] = a.name, o[i] = !0 === r.normalized;
                    }
                }
                return e.getDependency("bufferView", r).then(function(t1) {
                    return new Promise(function(e) {
                        i.decodeDracoFile(t1, function(t1) {
                            for(const e in t1.attributes){
                                const n = t1.attributes[e], i = o[e];
                                void 0 !== i && (n.normalized = i);
                            }
                            e(t1);
                        }, s, l);
                    });
                });
            }
        }
        class Yy {
            constructor(){
                this.name = Iy.KHR_TEXTURE_TRANSFORM;
            }
            extendTexture(t1, e) {
                return void 0 !== e.texCoord && e.texCoord !== t1.channel || void 0 !== e.offset || void 0 !== e.rotation || void 0 !== e.scale ? (t1 = t1.clone(), void 0 !== e.texCoord && (t1.channel = e.texCoord), void 0 !== e.offset && t1.offset.fromArray(e.offset), void 0 !== e.rotation && (t1.rotation = e.rotation), void 0 !== e.scale && t1.repeat.fromArray(e.scale), t1.needsUpdate = !0, t1) : t1;
            }
        }
        class Zy {
            constructor(){
                this.name = Iy.KHR_MESH_QUANTIZATION;
            }
        }
        class qy extends Kg {
            constructor(t1, e, n, i){
                super(t1, e, n, i);
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = t1 * i * 3 + i;
                for(let t1 = 0; t1 !== i; t1++)e[t1] = n[r + t1];
                return e;
            }
            interpolate_(t1, e, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = 2 * s, l = 3 * s, c = i - e, u = (n - e) / c, h = u * u, d = h * u, p = t1 * l, f = p - l, m = -2 * d + 3 * h, g = d - h, A = 1 - m, v = g - h + u;
                for(let t1 = 0; t1 !== s; t1++){
                    const e = a[f + t1 + s], n = a[f + t1 + o] * c, i = a[p + t1 + s], l = a[p + t1] * c;
                    r[t1] = A * e + v * n + m * i + g * l;
                }
                return r;
            }
        }
        const Jy = new Ll;
        class Ky extends qy {
            interpolate_(t1, e, n, i) {
                const r = super.interpolate_(t1, e, n, i);
                return Jy.fromArray(r).normalize().toArray(r), r;
            }
        }
        const $y = {
            FLOAT: 5126,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        }, tM = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, eM = {
            9728: ma,
            9729: Ma,
            9984: ga,
            9985: ba,
            9986: va,
            9987: wa
        }, nM = {
            33071: pa,
            33648: fa,
            10497: da
        }, iM = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        }, rM = {
            POSITION: "position",
            NORMAL: "normal",
            TANGENT: "tangent",
            TEXCOORD_0: "uv",
            TEXCOORD_1: "uv1",
            TEXCOORD_2: "uv2",
            TEXCOORD_3: "uv3",
            COLOR_0: "color",
            WEIGHTS_0: "skinWeight",
            JOINTS_0: "skinIndex"
        }, aM = {
            scale: "scale",
            translation: "position",
            rotation: "quaternion",
            weights: "morphTargetInfluences"
        }, sM = {
            CUBICSPLINE: void 0,
            LINEAR: Cs,
            STEP: Is
        };
        function oM(t1, e, n) {
            for(const i in n.extensions)void 0 === t1[i] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[i] = n.extensions[i]);
        }
        function lM(t1, e) {
            void 0 !== e.extras && ("object" == typeof e.extras ? Object.assign(t1.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
        }
        function cM(t1, e) {
            if (t1.updateMorphTargets(), void 0 !== e.weights) for(let n = 0, i = e.weights.length; n < i; n++)t1.morphTargetInfluences[n] = e.weights[n];
            if (e.extras && Array.isArray(e.extras.targetNames)) {
                const n = e.extras.targetNames;
                if (t1.morphTargetInfluences.length === n.length) {
                    t1.morphTargetDictionary = {};
                    for(let e = 0, i = n.length; e < i; e++)t1.morphTargetDictionary[n[e]] = e;
                } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
            }
        }
        function uM(t1) {
            let e;
            const n = t1.extensions && t1.extensions[Iy.KHR_DRACO_MESH_COMPRESSION];
            if (e = n ? "draco:" + n.bufferView + ":" + n.indices + ":" + hM(n.attributes) : t1.indices + ":" + hM(t1.attributes) + ":" + t1.mode, void 0 !== t1.targets) for(let n = 0, i = t1.targets.length; n < i; n++)e += ":" + hM(t1.targets[n]);
            return e;
        }
        function hM(t1) {
            let e = "";
            const n = Object.keys(t1).sort();
            for(let i = 0, r = n.length; i < r; i++)e += n[i] + ":" + t1[n[i]] + ";";
            return e;
        }
        function dM(t1) {
            switch(t1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
            }
        }
        const pM = new cc;
        class fM {
            constructor(t1 = {}, e = {}){
                this.json = t1, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new Ty, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
                    refs: {},
                    uses: {}
                }, this.cameraCache = {
                    refs: {},
                    uses: {}
                }, this.lightCache = {
                    refs: {},
                    uses: {}
                }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
                let n = !1, i = !1, r = -1;
                "undefined" != typeof navigator && (n = !0 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent), i = navigator.userAgent.indexOf("Firefox") > -1, r = i ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), "undefined" == typeof createImageBitmap || n || i && r < 98 ? this.textureLoader = new _A(this.options.manager) : this.textureLoader = new KA(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new vA(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
            }
            setExtensions(t1) {
                this.extensions = t1;
            }
            setPlugins(t1) {
                this.plugins = t1;
            }
            parse(t1, e) {
                const n = this, i = this.json, r = this.extensions;
                this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(t1) {
                    return t1._markDefs && t1._markDefs();
                }), Promise.all(this._invokeAll(function(t1) {
                    return t1.beforeRoot && t1.beforeRoot();
                })).then(function() {
                    return Promise.all([
                        n.getDependencies("scene"),
                        n.getDependencies("animation"),
                        n.getDependencies("camera")
                    ]);
                }).then(function(e) {
                    const a = {
                        scene: e[0][i.scene || 0],
                        scenes: e[0],
                        animations: e[1],
                        cameras: e[2],
                        asset: i.asset,
                        parser: n,
                        userData: {}
                    };
                    return oM(r, a, i), lM(a, i), Promise.all(n._invokeAll(function(t1) {
                        return t1.afterRoot && t1.afterRoot(a);
                    })).then(function() {
                        t1(a);
                    });
                }).catch(e);
            }
            _markDefs() {
                const t1 = this.json.nodes || [], e = this.json.skins || [], n = this.json.meshes || [];
                for(let n = 0, i = e.length; n < i; n++){
                    const i = e[n].joints;
                    for(let e = 0, n = i.length; e < n; e++)t1[i[e]].isBone = !0;
                }
                for(let e = 0, i = t1.length; e < i; e++){
                    const i = t1[e];
                    void 0 !== i.mesh && (this._addNodeRef(this.meshCache, i.mesh), void 0 !== i.skin && (n[i.mesh].isSkinnedMesh = !0)), void 0 !== i.camera && this._addNodeRef(this.cameraCache, i.camera);
                }
            }
            _addNodeRef(t1, e) {
                void 0 !== e && (void 0 === t1.refs[e] && (t1.refs[e] = t1.uses[e] = 0), t1.refs[e]++);
            }
            _getNodeRef(t1, e, n) {
                if (t1.refs[e] <= 1) return n;
                const i = n.clone(), r = (t1, e)=>{
                    const n = this.associations.get(t1);
                    null != n && this.associations.set(e, n);
                    for (const [n, i] of t1.children.entries())r(i, e.children[n]);
                };
                return r(n, i), i.name += "_instance_" + t1.uses[e]++, i;
            }
            _invokeOne(t1) {
                const e = Object.values(this.plugins);
                e.push(this);
                for(let n = 0; n < e.length; n++){
                    const i = t1(e[n]);
                    if (i) return i;
                }
                return null;
            }
            _invokeAll(t1) {
                const e = Object.values(this.plugins);
                e.unshift(this);
                const n = [];
                for(let i = 0; i < e.length; i++){
                    const r = t1(e[i]);
                    r && n.push(r);
                }
                return n;
            }
            getDependency(t1, e) {
                const n = t1 + ":" + e;
                let i = this.cache.get(n);
                if (!i) {
                    switch(t1){
                        case "scene":
                            i = this.loadScene(e);
                            break;
                        case "node":
                            i = this._invokeOne(function(t1) {
                                return t1.loadNode && t1.loadNode(e);
                            });
                            break;
                        case "mesh":
                            i = this._invokeOne(function(t1) {
                                return t1.loadMesh && t1.loadMesh(e);
                            });
                            break;
                        case "accessor":
                            i = this.loadAccessor(e);
                            break;
                        case "bufferView":
                            i = this._invokeOne(function(t1) {
                                return t1.loadBufferView && t1.loadBufferView(e);
                            });
                            break;
                        case "buffer":
                            i = this.loadBuffer(e);
                            break;
                        case "material":
                            i = this._invokeOne(function(t1) {
                                return t1.loadMaterial && t1.loadMaterial(e);
                            });
                            break;
                        case "texture":
                            i = this._invokeOne(function(t1) {
                                return t1.loadTexture && t1.loadTexture(e);
                            });
                            break;
                        case "skin":
                            i = this.loadSkin(e);
                            break;
                        case "animation":
                            i = this._invokeOne(function(t1) {
                                return t1.loadAnimation && t1.loadAnimation(e);
                            });
                            break;
                        case "camera":
                            i = this.loadCamera(e);
                            break;
                        default:
                            if (i = this._invokeOne(function(n) {
                                return n != this && n.getDependency && n.getDependency(t1, e);
                            }), !i) throw new Error("Unknown type: " + t1);
                    }
                    this.cache.add(n, i);
                }
                return i;
            }
            getDependencies(t1) {
                let e = this.cache.get(t1);
                if (!e) {
                    const n = this, i = this.json[t1 + ("mesh" === t1 ? "es" : "s")] || [];
                    e = Promise.all(i.map(function(e, i) {
                        return n.getDependency(t1, i);
                    })), this.cache.add(t1, e);
                }
                return e;
            }
            loadBuffer(t1) {
                const e = this.json.buffers[t1], n = this.fileLoader;
                if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
                if (void 0 === e.uri && 0 === t1) return Promise.resolve(this.extensions[Iy.KHR_BINARY_GLTF].body);
                const i = this.options;
                return new Promise(function(t1, r) {
                    n.load(GA.resolveURL(e.uri, i.path), t1, void 0, function() {
                        r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
                    });
                });
            }
            loadBufferView(t1) {
                const e = this.json.bufferViews[t1];
                return this.getDependency("buffer", e.buffer).then(function(t1) {
                    const n = e.byteLength || 0, i = e.byteOffset || 0;
                    return t1.slice(i, i + n);
                });
            }
            loadAccessor(t1) {
                const e = this, n = this.json, i = this.json.accessors[t1];
                if (void 0 === i.bufferView && void 0 === i.sparse) {
                    const t1 = iM[i.type], e = tM[i.componentType], n = !0 === i.normalized, r = new e(i.count * t1);
                    return Promise.resolve(new cu(r, t1, n));
                }
                const r = [];
                return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function(t1) {
                    const r = t1[0], a = iM[i.type], s = tM[i.componentType], o = s.BYTES_PER_ELEMENT, l = o * a, c = i.byteOffset || 0, u = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0, h = !0 === i.normalized;
                    let d, p;
                    if (u && u !== l) {
                        const t1 = Math.floor(c / u), n = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + t1 + ":" + i.count;
                        let l = e.cache.get(n);
                        l || (d = new s(r, t1 * u, i.count * u / o), l = new Jp(d, u / o), e.cache.add(n, l)), p = new $p(l, a, c % u / o, h);
                    } else d = null === r ? new s(i.count * a) : new s(r, c, i.count * a), p = new cu(d, a, h);
                    if (void 0 !== i.sparse) {
                        const e = iM.SCALAR, n = tM[i.sparse.indices.componentType], o = i.sparse.indices.byteOffset || 0, l = i.sparse.values.byteOffset || 0, c = new n(t1[1], o, i.sparse.count * e), u = new s(t1[2], l, i.sparse.count * a);
                        null !== r && (p = new cu(p.array.slice(), p.itemSize, p.normalized));
                        for(let t1 = 0, e = c.length; t1 < e; t1++){
                            const e = c[t1];
                            if (p.setX(e, u[t1 * a]), a >= 2 && p.setY(e, u[t1 * a + 1]), a >= 3 && p.setZ(e, u[t1 * a + 2]), a >= 4 && p.setW(e, u[t1 * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                        }
                    }
                    return p;
                });
            }
            loadTexture(t1) {
                const e = this.json, n = this.options, i = e.textures[t1].source, r = e.images[i];
                let a = this.textureLoader;
                if (r.uri) {
                    const t1 = n.manager.getHandler(r.uri);
                    null !== t1 && (a = t1);
                }
                return this.loadTextureImage(t1, i, a);
            }
            loadTextureImage(t1, e, n) {
                const i = this, r = this.json, a = r.textures[t1], s = r.images[e], o = (s.uri || s.bufferView) + ":" + a.sampler;
                if (this.textureCache[o]) return this.textureCache[o];
                const l = this.loadImageSource(e, n).then(function(e) {
                    e.flipY = !1, e.name = a.name || s.name || "", "" === e.name && "string" == typeof s.uri && !1 === s.uri.startsWith("data:image/") && (e.name = s.uri);
                    const n = (r.samplers || {})[a.sampler] || {};
                    return e.magFilter = eM[n.magFilter] || Ma, e.minFilter = eM[n.minFilter] || wa, e.wrapS = nM[n.wrapS] || da, e.wrapT = nM[n.wrapT] || da, i.associations.set(e, {
                        textures: t1
                    }), e;
                }).catch(function() {
                    return null;
                });
                return this.textureCache[o] = l, l;
            }
            loadImageSource(t1, e) {
                const n = this.json, i = this.options;
                if (void 0 !== this.sourceCache[t1]) return this.sourceCache[t1].then((t1)=>t1.clone());
                const r = n.images[t1], a = self.URL || self.webkitURL;
                let s = r.uri || "", o = !1;
                if (void 0 !== r.bufferView) s = this.getDependency("bufferView", r.bufferView).then(function(t1) {
                    o = !0;
                    const e = new Blob([
                        t1
                    ], {
                        type: r.mimeType
                    });
                    return s = a.createObjectURL(e), s;
                });
                else if (void 0 === r.uri) throw new Error("THREE.GLTFLoader: Image " + t1 + " is missing URI and bufferView");
                const l = Promise.resolve(s).then(function(t1) {
                    return new Promise(function(n, r) {
                        let a = n;
                        !0 === e.isImageBitmapLoader && (a = function(t1) {
                            const e = new wl(t1);
                            e.needsUpdate = !0, n(e);
                        }), e.load(GA.resolveURL(t1, i.path), a, void 0, r);
                    });
                }).then(function(t1) {
                    var e;
                    return !0 === o && a.revokeObjectURL(s), t1.userData.mimeType = r.mimeType || ((e = r.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), t1;
                }).catch(function(t1) {
                    throw console.error("THREE.GLTFLoader: Couldn't load texture", s), t1;
                });
                return this.sourceCache[t1] = l, l;
            }
            assignTexture(t1, e, n, i) {
                const r = this;
                return this.getDependency("texture", n.index).then(function(a) {
                    if (!a) return null;
                    if (void 0 !== n.texCoord && n.texCoord > 0 && ((a = a.clone()).channel = n.texCoord), r.extensions[Iy.KHR_TEXTURE_TRANSFORM]) {
                        const t1 = void 0 !== n.extensions ? n.extensions[Iy.KHR_TEXTURE_TRANSFORM] : void 0;
                        if (t1) {
                            const e = r.associations.get(a);
                            a = r.extensions[Iy.KHR_TEXTURE_TRANSFORM].extendTexture(a, t1), r.associations.set(a, e);
                        }
                    }
                    return void 0 !== i && (a.colorSpace = i), t1[e] = a, a;
                });
            }
            assignFinalMaterial(t1) {
                const e = t1.geometry;
                let n = t1.material;
                const i = void 0 === e.attributes.tangent, r = void 0 !== e.attributes.color, a = void 0 === e.attributes.normal;
                if (t1.isPoints) {
                    const t1 = "PointsMaterial:" + n.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new em, tu.prototype.copy.call(e, n), e.color.copy(n.color), e.map = n.map, e.sizeAttenuation = !1, this.cache.add(t1, e)), n = e;
                } else if (t1.isLine) {
                    const t1 = "LineBasicMaterial:" + n.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new Qf, tu.prototype.copy.call(e, n), e.color.copy(n.color), e.map = n.map, this.cache.add(t1, e)), n = e;
                }
                if (i || r || a) {
                    let t1 = "ClonedMaterial:" + n.uuid + ":";
                    i && (t1 += "derivative-tangents:"), r && (t1 += "vertex-colors:"), a && (t1 += "flat-shading:");
                    let e = this.cache.get(t1);
                    e || (e = n.clone(), r && (e.vertexColors = !0), a && (e.flatShading = !0), i && (e.normalScale && (e.normalScale.y *= -1), e.clearcoatNormalScale && (e.clearcoatNormalScale.y *= -1)), this.cache.add(t1, e), this.associations.set(e, this.associations.get(n))), n = e;
                }
                t1.material = n;
            }
            getMaterialType() {
                return kg;
            }
            loadMaterial(t1) {
                const e = this, n = this.json, i = this.extensions, r = n.materials[t1];
                let a;
                const s = {}, o = [];
                if ((r.extensions || {})[Iy.KHR_MATERIALS_UNLIT]) {
                    const t1 = i[Iy.KHR_MATERIALS_UNLIT];
                    a = t1.getMaterialType(), o.push(t1.extendParams(s, r, e));
                } else {
                    const n = r.pbrMetallicRoughness || {};
                    if (s.color = new Jc(1, 1, 1), s.opacity = 1, Array.isArray(n.baseColorFactor)) {
                        const t1 = n.baseColorFactor;
                        s.color.setRGB(t1[0], t1[1], t1[2], Xs), s.opacity = t1[3];
                    }
                    void 0 !== n.baseColorTexture && o.push(e.assignTexture(s, "map", n.baseColorTexture, Ws)), s.metalness = void 0 !== n.metallicFactor ? n.metallicFactor : 1, s.roughness = void 0 !== n.roughnessFactor ? n.roughnessFactor : 1, void 0 !== n.metallicRoughnessTexture && (o.push(e.assignTexture(s, "metalnessMap", n.metallicRoughnessTexture)), o.push(e.assignTexture(s, "roughnessMap", n.metallicRoughnessTexture))), a = this._invokeOne(function(e) {
                        return e.getMaterialType && e.getMaterialType(t1);
                    }), o.push(Promise.all(this._invokeAll(function(e) {
                        return e.extendMaterialParams && e.extendMaterialParams(t1, s);
                    })));
                }
                !0 === r.doubleSided && (s.side = pr);
                const l = r.alphaMode || "OPAQUE";
                if ("BLEND" === l ? (s.transparent = !0, s.depthWrite = !1) : (s.transparent = !1, "MASK" === l && (s.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && a !== eu && (o.push(e.assignTexture(s, "normalMap", r.normalTexture)), s.normalScale = new tl(1, 1), void 0 !== r.normalTexture.scale)) {
                    const t1 = r.normalTexture.scale;
                    s.normalScale.set(t1, t1);
                }
                if (void 0 !== r.occlusionTexture && a !== eu && (o.push(e.assignTexture(s, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (s.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && a !== eu) {
                    const t1 = r.emissiveFactor;
                    s.emissive = (new Jc).setRGB(t1[0], t1[1], t1[2], Xs);
                }
                return void 0 !== r.emissiveTexture && a !== eu && o.push(e.assignTexture(s, "emissiveMap", r.emissiveTexture, Ws)), Promise.all(o).then(function() {
                    const n = new a(s);
                    return r.name && (n.name = r.name), lM(n, r), e.associations.set(n, {
                        materials: t1
                    }), r.extensions && oM(i, n, r), n;
                });
            }
            createUniqueName(t1) {
                const e = Tv.sanitizeNodeName(t1 || "");
                return e in this.nodeNamesUsed ? e + "_" + ++this.nodeNamesUsed[e] : (this.nodeNamesUsed[e] = 0, e);
            }
            loadGeometries(t1) {
                const e = this, n = this.extensions, i = this.primitiveCache;
                function r(t1) {
                    return n[Iy.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t1, e).then(function(n) {
                        return mM(n, t1, e);
                    });
                }
                const a = [];
                for(let n = 0, s = t1.length; n < s; n++){
                    const s = t1[n], o = uM(s), l = i[o];
                    if (l) a.push(l.promise);
                    else {
                        let t1;
                        t1 = s.extensions && s.extensions[Iy.KHR_DRACO_MESH_COMPRESSION] ? r(s) : mM(new Tu, s, e), i[o] = {
                            primitive: s,
                            promise: t1
                        }, a.push(t1);
                    }
                }
                return Promise.all(a);
            }
            loadMesh(t1) {
                const e = this, n = this.json, i = this.extensions, r = n.meshes[t1], a = r.primitives, s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = void 0 === a[t1].material ? (void 0 === (o = this.cache).DefaultMaterial && (o.DefaultMaterial = new kg({
                        color: 16777215,
                        emissive: 0,
                        metalness: 1,
                        roughness: 1,
                        transparent: !1,
                        depthTest: !0,
                        side: hr
                    })), o.DefaultMaterial) : this.getDependency("material", a[t1].material);
                    s.push(e);
                }
                var o;
                return s.push(e.loadGeometries(a)), Promise.all(s).then(function(n) {
                    const s = n.slice(0, n.length - 1), o = n[n.length - 1], l = [];
                    for(let n = 0, c = o.length; n < c; n++){
                        const c = o[n], u = a[n];
                        let h;
                        const d = s[n];
                        if (u.mode === $y.TRIANGLES || u.mode === $y.TRIANGLE_STRIP || u.mode === $y.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new Cf(c, d) : new Gu(c, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === $y.TRIANGLE_STRIP ? h.geometry = Ey(h.geometry, Us) : u.mode === $y.TRIANGLE_FAN && (h.geometry = Ey(h.geometry, ks));
                        else if (u.mode === $y.LINES) h = new $f(c, d);
                        else if (u.mode === $y.LINE_STRIP) h = new qf(c, d);
                        else if (u.mode === $y.LINE_LOOP) h = new tm(c, d);
                        else {
                            if (u.mode !== $y.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                            h = new sm(c, d);
                        }
                        Object.keys(h.geometry.morphAttributes).length > 0 && cM(h, r), h.name = e.createUniqueName(r.name || "mesh_" + t1), lM(h, r), u.extensions && oM(i, h, u), e.assignFinalMaterial(h), l.push(h);
                    }
                    for(let n = 0, i = l.length; n < i; n++)e.associations.set(l[n], {
                        meshes: t1,
                        primitives: n
                    });
                    if (1 === l.length) return r.extensions && oM(i, l[0], r), l[0];
                    const c = new Bp;
                    r.extensions && oM(i, c, r), e.associations.set(c, {
                        meshes: t1
                    });
                    for(let t1 = 0, e = l.length; t1 < e; t1++)c.add(l[t1]);
                    return c;
                });
            }
            loadCamera(t1) {
                let e;
                const n = this.json.cameras[t1], i = n[n.type];
                if (i) return "perspective" === n.type ? e = new th($o.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (e = new Eh(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (e.name = this.createUniqueName(n.name)), lM(e, n), Promise.resolve(e);
                console.warn("THREE.GLTFLoader: Missing camera parameters.");
            }
            loadSkin(t1) {
                const e = this.json.skins[t1], n = [];
                for(let t1 = 0, i = e.joints.length; t1 < i; t1++)n.push(this._loadNodeShallow(e.joints[t1]));
                return void 0 !== e.inverseBindMatrices ? n.push(this.getDependency("accessor", e.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(t1) {
                    const n = t1.pop(), i = t1, r = [], a = [];
                    for(let t1 = 0, s = i.length; t1 < s; t1++){
                        const s = i[t1];
                        if (s) {
                            r.push(s);
                            const e = new cc;
                            null !== n && e.fromArray(n.array, 16 * t1), a.push(e);
                        } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[t1]);
                    }
                    return new Rf(r, a);
                });
            }
            loadAnimation(t1) {
                const e = this.json, n = this, i = e.animations[t1], r = i.name ? i.name : "animation_" + t1, a = [], s = [], o = [], l = [], c = [];
                for(let t1 = 0, e = i.channels.length; t1 < e; t1++){
                    const e = i.channels[t1], n = i.samplers[e.sampler], r = e.target, u = r.node, h = void 0 !== i.parameters ? i.parameters[n.input] : n.input, d = void 0 !== i.parameters ? i.parameters[n.output] : n.output;
                    void 0 !== r.node && (a.push(this.getDependency("node", u)), s.push(this.getDependency("accessor", h)), o.push(this.getDependency("accessor", d)), l.push(n), c.push(r));
                }
                return Promise.all([
                    Promise.all(a),
                    Promise.all(s),
                    Promise.all(o),
                    Promise.all(l),
                    Promise.all(c)
                ]).then(function(t1) {
                    const e = t1[0], i = t1[1], a = t1[2], s = t1[3], o = t1[4], l = [];
                    for(let t1 = 0, r = e.length; t1 < r; t1++){
                        const r = e[t1], c = i[t1], u = a[t1], h = s[t1], d = o[t1];
                        if (void 0 === r) continue;
                        r.updateMatrix && r.updateMatrix();
                        const p = n._createAnimationTracks(r, c, u, h, d);
                        if (p) for(let t1 = 0; t1 < p.length; t1++)l.push(p[t1]);
                    }
                    return new uA(r, void 0, l);
                });
            }
            createNodeMesh(t1) {
                const e = this.json, n = this, i = e.nodes[t1];
                return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function(t1) {
                    const e = n._getNodeRef(n.meshCache, i.mesh, t1);
                    return void 0 !== i.weights && e.traverse(function(t1) {
                        if (t1.isMesh) for(let e = 0, n = i.weights.length; e < n; e++)t1.morphTargetInfluences[e] = i.weights[e];
                    }), e;
                });
            }
            loadNode(t1) {
                const e = this, n = this.json.nodes[t1], i = e._loadNodeShallow(t1), r = [], a = n.children || [];
                for(let t1 = 0, n = a.length; t1 < n; t1++)r.push(e.getDependency("node", a[t1]));
                const s = void 0 === n.skin ? Promise.resolve(null) : e.getDependency("skin", n.skin);
                return Promise.all([
                    i,
                    Promise.all(r),
                    s
                ]).then(function(t1) {
                    const e = t1[0], n = t1[1], i = t1[2];
                    null !== i && e.traverse(function(t1) {
                        t1.isSkinnedMesh && t1.bind(i, pM);
                    });
                    for(let t1 = 0, i = n.length; t1 < i; t1++)e.add(n[t1]);
                    return e;
                });
            }
            _loadNodeShallow(t1) {
                const e = this.json, n = this.extensions, i = this;
                if (void 0 !== this.nodeCache[t1]) return this.nodeCache[t1];
                const r = e.nodes[t1], a = r.name ? i.createUniqueName(r.name) : "", s = [], o = i._invokeOne(function(e) {
                    return e.createNodeMesh && e.createNodeMesh(t1);
                });
                return o && s.push(o), void 0 !== r.camera && s.push(i.getDependency("camera", r.camera).then(function(t1) {
                    return i._getNodeRef(i.cameraCache, r.camera, t1);
                })), i._invokeAll(function(e) {
                    return e.createNodeAttachment && e.createNodeAttachment(t1);
                }).forEach(function(t1) {
                    s.push(t1);
                }), this.nodeCache[t1] = Promise.all(s).then(function(e) {
                    let s;
                    if (s = !0 === r.isBone ? new Nf : e.length > 1 ? new Bp : 1 === e.length ? e[0] : new Rc, s !== e[0]) for(let t1 = 0, n = e.length; t1 < n; t1++)s.add(e[t1]);
                    if (r.name && (s.userData.name = r.name, s.name = a), lM(s, r), r.extensions && oM(n, s, r), void 0 !== r.matrix) {
                        const t1 = new cc;
                        t1.fromArray(r.matrix), s.applyMatrix4(t1);
                    } else void 0 !== r.translation && s.position.fromArray(r.translation), void 0 !== r.rotation && s.quaternion.fromArray(r.rotation), void 0 !== r.scale && s.scale.fromArray(r.scale);
                    return i.associations.has(s) || i.associations.set(s, {}), i.associations.get(s).nodes = t1, s;
                }), this.nodeCache[t1];
            }
            loadScene(t1) {
                const e = this.extensions, n = this.json.scenes[t1], i = this, r = new Bp;
                n.name && (r.name = i.createUniqueName(n.name)), lM(r, n), n.extensions && oM(e, r, n);
                const a = n.nodes || [], s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++)s.push(i.getDependency("node", a[t1]));
                return Promise.all(s).then(function(t1) {
                    for(let e = 0, n = t1.length; e < n; e++)r.add(t1[e]);
                    return i.associations = ((t1)=>{
                        const e = new Map;
                        for (const [t1, n] of i.associations)(t1 instanceof tu || t1 instanceof wl) && e.set(t1, n);
                        return t1.traverse((t1)=>{
                            const n = i.associations.get(t1);
                            null != n && e.set(t1, n);
                        }), e;
                    })(r), r;
                });
            }
            _createAnimationTracks(t1, e, n, i, r) {
                const a = [], s = t1.name ? t1.name : t1.uuid, o = [];
                let l;
                switch(aM[r.path] === aM.weights ? t1.traverse(function(t1) {
                    t1.morphTargetInfluences && o.push(t1.name ? t1.name : t1.uuid);
                }) : o.push(s), aM[r.path]){
                    case aM.weights:
                        l = aA;
                        break;
                    case aM.rotation:
                        l = oA;
                        break;
                    case aM.position:
                    case aM.scale:
                        l = cA;
                        break;
                    default:
                        l = 1 === n.itemSize ? aA : cA;
                }
                const c = void 0 !== i.interpolation ? sM[i.interpolation] : Cs, u = this._getArrayFromAccessor(n);
                for(let t1 = 0, n = o.length; t1 < n; t1++){
                    const n = new l(o[t1] + "." + aM[r.path], e.array, u, c);
                    "CUBICSPLINE" === i.interpolation && this._createCubicSplineTrackInterpolant(n), a.push(n);
                }
                return a;
            }
            _getArrayFromAccessor(t1) {
                let e = t1.array;
                if (t1.normalized) {
                    const t1 = dM(e.constructor), n = new Float32Array(e.length);
                    for(let i = 0, r = e.length; i < r; i++)n[i] = e[i] * t1;
                    e = n;
                }
                return e;
            }
            _createCubicSplineTrackInterpolant(t1) {
                t1.createInterpolant = function(t1) {
                    return new (this instanceof oA ? Ky : qy)(this.times, this.values, this.getValueSize() / 3, t1);
                }, t1.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
            }
        }
        function mM(t1, e, n) {
            const i = e.attributes, r = [];
            function a(e, i) {
                return n.getDependency("accessor", e).then(function(e) {
                    t1.setAttribute(i, e);
                });
            }
            for(const e in i){
                const n = rM[e] || e.toLowerCase();
                n in t1.attributes || r.push(a(i[e], n));
            }
            if (void 0 !== e.indices && !t1.index) {
                const i = n.getDependency("accessor", e.indices).then(function(e) {
                    t1.setIndex(e);
                });
                r.push(i);
            }
            return fl.workingColorSpace !== Xs && "COLOR_0" in i && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${fl.workingColorSpace}" not supported.`), lM(t1, e), function(t1, e, n) {
                const i = e.attributes, r = new zl;
                if (void 0 === i.POSITION) return;
                {
                    const t1 = n.json.accessors[i.POSITION], e = t1.min, a = t1.max;
                    if (void 0 === e || void 0 === a) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                    if (r.set(new Ol(e[0], e[1], e[2]), new Ol(a[0], a[1], a[2])), t1.normalized) {
                        const e = dM(tM[t1.componentType]);
                        r.min.multiplyScalar(e), r.max.multiplyScalar(e);
                    }
                }
                const a = e.targets;
                if (void 0 !== a) {
                    const t1 = new Ol, e = new Ol;
                    for(let i = 0, r = a.length; i < r; i++){
                        const r = a[i];
                        if (void 0 !== r.POSITION) {
                            const i = n.json.accessors[r.POSITION], a = i.min, s = i.max;
                            if (void 0 !== a && void 0 !== s) {
                                if (e.setX(Math.max(Math.abs(a[0]), Math.abs(s[0]))), e.setY(Math.max(Math.abs(a[1]), Math.abs(s[1]))), e.setZ(Math.max(Math.abs(a[2]), Math.abs(s[2]))), i.normalized) {
                                    const t1 = dM(tM[i.componentType]);
                                    e.multiplyScalar(t1);
                                }
                                t1.max(e);
                            } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                        }
                    }
                    r.expandByVector(t1);
                }
                t1.boundingBox = r;
                const s = new tc;
                r.getCenter(s.center), s.radius = r.min.distanceTo(r.max) / 2, t1.boundingSphere = s;
            }(t1, e, n), Promise.all(r).then(function() {
                return void 0 !== e.targets ? function(t1, e, n) {
                    let i = !1, r = !1, a = !1;
                    for(let t1 = 0, n = e.length; t1 < n; t1++){
                        const n = e[t1];
                        if (void 0 !== n.POSITION && (i = !0), void 0 !== n.NORMAL && (r = !0), void 0 !== n.COLOR_0 && (a = !0), i && r && a) break;
                    }
                    if (!i && !r && !a) return Promise.resolve(t1);
                    const s = [], o = [], l = [];
                    for(let c = 0, u = e.length; c < u; c++){
                        const u = e[c];
                        if (i) {
                            const e = void 0 !== u.POSITION ? n.getDependency("accessor", u.POSITION) : t1.attributes.position;
                            s.push(e);
                        }
                        if (r) {
                            const e = void 0 !== u.NORMAL ? n.getDependency("accessor", u.NORMAL) : t1.attributes.normal;
                            o.push(e);
                        }
                        if (a) {
                            const e = void 0 !== u.COLOR_0 ? n.getDependency("accessor", u.COLOR_0) : t1.attributes.color;
                            l.push(e);
                        }
                    }
                    return Promise.all([
                        Promise.all(s),
                        Promise.all(o),
                        Promise.all(l)
                    ]).then(function(e) {
                        const n = e[0], s = e[1], o = e[2];
                        return i && (t1.morphAttributes.position = n), r && (t1.morphAttributes.normal = s), a && (t1.morphAttributes.color = o), t1.morphTargetsRelative = !0, t1;
                    });
                }(t1, e.targets, n) : t1;
            });
        }
        const gM = {
            Handedness: Object.freeze({
                NONE: "none",
                LEFT: "left",
                RIGHT: "right"
            }),
            ComponentState: Object.freeze({
                DEFAULT: "default",
                TOUCHED: "touched",
                PRESSED: "pressed"
            }),
            ComponentProperty: Object.freeze({
                BUTTON: "button",
                X_AXIS: "xAxis",
                Y_AXIS: "yAxis",
                STATE: "state"
            }),
            ComponentType: Object.freeze({
                TRIGGER: "trigger",
                SQUEEZE: "squeeze",
                TOUCHPAD: "touchpad",
                THUMBSTICK: "thumbstick",
                BUTTON: "button"
            }),
            ButtonTouchThreshold: .05,
            AxisTouchThreshold: .1,
            VisualResponseProperty: Object.freeze({
                TRANSFORM: "transform",
                VISIBILITY: "visibility"
            })
        };
        async function AM(t1) {
            const e = await fetch(t1);
            if (e.ok) return e.json();
            throw new Error(e.statusText);
        }
        const vM = {
            xAxis: 0,
            yAxis: 0,
            button: 0,
            state: gM.ComponentState.DEFAULT
        };
        class yM {
            constructor(t1){
                this.componentProperty = t1.componentProperty, this.states = t1.states, this.valueNodeName = t1.valueNodeName, this.valueNodeProperty = t1.valueNodeProperty, this.valueNodeProperty === gM.VisualResponseProperty.TRANSFORM && (this.minNodeName = t1.minNodeName, this.maxNodeName = t1.maxNodeName), this.value = 0, this.updateFromComponent(vM);
            }
            updateFromComponent({ xAxis: t1, yAxis: e, button: n, state: i }) {
                const { normalizedXAxis: r, normalizedYAxis: a } = function(t1 = 0, e = 0) {
                    let n = t1, i = e;
                    if (Math.sqrt(t1 * t1 + e * e) > 1) {
                        const r = Math.atan2(e, t1);
                        n = Math.cos(r), i = Math.sin(r);
                    }
                    return {
                        normalizedXAxis: .5 * n + .5,
                        normalizedYAxis: .5 * i + .5
                    };
                }(t1, e);
                switch(this.componentProperty){
                    case gM.ComponentProperty.X_AXIS:
                        this.value = this.states.includes(i) ? r : .5;
                        break;
                    case gM.ComponentProperty.Y_AXIS:
                        this.value = this.states.includes(i) ? a : .5;
                        break;
                    case gM.ComponentProperty.BUTTON:
                        this.value = this.states.includes(i) ? n : 0;
                        break;
                    case gM.ComponentProperty.STATE:
                        this.valueNodeProperty === gM.VisualResponseProperty.VISIBILITY ? this.value = this.states.includes(i) : this.value = this.states.includes(i) ? 1 : 0;
                        break;
                    default:
                        throw new Error(`Unexpected visualResponse componentProperty ${this.componentProperty}`);
                }
            }
        }
        class MM {
            constructor(t1, e){
                if (!(t1 && e && e.visualResponses && e.gamepadIndices && 0 !== Object.keys(e.gamepadIndices).length)) throw new Error("Invalid arguments supplied");
                this.id = t1, this.type = e.type, this.rootNodeName = e.rootNodeName, this.touchPointNodeName = e.touchPointNodeName, this.visualResponses = {}, Object.keys(e.visualResponses).forEach((t1)=>{
                    const n = new yM(e.visualResponses[t1]);
                    this.visualResponses[t1] = n;
                }), this.gamepadIndices = Object.assign({}, e.gamepadIndices), this.values = {
                    state: gM.ComponentState.DEFAULT,
                    button: void 0 !== this.gamepadIndices.button ? 0 : void 0,
                    xAxis: void 0 !== this.gamepadIndices.xAxis ? 0 : void 0,
                    yAxis: void 0 !== this.gamepadIndices.yAxis ? 0 : void 0
                };
            }
            get data() {
                return {
                    id: this.id,
                    ...this.values
                };
            }
            updateFromGamepad(t1) {
                if (this.values.state = gM.ComponentState.DEFAULT, void 0 !== this.gamepadIndices.button && t1.buttons.length > this.gamepadIndices.button) {
                    const e = t1.buttons[this.gamepadIndices.button];
                    this.values.button = e.value, this.values.button = this.values.button < 0 ? 0 : this.values.button, this.values.button = this.values.button > 1 ? 1 : this.values.button, e.pressed || 1 === this.values.button ? this.values.state = gM.ComponentState.PRESSED : (e.touched || this.values.button > gM.ButtonTouchThreshold) && (this.values.state = gM.ComponentState.TOUCHED);
                }
                void 0 !== this.gamepadIndices.xAxis && t1.axes.length > this.gamepadIndices.xAxis && (this.values.xAxis = t1.axes[this.gamepadIndices.xAxis], this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis, this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis, this.values.state === gM.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > gM.AxisTouchThreshold && (this.values.state = gM.ComponentState.TOUCHED)), void 0 !== this.gamepadIndices.yAxis && t1.axes.length > this.gamepadIndices.yAxis && (this.values.yAxis = t1.axes[this.gamepadIndices.yAxis], this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis, this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis, this.values.state === gM.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > gM.AxisTouchThreshold && (this.values.state = gM.ComponentState.TOUCHED)), Object.values(this.visualResponses).forEach((t1)=>{
                    t1.updateFromComponent(this.values);
                });
            }
        }
        class bM {
            constructor(t1, e, n){
                if (!t1) throw new Error("No xrInputSource supplied");
                if (!e) throw new Error("No profile supplied");
                this.xrInputSource = t1, this.assetUrl = n, this.id = e.profileId, this.layoutDescription = e.layouts[t1.handedness], this.components = {}, Object.keys(this.layoutDescription.components).forEach((t1)=>{
                    const e = this.layoutDescription.components[t1];
                    this.components[t1] = new MM(t1, e);
                }), this.updateFromGamepad();
            }
            get gripSpace() {
                return this.xrInputSource.gripSpace;
            }
            get targetRaySpace() {
                return this.xrInputSource.targetRaySpace;
            }
            get data() {
                const t1 = [];
                return Object.values(this.components).forEach((e)=>{
                    t1.push(e.data);
                }), t1;
            }
            updateFromGamepad() {
                Object.values(this.components).forEach((t1)=>{
                    t1.updateFromGamepad(this.xrInputSource.gamepad);
                });
            }
        }
        class xM extends Rc {
            constructor(){
                super(), this.motionController = null, this.envMap = null;
            }
            setEnvironmentMap(t1) {
                return this.envMap == t1 || (this.envMap = t1, this.traverse((t1)=>{
                    t1.isMesh && (t1.material.envMap = this.envMap, t1.material.needsUpdate = !0);
                })), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && (this.motionController.updateFromGamepad(), Object.values(this.motionController.components).forEach((t1)=>{
                    Object.values(t1.visualResponses).forEach((t1)=>{
                        const { valueNode: e, minNode: n, maxNode: i, value: r, valueNodeProperty: a } = t1;
                        e && (a === gM.VisualResponseProperty.VISIBILITY ? e.visible = r : a === gM.VisualResponseProperty.TRANSFORM && (e.quaternion.slerpQuaternions(n.quaternion, i.quaternion, r), e.position.lerpVectors(n.position, i.position, r)));
                    });
                }));
            }
        }
        function wM(t1, e) {
            !function(t1, e) {
                Object.values(t1.components).forEach((t1)=>{
                    const { type: n, touchPointNodeName: i, visualResponses: r } = t1;
                    if (n === gM.ComponentType.TOUCHPAD) {
                        if (t1.touchPointNode = e.getObjectByName(i), t1.touchPointNode) {
                            const e = new Ig(.001), n = new eu({
                                color: 255
                            }), i = new Gu(e, n);
                            t1.touchPointNode.add(i);
                        } else console.warn(`Could not find touch dot, ${t1.touchPointNodeName}, in touchpad component ${t1.id}`);
                    }
                    Object.values(r).forEach((t1)=>{
                        const { valueNodeName: n, minNodeName: i, maxNodeName: r, valueNodeProperty: a } = t1;
                        if (a === gM.VisualResponseProperty.TRANSFORM) {
                            if (t1.minNode = e.getObjectByName(i), t1.maxNode = e.getObjectByName(r), !t1.minNode) return void console.warn(`Could not find ${i} in the model`);
                            if (!t1.maxNode) return void console.warn(`Could not find ${r} in the model`);
                        }
                        t1.valueNode = e.getObjectByName(n), t1.valueNode || console.warn(`Could not find ${n} in the model`);
                    });
                });
            }(t1.motionController, e), t1.envMap && e.traverse((e)=>{
                e.isMesh && (e.material.envMap = t1.envMap, e.material.needsUpdate = !0);
            }), t1.add(e);
        }
        class _M {
            constructor(t1 = null){
                this.gltfLoader = t1, this.path = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles", this._assetCache = {}, this.gltfLoader || (this.gltfLoader = new Sy);
            }
            createControllerModel(t1) {
                const e = new xM;
                let n = null;
                return t1.addEventListener("connected", (t1)=>{
                    const i = t1.data;
                    "tracked-pointer" === i.targetRayMode && i.gamepad && (async function(t1, e, n = null, i = !0) {
                        if (!t1) throw new Error("No xrInputSource supplied");
                        if (!e) throw new Error("No basePath supplied");
                        const r = await async function(t1) {
                            if (!t1) throw new Error("No basePath supplied");
                            return await AM(`${t1}/profilesList.json`);
                        }(e);
                        let a;
                        if (t1.profiles.some((t1)=>{
                            const n = r[t1];
                            return n && (a = {
                                profileId: t1,
                                profilePath: `${e}/${n.path}`,
                                deprecated: !!n.deprecated
                            }), !!a;
                        }), !a) {
                            if (!n) throw new Error("No matching profile name found");
                            const t1 = r[n];
                            if (!t1) throw new Error(`No matching profile name found and default profile "${n}" missing.`);
                            a = {
                                profileId: n,
                                profilePath: `${e}/${t1.path}`,
                                deprecated: !!t1.deprecated
                            };
                        }
                        const s = await AM(a.profilePath);
                        let o;
                        if (i) {
                            let e;
                            if (e = "any" === t1.handedness ? s.layouts[Object.keys(s.layouts)[0]] : s.layouts[t1.handedness], !e) throw new Error(`No matching handedness, ${t1.handedness}, in profile ${a.profileId}`);
                            e.assetPath && (o = a.profilePath.replace("profile.json", e.assetPath));
                        }
                        return {
                            profile: s,
                            assetPath: o
                        };
                    })(i, this.path, "generic-trigger").then(({ profile: t1, assetPath: r })=>{
                        e.motionController = new bM(i, t1, r);
                        const a = this._assetCache[e.motionController.assetUrl];
                        if (a) n = a.scene.clone(), wM(e, n);
                        else {
                            if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                            this.gltfLoader.setPath(""), this.gltfLoader.load(e.motionController.assetUrl, (t1)=>{
                                this._assetCache[e.motionController.assetUrl] = t1, n = t1.scene.clone(), wM(e, n);
                            }, null, ()=>{
                                throw new Error(`Asset ${e.motionController.assetUrl} missing or malformed.`);
                            });
                        }
                    }).catch((t1)=>{
                        console.warn(t1);
                    });
                }), t1.addEventListener("disconnected", ()=>{
                    e.motionController = null, e.remove(n), n = null;
                }), e;
            }
        }
        const EM = new cc, SM = new Ol;
        class TM {
            constructor(t1, e, n, i, r){
                let a;
                this.controller = e, this.handModel = t1, this.envMap = null, r && r.primitive && "sphere" !== r.primitive ? "box" === r.primitive && (a = new Xu(1, 1, 1)) : a = new Ig(1, 10, 10);
                const s = new kg;
                this.handMesh = new Vf(a, s, 30), this.handMesh.frustumCulled = !1, this.handMesh.instanceMatrix.setUsage(So), this.handMesh.castShadow = !0, this.handMesh.receiveShadow = !0, this.handModel.add(this.handMesh), this.joints = [
                    "wrist",
                    "thumb-metacarpal",
                    "thumb-phalanx-proximal",
                    "thumb-phalanx-distal",
                    "thumb-tip",
                    "index-finger-metacarpal",
                    "index-finger-phalanx-proximal",
                    "index-finger-phalanx-intermediate",
                    "index-finger-phalanx-distal",
                    "index-finger-tip",
                    "middle-finger-metacarpal",
                    "middle-finger-phalanx-proximal",
                    "middle-finger-phalanx-intermediate",
                    "middle-finger-phalanx-distal",
                    "middle-finger-tip",
                    "ring-finger-metacarpal",
                    "ring-finger-phalanx-proximal",
                    "ring-finger-phalanx-intermediate",
                    "ring-finger-phalanx-distal",
                    "ring-finger-tip",
                    "pinky-finger-metacarpal",
                    "pinky-finger-phalanx-proximal",
                    "pinky-finger-phalanx-intermediate",
                    "pinky-finger-phalanx-distal",
                    "pinky-finger-tip"
                ];
            }
            updateMesh() {
                const t1 = this.controller.joints;
                let e = 0;
                for(let n = 0; n < this.joints.length; n++){
                    const i = t1[this.joints[n]];
                    i.visible && (SM.setScalar(i.jointRadius || .008), EM.compose(i.position, i.quaternion, SM), this.handMesh.setMatrixAt(n, EM), e++);
                }
                this.handMesh.count = e, this.handMesh.instanceMatrix.needsUpdate = !0;
            }
        }
        class IM {
            constructor(t1, e, n, i, r = null){
                this.controller = e, this.handModel = t1, this.bones = [], null === r && (r = new Sy).setPath(n || "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/"), r.load(`${i}.glb`, (t1)=>{
                    const e = t1.scene.children[0];
                    this.handModel.add(e);
                    const n = e.getObjectByProperty("type", "SkinnedMesh");
                    n.frustumCulled = !1, n.castShadow = !0, n.receiveShadow = !0, [
                        "wrist",
                        "thumb-metacarpal",
                        "thumb-phalanx-proximal",
                        "thumb-phalanx-distal",
                        "thumb-tip",
                        "index-finger-metacarpal",
                        "index-finger-phalanx-proximal",
                        "index-finger-phalanx-intermediate",
                        "index-finger-phalanx-distal",
                        "index-finger-tip",
                        "middle-finger-metacarpal",
                        "middle-finger-phalanx-proximal",
                        "middle-finger-phalanx-intermediate",
                        "middle-finger-phalanx-distal",
                        "middle-finger-tip",
                        "ring-finger-metacarpal",
                        "ring-finger-phalanx-proximal",
                        "ring-finger-phalanx-intermediate",
                        "ring-finger-phalanx-distal",
                        "ring-finger-tip",
                        "pinky-finger-metacarpal",
                        "pinky-finger-phalanx-proximal",
                        "pinky-finger-phalanx-intermediate",
                        "pinky-finger-phalanx-distal",
                        "pinky-finger-tip"
                    ].forEach((t1)=>{
                        const n = e.getObjectByName(t1);
                        void 0 !== n ? n.jointName = t1 : console.warn(`Couldn't find ${t1} in ${i} hand mesh`), this.bones.push(n);
                    });
                });
            }
            updateMesh() {
                const t1 = this.controller.joints;
                for(let e = 0; e < this.bones.length; e++){
                    const n = this.bones[e];
                    if (n) {
                        const e = t1[n.jointName];
                        if (e.visible) {
                            const t1 = e.position;
                            n.position.copy(t1), n.quaternion.copy(e.quaternion);
                        }
                    }
                }
            }
        }
        class CM extends Rc {
            constructor(t1){
                super(), this.controller = t1, this.motionController = null, this.envMap = null, this.mesh = null;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && this.motionController.updateMesh();
            }
        }
        class NM {
            constructor(){
                this.path = null;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            createHandModel(t1, e) {
                const n = new CM(t1);
                return t1.addEventListener("connected", (i)=>{
                    const r = i.data;
                    r.hand && !n.motionController && (n.xrInputSource = r, void 0 === e || "spheres" === e ? n.motionController = new TM(n, t1, this.path, r.handedness, {
                        primitive: "sphere"
                    }) : "boxes" === e ? n.motionController = new TM(n, t1, this.path, r.handedness, {
                        primitive: "box"
                    }) : "mesh" === e && (n.motionController = new IM(n, t1, this.path, r.handedness))), t1.visible = !0;
                }), t1.addEventListener("disconnected", ()=>{
                    t1.visible = !1;
                }), n;
            }
        }
        function DM(t1) {
            return Math.sqrt(Math.pow(t1[1][0] - t1[0][0], 2) + Math.pow(t1[1][1] - t1[0][1], 2));
        }
        var LM = function(t1) {
            return URL.createObjectURL(new Blob([
                t1
            ], {
                type: "text/javascript"
            }));
        };
        try {
            URL.revokeObjectURL(LM(""));
        } catch (t1) {
            LM = function(t1) {
                return "data:application/javascript;charset=UTF-8," + encodeURI(t1);
            };
        }
        var OM = Uint8Array, RM = Uint16Array, PM = Uint32Array, zM = new OM([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), UM = new OM([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), kM = new OM([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), BM = function(t1, e) {
            for(var n = new RM(31), i = 0; i < 31; ++i)n[i] = e += 1 << t1[i - 1];
            var r = new PM(n[30]);
            for(i = 1; i < 30; ++i)for(var a = n[i]; a < n[i + 1]; ++a)r[a] = a - n[i] << 5 | i;
            return [
                n,
                r
            ];
        }, jM = BM(zM, 2), FM = jM[0], HM = jM[1];
        FM[28] = 258, HM[258] = 28;
        for(var VM = BM(UM, 0), QM = VM[0], GM = (VM[1], new RM(32768)), WM = 0; WM < 32768; ++WM){
            var XM = (43690 & WM) >>> 1 | (21845 & WM) << 1;
            XM = (61680 & (XM = (52428 & XM) >>> 2 | (13107 & XM) << 2)) >>> 4 | (3855 & XM) << 4, GM[WM] = ((65280 & XM) >>> 8 | (255 & XM) << 8) >>> 1;
        }
        var YM = function(t1, e, n) {
            for(var i = t1.length, r = 0, a = new RM(e); r < i; ++r)++a[t1[r] - 1];
            var s, o = new RM(e);
            for(r = 0; r < e; ++r)o[r] = o[r - 1] + a[r - 1] << 1;
            if (n) {
                s = new RM(1 << e);
                var l = 15 - e;
                for(r = 0; r < i; ++r)if (t1[r]) for(var c = r << 4 | t1[r], u = e - t1[r], h = o[t1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[GM[h] >>> l] = c;
            } else for(s = new RM(i), r = 0; r < i; ++r)t1[r] && (s[r] = GM[o[t1[r] - 1]++] >>> 15 - t1[r]);
            return s;
        }, ZM = new OM(288);
        for(WM = 0; WM < 144; ++WM)ZM[WM] = 8;
        for(WM = 144; WM < 256; ++WM)ZM[WM] = 9;
        for(WM = 256; WM < 280; ++WM)ZM[WM] = 7;
        for(WM = 280; WM < 288; ++WM)ZM[WM] = 8;
        var qM = new OM(32);
        for(WM = 0; WM < 32; ++WM)qM[WM] = 5;
        var JM = YM(ZM, 9, 1), KM = YM(qM, 5, 1), $M = function(t1) {
            for(var e = t1[0], n = 1; n < t1.length; ++n)t1[n] > e && (e = t1[n]);
            return e;
        }, tb = function(t1, e, n) {
            var i = e / 8 | 0;
            return (t1[i] | t1[i + 1] << 8) >> (7 & e) & n;
        }, eb = function(t1, e) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8 | t1[n + 2] << 16) >> (7 & e);
        }, nb = function(t1, e, n) {
            var i = t1.length;
            if (!i || n && !n.l && i < 5) return e || new OM(0);
            var r = !e || n, a = !n || n.i;
            n || (n = {}), e || (e = new OM(3 * i));
            var s, o = function(t1) {
                var n = e.length;
                if (t1 > n) {
                    var i = new OM(Math.max(2 * n, t1));
                    i.set(e), e = i;
                }
            }, l = n.f || 0, c = n.p || 0, u = n.b || 0, h = n.l, d = n.d, p = n.m, f = n.n, m = 8 * i;
            do {
                if (!h) {
                    n.f = l = tb(t1, c, 1);
                    var g = tb(t1, c + 1, 3);
                    if (c += 3, !g) {
                        var A = t1[s = c, (I = (s / 8 | 0) + (7 & s && 1) + 4) - 4] | t1[I - 3] << 8, v = I + A;
                        if (v > i) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + A), e.set(t1.subarray(I, v), u), n.b = u += A, n.p = c = 8 * v;
                        continue;
                    }
                    if (1 == g) h = JM, d = KM, p = 9, f = 5;
                    else {
                        if (2 != g) throw "invalid block type";
                        var y = tb(t1, c, 31) + 257, M = tb(t1, c + 10, 15) + 4, b = y + tb(t1, c + 5, 31) + 1;
                        c += 14;
                        for(var x = new OM(b), w = new OM(19), _ = 0; _ < M; ++_)w[kM[_]] = tb(t1, c + 3 * _, 7);
                        c += 3 * M;
                        var E = $M(w), S = (1 << E) - 1, T = YM(w, E, 1);
                        for(_ = 0; _ < b;){
                            var I, C = T[tb(t1, c, S)];
                            if (c += 15 & C, (I = C >>> 4) < 16) x[_++] = I;
                            else {
                                var N = 0, D = 0;
                                for(16 == I ? (D = 3 + tb(t1, c, 3), c += 2, N = x[_ - 1]) : 17 == I ? (D = 3 + tb(t1, c, 7), c += 3) : 18 == I && (D = 11 + tb(t1, c, 127), c += 7); D--;)x[_++] = N;
                            }
                        }
                        var L = x.subarray(0, y), O = x.subarray(y);
                        p = $M(L), f = $M(O), h = YM(L, p, 1), d = YM(O, f, 1);
                    }
                    if (c > m) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                }
                r && o(u + 131072);
                for(var R = (1 << p) - 1, P = (1 << f) - 1, z = c;; z = c){
                    var U = (N = h[eb(t1, c) & R]) >>> 4;
                    if ((c += 15 & N) > m) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                    if (!N) throw "invalid length/literal";
                    if (U < 256) e[u++] = U;
                    else {
                        if (256 == U) {
                            z = c, h = null;
                            break;
                        }
                        var k = U - 254;
                        if (U > 264) {
                            var B = zM[_ = U - 257];
                            k = tb(t1, c, (1 << B) - 1) + FM[_], c += B;
                        }
                        var j = d[eb(t1, c) & P], F = j >>> 4;
                        if (!j) throw "invalid distance";
                        if (c += 15 & j, O = QM[F], F > 3 && (B = UM[F], O += eb(t1, c) & (1 << B) - 1, c += B), c > m) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + 131072);
                        for(var H = u + k; u < H; u += 4)e[u] = e[u - O], e[u + 1] = e[u + 1 - O], e[u + 2] = e[u + 2 - O], e[u + 3] = e[u + 3 - O];
                        u = H;
                    }
                }
                n.l = h, n.p = z, n.b = u, h && (l = 1, n.m = p, n.d = d, n.n = f);
            }while (!l);
            return u == e.length ? e : function(t1, e, n) {
                (null == e || e < 0) && (e = 0), (null == n || n > t1.length) && (n = t1.length);
                var i = new (t1 instanceof RM ? RM : t1 instanceof PM ? PM : OM)(n - e);
                return i.set(t1.subarray(e, n)), i;
            }(e, 0, u);
        }, ib = new OM(0);
        function rb(t1, e) {
            return nb((function(t1) {
                if (8 != (15 & t1[0]) || t1[0] >>> 4 > 7 || (t1[0] << 8 | t1[1]) % 31) throw "invalid zlib data";
                if (32 & t1[1]) throw "invalid zlib data: preset dictionaries not supported";
            }(t1), t1.subarray(2, -4)), e);
        }
        var ab = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            ab.decode(ib, {
                stream: !0
            });
        } catch (t1) {}
        class sb extends wA {
            constructor(t1){
                super(t1), this.type = La;
            }
            parse(t1) {
                const e = 65536, n = 14, i = 65537, r = Math.pow(2.7182818, 2.2), a = {
                    l: 0,
                    c: 0,
                    lc: 0
                };
                function s(t1, e, n, i, r) {
                    for(; n < t1;)e = e << 8 | U(i, r), n += 8;
                    n -= t1, a.l = e >> n & (1 << t1) - 1, a.c = e, a.lc = n;
                }
                const o = new Array(59);
                function l(t1) {
                    return 63 & t1;
                }
                function c(t1) {
                    return t1 >> 6;
                }
                const u = {
                    c: 0,
                    lc: 0
                };
                function h(t1, e, n, i) {
                    t1 = t1 << 8 | U(n, i), e += 8, u.c = t1, u.lc = e;
                }
                const d = {
                    c: 0,
                    lc: 0
                };
                function p(t1, e, n, i, r, a, s, o, l) {
                    if (t1 == e) {
                        i < 8 && (h(n, i, r, a), n = u.c, i = u.lc);
                        let t1 = n >> (i -= 8);
                        if (t1 = new Uint8Array([
                            t1
                        ])[0], o.value + t1 > l) return !1;
                        const e = s[o.value - 1];
                        for(; t1-- > 0;)s[o.value++] = e;
                    } else {
                        if (!(o.value < l)) return !1;
                        s[o.value++] = t1;
                    }
                    d.c = n, d.lc = i;
                }
                function f(t1) {
                    return 65535 & t1;
                }
                function m(t1) {
                    const e = f(t1);
                    return e > 32767 ? e - 65536 : e;
                }
                const g = {
                    a: 0,
                    b: 0
                };
                function A(t1, e) {
                    const n = m(t1), i = m(e), r = n + (1 & i) + (i >> 1), a = r, s = r - i;
                    g.a = a, g.b = s;
                }
                function v(t1, e) {
                    const n = f(t1), i = f(e), r = n - (i >> 1) & 65535, a = i + r - 32768 & 65535;
                    g.a = a, g.b = r;
                }
                function y(t1, e, n, i, r, a, s) {
                    const o = s < 16384, l = n > r ? r : n;
                    let c, u, h = 1;
                    for(; h <= l;)h <<= 1;
                    for(h >>= 1, c = h, h >>= 1; h >= 1;){
                        u = 0;
                        const s = u + a * (r - c), l = a * h, d = a * c, p = i * h, f = i * c;
                        let m, y, M, b;
                        for(; u <= s; u += d){
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p, i = r + l, a = i + p;
                                o ? (A(t1[r + e], t1[i + e]), m = g.a, M = g.b, A(t1[n + e], t1[a + e]), y = g.a, b = g.b, A(m, y), t1[r + e] = g.a, t1[n + e] = g.b, A(M, b), t1[i + e] = g.a, t1[a + e] = g.b) : (v(t1[r + e], t1[i + e]), m = g.a, M = g.b, v(t1[n + e], t1[a + e]), y = g.a, b = g.b, v(m, y), t1[r + e] = g.a, t1[n + e] = g.b, v(M, b), t1[i + e] = g.a, t1[a + e] = g.b);
                            }
                            if (n & h) {
                                const n = r + l;
                                o ? A(t1[r + e], t1[n + e]) : v(t1[r + e], t1[n + e]), m = g.a, t1[n + e] = g.b, t1[r + e] = m;
                            }
                        }
                        if (r & h) {
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p;
                                o ? A(t1[r + e], t1[n + e]) : v(t1[r + e], t1[n + e]), m = g.a, t1[n + e] = g.b, t1[r + e] = m;
                            }
                        }
                        c = h, h >>= 1;
                    }
                    return u;
                }
                function M(t1, e, r, f, m, g) {
                    const A = r.value, v = z(e, r), y = z(e, r);
                    r.value += 4;
                    const M = z(e, r);
                    if (r.value += 4, v < 0 || v >= i || y < 0 || y >= i) throw new Error("Something wrong with HUF_ENCSIZE");
                    const b = new Array(i), x = new Array(16384);
                    if (function(t1) {
                        for(let e = 0; e < 16384; e++)t1[e] = {}, t1[e].len = 0, t1[e].lit = 0, t1[e].p = null;
                    }(x), function(t1, e, n, r, l, c) {
                        const u = e;
                        let h = 0, d = 0;
                        for(; r <= l; r++){
                            if (u.value - e.value > n) return !1;
                            s(6, h, d, t1, u);
                            const i = a.l;
                            if (h = a.c, d = a.lc, c[r] = i, 63 == i) {
                                if (u.value - e.value > n) throw new Error("Something wrong with hufUnpackEncTable");
                                s(8, h, d, t1, u);
                                let i = a.l + 6;
                                if (h = a.c, d = a.lc, r + i > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; i--;)c[r++] = 0;
                                r--;
                            } else if (i >= 59) {
                                let t1 = i - 59 + 2;
                                if (r + t1 > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; t1--;)c[r++] = 0;
                                r--;
                            }
                        }
                        !function(t1) {
                            for(let t1 = 0; t1 <= 58; ++t1)o[t1] = 0;
                            for(let e = 0; e < i; ++e)o[t1[e]] += 1;
                            let e = 0;
                            for(let t1 = 58; t1 > 0; --t1){
                                const n = e + o[t1] >> 1;
                                o[t1] = e, e = n;
                            }
                            for(let e = 0; e < i; ++e){
                                const n = t1[e];
                                n > 0 && (t1[e] = n | o[n]++ << 6);
                            }
                        }(c);
                    }(t1, r, f - (r.value - A), v, y, b), M > 8 * (f - (r.value - A))) throw new Error("Something wrong with hufUncompress");
                    !function(t1, e, i, r) {
                        for(; e <= i; e++){
                            const i = c(t1[e]), a = l(t1[e]);
                            if (i >> a) throw new Error("Invalid table entry");
                            if (a > n) {
                                const t1 = r[i >> a - n];
                                if (t1.len) throw new Error("Invalid table entry");
                                if (t1.lit++, t1.p) {
                                    const e = t1.p;
                                    t1.p = new Array(t1.lit);
                                    for(let n = 0; n < t1.lit - 1; ++n)t1.p[n] = e[n];
                                } else t1.p = new Array(1);
                                t1.p[t1.lit - 1] = e;
                            } else if (a) {
                                let t1 = 0;
                                for(let s = 1 << n - a; s > 0; s--){
                                    const s = r[(i << n - a) + t1];
                                    if (s.len || s.p) throw new Error("Invalid table entry");
                                    s.len = a, s.lit = e, t1++;
                                }
                            }
                        }
                    }(b, v, y, x), function(t1, e, i, r, a, s, o, f, m) {
                        let g = 0, A = 0;
                        const v = o, y = Math.trunc(r.value + (a + 7) / 8);
                        for(; r.value < y;)for(h(g, A, i, r), g = u.c, A = u.lc; A >= n;){
                            const a = e[g >> A - n & 16383];
                            if (a.len) A -= a.len, p(a.lit, s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                            else {
                                if (!a.p) throw new Error("hufDecode issues");
                                let e;
                                for(e = 0; e < a.lit; e++){
                                    const n = l(t1[a.p[e]]);
                                    for(; A < n && r.value < y;)h(g, A, i, r), g = u.c, A = u.lc;
                                    if (A >= n && c(t1[a.p[e]]) == (g >> A - n & (1 << n) - 1)) {
                                        A -= n, p(a.p[e], s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                                        break;
                                    }
                                }
                                if (e == a.lit) throw new Error("hufDecode issues");
                            }
                        }
                        const M = 8 - a & 7;
                        for(g >>= M, A -= M; A > 0;){
                            const t1 = e[g << n - A & 16383];
                            if (!t1.len) throw new Error("hufDecode issues");
                            A -= t1.len, p(t1.lit, s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                        }
                    }(b, x, t1, r, M, y, g, m, {
                        value: 0
                    });
                }
                function b(t1) {
                    for(let e = 1; e < t1.length; e++){
                        const n = t1[e - 1] + t1[e] - 128;
                        t1[e] = n;
                    }
                }
                function x(t1, e) {
                    let n = 0, i = Math.floor((t1.length + 1) / 2), r = 0;
                    const a = t1.length - 1;
                    for(; !(r > a || (e[r++] = t1[n++], r > a));)e[r++] = t1[i++];
                }
                function w(t1) {
                    let e = t1.byteLength;
                    const n = new Array;
                    let i = 0;
                    const r = new DataView(t1);
                    for(; e > 0;){
                        const t1 = r.getInt8(i++);
                        if (t1 < 0) {
                            const a = -t1;
                            e -= a + 1;
                            for(let t1 = 0; t1 < a; t1++)n.push(r.getUint8(i++));
                        } else {
                            const a = t1;
                            e -= 2;
                            const s = r.getUint8(i++);
                            for(let t1 = 0; t1 < a + 1; t1++)n.push(s);
                        }
                    }
                    return n;
                }
                function _(t1, e, n) {
                    let i, r = 1;
                    for(; r < 64;)i = e[t1.value], 65280 == i ? r = 64 : i >> 8 == 255 ? r += 255 & i : (n[r] = i, r++), t1.value++;
                }
                function E(t1) {
                    const e = .5 * Math.cos(.7853975), n = .5 * Math.cos(3.14159 / 16), i = .5 * Math.cos(3.14159 / 8), r = .5 * Math.cos(3 * 3.14159 / 16), a = .5 * Math.cos(.981746875), s = .5 * Math.cos(3 * 3.14159 / 8), o = .5 * Math.cos(1.374445625), l = new Array(4), c = new Array(4), u = new Array(4), h = new Array(4);
                    for(let d = 0; d < 8; ++d){
                        const p = 8 * d;
                        l[0] = i * t1[p + 2], l[1] = s * t1[p + 2], l[2] = i * t1[p + 6], l[3] = s * t1[p + 6], c[0] = n * t1[p + 1] + r * t1[p + 3] + a * t1[p + 5] + o * t1[p + 7], c[1] = r * t1[p + 1] - o * t1[p + 3] - n * t1[p + 5] - a * t1[p + 7], c[2] = a * t1[p + 1] - n * t1[p + 3] + o * t1[p + 5] + r * t1[p + 7], c[3] = o * t1[p + 1] - a * t1[p + 3] + r * t1[p + 5] - n * t1[p + 7], u[0] = e * (t1[p + 0] + t1[p + 4]), u[3] = e * (t1[p + 0] - t1[p + 4]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[p + 0] = h[0] + c[0], t1[p + 1] = h[1] + c[1], t1[p + 2] = h[2] + c[2], t1[p + 3] = h[3] + c[3], t1[p + 4] = h[3] - c[3], t1[p + 5] = h[2] - c[2], t1[p + 6] = h[1] - c[1], t1[p + 7] = h[0] - c[0];
                    }
                    for(let d = 0; d < 8; ++d)l[0] = i * t1[16 + d], l[1] = s * t1[16 + d], l[2] = i * t1[48 + d], l[3] = s * t1[48 + d], c[0] = n * t1[8 + d] + r * t1[24 + d] + a * t1[40 + d] + o * t1[56 + d], c[1] = r * t1[8 + d] - o * t1[24 + d] - n * t1[40 + d] - a * t1[56 + d], c[2] = a * t1[8 + d] - n * t1[24 + d] + o * t1[40 + d] + r * t1[56 + d], c[3] = o * t1[8 + d] - a * t1[24 + d] + r * t1[40 + d] - n * t1[56 + d], u[0] = e * (t1[d] + t1[32 + d]), u[3] = e * (t1[d] - t1[32 + d]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[0 + d] = h[0] + c[0], t1[8 + d] = h[1] + c[1], t1[16 + d] = h[2] + c[2], t1[24 + d] = h[3] + c[3], t1[32 + d] = h[3] - c[3], t1[40 + d] = h[2] - c[2], t1[48 + d] = h[1] - c[1], t1[56 + d] = h[0] - c[0];
                }
                function S(t1) {
                    for(let e = 0; e < 64; ++e){
                        const n = t1[0][e], i = t1[1][e], r = t1[2][e];
                        t1[0][e] = n + 1.5747 * r, t1[1][e] = n - .1873 * i - .4682 * r, t1[2][e] = n + 1.8556 * i;
                    }
                }
                function T(t1, e, n) {
                    for(let a = 0; a < 64; ++a)e[n + a] = su.toHalfFloat((i = t1[a]) <= 1 ? Math.sign(i) * Math.pow(Math.abs(i), 2.2) : Math.sign(i) * Math.pow(r, Math.abs(i) - 1));
                    var i;
                }
                function I(t1) {
                    return new DataView(t1.array.buffer, t1.offset.value, t1.size);
                }
                function C(t1) {
                    const e = t1.viewer.buffer.slice(t1.offset.value, t1.offset.value + t1.size), n = new Uint8Array(w(e)), i = new Uint8Array(n.length);
                    return b(n), x(n, i), new DataView(i.buffer);
                }
                function N(t1) {
                    const e = rb(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), n = new Uint8Array(e.length);
                    return b(e), x(e, n), new DataView(n.buffer);
                }
                function D(t1) {
                    const n = t1.viewer, i = {
                        value: t1.offset.value
                    }, r = new Uint16Array(t1.width * t1.scanlineBlockSize * (t1.channels * t1.type)), a = new Uint8Array(8192);
                    let s = 0;
                    const o = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; e++)o[e] = {}, o[e].start = s, o[e].end = o[e].start, o[e].nx = t1.width, o[e].ny = t1.lines, o[e].size = t1.type, s += o[e].nx * o[e].ny * o[e].size;
                    const l = V(n, i), c = V(n, i);
                    if (c >= 8192) throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");
                    if (l <= c) for(let t1 = 0; t1 < c - l + 1; t1++)a[t1 + l] = k(n, i);
                    const u = new Uint16Array(e), h = function(t1, n) {
                        let i = 0;
                        for(let r = 0; r < e; ++r)(0 == r || t1[r >> 3] & 1 << (7 & r)) && (n[i++] = r);
                        const r = i - 1;
                        for(; i < e;)n[i++] = 0;
                        return r;
                    }(a, u), d = z(n, i);
                    M(t1.array, n, i, d, r, s);
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = o[e];
                        for(let n = 0; n < o[e].size; ++n)y(r, t1.start + n, t1.nx, t1.size, t1.ny, t1.nx * t1.size, h);
                    }
                    !function(t1, e, n) {
                        for(let i = 0; i < n; ++i)e[i] = t1[e[i]];
                    }(u, r, s);
                    let p = 0;
                    const f = new Uint8Array(r.buffer.byteLength);
                    for(let e = 0; e < t1.lines; e++)for(let e = 0; e < t1.channels; e++){
                        const t1 = o[e], n = t1.nx * t1.size, i = new Uint8Array(r.buffer, 2 * t1.end, 2 * n);
                        f.set(i, p), p += 2 * n, t1.end += n;
                    }
                    return new DataView(f.buffer);
                }
                function L(t1) {
                    const e = rb(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), n = t1.lines * t1.channels * t1.width, i = 1 == t1.type ? new Uint16Array(n) : new Uint32Array(n);
                    let r = 0, a = 0;
                    const s = new Array(4);
                    for(let n = 0; n < t1.lines; n++)for(let n = 0; n < t1.channels; n++){
                        let n = 0;
                        switch(t1.type){
                            case 1:
                                s[0] = r, s[1] = s[0] + t1.width, r = s[1] + t1.width;
                                for(let r = 0; r < t1.width; ++r)n += e[s[0]++] << 8 | e[s[1]++], i[a] = n, a++;
                                break;
                            case 2:
                                s[0] = r, s[1] = s[0] + t1.width, s[2] = s[1] + t1.width, r = s[2] + t1.width;
                                for(let r = 0; r < t1.width; ++r)n += e[s[0]++] << 24 | e[s[1]++] << 16 | e[s[2]++] << 8, i[a] = n, a++;
                        }
                    }
                    return new DataView(i.buffer);
                }
                function O(t1) {
                    const e = t1.viewer, n = {
                        value: t1.offset.value
                    }, i = new Uint8Array(t1.width * t1.lines * (t1.channels * t1.type * 2)), r = {
                        version: B(e, n),
                        unknownUncompressedSize: B(e, n),
                        unknownCompressedSize: B(e, n),
                        acCompressedSize: B(e, n),
                        dcCompressedSize: B(e, n),
                        rleCompressedSize: B(e, n),
                        rleUncompressedSize: B(e, n),
                        rleRawSize: B(e, n),
                        totalAcUncompressedCount: B(e, n),
                        totalDcUncompressedCount: B(e, n),
                        acCompression: B(e, n)
                    };
                    if (r.version < 2) throw new Error("EXRLoader.parse: " + Z.compression + " version " + r.version + " is unsupported");
                    const a = new Array;
                    let s = V(e, n) - 2;
                    for(; s > 0;){
                        const t1 = R(e.buffer, n), i = k(e, n), r = i >> 2 & 3, o = new Int8Array([
                            (i >> 4) - 1
                        ])[0], l = k(e, n);
                        a.push({
                            name: t1,
                            index: o,
                            type: l,
                            compression: r
                        }), s -= t1.length + 3;
                    }
                    const o = Z.channels, l = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; ++e){
                        const n = l[e] = {}, i = o[e];
                        n.name = i.name, n.compression = 0, n.decoded = !1, n.type = i.pixelType, n.pLinear = i.pLinear, n.width = t1.width, n.height = t1.lines;
                    }
                    const c = {
                        idx: new Array(3)
                    };
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = l[e];
                        for(let n = 0; n < a.length; ++n){
                            const i = a[n];
                            t1.name == i.name && (t1.compression = i.compression, i.index >= 0 && (c.idx[i.index] = e), t1.offset = e);
                        }
                    }
                    let u, h, d;
                    if (r.acCompressedSize > 0) switch(r.acCompression){
                        case 0:
                            u = new Uint16Array(r.totalAcUncompressedCount), M(t1.array, e, n, r.acCompressedSize, u, r.totalAcUncompressedCount);
                            break;
                        case 1:
                            const i1 = rb(t1.array.slice(n.value, n.value + r.totalAcUncompressedCount));
                            u = new Uint16Array(i1.buffer), n.value += r.totalAcUncompressedCount;
                    }
                    if (r.dcCompressedSize > 0) {
                        const e = {
                            array: t1.array,
                            offset: n,
                            size: r.dcCompressedSize
                        };
                        h = new Uint16Array(N(e).buffer), n.value += r.dcCompressedSize;
                    }
                    r.rleRawSize > 0 && (d = w(rb(t1.array.slice(n.value, n.value + r.rleCompressedSize)).buffer), n.value += r.rleCompressedSize);
                    let p = 0;
                    const f = new Array(l.length);
                    for(let t1 = 0; t1 < f.length; ++t1)f[t1] = new Array;
                    for(let e = 0; e < t1.lines; ++e)for(let e = 0; e < l.length; ++e)f[e].push(p), p += l[e].width * t1.type * 2;
                    !function(t1, e, n, i, r, a) {
                        let s = new DataView(a.buffer);
                        const o = n[t1.idx[0]].width, l = n[t1.idx[0]].height, c = Math.floor(o / 8), u = Math.ceil(o / 8), h = Math.ceil(l / 8), d = o - 8 * (u - 1), p = l - 8 * (h - 1), f = {
                            value: 0
                        }, m = new Array(3), g = new Array(3), A = new Array(3), v = new Array(3), y = new Array(3);
                        for(let n = 0; n < 3; ++n)y[n] = e[t1.idx[n]], m[n] = n < 1 ? 0 : m[n - 1] + u * h, g[n] = new Float32Array(64), A[n] = new Uint16Array(64), v[n] = new Uint16Array(64 * u);
                        for(let e = 0; e < h; ++e){
                            let a = 8;
                            e == h - 1 && (a = p);
                            let o = 8;
                            for(let t1 = 0; t1 < u; ++t1){
                                t1 == u - 1 && (o = d);
                                for(let t1 = 0; t1 < 3; ++t1)A[t1].fill(0), A[t1][0] = r[m[t1]++], _(f, i, A[t1]), M = A[t1], (b = g[t1])[0] = H(M[0]), b[1] = H(M[1]), b[2] = H(M[5]), b[3] = H(M[6]), b[4] = H(M[14]), b[5] = H(M[15]), b[6] = H(M[27]), b[7] = H(M[28]), b[8] = H(M[2]), b[9] = H(M[4]), b[10] = H(M[7]), b[11] = H(M[13]), b[12] = H(M[16]), b[13] = H(M[26]), b[14] = H(M[29]), b[15] = H(M[42]), b[16] = H(M[3]), b[17] = H(M[8]), b[18] = H(M[12]), b[19] = H(M[17]), b[20] = H(M[25]), b[21] = H(M[30]), b[22] = H(M[41]), b[23] = H(M[43]), b[24] = H(M[9]), b[25] = H(M[11]), b[26] = H(M[18]), b[27] = H(M[24]), b[28] = H(M[31]), b[29] = H(M[40]), b[30] = H(M[44]), b[31] = H(M[53]), b[32] = H(M[10]), b[33] = H(M[19]), b[34] = H(M[23]), b[35] = H(M[32]), b[36] = H(M[39]), b[37] = H(M[45]), b[38] = H(M[52]), b[39] = H(M[54]), b[40] = H(M[20]), b[41] = H(M[22]), b[42] = H(M[33]), b[43] = H(M[38]), b[44] = H(M[46]), b[45] = H(M[51]), b[46] = H(M[55]), b[47] = H(M[60]), b[48] = H(M[21]), b[49] = H(M[34]), b[50] = H(M[37]), b[51] = H(M[47]), b[52] = H(M[50]), b[53] = H(M[56]), b[54] = H(M[59]), b[55] = H(M[61]), b[56] = H(M[35]), b[57] = H(M[36]), b[58] = H(M[48]), b[59] = H(M[49]), b[60] = H(M[57]), b[61] = H(M[58]), b[62] = H(M[62]), b[63] = H(M[63]), E(g[t1]);
                                S(g);
                                for(let e = 0; e < 3; ++e)T(g[e], v[e], 64 * t1);
                            }
                            let l = 0;
                            for(let i = 0; i < 3; ++i){
                                const r = n[t1.idx[i]].type;
                                for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    l = y[i][t1];
                                    for(let e = 0; e < c; ++e){
                                        const n = 64 * e + 8 * (7 & t1);
                                        s.setUint16(l + 0 * r, v[i][n + 0], !0), s.setUint16(l + 2 * r, v[i][n + 1], !0), s.setUint16(l + 4 * r, v[i][n + 2], !0), s.setUint16(l + 6 * r, v[i][n + 3], !0), s.setUint16(l + 8 * r, v[i][n + 4], !0), s.setUint16(l + 10 * r, v[i][n + 5], !0), s.setUint16(l + 12 * r, v[i][n + 6], !0), s.setUint16(l + 14 * r, v[i][n + 7], !0), l += 16 * r;
                                    }
                                }
                                if (c != u) for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    const e = y[i][t1] + 8 * c * 2 * r, n = 64 * c + 8 * (7 & t1);
                                    for(let t1 = 0; t1 < o; ++t1)s.setUint16(e + 2 * t1 * r, v[i][n + t1], !0);
                                }
                            }
                        }
                        var M, b;
                        const x = new Uint16Array(o);
                        s = new DataView(a.buffer);
                        for(let e = 0; e < 3; ++e){
                            n[t1.idx[e]].decoded = !0;
                            const i = n[t1.idx[e]].type;
                            if (2 == n[e].type) for(let t1 = 0; t1 < l; ++t1){
                                const n = y[e][t1];
                                for(let t1 = 0; t1 < o; ++t1)x[t1] = s.getUint16(n + 2 * t1 * i, !0);
                                for(let t1 = 0; t1 < o; ++t1)s.setFloat32(n + 2 * t1 * i, H(x[t1]), !0);
                            }
                        }
                    }(c, f, l, u, h, i);
                    for(let e = 0; e < l.length; ++e){
                        const n = l[e];
                        if (!n.decoded) {
                            if (2 !== n.compression) throw new Error("EXRLoader.parse: unsupported channel compression");
                            {
                                let r = 0, a = 0;
                                for(let s = 0; s < t1.lines; ++s){
                                    let t1 = f[e][r];
                                    for(let e = 0; e < n.width; ++e){
                                        for(let e = 0; e < 2 * n.type; ++e)i[t1++] = d[a + e * n.width * n.height];
                                        a++;
                                    }
                                    r++;
                                }
                            }
                        }
                    }
                    return new DataView(i.buffer);
                }
                function R(t1, e) {
                    const n = new Uint8Array(t1);
                    let i = 0;
                    for(; 0 != n[e.value + i];)i += 1;
                    const r = (new TextDecoder).decode(n.slice(e.value, e.value + i));
                    return e.value = e.value + i + 1, r;
                }
                function P(t1, e) {
                    const n = t1.getInt32(e.value, !0);
                    return e.value = e.value + 4, n;
                }
                function z(t1, e) {
                    const n = t1.getUint32(e.value, !0);
                    return e.value = e.value + 4, n;
                }
                function U(t1, e) {
                    const n = t1[e.value];
                    return e.value = e.value + 1, n;
                }
                function k(t1, e) {
                    const n = t1.getUint8(e.value);
                    return e.value = e.value + 1, n;
                }
                const B = function(t1, e) {
                    let n;
                    return n = "getBigInt64" in DataView.prototype ? Number(t1.getBigInt64(e.value, !0)) : t1.getUint32(e.value + 4, !0) + Number(t1.getUint32(e.value, !0) << 32), e.value += 8, n;
                };
                function j(t1, e) {
                    const n = t1.getFloat32(e.value, !0);
                    return e.value += 4, n;
                }
                function F(t1, e) {
                    return su.toHalfFloat(j(t1, e));
                }
                function H(t1) {
                    const e = (31744 & t1) >> 10, n = 1023 & t1;
                    return (t1 >> 15 ? -1 : 1) * (e ? 31 === e ? n ? NaN : 1 / 0 : Math.pow(2, e - 15) * (1 + n / 1024) : n / 1024 * 6103515625e-14);
                }
                function V(t1, e) {
                    const n = t1.getUint16(e.value, !0);
                    return e.value += 2, n;
                }
                function Q(t1, e) {
                    return H(V(t1, e));
                }
                function G(t1, e, n, i, r) {
                    return "string" === i || "stringvector" === i || "iccProfile" === i ? function(t1, e, n) {
                        const i = (new TextDecoder).decode(new Uint8Array(t1).slice(e.value, e.value + n));
                        return e.value = e.value + n, i;
                    }(e, n, r) : "chlist" === i ? function(t1, e, n, i) {
                        const r = n.value, a = [];
                        for(; n.value < r + i - 1;){
                            const i = R(e, n), r = P(t1, n), s = k(t1, n);
                            n.value += 3;
                            const o = P(t1, n), l = P(t1, n);
                            a.push({
                                name: i,
                                pixelType: r,
                                pLinear: s,
                                xSampling: o,
                                ySampling: l
                            });
                        }
                        return n.value += 1, a;
                    }(t1, e, n, r) : "chromaticities" === i ? function(t1, e) {
                        return {
                            redX: j(t1, e),
                            redY: j(t1, e),
                            greenX: j(t1, e),
                            greenY: j(t1, e),
                            blueX: j(t1, e),
                            blueY: j(t1, e),
                            whiteX: j(t1, e),
                            whiteY: j(t1, e)
                        };
                    }(t1, n) : "compression" === i ? function(t1, e) {
                        return [
                            "NO_COMPRESSION",
                            "RLE_COMPRESSION",
                            "ZIPS_COMPRESSION",
                            "ZIP_COMPRESSION",
                            "PIZ_COMPRESSION",
                            "PXR24_COMPRESSION",
                            "B44_COMPRESSION",
                            "B44A_COMPRESSION",
                            "DWAA_COMPRESSION",
                            "DWAB_COMPRESSION"
                        ][k(t1, e)];
                    }(t1, n) : "box2i" === i ? function(t1, e) {
                        return {
                            xMin: z(t1, e),
                            yMin: z(t1, e),
                            xMax: z(t1, e),
                            yMax: z(t1, e)
                        };
                    }(t1, n) : "lineOrder" === i ? function(t1, e) {
                        return [
                            "INCREASING_Y"
                        ][k(t1, e)];
                    }(t1, n) : "float" === i ? j(t1, n) : "v2f" === i ? function(t1, e) {
                        return [
                            j(t1, e),
                            j(t1, e)
                        ];
                    }(t1, n) : "v3f" === i ? function(t1, e) {
                        return [
                            j(t1, e),
                            j(t1, e),
                            j(t1, e)
                        ];
                    }(t1, n) : "int" === i ? P(t1, n) : "rational" === i ? function(t1, e) {
                        return [
                            P(t1, e),
                            z(t1, e)
                        ];
                    }(t1, n) : "timecode" === i ? function(t1, e) {
                        return [
                            z(t1, e),
                            z(t1, e)
                        ];
                    }(t1, n) : "preview" === i ? (n.value += r, "skipped") : void (n.value += r);
                }
                const W = new DataView(t1), X = new Uint8Array(t1), Y = {
                    value: 0
                }, Z = function(t1, e, n) {
                    const i = {};
                    if (20000630 != t1.getUint32(0, !0)) throw new Error("THREE.EXRLoader: Provided file doesn't appear to be in OpenEXR format.");
                    i.version = t1.getUint8(4);
                    const r = t1.getUint8(5);
                    i.spec = {
                        singleTile: !!(2 & r),
                        longName: !!(4 & r),
                        deepFormat: !!(8 & r),
                        multiPart: !!(16 & r)
                    }, n.value = 8;
                    let a = !0;
                    for(; a;){
                        const r = R(e, n);
                        if (0 == r) a = !1;
                        else {
                            const a = R(e, n), s = G(t1, e, n, a, z(t1, n));
                            void 0 === s ? console.warn(`THREE.EXRLoader: Skipped unknown header attribute type '${a}'.`) : i[r] = s;
                        }
                    }
                    if (-5 & r) throw console.error("THREE.EXRHeader:", i), new Error("THREE.EXRLoader: Provided file is currently unsupported.");
                    return i;
                }(W, t1, Y), q = function(t1, e, n, i, r) {
                    const a = {
                        size: 0,
                        viewer: e,
                        array: n,
                        offset: i,
                        width: t1.dataWindow.xMax - t1.dataWindow.xMin + 1,
                        height: t1.dataWindow.yMax - t1.dataWindow.yMin + 1,
                        channels: t1.channels.length,
                        bytesPerLine: null,
                        lines: null,
                        inputSize: null,
                        type: t1.channels[0].pixelType,
                        uncompress: null,
                        getter: null,
                        format: null,
                        colorSpace: Xs
                    };
                    switch(t1.compression){
                        case "NO_COMPRESSION":
                            a.lines = 1, a.uncompress = I;
                            break;
                        case "RLE_COMPRESSION":
                            a.lines = 1, a.uncompress = C;
                            break;
                        case "ZIPS_COMPRESSION":
                            a.lines = 1, a.uncompress = N;
                            break;
                        case "ZIP_COMPRESSION":
                            a.lines = 16, a.uncompress = N;
                            break;
                        case "PIZ_COMPRESSION":
                            a.lines = 32, a.uncompress = D;
                            break;
                        case "PXR24_COMPRESSION":
                            a.lines = 16, a.uncompress = L;
                            break;
                        case "DWAA_COMPRESSION":
                            a.lines = 32, a.uncompress = O;
                            break;
                        case "DWAB_COMPRESSION":
                            a.lines = 256, a.uncompress = O;
                            break;
                        default:
                            throw new Error("EXRLoader.parse: " + t1.compression + " is unsupported");
                    }
                    if (a.scanlineBlockSize = a.lines, 1 == a.type) switch(r){
                        case Da:
                            a.getter = Q, a.inputSize = 2;
                            break;
                        case La:
                            a.getter = V, a.inputSize = 2;
                    }
                    else {
                        if (2 != a.type) throw new Error("EXRLoader.parse: unsupported pixelType " + a.type + " for " + t1.compression + ".");
                        switch(r){
                            case Da:
                                a.getter = j, a.inputSize = 4;
                                break;
                            case La:
                                a.getter = F, a.inputSize = 4;
                        }
                    }
                    a.blockCount = (t1.dataWindow.yMax + 1) / a.scanlineBlockSize;
                    for(let t1 = 0; t1 < a.blockCount; t1++)B(e, i);
                    a.outputChannels = 3 == a.channels ? 4 : a.channels;
                    const s = a.width * a.height * a.outputChannels;
                    switch(r){
                        case Da:
                            a.byteArray = new Float32Array(s), a.channels < a.outputChannels && a.byteArray.fill(1, 0, s);
                            break;
                        case La:
                            a.byteArray = new Uint16Array(s), a.channels < a.outputChannels && a.byteArray.fill(15360, 0, s);
                            break;
                        default:
                            console.error("THREE.EXRLoader: unsupported type: ", r);
                    }
                    return a.bytesPerLine = a.width * a.inputSize * a.channels, 4 == a.outputChannels ? (a.format = Ua, a.colorSpace = Xs) : (a.format = Ha, a.colorSpace = Gs), a;
                }(Z, W, X, Y, this.type), J = {
                    value: 0
                }, K = {
                    R: 0,
                    G: 1,
                    B: 2,
                    A: 3,
                    Y: 0
                };
                for(let t1 = 0; t1 < q.height / q.scanlineBlockSize; t1++){
                    const e = z(W, Y);
                    q.size = z(W, Y), q.lines = e + q.scanlineBlockSize > q.height ? q.height - e : q.scanlineBlockSize;
                    const n = q.size < q.lines * q.bytesPerLine ? q.uncompress(q) : I(q);
                    Y.value += q.size;
                    for(let e = 0; e < q.scanlineBlockSize; e++){
                        const i = e + t1 * q.scanlineBlockSize;
                        if (i >= q.height) break;
                        for(let t1 = 0; t1 < q.channels; t1++){
                            const r = K[Z.channels[t1].name];
                            for(let a = 0; a < q.width; a++){
                                J.value = (e * (q.channels * q.width) + t1 * q.width + a) * q.inputSize;
                                const s = (q.height - 1 - i) * (q.width * q.outputChannels) + a * q.outputChannels + r;
                                q.byteArray[s] = q.getter(n, J);
                            }
                        }
                    }
                }
                return {
                    header: Z,
                    width: q.width,
                    height: q.height,
                    data: q.byteArray,
                    format: q.format,
                    colorSpace: q.colorSpace,
                    type: this.type
                };
            }
            setDataType(t1) {
                return this.type = t1, this;
            }
            load(t1, e, n, i) {
                return super.load(t1, function(t1, n) {
                    t1.colorSpace = n.colorSpace, t1.minFilter = Ma, t1.magFilter = Ma, t1.generateMipmaps = !1, t1.flipY = !1, e && e(t1, n);
                }, n, i);
            }
        }
        const ob = (t1)=>{
            const e = new wl(t1);
            return e.center = new tl(.5, .5), e.colorSpace = Ws, e.minFilter = _a, e.magFilter = Ma, e.needsUpdate = !0, e;
        }, lb = (t1, e, n)=>t1.find((t1)=>t1.ID === e).Vertices.map((t1)=>{
                const e = n.find((e)=>e.ID === t1);
                return [
                    e.Location.X,
                    e.Location.Y
                ];
            }), cb = (t1, e)=>{
            const { Rooms: n } = t1.Floors[Vi.currentFloorIndex].Units[0];
            return n.find((t1)=>{
                let { ID: n } = t1;
                return n === e;
            }) || null;
        }, ub = (t1, e)=>{
            const { CameraPoints: n } = t1.Floors[Vi.currentFloorIndex];
            return (null == n ? void 0 : n.find((t1)=>{
                let { ID: n } = t1;
                return n === e;
            })) || null;
        }, hb = (t1, e)=>e.reduce((e, n)=>{
                const i = DM([
                    t1,
                    [
                        n.userData.left,
                        n.userData.top
                    ]
                ]);
                return i < e.length ? {
                    panorama: n,
                    length: i
                } : e;
            }, {
                length: 1 / 0,
                panorama: null
            }), db = async (t1, e)=>await new Promise((n)=>{
                const i = setInterval(()=>{
                    if (e < 0 && t1.opacity <= 0 || e > 0 && t1.opacity >= 1) return clearInterval(i), n();
                    t1.opacity += e;
                }, 1);
            }), pb = async (t1)=>await db(t1, -0.01), fb = async (t1)=>await db(t1, .01), mb = (t1)=>$o.DEG2RAD * t1, gb = (t1)=>$o.RAD2DEG * t1, Ab = async (t1)=>{
            const e = new sb;
            return e.type = Da, new Promise((n)=>{
                e.load(t1, (t1, e)=>n(e));
            });
        }, vb = async (t1)=>{
            const e = await (new _A).loadAsync(t1);
            return e.center = new tl(.5, .5), e.colorSpace = Ws, e.minFilter = _a, e.magFilter = Ma, e.anisotropy = 8, e;
        }, yb = (t1, e, n)=>{
            const { data: i, width: r, height: a } = n, s = i.length / a, o = (Math.round(a - e * a) - 1) * s + 4 * Math.round(t1 * r);
            return {
                R: i[o],
                G: i[o + 1],
                B: i[o + 2],
                A: i[o + 3]
            };
        }, Mb = (t1, e, n)=>{
            const i = t1.clone().sub(e).normalize(), r = t1.clone().sub(n).normalize();
            return i.cross(r);
        };
        function bb(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const xb = class extends Bp {
            constructor(t1, e){
                super(), bb(this, "_tempPointer", new tl), bb(this, "_raycaster", new Uv), bb(this, "_tempMatrix", new cc), bb(this, "_pointer", new tl), bb(this, "deepChildren", []), bb(this, "_hoverElement", void 0), bb(this, "controller1", void 0), bb(this, "controller2", void 0), bb(this, "_renderer", void 0), bb(this, "_camera", void 0), bb(this, "updateDeepChildren", ()=>{
                    const t1 = [];
                    this.traverse((e)=>{
                        e.interactive && t1.push(e);
                    }, []), this.deepChildren = t1;
                }), this._camera = e, this._renderer = t1, this._renderer.domElement.addEventListener("pointermove", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("pointerdown", this.onPointerDown.bind(this)), this._renderer.domElement.addEventListener("pointerup", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("mousemove", this.onPointerEvent.bind(this)), this.controller1 = this.createController(0), this.controller2 = this.createController(1);
            }
            get hover() {
                return this._pointer.hover || this.controller1.hover || this.controller2.hover;
            }
            get cursor() {
                return this._pointer._hoverElement ? this._pointer._hoverElement.isDoor ? "url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNTE4XzkzMikiPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4yNzU0IDYuMjI5MjFDMTAuMjc1NCA1Ljg5OTg2IDEwLjQ4ODIgNS42MDgzMyAxMC44MDE4IDUuNTA4MkwyNy4wNjM3IDAuMzE1MDE0QzI3LjU1MTYgMC4xNTkxOTEgMjguMDUgMC41MjM1MTIgMjguMDUgMS4wMzYwMlY0OC45OTY4QzI4LjA1IDQ5LjQ4NDQgMjcuNTk1OCA0OS44NDQ4IDI3LjEyMTMgNDkuNzMzN0wxMC44NTk0IDQ1LjkyNTNDMTAuNTE3MyA0NS44NDUzIDEwLjI3NTQgNDUuNTQgMTAuMjc1NCA0NS4xODg1VjYuMjI5MjFaTTI1LjQwMjcgMjYuMTEwOEMyNC45ODUgMjYuMTEwOCAyNC42NDY0IDI1Ljc3MiAyNC42NDY0IDI1LjM1NFYyNC4yMTg4QzI0LjY0NjQgMjMuODAwOCAyNC45ODUgMjMuNDYxOSAyNS40MDI3IDIzLjQ2MTlDMjUuODIwNSAyMy40NjE5IDI2LjE1OTEgMjMuODAwOCAyNi4xNTkxIDI0LjIxODhWMjUuMzU0QzI2LjE1OTEgMjUuNzcyIDI1LjgyMDUgMjYuMTEwOCAyNS40MDI3IDI2LjExMDhaTTMwLjY5NzMgNS4yOTc4OEMzMC42OTczIDUuNzE1ODggMzEuMDM1OSA2LjA1NDcyIDMxLjQ1MzYgNi4wNTQ3MkgzOC4yNjA5QzM4LjY3ODcgNi4wNTQ3MiAzOS4wMTczIDYuMzkzNTcgMzkuMDE3MyA2LjgxMTU2VjQzLjg5NjVDMzkuMDE3MyA0NC4zMTQ1IDM4LjY3ODcgNDQuNjUzMyAzOC4yNjA5IDQ0LjY1MzNIMzEuNDUzNkMzMS4wMzU5IDQ0LjY1MzMgMzAuNjk3MyA0NC45OTIyIDMwLjY5NzMgNDUuNDEwMkMzMC42OTczIDQ1LjgyODIgMzEuMDM1OSA0Ni4xNjcgMzEuNDUzNiA0Ni4xNjdIMzkuNzczN0M0MC4xOTE0IDQ2LjE2NyA0MC41MyA0NS44MjgyIDQwLjUzIDQ1LjQxMDJWNS4yOTc4OEM0MC41MyA0Ljg3OTkgNDAuMTkxNCA0LjU0MTA1IDM5Ljc3MzcgNC41NDEwNUgzMS40NTM2QzMxLjAzNTkgNC41NDEwNSAzMC42OTczIDQuODc5OSAzMC42OTczIDUuMjk3ODhaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9nPg0KPGRlZnM+DQo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE1MThfOTMyIj4NCjxyZWN0IHdpZHRoPSIzNi45NjI5IiBoZWlnaHQ9IjQ5Ljk1MTIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU0Mjk3KSIvPg0KPC9jbGlwUGF0aD4NCjwvZGVmcz4NCjwvc3ZnPg0K", ") 25 25, pointer") : "pointer" : "";
            }
            add() {
                super.add(...arguments), this.updateDeepChildren();
            }
            createControllerLine(t1) {
                const e = new Im(new Ol(0, 0, 0), new Ol(0, 0, -500)), n = new Lg(e, 100, .002, 100, !1), i = new kg({
                    color: new Jc(16777215),
                    side: pr
                }), r = new Gu(n, i);
                return r.isVrControllerLine = !0, r.defaultDistance = 500, r.renderOrder = 7, t1.distanceLine = r, t1.add(r), r;
            }
            createControllerCircle(t1) {
                const e = document.createElement("canvas"), n = e.getContext("2d");
                e.width = 128, e.height = 128, n.beginPath(), n.arc(e.width / 2, e.height / 2, e.width / 4, 0, 2 * Math.PI, !1), n.strokeStyle = "rgba(255, 255, 255, 1)", n.fillStyle = "rgba(20, 20, 20, 0.26)", n.lineWidth = 10, n.fill(), n.stroke();
                const i = ob(e), r = new tf({
                    color: new Jc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    side: pr,
                    map: i,
                    opacity: 1
                }), a = new mf(r);
                return a.isVrControllerCircle = !0, a.scale.setScalar(.05), a.renderOrder = 7, t1.distanceCircle = a, t1.add(a), a;
            }
            createController(t1) {
                const e = this._renderer.xr.getController(t1);
                e.isVrController = !0, this.createControllerLine(e), this.createControllerCircle(e);
                const n = new _M, i = new NM, r = this._renderer.xr.getControllerGrip(t1);
                r.add(n.createControllerModel(r)), r.isVrControllerGrip = !0;
                const a = this._renderer.xr.getHand(t1);
                return a.add(i.createHandModel(a, "mesh")), a.isVrHand = !0, e.addEventListener("move", this.onXRControllerEvent.bind(this)), e.addEventListener("select", this.onXRControllerEvent.bind(this)), this.add(e, r, a), e;
            }
            getIntersections() {
                return this._raycaster.intersectObjects(this.deepChildren, !1).filter((t1)=>t1.object.visible && t1.object.parent).sort((t1, e)=>t1.object.isLinkSphere ? 1 : -1);
            }
            onPointerDown(t1) {
                let { clientX: e, clientY: n } = t1;
                this._tempPointer.x = Number(e.toFixed(0)), this._tempPointer.y = Number(n.toFixed(0));
            }
            onPointerEvent(t1) {
                var e;
                const n = Math.abs(this._tempPointer.x - Number(t1.clientX.toFixed(0))) < 10, i = Math.abs(this._tempPointer.y - Number(t1.clientY.toFixed(0))) < 10, r = "pointerup" === t1.type ? "click" : t1.type;
                if (!("click" !== r || n && i)) return;
                const a = this._renderer.domElement.getBoundingClientRect();
                this._pointer.x = (t1.clientX - a.left) / a.width * 2 - 1, this._pointer.y = -(t1.clientY - a.top) / a.height * 2 + 1, this._raycaster.setFromCamera(this._pointer, this._camera);
                const s = this.getIntersections();
                s.length > 0 && this.onIntersection(s, r, this._pointer) || (null === (e = this._pointer._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: null
                }), this._pointer._hoverElement = null, this._pointer.hover = !1);
            }
            onXRControllerEvent(t1) {
                var e;
                const n = {
                    move: "mousemove",
                    select: "click"
                }, i = t1.target;
                this._tempMatrix.identity().extractRotation(i.matrixWorld), this._raycaster.ray.origin.setFromMatrixPosition(i.matrixWorld), this._raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this._tempMatrix);
                const r = this.getIntersections();
                r.length > 0 && this.onIntersection(r, n[t1.type], i) ? i.distanceCircle.material.depthTest = !1 : (i.distanceCircle.material.depthTest = !0, this.updateControllerPointer(i, 500), null === (e = i._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: i
                }), i._hoverElement = null, i.hover = !1);
            }
            onIntersection(t1, e, n) {
                this.deepChildren.forEach((e)=>{
                    if (!e.isLinkSphere) return;
                    const i = t1.some((t1)=>t1.object.uuid === e.uuid);
                    e.dispatchEvent({
                        type: i ? "hoverstart" : "hoverend",
                        controller: n
                    });
                });
                const i = t1[0];
                if (!i) return null;
                const { object: r } = i, a = {
                    x: i.uv.x,
                    y: 1 - i.uv.y
                };
                return r.dispatchEvent({
                    type: "hoverstart",
                    data: a,
                    controller: n
                }), r.dispatchEvent({
                    type: e,
                    data: a,
                    controller: n
                }), n && n.isVrController && this.updateControllerPointer(n, i.distance), n._hoverElement && n._hoverElement.uuid !== r.uuid && n._hoverElement.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = r, n.hover = !0, r;
            }
            updateControllerPointer(t1, e) {
                t1.distanceCircle.position.z = -e;
                const n = e / t1.distanceLine.defaultDistance;
                t1.distanceLine.scale.set(1, 1, n);
            }
        }, wb = [
            "StraightStair_01",
            "StraightStairWithTurn_01",
            "HelicalStair_01",
            "QuarterLandingStair_01",
            "HalfLandingStair_01"
        ];
        var _b = n(232), Eb = n.n(_b);
        function Sb(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        dn({
            useProxies: "never"
        });
        const Tb = "granted", Ib = new class {
            constructor(){
                Sb(this, "parser", null), Sb(this, "deviceOrientationStatus", "denied"), Sb(this, "setDeviceOrientationStatus", (t1)=>(this.deviceOrientationStatus = t1, t1)), Sb(this, "requestDeviceOrientation", async ()=>{
                    try {
                        return DeviceOrientationEvent.requestPermission ? await DeviceOrientationEvent.requestPermission().then((t1)=>this.setDeviceOrientationStatus(t1)) : this.setDeviceOrientationStatus(Tb);
                    } catch (t1) {
                        console.log(t1);
                    }
                }), On(this), this.parser = new (Eb());
            }
            get device() {
                return this.parser.getDevice();
            }
            get isMobile() {
                return "mobile" === this.device.type;
            }
            get isTablet() {
                return "tablet" === this.device.type;
            }
            get isMobileDevice() {
                return this.isMobile || this.isTablet;
            }
            get deviceOrientationGranted() {
                return this.deviceOrientationStatus === Tb;
            }
        };
        function Cb(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const Nb = class extends Gu {
            constructor(t1){
                super(), Cb(this, "interactive", !0), Cb(this, "_visible", !0), Cb(this, "isDoor", !0), this.userData = t1, this.position.copy(t1.position), this.rotation.copy(t1.rotation), this.renderOrder = 3, this.visible = !1, this.createGeometry(), this.createMaterial(), this.createSprite(), this.onHoverEnd(), this.addEventListeners();
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.sprite && (this.sprite.visible = t1 ? Ib.isMobileDevice : t1);
            }
            createGeometry() {
                return this.geometry = new fh(this.userData.width, this.userData.height, 10, 10), this;
            }
            async createMaterial() {
                const t1 = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    opacity: 0
                });
                return this.material = t1, this;
            }
            async createSprite() {
                return this.sprite = new mf, this.sprite.renderOrder = this.renderOrder + 1, this.sprite.visible = this.visible, this.sprite.interactive = !0, (new _A).loadAsync(this.userData.icon).then((t1)=>{
                    t1.center = new tl(.5, .5), t1.colorSpace = Ws, t1.minFilter = _a, t1.magFilter = Ma, t1.anisotropy = 8, this.sprite.material = new tf({
                        color: new Jc(16777215),
                        sizeAttenuation: !1,
                        transparent: !0,
                        depthTest: !1,
                        side: pr,
                        map: t1,
                        opacity: 1
                    });
                }), this.add(this.sprite), this.sprite;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this.sprite.addEventListener("select", ()=>this.onClick()), this.sprite.addEventListener("click", ()=>this.onClick()), this.sprite.addEventListener("hoverstart", ()=>this.onHoverStart()), this.sprite.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {
                this.sprite.scale.setScalar(this.userData.scale + 20 * this.userData.scale / 100);
            }
            onHoverEnd() {
                this.sprite.scale.setScalar(this.userData.scale);
            }
            onClick() {}
        };
        function Db(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }
        function Lb(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, t1.__proto__ = e;
        }
        var Ob, Rb, Pb, zb, Ub, kb, Bb, jb, Fb, Hb, Vb, Qb, Gb, Wb, Xb, Yb, Zb, qb = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        }, Jb = {
            duration: .5,
            overwrite: !1,
            delay: 0
        }, Kb = 1e8, $b = 1e-8, tx = 2 * Math.PI, ex = tx / 4, nx = 0, ix = Math.sqrt, rx = Math.cos, ax = Math.sin, sx = function(t1) {
            return "string" == typeof t1;
        }, ox = function(t1) {
            return "function" == typeof t1;
        }, lx = function(t1) {
            return "number" == typeof t1;
        }, cx = function(t1) {
            return void 0 === t1;
        }, ux = function(t1) {
            return "object" == typeof t1;
        }, hx = function(t1) {
            return !1 !== t1;
        }, dx = function() {
            return "undefined" != typeof window;
        }, px = function(t1) {
            return ox(t1) || sx(t1);
        }, fx = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}, mx = Array.isArray, gx = /(?:-?\.?\d|\.)+/gi, Ax = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, vx = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, yx = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Mx = /[+-]=-?[.\d]+/, bx = /[^,'"\[\]\s]+/gi, xx = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, wx = {}, _x = {}, Ex = function(t1) {
            return (_x = tw(t1, wx)) && tE;
        }, Sx = function(t1, e) {
            return console.warn("Invalid property", t1, "set to", e, "Missing plugin? gsap.registerPlugin()");
        }, Tx = function(t1, e) {
            return !e && console.warn(t1);
        }, Ix = function(t1, e) {
            return t1 && (wx[t1] = e) && _x && (_x[t1] = e) || wx;
        }, Cx = function() {
            return 0;
        }, Nx = {
            suppressEvents: !0,
            isStart: !0,
            kill: !1
        }, Dx = {
            suppressEvents: !0,
            kill: !1
        }, Lx = {
            suppressEvents: !0
        }, Ox = {}, Rx = [], Px = {}, zx = {}, Ux = {}, kx = 30, Bx = [], jx = "", Fx = function(t1) {
            var e, n, i = t1[0];
            if (ux(i) || ox(i) || (t1 = [
                t1
            ]), !(e = (i._gsap || {}).harness)) {
                for(n = Bx.length; n-- && !Bx[n].targetTest(i););
                e = Bx[n];
            }
            for(n = t1.length; n--;)t1[n] && (t1[n]._gsap || (t1[n]._gsap = new f_(t1[n], e))) || t1.splice(n, 1);
            return t1;
        }, Hx = function(t1) {
            return t1._gsap || Fx(Dw(t1))[0]._gsap;
        }, Vx = function(t1, e, n) {
            return (n = t1[e]) && ox(n) ? t1[e]() : cx(n) && t1.getAttribute && t1.getAttribute(e) || n;
        }, Qx = function(t1, e) {
            return (t1 = t1.split(",")).forEach(e) || t1;
        }, Gx = function(t1) {
            return Math.round(1e5 * t1) / 1e5 || 0;
        }, Wx = function(t1) {
            return Math.round(1e7 * t1) / 1e7 || 0;
        }, Xx = function(t1, e) {
            var n = e.charAt(0), i = parseFloat(e.substr(2));
            return t1 = parseFloat(t1), "+" === n ? t1 + i : "-" === n ? t1 - i : "*" === n ? t1 * i : t1 / i;
        }, Yx = function(t1, e) {
            for(var n = e.length, i = 0; t1.indexOf(e[i]) < 0 && ++i < n;);
            return i < n;
        }, Zx = function() {
            var t1, e, n = Rx.length, i = Rx.slice(0);
            for(Px = {}, Rx.length = 0, t1 = 0; t1 < n; t1++)(e = i[t1]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
        }, qx = function(t1, e, n, i) {
            Rx.length && !Rb && Zx(), t1.render(e, n, i || Rb && e < 0 && (t1._initted || t1._startAt)), Rx.length && !Rb && Zx();
        }, Jx = function(t1) {
            var e = parseFloat(t1);
            return (e || 0 === e) && (t1 + "").match(bx).length < 2 ? e : sx(t1) ? t1.trim() : t1;
        }, Kx = function(t1) {
            return t1;
        }, $x = function(t1, e) {
            for(var n in e)n in t1 || (t1[n] = e[n]);
            return t1;
        }, tw = function(t1, e) {
            for(var n in e)t1[n] = e[n];
            return t1;
        }, ew = function t1(e, n) {
            for(var i in n)"__proto__" !== i && "constructor" !== i && "prototype" !== i && (e[i] = ux(n[i]) ? t1(e[i] || (e[i] = {}), n[i]) : n[i]);
            return e;
        }, nw = function(t1, e) {
            var n, i = {};
            for(n in t1)n in e || (i[n] = t1[n]);
            return i;
        }, iw = function(t1) {
            var e, n = t1.parent || zb, i = t1.keyframes ? (e = mx(t1.keyframes), function(t1, n) {
                for(var i in n)i in t1 || "duration" === i && e || "ease" === i || (t1[i] = n[i]);
            }) : $x;
            if (hx(t1.inherit)) for(; n;)i(t1, n.vars.defaults), n = n.parent || n._dp;
            return t1;
        }, rw = function(t1, e, n, i, r) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var a, s = t1[i];
            if (r) for(a = e[r]; s && s[r] > a;)s = s._prev;
            return s ? (e._next = s._next, s._next = e) : (e._next = t1[n], t1[n] = e), e._next ? e._next._prev = e : t1[i] = e, e._prev = s, e.parent = e._dp = t1, e;
        }, aw = function(t1, e, n, i) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var r = e._prev, a = e._next;
            r ? r._next = a : t1[n] === e && (t1[n] = a), a ? a._prev = r : t1[i] === e && (t1[i] = r), e._next = e._prev = e.parent = null;
        }, sw = function(t1, e) {
            t1.parent && (!e || t1.parent.autoRemoveChildren) && t1.parent.remove && t1.parent.remove(t1), t1._act = 0;
        }, ow = function(t1, e) {
            if (t1 && (!e || e._end > t1._dur || e._start < 0)) for(var n = t1; n;)n._dirty = 1, n = n.parent;
            return t1;
        }, lw = function(t1, e, n, i) {
            return t1._startAt && (Rb ? t1._startAt.revert(Dx) : t1.vars.immediateRender && !t1.vars.autoRevert || t1._startAt.render(e, !0, i));
        }, cw = function t1(e) {
            return !e || e._ts && t1(e.parent);
        }, uw = function(t1) {
            return t1._repeat ? hw(t1._tTime, t1 = t1.duration() + t1._rDelay) * t1 : 0;
        }, hw = function(t1, e) {
            var n = Math.floor(t1 /= e);
            return t1 && n === t1 ? n - 1 : n;
        }, dw = function(t1, e) {
            return (t1 - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
        }, pw = function(t1) {
            return t1._end = Wx(t1._start + (t1._tDur / Math.abs(t1._ts || t1._rts || $b) || 0));
        }, fw = function(t1, e) {
            var n = t1._dp;
            return n && n.smoothChildTiming && t1._ts && (t1._start = Wx(n._time - (t1._ts > 0 ? e / t1._ts : ((t1._dirty ? t1.totalDuration() : t1._tDur) - e) / -t1._ts)), pw(t1), n._dirty || ow(n, t1)), t1;
        }, mw = function(t1, e) {
            var n;
            if ((e._time || !e._dur && e._initted || e._start < t1._time && (e._dur || !e.add)) && (n = dw(t1.rawTime(), e), (!e._dur || Tw(0, e.totalDuration(), n) - e._tTime > $b) && e.render(n, !0)), ow(t1, e)._dp && t1._initted && t1._time >= t1._dur && t1._ts) {
                if (t1._dur < t1.duration()) for(n = t1; n._dp;)n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
                t1._zTime = -0.00000001;
            }
        }, gw = function(t1, e, n, i) {
            return e.parent && sw(e), e._start = Wx((lx(n) ? n : n || t1 !== zb ? _w(t1, n, e) : t1._time) + e._delay), e._end = Wx(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), rw(t1, e, "_first", "_last", t1._sort ? "_start" : 0), Mw(e) || (t1._recent = e), i || mw(t1, e), t1._ts < 0 && fw(t1, t1._tTime), t1;
        }, Aw = function(t1, e) {
            return (wx.ScrollTrigger || Sx("scrollTrigger", e)) && wx.ScrollTrigger.create(e, t1);
        }, vw = function(t1, e, n, i, r) {
            return x_(t1, e, r), t1._initted ? !n && t1._pt && !Rb && (t1._dur && !1 !== t1.vars.lazy || !t1._dur && t1.vars.lazy) && Fb !== e_.frame ? (Rx.push(t1), t1._lazy = [
                r,
                i
            ], 1) : void 0 : 1;
        }, yw = function t1(e) {
            var n = e.parent;
            return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || t1(n));
        }, Mw = function(t1) {
            var e = t1.data;
            return "isFromStart" === e || "isStart" === e;
        }, bw = function(t1, e, n, i) {
            var r = t1._repeat, a = Wx(e) || 0, s = t1._tTime / t1._tDur;
            return s && !i && (t1._time *= a / t1._dur), t1._dur = a, t1._tDur = r ? r < 0 ? 1e10 : Wx(a * (r + 1) + t1._rDelay * r) : a, s > 0 && !i && fw(t1, t1._tTime = t1._tDur * s), t1.parent && pw(t1), n || ow(t1.parent, t1), t1;
        }, xw = function(t1) {
            return t1 instanceof g_ ? ow(t1) : bw(t1, t1._dur);
        }, ww = {
            _start: 0,
            endTime: Cx,
            totalDuration: Cx
        }, _w = function t1(e, n, i) {
            var r, a, s, o = e.labels, l = e._recent || ww, c = e.duration() >= Kb ? l.endTime(!1) : e._dur;
            return sx(n) && (isNaN(n) || n in o) ? (a = n.charAt(0), s = "%" === n.substr(-1), r = n.indexOf("="), "<" === a || ">" === a ? (r >= 0 && (n = n.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (s ? (r < 0 ? l : i).totalDuration() / 100 : 1)) : r < 0 ? (n in o || (o[n] = c), o[n]) : (a = parseFloat(n.charAt(r - 1) + n.substr(r + 1)), s && i && (a = a / 100 * (mx(i) ? i[0] : i).totalDuration()), r > 1 ? t1(e, n.substr(0, r - 1), i) + a : c + a)) : null == n ? c : +n;
        }, Ew = function(t1, e, n) {
            var i, r, a = lx(e[1]), s = (a ? 2 : 1) + (t1 < 2 ? 0 : 1), o = e[s];
            if (a && (o.duration = e[1]), o.parent = n, t1) {
                for(i = o, r = n; r && !("immediateRender" in i);)i = r.vars.defaults || {}, r = hx(r.vars.inherit) && r.parent;
                o.immediateRender = hx(i.immediateRender), t1 < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1];
            }
            return new T_(e[0], o, e[s + 1]);
        }, Sw = function(t1, e) {
            return t1 || 0 === t1 ? e(t1) : e;
        }, Tw = function(t1, e, n) {
            return n < t1 ? t1 : n > e ? e : n;
        }, Iw = function(t1, e) {
            return sx(t1) && (e = xx.exec(t1)) ? e[1] : "";
        }, Cw = [].slice, Nw = function(t1, e) {
            return t1 && ux(t1) && "length" in t1 && (!e && !t1.length || t1.length - 1 in t1 && ux(t1[0])) && !t1.nodeType && t1 !== Ub;
        }, Dw = function(t1, e, n) {
            return Pb && !e && Pb.selector ? Pb.selector(t1) : !sx(t1) || n || !kb && n_() ? mx(t1) ? function(t1, e, n) {
                return void 0 === n && (n = []), t1.forEach(function(t1) {
                    var i;
                    return sx(t1) && !e || Nw(t1, 1) ? (i = n).push.apply(i, Dw(t1)) : n.push(t1);
                }) || n;
            }(t1, n) : Nw(t1) ? Cw.call(t1, 0) : t1 ? [
                t1
            ] : [] : Cw.call((e || Bb).querySelectorAll(t1), 0);
        }, Lw = function(t1) {
            return t1 = Dw(t1)[0] || Tx("Invalid scope") || {}, function(e) {
                var n = t1.current || t1.nativeElement || t1;
                return Dw(e, n.querySelectorAll ? n : n === t1 ? Tx("Invalid scope") || Bb.createElement("div") : t1);
            };
        }, Ow = function(t1) {
            return t1.sort(function() {
                return .5 - Math.random();
            });
        }, Rw = function(t1) {
            if (ox(t1)) return t1;
            var e = ux(t1) ? t1 : {
                each: t1
            }, n = c_(e.ease), i = e.from || 0, r = parseFloat(e.base) || 0, a = {}, s = i > 0 && i < 1, o = isNaN(i) || s, l = e.axis, c = i, u = i;
            return sx(i) ? c = u = ({
                center: .5,
                edges: .5,
                end: 1
            })[i] || 0 : !s && o && (c = i[0], u = i[1]), function(t1, s, h) {
                var d, p, f, m, g, A, v, y, M, b = (h || e).length, x = a[b];
                if (!x) {
                    if (!(M = "auto" === e.grid ? 0 : (e.grid || [
                        1,
                        Kb
                    ])[1])) {
                        for(v = -Kb; v < (v = h[M++].getBoundingClientRect().left) && M < b;);
                        M < b && M--;
                    }
                    for(x = a[b] = [], d = o ? Math.min(M, b) * c - .5 : i % M, p = M === Kb ? 0 : o ? b * u / M - .5 : i / M | 0, v = 0, y = Kb, A = 0; A < b; A++)f = A % M - d, m = p - (A / M | 0), x[A] = g = l ? Math.abs("y" === l ? m : f) : ix(f * f + m * m), g > v && (v = g), g < y && (y = g);
                    "random" === i && Ow(x), x.max = v - y, x.min = y, x.v = b = (parseFloat(e.amount) || parseFloat(e.each) * (M > b ? b - 1 : l ? "y" === l ? b / M : M : Math.max(M, b / M)) || 0) * ("edges" === i ? -1 : 1), x.b = b < 0 ? r - b : r, x.u = Iw(e.amount || e.each) || 0, n = n && b < 0 ? o_(n) : n;
                }
                return b = (x[t1] - x.min) / x.max || 0, Wx(x.b + (n ? n(b) : b) * x.v) + x.u;
            };
        }, Pw = function(t1) {
            var e = Math.pow(10, ((t1 + "").split(".")[1] || "").length);
            return function(n) {
                var i = Wx(Math.round(parseFloat(n) / t1) * t1 * e);
                return (i - i % 1) / e + (lx(n) ? 0 : Iw(n));
            };
        }, zw = function(t1, e) {
            var n, i, r = mx(t1);
            return !r && ux(t1) && (n = r = t1.radius || Kb, t1.values ? (t1 = Dw(t1.values), (i = !lx(t1[0])) && (n *= n)) : t1 = Pw(t1.increment)), Sw(e, r ? ox(t1) ? function(e) {
                return i = t1(e), Math.abs(i - e) <= n ? i : e;
            } : function(e) {
                for(var r, a, s = parseFloat(i ? e.x : e), o = parseFloat(i ? e.y : 0), l = Kb, c = 0, u = t1.length; u--;)(r = i ? (r = t1[u].x - s) * r + (a = t1[u].y - o) * a : Math.abs(t1[u] - s)) < l && (l = r, c = u);
                return c = !n || l <= n ? t1[c] : e, i || c === e || lx(e) ? c : c + Iw(e);
            } : Pw(t1));
        }, Uw = function(t1, e, n, i) {
            return Sw(mx(t1) ? !e : !0 === n ? (n = 0, false) : !i, function() {
                return mx(t1) ? t1[~~(Math.random() * t1.length)] : (n = n || 1e-5, i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t1 - n / 2 + Math.random() * (e - t1 + .99 * n)) / n) * n * i) / i;
            });
        }, kw = function(t1, e, n) {
            return Sw(n, function(n) {
                return t1[~~e(n)];
            });
        }, Bw = function(t1) {
            for(var e, n, i, r, a = 0, s = ""; ~(e = t1.indexOf("random(", a));)i = t1.indexOf(")", e), r = "[" === t1.charAt(e + 7), n = t1.substr(e + 7, i - e - 7).match(r ? bx : gx), s += t1.substr(a, e - a) + Uw(r ? n : +n[0], r ? 0 : +n[1], +n[2] || 1e-5), a = i + 1;
            return s + t1.substr(a, t1.length - a);
        }, jw = function(t1, e, n, i, r) {
            var a = e - t1, s = i - n;
            return Sw(r, function(e) {
                return n + ((e - t1) / a * s || 0);
            });
        }, Fw = function(t1, e, n) {
            var i, r, a, s = t1.labels, o = Kb;
            for(i in s)(r = s[i] - e) < 0 == !!n && r && o > (r = Math.abs(r)) && (a = i, o = r);
            return a;
        }, Hw = function(t1, e, n) {
            var i, r, a, s = t1.vars, o = s[e], l = Pb, c = t1._ctx;
            if (o) return i = s[e + "Params"], r = s.callbackScope || t1, n && Rx.length && Zx(), c && (Pb = c), a = i ? o.apply(r, i) : o.call(r), Pb = l, a;
        }, Vw = function(t1) {
            return sw(t1), t1.scrollTrigger && t1.scrollTrigger.kill(!!Rb), t1.progress() < 1 && Hw(t1, "onInterrupt"), t1;
        }, Qw = [], Gw = function(t1) {
            if (t1) {
                if (t1 = !t1.name && t1.default || t1, dx() || t1.headless) {
                    var e = t1.name, n = ox(t1), i = e && !n && t1.init ? function() {
                        this._props = [];
                    } : t1, r = {
                        init: Cx,
                        render: z_,
                        add: M_,
                        kill: k_,
                        modifier: U_,
                        rawVars: 0
                    }, a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: L_,
                        aliases: {},
                        register: 0
                    };
                    if (n_(), t1 !== i) {
                        if (zx[e]) return;
                        $x(i, $x(nw(t1, r), a)), tw(i.prototype, tw(r, nw(t1, a))), zx[i.prop = e] = i, t1.targetTest && (Bx.push(i), Ox[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
                    }
                    Ix(e, i), t1.register && t1.register(tE, i, F_);
                } else Qw.push(t1);
            }
        }, Ww = 255, Xw = {
            aqua: [
                0,
                Ww,
                Ww
            ],
            lime: [
                0,
                Ww,
                0
            ],
            silver: [
                192,
                192,
                192
            ],
            black: [
                0,
                0,
                0
            ],
            maroon: [
                128,
                0,
                0
            ],
            teal: [
                0,
                128,
                128
            ],
            blue: [
                0,
                0,
                Ww
            ],
            navy: [
                0,
                0,
                128
            ],
            white: [
                Ww,
                Ww,
                Ww
            ],
            olive: [
                128,
                128,
                0
            ],
            yellow: [
                Ww,
                Ww,
                0
            ],
            orange: [
                Ww,
                165,
                0
            ],
            gray: [
                128,
                128,
                128
            ],
            purple: [
                128,
                0,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            red: [
                Ww,
                0,
                0
            ],
            pink: [
                Ww,
                192,
                203
            ],
            cyan: [
                0,
                Ww,
                Ww
            ],
            transparent: [
                Ww,
                Ww,
                Ww,
                0
            ]
        }, Yw = function(t1, e, n) {
            return (6 * (t1 += t1 < 0 ? 1 : t1 > 1 ? -1 : 0) < 1 ? e + (n - e) * t1 * 6 : t1 < .5 ? n : 3 * t1 < 2 ? e + (n - e) * (2 / 3 - t1) * 6 : e) * Ww + .5 | 0;
        }, Zw = function(t1, e, n) {
            var i, r, a, s, o, l, c, u, h, d, p = t1 ? lx(t1) ? [
                t1 >> 16,
                t1 >> 8 & Ww,
                t1 & Ww
            ] : 0 : Xw.black;
            if (!p) {
                if ("," === t1.substr(-1) && (t1 = t1.substr(0, t1.length - 1)), Xw[t1]) p = Xw[t1];
                else if ("#" === t1.charAt(0)) {
                    if (t1.length < 6 && (i = t1.charAt(1), r = t1.charAt(2), a = t1.charAt(3), t1 = "#" + i + i + r + r + a + a + (5 === t1.length ? t1.charAt(4) + t1.charAt(4) : "")), 9 === t1.length) return [
                        (p = parseInt(t1.substr(1, 6), 16)) >> 16,
                        p >> 8 & Ww,
                        p & Ww,
                        parseInt(t1.substr(7), 16) / 255
                    ];
                    p = [
                        (t1 = parseInt(t1.substr(1), 16)) >> 16,
                        t1 >> 8 & Ww,
                        t1 & Ww
                    ];
                } else if ("hsl" === t1.substr(0, 3)) {
                    if (p = d = t1.match(gx), e) {
                        if (~t1.indexOf("=")) return p = t1.match(Ax), n && p.length < 4 && (p[3] = 1), p;
                    } else s = +p[0] % 360 / 360, o = +p[1] / 100, i = 2 * (l = +p[2] / 100) - (r = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = Yw(s + 1 / 3, i, r), p[1] = Yw(s, i, r), p[2] = Yw(s - 1 / 3, i, r);
                } else p = t1.match(gx) || Xw.transparent;
                p = p.map(Number);
            }
            return e && !d && (i = p[0] / Ww, r = p[1] / Ww, a = p[2] / Ww, l = ((c = Math.max(i, r, a)) + (u = Math.min(i, r, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === i ? (r - a) / h + (r < a ? 6 : 0) : c === r ? (a - i) / h + 2 : (i - r) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), n && p.length < 4 && (p[3] = 1), p;
        }, qw = function(t1) {
            var e = [], n = [], i = -1;
            return t1.split(Kw).forEach(function(t1) {
                var r = t1.match(vx) || [];
                e.push.apply(e, r), n.push(i += r.length + 1);
            }), e.c = n, e;
        }, Jw = function(t1, e, n) {
            var i, r, a, s, o = "", l = (t1 + o).match(Kw), c = e ? "hsla(" : "rgba(", u = 0;
            if (!l) return t1;
            if (l = l.map(function(t1) {
                return (t1 = Zw(t1, e, 1)) && c + (e ? t1[0] + "," + t1[1] + "%," + t1[2] + "%," + t1[3] : t1.join(",")) + ")";
            }), n && (a = qw(t1), (i = n.c).join(o) !== a.c.join(o))) for(s = (r = t1.replace(Kw, "1").split(vx)).length - 1; u < s; u++)o += r[u] + (~i.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : n).shift());
            if (!r) for(s = (r = t1.split(Kw)).length - 1; u < s; u++)o += r[u] + l[u];
            return o + r[s];
        }, Kw = function() {
            var t1, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
            for(t1 in Xw)e += "|" + t1 + "\\b";
            return new RegExp(e + ")", "gi");
        }(), $w = /hsl[a]?\(/, t_ = function(t1) {
            var e, n = t1.join(" ");
            if (Kw.lastIndex = 0, Kw.test(n)) return e = $w.test(n), t1[1] = Jw(t1[1], e), t1[0] = Jw(t1[0], e, qw(t1[1])), !0;
        }, e_ = function() {
            var t1, e, n, i, r, a, s = Date.now, o = 500, l = 33, c = s(), u = c, h = 1e3 / 240, d = h, p = [], f = function n(f) {
                var m, g, A, v, y = s() - u, M = !0 === f;
                if ((y > o || y < 0) && (c += y - l), ((m = (A = (u += y) - c) - d) > 0 || M) && (v = ++i.frame, r = A - 1e3 * i.time, i.time = A /= 1e3, d += m + (m >= h ? 4 : h - m), g = 1), M || (t1 = e(n)), g) for(a = 0; a < p.length; a++)p[a](A, r, v, f);
            };
            return i = {
                time: 0,
                frame: 0,
                tick: function() {
                    f(!0);
                },
                deltaRatio: function(t1) {
                    return r / (1e3 / (t1 || 60));
                },
                wake: function() {
                    jb && (!kb && dx() && (Ub = kb = window, Bb = Ub.document || {}, wx.gsap = tE, (Ub.gsapVersions || (Ub.gsapVersions = [])).push(tE.version), Ex(_x || Ub.GreenSockGlobals || !Ub.gsap && Ub || {}), Qw.forEach(Gw)), n = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, t1 && i.sleep(), e = n || function(t1) {
                        return setTimeout(t1, d - 1e3 * i.time + 1 | 0);
                    }, Vb = 1, f(2));
                },
                sleep: function() {
                    (n ? cancelAnimationFrame : clearTimeout)(t1), Vb = 0, e = Cx;
                },
                lagSmoothing: function(t1, e) {
                    o = t1 || 1 / 0, l = Math.min(e || 33, o);
                },
                fps: function(t1) {
                    h = 1e3 / (t1 || 240), d = 1e3 * i.time + h;
                },
                add: function(t1, e, n) {
                    var r = e ? function(e, n, a, s) {
                        t1(e, n, a, s), i.remove(r);
                    } : t1;
                    return i.remove(t1), p[n ? "unshift" : "push"](r), n_(), r;
                },
                remove: function(t1, e) {
                    ~(e = p.indexOf(t1)) && p.splice(e, 1) && a >= e && a--;
                },
                _listeners: p
            }, i;
        }(), n_ = function() {
            return !Vb && e_.wake();
        }, i_ = {}, r_ = /^[\d.\-M][\d.\-,\s]/, a_ = /["']/g, s_ = function(t1) {
            for(var e, n, i, r = {}, a = t1.substr(1, t1.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++)n = a[o], e = o !== l - 1 ? n.lastIndexOf(",") : n.length, i = n.substr(0, e), r[s] = isNaN(i) ? i.replace(a_, "").trim() : +i, s = n.substr(e + 1).trim();
            return r;
        }, o_ = function(t1) {
            return function(e) {
                return 1 - t1(1 - e);
            };
        }, l_ = function t1(e, n) {
            for(var i, r = e._first; r;)r instanceof g_ ? t1(r, n) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === n || (r.timeline ? t1(r.timeline, n) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = n)), r = r._next;
        }, c_ = function(t1, e) {
            return t1 && (ox(t1) ? t1 : i_[t1] || function(t1) {
                var e, n, i, r, a = (t1 + "").split("("), s = i_[a[0]];
                return s && a.length > 1 && s.config ? s.config.apply(null, ~t1.indexOf("{") ? [
                    s_(a[1])
                ] : (e = t1, n = e.indexOf("(") + 1, i = e.indexOf(")"), r = e.indexOf("(", n), e.substring(n, ~r && r < i ? e.indexOf(")", i + 1) : i)).split(",").map(Jx)) : i_._CE && r_.test(t1) ? i_._CE("", t1) : s;
            }(t1)) || e;
        }, u_ = function(t1, e, n, i) {
            void 0 === n && (n = function(t1) {
                return 1 - e(1 - t1);
            }), void 0 === i && (i = function(t1) {
                return t1 < .5 ? e(2 * t1) / 2 : 1 - e(2 * (1 - t1)) / 2;
            });
            var r, a = {
                easeIn: e,
                easeOut: n,
                easeInOut: i
            };
            return Qx(t1, function(t1) {
                for(var e in i_[t1] = wx[t1] = a, i_[r = t1.toLowerCase()] = n, a)i_[r + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = i_[t1 + "." + e] = a[e];
            }), a;
        }, h_ = function(t1) {
            return function(e) {
                return e < .5 ? (1 - t1(1 - 2 * e)) / 2 : .5 + t1(2 * (e - .5)) / 2;
            };
        }, d_ = function t1(e, n, i) {
            var r = n >= 1 ? n : 1, a = (i || (e ? .3 : .45)) / (n < 1 ? n : 1), s = a / tx * (Math.asin(1 / r) || 0), o = function(t1) {
                return 1 === t1 ? 1 : r * Math.pow(2, -10 * t1) * ax((t1 - s) * a) + 1;
            }, l = "out" === e ? o : "in" === e ? function(t1) {
                return 1 - o(1 - t1);
            } : h_(o);
            return a = tx / a, l.config = function(n, i) {
                return t1(e, n, i);
            }, l;
        }, p_ = function t1(e, n) {
            void 0 === n && (n = 1.70158);
            var i = function(t1) {
                return t1 ? --t1 * t1 * ((n + 1) * t1 + n) + 1 : 0;
            }, r = "out" === e ? i : "in" === e ? function(t1) {
                return 1 - i(1 - t1);
            } : h_(i);
            return r.config = function(n) {
                return t1(e, n);
            }, r;
        };
        Qx("Linear,Quad,Cubic,Quart,Quint,Strong", function(t1, e) {
            var n = e < 5 ? e + 1 : e;
            u_(t1 + ",Power" + (n - 1), e ? function(t1) {
                return Math.pow(t1, n);
            } : function(t1) {
                return t1;
            }, function(t1) {
                return 1 - Math.pow(1 - t1, n);
            }, function(t1) {
                return t1 < .5 ? Math.pow(2 * t1, n) / 2 : 1 - Math.pow(2 * (1 - t1), n) / 2;
            });
        }), i_.Linear.easeNone = i_.none = i_.Linear.easeIn, u_("Elastic", d_("in"), d_("out"), d_()), Qb = 7.5625, Xb = 2 * (Wb = 1 / (Gb = 2.75)), Yb = 2.5 * Wb, u_("Bounce", function(t1) {
            return 1 - Zb(1 - t1);
        }, Zb = function(t1) {
            return t1 < Wb ? Qb * t1 * t1 : t1 < Xb ? Qb * Math.pow(t1 - 1.5 / Gb, 2) + .75 : t1 < Yb ? Qb * (t1 -= 2.25 / Gb) * t1 + .9375 : Qb * Math.pow(t1 - 2.625 / Gb, 2) + .984375;
        }), u_("Expo", function(t1) {
            return t1 ? Math.pow(2, 10 * (t1 - 1)) : 0;
        }), u_("Circ", function(t1) {
            return -(ix(1 - t1 * t1) - 1);
        }), u_("Sine", function(t1) {
            return 1 === t1 ? 1 : 1 - rx(t1 * ex);
        }), u_("Back", p_("in"), p_("out"), p_()), i_.SteppedEase = i_.steps = wx.SteppedEase = {
            config: function(t1, e) {
                void 0 === t1 && (t1 = 1);
                var n = 1 / t1, i = t1 + (e ? 0 : 1), r = e ? 1 : 0;
                return function(t1) {
                    return ((i * Tw(0, .99999999, t1) | 0) + r) * n;
                };
            }
        }, Jb.ease = i_["quad.out"], Qx("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t1) {
            return jx += t1 + "," + t1 + "Params,";
        });
        var f_ = function(t1, e) {
            this.id = nx++, t1._gsap = this, this.target = t1, this.harness = e, this.get = e ? e.get : Vx, this.set = e ? e.getSetter : L_;
        }, m_ = function() {
            function t1(t1) {
                this.vars = t1, this._delay = +t1.delay || 0, (this._repeat = t1.repeat === 1 / 0 ? -2 : t1.repeat || 0) && (this._rDelay = t1.repeatDelay || 0, this._yoyo = !!t1.yoyo || !!t1.yoyoEase), this._ts = 1, bw(this, +t1.duration, 1, 1), this.data = t1.data, Pb && (this._ctx = Pb, Pb.data.push(this)), Vb || e_.wake();
            }
            var e = t1.prototype;
            return e.delay = function(t1) {
                return t1 || 0 === t1 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t1 - this._delay), this._delay = t1, this) : this._delay;
            }, e.duration = function(t1) {
                return arguments.length ? this.totalDuration(this._repeat > 0 ? t1 + (t1 + this._rDelay) * this._repeat : t1) : this.totalDuration() && this._dur;
            }, e.totalDuration = function(t1) {
                return arguments.length ? (this._dirty = 0, bw(this, this._repeat < 0 ? t1 : (t1 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }, e.totalTime = function(t1, e) {
                if (n_(), !arguments.length) return this._tTime;
                var n = this._dp;
                if (n && n.smoothChildTiming && this._ts) {
                    for(fw(this, t1), !n._dp || n.parent || mw(n, this); n && n.parent;)n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), n = n.parent;
                    !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t1 < this._tDur || this._ts < 0 && t1 > 0 || !this._tDur && !t1) && gw(this._dp, this, this._start - this._delay);
                }
                return (this._tTime !== t1 || !this._dur && !e || this._initted && Math.abs(this._zTime) === $b || !t1 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t1), qx(this, t1, e)), this;
            }, e.time = function(t1, e) {
                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t1 + uw(this)) % (this._dur + this._rDelay) || (t1 ? this._dur : 0), e) : this._time;
            }, e.totalProgress = function(t1, e) {
                return arguments.length ? this.totalTime(this.totalDuration() * t1, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
            }, e.progress = function(t1, e) {
                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t1 : 1 - t1) + uw(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
            }, e.iteration = function(t1, e) {
                var n = this.duration() + this._rDelay;
                return arguments.length ? this.totalTime(this._time + (t1 - 1) * n, e) : this._repeat ? hw(this._tTime, n) + 1 : 1;
            }, e.timeScale = function(t1, e) {
                if (!arguments.length) return -0.00000001 === this._rts ? 0 : this._rts;
                if (this._rts === t1) return this;
                var n = this.parent && this._ts ? dw(this.parent._time, this) : this._tTime;
                return this._rts = +t1 || 0, this._ts = this._ps || -0.00000001 === t1 ? 0 : this._rts, this.totalTime(Tw(-Math.abs(this._delay), this._tDur, n), !1 !== e), pw(this), function(t1) {
                    for(var e = t1.parent; e && e.parent;)e._dirty = 1, e.totalDuration(), e = e.parent;
                    return t1;
                }(this);
            }, e.paused = function(t1) {
                return arguments.length ? (this._ps !== t1 && (this._ps = t1, t1 ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (n_(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== $b && (this._tTime -= $b)))), this) : this._ps;
            }, e.startTime = function(t1) {
                if (arguments.length) {
                    this._start = t1;
                    var e = this.parent || this._dp;
                    return e && (e._sort || !this.parent) && gw(e, this, t1 - this._delay), this;
                }
                return this._start;
            }, e.endTime = function(t1) {
                return this._start + (hx(t1) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }, e.rawTime = function(t1) {
                var e = this.parent || this._dp;
                return e ? t1 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? dw(e.rawTime(t1), this) : this._tTime : this._tTime;
            }, e.revert = function(t1) {
                void 0 === t1 && (t1 = Lx);
                var e = Rb;
                return Rb = t1, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(t1), this.totalTime(-0.01, t1.suppressEvents)), "nested" !== this.data && !1 !== t1.kill && this.kill(), Rb = e, this;
            }, e.globalTime = function(t1) {
                for(var e = this, n = arguments.length ? t1 : e.rawTime(); e;)n = e._start + n / (Math.abs(e._ts) || 1), e = e._dp;
                return !this.parent && this._sat ? this._sat.globalTime(t1) : n;
            }, e.repeat = function(t1) {
                return arguments.length ? (this._repeat = t1 === 1 / 0 ? -2 : t1, xw(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }, e.repeatDelay = function(t1) {
                if (arguments.length) {
                    var e = this._time;
                    return this._rDelay = t1, xw(this), e ? this.time(e) : this;
                }
                return this._rDelay;
            }, e.yoyo = function(t1) {
                return arguments.length ? (this._yoyo = t1, this) : this._yoyo;
            }, e.seek = function(t1, e) {
                return this.totalTime(_w(this, t1), hx(e));
            }, e.restart = function(t1, e) {
                return this.play().totalTime(t1 ? -this._delay : 0, hx(e));
            }, e.play = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.reversed(!1).paused(!1);
            }, e.reverse = function(t1, e) {
                return null != t1 && this.seek(t1 || this.totalDuration(), e), this.reversed(!0).paused(!1);
            }, e.pause = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.paused(!0);
            }, e.resume = function() {
                return this.paused(!1);
            }, e.reversed = function(t1) {
                return arguments.length ? (!!t1 !== this.reversed() && this.timeScale(-this._rts || (t1 ? -0.00000001 : 0)), this) : this._rts < 0;
            }, e.invalidate = function() {
                return this._initted = this._act = 0, this._zTime = -0.00000001, this;
            }, e.isActive = function() {
                var t1, e = this.parent || this._dp, n = this._start;
                return !(e && !(this._ts && this._initted && e.isActive() && (t1 = e.rawTime(!0)) >= n && t1 < this.endTime(!0) - $b));
            }, e.eventCallback = function(t1, e, n) {
                var i = this.vars;
                return arguments.length > 1 ? (e ? (i[t1] = e, n && (i[t1 + "Params"] = n), "onUpdate" === t1 && (this._onUpdate = e)) : delete i[t1], this) : i[t1];
            }, e.then = function(t1) {
                var e = this;
                return new Promise(function(n) {
                    var i = ox(t1) ? t1 : Kx, r = function() {
                        var t1 = e.then;
                        e.then = null, ox(i) && (i = i(e)) && (i.then || i === e) && (e.then = t1), n(i), e.then = t1;
                    };
                    e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? r() : e._prom = r;
                });
            }, e.kill = function() {
                Vw(this);
            }, t1;
        }();
        $x(m_.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -0.00000001,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var g_ = function(t1) {
            function e(e, n) {
                var i;
                return void 0 === e && (e = {}), (i = t1.call(this, e) || this).labels = {}, i.smoothChildTiming = !!e.smoothChildTiming, i.autoRemoveChildren = !!e.autoRemoveChildren, i._sort = hx(e.sortChildren), zb && gw(e.parent || zb, Db(i), n), e.reversed && i.reverse(), e.paused && i.paused(!0), e.scrollTrigger && Aw(Db(i), e.scrollTrigger), i;
            }
            Lb(e, t1);
            var n = e.prototype;
            return n.to = function(t1, e, n) {
                return Ew(0, arguments, this), this;
            }, n.from = function(t1, e, n) {
                return Ew(1, arguments, this), this;
            }, n.fromTo = function(t1, e, n, i) {
                return Ew(2, arguments, this), this;
            }, n.set = function(t1, e, n) {
                return e.duration = 0, e.parent = this, iw(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new T_(t1, e, _w(this, n), 1), this;
            }, n.call = function(t1, e, n) {
                return gw(this, T_.delayedCall(0, t1, e), n);
            }, n.staggerTo = function(t1, e, n, i, r, a, s) {
                return n.duration = e, n.stagger = n.stagger || i, n.onComplete = a, n.onCompleteParams = s, n.parent = this, new T_(t1, n, _w(this, r)), this;
            }, n.staggerFrom = function(t1, e, n, i, r, a, s) {
                return n.runBackwards = 1, iw(n).immediateRender = hx(n.immediateRender), this.staggerTo(t1, e, n, i, r, a, s);
            }, n.staggerFromTo = function(t1, e, n, i, r, a, s, o) {
                return i.startAt = n, iw(i).immediateRender = hx(i.immediateRender), this.staggerTo(t1, e, i, r, a, s, o);
            }, n.render = function(t1, e, n) {
                var i, r, a, s, o, l, c, u, h, d, p, f, m = this._time, g = this._dirty ? this.totalDuration() : this._tDur, A = this._dur, v = t1 <= 0 ? 0 : Wx(t1), y = this._zTime < 0 != t1 < 0 && (this._initted || !A);
                if (this !== zb && v > g && t1 >= 0 && (v = g), v !== this._tTime || n || y) {
                    if (m !== this._time && A && (v += this._time - m, t1 += this._time - m), i = v, h = this._start, l = !(u = this._ts), y && (A || (m = this._zTime), (t1 || !e) && (this._zTime = t1)), this._repeat) {
                        if (p = this._yoyo, o = A + this._rDelay, this._repeat < -1 && t1 < 0) return this.totalTime(100 * o + t1, e, n);
                        if (i = Wx(v % o), v === g ? (s = this._repeat, i = A) : ((s = ~~(v / o)) && s === v / o && (i = A, s--), i > A && (i = A)), d = hw(this._tTime, o), !m && this._tTime && d !== s && this._tTime - d * o - this._dur <= 0 && (d = s), p && 1 & s && (i = A - i, f = 1), s !== d && !this._lock) {
                            var M = p && 1 & d, b = M === (p && 1 & s);
                            if (s < d && (M = !M), m = M ? 0 : v % A ? A : v, this._lock = 1, this.render(m || (f ? 0 : Wx(s * o)), e, !A)._lock = 0, this._tTime = v, !e && this.parent && Hw(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), m && m !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (A = this._dur, g = this._tDur, b && (this._lock = 2, m = M ? A : -0.0001, this.render(m, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            l_(this, f);
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(t1, e, n) {
                        var i;
                        if (n > e) for(i = t1._first; i && i._start <= n;){
                            if ("isPause" === i.data && i._start > e) return i;
                            i = i._next;
                        }
                        else for(i = t1._last; i && i._start >= n;){
                            if ("isPause" === i.data && i._start < e) return i;
                            i = i._prev;
                        }
                    }(this, Wx(m), Wx(i)), c && (v -= i - (i = c._start))), this._tTime = v, this._time = i, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t1, m = 0), !m && i && !e && !s && (Hw(this, "onStart"), this._tTime !== v)) return this;
                    if (i >= m && t1 >= 0) for(r = this._first; r;){
                        if (a = r._next, (r._act || i >= r._start) && r._ts && c !== r) {
                            if (r.parent !== this) return this.render(t1, e, n);
                            if (r.render(r._ts > 0 ? (i - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (i - r._start) * r._ts, e, n), i !== this._time || !this._ts && !l) {
                                c = 0, a && (v += this._zTime = -0.00000001);
                                break;
                            }
                        }
                        r = a;
                    }
                    else {
                        r = this._last;
                        for(var x = t1 < 0 ? t1 : i; r;){
                            if (a = r._prev, (r._act || x <= r._end) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(t1, e, n);
                                if (r.render(r._ts > 0 ? (x - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (x - r._start) * r._ts, e, n || Rb && (r._initted || r._startAt)), i !== this._time || !this._ts && !l) {
                                    c = 0, a && (v += this._zTime = x ? -0.00000001 : $b);
                                    break;
                                }
                            }
                            r = a;
                        }
                    }
                    if (c && !e && (this.pause(), c.render(i >= m ? 0 : -0.00000001)._zTime = i >= m ? 1 : -1, this._ts)) return this._start = h, pw(this), this.render(t1, e, n);
                    this._onUpdate && !e && Hw(this, "onUpdate", !0), (v === g && this._tTime >= this.totalDuration() || !v && m) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((t1 || !A) && (v === g && this._ts > 0 || !v && this._ts < 0) && sw(this, 1), e || t1 < 0 && !m || !v && !m && g || (Hw(this, v === g && t1 >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < g && this.timeScale() > 0) && this._prom())));
                }
                return this;
            }, n.add = function(t1, e) {
                var n = this;
                if (lx(e) || (e = _w(this, e, t1)), !(t1 instanceof m_)) {
                    if (mx(t1)) return t1.forEach(function(t1) {
                        return n.add(t1, e);
                    }), this;
                    if (sx(t1)) return this.addLabel(t1, e);
                    if (!ox(t1)) return this;
                    t1 = T_.delayedCall(0, t1);
                }
                return this !== t1 ? gw(this, t1, e) : this;
            }, n.getChildren = function(t1, e, n, i) {
                void 0 === t1 && (t1 = !0), void 0 === e && (e = !0), void 0 === n && (n = !0), void 0 === i && (i = -Kb);
                for(var r = [], a = this._first; a;)a._start >= i && (a instanceof T_ ? e && r.push(a) : (n && r.push(a), t1 && r.push.apply(r, a.getChildren(!0, e, n)))), a = a._next;
                return r;
            }, n.getById = function(t1) {
                for(var e = this.getChildren(1, 1, 1), n = e.length; n--;)if (e[n].vars.id === t1) return e[n];
            }, n.remove = function(t1) {
                return sx(t1) ? this.removeLabel(t1) : ox(t1) ? this.killTweensOf(t1) : (aw(this, t1), t1 === this._recent && (this._recent = this._last), ow(this));
            }, n.totalTime = function(e, n) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Wx(e_.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t1.prototype.totalTime.call(this, e, n), this._forcing = 0, this) : this._tTime;
            }, n.addLabel = function(t1, e) {
                return this.labels[t1] = _w(this, e), this;
            }, n.removeLabel = function(t1) {
                return delete this.labels[t1], this;
            }, n.addPause = function(t1, e, n) {
                var i = T_.delayedCall(0, e || Cx, n);
                return i.data = "isPause", this._hasPause = 1, gw(this, i, _w(this, t1));
            }, n.removePause = function(t1) {
                var e = this._first;
                for(t1 = _w(this, t1); e;)e._start === t1 && "isPause" === e.data && sw(e), e = e._next;
            }, n.killTweensOf = function(t1, e, n) {
                for(var i = this.getTweensOf(t1, n), r = i.length; r--;)A_ !== i[r] && i[r].kill(t1, e);
                return this;
            }, n.getTweensOf = function(t1, e) {
                for(var n, i = [], r = Dw(t1), a = this._first, s = lx(e); a;)a instanceof T_ ? Yx(a._targets, r) && (s ? (!A_ || a._initted && a._ts) && a.globalTime(0) <= e && a.globalTime(a.totalDuration()) > e : !e || a.isActive()) && i.push(a) : (n = a.getTweensOf(r, e)).length && i.push.apply(i, n), a = a._next;
                return i;
            }, n.tweenTo = function(t1, e) {
                e = e || {};
                var n, i = this, r = _w(i, t1), a = e, s = a.startAt, o = a.onStart, l = a.onStartParams, c = a.immediateRender, u = T_.to(i, $x({
                    ease: e.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: r,
                    overwrite: "auto",
                    duration: e.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale()) || $b,
                    onStart: function() {
                        if (i.pause(), !n) {
                            var t1 = e.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale());
                            u._dur !== t1 && bw(u, t1, 0, 1).render(u._time, !0, !0), n = 1;
                        }
                        o && o.apply(u, l || []);
                    }
                }, e));
                return c ? u.render(0) : u;
            }, n.tweenFromTo = function(t1, e, n) {
                return this.tweenTo(e, $x({
                    startAt: {
                        time: _w(this, t1)
                    }
                }, n));
            }, n.recent = function() {
                return this._recent;
            }, n.nextLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Fw(this, _w(this, t1));
            }, n.previousLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Fw(this, _w(this, t1), 1);
            }, n.currentLabel = function(t1) {
                return arguments.length ? this.seek(t1, !0) : this.previousLabel(this._time + $b);
            }, n.shiftChildren = function(t1, e, n) {
                void 0 === n && (n = 0);
                for(var i, r = this._first, a = this.labels; r;)r._start >= n && (r._start += t1, r._end += t1), r = r._next;
                if (e) for(i in a)a[i] >= n && (a[i] += t1);
                return ow(this);
            }, n.invalidate = function(e) {
                var n = this._first;
                for(this._lock = 0; n;)n.invalidate(e), n = n._next;
                return t1.prototype.invalidate.call(this, e);
            }, n.clear = function(t1) {
                void 0 === t1 && (t1 = !0);
                for(var e, n = this._first; n;)e = n._next, this.remove(n), n = e;
                return this._dp && (this._time = this._tTime = this._pTime = 0), t1 && (this.labels = {}), ow(this);
            }, n.totalDuration = function(t1) {
                var e, n, i, r = 0, a = this, s = a._last, o = Kb;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -t1 : t1));
                if (a._dirty) {
                    for(i = a.parent; s;)e = s._prev, s._dirty && s.totalDuration(), (n = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, gw(a, s, n - s._delay, 1)._lock = 0) : o = n, n < 0 && s._ts && (r -= n, (!i && !a._dp || i && i.smoothChildTiming) && (a._start += n / a._ts, a._time -= n, a._tTime -= n), a.shiftChildren(-n, !1, -Infinity), o = 0), s._end > r && s._ts && (r = s._end), s = e;
                    bw(a, a === zb && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
                }
                return a._tDur;
            }, e.updateRoot = function(t1) {
                if (zb._ts && (qx(zb, dw(t1, zb)), Fb = e_.frame), e_.frame >= kx) {
                    kx += qb.autoSleep || 120;
                    var e = zb._first;
                    if ((!e || !e._ts) && qb.autoSleep && e_._listeners.length < 2) {
                        for(; e && !e._ts;)e = e._next;
                        e || e_.sleep();
                    }
                }
            }, e;
        }(m_);
        $x(g_.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var A_, v_, y_ = function(t1, e, n, i, r, a, s) {
            var o, l, c, u, h, d, p, f, m = new F_(this._pt, t1, e, 0, 1, P_, null, r), g = 0, A = 0;
            for(m.b = n, m.e = i, n += "", (p = ~(i += "").indexOf("random(")) && (i = Bw(i)), a && (a(f = [
                n,
                i
            ], t1, e), n = f[0], i = f[1]), l = n.match(yx) || []; o = yx.exec(i);)u = o[0], h = i.substring(g, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[A++] && (d = parseFloat(l[A - 1]) || 0, m._pt = {
                _next: m._pt,
                p: h || 1 === A ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? Xx(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, g = yx.lastIndex);
            return m.c = g < i.length ? i.substring(g, i.length) : "", m.fp = s, (Mx.test(i) || p) && (m.e = 0), this._pt = m, m;
        }, M_ = function(t1, e, n, i, r, a, s, o, l, c) {
            ox(i) && (i = i(r || 0, t1, a));
            var u, h = t1[e], d = "get" !== n ? n : ox(h) ? l ? t1[e.indexOf("set") || !ox(t1["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t1[e]() : h, p = ox(h) ? l ? N_ : C_ : I_;
            if (sx(i) && (~i.indexOf("random(") && (i = Bw(i)), "=" === i.charAt(1) && ((u = Xx(d, i) + (Iw(d) || 0)) || 0 === u) && (i = u)), !c || d !== i || v_) return isNaN(d * i) || "" === i ? (!h && !(e in t1) && Sx(e, i), y_.call(this, t1, e, d, i, p, o || qb.stringFilter, l)) : (u = new F_(this._pt, t1, e, +d || 0, i - (d || 0), "boolean" == typeof h ? R_ : O_, 0, p), l && (u.fp = l), s && u.modifier(s, this, t1), this._pt = u);
        }, b_ = function(t1, e, n, i, r, a) {
            var s, o, l, c;
            if (zx[t1] && !1 !== (s = new zx[t1]).init(r, s.rawVars ? e[t1] : function(t1, e, n, i, r) {
                if (ox(t1) && (t1 = __(t1, r, e, n, i)), !ux(t1) || t1.style && t1.nodeType || mx(t1) || fx(t1)) return sx(t1) ? __(t1, r, e, n, i) : t1;
                var a, s = {};
                for(a in t1)s[a] = __(t1[a], r, e, n, i);
                return s;
            }(e[t1], i, r, a, n), n, i, a) && (n._pt = o = new F_(n._pt, r, t1, 0, 1, s.render, s, 0, s.priority), n !== Hb)) for(l = n._ptLookup[n._targets.indexOf(r)], c = s._props.length; c--;)l[s._props[c]] = o;
            return s;
        }, x_ = function t1(e, n, i) {
            var r, a, s, o, l, c, u, h, d, p, f, m, g, A = e.vars, v = A.ease, y = A.startAt, M = A.immediateRender, b = A.lazy, x = A.onUpdate, w = A.runBackwards, _ = A.yoyoEase, E = A.keyframes, S = A.autoRevert, T = e._dur, I = e._startAt, C = e._targets, N = e.parent, D = N && "nested" === N.data ? N.vars.targets : C, L = "auto" === e._overwrite && !Ob, O = e.timeline;
            if (O && (!E || !v) && (v = "none"), e._ease = c_(v, Jb.ease), e._yEase = _ ? o_(c_(!0 === _ ? v : _, Jb.ease)) : 0, _ && e._yoyo && !e._repeat && (_ = e._yEase, e._yEase = e._ease, e._ease = _), e._from = !O && !!A.runBackwards, !O || E && !A.stagger) {
                if (m = (h = C[0] ? Hx(C[0]).harness : 0) && A[h.prop], r = nw(A, Ox), I && (I._zTime < 0 && I.progress(1), n < 0 && w && M && !S ? I.render(-1, !0) : I.revert(w && T ? Dx : Nx), I._lazy = 0), y) {
                    if (sw(e._startAt = T_.set(C, $x({
                        data: "isStart",
                        overwrite: !1,
                        parent: N,
                        immediateRender: !0,
                        lazy: !I && hx(b),
                        startAt: null,
                        delay: 0,
                        onUpdate: x && function() {
                            return Hw(e, "onUpdate");
                        },
                        stagger: 0
                    }, y))), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (Rb || !M && !S) && e._startAt.revert(Dx), M && T && n <= 0 && i <= 0) return void (n && (e._zTime = n));
                } else if (w && T && !I) {
                    if (n && (M = !1), s = $x({
                        overwrite: !1,
                        data: "isFromStart",
                        lazy: M && !I && hx(b),
                        immediateRender: M,
                        stagger: 0,
                        parent: N
                    }, r), m && (s[h.prop] = m), sw(e._startAt = T_.set(C, s)), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (Rb ? e._startAt.revert(Dx) : e._startAt.render(-1, !0)), e._zTime = n, M) {
                        if (!n) return;
                    } else t1(e._startAt, $b, $b);
                }
                for(e._pt = e._ptCache = 0, b = T && hx(b) || b && !T, a = 0; a < C.length; a++){
                    if (u = (l = C[a])._gsap || Fx(C)[a]._gsap, e._ptLookup[a] = p = {}, Px[u.id] && Rx.length && Zx(), f = D === C ? a : D.indexOf(l), h && !1 !== (d = new h).init(l, m || r, e, f, D) && (e._pt = o = new F_(e._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach(function(t1) {
                        p[t1] = o;
                    }), d.priority && (c = 1)), !h || m) for(s in r)zx[s] && (d = b_(s, r, e, f, l, D)) ? d.priority && (c = 1) : p[s] = o = M_.call(e, l, s, "get", r[s], f, D, 0, A.stringFilter);
                    e._op && e._op[a] && e.kill(l, e._op[a]), L && e._pt && (A_ = e, zb.killTweensOf(l, p, e.globalTime(n)), g = !e.parent, A_ = 0), e._pt && b && (Px[u.id] = 1);
                }
                c && j_(e), e._onInit && e._onInit(e);
            }
            e._onUpdate = x, e._initted = (!e._op || e._pt) && !g, E && n <= 0 && O.render(Kb, !0, !0);
        }, w_ = function(t1, e, n, i) {
            var r, a, s = e.ease || i || "power1.inOut";
            if (mx(e)) a = n[t1] || (n[t1] = []), e.forEach(function(t1, n) {
                return a.push({
                    t: n / (e.length - 1) * 100,
                    v: t1,
                    e: s
                });
            });
            else for(r in e)a = n[r] || (n[r] = []), "ease" === r || a.push({
                t: parseFloat(t1),
                v: e[r],
                e: s
            });
        }, __ = function(t1, e, n, i, r) {
            return ox(t1) ? t1.call(e, n, i, r) : sx(t1) && ~t1.indexOf("random(") ? Bw(t1) : t1;
        }, E_ = jx + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", S_ = {};
        Qx(E_ + ",id,stagger,delay,duration,paused,scrollTrigger", function(t1) {
            return S_[t1] = 1;
        });
        var T_ = function(t1) {
            function e(e, n, i, r) {
                var a;
                "number" == typeof n && (i.duration = n, n = i, i = null);
                var s, o, l, c, u, h, d, p, f = (a = t1.call(this, r ? n : iw(n)) || this).vars, m = f.duration, g = f.delay, A = f.immediateRender, v = f.stagger, y = f.overwrite, M = f.keyframes, b = f.defaults, x = f.scrollTrigger, w = f.yoyoEase, _ = n.parent || zb, E = (mx(e) || fx(e) ? lx(e[0]) : "length" in n) ? [
                    e
                ] : Dw(e);
                if (a._targets = E.length ? Fx(E) : Tx("GSAP target " + e + " not found. https://gsap.com", !qb.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = y, M || v || px(m) || px(g)) {
                    if (n = a.vars, (s = a.timeline = new g_({
                        data: "nested",
                        defaults: b || {},
                        targets: _ && "nested" === _.data ? _.vars.targets : E
                    })).kill(), s.parent = s._dp = Db(a), s._start = 0, v || px(m) || px(g)) {
                        if (c = E.length, d = v && Rw(v), ux(v)) for(u in v)~E_.indexOf(u) && (p || (p = {}), p[u] = v[u]);
                        for(o = 0; o < c; o++)(l = nw(n, S_)).stagger = 0, w && (l.yoyoEase = w), p && tw(l, p), h = E[o], l.duration = +__(m, Db(a), o, h, E), l.delay = (+__(g, Db(a), o, h, E) || 0) - a._delay, !v && 1 === c && l.delay && (a._delay = g = l.delay, a._start += g, l.delay = 0), s.to(h, l, d ? d(o, h, E) : 0), s._ease = i_.none;
                        s.duration() ? m = g = 0 : a.timeline = 0;
                    } else if (M) {
                        iw($x(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = c_(M.ease || n.ease || "none");
                        var S, T, I, C = 0;
                        if (mx(M)) M.forEach(function(t1) {
                            return s.to(E, t1, ">");
                        }), s.duration();
                        else {
                            for(u in l = {}, M)"ease" === u || "easeEach" === u || w_(u, M[u], l, M.easeEach);
                            for(u in l)for(S = l[u].sort(function(t1, e) {
                                return t1.t - e.t;
                            }), C = 0, o = 0; o < S.length; o++)(I = {
                                ease: (T = S[o]).e,
                                duration: (T.t - (o ? S[o - 1].t : 0)) / 100 * m
                            })[u] = T.v, s.to(E, I, C), C += I.duration;
                            s.duration() < m && s.to({}, {
                                duration: m - s.duration()
                            });
                        }
                    }
                    m || a.duration(m = s.duration());
                } else a.timeline = 0;
                return !0 !== y || Ob || (A_ = Db(a), zb.killTweensOf(E), A_ = 0), gw(_, Db(a), i), n.reversed && a.reverse(), n.paused && a.paused(!0), (A || !m && !M && a._start === Wx(_._time) && hx(A) && cw(Db(a)) && "nested" !== _.data) && (a._tTime = -0.00000001, a.render(Math.max(0, -g) || 0)), x && Aw(Db(a), x), a;
            }
            Lb(e, t1);
            var n = e.prototype;
            return n.render = function(t1, e, n) {
                var i, r, a, s, o, l, c, u, h, d = this._time, p = this._tDur, f = this._dur, m = t1 < 0, g = t1 > p - $b && !m ? p : t1 < $b ? 0 : t1;
                if (f) {
                    if (g !== this._tTime || !t1 || n || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m) {
                        if (i = g, u = this.timeline, this._repeat) {
                            if (s = f + this._rDelay, this._repeat < -1 && m) return this.totalTime(100 * s + t1, e, n);
                            if (i = Wx(g % s), g === p ? (a = this._repeat, i = f) : ((a = ~~(g / s)) && a === Wx(g / s) && (i = f, a--), i > f && (i = f)), (l = this._yoyo && 1 & a) && (h = this._yEase, i = f - i), o = hw(this._tTime, s), i === d && !n && this._initted && a === o) return this._tTime = g, this;
                            a !== o && (u && this._yEase && l_(u, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== s && this._initted && (this._lock = n = 1, this.render(Wx(s * a), !0).invalidate()._lock = 0));
                        }
                        if (!this._initted) {
                            if (vw(this, m ? t1 : i, n, e, g)) return this._tTime = 0, this;
                            if (!(d === this._time || n && this.vars.repeatRefresh && a !== o)) return this;
                            if (f !== this._dur) return this.render(t1, e, n);
                        }
                        if (this._tTime = g, this._time = i, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(i / f), this._from && (this.ratio = c = 1 - c), i && !d && !e && !a && (Hw(this, "onStart"), this._tTime !== g)) return this;
                        for(r = this._pt; r;)r.r(c, r.d), r = r._next;
                        u && u.render(t1 < 0 ? t1 : u._dur * u._ease(i / this._dur), e, n) || this._startAt && (this._zTime = t1), this._onUpdate && !e && (m && lw(this, t1, 0, n), Hw(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !e && this.parent && Hw(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (m && !this._onUpdate && lw(this, t1, 0, !0), (t1 || !f) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && sw(this, 1), e || m && !d || !(g || d || l) || (Hw(this, g === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < p && this.timeScale() > 0) && this._prom()));
                    }
                } else !function(t1, e, n, i) {
                    var r, a, s, o = t1.ratio, l = e < 0 || !e && (!t1._start && yw(t1) && (t1._initted || !Mw(t1)) || (t1._ts < 0 || t1._dp._ts < 0) && !Mw(t1)) ? 0 : 1, c = t1._rDelay, u = 0;
                    if (c && t1._repeat && (u = Tw(0, t1._tDur, e), a = hw(u, c), t1._yoyo && 1 & a && (l = 1 - l), a !== hw(t1._tTime, c) && (o = 1 - l, t1.vars.repeatRefresh && t1._initted && t1.invalidate())), l !== o || Rb || i || t1._zTime === $b || !e && t1._zTime) {
                        if (!t1._initted && vw(t1, e, i, n, u)) return;
                        for(s = t1._zTime, t1._zTime = e || (n ? $b : 0), n || (n = e && !s), t1.ratio = l, t1._from && (l = 1 - l), t1._time = 0, t1._tTime = u, r = t1._pt; r;)r.r(l, r.d), r = r._next;
                        e < 0 && lw(t1, e, 0, !0), t1._onUpdate && !n && Hw(t1, "onUpdate"), u && t1._repeat && !n && t1.parent && Hw(t1, "onRepeat"), (e >= t1._tDur || e < 0) && t1.ratio === l && (l && sw(t1, 1), n || Rb || (Hw(t1, l ? "onComplete" : "onReverseComplete", !0), t1._prom && t1._prom()));
                    } else t1._zTime || (t1._zTime = e);
                }(this, t1, e, n);
                return this;
            }, n.targets = function() {
                return this._targets;
            }, n.invalidate = function(e) {
                return (!e || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(e), t1.prototype.invalidate.call(this, e);
            }, n.resetTo = function(t1, e, n, i, r) {
                Vb || e_.wake(), this._ts || this.play();
                var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || x_(this, a), function(t1, e, n, i, r, a, s, o) {
                    var l, c, u, h, d = (t1._pt && t1._ptCache || (t1._ptCache = {}))[e];
                    if (!d) for(d = t1._ptCache[e] = [], u = t1._ptLookup, h = t1._targets.length; h--;){
                        if ((l = u[h][e]) && l.d && l.d._pt) for(l = l.d._pt; l && l.p !== e && l.fp !== e;)l = l._next;
                        if (!l) return v_ = 1, t1.vars[e] = "+=0", x_(t1, s), v_ = 0, o ? Tx(e + " not eligible for reset") : 1;
                        d.push(l);
                    }
                    for(h = d.length; h--;)(l = (c = d[h])._pt || c).s = !i && 0 !== i || r ? l.s + (i || 0) + a * l.c : i, l.c = n - l.s, c.e && (c.e = Gx(n) + Iw(c.e)), c.b && (c.b = l.s + Iw(c.b));
                }(this, t1, e, n, i, this._ease(a / this._dur), a, r) ? this.resetTo(t1, e, n, i, 1) : (fw(this, 0), this.parent || rw(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
            }, n.kill = function(t1, e) {
                if (void 0 === e && (e = "all"), !(t1 || e && "all" !== e)) return this._lazy = this._pt = 0, this.parent ? Vw(this) : this;
                if (this.timeline) {
                    var n = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(t1, e, A_ && !0 !== A_.vars.overwrite)._first || Vw(this), this.parent && n !== this.timeline.totalDuration() && bw(this, this._dur * this.timeline._tDur / n, 0, 1), this;
                }
                var i, r, a, s, o, l, c, u = this._targets, h = t1 ? Dw(t1) : u, d = this._ptLookup, p = this._pt;
                if ((!e || "all" === e) && function(t1, e) {
                    for(var n = t1.length, i = n === e.length; i && n-- && t1[n] === e[n];);
                    return n < 0;
                }(u, h)) return "all" === e && (this._pt = 0), Vw(this);
                for(i = this._op = this._op || [], "all" !== e && (sx(e) && (o = {}, Qx(e, function(t1) {
                    return o[t1] = 1;
                }), e = o), e = function(t1, e) {
                    var n, i, r, a, s = t1[0] ? Hx(t1[0]).harness : 0, o = s && s.aliases;
                    if (!o) return e;
                    for(i in n = tw({}, e), o)if ((i in n)) for(r = (a = o[i].split(",")).length; r--;)n[a[r]] = n[i];
                    return n;
                }(u, e)), c = u.length; c--;)if (~h.indexOf(u[c])) for(o in r = d[c], "all" === e ? (i[c] = e, s = r, a = {}) : (a = i[c] = i[c] || {}, s = e), s)(l = r && r[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || aw(this, l, "_pt"), delete r[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && Vw(this), this;
            }, e.to = function(t1, n) {
                return new e(t1, n, arguments[2]);
            }, e.from = function(t1, e) {
                return Ew(1, arguments);
            }, e.delayedCall = function(t1, n, i, r) {
                return new e(n, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: t1,
                    onComplete: n,
                    onReverseComplete: n,
                    onCompleteParams: i,
                    onReverseCompleteParams: i,
                    callbackScope: r
                });
            }, e.fromTo = function(t1, e, n) {
                return Ew(2, arguments);
            }, e.set = function(t1, n) {
                return n.duration = 0, n.repeatDelay || (n.repeat = 0), new e(t1, n);
            }, e.killTweensOf = function(t1, e, n) {
                return zb.killTweensOf(t1, e, n);
            }, e;
        }(m_);
        $x(T_.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), Qx("staggerTo,staggerFrom,staggerFromTo", function(t1) {
            T_[t1] = function() {
                var e = new g_, n = Cw.call(arguments, 0);
                return n.splice("staggerFromTo" === t1 ? 5 : 4, 0, 0), e[t1].apply(e, n);
            };
        });
        var I_ = function(t1, e, n) {
            return t1[e] = n;
        }, C_ = function(t1, e, n) {
            return t1[e](n);
        }, N_ = function(t1, e, n, i) {
            return t1[e](i.fp, n);
        }, D_ = function(t1, e, n) {
            return t1.setAttribute(e, n);
        }, L_ = function(t1, e) {
            return ox(t1[e]) ? C_ : cx(t1[e]) && t1.setAttribute ? D_ : I_;
        }, O_ = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t1)) / 1e6, e);
        }, R_ = function(t1, e) {
            return e.set(e.t, e.p, !!(e.s + e.c * t1), e);
        }, P_ = function(t1, e) {
            var n = e._pt, i = "";
            if (!t1 && e.b) i = e.b;
            else if (1 === t1 && e.e) i = e.e;
            else {
                for(; n;)i = n.p + (n.m ? n.m(n.s + n.c * t1) : Math.round(1e4 * (n.s + n.c * t1)) / 1e4) + i, n = n._next;
                i += e.c;
            }
            e.set(e.t, e.p, i, e);
        }, z_ = function(t1, e) {
            for(var n = e._pt; n;)n.r(t1, n.d), n = n._next;
        }, U_ = function(t1, e, n, i) {
            for(var r, a = this._pt; a;)r = a._next, a.p === i && a.modifier(t1, e, n), a = r;
        }, k_ = function(t1) {
            for(var e, n, i = this._pt; i;)n = i._next, i.p === t1 && !i.op || i.op === t1 ? aw(this, i, "_pt") : i.dep || (e = 1), i = n;
            return !e;
        }, B_ = function(t1, e, n, i) {
            i.mSet(t1, e, i.m.call(i.tween, n, i.mt), i);
        }, j_ = function(t1) {
            for(var e, n, i, r, a = t1._pt; a;){
                for(e = a._next, n = i; n && n.pr > a.pr;)n = n._next;
                (a._prev = n ? n._prev : r) ? a._prev._next = a : i = a, (a._next = n) ? n._prev = a : r = a, a = e;
            }
            t1._pt = i;
        }, F_ = function() {
            function t1(t1, e, n, i, r, a, s, o, l) {
                this.t = e, this.s = i, this.c = r, this.p = n, this.r = a || O_, this.d = s || this, this.set = o || I_, this.pr = l || 0, this._next = t1, t1 && (t1._prev = this);
            }
            return t1.prototype.modifier = function(t1, e, n) {
                this.mSet = this.mSet || this.set, this.set = B_, this.m = t1, this.mt = n, this.tween = e;
            }, t1;
        }();
        Qx(jx + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t1) {
            return Ox[t1] = 1;
        }), wx.TweenMax = wx.TweenLite = T_, wx.TimelineLite = wx.TimelineMax = g_, zb = new g_({
            sortChildren: !1,
            defaults: Jb,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), qb.stringFilter = t_;
        var H_ = [], V_ = {}, Q_ = [], G_ = 0, W_ = 0, X_ = function(t1) {
            return (V_[t1] || Q_).map(function(t1) {
                return t1();
            });
        }, Y_ = function() {
            var t1 = Date.now(), e = [];
            t1 - G_ > 2 && (X_("matchMediaInit"), H_.forEach(function(t1) {
                var n, i, r, a, s = t1.queries, o = t1.conditions;
                for(i in s)(n = Ub.matchMedia(s[i]).matches) && (r = 1), n !== o[i] && (o[i] = n, a = 1);
                a && (t1.revert(), r && e.push(t1));
            }), X_("matchMediaRevert"), e.forEach(function(t1) {
                return t1.onMatch(t1, function(e) {
                    return t1.add(null, e);
                });
            }), G_ = t1, X_("matchMedia"));
        }, Z_ = function() {
            function t1(t1, e) {
                this.selector = e && Lw(e), this.data = [], this._r = [], this.isReverted = !1, this.id = W_++, t1 && this.add(t1);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, n) {
                ox(t1) && (n = e, e = t1, t1 = ox);
                var i = this, r = function() {
                    var t1, r = Pb, a = i.selector;
                    return r && r !== i && r.data.push(i), n && (i.selector = Lw(n)), Pb = i, t1 = e.apply(i, arguments), ox(t1) && i._r.push(t1), Pb = r, i.selector = a, i.isReverted = !1, t1;
                };
                return i.last = r, t1 === ox ? r(i, function(t1) {
                    return i.add(null, t1);
                }) : t1 ? i[t1] = r : r;
            }, e.ignore = function(t1) {
                var e = Pb;
                Pb = null, t1(this), Pb = e;
            }, e.getTweens = function() {
                var e = [];
                return this.data.forEach(function(n) {
                    return n instanceof t1 ? e.push.apply(e, n.getTweens()) : n instanceof T_ && !(n.parent && "nested" === n.parent.data) && e.push(n);
                }), e;
            }, e.clear = function() {
                this._r.length = this.data.length = 0;
            }, e.kill = function(t1, e) {
                var n = this;
                if (t1 ? function() {
                    for(var e, i = n.getTweens(), r = n.data.length; r--;)"isFlip" === (e = n.data[r]).data && (e.revert(), e.getChildren(!0, !0, !1).forEach(function(t1) {
                        return i.splice(i.indexOf(t1), 1);
                    }));
                    for(i.map(function(t1) {
                        return {
                            g: t1._dur || t1._delay || t1._sat && !t1._sat.vars.immediateRender ? t1.globalTime(0) : -1 / 0,
                            t: t1
                        };
                    }).sort(function(t1, e) {
                        return e.g - t1.g || -1 / 0;
                    }).forEach(function(e) {
                        return e.t.revert(t1);
                    }), r = n.data.length; r--;)(e = n.data[r]) instanceof g_ ? "nested" !== e.data && (e.scrollTrigger && e.scrollTrigger.revert(), e.kill()) : !(e instanceof T_) && e.revert && e.revert(t1);
                    n._r.forEach(function(e) {
                        return e(t1, n);
                    }), n.isReverted = !0;
                }() : this.data.forEach(function(t1) {
                    return t1.kill && t1.kill();
                }), this.clear(), e) for(var i = H_.length; i--;)H_[i].id === this.id && H_.splice(i, 1);
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, t1;
        }(), q_ = function() {
            function t1(t1) {
                this.contexts = [], this.scope = t1, Pb && Pb.data.push(this);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, n) {
                ux(t1) || (t1 = {
                    matches: t1
                });
                var i, r, a, s = new Z_(0, n || this.scope), o = s.conditions = {};
                for(r in Pb && !s.selector && (s.selector = Pb.selector), this.contexts.push(s), e = s.add("onMatch", e), s.queries = t1, t1)"all" === r ? a = 1 : (i = Ub.matchMedia(t1[r])) && (H_.indexOf(s) < 0 && H_.push(s), (o[r] = i.matches) && (a = 1), i.addListener ? i.addListener(Y_) : i.addEventListener("change", Y_));
                return a && e(s, function(t1) {
                    return s.add(null, t1);
                }), this;
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, e.kill = function(t1) {
                this.contexts.forEach(function(e) {
                    return e.kill(t1, !0);
                });
            }, t1;
        }(), J_ = {
            registerPlugin: function() {
                for(var t1 = arguments.length, e = new Array(t1), n = 0; n < t1; n++)e[n] = arguments[n];
                e.forEach(function(t1) {
                    return Gw(t1);
                });
            },
            timeline: function(t1) {
                return new g_(t1);
            },
            getTweensOf: function(t1, e) {
                return zb.getTweensOf(t1, e);
            },
            getProperty: function(t1, e, n, i) {
                sx(t1) && (t1 = Dw(t1)[0]);
                var r = Hx(t1 || {}).get, a = n ? Kx : Jx;
                return "native" === n && (n = ""), t1 ? e ? a((zx[e] && zx[e].get || r)(t1, e, n, i)) : function(e, n, i) {
                    return a((zx[e] && zx[e].get || r)(t1, e, n, i));
                } : t1;
            },
            quickSetter: function(t1, e, n) {
                if ((t1 = Dw(t1)).length > 1) {
                    var i = t1.map(function(t1) {
                        return tE.quickSetter(t1, e, n);
                    }), r = i.length;
                    return function(t1) {
                        for(var e = r; e--;)i[e](t1);
                    };
                }
                t1 = t1[0] || {};
                var a = zx[e], s = Hx(t1), o = s.harness && (s.harness.aliases || {})[e] || e, l = a ? function(e) {
                    var i = new a;
                    Hb._pt = 0, i.init(t1, n ? e + n : e, Hb, 0, [
                        t1
                    ]), i.render(1, i), Hb._pt && z_(1, Hb);
                } : s.set(t1, o);
                return a ? l : function(e) {
                    return l(t1, o, n ? e + n : e, s, 1);
                };
            },
            quickTo: function(t1, e, n) {
                var i, r = tE.to(t1, tw(((i = {})[e] = "+=0.1", i.paused = !0, i), n || {})), a = function(t1, n, i) {
                    return r.resetTo(e, t1, n, i);
                };
                return a.tween = r, a;
            },
            isTweening: function(t1) {
                return zb.getTweensOf(t1, !0).length > 0;
            },
            defaults: function(t1) {
                return t1 && t1.ease && (t1.ease = c_(t1.ease, Jb.ease)), ew(Jb, t1 || {});
            },
            config: function(t1) {
                return ew(qb, t1 || {});
            },
            registerEffect: function(t1) {
                var e = t1.name, n = t1.effect, i = t1.plugins, r = t1.defaults, a = t1.extendTimeline;
                (i || "").split(",").forEach(function(t1) {
                    return t1 && !zx[t1] && !wx[t1] && Tx(e + " effect requires " + t1 + " plugin.");
                }), Ux[e] = function(t1, e, i) {
                    return n(Dw(t1), $x(e || {}, r), i);
                }, a && (g_.prototype[e] = function(t1, n, i) {
                    return this.add(Ux[e](t1, ux(n) ? n : (i = n) && {}, this), i);
                });
            },
            registerEase: function(t1, e) {
                i_[t1] = c_(e);
            },
            parseEase: function(t1, e) {
                return arguments.length ? c_(t1, e) : i_;
            },
            getById: function(t1) {
                return zb.getById(t1);
            },
            exportRoot: function(t1, e) {
                void 0 === t1 && (t1 = {});
                var n, i, r = new g_(t1);
                for(r.smoothChildTiming = hx(t1.smoothChildTiming), zb.remove(r), r._dp = 0, r._time = r._tTime = zb._time, n = zb._first; n;)i = n._next, !e && !n._dur && n instanceof T_ && n.vars.onComplete === n._targets[0] || gw(r, n, n._start - n._delay), n = i;
                return gw(zb, r, 0), r;
            },
            context: function(t1, e) {
                return t1 ? new Z_(t1, e) : Pb;
            },
            matchMedia: function(t1) {
                return new q_(t1);
            },
            matchMediaRefresh: function() {
                return H_.forEach(function(t1) {
                    var e, n, i = t1.conditions;
                    for(n in i)i[n] && (i[n] = !1, e = 1);
                    e && t1.revert();
                }) || Y_();
            },
            addEventListener: function(t1, e) {
                var n = V_[t1] || (V_[t1] = []);
                ~n.indexOf(e) || n.push(e);
            },
            removeEventListener: function(t1, e) {
                var n = V_[t1], i = n && n.indexOf(e);
                i >= 0 && n.splice(i, 1);
            },
            utils: {
                wrap: function t1(e, n, i) {
                    var r = n - e;
                    return mx(e) ? kw(e, t1(0, e.length), n) : Sw(i, function(t1) {
                        return (r + (t1 - e) % r) % r + e;
                    });
                },
                wrapYoyo: function t1(e, n, i) {
                    var r = n - e, a = 2 * r;
                    return mx(e) ? kw(e, t1(0, e.length - 1), n) : Sw(i, function(t1) {
                        return e + ((t1 = (a + (t1 - e) % a) % a || 0) > r ? a - t1 : t1);
                    });
                },
                distribute: Rw,
                random: Uw,
                snap: zw,
                normalize: function(t1, e, n) {
                    return jw(t1, e, 0, 1, n);
                },
                getUnit: Iw,
                clamp: function(t1, e, n) {
                    return Sw(n, function(n) {
                        return Tw(t1, e, n);
                    });
                },
                splitColor: Zw,
                toArray: Dw,
                selector: Lw,
                mapRange: jw,
                pipe: function() {
                    for(var t1 = arguments.length, e = new Array(t1), n = 0; n < t1; n++)e[n] = arguments[n];
                    return function(t1) {
                        return e.reduce(function(t1, e) {
                            return e(t1);
                        }, t1);
                    };
                },
                unitize: function(t1, e) {
                    return function(n) {
                        return t1(parseFloat(n)) + (e || Iw(n));
                    };
                },
                interpolate: function t1(e, n, i, r) {
                    var a = isNaN(e + n) ? 0 : function(t1) {
                        return (1 - t1) * e + t1 * n;
                    };
                    if (!a) {
                        var s, o, l, c, u, h = sx(e), d = {};
                        if (!0 === i && (r = 1) && (i = null), h) e = {
                            p: e
                        }, n = {
                            p: n
                        };
                        else if (mx(e) && !mx(n)) {
                            for(l = [], c = e.length, u = c - 2, o = 1; o < c; o++)l.push(t1(e[o - 1], e[o]));
                            c--, a = function(t1) {
                                t1 *= c;
                                var e = Math.min(u, ~~t1);
                                return l[e](t1 - e);
                            }, i = n;
                        } else r || (e = tw(mx(e) ? [] : {}, e));
                        if (!l) {
                            for(s in n)M_.call(d, e, s, "get", n[s]);
                            a = function(t1) {
                                return z_(t1, d) || (h ? e.p : e);
                            };
                        }
                    }
                    return Sw(i, a);
                },
                shuffle: Ow
            },
            install: Ex,
            effects: Ux,
            ticker: e_,
            updateRoot: g_.updateRoot,
            plugins: zx,
            globalTimeline: zb,
            core: {
                PropTween: F_,
                globals: Ix,
                Tween: T_,
                Timeline: g_,
                Animation: m_,
                getCache: Hx,
                _removeLinkedListItem: aw,
                reverting: function() {
                    return Rb;
                },
                context: function(t1) {
                    return t1 && Pb && (Pb.data.push(t1), t1._ctx = Pb), Pb;
                },
                suppressOverwrites: function(t1) {
                    return Ob = t1;
                }
            }
        };
        Qx("to,from,fromTo,delayedCall,set,killTweensOf", function(t1) {
            return J_[t1] = T_[t1];
        }), e_.add(g_.updateRoot), Hb = J_.to({}, {
            duration: 0
        });
        var K_ = function(t1, e) {
            for(var n = t1._pt; n && n.p !== e && n.op !== e && n.fp !== e;)n = n._next;
            return n;
        }, $_ = function(t1, e) {
            return {
                name: t1,
                rawVars: 1,
                init: function(t1, n, i) {
                    i._onInit = function(t1) {
                        var i, r;
                        if (sx(n) && (i = {}, Qx(n, function(t1) {
                            return i[t1] = 1;
                        }), n = i), e) {
                            for(r in i = {}, n)i[r] = e(n[r]);
                            n = i;
                        }
                        !function(t1, e) {
                            var n, i, r, a = t1._targets;
                            for(n in e)for(i = a.length; i--;)(r = t1._ptLookup[i][n]) && (r = r.d) && (r._pt && (r = K_(r, n)), r && r.modifier && r.modifier(e[n], t1, a[i], n));
                        }(t1, n);
                    };
                }
            };
        }, tE = J_.registerPlugin({
            name: "attr",
            init: function(t1, e, n, i, r) {
                var a, s, o;
                for(a in this.tween = n, e)o = t1.getAttribute(a) || "", (s = this.add(t1, "setAttribute", (o || 0) + "", e[a], i, r, 0, 0, a)).op = a, s.b = o, this._props.push(a);
            },
            render: function(t1, e) {
                for(var n = e._pt; n;)Rb ? n.set(n.t, n.p, n.b, n) : n.r(t1, n.d), n = n._next;
            }
        }, {
            name: "endArray",
            init: function(t1, e) {
                for(var n = e.length; n--;)this.add(t1, n, t1[n] || 0, e[n], 0, 0, 0, 0, 0, 1);
            }
        }, $_("roundProps", Pw), $_("modifiers"), $_("snap", zw)) || J_;
        T_.version = g_.version = tE.version = "3.12.5", jb = 1, dx() && n_(), i_.Power0, i_.Power1, i_.Power2, i_.Power3, i_.Power4, i_.Linear, i_.Quad, i_.Cubic, i_.Quart, i_.Quint, i_.Strong, i_.Elastic, i_.Back, i_.SteppedEase, i_.Bounce, i_.Sine, i_.Expo, i_.Circ;
        var eE, nE, iE, rE, aE, sE, oE, lE, cE = {}, uE = 180 / Math.PI, hE = Math.PI / 180, dE = Math.atan2, pE = /([A-Z])/g, fE = /(left|right|width|margin|padding|x)/i, mE = /[\s,\(]\S/, gE = {
            autoAlpha: "opacity,visibility",
            scale: "scaleX,scaleY",
            alpha: "opacity"
        }, AE = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, vE = function(t1, e) {
            return e.set(e.t, e.p, 1 === t1 ? e.e : Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, yE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u : e.b, e);
        }, ME = function(t1, e) {
            var n = e.s + e.c * t1;
            e.set(e.t, e.p, ~~(n + (n < 0 ? -0.5 : .5)) + e.u, e);
        }, bE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? e.e : e.b, e);
        }, xE = function(t1, e) {
            return e.set(e.t, e.p, 1 !== t1 ? e.b : e.e, e);
        }, wE = function(t1, e, n) {
            return t1.style[e] = n;
        }, _E = function(t1, e, n) {
            return t1.style.setProperty(e, n);
        }, EE = function(t1, e, n) {
            return t1._gsap[e] = n;
        }, SE = function(t1, e, n) {
            return t1._gsap.scaleX = t1._gsap.scaleY = n;
        }, TE = function(t1, e, n, i, r) {
            var a = t1._gsap;
            a.scaleX = a.scaleY = n, a.renderTransform(r, a);
        }, IE = function(t1, e, n, i, r) {
            var a = t1._gsap;
            a[e] = n, a.renderTransform(r, a);
        }, CE = "transform", NE = CE + "Origin", DE = function t1(e, n) {
            var i = this, r = this.target, a = r.style, s = r._gsap;
            if (e in cE && a) {
                if (this.tfm = this.tfm || {}, "transform" === e) return gE.transform.split(",").forEach(function(e) {
                    return t1.call(i, e, n);
                });
                if (~(e = gE[e] || e).indexOf(",") ? e.split(",").forEach(function(t1) {
                    return i.tfm[t1] = ZE(r, t1);
                }) : this.tfm[e] = s.x ? s[e] : ZE(r, e), e === NE && (this.tfm.zOrigin = s.zOrigin), this.props.indexOf(CE) >= 0) return;
                s.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(NE, n, "")), e = CE;
            }
            (a || n) && this.props.push(e, n, a[e]);
        }, LE = function(t1) {
            t1.translate && (t1.removeProperty("translate"), t1.removeProperty("scale"), t1.removeProperty("rotate"));
        }, OE = function() {
            var t1, e, n = this.props, i = this.target, r = i.style, a = i._gsap;
            for(t1 = 0; t1 < n.length; t1 += 3)n[t1 + 1] ? i[n[t1]] = n[t1 + 2] : n[t1 + 2] ? r[n[t1]] = n[t1 + 2] : r.removeProperty("--" === n[t1].substr(0, 2) ? n[t1] : n[t1].replace(pE, "-$1").toLowerCase());
            if (this.tfm) {
                for(e in this.tfm)a[e] = this.tfm[e];
                a.svg && (a.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")), (t1 = oE()) && t1.isStart || r[CE] || (LE(r), a.zOrigin && r[NE] && (r[NE] += " " + a.zOrigin + "px", a.zOrigin = 0, a.renderTransform()), a.uncache = 1);
            }
        }, RE = function(t1, e) {
            var n = {
                target: t1,
                props: [],
                revert: OE,
                save: DE
            };
            return t1._gsap || tE.core.getCache(t1), e && e.split(",").forEach(function(t1) {
                return n.save(t1);
            }), n;
        }, PE = function(t1, e) {
            var n = nE.createElementNS ? nE.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t1) : nE.createElement(t1);
            return n && n.style ? n : nE.createElement(t1);
        }, zE = function t1(e, n, i) {
            var r = getComputedStyle(e);
            return r[n] || r.getPropertyValue(n.replace(pE, "-$1").toLowerCase()) || r.getPropertyValue(n) || !i && t1(e, kE(n) || n, 1) || "";
        }, UE = "O,Moz,ms,Ms,Webkit".split(","), kE = function(t1, e, n) {
            var i = (e || aE).style, r = 5;
            if (t1 in i && !n) return t1;
            for(t1 = t1.charAt(0).toUpperCase() + t1.substr(1); r-- && !(UE[r] + t1 in i););
            return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? UE[r] : "") + t1;
        }, BE = function() {
            "undefined" != typeof window && window.document && (eE = window, nE = eE.document, iE = nE.documentElement, aE = PE("div") || {
                style: {}
            }, PE("div"), CE = kE(CE), NE = CE + "Origin", aE.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", lE = !!kE("perspective"), oE = tE.core.reverting, rE = 1);
        }, jE = function t1(e) {
            var n, i = PE("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, a = this.nextSibling, s = this.style.cssText;
            if (iE.appendChild(i), i.appendChild(this), this.style.display = "block", e) try {
                n = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t1;
            } catch (t1) {}
            else this._gsapBBox && (n = this._gsapBBox());
            return r && (a ? r.insertBefore(this, a) : r.appendChild(this)), iE.removeChild(i), this.style.cssText = s, n;
        }, FE = function(t1, e) {
            for(var n = e.length; n--;)if (t1.hasAttribute(e[n])) return t1.getAttribute(e[n]);
        }, HE = function(t1) {
            var e;
            try {
                e = t1.getBBox();
            } catch (n) {
                e = jE.call(t1, !0);
            }
            return e && (e.width || e.height) || t1.getBBox === jE || (e = jE.call(t1, !0)), !e || e.width || e.x || e.y ? e : {
                x: +FE(t1, [
                    "x",
                    "cx",
                    "x1"
                ]) || 0,
                y: +FE(t1, [
                    "y",
                    "cy",
                    "y1"
                ]) || 0,
                width: 0,
                height: 0
            };
        }, VE = function(t1) {
            return !(!t1.getCTM || t1.parentNode && !t1.ownerSVGElement || !HE(t1));
        }, QE = function(t1, e) {
            if (e) {
                var n, i = t1.style;
                e in cE && e !== NE && (e = CE), i.removeProperty ? ("ms" !== (n = e.substr(0, 2)) && "webkit" !== e.substr(0, 6) || (e = "-" + e), i.removeProperty("--" === n ? e : e.replace(pE, "-$1").toLowerCase())) : i.removeAttribute(e);
            }
        }, GE = function(t1, e, n, i, r, a) {
            var s = new F_(t1._pt, e, n, 0, 1, a ? xE : bE);
            return t1._pt = s, s.b = i, s.e = r, t1._props.push(n), s;
        }, WE = {
            deg: 1,
            rad: 1,
            turn: 1
        }, XE = {
            grid: 1,
            flex: 1
        }, YE = function t1(e, n, i, r) {
            var a, s, o, l, c = parseFloat(i) || 0, u = (i + "").trim().substr((c + "").length) || "px", h = aE.style, d = fE.test(n), p = "svg" === e.tagName.toLowerCase(), f = (p ? "client" : "offset") + (d ? "Width" : "Height"), m = 100, g = "px" === r, A = "%" === r;
            if (r === u || !c || WE[r] || WE[u]) return c;
            if ("px" !== u && !g && (c = t1(e, n, i, "px")), l = e.getCTM && VE(e), (A || "%" === u) && (cE[n] || ~n.indexOf("adius"))) return a = l ? e.getBBox()[d ? "width" : "height"] : e[f], Gx(A ? c / a * m : c / 100 * a);
            if (h[d ? "width" : "height"] = m + (g ? u : r), s = ~n.indexOf("adius") || "em" === r && e.appendChild && !p ? e : e.parentNode, l && (s = (e.ownerSVGElement || {}).parentNode), s && s !== nE && s.appendChild || (s = nE.body), (o = s._gsap) && A && o.width && d && o.time === e_.time && !o.uncache) return Gx(c / o.width * m);
            if (!A || "height" !== n && "width" !== n) (A || "%" === u) && !XE[zE(s, "display")] && (h.position = zE(e, "position")), s === e && (h.position = "static"), s.appendChild(aE), a = aE[f], s.removeChild(aE), h.position = "absolute";
            else {
                var v = e.style[n];
                e.style[n] = m + r, a = e[f], v ? e.style[n] = v : QE(e, n);
            }
            return d && A && ((o = Hx(s)).time = e_.time, o.width = s[f]), Gx(g ? a * c / m : a && c ? m / a * c : 0);
        }, ZE = function(t1, e, n, i) {
            var r;
            return rE || BE(), e in gE && "transform" !== e && ~(e = gE[e]).indexOf(",") && (e = e.split(",")[0]), cE[e] && "transform" !== e ? (r = oS(t1, i), r = "transformOrigin" !== e ? r[e] : r.svg ? r.origin : lS(zE(t1, NE)) + " " + r.zOrigin + "px") : (!(r = t1.style[e]) || "auto" === r || i || ~(r + "").indexOf("calc(")) && (r = tS[e] && tS[e](t1, e, n) || zE(t1, e) || Vx(t1, e) || ("opacity" === e ? 1 : 0)), n && !~(r + "").trim().indexOf(" ") ? YE(t1, e, r, n) + n : r;
        }, qE = function(t1, e, n, i) {
            if (!n || "none" === n) {
                var r = kE(e, t1, 1), a = r && zE(t1, r, 1);
                a && a !== n ? (e = r, n = a) : "borderColor" === e && (n = zE(t1, "borderTopColor"));
            }
            var s, o, l, c, u, h, d, p, f, m, g, A = new F_(this._pt, t1.style, e, 0, 1, P_), v = 0, y = 0;
            if (A.b = n, A.e = i, n += "", "auto" == (i += "") && (h = t1.style[e], t1.style[e] = i, i = zE(t1, e) || i, h ? t1.style[e] = h : QE(t1, e)), t_(s = [
                n,
                i
            ]), i = s[1], l = (n = s[0]).match(vx) || [], (i.match(vx) || []).length) {
                for(; o = vx.exec(i);)d = o[0], f = i.substring(v, o.index), u ? u = (u + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (u = 1), d !== (h = l[y++] || "") && (c = parseFloat(h) || 0, g = h.substr((c + "").length), "=" === d.charAt(1) && (d = Xx(c, d) + g), p = parseFloat(d), m = d.substr((p + "").length), v = vx.lastIndex - m.length, m || (m = m || qb.units[e] || g, v === i.length && (i += m, A.e += m)), g !== m && (c = YE(t1, e, h, m) || 0), A._pt = {
                    _next: A._pt,
                    p: f || 1 === y ? f : ",",
                    s: c,
                    c: p - c,
                    m: u && u < 4 || "zIndex" === e ? Math.round : 0
                });
                A.c = v < i.length ? i.substring(v, i.length) : "";
            } else A.r = "display" === e && "none" === i ? xE : bE;
            return Mx.test(i) && (A.e = 0), this._pt = A, A;
        }, JE = {
            top: "0%",
            bottom: "100%",
            left: "0%",
            right: "100%",
            center: "50%"
        }, KE = function(t1) {
            var e = t1.split(" "), n = e[0], i = e[1] || "50%";
            return "top" !== n && "bottom" !== n && "left" !== i && "right" !== i || (t1 = n, n = i, i = t1), e[0] = JE[n] || n, e[1] = JE[i] || i, e.join(" ");
        }, $E = function(t1, e) {
            if (e.tween && e.tween._time === e.tween._dur) {
                var n, i, r, a = e.t, s = a.style, o = e.u, l = a._gsap;
                if ("all" === o || !0 === o) s.cssText = "", i = 1;
                else for(r = (o = o.split(",")).length; --r > -1;)n = o[r], cE[n] && (i = 1, n = "transformOrigin" === n ? NE : CE), QE(a, n);
                i && (QE(a, CE), l && (l.svg && a.removeAttribute("transform"), oS(a, 1), l.uncache = 1, LE(s)));
            }
        }, tS = {
            clearProps: function(t1, e, n, i, r) {
                if ("isFromStart" !== r.data) {
                    var a = t1._pt = new F_(t1._pt, e, n, 0, 0, $E);
                    return a.u = i, a.pr = -10, a.tween = r, t1._props.push(n), 1;
                }
            }
        }, eS = [
            1,
            0,
            0,
            1,
            0,
            0
        ], nS = {}, iS = function(t1) {
            return "matrix(1, 0, 0, 1, 0, 0)" === t1 || "none" === t1 || !t1;
        }, rS = function(t1) {
            var e = zE(t1, CE);
            return iS(e) ? eS : e.substr(7).match(Ax).map(Gx);
        }, aS = function(t1, e) {
            var n, i, r, a, s = t1._gsap || Hx(t1), o = t1.style, l = rS(t1);
            return s.svg && t1.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [
                (r = t1.transform.baseVal.consolidate().matrix).a,
                r.b,
                r.c,
                r.d,
                r.e,
                r.f
            ]).join(",") ? eS : l : (l !== eS || t1.offsetParent || t1 === iE || s.svg || (r = o.display, o.display = "block", (n = t1.parentNode) && t1.offsetParent || (a = 1, i = t1.nextElementSibling, iE.appendChild(t1)), l = rS(t1), r ? o.display = r : QE(t1, "display"), a && (i ? n.insertBefore(t1, i) : n ? n.appendChild(t1) : iE.removeChild(t1))), e && l.length > 6 ? [
                l[0],
                l[1],
                l[4],
                l[5],
                l[12],
                l[13]
            ] : l);
        }, sS = function(t1, e, n, i, r, a) {
            var s, o, l, c = t1._gsap, u = r || aS(t1, !0), h = c.xOrigin || 0, d = c.yOrigin || 0, p = c.xOffset || 0, f = c.yOffset || 0, m = u[0], g = u[1], A = u[2], v = u[3], y = u[4], M = u[5], b = e.split(" "), x = parseFloat(b[0]) || 0, w = parseFloat(b[1]) || 0;
            n ? u !== eS && (o = m * v - g * A) && (l = x * (-g / o) + w * (m / o) - (m * M - g * y) / o, x = x * (v / o) + w * (-A / o) + (A * M - v * y) / o, w = l) : (x = (s = HE(t1)).x + (~b[0].indexOf("%") ? x / 100 * s.width : x), w = s.y + (~(b[1] || b[0]).indexOf("%") ? w / 100 * s.height : w)), i || !1 !== i && c.smooth ? (y = x - h, M = w - d, c.xOffset = p + (y * m + M * A) - y, c.yOffset = f + (y * g + M * v) - M) : c.xOffset = c.yOffset = 0, c.xOrigin = x, c.yOrigin = w, c.smooth = !!i, c.origin = e, c.originIsAbsolute = !!n, t1.style[NE] = "0px 0px", a && (GE(a, c, "xOrigin", h, x), GE(a, c, "yOrigin", d, w), GE(a, c, "xOffset", p, c.xOffset), GE(a, c, "yOffset", f, c.yOffset)), t1.setAttribute("data-svg-origin", x + " " + w);
        }, oS = function(t1, e) {
            var n = t1._gsap || new f_(t1);
            if ("x" in n && !e && !n.uncache) return n;
            var i, r, a, s, o, l, c, u, h, d, p, f, m, g, A, v, y, M, b, x, w, _, E, S, T, I, C, N, D, L, O, R, P = t1.style, z = n.scaleX < 0, U = "px", k = "deg", B = getComputedStyle(t1), j = zE(t1, NE) || "0";
            return i = r = a = l = c = u = h = d = p = 0, s = o = 1, n.svg = !(!t1.getCTM || !VE(t1)), B.translate && ("none" === B.translate && "none" === B.scale && "none" === B.rotate || (P[CE] = ("none" !== B.translate ? "translate3d(" + (B.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== B.rotate ? "rotate(" + B.rotate + ") " : "") + ("none" !== B.scale ? "scale(" + B.scale.split(" ").join(",") + ") " : "") + ("none" !== B[CE] ? B[CE] : "")), P.scale = P.rotate = P.translate = "none"), g = aS(t1, n.svg), n.svg && (n.uncache ? (T = t1.getBBox(), j = n.xOrigin - T.x + "px " + (n.yOrigin - T.y) + "px", S = "") : S = !e && t1.getAttribute("data-svg-origin"), sS(t1, S || j, !!S || n.originIsAbsolute, !1 !== n.smooth, g)), f = n.xOrigin || 0, m = n.yOrigin || 0, g !== eS && (M = g[0], b = g[1], x = g[2], w = g[3], i = _ = g[4], r = E = g[5], 6 === g.length ? (s = Math.sqrt(M * M + b * b), o = Math.sqrt(w * w + x * x), l = M || b ? dE(b, M) * uE : 0, (h = x || w ? dE(x, w) * uE + l : 0) && (o *= Math.abs(Math.cos(h * hE))), n.svg && (i -= f - (f * M + m * x), r -= m - (f * b + m * w))) : (R = g[6], L = g[7], C = g[8], N = g[9], D = g[10], O = g[11], i = g[12], r = g[13], a = g[14], c = (A = dE(R, D)) * uE, A && (S = _ * (v = Math.cos(-A)) + C * (y = Math.sin(-A)), T = E * v + N * y, I = R * v + D * y, C = _ * -y + C * v, N = E * -y + N * v, D = R * -y + D * v, O = L * -y + O * v, _ = S, E = T, R = I), u = (A = dE(-x, D)) * uE, A && (v = Math.cos(-A), O = w * (y = Math.sin(-A)) + O * v, M = S = M * v - C * y, b = T = b * v - N * y, x = I = x * v - D * y), l = (A = dE(b, M)) * uE, A && (S = M * (v = Math.cos(A)) + b * (y = Math.sin(A)), T = _ * v + E * y, b = b * v - M * y, E = E * v - _ * y, M = S, _ = T), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = Gx(Math.sqrt(M * M + b * b + x * x)), o = Gx(Math.sqrt(E * E + R * R)), A = dE(_, E), h = Math.abs(A) > 2e-4 ? A * uE : 0, p = O ? 1 / (O < 0 ? -O : O) : 0), n.svg && (S = t1.getAttribute("transform"), n.forceCSS = t1.setAttribute("transform", "") || !iS(zE(t1, CE)), S && t1.setAttribute("transform", S))), Math.abs(h) > 90 && Math.abs(h) < 270 && (z ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), e = e || n.uncache, n.x = i - ((n.xPercent = i && (!e && n.xPercent || (Math.round(t1.offsetWidth / 2) === Math.round(-i) ? -50 : 0))) ? t1.offsetWidth * n.xPercent / 100 : 0) + U, n.y = r - ((n.yPercent = r && (!e && n.yPercent || (Math.round(t1.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? t1.offsetHeight * n.yPercent / 100 : 0) + U, n.z = a + U, n.scaleX = Gx(s), n.scaleY = Gx(o), n.rotation = Gx(l) + k, n.rotationX = Gx(c) + k, n.rotationY = Gx(u) + k, n.skewX = h + k, n.skewY = d + k, n.transformPerspective = p + U, (n.zOrigin = parseFloat(j.split(" ")[2]) || !e && n.zOrigin || 0) && (P[NE] = lS(j)), n.xOffset = n.yOffset = 0, n.force3D = qb.force3D, n.renderTransform = n.svg ? mS : lE ? fS : uS, n.uncache = 0, n;
        }, lS = function(t1) {
            return (t1 = t1.split(" "))[0] + " " + t1[1];
        }, cS = function(t1, e, n) {
            var i = Iw(e);
            return Gx(parseFloat(e) + parseFloat(YE(t1, "x", n + "px", i))) + i;
        }, uS = function(t1, e) {
            e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, fS(t1, e);
        }, hS = "0deg", dS = "0px", pS = ") ", fS = function(t1, e) {
            var n = e || this, i = n.xPercent, r = n.yPercent, a = n.x, s = n.y, o = n.z, l = n.rotation, c = n.rotationY, u = n.rotationX, h = n.skewX, d = n.skewY, p = n.scaleX, f = n.scaleY, m = n.transformPerspective, g = n.force3D, A = n.target, v = n.zOrigin, y = "", M = "auto" === g && t1 && 1 !== t1 || !0 === g;
            if (v && (u !== hS || c !== hS)) {
                var b, x = parseFloat(c) * hE, w = Math.sin(x), _ = Math.cos(x);
                x = parseFloat(u) * hE, b = Math.cos(x), a = cS(A, a, w * b * -v), s = cS(A, s, -Math.sin(x) * -v), o = cS(A, o, _ * b * -v + v);
            }
            m !== dS && (y += "perspective(" + m + pS), (i || r) && (y += "translate(" + i + "%, " + r + "%) "), (M || a !== dS || s !== dS || o !== dS) && (y += o !== dS || M ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + pS), l !== hS && (y += "rotate(" + l + pS), c !== hS && (y += "rotateY(" + c + pS), u !== hS && (y += "rotateX(" + u + pS), h === hS && d === hS || (y += "skew(" + h + ", " + d + pS), 1 === p && 1 === f || (y += "scale(" + p + ", " + f + pS), A.style[CE] = y || "translate(0, 0)";
        }, mS = function(t1, e) {
            var n, i, r, a, s, o = e || this, l = o.xPercent, c = o.yPercent, u = o.x, h = o.y, d = o.rotation, p = o.skewX, f = o.skewY, m = o.scaleX, g = o.scaleY, A = o.target, v = o.xOrigin, y = o.yOrigin, M = o.xOffset, b = o.yOffset, x = o.forceCSS, w = parseFloat(u), _ = parseFloat(h);
            d = parseFloat(d), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), d += f), d || p ? (d *= hE, p *= hE, n = Math.cos(d) * m, i = Math.sin(d) * m, r = Math.sin(d - p) * -g, a = Math.cos(d - p) * g, p && (f *= hE, s = Math.tan(p - f), r *= s = Math.sqrt(1 + s * s), a *= s, f && (s = Math.tan(f), n *= s = Math.sqrt(1 + s * s), i *= s)), n = Gx(n), i = Gx(i), r = Gx(r), a = Gx(a)) : (n = m, a = g, i = r = 0), (w && !~(u + "").indexOf("px") || _ && !~(h + "").indexOf("px")) && (w = YE(A, "x", u, "px"), _ = YE(A, "y", h, "px")), (v || y || M || b) && (w = Gx(w + v - (v * n + y * r) + M), _ = Gx(_ + y - (v * i + y * a) + b)), (l || c) && (s = A.getBBox(), w = Gx(w + l / 100 * s.width), _ = Gx(_ + c / 100 * s.height)), s = "matrix(" + n + "," + i + "," + r + "," + a + "," + w + "," + _ + ")", A.setAttribute("transform", s), x && (A.style[CE] = s);
        }, gS = function(t1, e, n, i, r) {
            var a, s, o = 360, l = sx(r), c = parseFloat(r) * (l && ~r.indexOf("rad") ? uE : 1) - i, u = i + c + "deg";
            return l && ("short" === (a = r.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), t1._pt = s = new F_(t1._pt, e, n, i, c, vE), s.e = u, s.u = "deg", t1._props.push(n), s;
        }, AS = function(t1, e) {
            for(var n in e)t1[n] = e[n];
            return t1;
        }, vS = function(t1, e, n) {
            var i, r, a, s, o, l, c, u = AS({}, n._gsap), h = n.style;
            for(r in u.svg ? (a = n.getAttribute("transform"), n.setAttribute("transform", ""), h[CE] = e, i = oS(n, 1), QE(n, CE), n.setAttribute("transform", a)) : (a = getComputedStyle(n)[CE], h[CE] = e, i = oS(n, 1), h[CE] = a), cE)(a = u[r]) !== (s = i[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (o = Iw(a) !== (c = Iw(s)) ? YE(n, r, a, c) : parseFloat(a), l = parseFloat(s), t1._pt = new F_(t1._pt, i, r, o, l - o, AE), t1._pt.u = c || 0, t1._props.push(r));
            AS(i, u);
        };
        Qx("padding,margin,Width,Radius", function(t1, e) {
            var n = "Top", i = "Right", r = "Bottom", a = "Left", s = (e < 3 ? [
                n,
                i,
                r,
                a
            ] : [
                n + a,
                n + i,
                r + i,
                r + a
            ]).map(function(n) {
                return e < 2 ? t1 + n : "border" + n + t1;
            });
            tS[e > 1 ? "border" + t1 : t1] = function(t1, e, n, i, r) {
                var a, o;
                if (arguments.length < 4) return a = s.map(function(e) {
                    return ZE(t1, e, n);
                }), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (i + "").split(" "), o = {}, s.forEach(function(t1, e) {
                    return o[t1] = a[e] = a[e] || a[(e - 1) / 2 | 0];
                }), t1.init(e, o, r);
            };
        });
        var yS, MS, bS = {
            name: "css",
            register: BE,
            targetTest: function(t1) {
                return t1.style && t1.nodeType;
            },
            init: function(t1, e, n, i, r) {
                var a, s, o, l, c, u, h, d, p, f, m, g, A, v, y, M, b = this._props, x = t1.style, w = n.vars.startAt;
                for(h in rE || BE(), this.styles = this.styles || RE(t1), M = this.styles.props, this.tween = n, e)if ("autoRound" !== h && (s = e[h], !zx[h] || !b_(h, e, n, i, t1, r))) {
                    if (c = typeof s, u = tS[h], "function" === c && (c = typeof (s = s.call(n, i, t1, r))), "string" === c && ~s.indexOf("random(") && (s = Bw(s)), u) u(this, t1, h, s, n) && (y = 1);
                    else if ("--" === h.substr(0, 2)) a = (getComputedStyle(t1).getPropertyValue(h) + "").trim(), s += "", Kw.lastIndex = 0, Kw.test(a) || (d = Iw(a), p = Iw(s)), p ? d !== p && (a = YE(t1, h, a, p) + p) : d && (s += d), this.add(x, "setProperty", a, s, i, r, 0, 0, h), b.push(h), M.push(h, 0, x[h]);
                    else if ("undefined" !== c) {
                        if (w && h in w ? (a = "function" == typeof w[h] ? w[h].call(n, i, t1, r) : w[h], sx(a) && ~a.indexOf("random(") && (a = Bw(a)), Iw(a + "") || "auto" === a || (a += qb.units[h] || Iw(ZE(t1, h)) || ""), "=" === (a + "").charAt(1) && (a = ZE(t1, h))) : a = ZE(t1, h), l = parseFloat(a), (f = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in gE && ("autoAlpha" === h && (1 === l && "hidden" === ZE(t1, "visibility") && o && (l = 0), M.push("visibility", 0, x.visibility), GE(this, x, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = gE[h]).indexOf(",") && (h = h.split(",")[0])), m = h in cE) {
                            if (this.styles.save(h), g || ((A = t1._gsap).renderTransform && !e.parseTransform || oS(t1, e.parseTransform), v = !1 !== e.smoothOrigin && A.smooth, (g = this._pt = new F_(this._pt, x, CE, 0, 1, A.renderTransform, A, 0, -1)).dep = 1), "scale" === h) this._pt = new F_(this._pt, A, "scaleY", A.scaleY, (f ? Xx(A.scaleY, f + o) : o) - A.scaleY || 0, AE), this._pt.u = 0, b.push("scaleY", h), h += "X";
                            else {
                                if ("transformOrigin" === h) {
                                    M.push(NE, 0, x[NE]), s = KE(s), A.svg ? sS(t1, s, 0, v, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== A.zOrigin && GE(this, A, "zOrigin", A.zOrigin, p), GE(this, x, h, lS(a), lS(s)));
                                    continue;
                                }
                                if ("svgOrigin" === h) {
                                    sS(t1, s, 1, v, 0, this);
                                    continue;
                                }
                                if (h in nS) {
                                    gS(this, A, h, l, f ? Xx(l, f + s) : s);
                                    continue;
                                }
                                if ("smoothOrigin" === h) {
                                    GE(this, A, "smooth", A.smooth, s);
                                    continue;
                                }
                                if ("force3D" === h) {
                                    A[h] = s;
                                    continue;
                                }
                                if ("transform" === h) {
                                    vS(this, s, t1);
                                    continue;
                                }
                            }
                        } else h in x || (h = kE(h) || h);
                        if (m || (o || 0 === o) && (l || 0 === l) && !mE.test(s) && h in x) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = Iw(s) || (h in qb.units ? qb.units[h] : d)) && (l = YE(t1, h, a, p)), this._pt = new F_(this._pt, m ? A : x, h, l, (f ? Xx(l, f + o) : o) - l, m || "px" !== p && "zIndex" !== h || !1 === e.autoRound ? AE : ME), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = yE);
                        else if (h in x) qE.call(this, t1, h, a, f ? f + s : s);
                        else if (h in t1) this.add(t1, h, a || t1[h], f ? f + s : s, i, r);
                        else if ("parseTransform" !== h) {
                            Sx(h, s);
                            continue;
                        }
                        m || (h in x ? M.push(h, 0, x[h]) : M.push(h, 1, a || t1[h])), b.push(h);
                    }
                }
                y && j_(this);
            },
            render: function(t1, e) {
                if (e.tween._time || !oE()) for(var n = e._pt; n;)n.r(t1, n.d), n = n._next;
                else e.styles.revert();
            },
            get: ZE,
            aliases: gE,
            getSetter: function(t1, e, n) {
                var i = gE[e];
                return i && i.indexOf(",") < 0 && (e = i), e in cE && e !== NE && (t1._gsap.x || ZE(t1, "x")) ? n && sE === n ? "scale" === e ? SE : EE : (sE = n || {}, "scale" === e ? TE : IE) : t1.style && !cx(t1.style[e]) ? wE : ~e.indexOf("-") ? _E : L_(t1, e);
            },
            core: {
                _removeProperty: QE,
                _getMatrix: aS
            }
        };
        tE.utils.checkPrefix = kE, tE.core.getStyleSaver = RE, MS = Qx("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (yS = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(t1) {
            cE[t1] = 1;
        }), Qx(yS, function(t1) {
            qb.units[t1] = "deg", nS[t1] = 1;
        }), gE[MS[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + yS, Qx("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(t1) {
            var e = t1.split(":");
            gE[e[1]] = MS[e[0]];
        }), Qx("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t1) {
            qb.units[t1] = "px";
        }), tE.registerPlugin(bS);
        var xS = tE.registerPlugin(bS) || tE;
        xS.core.Tween;
        const wS = class extends Bp {
            constructor(t1){
                var e, n, i;
                super(), e = this, i = !0, n = function(t1) {
                    var e = function(t1, e) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var n = t1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(n = "_visible"), n in e ? Object.defineProperty(e, n, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[n] = i, this.userData = t1, this.visible = !1, this.createHoverArea(), this.createPoint().then(()=>this.addEventListeners());
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.hoverArea && (this.hoverArea.visible = t1), this.point && (this.point.visible = t1);
            }
            async createPoint() {
                const t1 = new fh(30, 30, 10, 10), e = new _A, n = await e.loadAsync(this.userData.icon);
                n.center = new tl(.5, .5), n.colorSpace = Ws, n.minFilter = _a, n.magFilter = Ma, n.anisotropy = 8;
                const i = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    map: n,
                    opacity: Ib.isMobileDevice ? .5 : 0
                });
                this.point = new Gu(t1, i), this.point.position.copy(this.userData.position), this.point.rotation.x = Math.PI / 2, this.point.visible = this.visible, this.point.interactive = !0, this.point.renderOrder = 3, this.point.isLink = !0, this.point.updateOpacity = xS.quickTo(this.point.material, "opacity", {
                    ease: "back",
                    duration: .5
                }), this.add(this.point);
            }
            createHoverArea() {
                const t1 = new km(150, 10, 10), e = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    opacity: 0
                });
                this.hoverArea = new Gu(t1, e), this.hoverArea.position.copy(this.userData.position), this.hoverArea.rotation.x = Math.PI / 2, this.hoverArea.visible = this.visible, this.hoverArea.isLinkSphere = !0, this.hoverArea.interactive = !0, this.hoverArea.renderOrder = 2, this.add(this.hoverArea);
            }
            addEventListeners() {
                return this.point.addEventListener("select", ()=>this.onClick()), this.point.addEventListener("click", ()=>this.onClick()), this.point.addEventListener("hoverstart", ()=>this.onHoverStart()), this.point.addEventListener("hoverend", ()=>this.onHoverEnd()), this.hoverArea.addEventListener("click", ()=>this.onClick()), this.hoverArea.addEventListener("hoverstart", ()=>this.onHoverStart()), this.hoverArea.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.point && (this.point.material.dispose(), this.point.removeFromParent()), this.hoverArea && (this.hoverArea.material.dispose(), this.hoverArea.removeFromParent()), this.removeFromParent();
            }
            onHoverStart() {
                Ib.isMobileDevice || this.point.updateOpacity(1);
            }
            onHoverEnd() {
                Ib.isMobileDevice || this.point.updateOpacity(0);
            }
            onClick() {}
        };
        function _S(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const ES = class extends Gu {
            constructor(t1, e){
                super(e), _S(this, "depthMap", null), _S(this, "loaded", !1), _S(this, "links", []), this.renderOrder = 0, this.userData = t1;
            }
            get panoramaId() {
                return this.userData.camera_id;
            }
            async loadDepth() {
                try {
                    this.depthMap = await Ab(this.userData.images.scene_depth);
                } catch (t1) {
                    this.depthMap = null, console.error("Error loading depthMap");
                }
            }
            async loadMask() {
                try {
                    this.mask = await Ab(this.userData.images.object_ids);
                } catch (t1) {
                    this.mask = null, console.error("Error loading mask");
                }
            }
            async load() {
                return this.userData.images.scene_depth && await this.loadDepth().then(()=>this.removeBlockedLinks()), this.userData.images.object_ids && await this.loadMask(), await this.createMaterial().then(()=>this.loaded = !0);
            }
            removeBlockedLinks() {
                const t1 = [];
                this.links.forEach((e)=>{
                    const { delta: n, distance: i } = ((t1, e)=>{
                        const { direction: n } = (new lc).lookAt(t1), i = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, r = Math.acos(n.y) / Math.PI, { R: a } = yb(i, r, e), s = a || 140, o = (new Ol).distanceTo(t1);
                        return {
                            depth: s,
                            distance: o,
                            delta: o - s
                        };
                    })(e.userData.position, this.depthMap);
                    if (n > 40 || i > 800) return e.dispose();
                    t1.push(e);
                });
            }
            createLinks(t1) {
                return this.createCameraPoints(), this.createDoors(t1), this;
            }
            createCameraPoints() {
                for (const t1 of this.userData.roomPanoramas){
                    if (t1 === this.panoramaId) continue;
                    const e = ub(Vi.config.json, t1);
                    e && this.createLink(t1, e.Location, !1);
                }
                return this;
            }
            createDoors(t1) {
                var e, n;
                const i = Vi.config.json.Floors[Vi.currentFloorIndex], r = null !== (e = i.Apertures) && void 0 !== e ? e : [], a = null !== (n = i.Doors) && void 0 !== n ? n : [], s = cb(Vi.config.json, this.userData.room_id), { Rooms: o } = i.Units[0];
                for (const { Location: e, Walls: n, ...i } of [
                    ...a,
                    ...r
                ]){
                    if (!n.some((t1)=>s.Walls.some((e)=>e === t1))) continue;
                    const r = o.find((t1)=>{
                        const e = t1.Walls.some((t1)=>n.some((e)=>t1 === e)), i = t1.ID === s.ID;
                        return e && !i;
                    });
                    if (!r) continue;
                    const a = t1.filter((t1)=>{
                        let { userData: e } = t1;
                        return e.room_id === r.ID;
                    }), { panorama: l } = hb([
                        e.X,
                        e.Y
                    ], a);
                    l && this.createLink(l.panoramaId, e, !0, i);
                }
                return this;
            }
            createLink(t1, e) {
                var n;
                let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0;
                const a = (null === (n = this.userData.cameraData) || void 0 === n ? void 0 : n.Location.Z) || 140, s = [
                    this.userData.left,
                    this.userData.top
                ], o = e.X - s[0], l = e.Y - s[1], c = i ? r.Height / 2 - a : -a, u = new Ol(o, c, l);
                u.applyAxisAngle(new Ol(0, 1, 0), Math.PI / 2);
                const h = {
                    panoramaId: this.panoramaId,
                    position: u,
                    targetId: t1
                };
                if (i) {
                    const t1 = Vi.config.panoramaIcons.door, e = new Nb({
                        ...h,
                        rotation: new yc(0, mb(r.Rotation.Yaw + 90), 0),
                        height: r.Height,
                        width: r.Width,
                        scale: .1,
                        icon: t1
                    });
                    return this.links.push(e), e;
                }
                const d = Vi.config.panoramaIcons.spot, p = new wS({
                    ...h,
                    icon: d,
                    scale: 1
                });
                return this.links.push(p), p;
            }
        }, SS = class extends ES {
            constructor(t1){
                super(t1, new Ig(1e3, 512, 512).scale(-1, 1, 1)), this.userData.image = t1.images.sphere || t1.images[0];
            }
            async createMaterial() {
                const t1 = await vb(this.userData.image);
                return this.material = new kg({
                    transparent: !0,
                    side: pr,
                    map: t1,
                    opacity: 0
                }), this;
            }
            async fadeOut() {
                return await pb(this.material).then(()=>this.visible = !1);
            }
            async fadeIn() {
                return this.visible = !0, await fb(this.material);
            }
        }, TS = class extends ES {
            constructor(t1){
                super(t1, new Xu(2e3, 2e3, 2e3).scale(-1, 1, 1)), this.userData.cubemap = [
                    {
                        url: t1.images.front,
                        rotation: 0
                    },
                    {
                        url: t1.images.back,
                        rotation: 0
                    },
                    {
                        url: t1.images.top,
                        rotation: 90
                    },
                    {
                        url: t1.images.bottom,
                        rotation: 270
                    },
                    {
                        url: t1.images.left,
                        rotation: 0
                    },
                    {
                        url: t1.images.right,
                        rotation: 0
                    }
                ];
            }
            async createMaterial() {
                const t1 = this.userData.cubemap.map((t1, e)=>vb(t1.url).then((n)=>(n.rotation = mb(t1.rotation), {
                            texture: n,
                            index: e
                        }))), e = await Promise.all(t1);
                this.material = e.sort((t1, e)=>t1.index - e.index).map((t1)=>{
                    let { texture: e } = t1;
                    return new kg({
                        transparent: !0,
                        side: pr,
                        opacity: 0,
                        map: e
                    });
                });
            }
            async fadeOut() {
                const t1 = this.material.map(pb);
                return await Promise.all(t1).then(()=>this.visible = !1);
            }
            async fadeIn() {
                this.visible = !0;
                const t1 = this.material.map(fb);
                return await Promise.all(t1);
            }
        };
        function IS(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const CS = class extends Bp {
            constructor(t1){
                super(), IS(this, "type", "sphere"), IS(this, "items", []), IS(this, "floorIndex", void 0), this.floorIndex = t1;
            }
            getCreatedPanoramas() {
                if (!Vi.config.json) return this.items.map((t1)=>{
                    const e = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...t1
                    };
                    return this.createPanorama(e);
                });
                const t1 = ub(Vi.config.json, Vi.primaryCameraPointId), { Walls: e } = Vi.config.json.Floors[Vi.currentFloorIndex], { Vertices: n } = Vi.config.json;
                return this.items.reduce((i, r)=>{
                    var a;
                    const s = ub(Vi.config.json, r.camera_id), o = cb(Vi.config.json, r.room_id), l = this.items.reduce((t1, e)=>e.room_id !== r.room_id ? t1 : [
                            ...t1,
                            e.camera_id
                        ], []), c = ((t1, e, n)=>{
                        const i = t1.Walls.reduce((t1, i)=>{
                            const r = e.find((t1)=>t1.ID === i);
                            return lb(e, r.ID, n).forEach((e)=>t1.push(e)), t1;
                        }, []);
                        return i;
                    })(o, e, n), u = o.Walls.reduce((t1, i, r)=>{
                        const a = e.find((t1)=>t1.ID === i), [s, o] = lb(e, i, n), l = [];
                        return 0 === r && t1.push({
                            type: "M",
                            x: s[0],
                            y: s[1]
                        }), t1.push({
                            type: "L",
                            x: s[0],
                            y: s[1]
                        }), a.ControlPoint && l.push({
                            type: "Q",
                            x: a.ControlPoint.Location.X,
                            y: a.ControlPoint.Location.Y,
                            dx: o[0],
                            dy: o[1]
                        }), l.push({
                            type: "L",
                            x: o[0],
                            y: o[1]
                        }), [
                            ...t1,
                            ...l
                        ];
                    }, []), [h, d] = s ? [
                        s.Location.X,
                        s.Location.Y
                    ] : function(t1) {
                        let e = 0, n = 0, i = t1.length;
                        for(let r = 0; r < i; r++){
                            const i = t1[r];
                            e += i[0], n += i[1];
                        }
                        return [
                            e / i,
                            n / i
                        ];
                    }(c), p = -1 * mb((null === (a = s.Rotation) || void 0 === a ? void 0 : a.Yaw) || 0), f = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...r,
                        cameraData: s || null,
                        roomPanoramas: l,
                        svgPathActions: u,
                        rotation: p,
                        points: c,
                        left: h,
                        top: d
                    }, m = this.createPanorama(f);
                    return t1 && t1.ID === s.ID ? (i.unshift(m), i) : t1 || o.ID !== Vi.initialPanoramaRoomId ? (i.push(m), i) : (i.unshift(m), i);
                }, []);
            }
            createPanoramas(t1, e) {
                this.items = t1, this.type = e;
                const n = this.getCreatedPanoramas();
                return n.forEach((t1, e)=>{
                    t1.userData.panorama_index = e, Vi.config.json && t1.createLinks(n);
                }), n;
            }
            createPanorama(t1) {
                const e = "cube" === this.type ? new TS(t1) : new SS(t1);
                return e.visible = !1, this.add(e), e;
            }
        };
        const NS = class extends Wp {
            constructor(){
                var t1, e, n;
                super({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                }), t1 = this, n = void 0, e = function(t1) {
                    var e = function(t1, e) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var n = t1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "currentVrSession"), e in t1 ? Object.defineProperty(t1, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = n, this.toneMapping = $r, this.toneMappingExposure = 1, this.setPixelRatio(window.devicePixelRatio), this.setClearColor(new Jc(0), 0), this.setClearAlpha(1), this.xr.setReferenceSpaceType("local"), this.xr.enabled = !0;
            }
            async checkVrSessionSupport() {
                try {
                    return await navigator.xr.isSessionSupported("immersive-vr");
                } catch (t1) {
                    return !1;
                }
            }
            async onSessionStarted(t1) {
                t1.addEventListener("end", this.onSessionEnded.bind(this)), await this.xr.setSession(t1), this.xr.setFoveation(0), this.currentVrSession = t1;
            }
            onSessionEnded() {
                this.currentVrSession.removeEventListener("end", this.onSessionEnded.bind(this)), this.currentVrSession = null;
            }
            async enterVR() {
                return await navigator.xr.requestSession("immersive-vr", {
                    optionalFeatures: [
                        "local-floor",
                        "bounded-floor",
                        "hand-tracking",
                        "layers"
                    ]
                }).then(this.onSessionStarted.bind(this));
            }
            async exitVR() {
                if (this.currentVrSession) return await this.xr.getSession().end();
            }
        };
        function DS(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const LS = class {
            constructor(t1, e){
                DS(this, "deviceOrientation", {}), DS(this, "screenOrientation", 0), DS(this, "alphaOffsetAngle", 0), DS(this, "connected", !1), DS(this, "enabled", !1), DS(this, "domElement", void 0), DS(this, "alpha", 0), DS(this, "tempX", 0), DS(this, "tempY", 0), DS(this, "rotY", 0), DS(this, "rotX", 0), DS(this, "camera", void 0), this.camera = t1, this.camera.rotation.reorder("YXZ"), this.domElement = e || document;
            }
            enable() {
                this.enabled = !0;
            }
            disable() {
                this.enabled = !1;
            }
            connect() {
                this.onScreenOrientationChange(), window.addEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.update.bind(this)), this.domElement.addEventListener("touchstart", this.onTouchStart.bind(this)), this.domElement.addEventListener("touchmove", this.onTouchMove.bind(this)), this.connected = !0;
            }
            disconnect() {
                window.removeEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.update.bind(this)), this.domElement.removeEventListener("touchstart", this.onTouchStart), this.domElement.removeEventListener("touchmove", this.onTouchMove), this.connected = !1;
            }
            onDeviceOrientationChange(t1) {
                this.deviceOrientation = t1;
            }
            onScreenOrientationChange() {
                this.screenOrientation = window.orientation || 0;
            }
            onTouchStart(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            onTouchMove(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.rotY += mb((t1.touches[0].pageX - this.tempX) / 4), this.rotX += mb((this.tempY - t1.touches[0].pageY) / 4), this.updateAlphaOffsetAngle(this.rotY), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            setCameraQuaternion(t1, e, n, i, r) {
                const a = new Ol(0, 0, 1), s = new yc, o = new Ll, l = new Ll(-Math.sqrt(.5), 0, 0, Math.sqrt(.5)), c = new Ll, u = new Ll;
                let h = null;
                0 === this.screenOrientation ? (h = new Ol(1, 0, 0), c.setFromAxisAngle(h, -this.rotX)) : 180 === this.screenOrientation ? (h = new Ol(1, 0, 0), c.setFromAxisAngle(h, this.rotX)) : 90 === this.screenOrientation ? (h = new Ol(0, 1, 0), c.setFromAxisAngle(h, this.rotX)) : -90 === this.screenOrientation && (h = new Ol(0, 1, 0), c.setFromAxisAngle(h, -this.rotX)), l.multiply(c), l.multiply(u), s.set(n, e, -i, "YXZ"), t1.setFromEuler(s), t1.multiply(l), t1.multiply(o.setFromAxisAngle(a, -r));
            }
            updateAlphaOffsetAngle(t1) {
                this.alphaOffsetAngle = t1, this.update();
            }
            update() {
                if (!1 === this.enabled) return;
                const t1 = this.deviceOrientation.alpha ? mb(this.deviceOrientation.alpha + 90) + this.alphaOffsetAngle : 0, e = this.deviceOrientation.beta ? mb(this.deviceOrientation.beta) : 0, n = this.deviceOrientation.gamma ? mb(this.deviceOrientation.gamma) : 0, i = this.screenOrientation ? mb(this.screenOrientation) : 0;
                this.setCameraQuaternion(this.camera.quaternion, t1, e, n, i), this.alpha = t1;
            }
            dispose() {
                this.disconnect();
            }
        }, OS = Object.freeze({
            NONE: 0,
            ROTATE: 1,
            TRUCK: 2,
            OFFSET: 4,
            DOLLY: 8,
            ZOOM: 16,
            TOUCH_ROTATE: 32,
            TOUCH_TRUCK: 64,
            TOUCH_OFFSET: 128,
            TOUCH_DOLLY: 256,
            TOUCH_ZOOM: 512,
            TOUCH_DOLLY_TRUCK: 1024,
            TOUCH_DOLLY_OFFSET: 2048,
            TOUCH_DOLLY_ROTATE: 4096,
            TOUCH_ZOOM_TRUCK: 8192,
            TOUCH_ZOOM_OFFSET: 16384,
            TOUCH_ZOOM_ROTATE: 32768
        });
        function RS(t1) {
            return t1.isPerspectiveCamera;
        }
        function PS(t1) {
            return t1.isOrthographicCamera;
        }
        const zS = 2 * Math.PI, US = Math.PI / 2, kS = 1e-5, BS = Math.PI / 180;
        function jS(t1, e, n) {
            return Math.max(e, Math.min(n, t1));
        }
        function FS(t1, e = kS) {
            return Math.abs(t1) < e;
        }
        function HS(t1, e, n = kS) {
            return FS(t1 - e, n);
        }
        function VS(t1, e) {
            return Math.round(t1 / e) * e;
        }
        function QS(t1) {
            return isFinite(t1) ? t1 : t1 < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
        }
        function GS(t1) {
            return Math.abs(t1) < Number.MAX_VALUE ? t1 : t1 * (1 / 0);
        }
        function WS(t1, e, n, i, r = 1 / 0, a) {
            const s = 2 / (i = Math.max(1e-4, i)), o = s * a, l = 1 / (1 + o + .48 * o * o + .235 * o * o * o);
            let c = t1 - e;
            const u = e, h = r * i;
            c = jS(c, -h, h), e = t1 - c;
            const d = (n.value + s * c) * a;
            n.value = (n.value - s * d) * l;
            let p = e + (c + d) * l;
            return u - t1 > 0 == p > u && (p = u, n.value = (p - u) / a), p;
        }
        function XS(t1, e, n, i, r = 1 / 0, a, s) {
            const o = 2 / (i = Math.max(1e-4, i)), l = o * a, c = 1 / (1 + l + .48 * l * l + .235 * l * l * l);
            let u = e.x, h = e.y, d = e.z, p = t1.x - u, f = t1.y - h, m = t1.z - d;
            const g = u, A = h, v = d, y = r * i, M = p * p + f * f + m * m;
            if (M > y * y) {
                const t1 = Math.sqrt(M);
                p = p / t1 * y, f = f / t1 * y, m = m / t1 * y;
            }
            u = t1.x - p, h = t1.y - f, d = t1.z - m;
            const b = (n.x + o * p) * a, x = (n.y + o * f) * a, w = (n.z + o * m) * a;
            n.x = (n.x - o * b) * c, n.y = (n.y - o * x) * c, n.z = (n.z - o * w) * c, s.x = u + (p + b) * c, s.y = h + (f + x) * c, s.z = d + (m + w) * c;
            const _ = g - t1.x, E = A - t1.y, S = v - t1.z;
            return _ * (s.x - g) + E * (s.y - A) + S * (s.z - v) > 0 && (s.x = g, s.y = A, s.z = v, n.x = (s.x - g) / a, n.y = (s.y - A) / a, n.z = (s.z - v) / a), s;
        }
        function YS(t1, e) {
            e.set(0, 0), t1.forEach((t1)=>{
                e.x += t1.clientX, e.y += t1.clientY;
            }), e.x /= t1.length, e.y /= t1.length;
        }
        function ZS(t1, e) {
            return !!PS(t1) && (console.warn(`${e} is not supported in OrthographicCamera`), !0);
        }
        class qS {
            constructor(){
                this._listeners = {};
            }
            addEventListener(t1, e) {
                const n = this._listeners;
                void 0 === n[t1] && (n[t1] = []), -1 === n[t1].indexOf(e) && n[t1].push(e);
            }
            hasEventListener(t1, e) {
                const n = this._listeners;
                return void 0 !== n[t1] && -1 !== n[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                const n = this._listeners[t1];
                if (void 0 !== n) {
                    const t1 = n.indexOf(e);
                    -1 !== t1 && n.splice(t1, 1);
                }
            }
            removeAllEventListeners(t1) {
                t1 ? Array.isArray(this._listeners[t1]) && (this._listeners[t1].length = 0) : this._listeners = {};
            }
            dispatchEvent(t1) {
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const n = e.slice(0);
                    for(let e = 0, i = n.length; e < i; e++)n[e].call(this, t1);
                }
            }
        }
        var JS;
        const KS = 1 / 8, $S = /Mac/.test(null === (JS = null === globalThis || void 0 === globalThis ? void 0 : globalThis.navigator) || void 0 === JS ? void 0 : JS.platform);
        let tT, eT, nT, iT, rT, aT, sT, oT, lT, cT, uT, hT, dT, pT, fT, mT, gT, AT, vT, yT, MT, bT, xT;
        class wT extends qS {
            static install(t1) {
                tT = t1.THREE, eT = Object.freeze(new tT.Vector3(0, 0, 0)), nT = Object.freeze(new tT.Vector3(0, 1, 0)), iT = Object.freeze(new tT.Vector3(0, 0, 1)), rT = new tT.Vector2, aT = new tT.Vector3, sT = new tT.Vector3, oT = new tT.Vector3, lT = new tT.Vector3, cT = new tT.Vector3, uT = new tT.Vector3, hT = new tT.Vector3, dT = new tT.Vector3, pT = new tT.Vector3, fT = new tT.Spherical, mT = new tT.Spherical, gT = new tT.Box3, AT = new tT.Box3, vT = new tT.Sphere, yT = new tT.Quaternion, MT = new tT.Quaternion, bT = new tT.Matrix4, xT = new tT.Raycaster;
            }
            static get ACTION() {
                return OS;
            }
            constructor(t1, e){
                super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = .01, this.maxZoom = 1 / 0, this.smoothTime = .25, this.draggingSmoothTime = .125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.verticalDragToForward = !1, this.boundaryFriction = 0, this.restThreshold = .01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = OS.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect, this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = 0, this._thetaVelocity = {
                    value: 0
                }, this._phiVelocity = {
                    value: 0
                }, this._radiusVelocity = {
                    value: 0
                }, this._targetVelocity = new tT.Vector3, this._focalOffsetVelocity = new tT.Vector3, this._zoomVelocity = {
                    value: 0
                }, this._truckInternal = (t1, e, n)=>{
                    let i, r;
                    if (RS(this._camera)) {
                        const n = aT.copy(this._camera.position).sub(this._target), a = this._camera.getEffectiveFOV() * BS, s = n.length() * Math.tan(.5 * a);
                        i = this.truckSpeed * t1 * s / this._elementRect.height, r = this.truckSpeed * e * s / this._elementRect.height;
                    } else {
                        if (!PS(this._camera)) return;
                        {
                            const n = this._camera;
                            i = t1 * (n.right - n.left) / n.zoom / this._elementRect.width, r = e * (n.top - n.bottom) / n.zoom / this._elementRect.height;
                        }
                    }
                    this.verticalDragToForward ? (n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(i, 0, !0), this.forward(-r, !0)) : n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y + r, this._focalOffsetEnd.z, !0) : this.truck(i, r, !0);
                }, this._rotateInternal = (t1, e)=>{
                    const n = zS * this.azimuthRotateSpeed * t1 / this._elementRect.height, i = zS * this.polarRotateSpeed * e / this._elementRect.height;
                    this.rotate(n, i, !0);
                }, this._dollyInternal = (t1, e, n)=>{
                    const i = Math.pow(.95, -t1 * this.dollySpeed), r = this._sphericalEnd.radius, a = this._sphericalEnd.radius * i, s = jS(a, this.minDistance, this.maxDistance), o = s - a;
                    this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(a, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(o, !0), this._dollyToNoClamp(s, !0)) : this._dollyToNoClamp(s, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? a : s) - r, this._dollyControlCoord.set(e, n)), this._lastDollyDirection = Math.sign(-t1);
                }, this._zoomInternal = (t1, e, n)=>{
                    const i = Math.pow(.95, t1 * this.dollySpeed), r = this._zoom, a = this._zoom * i;
                    this.zoomTo(a, !0), this.dollyToCursor && (this._changedZoom += a - r, this._dollyControlCoord.set(e, n));
                }, void 0 === tT && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = t1, this._yAxisUpSpace = (new tT.Quaternion).setFromUnitVectors(this._camera.up, nT), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = OS.NONE, this._target = new tT.Vector3, this._targetEnd = this._target.clone(), this._focalOffset = new tT.Vector3, this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = (new tT.Spherical).setFromVector3(aT.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
                    new tT.Vector3,
                    new tT.Vector3,
                    new tT.Vector3,
                    new tT.Vector3
                ], this._updateNearPlaneCorners(), this._boundary = new tT.Box3(new tT.Vector3(-1 / 0, -1 / 0, -1 / 0), new tT.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new tT.Vector2, this.mouseButtons = {
                    left: OS.ROTATE,
                    middle: OS.DOLLY,
                    right: OS.TRUCK,
                    wheel: RS(this._camera) ? OS.DOLLY : PS(this._camera) ? OS.ZOOM : OS.NONE
                }, this.touches = {
                    one: OS.TOUCH_ROTATE,
                    two: RS(this._camera) ? OS.TOUCH_DOLLY_TRUCK : PS(this._camera) ? OS.TOUCH_ZOOM_TRUCK : OS.NONE,
                    three: OS.TOUCH_TRUCK
                };
                const n = new tT.Vector2, i = new tT.Vector2, r = new tT.Vector2, a = (t1)=>{
                    if (!this._enabled || !this._domElement) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), n = t1.clientX / e.width, i = t1.clientY / e.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    const e = "mouse" !== t1.pointerType ? null : 1 & ~t1.buttons ? 4 & ~t1.buttons ? 2 & ~t1.buttons ? null : 2 : 4 : 1;
                    if (null !== e) {
                        const t1 = this._findPointerByMouseButton(e);
                        t1 && this._disposePointer(t1);
                    }
                    if (!(1 & ~t1.buttons) && this._lockedPointer) return;
                    const n = {
                        pointerId: t1.pointerId,
                        clientX: t1.clientX,
                        clientY: t1.clientY,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: e
                    };
                    this._activePointers.push(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), this._isDragging = !0, h(t1);
                }, s = (t1)=>{
                    t1.cancelable && t1.preventDefault();
                    const e = t1.pointerId, n = this._lockedPointer || this._findPointerById(e);
                    if (n) {
                        if (n.clientX = t1.clientX, n.clientY = t1.clientY, n.deltaX = t1.movementX, n.deltaY = t1.movementY, this._state = 0, "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else (!this._isDragging && this._lockedPointer || this._isDragging && !(1 & ~t1.buttons)) && (this._state = this._state | this.mouseButtons.left), this._isDragging && !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), this._isDragging && !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        d();
                    }
                }, o = (t1)=>{
                    const e = this._findPointerById(t1.pointerId);
                    if (!e || e !== this._lockedPointer) {
                        if (e && this._disposePointer(e), "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 0:
                                this._state = OS.NONE;
                                break;
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else this._state = OS.NONE;
                        p();
                    }
                };
                let l = -1;
                const c = (t1)=>{
                    if (!this._domElement) return;
                    if (!this._enabled || this.mouseButtons.wheel === OS.NONE) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), n = t1.clientX / e.width, i = t1.clientY / e.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    if (t1.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === OS.ROTATE || this.mouseButtons.wheel === OS.TRUCK) {
                        const t1 = performance.now();
                        l - t1 < 1e3 && this._getClientRect(this._elementRect), l = t1;
                    }
                    const e = $S ? -1 : -3, n = 1 === t1.deltaMode ? t1.deltaY / e : t1.deltaY / (10 * e), i = this.dollyToCursor ? (t1.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, r = this.dollyToCursor ? (t1.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                    switch(this.mouseButtons.wheel){
                        case OS.ROTATE:
                            this._rotateInternal(t1.deltaX, t1.deltaY), this._isUserControllingRotate = !0;
                            break;
                        case OS.TRUCK:
                            this._truckInternal(t1.deltaX, t1.deltaY, !1), this._isUserControllingTruck = !0;
                            break;
                        case OS.OFFSET:
                            this._truckInternal(t1.deltaX, t1.deltaY, !0), this._isUserControllingOffset = !0;
                            break;
                        case OS.DOLLY:
                            this._dollyInternal(-n, i, r), this._isUserControllingDolly = !0;
                            break;
                        case OS.ZOOM:
                            this._zoomInternal(-n, i, r), this._isUserControllingZoom = !0;
                    }
                    this.dispatchEvent({
                        type: "control"
                    });
                }, u = (t1)=>{
                    if (this._domElement && this._enabled) {
                        if (this.mouseButtons.right === wT.ACTION.NONE) {
                            const e = t1 instanceof PointerEvent ? t1.pointerId : 0, n = this._findPointerById(e);
                            return n && this._disposePointer(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                                passive: !1
                            }), void this._domElement.ownerDocument.removeEventListener("pointerup", o);
                        }
                        t1.preventDefault();
                    }
                }, h = (t1)=>{
                    if (this._enabled) {
                        if (YS(this._activePointers, rT), this._getClientRect(this._elementRect), n.copy(rT), i.copy(rT), this._activePointers.length >= 2) {
                            const t1 = rT.x - this._activePointers[1].clientX, e = rT.y - this._activePointers[1].clientY, n = Math.sqrt(t1 * t1 + e * e);
                            r.set(0, n);
                            const a = .5 * (this._activePointers[0].clientX + this._activePointers[1].clientX), s = .5 * (this._activePointers[0].clientY + this._activePointers[1].clientY);
                            i.set(a, s);
                        }
                        if (this._state = 0, t1) {
                            if ("pointerType" in t1 && "touch" === t1.pointerType) switch(this._activePointers.length){
                                case 1:
                                    this._state = this.touches.one;
                                    break;
                                case 2:
                                    this._state = this.touches.two;
                                    break;
                                case 3:
                                    this._state = this.touches.three;
                            }
                            else this._lockedPointer || !!(1 & ~t1.buttons) || (this._state = this._state | this.mouseButtons.left), !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        } else this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
                        (this._state & OS.ROTATE) !== OS.ROTATE && (this._state & OS.TOUCH_ROTATE) !== OS.TOUCH_ROTATE && (this._state & OS.TOUCH_DOLLY_ROTATE) !== OS.TOUCH_DOLLY_ROTATE && (this._state & OS.TOUCH_ZOOM_ROTATE) !== OS.TOUCH_ZOOM_ROTATE || (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), (this._state & OS.TRUCK) !== OS.TRUCK && (this._state & OS.TOUCH_TRUCK) !== OS.TOUCH_TRUCK && (this._state & OS.TOUCH_DOLLY_TRUCK) !== OS.TOUCH_DOLLY_TRUCK && (this._state & OS.TOUCH_ZOOM_TRUCK) !== OS.TOUCH_ZOOM_TRUCK || (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), (this._state & OS.DOLLY) !== OS.DOLLY && (this._state & OS.TOUCH_DOLLY) !== OS.TOUCH_DOLLY && (this._state & OS.TOUCH_DOLLY_TRUCK) !== OS.TOUCH_DOLLY_TRUCK && (this._state & OS.TOUCH_DOLLY_OFFSET) !== OS.TOUCH_DOLLY_OFFSET && (this._state & OS.TOUCH_DOLLY_ROTATE) !== OS.TOUCH_DOLLY_ROTATE || (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), (this._state & OS.ZOOM) !== OS.ZOOM && (this._state & OS.TOUCH_ZOOM) !== OS.TOUCH_ZOOM && (this._state & OS.TOUCH_ZOOM_TRUCK) !== OS.TOUCH_ZOOM_TRUCK && (this._state & OS.TOUCH_ZOOM_OFFSET) !== OS.TOUCH_ZOOM_OFFSET && (this._state & OS.TOUCH_ZOOM_ROTATE) !== OS.TOUCH_ZOOM_ROTATE || (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), (this._state & OS.OFFSET) !== OS.OFFSET && (this._state & OS.TOUCH_OFFSET) !== OS.TOUCH_OFFSET && (this._state & OS.TOUCH_DOLLY_OFFSET) !== OS.TOUCH_DOLLY_OFFSET && (this._state & OS.TOUCH_ZOOM_OFFSET) !== OS.TOUCH_ZOOM_OFFSET || (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                            type: "controlstart"
                        });
                    }
                }, d = ()=>{
                    if (!this._enabled || !this._dragNeedsUpdate) return;
                    this._dragNeedsUpdate = !1, YS(this._activePointers, rT);
                    const t1 = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, e = t1 ? -t1.deltaX : i.x - rT.x, a = t1 ? -t1.deltaY : i.y - rT.y;
                    if (i.copy(rT), (this._state & OS.ROTATE) !== OS.ROTATE && (this._state & OS.TOUCH_ROTATE) !== OS.TOUCH_ROTATE && (this._state & OS.TOUCH_DOLLY_ROTATE) !== OS.TOUCH_DOLLY_ROTATE && (this._state & OS.TOUCH_ZOOM_ROTATE) !== OS.TOUCH_ZOOM_ROTATE || (this._rotateInternal(e, a), this._isUserControllingRotate = !0), (this._state & OS.DOLLY) === OS.DOLLY || (this._state & OS.ZOOM) === OS.ZOOM) {
                        const t1 = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, e = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, i = this.dollyDragInverted ? -1 : 1;
                        (this._state & OS.DOLLY) === OS.DOLLY ? (this._dollyInternal(i * a * KS, t1, e), this._isUserControllingDolly = !0) : (this._zoomInternal(i * a * KS, t1, e), this._isUserControllingZoom = !0);
                    }
                    if ((this._state & OS.TOUCH_DOLLY) === OS.TOUCH_DOLLY || (this._state & OS.TOUCH_ZOOM) === OS.TOUCH_ZOOM || (this._state & OS.TOUCH_DOLLY_TRUCK) === OS.TOUCH_DOLLY_TRUCK || (this._state & OS.TOUCH_ZOOM_TRUCK) === OS.TOUCH_ZOOM_TRUCK || (this._state & OS.TOUCH_DOLLY_OFFSET) === OS.TOUCH_DOLLY_OFFSET || (this._state & OS.TOUCH_ZOOM_OFFSET) === OS.TOUCH_ZOOM_OFFSET || (this._state & OS.TOUCH_DOLLY_ROTATE) === OS.TOUCH_DOLLY_ROTATE || (this._state & OS.TOUCH_ZOOM_ROTATE) === OS.TOUCH_ZOOM_ROTATE) {
                        const t1 = rT.x - this._activePointers[1].clientX, e = rT.y - this._activePointers[1].clientY, n = Math.sqrt(t1 * t1 + e * e), a = r.y - n;
                        r.set(0, n);
                        const s = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, o = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                        (this._state & OS.TOUCH_DOLLY) === OS.TOUCH_DOLLY || (this._state & OS.TOUCH_DOLLY_ROTATE) === OS.TOUCH_DOLLY_ROTATE || (this._state & OS.TOUCH_DOLLY_TRUCK) === OS.TOUCH_DOLLY_TRUCK || (this._state & OS.TOUCH_DOLLY_OFFSET) === OS.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(a * KS, s, o), this._isUserControllingDolly = !0) : (this._zoomInternal(a * KS, s, o), this._isUserControllingZoom = !0);
                    }
                    (this._state & OS.TRUCK) !== OS.TRUCK && (this._state & OS.TOUCH_TRUCK) !== OS.TOUCH_TRUCK && (this._state & OS.TOUCH_DOLLY_TRUCK) !== OS.TOUCH_DOLLY_TRUCK && (this._state & OS.TOUCH_ZOOM_TRUCK) !== OS.TOUCH_ZOOM_TRUCK || (this._truckInternal(e, a, !1), this._isUserControllingTruck = !0), (this._state & OS.OFFSET) !== OS.OFFSET && (this._state & OS.TOUCH_OFFSET) !== OS.TOUCH_OFFSET && (this._state & OS.TOUCH_DOLLY_OFFSET) !== OS.TOUCH_DOLLY_OFFSET && (this._state & OS.TOUCH_ZOOM_OFFSET) !== OS.TOUCH_ZOOM_OFFSET || (this._truckInternal(e, a, !0), this._isUserControllingOffset = !0), this.dispatchEvent({
                        type: "control"
                    });
                }, p = ()=>{
                    YS(this._activePointers, rT), i.copy(rT), this._dragNeedsUpdate = !1, (0 === this._activePointers.length || 1 === this._activePointers.length && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), 0 === this._activePointers.length && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this.dispatchEvent({
                        type: "controlend"
                    }));
                };
                this.lockPointer = ()=>{
                    this._enabled && this._domElement && (this.cancel(), this._lockedPointer = {
                        pointerId: -1,
                        clientX: 0,
                        clientY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: null
                    }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", f), this._domElement.ownerDocument.addEventListener("pointerlockerror", m), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), h());
                }, this.unlockPointer = ()=>{
                    var t1, e, n;
                    null !== this._lockedPointer && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), null === (t1 = this._domElement) || void 0 === t1 || t1.ownerDocument.exitPointerLock(), null === (e = this._domElement) || void 0 === e || e.ownerDocument.removeEventListener("pointerlockchange", f), null === (n = this._domElement) || void 0 === n || n.ownerDocument.removeEventListener("pointerlockerror", m), this.cancel();
                };
                const f = ()=>{
                    this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
                }, m = ()=>{
                    this.unlockPointer();
                };
                this._addAllEventListeners = (t1)=>{
                    this._domElement = t1, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", o), this._domElement.addEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.addEventListener("contextmenu", u);
                }, this._removeAllEventListeners = ()=>{
                    this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", o), this._domElement.removeEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.removeEventListener("contextmenu", u), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.removeEventListener("pointerlockchange", f), this._domElement.ownerDocument.removeEventListener("pointerlockerror", m));
                }, this.cancel = ()=>{
                    this._state !== OS.NONE && (this._state = OS.NONE, this._activePointers.length = 0, p());
                }, e && this.connect(e), this.update(0);
            }
            get camera() {
                return this._camera;
            }
            set camera(t1) {
                this._camera = t1, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(t1) {
                this._enabled = t1, this._domElement && (t1 ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
            }
            get active() {
                return !this._hasRested;
            }
            get currentAction() {
                return this._state;
            }
            get distance() {
                return this._spherical.radius;
            }
            set distance(t1) {
                this._spherical.radius === t1 && this._sphericalEnd.radius === t1 || (this._spherical.radius = t1, this._sphericalEnd.radius = t1, this._needsUpdate = !0);
            }
            get azimuthAngle() {
                return this._spherical.theta;
            }
            set azimuthAngle(t1) {
                this._spherical.theta === t1 && this._sphericalEnd.theta === t1 || (this._spherical.theta = t1, this._sphericalEnd.theta = t1, this._needsUpdate = !0);
            }
            get polarAngle() {
                return this._spherical.phi;
            }
            set polarAngle(t1) {
                this._spherical.phi === t1 && this._sphericalEnd.phi === t1 || (this._spherical.phi = t1, this._sphericalEnd.phi = t1, this._needsUpdate = !0);
            }
            get boundaryEnclosesCamera() {
                return this._boundaryEnclosesCamera;
            }
            set boundaryEnclosesCamera(t1) {
                this._boundaryEnclosesCamera = t1, this._needsUpdate = !0;
            }
            set interactiveArea(t1) {
                this._interactiveArea.width = jS(t1.width, 0, 1), this._interactiveArea.height = jS(t1.height, 0, 1), this._interactiveArea.x = jS(t1.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = jS(t1.y, 0, 1 - this._interactiveArea.height);
            }
            addEventListener(t1, e) {
                super.addEventListener(t1, e);
            }
            removeEventListener(t1, e) {
                super.removeEventListener(t1, e);
            }
            rotate(t1, e, n = !1) {
                return this.rotateTo(this._sphericalEnd.theta + t1, this._sphericalEnd.phi + e, n);
            }
            rotateAzimuthTo(t1, e = !1) {
                return this.rotateTo(t1, this._sphericalEnd.phi, e);
            }
            rotatePolarTo(t1, e = !1) {
                return this.rotateTo(this._sphericalEnd.theta, t1, e);
            }
            rotateTo(t1, e, n = !1) {
                this._isUserControllingRotate = !1;
                const i = jS(t1, this.minAzimuthAngle, this.maxAzimuthAngle), r = jS(e, this.minPolarAngle, this.maxPolarAngle);
                this._sphericalEnd.theta = i, this._sphericalEnd.phi = r, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, n || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
                const a = !n || HS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && HS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            dolly(t1, e = !1) {
                return this.dollyTo(this._sphericalEnd.radius - t1, e);
            }
            dollyTo(t1, e = !1) {
                return this._isUserControllingDolly = !1, this._lastDollyDirection = 0, this._changedDolly = 0, this._dollyToNoClamp(jS(t1, this.minDistance, this.maxDistance), e);
            }
            _dollyToNoClamp(t1, e = !1) {
                const n = this._sphericalEnd.radius;
                if (this.colliderMeshes.length >= 1) {
                    const e = this._collisionTest(), i = HS(e, this._spherical.radius);
                    if (!(n > t1) && i) return Promise.resolve();
                    this._sphericalEnd.radius = Math.min(t1, e);
                } else this._sphericalEnd.radius = t1;
                this._needsUpdate = !0, e || (this._spherical.radius = this._sphericalEnd.radius);
                const i = !e || HS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(i);
            }
            dollyInFixed(t1, e = !1) {
                this._targetEnd.add(this._getCameraDirection(lT).multiplyScalar(t1)), e || this._target.copy(this._targetEnd);
                const n = !e || HS(this._target.x, this._targetEnd.x, this.restThreshold) && HS(this._target.y, this._targetEnd.y, this.restThreshold) && HS(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(n);
            }
            zoom(t1, e = !1) {
                return this.zoomTo(this._zoomEnd + t1, e);
            }
            zoomTo(t1, e = !1) {
                this._isUserControllingZoom = !1, this._zoomEnd = jS(t1, this.minZoom, this.maxZoom), this._needsUpdate = !0, e || (this._zoom = this._zoomEnd);
                const n = !e || HS(this._zoom, this._zoomEnd, this.restThreshold);
                return this._changedZoom = 0, this._createOnRestPromise(n);
            }
            pan(t1, e, n = !1) {
                return console.warn("`pan` has been renamed to `truck`"), this.truck(t1, e, n);
            }
            truck(t1, e, n = !1) {
                this._camera.updateMatrix(), cT.setFromMatrixColumn(this._camera.matrix, 0), uT.setFromMatrixColumn(this._camera.matrix, 1), cT.multiplyScalar(t1), uT.multiplyScalar(-e);
                const i = aT.copy(cT).add(uT), r = sT.copy(this._targetEnd).add(i);
                return this.moveTo(r.x, r.y, r.z, n);
            }
            forward(t1, e = !1) {
                aT.setFromMatrixColumn(this._camera.matrix, 0), aT.crossVectors(this._camera.up, aT), aT.multiplyScalar(t1);
                const n = sT.copy(this._targetEnd).add(aT);
                return this.moveTo(n.x, n.y, n.z, e);
            }
            elevate(t1, e = !1) {
                return aT.copy(this._camera.up).multiplyScalar(t1), this.moveTo(this._targetEnd.x + aT.x, this._targetEnd.y + aT.y, this._targetEnd.z + aT.z, e);
            }
            moveTo(t1, e, n, i = !1) {
                this._isUserControllingTruck = !1;
                const r = aT.set(t1, e, n).sub(this._targetEnd);
                this._encloseToBoundary(this._targetEnd, r, this.boundaryFriction), this._needsUpdate = !0, i || this._target.copy(this._targetEnd);
                const a = !i || HS(this._target.x, this._targetEnd.x, this.restThreshold) && HS(this._target.y, this._targetEnd.y, this.restThreshold) && HS(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            lookInDirectionOf(t1, e, n, i = !1) {
                const r = aT.set(t1, e, n).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
                return this.setPosition(r.x, r.y, r.z, i);
            }
            fitToBox(t1, e, { cover: n = !1, paddingLeft: i = 0, paddingRight: r = 0, paddingBottom: a = 0, paddingTop: s = 0 } = {}) {
                const o = [], l = t1.isBox3 ? gT.copy(t1) : gT.setFromObject(t1);
                l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
                const c = VS(this._sphericalEnd.theta, US), u = VS(this._sphericalEnd.phi, US);
                o.push(this.rotateTo(c, u, e));
                const h = aT.setFromSpherical(this._sphericalEnd).normalize(), d = yT.setFromUnitVectors(h, iT), p = HS(Math.abs(h.y), 1);
                p && d.multiply(MT.setFromAxisAngle(nT, c)), d.multiply(this._yAxisUpSpaceInverse);
                const f = AT.makeEmpty();
                sT.copy(l.min).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.min).setX(l.max.x).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.min).setY(l.max.y).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.max).setZ(l.min.z).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.min).setZ(l.max.z).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.max).setY(l.min.y).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.max).setX(l.min.x).applyQuaternion(d), f.expandByPoint(sT), sT.copy(l.max).applyQuaternion(d), f.expandByPoint(sT), f.min.x -= i, f.min.y -= a, f.max.x += r, f.max.y += s, d.setFromUnitVectors(iT, h), p && d.premultiply(MT.invert()), d.premultiply(this._yAxisUpSpace);
                const m = f.getSize(aT), g = f.getCenter(sT).applyQuaternion(d);
                if (RS(this._camera)) {
                    const t1 = this.getDistanceToFitBox(m.x, m.y, m.z, n);
                    o.push(this.moveTo(g.x, g.y, g.z, e)), o.push(this.dollyTo(t1, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                } else if (PS(this._camera)) {
                    const t1 = this._camera, i = t1.right - t1.left, r = t1.top - t1.bottom, a = n ? Math.max(i / m.x, r / m.y) : Math.min(i / m.x, r / m.y);
                    o.push(this.moveTo(g.x, g.y, g.z, e)), o.push(this.zoomTo(a, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                }
                return Promise.all(o);
            }
            fitToSphere(t1, e) {
                const n = [], i = t1 instanceof tT.Sphere ? vT.copy(t1) : wT.createBoundingSphere(t1, vT);
                if (n.push(this.moveTo(i.center.x, i.center.y, i.center.z, e)), RS(this._camera)) {
                    const t1 = this.getDistanceToFitSphere(i.radius);
                    n.push(this.dollyTo(t1, e));
                } else if (PS(this._camera)) {
                    const t1 = this._camera.right - this._camera.left, r = this._camera.top - this._camera.bottom, a = 2 * i.radius, s = Math.min(t1 / a, r / a);
                    n.push(this.zoomTo(s, e));
                }
                return n.push(this.setFocalOffset(0, 0, 0, e)), Promise.all(n);
            }
            setLookAt(t1, e, n, i, r, a, s = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const o = sT.set(i, r, a), l = aT.set(t1, e, n);
                this._targetEnd.copy(o), this._sphericalEnd.setFromVector3(l.sub(o).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, s || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const c = !s || HS(this._target.x, this._targetEnd.x, this.restThreshold) && HS(this._target.y, this._targetEnd.y, this.restThreshold) && HS(this._target.z, this._targetEnd.z, this.restThreshold) && HS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && HS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && HS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(c);
            }
            lerpLookAt(t1, e, n, i, r, a, s, o, l, c, u, h, d, p = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const f = aT.set(i, r, a), m = sT.set(t1, e, n);
                fT.setFromVector3(m.sub(f).applyQuaternion(this._yAxisUpSpace));
                const g = oT.set(c, u, h), A = sT.set(s, o, l);
                mT.setFromVector3(A.sub(g).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(f.lerp(g, d));
                const v = mT.theta - fT.theta, y = mT.phi - fT.phi, M = mT.radius - fT.radius;
                this._sphericalEnd.set(fT.radius + M * d, fT.phi + y * d, fT.theta + v * d), this.normalizeRotations(), this._needsUpdate = !0, p || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const b = !p || HS(this._target.x, this._targetEnd.x, this.restThreshold) && HS(this._target.y, this._targetEnd.y, this.restThreshold) && HS(this._target.z, this._targetEnd.z, this.restThreshold) && HS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && HS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && HS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(b);
            }
            setPosition(t1, e, n, i = !1) {
                return this.setLookAt(t1, e, n, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, i);
            }
            setTarget(t1, e, n, i = !1) {
                const r = this.getPosition(aT), a = this.setLookAt(r.x, r.y, r.z, t1, e, n, i);
                return this._sphericalEnd.phi = jS(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
            }
            setFocalOffset(t1, e, n, i = !1) {
                this._isUserControllingOffset = !1, this._focalOffsetEnd.set(t1, e, n), this._needsUpdate = !0, i || this._focalOffset.copy(this._focalOffsetEnd);
                const r = !i || HS(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && HS(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && HS(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
                return this._createOnRestPromise(r);
            }
            setOrbitPoint(t1, e, n) {
                this._camera.updateMatrixWorld(), cT.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), uT.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), hT.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
                const i = aT.set(t1, e, n), r = i.distanceTo(this._camera.position), a = i.sub(this._camera.position);
                cT.multiplyScalar(a.x), uT.multiplyScalar(a.y), hT.multiplyScalar(a.z), aT.copy(cT).add(uT).add(hT), aT.z = aT.z + r, this.dollyTo(r, !1), this.setFocalOffset(-aT.x, aT.y, -aT.z, !1), this.moveTo(t1, e, n, !1);
            }
            setBoundary(t1) {
                if (!t1) return this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), void (this._needsUpdate = !0);
                this._boundary.copy(t1), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
            }
            setViewport(t1, e, n, i) {
                null !== t1 ? (this._viewport = this._viewport || new tT.Vector4, "number" == typeof t1 ? this._viewport.set(t1, e, n, i) : this._viewport.copy(t1)) : this._viewport = null;
            }
            getDistanceToFitBox(t1, e, n, i = !1) {
                if (ZS(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
                const r = t1 / e, a = this._camera.getEffectiveFOV() * BS, s = this._camera.aspect;
                return .5 * ((i ? r > s : r < s) ? e : t1 / s) / Math.tan(.5 * a) + .5 * n;
            }
            getDistanceToFitSphere(t1) {
                if (ZS(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
                const e = this._camera.getEffectiveFOV() * BS, n = 2 * Math.atan(Math.tan(.5 * e) * this._camera.aspect), i = 1 < this._camera.aspect ? e : n;
                return t1 / Math.sin(.5 * i);
            }
            getTarget(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new tT.Vector3).copy(e ? this._targetEnd : this._target);
            }
            getPosition(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new tT.Vector3).setFromSpherical(e ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(e ? this._targetEnd : this._target);
            }
            getSpherical(t1, e = !0) {
                return (t1 && t1 instanceof tT.Spherical ? t1 : new tT.Spherical).copy(e ? this._sphericalEnd : this._spherical);
            }
            getFocalOffset(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new tT.Vector3).copy(e ? this._focalOffsetEnd : this._focalOffset);
            }
            normalizeRotations() {
                this._sphericalEnd.theta = this._sphericalEnd.theta % zS, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += zS), this._spherical.theta += zS * Math.round((this._sphericalEnd.theta - this._spherical.theta) / zS);
            }
            reset(t1 = !1) {
                if (!HS(this._camera.up.x, this._cameraUp0.x) || !HS(this._camera.up.y, this._cameraUp0.y) || !HS(this._camera.up.z, this._cameraUp0.z)) {
                    this._camera.up.copy(this._cameraUp0);
                    const t1 = this.getPosition(aT);
                    this.updateCameraUp(), this.setPosition(t1.x, t1.y, t1.z);
                }
                const e = [
                    this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, t1),
                    this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, t1),
                    this.zoomTo(this._zoom0, t1)
                ];
                return Promise.all(e);
            }
            saveState() {
                this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
            }
            updateCameraUp() {
                this._yAxisUpSpace.setFromUnitVectors(this._camera.up, nT), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
            }
            applyCameraUp() {
                const t1 = aT.subVectors(this._target, this._camera.position).normalize(), e = sT.crossVectors(t1, this._camera.up);
                this._camera.up.crossVectors(e, t1).normalize(), this._camera.updateMatrixWorld();
                const n = this.getPosition(aT);
                this.updateCameraUp(), this.setPosition(n.x, n.y, n.z);
            }
            update(t1) {
                const e = this._sphericalEnd.theta - this._spherical.theta, n = this._sphericalEnd.phi - this._spherical.phi, i = this._sphericalEnd.radius - this._spherical.radius, r = dT.subVectors(this._targetEnd, this._target), a = pT.subVectors(this._focalOffsetEnd, this._focalOffset), s = this._zoomEnd - this._zoom;
                if (FS(e)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.theta = WS(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (FS(n)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.phi = WS(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (FS(i)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
                else {
                    const e = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.radius = WS(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, e, this.maxSpeed, t1), this._needsUpdate = !0;
                }
                if (FS(r.x) && FS(r.y) && FS(r.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
                else {
                    const e = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
                    XS(this._target, this._targetEnd, this._targetVelocity, e, this.maxSpeed, t1, this._target), this._needsUpdate = !0;
                }
                if (FS(a.x) && FS(a.y) && FS(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
                else {
                    const e = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
                    XS(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, e, this.maxSpeed, t1, this._focalOffset), this._needsUpdate = !0;
                }
                if (FS(s)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
                else {
                    const e = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
                    this._zoom = WS(this._zoom, this._zoomEnd, this._zoomVelocity, e, 1 / 0, t1);
                }
                if (this.dollyToCursor) {
                    if (RS(this._camera) && 0 !== this._changedDolly) {
                        const t1 = this._spherical.radius - this._lastDistance, e = this._camera, n = this._getCameraDirection(lT), i = aT.copy(n).cross(e.up).normalize();
                        0 === i.lengthSq() && (i.x = 1);
                        const r = sT.crossVectors(i, n), a = this._sphericalEnd.radius * Math.tan(e.getEffectiveFOV() * BS * .5), s = (this._sphericalEnd.radius - t1 - this._sphericalEnd.radius) / this._sphericalEnd.radius, o = oT.copy(this._targetEnd).add(i.multiplyScalar(this._dollyControlCoord.x * a * e.aspect)).add(r.multiplyScalar(this._dollyControlCoord.y * a)), l = aT.copy(this._targetEnd).lerp(o, s), c = 1 === this._lastDollyDirection && this._spherical.radius <= this.minDistance, u = -1 === this._lastDollyDirection && this.maxDistance <= this._spherical.radius;
                        if (this.infinityDolly && (c || u)) {
                            this._sphericalEnd.radius -= t1, this._spherical.radius -= t1;
                            const e = sT.copy(n).multiplyScalar(-t1);
                            l.add(e);
                        }
                        this._boundary.clampPoint(l, l);
                        const h = sT.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedDolly -= t1, FS(this._changedDolly) && (this._changedDolly = 0);
                    } else if (PS(this._camera) && 0 !== this._changedZoom) {
                        const t1 = this._zoom - this._lastZoom, e = this._camera, n = aT.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (e.near + e.far) / (e.near - e.far)).unproject(e), i = sT.set(0, 0, -1).applyQuaternion(e.quaternion), r = oT.copy(n).add(i.multiplyScalar(-n.dot(e.up))), a = -(this._zoom - t1 - this._zoom) / this._zoom, s = this._getCameraDirection(lT), o = this._targetEnd.dot(s), l = aT.copy(this._targetEnd).lerp(r, a), c = l.dot(s), u = s.multiplyScalar(c - o);
                        l.sub(u), this._boundary.clampPoint(l, l);
                        const h = sT.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedZoom -= t1, FS(this._changedZoom) && (this._changedZoom = 0);
                    }
                }
                this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
                const o = this._collisionTest();
                this._spherical.radius = Math.min(this._spherical.radius, o), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!FS(this._focalOffset.x) || !FS(this._focalOffset.y) || !FS(this._focalOffset.z)) && (this._camera.updateMatrixWorld(), cT.setFromMatrixColumn(this._camera.matrix, 0), uT.setFromMatrixColumn(this._camera.matrix, 1), hT.setFromMatrixColumn(this._camera.matrix, 2), cT.multiplyScalar(this._focalOffset.x), uT.multiplyScalar(-this._focalOffset.y), hT.multiplyScalar(this._focalOffset.z), aT.copy(cT).add(uT).add(hT), this._camera.position.add(aT)), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), aT.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
                const l = this._needsUpdate;
                return l && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
                    type: "wake"
                }), this.dispatchEvent({
                    type: "update"
                })) : l ? (this.dispatchEvent({
                    type: "update"
                }), FS(e, this.restThreshold) && FS(n, this.restThreshold) && FS(i, this.restThreshold) && FS(r.x, this.restThreshold) && FS(r.y, this.restThreshold) && FS(r.z, this.restThreshold) && FS(a.x, this.restThreshold) && FS(a.y, this.restThreshold) && FS(a.z, this.restThreshold) && FS(s, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
                    type: "rest"
                }))) : !l && this._updatedLastTime && this.dispatchEvent({
                    type: "sleep"
                }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = l, this._needsUpdate = !1, l;
            }
            toJSON() {
                return JSON.stringify({
                    enabled: this._enabled,
                    minDistance: this.minDistance,
                    maxDistance: QS(this.maxDistance),
                    minZoom: this.minZoom,
                    maxZoom: QS(this.maxZoom),
                    minPolarAngle: this.minPolarAngle,
                    maxPolarAngle: QS(this.maxPolarAngle),
                    minAzimuthAngle: QS(this.minAzimuthAngle),
                    maxAzimuthAngle: QS(this.maxAzimuthAngle),
                    smoothTime: this.smoothTime,
                    draggingSmoothTime: this.draggingSmoothTime,
                    dollySpeed: this.dollySpeed,
                    truckSpeed: this.truckSpeed,
                    dollyToCursor: this.dollyToCursor,
                    verticalDragToForward: this.verticalDragToForward,
                    target: this._targetEnd.toArray(),
                    position: aT.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
                    zoom: this._zoomEnd,
                    focalOffset: this._focalOffsetEnd.toArray(),
                    target0: this._target0.toArray(),
                    position0: this._position0.toArray(),
                    zoom0: this._zoom0,
                    focalOffset0: this._focalOffset0.toArray()
                });
            }
            fromJSON(t1, e = !1) {
                const n = JSON.parse(t1);
                this.enabled = n.enabled, this.minDistance = n.minDistance, this.maxDistance = GS(n.maxDistance), this.minZoom = n.minZoom, this.maxZoom = GS(n.maxZoom), this.minPolarAngle = n.minPolarAngle, this.maxPolarAngle = GS(n.maxPolarAngle), this.minAzimuthAngle = GS(n.minAzimuthAngle), this.maxAzimuthAngle = GS(n.maxAzimuthAngle), this.smoothTime = n.smoothTime, this.draggingSmoothTime = n.draggingSmoothTime, this.dollySpeed = n.dollySpeed, this.truckSpeed = n.truckSpeed, this.dollyToCursor = n.dollyToCursor, this.verticalDragToForward = n.verticalDragToForward, this._target0.fromArray(n.target0), this._position0.fromArray(n.position0), this._zoom0 = n.zoom0, this._focalOffset0.fromArray(n.focalOffset0), this.moveTo(n.target[0], n.target[1], n.target[2], e), fT.setFromVector3(aT.fromArray(n.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(fT.theta, fT.phi, e), this.dollyTo(fT.radius, e), this.zoomTo(n.zoom, e), this.setFocalOffset(n.focalOffset[0], n.focalOffset[1], n.focalOffset[2], e), this._needsUpdate = !0;
            }
            connect(t1) {
                this._domElement ? console.warn("camera-controls is already connected.") : (t1.setAttribute("data-camera-controls-version", "2.8.3"), this._addAllEventListeners(t1), this._getClientRect(this._elementRect));
            }
            disconnect() {
                this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
            }
            dispose() {
                this.removeAllEventListeners(), this.disconnect();
            }
            _getTargetDirection(t1) {
                return t1.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
            }
            _getCameraDirection(t1) {
                return this._getTargetDirection(t1).negate();
            }
            _findPointerById(t1) {
                return this._activePointers.find((e)=>e.pointerId === t1);
            }
            _findPointerByMouseButton(t1) {
                return this._activePointers.find((e)=>e.mouseButton === t1);
            }
            _disposePointer(t1) {
                this._activePointers.splice(this._activePointers.indexOf(t1), 1);
            }
            _encloseToBoundary(t1, e, n) {
                const i = e.lengthSq();
                if (0 === i) return t1;
                const r = sT.copy(e).add(t1), a = this._boundary.clampPoint(r, oT).sub(r), s = a.lengthSq();
                if (0 === s) return t1.add(e);
                if (s === i) return t1;
                if (0 === n) return t1.add(e).add(a);
                {
                    const i = 1 + n * s / e.dot(a);
                    return t1.add(sT.copy(e).multiplyScalar(i)).add(a.multiplyScalar(1 - n));
                }
            }
            _updateNearPlaneCorners() {
                if (RS(this._camera)) {
                    const t1 = this._camera, e = t1.near, n = t1.getEffectiveFOV() * BS, i = Math.tan(.5 * n) * e, r = i * t1.aspect;
                    this._nearPlaneCorners[0].set(-r, -i, 0), this._nearPlaneCorners[1].set(r, -i, 0), this._nearPlaneCorners[2].set(r, i, 0), this._nearPlaneCorners[3].set(-r, i, 0);
                } else if (PS(this._camera)) {
                    const t1 = this._camera, e = 1 / t1.zoom, n = t1.left * e, i = t1.right * e, r = t1.top * e, a = t1.bottom * e;
                    this._nearPlaneCorners[0].set(n, r, 0), this._nearPlaneCorners[1].set(i, r, 0), this._nearPlaneCorners[2].set(i, a, 0), this._nearPlaneCorners[3].set(n, a, 0);
                }
            }
            _collisionTest() {
                let t1 = 1 / 0;
                if (!(this.colliderMeshes.length >= 1)) return t1;
                if (ZS(this._camera, "_collisionTest")) return t1;
                const e = this._getTargetDirection(lT);
                bT.lookAt(eT, e, this._camera.up);
                for(let n = 0; n < 4; n++){
                    const i = sT.copy(this._nearPlaneCorners[n]);
                    i.applyMatrix4(bT);
                    const r = oT.addVectors(this._target, i);
                    xT.set(r, e), xT.far = this._spherical.radius + 1;
                    const a = xT.intersectObjects(this.colliderMeshes);
                    0 !== a.length && a[0].distance < t1 && (t1 = a[0].distance);
                }
                return t1;
            }
            _getClientRect(t1) {
                if (!this._domElement) return;
                const e = this._domElement.getBoundingClientRect();
                return t1.x = e.left, t1.y = e.top, this._viewport ? (t1.x += this._viewport.x, t1.y += e.height - this._viewport.w - this._viewport.y, t1.width = this._viewport.z, t1.height = this._viewport.w) : (t1.width = e.width, t1.height = e.height), t1;
            }
            _createOnRestPromise(t1) {
                return t1 ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
                    type: "transitionstart"
                }), new Promise((t1)=>{
                    const e = ()=>{
                        this.removeEventListener("rest", e), t1();
                    };
                    this.addEventListener("rest", e);
                }));
            }
            _addAllEventListeners(t1) {}
            _removeAllEventListeners() {}
            get dampingFactor() {
                return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
            }
            set dampingFactor(t1) {
                console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
            }
            get draggingDampingFactor() {
                return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
            }
            set draggingDampingFactor(t1) {
                console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
            }
            static createBoundingSphere(t1, e = new tT.Sphere) {
                const n = e, i = n.center;
                gT.makeEmpty(), t1.traverseVisible((t1)=>{
                    t1.isMesh && gT.expandByObject(t1);
                }), gT.getCenter(i);
                let r = 0;
                return t1.traverseVisible((t1)=>{
                    if (!t1.isMesh) return;
                    const e = t1, n = e.geometry.clone();
                    n.applyMatrix4(e.matrixWorld);
                    const a = n.attributes.position;
                    for(let t1 = 0, e = a.count; t1 < e; t1++)aT.fromBufferAttribute(a, t1), r = Math.max(r, i.distanceToSquared(aT));
                }), n.radius = Math.sqrt(r), n;
            }
        }
        function _T(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        wT.install({
            THREE: t1
        });
        const ET = class extends wT {
            constructor(t1, e){
                super(e, t1.domElement), _T(this, "disableAutoRotate", !1), _T(this, "userDragging", !1), _T(this, "_renderer", void 0), _T(this, "_camera", void 0), this._renderer = t1, this._camera = e, this.mouseButtons.middle = wT.ACTION.NONE, this.mouseButtons.left = wT.ACTION.ROTATE, this.mouseButtons.right = wT.ACTION.NONE, this.mouseButtons.wheel = wT.ACTION.NONE, this.touches.three = wT.ACTION.NONE, this.touches.two = wT.ACTION.NONE, this.touches.one = wT.ACTION.TOUCH_ROTATE, this.verticalDragToForward = !0, this.azimuthRotateSpeed = -0.25, this.polarRotateSpeed = -0.25, this.maxDistance = .001, this.truckSpeed = 1e4, this.minDistance = 0, this.dollySpeed = 0, this.minZoom = 1, this.maxZoom = 2, this.rotateTo(0, Math.PI / 2), this.setDefaultPosition(), this.addListeners();
            }
            setDefaultPosition() {
                this.moveTo(0, 0, 0), this.dollyTo(1e-9), this.zoomTo(1);
            }
            onRest() {
                this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !1, this.holding = !1;
            }
            onControlStart() {
                this.currentAction !== wT.ACTION.NONE && (this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !0, this.holding = !0);
            }
            onControlEnd() {
                this.active ? this.addEventListener("rest", this.onRest) : this.onRest();
            }
            onTransitionStart() {
                this.holding || (this.disableAutoRotate = !0, this.addEventListener("rest", this.onRest));
            }
            addListeners() {
                this.addEventListener("transitionstart", this.onTransitionStart), this.addEventListener("controlstart", this.onControlStart), this.addEventListener("controlend", this.onControlEnd);
            }
        };
        function ST(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const TT = class extends th {
            constructor(t1){
                super(60, 1, .1, 1e4), ST(this, "deviceOrientationControls", void 0), ST(this, "controls", void 0), this.controls = new ET(t1, this), this.deviceOrientationControls = new LS(this, t1.domElement);
            }
        };
        const IT = class extends qp {
            constructor(){
                var t1, e, n;
                super(), t1 = this, n = void 0, e = function(t1) {
                    var e = function(t1, e) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var n = t1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "controls"), e in t1 ? Object.defineProperty(t1, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = n, this.background = new Jc(16777215), this.add(new jA(new Jc(16777215), 3));
            }
        }, CT = (t1)=>{
            t1.preventDefault();
        }, NT = async (t1)=>{
            const e = new Promise((e)=>{
                const n = new Image;
                n.onload = ()=>e(n), n.src = t1;
            });
            return await e;
        }, DT = (t1, e, n, i, r, a)=>{
            let s = a;
            i < 2 * s && (s = i / 2), r < 2 * a && (s = r / 2), t1.beginPath(), t1.moveTo(e + s, n), t1.arcTo(e + i, n, e + i, n + r, s), t1.arcTo(e + i, n + r, e, n + r, s), t1.arcTo(e, n + r, e, n, s), t1.arcTo(e, n, e + i, n, s), t1.closePath();
        }, LT = function(t1) {
            var e, n;
            let i = null !== (e = null === (n = Vi.dictionaryOverrides) || void 0 === n ? void 0 : n[t1]) && void 0 !== e ? e : Fi.getLocaleText(t1);
            for(var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)a[s - 1] = arguments[s];
            return Vi.config.floorNumberEndingsVisible && "floor" === t1 ? a.reduce((t1, e, n)=>{
                var i;
                return t1.replaceAll("$".concat(n), e + (null !== (i = Fi.getLocaleText("floorNumberEndings")[e]) && void 0 !== i ? i : Fi.getLocaleText("floorNumberEndings").rest));
            }, i) : a.reduce((t1, e, n)=>t1.replaceAll("$".concat(n), e), i);
        };
        function OT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const RT = class extends Gu {
            constructor(){
                super(), OT(this, "canvas", document.createElement("canvas")), OT(this, "interactive", !0), OT(this, "height", 775), OT(this, "width", 775), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            onHoverStart() {
                this.scale.setScalar(1.15);
            }
            onHoverEnd() {
                this.scale.setScalar(1);
            }
            createGeomtery() {
                this.geometry = new fh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    side: pr,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await e.blob();
                return await NT(URL.createObjectURL(n));
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
            async updateMaterial(t1) {
                const e = "".concat(t1 + 1, " ").concat(LT("floor")), n = Vi.config.colors.mainText, i = Vi.getFloorConfig(t1);
                return this.loadImage(i.planImage).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", DT(this.context, 0, 0, this.canvas.width, this.canvas.height, 50), this.context.fill(), this.context.drawImage(t1, 165, 75, 450, 450), this.context.textAlign = "center", this.context.font = "Bold 80px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillColor = n, this.context.fillText(e, this.canvas.width / 2, this.canvas.height - 100), this.context.fillRect((this.canvas.width - 430) / 2, this.canvas.height - 55, 430, 5), this.material.map || (this.material.map = ob(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
        };
        function PT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const zT = class extends Gu {
            constructor(){
                super(), PT(this, "canvas", document.createElement("canvas")), PT(this, "height", 700), PT(this, "width", 700), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeomtery() {
                this.geometry = new fh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    side: pr,
                    opacity: 1
                }), this;
            }
            updateMaterial() {
                const t1 = "".concat(Vi.currentFloorIndex + 1, " ").concat(LT("floor")), e = Vi.config.colors.mainText;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.textAlign = "center", this.context.font = "Bold 140px/1 Roboto Mono", this.context.fillStyle = e, this.context.fillColor = e, this.context.fillText(t1, this.canvas.width / 2, this.canvas.height / 2), this.context.fillRect(0, this.canvas.height / 2 + 50, this.canvas.width, 5), this.material.map || (this.material.map = ob(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
        };
        function UT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const kT = class extends Gu {
            constructor(){
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                super(), UT(this, "canvas", document.createElement("canvas")), UT(this, "isContainer", !0), this.canvas.width = t1, this.canvas.height = 120, this.createGeometry(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new fh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(20, 20, 20, 0.26)", DT(this.context, 0, 0, this.canvas.width, this.canvas.height, 64), this.context.fill();
                const t1 = ob(this.canvas);
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    side: pr,
                    map: t1,
                    opacity: 1
                }), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function BT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const jT = class extends Gu {
            constructor(t1){
                super(), BT(this, "canvas", document.createElement("canvas")), BT(this, "interactive", !0), BT(this, "isButton", !0), this.canvas.height = 92, this.canvas.width = 92, this.createGeometry(), this.createMaterial(), this.update(t1), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.position.set(0, 0, 1), this.renderOrder = 6;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            createGeometry() {
                return this.geometry = new fh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    side: pr,
                    opacity: 1
                }), this;
            }
            update(t1) {
                return NT(t1).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", DT(this.context, 0, 0, this.canvas.width, this.canvas.height, 46), this.context.fill(), this.context.drawImage(t1, 20, 20, 52, 52), this.material.map || (this.material.map = ob(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
        };
        function FT(t1, e) {
            let n = t1[0], i = t1[1], r = !1;
            for(let t1 = 0, a = e.length - 1; t1 < e.length; a = t1++){
                const s = e[t1][0], o = e[t1][1], l = e[a][0], c = e[a][1];
                o > i != c > i && n < (l - s) * (i - o) / (c - o) + s && (r = !r);
            }
            return r;
        }
        function HT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const VT = class extends Bp {
            constructor(){
                super(), HT(this, "planScale", new tl(1, 1)), HT(this, "currentPanoramasGroup", void 0), HT(this, "padding", 16), HT(this, "rooms", []), this.scale.set(1, -1, 1), this.renderOrder = 6;
            }
            updateScale(t1) {
                let { X: e, Y: n } = t1;
                return this.planScale.x = e, this.planScale.y = n, this.deleteRooms(), this.createRooms(this.currentPanoramasGroup), this;
            }
            showRoomById(t1) {
                return this.rooms.forEach((e)=>{
                    e.material.opacity = e.userData.id === t1 ? .3 : 0;
                }), this;
            }
            createRooms(t1) {
                return this.currentPanoramasGroup = t1, this.currentPanoramasGroup.children.forEach((t1)=>{
                    let { userData: e, panoramaId: n } = t1;
                    const i = e.points.map((t1)=>{
                        let [e, n] = t1;
                        return [
                            this.padding + 2 * e * this.planScale.x,
                            this.padding + 2 * n * this.planScale.y
                        ];
                    }).filter((t1)=>{
                        let [e, n] = t1;
                        return !isNaN(e) && !isNaN(n);
                    });
                    if (!i.length) return;
                    const r = this.padding + 2 * e.left * this.planScale.x, a = this.padding + 2 * e.top * this.planScale.y, s = new Ym;
                    s.moveTo(i[0][0], i[0][1]), i.forEach((t1)=>{
                        let [e, n] = t1;
                        return s.lineTo(e, n);
                    });
                    const o = new Tg(s), l = new kg({
                        color: new Jc(Vi.config.colors.main),
                        transparent: !0,
                        side: pr,
                        opacity: 0
                    }), c = new Gu(o, l);
                    c.userData = {
                        id: n,
                        points: i,
                        left: r,
                        top: a
                    }, this.rooms.push(c), this.add(c);
                }), this;
            }
            deleteRooms() {
                return this.rooms.forEach((t1)=>{
                    t1.material.dispose(), t1.removeFromParent();
                }), this.rooms = [], this;
            }
        };
        function QT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const GT = class extends Gu {
            constructor(){
                super(), QT(this, "height", 140), QT(this, "width", 140), this.createGeometry(), this.createMaterial(), this.renderOrder = 7;
            }
            createGeometry() {
                return this.geometry = new fh(this.width, this.height, 10, 10), this;
            }
            createMaterial() {
                const t1 = this.width / 2, e = this.height / 2, n = Math.PI / 3 * 4, i = n + Math.PI / 3, r = document.createElement("canvas"), a = r.getContext("2d");
                return r.height = this.height, r.width = this.width, a.clearRect(0, 0, this.width, this.height), a.globalAlpha = .4, a.beginPath(), a.moveTo(t1, e), a.fillStyle = Vi.config.colors.main, a.arc(t1, e, 70, n, i), a.lineTo(t1, e), a.fill(), a.closePath(), a.globalAlpha = 1, a.beginPath(), a.fillStyle = Vi.config.colors.main, a.arc(t1, e, 16, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = "rgba(255, 255, 255, 1)", a.arc(t1, e, 12, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = Vi.config.colors.main, a.arc(t1, e, 8, 0, 2 * Math.PI), a.fill(), a.closePath(), this.material = new kg({
                    map: ob(r),
                    color: new Jc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    opacity: 1
                }), this;
            }
            update(t1, e, n) {
                this.position.set(t1, e, 10), this.rotation.set(0, 0, n);
            }
        };
        function WT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const XT = class extends Gu {
            constructor(){
                super(), WT(this, "planScale", new tl(1, 1)), WT(this, "pointer", new tl(-1, -1)), WT(this, "interactive", !0), WT(this, "boundingScale", 4), WT(this, "padding", 16), WT(this, "hoverRoom", void 0), WT(this, "fovLayer", void 0), WT(this, "height", void 0), WT(this, "width", void 0), this.height = 200, this.width = 200, this.createGeometry(), this.createMaterial(), this.creteRoomsLayer(), this.createFovLayer(), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.addEventListener("click", this.handleClick), this.renderOrder = 5;
            }
            createGeometry() {
                return this.geometry = new fh(this.width, this.height, 100, 100), this;
            }
            createMaterial() {
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    side: pr,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await e.blob();
                return this.image = new Image, this.image.onload = ()=>this.updateMaterial(), this.image.src = URL.createObjectURL(n), this;
            }
            createFovLayer() {
                return this.fovLayer = new GT, this.add(this.fovLayer), this;
            }
            creteRoomsLayer() {
                return this.roomsLayer = new VT, this.add(this.roomsLayer), this;
            }
            setDisabledState(t1) {
                this.disabled = t1;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? this.boundingScale : 0);
            }
            onHoverStart(t1) {
                const { x: e, y: n } = t1.data, i = this.height * n, r = this.width * e;
                this.pointer.x = r, this.pointer.y = i;
            }
            onHoverEnd() {
                this.pointer.x = -1, this.pointer.y = -1;
            }
            handleClick() {
                this.hoverRoom && (this.onClick(this.hoverRoom.userData.id), this.dispatchEvent({
                    type: "closemap"
                }));
            }
            onClick() {}
            updateMaterial() {
                const t1 = document.createElement("canvas"), e = t1.getContext("2d");
                return t1.height = this.height, t1.width = this.width, e.fillStyle = "rgba(255, 255, 255, 1)", DT(e, 0, 0, this.width, this.height, 20), e.fill(), this.image && e.drawImage(this.image, this.padding, this.padding, this.width - 2 * this.padding, this.height - 2 * this.padding), this.material.map && this.material.map.dispose(), this.material.map = ob(t1), this.material.needsUpdate = !0, this;
            }
            updateSize(t1, e) {
                this.height = e + 2 * this.padding, this.width = t1 + 2 * this.padding, this.roomsLayer.position.set(-this.width / 2, this.height / 2, 5), this.createGeometry();
                const n = Math.min(this.width / this.height, 1);
                return this.boundingScale = 5 * n, this.setVisibility(this.visible), this;
            }
            updateScale(t1) {
                let { X: e, Y: n } = t1;
                return this.planScale.x = e, this.planScale.y = n, this.roomsLayer.updateScale({
                    X: e,
                    Y: n
                }), this;
            }
            updateRoomsLayer(t1) {
                return this.roomsLayer.deleteRooms(), this.roomsLayer.createRooms(t1), this;
            }
            update(t1, e, n) {
                var i;
                if (n) {
                    const t1 = this.roomsLayer.rooms.filter((t1)=>FT([
                            this.pointer.x,
                            this.pointer.y
                        ], t1.userData.points));
                    this.hoverRoom = hb([
                        this.pointer.x,
                        this.pointer.y
                    ], t1).panorama;
                }
                if (this.roomsLayer.showRoomById((null === (i = this.hoverRoom) || void 0 === i ? void 0 : i.userData.id) || null), !this.disabled && e) {
                    const n = this.padding + 2 * e.userData.left * this.planScale.x, i = this.padding + 2 * e.userData.top * this.planScale.y, r = this.height / 2, a = n - this.width / 2, s = -1 * (i - r);
                    this.fovLayer.update(a, s, t1);
                }
                return this;
            }
        }, YT = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xODQ4XzYyNCkiPg0KPHBhdGggZD0iTTE4LjgyMjYgMS44NzQ4OUwxLjg3NTA1IDE4LjgyMjRDMS40NzYwMSAxOS4yMjE0IDEuNDQxNSAxOS44MzM5IDEuNzk3OTcgMjAuMTkwNEw3LjgwOTQ4IDI2LjIwMTlDOC4xNjU5NSAyNi41NTgzIDguNzc4NDIgMjYuNTIzOCA5LjE3NzQ2IDI2LjEyNDhMMjYuMTI1IDkuMTc3MjlDMjYuNTI0IDguNzc4MjUgMjYuNTU4NSA4LjE2NTc5IDI2LjIwMiA3LjgwOTMyTDIwLjE5MDUgMS43OTc4MUMxOS44MzQxIDEuNDQxMzQgMTkuMjIxNiAxLjQ3NTg1IDE4LjgyMjYgMS44NzQ4OVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xMC45MjY5IDEwLjkyNjhMMTQuMDE0MiAxNC4wMTQiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik02LjMyODc0IDE1LjUyNDlMMTAuNDE2IDE5LjYxMjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvZz4NCjxkZWZzPg0KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQ4XzYyNCI+DQo8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IndoaXRlIi8+DQo8L2NsaXBQYXRoPg0KPC9kZWZzPg0KPC9zdmc+DQo=";
        function ZT(t1, e, n) {
            !function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            }(t1, e), e.set(t1, n);
        }
        function qT(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        function JT(t1, e) {
            return t1.get($T(t1, e));
        }
        function KT(t1, e, n) {
            return t1.set($T(t1, e), n), n;
        }
        function $T(t1, e, n) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : n;
            throw new TypeError("Private element is not present on this object");
        }
        var tI = new WeakMap, eI = new WeakMap;
        const nI = class extends Bp {
            constructor(){
                super(), qT(this, "mapGroup", new Bp), ZT(this, tI, void 0), ZT(this, eI, void 0), qT(this, "prevFloorButton", void 0), qT(this, "nextFloorButton", void 0), qT(this, "rulerButton", void 0), qT(this, "floorTitle", void 0), qT(this, "exitButton", void 0), qT(this, "mapButton", void 0), qT(this, "container", void 0), qT(this, "map", void 0), this.createContainer(), this.createButtons(), this.createMap(), this.createFloorTitle(), this.createPrevFloorButton(), this.createNextFloorButton(), this.closeMap(), this.mapButton.setVisibility(!1), this.setVisibility(!1), this.mapGroup.position.set(0, 2e3, -2500), this.mapGroup.rotation.set(mb(30), 0, 0), this.add(this.mapGroup);
            }
            set rulerButtonAvailable(t1) {
                KT(tI, this, t1), this.map.visible || this.setRulerButtonVisibility(t1);
            }
            set mapButtonAvailable(t1) {
                KT(eI, this, t1), this.map.visible || this.setMapButtonVisibility(t1);
            }
            onRulerButtonClick() {}
            onExitButtonClick() {}
            createContainer() {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                if (this.container) {
                    const e = new kT(t1);
                    this.container.geometry = e.geometry.clone(), this.container.material = e.material.clone(), e.dispose();
                } else this.container = new kT(t1), this.add(this.container);
                return this;
            }
            createButtons() {
                return this.exitButton = new jT("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMy4xNjYxIDQuODMzOThMMTQgMTQuMDAwMU0xNCAxNC4wMDAxTDQuODMzOCAyMy4xNjYzTTE0IDE0LjAwMDFMMjMuMTY2MSAyMy4xNjYzTTE0IDE0LjAwMDFMNC44MzM4IDQuODMzOTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjwvc3ZnPg0K"), this.exitButton.onClick = (t1)=>{
                    if (this.map.visible) return this.closeMap();
                    this.onExitButtonClick(t1);
                }, this.rulerButton = new jT(YT), this.rulerButton.onClick = (t1)=>this.onRulerButtonClick(t1), this.mapButton = new jT("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yNC4yMTE0IDI0LjQyMTFIMy43ODg2NUMzLjYyNzQ4IDI0LjQyMTEgMy40OTY4MyAyNC4yOTA0IDMuNDk2ODMgMjQuMTI5M0wzLjQ5Njc3IDQuMDY2MjRDMy40OTY3NyAzLjkwNTA3IDMuNjI3NDIgMy43NzQ0MSAzLjc4ODU5IDMuNzc0NDFIMjQuMjExNEMyNC4zNzI1IDMuNzc0NDEgMjQuNTAzMiAzLjkwNTA3IDI0LjUwMzIgNC4wNjYyNFYyNC4xMjkzQzI0LjUwMzIgMjQuMjkwNCAyNC4zNzI1IDI0LjQyMTEgMjQuMjExNCAyNC40MjExWiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiLz4NCjxwYXRoIGQ9Ik00LjAwMTQ2IDEwLjA0NTRIMTMuMzY4NEMxMy41Mjk2IDEwLjA0NTQgMTMuNjYwMiAxMC4xNzYxIDEzLjY2MDIgMTAuMzM3MlYyNC4yMDU5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS40NTkxIi8+DQo8cGF0aCBkPSJNMjQuNTAzMiAxMS4wNjU2SDE4LjM2NTFDMTguMjA0IDExLjA2NTYgMTguMDczMyAxMC45MzQ5IDE4LjA3MzMgMTAuNzczOFYzLjU3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjQ1OTEiLz4NCjwvc3ZnPg0K"), this.mapButton.onClick = (t1)=>this.openMap(t1), this.add(this.exitButton, this.rulerButton, this.mapButton), this;
            }
            createMap() {
                return this.map = new XT, this.map.addEventListener("closemap", this.closeMap.bind(this)), this.mapGroup.add(this.map), this;
            }
            createFloorTitle() {
                return this.floorTitle = new zT, this.mapGroup.add(this.floorTitle), this;
            }
            createNextFloorButton() {
                return this.nextFloorButton = new RT, this.mapGroup.add(this.nextFloorButton), this;
            }
            createPrevFloorButton() {
                return this.prevFloorButton = new RT, this.mapGroup.add(this.prevFloorButton), this;
            }
            openMap() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Vi.prevFloorIndex), this.nextFloorButton.updateMaterial(Vi.nextFloorIndex), this.mapGroup.visible = !0, this.map.setVisibility(!0), this.rulerButton.setVisibility(!1), this.setMapButtonVisibility(!1);
                const t1 = Vi.configParams.floors.length > 1;
                this.prevFloorButton.setVisibility(t1), this.nextFloorButton.setVisibility(t1);
            }
            closeMap() {
                this.mapGroup.visible = !1, this.map.setVisibility(!1), this.rulerButton.setVisibility(JT(tI, this)), this.setMapButtonVisibility(!0), this.prevFloorButton.setVisibility(!1), this.nextFloorButton.setVisibility(!1);
            }
            setRulerButtonVisibility(t1) {
                this.rulerButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setMapButtonVisibility(t1) {
                this.mapButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setVisibility(t1) {
                t1 ? (this.setRulerButtonVisibility(JT(tI, this)), this.setMapButtonVisibility(JT(eI, this))) : (this.setRulerButtonVisibility(!1), this.setMapButtonVisibility(!1)), this.exitButton.setVisibility(t1), this.container.visible = t1, this.visible = t1, this.scale.setScalar(t1 ? 6e-4 : 0);
            }
            setRulerIcon(t1) {
                return t1 ? this.rulerButton.update("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xODQ4XzY1OSkiPg0KPHBhdGggZD0iTTE4LjgyMjYgMS44NzQ4OUwxLjg3NTA1IDE4LjgyMjRDMS40NzYwMSAxOS4yMjE0IDEuNDQxNSAxOS44MzM5IDEuNzk3OTcgMjAuMTkwNEw3LjgwOTQ4IDI2LjIwMTlDOC4xNjU5NSAyNi41NTgzIDguNzc4NDIgMjYuNTIzOCA5LjE3NzQ2IDI2LjEyNDhMMjYuMTI1IDkuMTc3MjlDMjYuNTI0IDguNzc4MjUgMjYuNTU4NSA4LjE2NTc5IDI2LjIwMiA3LjgwOTMyTDIwLjE5MDUgMS43OTc4MUMxOS44MzQxIDEuNDQxMzQgMTkuMjIxNiAxLjQ3NTg1IDE4LjgyMjYgMS44NzQ4OVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xMC45MjY5IDEwLjkyNjhMMTQuMDE0MiAxNC4wMTQiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik02LjMyODc0IDE1LjUyNDlMMTAuNDE2IDE5LjYxMjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxyZWN0IHg9IjEwLjYyNDYiIHk9IjYuMjkzNDYiIHdpZHRoPSIxNS44MDAyIiBoZWlnaHQ9IjMuNjYxNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTAuNjI0NiA2LjI5MzQ2KSIgZmlsbD0id2hpdGUiLz4NCjxwYXRoIGQ9Ik0zLjAwNjI5IDQuNzExNDNMMjIuOTkzOCAyNS4yODc5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L2c+DQo8ZGVmcz4NCjxjbGlwUGF0aCBpZD0iY2xpcDBfMTg0OF82NTkiPg0KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSJ3aGl0ZSIvPg0KPC9jbGlwUGF0aD4NCjwvZGVmcz4NCjwvc3ZnPg0K") : this.rulerButton.update(YT);
            }
            updateButtonsPositions() {
                return this.map.visible ? (this.exitButton.position.x = 0, void this.createContainer(120)) : this.mapButton.visible ? this.rulerButton.visible ? (this.rulerButton.position.x = 0, this.exitButton.position.x = 140, this.mapButton.position.x = -140, void this.createContainer(400)) : (this.exitButton.position.x = 70, this.mapButton.position.x = -70, void this.createContainer(260)) : this.rulerButton.visible ? (this.rulerButton.position.x = -70, this.exitButton.position.x = 70, void this.createContainer(260)) : (this.exitButton.position.x = 0, void this.createContainer(120));
            }
            updateFloorMaterials() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Vi.prevFloorIndex), this.nextFloorButton.updateMaterial(Vi.nextFloorIndex);
            }
            updateFloorTitlePosition() {
                const t1 = 210 + this.map.height * this.map.scale.y / 2;
                this.floorTitle.position.set(0, t1, 0);
            }
            updateFloorButtonsPositions() {
                const { width: t1, height: e } = this.nextFloorButton, n = e / 2 - this.map.height * this.map.scale.y / 2, i = t1 / 2 + 200 + this.map.width * this.map.scale.x / 2;
                this.prevFloorButton.position.set(-i, n, 0), this.nextFloorButton.position.set(i, n, 0);
            }
            update(t1, e, n, i) {
                this.map.visible && this.map.update(e, n, i);
                const r = new Ol(.025, -0.5, -0.9);
                r.applyMatrix4(t1.matrixWorld);
                const a = new yc(0, 0, 0);
                a.setFromRotationMatrix(t1.matrixWorld), this.position.copy(r), this.rotation.copy(a), this.rotateX(mb(-30)), this.updateMatrix(), this.updateFloorTitlePosition(), this.updateFloorButtonsPositions();
            }
        };
        const iI = class extends Gu {
            constructor(){
                var t1, e, n;
                super(), t1 = this, n = !0, e = function(t1) {
                    var e = function(t1, e) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var n = t1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "isDistanceLine"), e in t1 ? Object.defineProperty(t1, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = n, this.createGeometry(), this.createMaterial(), this.renderOrder = 3;
            }
            createGeometry(t1, e) {
                const n = new Im(t1, e);
                return this.geometry = new Lg(n, 100, .1, 100, !1), this;
            }
            createMaterial() {
                return this.material = new kg({
                    color: new Jc(4275774),
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                return this.createGeometry(t1, e), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
        };
        function rI(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const aI = class extends mf {
            constructor(t1){
                super(), rI(this, "canvas", document.createElement("canvas")), rI(this, "isCenterPoint", !0), rI(this, "interactive", !0), rI(this, "materialValue", 0), rI(this, "ruler", void 0), this.ruler = t1;
                const e = .15;
                this.canvas.width = 256, this.canvas.height = 128, this.scale.set(e, e / (this.canvas.width / this.canvas.height), e), this.renderOrder = 5, this.createMaterial();
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {
                this.ruler.dispose();
            }
            onHoverStart() {
                this.updateMaterial(this.materialValue, "rgba(255, 99, 64, 0.8)", "rgba(255, 255, 255, 1)");
            }
            onHoverEnd() {
                this.updateMaterial(this.materialValue);
            }
            addEventListeners() {
                return this.addEventListener("select", this.onClick), this.addEventListener("click", this.onClick), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this;
            }
            createMaterial() {
                return this.material = new tf({
                    color: new Jc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: pr,
                    opacity: 1
                }), this;
            }
            updateMaterial(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "rgba(255, 255, 255, 0.8)", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Vi.config.colors.mainText;
                this.materialValue = t1;
                const i = "".concat(Number(t1 / 100).toFixed(2), " m "), r = "".concat(Number(.0328084 * t1).toFixed(2), " ft");
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = e, DT(this.context, 0, 0, this.canvas.width, this.canvas.height, 55), this.context.fill(), this.context.textAlign = "center", this.context.font = "Bold 38px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillText(r, this.canvas.width / 2, 100), this.context.fillText(i, this.canvas.width / 2, 50), this.material.map || (this.material.map = ob(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
            updatePosition(t1, e) {
                const n = new Im(t1, e).getPoint(.5, new Ol);
                return this.position.copy(n), this;
            }
            update(t1, e, n) {
                return this.updateMaterial(t1), this.updatePosition(e, n), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function sI(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const oI = class extends Gu {
            constructor(){
                super(), sI(this, "canvas", document.createElement("canvas")), sI(this, "isPoint", !0), this.canvas.width = 128, this.canvas.height = 128, this.createGeometry(), this.createMaterial(), this.renderOrder = 4;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new fh(15, 15, 10, 10), this.geometry.rotateX(-Math.PI / 2), this;
            }
            createMaterial() {
                const t1 = this.canvas.width / 2, e = this.canvas.height / 2;
                this.context.beginPath(), this.context.arc(t1, e, this.canvas.width / 4, 0, 2 * Math.PI, !1), this.context.fillStyle = "rgba(255, 255, 255, 1)", this.context.fill(), this.context.lineWidth = 15, this.context.strokeStyle = Vi.config.colors.main, this.context.stroke();
                const n = ob(this.canvas);
                return this.material = new kg({
                    color: new Jc(16777215),
                    transparent: !0,
                    depthWrite: !1,
                    depthTest: !1,
                    side: pr,
                    map: n,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.position.copy(t1), n ? (this.quaternion.slerp(e, .5), this) : (this.quaternion.copy(e), this);
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function lI(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        const cI = class extends Bp {
            constructor(t1){
                super(), lI(this, "distanceLine", null), lI(this, "centerPoint", null), lI(this, "secondPoint", null), lI(this, "firstPoint", null), lI(this, "isRuler", !0), this.userData = {
                    panoramaId: t1
                };
            }
            get distance() {
                return this.firstPoint && this.secondPoint ? this.firstPoint.position.distanceTo(this.secondPoint.position) : 0;
            }
            createRest(t1, e) {
                return this.createSecondPoint(t1, e), this.createDistanceLine(), this.createCenterPoint(), this;
            }
            createFirstPoint(t1, e) {
                return this.firstPoint = (new oI).update(t1, e, !1), this.add(this.firstPoint), this;
            }
            createSecondPoint(t1, e) {
                return this.secondPoint = (new oI).update(t1, e, !1), this.add(this.secondPoint), this;
            }
            createDistanceLine() {
                return this.distanceLine = new iI, this.add(this.distanceLine), this;
            }
            createCenterPoint() {
                return this.centerPoint = new aI(this), this.add(this.centerPoint), this;
            }
            update(t1, e) {
                var n, i, r;
                return null === (n = this.secondPoint) || void 0 === n || n.update(t1, e, !0), null === (i = this.centerPoint) || void 0 === i || i.update(this.distance, this.firstPoint.position, this.secondPoint.position), null === (r = this.distanceLine) || void 0 === r || r.update(this.firstPoint.position, this.secondPoint.position), this;
            }
            dispose() {
                var t1, e, n, i;
                return null === (t1 = this.firstPoint) || void 0 === t1 || t1.dispose(), null === (e = this.secondPoint) || void 0 === e || e.dispose(), null === (n = this.centerPoint) || void 0 === n || n.dispose(), null === (i = this.distanceLine) || void 0 === i || i.dispose(), this.removeFromParent(), this;
            }
        }, uI = "data:image/svg+xml;base64,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", hI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMS44MzU0IDIuMTQwNzhMMi4zNzcxOCAyMS41OTlDMS45MTkwMiAyMi4wNTcyIDEuODc5NCAyMi43NjA0IDIuMjg4NjggMjMuMTY5N0w5LjE5MDc4IDMwLjA3MThDOS42MDAwNiAzMC40ODEgMTAuMzAzMyAzMC40NDE0IDEwLjc2MTQgMjkuOTgzM0wzMC4yMTk3IDEwLjUyNUMzMC42Nzc4IDEwLjA2NjkgMzAuNzE3NCA5LjM2MzY2IDMwLjMwODIgOC45NTQzOEwyMy40MDYxIDIuMDUyMjhDMjIuOTk2OCAxLjY0Mjk5IDIyLjI5MzYgMS42ODI2MiAyMS44MzU0IDIuMTQwNzhaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xOC4wNDkzIDcuMjU0MjdMMjIuNzQyMSAxMS45NDciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEyLjc3IDEyLjUzMzZMMTYuMzE0NiAxNi4wNzgyIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik03LjQ5MDcyIDE3LjgxMjlMMTIuMTgzNSAyMi41MDU2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K", dI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05LjE2MzIgMjQuOTA2N1Y1LjkwNjY4SDguOTYyNTdMMC40ODI4NTcgOC44OTVWMTIuMDUzTDUuNDA0ODQgMTAuMzMwNFYyNC45MDY3SDkuMTYzMloiIGZpbGw9IiM0MTNFM0UiLz4NCjxwYXRoIGQ9Ik0yMy4xMjY2IDE1LjE5NzlMMTkuOTk2OSAxMC43ODcySDE1Ljk5NzhMMjAuODM5NSAxNy43MTY0TDE1LjgxMDUgMjQuOTA2N0gxOS44MzY0TDIzLjE0IDIwLjI4NzJMMjYuNDcwNCAyNC45MDY3SDMwLjQ4MjlMMjUuNDUzOSAxNy43MTY0TDMwLjMwOSAxMC43ODcySDI2LjMwOTlMMjMuMTI2NiAxNS4xOTc5WiIgZmlsbD0iIzQxM0UzRSIvPg0KPC9zdmc+DQo=";
        function pI(t1, e, n) {
            return e = function(t1) {
                var e = function(t1, e) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var n = t1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var i = n.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e), e in t1 ? Object.defineProperty(t1, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = n, t1;
        }
        dn({
            useProxies: "never"
        });
        const fI = new class {
            constructor(){
                pI(this, "currentAutoRotateIcon", uI), pI(this, "currentRulerIcon", hI), pI(this, "currentFovIcon", dI), pI(this, "currentFovText", "1x"), pI(this, "rulerInstructionShown", !1), pI(this, "tempPointer", new tl), pI(this, "raycaster", new Uv), pI(this, "tempMatrix", new cc), pI(this, "vrSessionSupported", !1), pI(this, "rulerButtonEnabled", !1), pI(this, "rulersGroup", new Bp), pI(this, "renderer", new NS), pI(this, "floorsGroup", new Bp), pI(this, "initialPanoramaId", null), pI(this, "rulerModeEnabled", !1), pI(this, "autoRotateState", !1), pI(this, "pointer", new tl), pI(this, "panoramasGroup", null), pI(this, "initialized", !1), pI(this, "clock", new sv), pI(this, "scene", new IT), pI(this, "animation", !1), pI(this, "currentPanoramaId", void 0), pI(this, "interactiveGroup", void 0), pI(this, "tempRuler", null), pI(this, "currentPanorama", void 0), pI(this, "loading", !1), pI(this, "vrControlPanel", void 0), pI(this, "maskCursor", void 0), pI(this, "camera", void 0), pI(this, "onMouseMove", (t1)=>{
                    let { clientX: e, clientY: n } = t1;
                    this.pointer.x = e / Vi.config.width * 2 - 1, this.pointer.y = -n / Vi.config.height * 2 + 1;
                }), pI(this, "onPointerDown", (t1)=>{
                    let { clientX: e, clientY: n } = t1;
                    this.tempPointer.x = Number(e.toFixed(0)), this.tempPointer.y = Number(n.toFixed(0)), this.onMouseMove({
                        clientX: e,
                        clientY: n
                    });
                }), pI(this, "onPointerUp", (t1)=>{
                    let { clientX: e, clientY: n } = t1;
                    if (this.interactiveGroup.hover) return;
                    const i = Math.abs(this.tempPointer.x - Number(e.toFixed(0))) < 10, r = Math.abs(this.tempPointer.y - Number(n.toFixed(0))) < 10;
                    i && r && (this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick());
                }), pI(this, "onControllerMove", (t1)=>{
                    const e = t1.target;
                    this.tempMatrix.identity().extractRotation(e.matrixWorld), this.raycaster.ray.origin.setFromMatrixPosition(e.matrixWorld), this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);
                }), pI(this, "onControllerSelect", ()=>{
                    this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick();
                }), pI(this, "onMaskObjectClick", ()=>{}), On(this), this.camera = new TT(this.renderer), this.interactiveGroup = new xb(this.renderer, this.camera), this.floorsGroup.rotation.y = Math.PI, this.scene.add(this.interactiveGroup, this.rulersGroup, this.floorsGroup), this.addEventListeners();
            }
            get currentViewAngle() {
                const t1 = this.currentCamera.getWorldDirection(new Ol), e = new Ol(-1, 0, 0), n = t1.x * e.x + t1.z * e.z, i = Math.sqrt(Math.pow(t1.x, 2) + Math.pow(t1.z, 2)), r = Math.sqrt(Math.pow(e.x, 2) + Math.pow(e.z, 2)), a = Math.acos(n / (i * r));
                return Math.sign(t1.z) * a;
            }
            get currentCamera() {
                return this.renderer.xr.getCamera().cameras[0] || this.camera;
            }
            get currentControls() {
                return this.camera.deviceOrientationControls.enabled ? this.camera.deviceOrientationControls : this.camera.controls;
            }
            getPanoramaById(t1) {
                return this.panoramasGroup.children.find((e)=>{
                    let { panoramaId: n } = e;
                    return n === t1;
                });
            }
            setLoadingState(t1) {
                this.loading = t1;
            }
            setInitializedState(t1) {
                this.initialized = t1;
            }
            updateWindowSize(t1, e) {
                return this.renderer.setSize(t1, e), this.camera.aspect = t1 / e, this.camera.updateProjectionMatrix(), this.render();
            }
            enableRender() {
                this.renderer.setAnimationLoop(this.render.bind(this));
            }
            disbleRender() {
                this.renderer.setAnimationLoop(null);
            }
            render() {
                const t1 = this.clock.getDelta();
                this.currentControls.update(t1), this.camera.updateProjectionMatrix(), this.autoRotateState && !this.camera.controls.disableAutoRotate && (this.camera.controls.azimuthAngle -= mb(10 * t1)), this.renderer.currentVrSession || this.raycaster.setFromCamera(this.pointer, this.camera), Ib.isMobileDevice || (this.tempRuler ? this.updateRuler() : this.updateMask()), this.maskCursor ? this.renderer.domElement.style.cursor = this.maskCursor : this.interactiveGroup.hover && this.interactiveGroup.cursor.length > 0 ? this.renderer.domElement.style.cursor = this.interactiveGroup.cursor : this.rulerModeEnabled ? this.renderer.domElement.style.cursor = "none" : this.camera.controls.holding ? this.renderer.domElement.style.cursor = "grabbing" : this.renderer.domElement.style.cursor = "grab";
                const e = document.querySelector(".widget-tab__panorama-map__fov");
                return e && e.style.setProperty("--rotate", -this.currentViewAngle), this.renderer.currentVrSession && this.vrControlPanel.update(this.currentCamera, this.currentViewAngle, this.getPanoramaById(this.currentPanoramaId), this.panoramasGroup), this.renderer.render(this.scene, this.camera), this;
            }
            async init(t1, e, n) {
                return this.vrControlPanel = new nI, this.interactiveGroup.add(this.vrControlPanel), this.vrControlPanel.onRulerButtonClick = this.toggleRulerMode.bind(this), this.vrControlPanel.onExitButtonClick = this.exitVr.bind(this), this.vrControlPanel.map.onClick = this.setCurrentPanoramaById.bind(this), this.vrControlPanel.prevFloorButton.onClick = ()=>Vi.setPrevFloorIndex(), this.vrControlPanel.nextFloorButton.onClick = ()=>Vi.setNextFloorIndex(), this.setRulerButtonState(!1), this.cameraFovValues = {
                    x1: Vi.config.panoramaFov,
                    x2: Vi.config.panoramaFov / 2,
                    x05: 1.35 * Vi.config.panoramaFov
                }, this.setCameraFov(this.cameraFovValues[Vi.scales[0]]), this.checkVrSessionSupport(), await this.createPanoramasGroup(t1, e, n), this.setInitializedState(!0), this;
            }
            async createPanoramasGroup(t1, e, n) {
                const i = new CS(n);
                return this.floorsGroup.add(i), this.setCurrentPanoramasGroup(n), this.createPanoramas(t1, e), await this.setInitialCurrentPanorama(), this.interactiveGroup.updateDeepChildren(), this;
            }
            addEventListeners() {
                const { domElement: t1 } = this.renderer;
                t1.addEventListener("contextmenu", (t1)=>t1.preventDefault()), t1.addEventListener("pointerdown", this.onPointerDown), t1.addEventListener("pointerup", this.onPointerUp), t1.addEventListener("mousemove", this.onMouseMove);
            }
            async enterVr() {
                return await this.renderer.enterVR().then(()=>{
                    this.vrControlPanel.setVisibility(!0);
                });
            }
            async exitVr() {
                return await this.renderer.exitVR().then(()=>{
                    this.camera.fov = this.cameraFov, this.vrControlPanel.setVisibility(!1);
                });
            }
            async checkVrSessionSupport() {
                const t1 = await this.renderer.checkVrSessionSupport();
                return this.setVrSessionSupport(t1), this.vrSessionSupported;
            }
            setVrSessionSupport(t1) {
                this.vrSessionSupported = t1;
            }
            resetMaskOptions() {
                this.onMaskObjectClick = ()=>{}, this.maskCursor = null;
            }
            setMaskObjectStairs(t1) {
                const e = t1.RoomID === this.currentPanorama.userData.room_id, n = "url(".concat(e ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNTY2XzIpIj4NCjxwYXRoIGQ9Ik0yLjcwMjIxIDE1LjI5ODFMMTQuNDQ2OCAzLjU1MzQ2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTQuOTA0MzMgMy41NTM0N0wxNC40NDY4IDMuNTUzNDdMMTQuNDQ2OSAxMy4wOTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNDUuMTkwNCA0Ni4zMzMzSDQuODA5NTdDNC4xNzgzOSA0Ni4zMzMzIDMuNjY2NzIgNDUuODIxNiAzLjY2NjcyIDQ1LjE5MDRWMzcuOTk0N0MzLjY2NjcyIDM3LjM2MzUgNC4xNzgzOSAzNi44NTE4IDQuODA5NTcgMzYuODUxOEgxMy4wMjc2QzEzLjY1ODggMzYuODUxOCAxNC4xNzA1IDM2LjM0MDEgMTQuMTcwNSAzNS43MDlWMjcuMjQzNEMxNC4xNzA1IDI2LjYxMjIgMTQuNjgyMiAyNi4xMDA1IDE1LjMxMzQgMjYuMTAwNUgyNC4xODI4QzI0LjgxNCAyNi4xMDA1IDI1LjMyNTcgMjUuNTg4OSAyNS4zMjU3IDI0Ljk1NzdWMTUuNTYwOUMyNS4zMjU3IDE0LjkyOTcgMjUuODM3MyAxNC40MTggMjYuNDY4NSAxNC40MThIMzQuNjg2NkMzNS4zMTc4IDE0LjQxOCAzNS44Mjk1IDEzLjkwNjQgMzUuODI5NSAxMy4yNzUyVjQuODA5NkMzNS44Mjk1IDQuMTc4NDIgMzYuMzQxMSAzLjY2Njc1IDM2Ljk3MjMgMy42NjY3NUg0NS4xOTA0QzQ1LjgyMTYgMy42NjY3NSA0Ni4zMzMyIDQuMTc4NDIgNDYuMzMzMiA0LjgwOTZWNDUuMTkwNEM0Ni4zMzMyIDQ1LjgyMTYgNDUuODIxNiA0Ni4zMzMzIDQ1LjE5MDQgNDYuMzMzM1oiIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvZz4NCjxkZWZzPg0KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNTY2XzIiPg0KPHJlY3Qgd2lkdGg9IjQ3Ljk5OTgiIGhlaWdodD0iNDcuOTk5OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDYgMS4wMDAyNCkiLz4NCjwvY2xpcFBhdGg+DQo8L2RlZnM+DQo8L3N2Zz4NCg==" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNTUxXzE3MikiPg0KPHBhdGggZD0iTTE0LjQ0NjggMy41NTM0NkwyLjcwMjIgMTUuMjk4MSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xMi4yNDQ3IDE1LjI5ODFMMi43MDIyIDE1LjI5ODFMMi43MDIyIDUuNzU1NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNDUuMTkwNCA0Ni4zMzMzSDQuODA5NTdDNC4xNzgzOSA0Ni4zMzMzIDMuNjY2NzIgNDUuODIxNiAzLjY2NjcyIDQ1LjE5MDRWMzcuOTk0N0MzLjY2NjcyIDM3LjM2MzUgNC4xNzgzOSAzNi44NTE4IDQuODA5NTcgMzYuODUxOEgxMy4wMjc2QzEzLjY1ODggMzYuODUxOCAxNC4xNzA1IDM2LjM0MDEgMTQuMTcwNSAzNS43MDlWMjcuMjQzNEMxNC4xNzA1IDI2LjYxMjIgMTQuNjgyMiAyNi4xMDA1IDE1LjMxMzQgMjYuMTAwNUgyNC4xODI4QzI0LjgxNCAyNi4xMDA1IDI1LjMyNTcgMjUuNTg4OSAyNS4zMjU3IDI0Ljk1NzdWMTUuNTYwOUMyNS4zMjU3IDE0LjkyOTcgMjUuODM3MyAxNC40MTggMjYuNDY4NSAxNC40MThIMzQuNjg2NkMzNS4zMTc4IDE0LjQxOCAzNS44Mjk1IDEzLjkwNjQgMzUuODI5NSAxMy4yNzUyVjQuODA5NkMzNS44Mjk1IDQuMTc4NDIgMzYuMzQxMSAzLjY2Njc1IDM2Ljk3MjMgMy42NjY3NUg0NS4xOTA0QzQ1LjgyMTYgMy42NjY3NSA0Ni4zMzMyIDQuMTc4NDIgNDYuMzMzMiA0LjgwOTZWNDUuMTkwNEM0Ni4zMzMyIDQ1LjgyMTYgNDUuODIxNiA0Ni4zMzMzIDQ1LjE5MDQgNDYuMzMzM1oiIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvZz4NCjxkZWZzPg0KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNTUxXzE3MiI+DQo8cmVjdCB3aWR0aD0iNDcuOTk5OCIgaGVpZ2h0PSI0Ny45OTk4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwNiAxLjAwMDI0KSIvPg0KPC9jbGlwUGF0aD4NCjwvZGVmcz4NCjwvc3ZnPg0K", ") 25 25, pointer"), i = e ? Vi.nextFloorIndex : Vi.prevFloorIndex, r = e ? t1.UpperFloorCameraPointID : t1.LowerFloorCameraPointID, { CameraPoints: a } = Vi.config.json.Floors[i], { id: s } = a.reduce((e, n)=>{
                    const i = [
                        n.Location.X,
                        n.Location.Y
                    ], r = DM([
                        [
                            t1.Location.X,
                            t1.Location.Y
                        ],
                        i
                    ]);
                    return r < e.length ? {
                        id: n.ID,
                        length: r
                    } : e;
                }, {
                    length: 1 / 0,
                    id: null
                });
                this.initialPanoramaId = r || s, this.maskCursor = n, this.onMaskObjectClick = ()=>e ? Vi.setNextFloorIndex() : Vi.setPrevFloorIndex();
            }
            setMaskObjectDefault() {
                this.maskCursor = "pointer", this.onMaskObjectClick = ()=>{};
            }
            updateMask() {
                const t1 = this.getObjectFromMask(), e = wb.some((e)=>(null == t1 ? void 0 : t1.Model) === e);
                return t1 ? e ? this.setMaskObjectStairs(t1) : this.setMaskObjectDefault() : this.resetMaskOptions();
            }
            getObjectFromMask() {
                if (!this.currentPanorama || !this.currentPanorama.mask) return;
                if (!Vi.config.json || !Vi.config.json.ObjectMaskColorPairs) return;
                if (this.interactiveGroup.hover) return;
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, n = Math.acos(t1.y) / Math.PI, { R: i } = yb(e, n, this.currentPanorama.mask), r = Math.round(i), a = Vi.config.json.ObjectMaskColorPairs.find((t1)=>t1.MaskColorID.R === r);
                if (!a || "Furniture" !== a.Type) return;
                if (!cb(Vi.config.json, this.currentPanorama.userData.room_id)) return;
                let s = null;
                return Vi.config.json.Floors.forEach((t1)=>{
                    t1.Units.forEach((t1)=>{
                        t1.Rooms.forEach((t1)=>{
                            t1.Furniture.forEach((t1)=>{
                                t1.ID === a.ObjectID && (s = t1);
                            });
                        });
                    });
                }), s;
            }
            setRulerInstructionShown(t1) {
                this.rulerInstructionShown = t1;
            }
            setRulerButtonState(t1) {
                this.rulerButtonEnabled = t1, this.vrControlPanel.rulerButtonAvailable = t1;
            }
            setRulerMode(t1) {
                this.rulerModeEnabled = t1, this.vrControlPanel.setRulerIcon(t1), this.rulersGroup.children.forEach((e)=>{
                    const n = !!t1 && e.userData.panoramaId === this.currentPanorama.panoramaId;
                    e.centerPoint && (e.centerPoint.visible = n), e.visible = n;
                }), t1 ? (this.currentRulerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMi45MjI4IDE3LjgyMkwyNS4zNTUgMTUuMzg5N0wzMC4yMTk2IDEwLjUyNTFDMzAuNjc3OCAxMC4wNjcgMzAuNzE3NCA5LjM2Mzc4IDMwLjMwODEgOC45NTQ1TDIzLjQwNiAyLjA1MjRDMjIuOTk2NyAxLjY0MzEyIDIyLjI5MzUgMS42ODI3NCAyMS44MzU0IDIuMTQwOUwxNi45NzA4IDcuMDA1NDZMMTQuNTM4NSA5LjQzNzc0TTE5LjMxNzggMjEuNDI3TDEwLjc2MTQgMjkuOTgzNEMxMC4zMDMyIDMwLjQ0MTUgOS42IDMwLjQ4MTIgOS4xOTA3MiAzMC4wNzE5TDIuMjg4NjIgMjMuMTY5OEMxLjg3OTMzIDIyLjc2MDUgMS45MTg5NiAyMi4wNTczIDIuMzc3MTIgMjEuNTk5MUwxMC43NjE0IDEzLjIxNDkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTE4LjA0OTMgNy4yNTQzOUwyMi43NDIgMTEuOTQ3MSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNy40OTA2IDE3LjgxM0wxMi4xODM0IDIyLjUwNTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEuNTQ5MjYgMy40OTYwOUwyOS4xMDIzIDMwLjgxMTMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjI4MzIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K", Ib.isMobileDevice || this.createTempRuler()) : (this.currentRulerIcon = hI, this.destroyTempRuler());
            }
            toggleRulerMode(t1) {
                this.setRulerMode(!this.rulerModeEnabled), t1 && t1.controller && (this.interactiveGroup.controller1.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller1.removeEventListener("move", this.onControllerMove), this.interactiveGroup.controller2.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller2.removeEventListener("move", this.onControllerMove), t1.controller.addEventListener("select", this.onControllerSelect), t1.controller.addEventListener("move", this.onControllerMove));
            }
            getRulerPoint() {
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, n = Math.acos(t1.y) / Math.PI, { R: i } = yb(e, n, this.currentPanorama.depthMap), r = i || 140;
                return {
                    depthValue: r,
                    position: t1.clone().multiplyScalar(r).add(this.currentCamera.position),
                    quaternion: this.getRulerPointQuaternion()
                };
            }
            getRulerPointQuaternion() {
                const { width: t1, height: e } = this.currentPanorama.depthMap, { direction: n } = this.raycaster.ray, i = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 0,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: 1,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 1
                    },
                    {
                        x: 0,
                        y: 1
                    },
                    {
                        x: 1,
                        y: 1
                    }
                ], r = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, a = Math.acos(n.y) / Math.PI, s = 1 / e, o = 1 / t1, l = Math.round(Math.sqrt(i.length)), c = i.map((t1)=>{
                    let { x: e, y: n } = t1;
                    const i = r + o * e, l = a + s * n, { R: c } = yb(i, l, this.currentPanorama.depthMap), u = c || 140, h = ((t1, e)=>{
                        const n = new Ol;
                        return n.x = Math.cos((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), n.z = Math.sin((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), n.y = Math.cos(e * Math.PI), n;
                    })(i, l);
                    return h.clone().multiplyScalar(u).add(this.currentCamera.position);
                }), u = new Ol(0, 0, 0);
                for(let t1 = 0; t1 < l - 1; t1++)for(let e = 0; e < l - 1; e++){
                    const n = t1 * l + e, i = (t1 + 1) * l + e, r = c[n], a = c[n + 1], s = c[i], o = c[i + 1];
                    u.add(Mb(r, a, s)), u.add(Mb(a, o, s));
                }
                u.normalize();
                const h = new Ol(0, Math.sign(n.y), 0), d = (new Ol).crossVectors(h, u), p = u.angleTo(h);
                return (new Ll).setFromAxisAngle(d, p);
            }
            updateRuler() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler.secondPoint ? this.tempRuler.update(t1, e) : this.tempRuler.firstPoint.update(t1, e);
            }
            finishRuler() {
                return this.interactiveGroup.add(this.tempRuler.centerPoint), this.tempRuler.centerPoint.addEventListeners(), this.tempRuler = null, this;
            }
            addRulerPoint() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return Ib.isMobileDevice ? this.tempRuler ? void (this.tempRuler.firstPoint && (this.tempRuler.createRest(t1, e), this.updateRuler(), this.finishRuler())) : this.createTempRuler() : this.tempRuler.secondPoint ? (this.finishRuler(), this.createTempRuler()) : this.tempRuler.createRest(t1, e);
            }
            createTempRuler() {
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler = new cI(this.currentPanorama.panoramaId), this.tempRuler.createFirstPoint(t1, e), this.rulersGroup.add(this.tempRuler), this;
            }
            destroyTempRuler() {
                return this.tempRuler ? (this.tempRuler.dispose(), this.tempRuler = null, this) : this;
            }
            setCameraFov(t1) {
                this.camera.fov = t1, this.cameraFov = t1, t1 === this.cameraFovValues.x1 && (this.currentFovIcon = dI, this.currentFovText = "1x"), t1 === this.cameraFovValues.x2 && (this.currentFovIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMy43MDc2IDI0LjkwNjdWMjEuOTk3OUg1LjE2MjE0TDguODI2NDEgMTguMjE1MUM5LjQ1OTQxIDE3LjU4MDMgMTAuMDM0NSAxNi45NzU5IDEwLjU1MTYgMTYuNDAyQzExLjA2ODcgMTUuODE5MyAxMS41MTQ0IDE1LjI0OTcgMTEuODg4OSAxNC42OTMyQzEyLjI1NDQgMTQuMTM2NyAxMi41MzUzIDEzLjU3NTggMTIuNzMxNCAxMy4wMTA1QzEyLjkzNjUgMTIuNDM2NiAxMy4wMzkgMTEuODM2NiAxMy4wMzkgMTEuMjEwNEMxMy4wMzkgMTAuMzg0MyAxMi45MDUyIDkuNjMyMTIgMTIuNjM3OCA4Ljk1MzgzQzEyLjM3MDMgOC4yNjY4NCAxMS45ODI1IDcuNjc5ODYgMTEuNDc0MyA3LjE5Mjg4QzEwLjk1NzIgNi43MDU5MSAxMC4zMTUzIDYuMzI3NjMgOS41NDg1NiA2LjA1ODA1QzguNzkwNzUgNS43ODg0NyA3LjkxNzAzIDUuNjUzNjkgNi45Mjc0MSA1LjY1MzY5QzUuODkzMjEgNS42NTM2OSA0Ljk0ODE3IDUuODE4OTEgNC4wOTIyOCA2LjE0OTM2QzMuMjQ1MzEgNi40NzExMSAyLjUyMzE2IDYuOTE0NjEgMS45MjU4MiA3LjQ3OTg1QzEuMzE5NTYgOC4wNDUwOSAwLjg1MTUgOC43MDU5OSAwLjUyMTYyNyA5LjQ2MjU1QzAuMTkxNzU0IDEwLjIxMDQgMC4wMjY4MTczIDExLjAwNjEgMC4wMjY4MTczIDExLjg0OTZIMy43NTc5NUMzLjc1Nzk1IDExLjMzNjUgMy44MjQ4MiAxMC44OCAzLjk1ODU1IDEwLjQ4QzQuMDkyMjggMTAuMDggNC4yODg0MiA5Ljc0NTE3IDQuNTQ2OTcgOS40NzU1OUM0Ljc5NjYxIDkuMjE0NzEgNS4xMDg2NSA5LjAxOTA1IDUuNDgzMSA4Ljg4ODYxQzUuODY2NDcgOC43NDk0NyA2LjMwNzc4IDguNjc5OSA2LjgwNzA1IDguNjc5OUM3LjE5MDQyIDguNjc5OSA3LjUzODEyIDguNzQwNzcgNy44NTAxNiA4Ljg2MjUyQzguMTcxMTIgOC45ODQyNiA4LjQ0NzUgOS4xNTgxOCA4LjY3OTMgOS4zODQyOEM4LjkwMjE5IDkuNjE5MDcgOS4wNzYwNCA5LjkwMTY5IDkuMjAwODYgMTAuMjMyMUM5LjMyNTY4IDEwLjU2MjYgOS4zODgwOSAxMC45NDA5IDkuMzg4MDkgMTEuMzY3QzkuMzg4MDkgMTEuNjUzOSA5LjMzOTA1IDExLjk0OTYgOS4yNDA5OCAxMi4yNTRDOS4xNTE4MyAxMi41NTgzIDkuMDA0NzIgMTIuODg0NCA4Ljc5OTY2IDEzLjIzMjNDOC41ODU2OSAxMy41ODg4IDguMzA5MzEgMTMuOTgwMSA3Ljk3MDUyIDE0LjQwNjJDNy42MzE3MyAxNC44MzIzIDcuMjE3MTYgMTUuMzA2MyA2LjcyNjgxIDE1LjgyOEwwLjQyODAxNSAyMi40MjgzVjI0LjkwNjdIMTMuNzA3NloiIGZpbGw9IiM0MTNFM0UiLz4NCjxwYXRoIGQ9Ik0yNC4wNDUyIDE1LjIwMTlMMjAuOTE1OCAxMC43OTNIMTYuOTE3MkwyMS43NTgzIDE3LjcxOTRMMTYuNzMgMjQuOTA2N0gyMC43NTUzTDI0LjA1ODUgMjAuMjg5MUwyNy4zODg1IDI0LjkwNjdIMzEuNDAwNEwyNi4zNzIxIDE3LjcxOTRMMzEuMjI2NiAxMC43OTNIMjcuMjI4TDI0LjA0NTIgMTUuMjAxOVoiIGZpbGw9IiM0MTNFM0UiLz4NCjwvc3ZnPg0K", this.currentFovText = "2x"), t1 === this.cameraFovValues.x05 && (this.currentFovIcon = "data:image/svg+xml;base64,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", this.currentFovText = "0.5x");
            }
            toggleFov() {
                const t1 = Object.entries(this.cameraFovValues).find((t1)=>{
                    let [e, n] = t1;
                    return n === this.camera.fov;
                })[0], e = Vi.scales.findIndex((e)=>e === t1);
                Vi.scales[e + 1] ? this.setCameraFov(this.cameraFovValues[Vi.scales[e + 1]]) : this.setCameraFov(this.cameraFovValues[Vi.scales[0]]);
            }
            setAutoRotateState(t1) {
                this.autoRotateState = t1, this.currentAutoRotateIcon = t1 ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMi43NiAyNi40MTQzQzI1LjQyMSAyNi4wNjY2IDI3LjkwNzQgMjUuMzIyNSAyOS45Njg1IDI0LjIzODNDMzIuOTA3MSAyMi42OTI2IDM0Ljc3NTMgMjAuNTYzOSAzNS4yMTYzIDE4LjI1ODhDMzUuNjU3MyAxNS45NTM3IDM0LjY0MDEgMTMuNjMzOCAzMi4zNTkxIDExLjc0MjJDMzAuMDc4MSA5Ljg1MDUxIDI2LjY5MzEgOC41MTk2OCAyMi44NTA1IDguMDAzODVDMTkuMDA4IDcuNDg4MDIgMTQuOTc3MyA3LjgyMzM0IDExLjUyODIgOC45NDU3N0M4LjA3OTExIDEwLjA2ODIgNS40NTMzOSAxMS44OTkxIDQuMTUyNTIgMTQuMDg4N0MzLjgxODExIDE0LjY1MTYgMy41NzcyOCAxNS4yMjggMy40Mjk2NSAxNS44MTAzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8cGF0aCBkPSJNMjUuMjUzNiAxOS40MzMzTDE5Ljk2ODcgMjYuMDgzOUwyNi4wODczIDMwLjk0NjMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xNC40Nzg1IDIwLjk2OTdMNS40MTAyMyAzMC4wMzgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xNC40Nzg1IDMwLjAzOEw1LjQxMDIzIDIwLjk2OTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K" : uI;
            }
            toggleAutoRotate() {
                this.setAutoRotateState(!this.autoRotateState), this.autoRotateState ? this.camera.deviceOrientationControls.disable() : Ib.deviceOrientationGranted && this.camera.deviceOrientationControls.enable();
            }
            setCurrentPanoramasGroup(t1) {
                const e = this.floorsGroup.children.find((e)=>e.floorIndex === t1);
                if (e) return this.panoramasGroup = e, this.vrControlPanel.map.updateRoomsLayer(e), this.vrControlPanel.updateFloorMaterials(), this;
            }
            async setCurrentPanoramaById(t1) {
                var e;
                if ((null === (e = this.currentPanorama) || void 0 === e ? void 0 : e.panoramaId) === t1) return;
                const n = this.getPanoramaById(t1);
                if (this.animation || !n) return this;
                if (this.setCurrentPanoramaId(t1), this.animation = !0, !n.loaded && (this.setLoadingState(!0), await n.load(), this.setLoadingState(!1), 0 !== n.userData.rotation)) {
                    const t1 = !!Vi.config.enableCameraTransitionBetweenPanoramas && this.currentPanorama;
                    setTimeout(()=>{
                        this.camera.controls.normalizeRotations();
                        const e = gb(this.camera.controls.azimuthAngle), i = gb(n.userData.rotation), r = mb(((t1, e)=>{
                            const n = (e - t1) % 360;
                            return n > 180 ? n - 360 : n < -180 ? n + 360 : n;
                        })(e, i));
                        this.camera.controls.rotate(r, 0, t1);
                    }, t1 ? 200 : 0);
                }
                for (const t1 of (null === (i = this.currentPanorama) || void 0 === i ? void 0 : i.links) || []){
                    var i;
                    t1.visible = !1;
                }
                for (const t1 of n.links)t1.visible = !0;
                if (this.rulerModeEnabled) for (const e of this.rulersGroup.children){
                    const n = e.userData.panoramaId === t1;
                    e.centerPoint && (e.centerPoint.visible = n), e.visible = n;
                }
                this.currentPanorama && (this.currentPanorama.renderOrder = 0), n.renderOrder = 1, n.visible = !0, await n.fadeIn(), this.currentPanorama && (await this.currentPanorama.fadeOut(), this.currentPanorama.visible = !1);
                const r = null !== n.depthMap;
                return this.setCurrentPanorama(n), this.animation = !1, this.destroyTempRuler(), this.setRulerButtonState(r), this.rulerModeEnabled && this.setRulerMode(r), this;
            }
            setCurrentPanoramaId(t1) {
                this.currentPanoramaId = t1;
            }
            setCurrentPanorama(t1) {
                this.currentPanorama = t1;
            }
            async setInitialCurrentPanorama() {
                const t1 = this.panoramasGroup.children.find((t1)=>0 === t1.userData.panorama_index), e = this.initialPanoramaId || (null == t1 ? void 0 : t1.panoramaId) || null;
                return await this.setCurrentPanoramaById(e).then(()=>{
                    this.initialPanoramaId = null;
                });
            }
            createPanoramas(t1, e) {
                const n = this.panoramasGroup.createPanoramas(t1, e);
                for (const t1 of n)for (const e of t1.links)e.onClick = ()=>this.setCurrentPanoramaById(e.userData.targetId), this.interactiveGroup.add(e);
                return this;
            }
        };
        if (!e.useState) throw new Error("mobx-react-lite requires React with Hooks support");
        var mI = n(961);
        function gI(t1) {
            t1();
        }
        function AI(t1) {
            var e;
            return fn(wi(t1, e));
        }
        var vI = function() {
            function t1(t1) {
                var e = this;
                Object.defineProperty(this, "finalize", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t1
                }), Object.defineProperty(this, "registrations", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: new Map
                }), Object.defineProperty(this, "sweepTimeout", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                }), Object.defineProperty(this, "sweep", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function(t1) {
                        void 0 === t1 && (t1 = 1e4), clearTimeout(e.sweepTimeout), e.sweepTimeout = void 0;
                        var n = Date.now();
                        e.registrations.forEach(function(i, r) {
                            n - i.registeredAt >= t1 && (e.finalize(i.value), e.registrations.delete(r));
                        }), e.registrations.size > 0 && e.scheduleSweep();
                    }
                }), Object.defineProperty(this, "finalizeAllImmediately", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        e.sweep(0);
                    }
                });
            }
            return Object.defineProperty(t1.prototype, "register", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1, e, n) {
                    this.registrations.set(n, {
                        value: e,
                        registeredAt: Date.now()
                    }), this.scheduleSweep();
                }
            }), Object.defineProperty(t1.prototype, "unregister", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1) {
                    this.registrations.delete(t1);
                }
            }), Object.defineProperty(t1.prototype, "scheduleSweep", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function() {
                    void 0 === this.sweepTimeout && (this.sweepTimeout = setTimeout(this.sweep, 1e4));
                }
            }), t1;
        }(), yI = new ("undefined" != typeof FinalizationRegistry ? FinalizationRegistry : vI)(function(t1) {
            var e;
            null === (e = t1.reaction) || void 0 === e || e.dispose(), t1.reaction = null;
        }), MI = !1;
        function bI() {
            return MI;
        }
        var xI = function(t1, e) {
            var n = "function" == typeof Symbol && t1[Symbol.iterator];
            if (!n) return t1;
            var i, r, a = n.call(t1), s = [];
            try {
                for(; (void 0 === e || e-- > 0) && !(i = a.next()).done;)s.push(i.value);
            } catch (t1) {
                r = {
                    error: t1
                };
            } finally{
                try {
                    i && !i.done && (n = a.return) && n.call(a);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s;
        };
        function wI(t1) {
            return "observer".concat(t1);
        }
        var _I = function() {};
        function EI() {
            return new _I;
        }
        var SI = "function" == typeof Symbol && Symbol.for, TI = SI ? Symbol.for("react.forward_ref") : "function" == typeof e.forwardRef && (0, e.forwardRef)(function(t1) {
            return null;
        }).$$typeof, II = SI ? Symbol.for("react.memo") : "function" == typeof e.memo && (0, e.memo)(function(t1) {
            return null;
        }).$$typeof;
        function CI(t1, n) {
            var i;
            if (II && t1.$$typeof === II) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
            if (bI()) return t1;
            var r = null !== (i = null == n ? void 0 : n.forwardRef) && void 0 !== i && i, a = t1, s = t1.displayName || t1.name;
            if (TI && t1.$$typeof === TI && (r = !0, "function" != typeof (a = t1.render))) throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
            var o, l, c = function(t1, n) {
                return function(t1, n) {
                    if (void 0 === n && (n = "observed"), bI()) return t1();
                    var i = xI(e.useState(EI), 1)[0], r = xI(e.useState(), 2)[1], a = function() {
                        return r([]);
                    }, s = e.useRef(null);
                    s.current || (s.current = {
                        reaction: null,
                        mounted: !1,
                        changedBeforeMount: !1
                    });
                    var o, l, c = s.current;
                    if (c.reaction || (c.reaction = new Ve(wI(n), function() {
                        c.mounted ? a() : c.changedBeforeMount = !0;
                    }), yI.register(i, c, c)), e.useDebugValue(c.reaction, AI), e.useEffect(function() {
                        return yI.unregister(c), c.mounted = !0, c.reaction ? c.changedBeforeMount && (c.changedBeforeMount = !1, a()) : (c.reaction = new Ve(wI(n), function() {
                            a();
                        }), a()), function() {
                            c.reaction.dispose(), c.reaction = null, c.mounted = !1, c.changedBeforeMount = !1;
                        };
                    }, []), c.reaction.track(function() {
                        try {
                            o = t1();
                        } catch (t1) {
                            l = t1;
                        }
                    }), l) throw l;
                    return o;
                }(function() {
                    return a(t1, n);
                }, s);
            };
            return "" !== s && (c.displayName = s), t1.contextTypes && (c.contextTypes = t1.contextTypes), r && (c = (0, e.forwardRef)(c)), c = (0, e.memo)(c), o = t1, l = c, Object.keys(o).forEach(function(t1) {
                NI[t1] || Object.defineProperty(l, t1, Object.getOwnPropertyDescriptor(o, t1));
            }), c;
        }
        var NI = {
            $$typeof: !0,
            render: !0,
            compare: !0,
            type: !0,
            displayName: !0
        };
        !function(t1) {
            t1 || (t1 = gI), dn({
                reactionScheduler: t1
            });
        }(mI.unstable_batchedUpdates), yI.finalizeAllImmediately;
        const DI = {
            smallMobile: 374,
            mobile: 670,
            tablet: 1100,
            laptop: 1440
        }, LI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zOS40MDg5IDEwLjI3NjlMMTEuMDM0NSAzOC42NTEzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMzkuNDA4OSAzOC42NTEzTDExLjAzNDUgMTAuMjc2OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo=", OI = CI(()=>qi.enabled ? qi.active ? e.createElement("button", {
                type: "button",
                className: "widget-exit-fullscreen",
                onClick: ()=>qi.exit()
            }, e.createElement("img", {
                src: LI,
                alt: "exit-fullscreen"
            })) : e.createElement("button", {
                type: "button",
                className: "widget-enter-fullscreen",
                onClick: ()=>qi.enter()
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zMS4yNSA5Ljg3NUg0MC42MjVWMTkuMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0yOS42ODc1IDIwLjgxMjVMNDAuNjI1IDkuODc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMTguNzUgNDEuMTI1SDkuMzc1VjMxLjc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMjAuMzEyNSAzMC4xODc1TDkuMzc1IDQxLjEyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo=",
                alt: "enter-fullscreen"
            })) : null), RI = CI(()=>{
            const [t1, n] = (0, e.useState)(!1), i = (t1)=>LT("floor", t1), r = Vi.config.floors.map((t1, e)=>({
                    label: i(e + 1),
                    value: e,
                    class: "floors-select--block-item",
                    classActive: "floors-select--block-item floors-select--block-item--active"
                }));
            return (0, e.useEffect)(()=>{
                document.addEventListener("click", (t1)=>{
                    t1.target.closest(".floors-select") || n(!1);
                });
            }, []), r.length > 1 && e.createElement("div", {
                id: "floors-select",
                onClick: ()=>n(!t1),
                className: "floors-select"
            }, e.createElement("div", {
                className: "floors-select--text"
            }, i(Vi.currentFloorIndex + 1)), t1 && e.createElement("div", {
                className: "floors-select--block"
            }, r.map((t1)=>e.createElement("div", {
                    key: t1.value,
                    onClick: ()=>((t1)=>{
                            let { value: e } = t1;
                            Vi.setCurrentFloorIndex(e), n(!1);
                        })(t1),
                    className: Vi.currentFloorIndex === t1.value ? t1.classActive : t1.class
                }, t1.label))));
        }), PI = RI, zI = CI(()=>{
            const [t1, n] = (0, e.useState)(!1);
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button",
                disabled: t1,
                onClick: async ()=>{
                    n(!0), fI.enterVr().finally(()=>n(!1));
                }
            }, "VR");
        }), UI = (t1)=>{
            let { active: n, text: i, onClick: r } = t1;
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button ".concat(n ? "widget-tab-button--active" : ""),
                onClick: r
            }, i);
        }, kI = (t1)=>{
            let { href: n, text: i } = t1;
            return e.createElement("a", {
                href: n,
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("span", null, "made by"), " ", i);
        };
        var BI = n(611), jI = n.n(BI);
        function FI(t1, e, n) {
            !function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            }(t1, e), e.set(t1, n);
        }
        function HI(t1, e) {
            return t1.get(QI(t1, e));
        }
        function VI(t1, e, n) {
            return t1.set(QI(t1, e), n), n;
        }
        function QI(t1, e, n) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : n;
            throw new TypeError("Private element is not present on this object");
        }
        var GI = new WeakMap, WI = new WeakMap, XI = new WeakMap;
        const YI = class {
            constructor(t1, e){
                FI(this, GI, null), FI(this, WI, null), FI(this, XI, null), VI(WI, this, e), VI(XI, this, {
                    container: {
                        mousedown: (t1)=>{
                            0 === t1.button && VI(GI, this, t1.pageX);
                        },
                        touchstart: (t1)=>VI(GI, this, t1.touches[0].clientX),
                        touchend: ()=>VI(GI, this, null)
                    },
                    prev: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play(!0);
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.prev();
                        }
                    },
                    next: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play();
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.next();
                        }
                    },
                    global: {
                        mouseup: ()=>VI(GI, this, null),
                        mousemove: (e)=>{
                            HI(GI, this) && Math.abs(HI(GI, this) - e.pageX) > HI(WI, this).dragTolerance && (t1.stop(), HI(GI, this) > e.pageX ? t1.prev() : t1.next(), VI(GI, this, e.pageX));
                        },
                        touchmove: (e)=>{
                            2 !== e.touches.length && (1 === e.touches.length && e.stopPropagation(), HI(GI, this) && Math.abs(HI(GI, this) - e.touches[0].clientX) > HI(WI, this).swipeTolerance && (t1.stop(), HI(GI, this) > e.touches[0].clientX ? t1.prev() : t1.next(), VI(GI, this, e.touches[0].clientX)));
                        },
                        keydown: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.play(37 === e.keyCode);
                        },
                        keyup: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.stop();
                        }
                    }
                }), this._initEvents();
            }
            destroy() {
                HI(WI, this).swipeTarget.removeEventListener("mousedown", HI(XI, this).container.mousedown), HI(WI, this).swipeTarget.removeEventListener("touchstart", HI(XI, this).container.touchstart), HI(WI, this).swipeTarget.removeEventListener("touchend", HI(XI, this).container.touchend), n.g.removeEventListener("mouseup", HI(XI, this).global.mouseup), n.g.removeEventListener("mousemove", HI(XI, this).global.mousemove), HI(WI, this).parentElement.removeEventListener("touchmove", HI(XI, this).global.touchmove), n.g.removeEventListener("keydown", HI(XI, this).global.keydown), n.g.removeEventListener("keyup", HI(XI, this).global.keyup), HI(WI, this).prev && (HI(WI, this).prev.removeEventListener("mousedown", HI(XI, this).prev.mousedown), HI(WI, this).prev.removeEventListener("mouseup", HI(XI, this).prev.mouseup), HI(WI, this).prev.removeEventListener("touchstart", HI(XI, this).prev.touchstart)), HI(WI, this).next && (HI(WI, this).next.removeEventListener("mousedown", HI(XI, this).next.mousedown), HI(WI, this).next.removeEventListener("mouseup", HI(XI, this).next.mouseup), HI(WI, this).next.removeEventListener("touchstart", HI(XI, this).next.touchstart));
            }
            _initEvents() {
                HI(WI, this).draggable && (HI(WI, this).swipeTarget.addEventListener("mousedown", HI(XI, this).container.mousedown), n.g.addEventListener("mouseup", HI(XI, this).global.mouseup), n.g.addEventListener("mousemove", HI(XI, this).global.mousemove)), HI(WI, this).swipeable && (HI(WI, this).swipeTarget.addEventListener("touchstart", HI(XI, this).container.touchstart), HI(WI, this).swipeTarget.addEventListener("touchend", HI(XI, this).container.touchend), HI(WI, this).parentElement.addEventListener("touchmove", HI(XI, this).global.touchmove)), HI(WI, this).keys && (n.g.addEventListener("keydown", HI(XI, this).global.keydown), n.g.addEventListener("keyup", HI(XI, this).global.keyup)), HI(WI, this).prev && (HI(WI, this).prev.addEventListener("mousedown", HI(XI, this).prev.mousedown), HI(WI, this).prev.addEventListener("mouseup", HI(XI, this).prev.mouseup), HI(WI, this).prev.addEventListener("touchstart", HI(XI, this).prev.touchstart)), HI(WI, this).next && (HI(WI, this).next.addEventListener("mousedown", HI(XI, this).next.mousedown), HI(WI, this).next.addEventListener("mouseup", HI(XI, this).next.mouseup), HI(WI, this).next.addEventListener("touchstart", HI(XI, this).next.touchstart));
            }
        };
        function ZI(t1, e, n) {
            !function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            }(t1, e), e.set(t1, n);
        }
        function qI(t1, e) {
            return t1.get(KI(t1, e));
        }
        function JI(t1, e, n) {
            return t1.set(KI(t1, e), n), n;
        }
        function KI(t1, e, n) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : n;
            throw new TypeError("Private element is not present on this object");
        }
        var $I = new WeakMap, tC = new WeakMap, eC = new WeakMap, nC = new WeakMap, iC = new WeakMap, rC = new WeakMap;
        const aC = class {
            constructor(t1, e){
                ZI(this, $I, null), ZI(this, tC, 0), ZI(this, eC, null), ZI(this, nC, !1), ZI(this, iC, null), ZI(this, rC, !1), this.container = t1, JI($I, this, Object.assign({
                    width: 300,
                    height: 300,
                    aspectRatio: 0,
                    count: 0,
                    perRow: 0,
                    speed: 100,
                    dragTolerance: 10,
                    swipeTolerance: 10,
                    draggable: !0,
                    swipeable: !0,
                    keys: !0,
                    inverted: !1
                }, e)), qI($I, this).swipeTarget = qI($I, this).swipeTarget || this.container, JI(rC, this, !Array.isArray(qI($I, this).image)), this.sprite || (qI($I, this).count = qI($I, this).image.length), Object.freeze(qI($I, this)), JI(iC, this, new YI(this, qI($I, this))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer();
            }
            get isResponsive() {
                return qI($I, this).aspectRatio > 0;
            }
            get containerWidth() {
                return this.isResponsive ? this.container.clientWidth : qI($I, this).width;
            }
            get containerHeight() {
                return this.isResponsive ? this.container.clientWidth * qI($I, this).aspectRatio : qI($I, this).height;
            }
            get index() {
                return qI(tC, this);
            }
            get looping() {
                return qI(nC, this);
            }
            get sprite() {
                return qI(rC, this);
            }
            next() {
                this.goto(qI($I, this).inverted ? qI(tC, this) - 1 : qI(tC, this) + 1);
            }
            prev() {
                this.goto(qI($I, this).inverted ? qI(tC, this) + 1 : qI(tC, this) - 1);
            }
            goto(t1) {
                JI(tC, this, (qI($I, this).count + t1) % qI($I, this).count), this._update();
            }
            play(t1) {
                this.looping || (this._loop(t1), JI(nC, this, !0));
            }
            stop() {
                this.looping && (n.g.clearTimeout(qI(eC, this)), JI(nC, this, !1));
            }
            toggle(t1) {
                this.looping ? this.stop() : this.play(t1);
            }
            destroy() {
                this.stop(), qI(iC, this).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener);
            }
            _loop(t1) {
                t1 ? this.prev() : this.next(), JI(eC, this, n.g.setTimeout(()=>{
                    this._loop(t1);
                }, qI($I, this).speed));
            }
            _update() {
                this.sprite ? (this.container.style.backgroundPositionX = -qI(tC, this) % qI($I, this).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(qI(tC, this) / qI($I, this).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = 'url("'.concat(qI($I, this).image[qI(tC, this)], '")');
            }
            _windowResizeListener() {
                this.container.style.height = this.containerHeight + "px", this._update();
            }
            _initContainer() {
                if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) {
                    this.container.style.backgroundImage = 'url("'.concat(qI($I, this).image, '")');
                    const t1 = qI($I, this).perRow, e = Math.ceil(qI($I, this).count / qI($I, this).perRow);
                    this.container.style.backgroundSize = 100 * t1 + "% " + 100 * e + "%";
                }
                this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update();
            }
        }, sC = (t1)=>{
            let { initialized: n, images: i, activeIndex: r } = t1;
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__threesixty ".concat(n ? "widget-tab__threesixty--active" : "")
            }, e.createElement("div", {
                className: "widget-tab__threesixty-container",
                onTouchMove: (t1)=>{
                    t1.touches.length > 1 || n || t1.stopPropagation();
                }
            }, i.map((t1, n)=>e.createElement("img", {
                    className: r === n ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: t1
                })))));
        }, oC = (t1)=>{
            let { steps: n = [], disabled: i = !1, onClick: r = ()=>{} } = t1;
            const a = LT("instructions-hint-text");
            return e.createElement("div", {
                className: "widget-instructions",
                onClick: ()=>{
                    i || r();
                }
            }, e.createElement("div", {
                className: "widget-instructions__content",
                onClick: (t1)=>t1.stopPropagation()
            }, e.createElement("div", {
                className: "widget-instructions__steps"
            }, n.map((t1, n)=>{
                let { text: i, icon: r } = t1;
                return e.createElement("div", {
                    className: "widget-instructions__step",
                    key: n
                }, e.createElement("img", {
                    src: r,
                    alt: "step-icon"
                }), e.createElement("p", null, i));
            })), e.createElement("button", {
                disabled: i,
                onClick: r,
                type: "button"
            }, LT("ok")), Boolean(a) && e.createElement("div", {
                className: "widget-instructions__hint"
            }, e.createElement("p", null, a))));
        }, lC = (t1)=>{
            let { topViewImage: n, activeIndex: i, currentStep: r, planImage: a, images: s, steps: o, setCurrentStep: l, setActiveIndex: c } = t1;
            const u = ()=>{
                const t1 = o.findIndex((t1)=>t1 === r);
                return o[t1 + 1] || o[0];
            }, h = ()=>{
                const t1 = i + 1;
                s[t1] ? c(t1) : c(0);
            }, d = ()=>{
                const t1 = i - 1;
                s[t1] ? c(t1) : c(s.length - 1);
            };
            let p = {
                x: 0,
                y: 0
            };
            const f = ()=>p = {
                    x: 0,
                    y: 0
                };
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__isometry"
            }, e.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: (t1)=>{
                    if (t1.touches.length > 1) return;
                    const e = t1.touches[0];
                    p = {
                        x: e.screenX
                    };
                },
                onTouchMove: (t1)=>{
                    if (t1.touches.length > 1) return;
                    t1.stopPropagation();
                    const e = t1.touches[0], n = p.x - e.screenX;
                    "carousel" === r && 0 !== p.x && (n >= 100 ? (h(), f()) : n <= -100 && (d(), f()));
                },
                onTouchEnd: f
            }, e.createElement("img", {
                className: "widget-tab__isometry--plan ".concat("plan" === r ? "active" : ""),
                src: a,
                alt: "plan-view"
            }), e.createElement("img", {
                className: "widget-tab__isometry--top-view ".concat("topView" === r ? "active" : ""),
                src: n,
                alt: "top-view"
            }), s.map((t1, n)=>e.createElement("img", {
                    className: "carousel" === r && i === n ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: t1
                })))), "carousel" === r && e.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: d
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yNyAxNkg1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMTQgN0w1IDE2TDE0IDI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==",
                alt: "arrow-left"
            })), e.createElement("span", null, i + 1, "/", s.length), e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: h
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik01IDE2SDI3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMTggN0wyNyAxNkwxOCAyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo=",
                alt: "arrow-right"
            }))), e.createElement("div", {
                className: "widget-tab__isometry-buttons"
            }, o.length > 1 && e.createElement("button", {
                className: "widget-tab__isometry-button",
                onClick: ()=>l(u())
            }, e.createElement("img", {
                src: (()=>{
                    switch(u()){
                        case "carousel":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik03LjE2OTkyIDM1Ljg1NTdMMjQuODM3IDQzLjE3N0w0MS44NDk3IDM1Ljg1NTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0yNi4zMzAxIDQzLjE5NDZMOC44MzAwOCAzNS42OTQ2TDI1LjgzMDEgMjguMTk0Nkw0Mi44MzAxIDM1LjY5NDZMMjYuMzMwMSA0My4xOTQ2WiIgZmlsbD0iI0M0QzRDNCIvPg0KPHBhdGggZD0iTTcuMTY5OTIgMzUuODE5NlYxMy44NTU3TDI0LjgzNyA2LjUzNDQyTDQxLjg0OTcgMTMuODU1N1YzNS44MTk2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMjQuODM1OSA2LjY5NDU4VjI4LjE1ODUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik03LjE2OTkyIDM2LjUxNTlMMjQuODM3IDI5LjE5NDZMNDEuODQ5NyAzNi41MTU5TDI0LjgzNyA0My44MzcyTDcuMTY5OTIgMzYuNTE1OVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
                        case "plan":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yNS41MTQ3IDM5TDcuNSAzMS41TDE2LjI1IDI3Ljc1TDIwLjYyNSAyNS44NzVMMjUgMjcuNzVMMjkuMzc1IDI1Ljg3NUwzMy43NSAyNy43NUw0Mi41IDMxLjVMMjUuNTE0NyAzOVoiIGZpbGw9IiNDNEM0QzQiLz4NCjxwYXRoIGQ9Ik0zMC4xNTA5IDI1LjEyNUwzNC45MzQgMjcuMjVMNDQuNSAzMS41TDI1LjM2NzkgNDBMNS41IDMxLjVMMTUuNDM0IDI3LjI1TDIwLjQwMDkgMjUuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNS41IDE4LjVMMjUuMzY3OSAxMEw0NC41IDE4LjVMMjUuMzY3OSAyN0w1LjUgMTguNVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
                        default:
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1MCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zOC45OTcyIDM4Ljg5OTRIMTEuMDAzNkMxMC43ODI3IDM4Ljg5OTQgMTAuNjAzNiAzOC43MjAzIDEwLjYwMzYgMzguNDk5NEwxMC42MDM1IDEwLjk5ODlDMTAuNjAzNSAxMC43NzggMTAuNzgyNiAxMC41OTg5IDExLjAwMzUgMTAuNTk4OUgzOC45OTcyQzM5LjIxODEgMTAuNTk4OSAzOS4zOTcyIDEwLjc3OCAzOS4zOTcyIDEwLjk5ODlWMzguNDk5NEMzOS4zOTcyIDM4LjcyMDMgMzkuMjE4MSAzOC44OTk0IDM4Ljk5NzIgMzguODk5NFoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIi8+DQo8cGF0aCBkPSJNMTIuMTY5OSAxOS4xOTQ2SDI0LjEzNDFDMjQuMzU1MSAxOS4xOTQ2IDI0LjUzNDEgMTkuMzczNyAyNC41MzQxIDE5LjU5NDZWMzcuMzIxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiLz4NCjxwYXRoIGQ9Ik0zNy44MjA2IDIwLjU5NDVIMzAuOTg0QzMwLjc2MzEgMjAuNTk0NSAzMC41ODQgMjAuNDE1NCAzMC41ODQgMjAuMTk0NVYxMi4xNjg3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPg0KPC9zdmc+DQo=";
                    }
                })(),
                alt: "".concat(r, "-icon")
            }))));
        }, cC = "data:image/svg+xml;base64,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", uC = (t1)=>{
            let { planImage: n, topViewImage: i, images: r, mode: a, disabled: s = !1 } = t1;
            const o = [
                {
                    icon: cC,
                    text: LT("rotate-plan")
                }
            ], [l, c] = (0, e.useState)(!1), [u, h] = (0, e.useState)(null), [d, p] = (0, e.useState)(0), [f, m] = (0, e.useState)(null), [g] = (0, e.useState)((()=>{
                const t1 = [];
                return r && r.length > 0 && t1.push("carousel"), n && t1.push("plan"), i && t1.push("topView"), t1;
            })()), [A, v] = (0, e.useState)(g[0]);
            function y() {
                p(this.index);
            }
            return (0, e.useEffect)(()=>{
                const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__isometry-container"), n = a === Ji.THREESIXTY ? t1 : e, i = jI()(n, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                h(i);
            }, []), e.createElement("div", {
                className: "widget-tab__rotation",
                onContextMenu: CT
            }, a === Ji.THREESIXTY && e.createElement(sC, {
                initialized: l,
                activeIndex: d,
                images: r
            }), a === Ji.DEFAULT && e.createElement(lC, {
                setActiveIndex: p,
                setCurrentStep: (t1)=>{
                    const { scale: e } = u.getTransform();
                    u.pause(), u.zoomTo(0, 0, 1 / e), u.moveTo(0, 0), u.resume(), v(t1);
                },
                topViewImage: i,
                activeIndex: d,
                currentStep: A,
                planImage: n,
                images: r,
                steps: g
            }), a === Ji.THREESIXTY && !l && e.createElement(oC, {
                onClick: ()=>{
                    c(!0);
                    const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__rotation"), n = new aC(t1, {
                        image: [
                            ...r
                        ],
                        parentElement: e,
                        inverted: !0,
                        speed: 300
                    });
                    n._update = y, u.on("panstart", ()=>{
                        n.stop(), n._update = ()=>{};
                    }), u.on("panend", ()=>{
                        n.goto(n.index), n._update = y;
                    }), m(n);
                },
                steps: o,
                disabled: s
            }));
        }, hC = CI(()=>((0, e.useEffect)(()=>{
                fI.setAutoRotateState(Vi.autoRotatePanarama);
            }, []), e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--rotation",
                onClick: ()=>fI.toggleAutoRotate()
            }, e.createElement("img", {
                src: fI.currentAutoRotateIcon,
                alt: "rotation-icon"
            })))), dC = CI((t1)=>{
            let { onClick: n } = t1;
            return e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--ruler",
                disabled: !fI.rulerButtonEnabled,
                onClick: n
            }, e.createElement("img", {
                src: fI.currentRulerIcon,
                alt: "ruler-icon"
            }));
        }), pC = CI(()=>{
            const t1 = Vi.config.scaleButtonType;
            return e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--scale",
                onClick: ()=>fI.toggleFov()
            }, "img" === t1 && e.createElement("img", {
                src: fI.currentFovIcon,
                alt: "scale-icon"
            }), "img" !== t1 && e.createElement("span", null, fI.currentFovText));
        }), fC = (t1)=>{
            let { absolute: n, size: i = "lg" } = t1;
            return e.createElement("div", {
                className: "widget-loader widget-loader--".concat(i, " ").concat(n ? "widget-loader--absolute" : "")
            }, e.createElement("div", null), e.createElement("div", null), e.createElement("div", null), e.createElement("div", null));
        }, mC = CI((t1)=>{
            let { planImage: n, disabled: i } = t1;
            const [r, a] = (0, e.useState)({
                width: "200px",
                height: "auto"
            }), [s, o] = (0, e.useState)(!0), [l, c] = (0, e.useState)({
                X: 1,
                Y: 1
            }), [u, h] = (0, e.useState)(!1), d = ()=>{
                const t1 = document.querySelector(".widget-tab__panorama-map img"), e = t1.naturalWidth / t1.naturalHeight || 1, n = Vi.config.height - 200;
                let i = 200, r = i / e;
                r >= n && (r = n, i = r * e);
                const s = ((t1, e)=>{
                    let { width: n, height: i } = t1;
                    if (!e) return {
                        X: 1,
                        Y: 1
                    };
                    const r = ((t1)=>{
                        var e, n, i, r, a;
                        const s = t1.Meta;
                        if (!s) return {
                            X: t1.Scale.X,
                            Y: t1.Scale.X
                        };
                        const o = Vi.currentFloorIndex, l = null === (e = s.BackgroundsTransforms) || void 0 === e ? void 0 : e[o], c = null === (n = s.WidgetInfo) || void 0 === n || null === (n = n.PlanBounds) || void 0 === n ? void 0 : n[o];
                        if (null != l && l.Modified && c) return {
                            Width: c.Right,
                            Height: c.Bottom
                        };
                        const u = null === (i = s.FloorsScales) || void 0 === i ? void 0 : i[o];
                        return {
                            X: null !== (r = null == u ? void 0 : u.X) && void 0 !== r ? r : t1.Scale.X,
                            Y: null !== (a = null == u ? void 0 : u.Y) && void 0 !== a ? a : t1.Scale.X
                        };
                    })(e);
                    if (r.Width && r.Height) return {
                        X: n / r.Width,
                        Y: i / r.Height
                    };
                    const a = i * (1024 / n);
                    return {
                        X: n / 1024 / r.X,
                        Y: i / a / r.Y
                    };
                })({
                    width: i,
                    height: r
                }, Vi.config.json);
                a({
                    width: "".concat(i, "px"),
                    height: "".concat(r, "px")
                }), c(s), fI.updateWindowSize(Vi.config.width, Vi.config.height), fI.vrControlPanel.map.updateSize(2 * i, 2 * r), fI.vrControlPanel.map.updateScale(s);
            }, p = ()=>{
                Vi.showControls(), h(!1);
            };
            return (0, e.useEffect)(d, [
                Vi.config.width,
                Vi.config.height,
                Vi.currentFloorIndex
            ]), e.createElement(e.Fragment, null, u && e.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: p
            }, e.createElement("img", {
                src: LI,
                alt: "close-map"
            })), e.createElement("div", {
                className: (()=>{
                    let t1 = "widget-tab__panorama-map";
                    return s && (t1 += " widget-tab__panorama-map--hidden"), u && (t1 += " widget-tab__panorama-map--scaled"), t1;
                })()
            }, e.createElement("img", {
                src: n,
                style: r,
                alt: "plan",
                onLoad: ()=>{
                    d(), o(!Vi.config.json || i), fI.vrControlPanel.map.setDisabledState(!Vi.config.json || i), fI.vrControlPanel.map.loadImage(n).then(()=>{
                        fI.vrControlPanel.mapButtonAvailable = !0;
                    });
                }
            }), !s && e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama-map__fov",
                style: (()=>{
                    const t1 = fI.getPanoramaById(fI.currentPanoramaId);
                    if (!t1) return {
                        display: "none"
                    };
                    const { left: e, top: n } = t1.userData;
                    return {
                        "--x": "".concat(e * l.X, "px"),
                        "--y": "".concat(n * l.Y, "px")
                    };
                })()
            }, e.createElement("div", {
                className: "widget-tab__panorama-map__fov-direction"
            }), e.createElement("div", {
                className: "widget-tab__panorama-map__fov-dot"
            })), e.createElement("svg", {
                style: {
                    width: r.width
                },
                key: "X-".concat(l.X, "-Y-").concat(l.Y),
                onClick: (t1)=>{
                    if (fI.loading) return;
                    if (Vi.config.width <= DI.tablet && !u) return Vi.hideControls(), void h(!0);
                    const e = document.querySelector(".widget-tab__panorama-map"), n = e.getBoundingClientRect().width / e.offsetWidth, i = document.querySelector(".widget-tab__panorama-map img").getBoundingClientRect(), { clientX: r, clientY: a } = t1, s = (r - i.left) / n / l.X, o = (a - i.top) / n / l.Y, c = fI.panoramasGroup.children.filter((t1)=>{
                        let { userData: e } = t1;
                        return FT([
                            s,
                            o
                        ], e.points);
                    }), { panorama: d } = hb([
                        s,
                        o
                    ], c);
                    p(), d && fI.setCurrentPanoramaById(d.panoramaId);
                }
            }, fI.panoramasGroup.children.map((t1, n)=>{
                let { userData: i } = t1;
                const r = i.svgPathActions.reduce((t1, e)=>{
                    const n = e.x * l.X, i = e.y * l.Y;
                    let r = "".concat(e.type, " ").concat(n, " ").concat(i);
                    if ("Q" === e.type) {
                        const t1 = e.dx * l.X, n = e.dy * l.Y;
                        r += " ".concat(t1, " ").concat(n);
                    }
                    return "".concat(t1, " ").concat(r);
                }, "");
                return e.createElement("path", {
                    key: n,
                    d: r
                });
            })))));
        }), gC = mC, AC = "data:image/svg+xml;base64,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", vC = CI((t1)=>{
            let { planImage: n, items: i, type: r, disabled: a } = t1;
            const s = [
                {
                    icon: cC,
                    text: LT("rotate-plan")
                },
                {
                    icon: AC,
                    text: LT("research-plan")
                }
            ], o = [
                {
                    icon: cC,
                    text: LT("create-points")
                },
                {
                    icon: AC,
                    text: LT("delete-points")
                }
            ], [l, c] = (0, e.useState)(!1), [u, h] = (0, e.useState)(Vi.instructionVisible), d = ()=>fI.updateWindowSize(Vi.config.width, Vi.config.height);
            return (0, e.useEffect)(()=>{
                fI.enableRender();
                const t1 = document.querySelector(".widget-tab__panorama-overlay");
                return t1.appendChild(fI.renderer.domElement), ()=>{
                    fI.setInitialCurrentPanorama(), fI.camera.deviceOrientationControls.disable(), fI.setCameraFov(fI.cameraFovValues.x1), fI.camera.controls.setDefaultPosition(), fI.setAutoRotateState(!1), fI.setRulerMode(!1), fI.disbleRender(), t1.innerHTML = "";
                };
            }, []), (0, e.useEffect)(()=>{
                const t1 = fI.floorsGroup.children.some((t1)=>t1.floorIndex === Vi.currentFloorIndex);
                return fI.initialized ? t1 ? (fI.setCurrentPanoramasGroup(Vi.currentFloorIndex), void fI.setInitialCurrentPanorama()) : (fI.setLoadingState(!0), void fI.createPanoramasGroup(i, r, Vi.currentFloorIndex).finally(()=>fI.setLoadingState(!1))) : (fI.setLoadingState(!0), void fI.init(i, r, Vi.currentFloorIndex).finally(()=>fI.setLoadingState(!1)));
            }, [
                Vi.currentFloorIndex
            ]), (0, e.useEffect)(d, [
                Vi.config.width,
                Vi.config.height
            ]), e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama"
            }, fI.loading && e.createElement(fC, {
                absolute: !0
            }), e.createElement("div", {
                className: "widget-tab__panorama-overlay",
                onContextMenu: CT
            }), fI.currentPanorama && e.createElement(gC, {
                planImage: n,
                disabled: a
            }), fI.currentPanorama && e.createElement("div", {
                className: "widget-tab__panorama-controls"
            }, fI.currentPanorama.userData.images.scene_depth && e.createElement(dC, {
                onClick: ()=>{
                    fI.toggleRulerMode(), fI.rulerInstructionShown || c(!0);
                }
            }), e.createElement(pC, null), e.createElement(hC, null))), u && e.createElement(oC, {
                disabled: a,
                steps: s,
                onClick: async ()=>{
                    if (h(!1), d(), !Ib.isMobile && !Ib.isTablet) return;
                    if (fI.camera.deviceOrientationControls.connected) return fI.camera.deviceOrientationControls.enable();
                    if (await Ib.requestDeviceOrientation() !== Tb) return;
                    const t1 = ()=>{
                        window.removeEventListener("deviceorientation", t1), fI.camera.deviceOrientationControls.connect(), setTimeout(()=>fI.camera.deviceOrientationControls.enable(), 250);
                    };
                    window.addEventListener("deviceorientation", t1);
                }
            }), l && e.createElement(oC, {
                steps: o,
                onClick: ()=>{
                    fI.setRulerInstructionShown(!0), c(!1);
                }
            }));
        }), yC = CI(()=>{
            var t1, n, i, r, a;
            const { config: s } = Vi, o = {
                width: s.width,
                height: s.height,
                "--main-color": s.colors.main,
                "--main-text": s.colors.mainText
            }, [l, c] = (0, e.useState)(s.tabs[0]), u = {
                rotation: e.createElement(uC, {
                    disabled: !s.rotationData || !s.rotationData.items.length,
                    topViewImage: s.topViewImage,
                    images: (null === (t1 = s.rotationData) || void 0 === t1 ? void 0 : t1.items) || [],
                    type: (null === (n = s.rotationData) || void 0 === n ? void 0 : n.type) || "top_down",
                    planImage: s.planImage,
                    mode: s.rotationMode
                }),
                panorama: e.createElement(vC, {
                    disabled: !s.panoramaData || !s.panoramaData.items.length,
                    items: (null === (i = s.panoramaData) || void 0 === i ? void 0 : i.items) || [],
                    type: (null === (r = s.panoramaData) || void 0 === r ? void 0 : r.type) || "sphere",
                    planImage: s.planImage
                })
            };
            var h;
            return (0, e.useEffect)(()=>{
                qi.init();
            }, []), (0, e.useEffect)(()=>{
                s.tabs.some((t1)=>t1 === l) || c(s.tabs[0]);
            }, [
                s,
                l
            ]), e.createElement("main", {
                className: (h = s.width, Object.keys(DI).filter((t1)=>h <= DI[t1])).reduce((t1, e)=>t1 + " widget-application--".concat(e), "widget-application"),
                id: "widget-application",
                style: o
            }, e.createElement("section", {
                className: "widget-tab widget-tab--".concat(l)
            }, u[l]), s.logo && e.createElement("a", {
                href: (null === (a = s.branding) || void 0 === a ? void 0 : a.url) || s.logoUrl,
                className: "widget-logo",
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("img", {
                src: s.logo,
                alt: "logo"
            })), Vi.controlsVisible && e.createElement(OI, null), e.createElement("div", {
                className: "widget-tab-buttons"
            }, [
                {
                    tab: "rotation",
                    text: "2D"
                },
                {
                    tab: "panorama",
                    text: "3D"
                }
            ].map((t1, n)=>!Vi.isTabIncluded(t1.tab) || s.tabs.length < 2 ? null : Vi.controlsVisible ? e.createElement(UI, {
                    key: n,
                    text: t1.text,
                    active: l === t1.tab,
                    onClick: ()=>c(t1.tab)
                }) : null), "panorama" === l && fI.vrSessionSupported && fI.currentPanorama && !Ib.isMobileDevice && e.createElement(zI, null)), e.createElement("div", {
                className: "widget-watermark-button"
            }, e.createElement(kI, {
                href: s.branding ? s.branding.url : (()=>{
                    const t1 = LT("made-by-link");
                    return "en" === Fi.currentLocale ? t1 + "?utm_source=widget&utm_medium=widget" : t1;
                })(),
                text: s.branding ? s.branding.name : LT("made-by-text")
            })), e.createElement(PI, null));
        }), MC = class {
            constructor(t1){
                let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const i = {
                    ...$i,
                    ...n
                }, r = document.querySelector(t1);
                if (!r) throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442: ".concat(t1));
                r.addEventListener("wheel", (t1)=>t1.preventDefault()), n.width || (i.width = r.offsetWidth), n.height || (i.height = r.offsetHeight), n.panoramaFov && "number" == typeof n.panoramaFov || (i.panoramaFov = $i.panoramaFov), n.panoramaIcons && "object" == typeof n.panoramaIcons ? i.panoramaIcons = {
                    ...$i.panoramaIcons,
                    ...n.panoramaIcons
                } : i.panoramaIcons = {
                    ...$i.panoramaIcons
                }, i.containerElement = r, Vi.setConfig(i), qi.resize(i), i.resizable && new ResizeObserver(()=>this.onResize()).observe(r), mI.render(e.createElement(yC, null), r);
            }
            get options() {
                return Vi.config;
            }
            get panoramaStore() {
                return fI;
            }
            updateSize(t1) {
                const e = {
                    ...this.options,
                    ...t1
                };
                Vi.setConfig(e), qi.resize(e);
            }
            onResize() {
                const { offsetWidth: t1, offsetHeight: e } = this.options.containerElement;
                this.updateSize({
                    width: t1,
                    height: e
                });
            }
            on(t1, e) {
                Vi.addEventListener(t1, e);
            }
        };
    })(), $a5056a6656605403$exports = i;
})();



var $8fc590030257c6da$exports = {};
$8fc590030257c6da$exports = new URL("spot-icon.0138370d.png", import.meta.url).toString();


var $25145dff891e257d$exports = {};
$25145dff891e257d$exports = new URL("door-icon.6b049a9d.svg", import.meta.url).toString();


const $8f6a480bb40b134f$var$WIDGET_API_URL = "https://backend.estate.hart-digital.com";
const $8f6a480bb40b134f$var$createWidget = async (logoUrl)=>{
    const widgetApiHandler = new (0, $a5056a6656605403$exports.ApiStore)($8f6a480bb40b134f$var$WIDGET_API_URL);
    const searchParams = new URL(document.location).searchParams;
    const planId = searchParams.get("id");
    const planData = await widgetApiHandler.loadWidgetData(planId);
    const options = {
        ...planData.parsed,
        API_URL: $8f6a480bb40b134f$var$WIDGET_API_URL,
        rotationMode: (0, $a5056a6656605403$exports.rotationModes).DEFAULT,
        tabs: [
            "panorama",
            "rotation"
        ],
        locale: "en",
        logoUrl: logoUrl,
        dictionaryOverrides: {
            "made-by-text": "Omniyat",
            "made-by-link": "https://www.omniyat.com/residential/anwa-aria-by-omniyat",
            "instructions-hint-text": "The actual finishes and external view may vary and this is illustration purpose only"
        },
        colors: {
            main: "#414141",
            mainText: "#FFFFFF"
        },
        panoramaIcons: {
            spot: (/*@__PURE__*/$parcel$interopDefault($8fc590030257c6da$exports)),
            door: (/*@__PURE__*/$parcel$interopDefault($25145dff891e257d$exports))
        },
        scales: [
            "x05",
            "x1"
        ],
        scaleButtonType: "text",
        enableCameraTransitionBetweenPanoramas: false
    };
    new (0, $a5056a6656605403$exports.Widget)("#widget", options);
};
const $8f6a480bb40b134f$var$cursor = document.querySelector(".custom-cursor");
const $8f6a480bb40b134f$var$setPosition = ({ x: x, y: y })=>{
    $8f6a480bb40b134f$var$cursor.style.setProperty("--cursor-x", x);
    $8f6a480bb40b134f$var$cursor.style.setProperty("--cursor-y", y);
};
const $8f6a480bb40b134f$var$onMouseMove = (event)=>{
    const { clientX: clientX, clientY: clientY, target: target } = event;
    const scaleElement = target.closest(".cursor-scale");
    if (scaleElement) $8f6a480bb40b134f$var$cursor.classList.add("custom-cursor--scale");
    else $8f6a480bb40b134f$var$cursor.classList.remove("custom-cursor--scale");
    $8f6a480bb40b134f$var$setPosition({
        x: clientX,
        y: clientY
    });
};
window.addEventListener("mousemove", (e)=>$8f6a480bb40b134f$var$onMouseMove(e));
const $8f6a480bb40b134f$var$startScaleTime = (switchToogle = false)=>{
    const scaleTime = setInterval(()=>{
        const select = document.querySelector(".widget-tab-button--active");
        const scale = document.querySelector(".widget-tab__panorama-controls-button--scale");
        if (select && scale) {
            select.after(scale);
            if (switchToogle) {
                const scaleImg = document.querySelector(".widget-tab__panorama-controls-button--scale img");
                scaleImg.style.setProperty("width", "25px", "important");
            }
            clearInterval(scaleTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$startSelectFloorTime = ()=>{
    const selectTime = setInterval(()=>{
        const buttons = document.querySelector(".widget-tab-buttons");
        const select = document.querySelector(".floors-select");
        if (select && buttons) {
            buttons.append(select);
            clearInterval(selectTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$copyWidgetEvents = ()=>{
    document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrow--prev").addEventListener("click", ()=>{
        document.querySelector(".widget-tab__rotation .widget-tab__isometry-arrow--prev").click();
        document.querySelector(".widget-tab-buttons span").innerHTML = document.querySelector(".widget-tab__rotation span").innerHTML;
    });
    document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrow--next").addEventListener("click", ()=>{
        document.querySelector(".widget-tab__rotation .widget-tab__isometry-arrow--next").click();
        document.querySelector(".widget-tab-buttons span").innerHTML = document.querySelector(".widget-tab__rotation span").innerHTML;
    });
    document.querySelector(".widget-tab__isometry-button").addEventListener("click", ()=>{
        document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrows").remove();
        $8f6a480bb40b134f$var$startArrowsTime();
    });
};
const $8f6a480bb40b134f$var$startArrowsTime = ()=>{
    const arrowsTime = setInterval(()=>{
        const buttons = document.querySelector(".widget-tab-buttons");
        const arrows = document.querySelector(".widget-tab__isometry-arrows");
        if (buttons && arrows) {
            buttons.append(arrows.cloneNode(true));
            $8f6a480bb40b134f$var$copyWidgetEvents();
            clearInterval(arrowsTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$redisignButtons = ()=>{
    $8f6a480bb40b134f$var$startSelectFloorTime();
    $8f6a480bb40b134f$var$startScaleTime();
    $8f6a480bb40b134f$var$startArrowsTime();
    let scaleSwitch = false;
    document.addEventListener("click", (e)=>{
        if (e.target.innerHTML === "2D") {
            const buttons = document.querySelector(".widget-tab-buttons");
            const scale = document.querySelector(".widget-tab__panorama-controls-button--scale");
            buttons.removeChild(scale);
            $8f6a480bb40b134f$var$startScaleTime(true);
            scaleSwitch = true;
        }
        if (e.target.innerHTML === "3D") {
            const buttons = document.querySelector(".widget-tab-buttons");
            const arrows = document.querySelector(".widget-tab__isometry-arrows");
            buttons.removeChild(arrows);
            $8f6a480bb40b134f$var$startArrowsTime();
        }
    });
};
$8f6a480bb40b134f$var$createWidget("https://www.omniyat.com/residential/anwa-aria-by-omniyat").then(()=>{
    $8f6a480bb40b134f$var$redisignButtons();
});


//# sourceMappingURL=index.79b3d151.js.map
